{
  "analyzer.mapping.error.profileUnavailable": "The analyzer profile could not be read. Retry confirmation when the Bridge is available.",
  "reporting.title": "Xuất dữ liệu tùy chỉnh",
  "reporting.description": "Chọn báo cáo, kỳ báo cáo và các cột, rồi tải về tệp CSV dùng được ngay trong bảng tính.",
  "reporting.builder": "Quay lại trình tạo báo cáo",
  "reporting.queue": "Hàng đợi báo cáo của tôi",
  "reporting.queueEmpty": "Các báo cáo bạn tạo sẽ hiển thị tại đây.",
  "reporting.design.emptyQueuePage": "Trang này không có báo cáo nào.",
  "reporting.design.firstQueuePage": "Về trang đầu",
  "reporting.reportType": "Loại báo cáo",
  "reporting.layout": "Bố cục CSV",
  "reporting.layout.SPREADSHEET": "Bảng tính — xét nghiệm theo cột",
  "reporting.layout.RESULT_LIST": "Danh sách chi tiết — kết quả theo dòng",
  "reporting.layout.TABLE": "Bảng",
  "reporting.meaning.SPREADSHEET": "Mỗi xét nghiệm hiển thị thành một cột cho từng mẫu. Kết quả lặp lại dùng thêm dòng; các lần đo lặp không liên quan được giữ riêng.",
  "reporting.meaning.RESULT_LIST": "Mỗi kết quả độc lập nằm trên một dòng riêng. Kết quả lặp lại được giữ nguyên.",
  "reporting.meaning.TABLE": "Mỗi lần ghi nhận nằm trên một dòng riêng.",
  "reporting.dateFrom": "Từ ngày",
  "reporting.dateTo": "Đến ngày",
  "reporting.dates.required": "Bắt buộc",
  "reporting.dates.requiredFrom": "Chọn ngày bắt đầu.",
  "reporting.dates.requiredTo": "Chọn ngày kết thúc.",
  "reporting.dates.invalid": "Chọn một ngày hợp lệ.",
  "reporting.dates.reversed": "Ngày kết thúc phải bằng hoặc sau ngày bắt đầu.",
  "reporting.dates.tooLong": "Chọn kỳ tối đa {days} ngày, tính cả hai ngày đầu và cuối.",
  "reporting.dates.range": "Chọn một khoảng thời gian đúng thứ tự, trong giới hạn tối đa nêu trên.",
  "reporting.periodHelp": "Lấy theo {dateMeaning} tại {timezone}, tính cả hai ngày. Kỳ tối đa: {days} ngày.",
  "reporting.dateAnchor.collectionDate": "ngày lấy mẫu",
  "reporting.dateAnchor.requestDate": "ngày yêu cầu chuyển gửi",
  "reporting.dateAnchor.sentDate": "ngày gửi chuyển",
  "reporting.dateAnchor.eventOrRecordedDate": "ngày sự kiện nếu có, nếu không thì ngày ghi nhận (xác định theo Date Basis)",
  "reporting.dateAnchor.dateOfEvent": "ngày xảy ra sự không phù hợp",
  "reporting.dateAnchor.enteredDate": "ngày ghi nhận từ chối mẫu",
  "reporting.labSections": "Nhóm xét nghiệm",
  "reporting.allAccessibleSections": "Tất cả nhóm xét nghiệm được phép truy cập",
  "reporting.tests": "Xét nghiệm",
  "reporting.allTests": "Tất cả xét nghiệm",
  "reporting.resultStatuses": "Trạng thái kết quả",
  "reporting.finalized": "Đã chốt",
  "reporting.all": "Tất cả",
  "reporting.available": "Cột có sẵn",
  "reporting.search": "Tìm cột",
  "reporting.selected": "Cột đã chọn",
  "reporting.selectedCount": "Cột đã chọn ({count})",
  "reporting.group.sample": "Mẫu và chỉ định",
  "reporting.group.referrals": "Gửi mẫu đi",
  "reporting.group.nonConformance": "Sự không phù hợp / Từ chối mẫu",
  "reporting.group.patient": "Bệnh nhân",
  "reporting.group.result": "Chi tiết kết quả",
  "reporting.group.tests": "Xét nghiệm đã cấu hình",
  "reporting.group.components": "Thành phần kết quả đã cấu hình",
  "reporting.group.turnaround": "Thời gian trả kết quả",
  "reporting.group.testTurnaround": "Thời gian trả kết quả theo xét nghiệm",
  "reporting.group.componentTurnaround": "Thời gian trả kết quả theo thành phần",
  "reporting.group.observations": "Câu hỏi bổ sung",
  "reporting.headerPreview": "Xem trước tiêu đề CSV",
  "reporting.moveUp": "Đưa {field} lên",
  "reporting.moveDown": "Đưa {field} xuống",
  "reporting.remove": "Bỏ {field}",
  "reporting.position": "{field}: vị trí {position} / {count}",
  "reporting.review": "Xem lại báo cáo",
  "reporting.edit": "Sửa báo cáo",
  "reporting.generate": "Tạo CSV",
  "reporting.submitting": "Đang gửi báo cáo…",
  "reporting.generating": "Đang chuẩn bị CSV…",
  "reporting.download": "Tải CSV",
  "reporting.loading": "Đang tải tùy chọn báo cáo…",
  "reporting.currentReport": "Báo cáo hiện tại",
  "reporting.previous": "Trước",
  "reporting.next": "Tiếp",
  "reporting.rows": "{count, plural, other {# dòng}}",
  "reporting.state.QUEUED": "Đang chờ",
  "reporting.state.GENERATING": "Đang tạo",
  "reporting.state.READY": "Sẵn sàng tải",
  "reporting.state.FAILED": "Lỗi",
  "reporting.state.EXPIRED": "Hết hạn",
  "reporting.state.CANCELLED": "Đã hủy",
  "reporting.loadError": "Không tải được thông tin báo cáo",
  "reporting.submitError": "Không tạo được báo cáo",
  "reporting.requestError": "Không hoàn tất được yêu cầu. Các lựa chọn của bạn vẫn được giữ; hãy thử lại.",
  "reporting.networkError": "Không kết nối được máy chủ. Các lựa chọn của bạn vẫn được giữ; hãy thử lại.",
  "reporting.request.invalid": "Kiểm tra kỳ báo cáo, bộ lọc và các cột đã chọn, rồi thử lại.",
  "reporting.request.conflict": "Mã gửi này đã được dùng cho lựa chọn báo cáo khác. Hãy bắt đầu một báo cáo mới.",
  "reporting.columns.stale": "Một số cột đã chọn không còn sẵn. Hãy bỏ chúng và chọn lại từ danh mục hiện tại.",
  "reporting.jobs.limit": "Bạn đã đạt giới hạn số báo cáo đang chạy. Chờ một báo cáo hoàn tất rồi thử lại.",
  "reporting.access.denied": "Quyền truy cập OpenELIS hiện tại của bạn không cho phép báo cáo này.",
  "reporting.access.scopeChanged": "Quyền truy cập của bạn vào các nhóm xét nghiệm đã chọn đã thay đổi. Hãy xem lại báo cáo theo quyền hiện tại.",
  "reporting.access.noSections": "Không có nhóm xét nghiệm nào bạn được phép truy cập cho báo cáo này.",
  "reporting.access.signIn": "Đăng nhập OpenELIS để tiếp tục.",
  "reporting.definition.changed": "Định nghĩa báo cáo đã thay đổi. Hãy xem lại tùy chọn báo cáo hiện tại trước khi chạy lại.",
  "reporting.definition.unavailable": "Loại báo cáo này không còn sẵn.",
  "reporting.tests.stale": "Một số xét nghiệm đã chọn không còn sẵn. Hãy xem lại lựa chọn xét nghiệm.",
  "reporting.status.invalid": "Chọn một trạng thái kết quả có sẵn.",
  "reporting.filters.unsupported": "Một số bộ lọc được yêu cầu không dùng được cho báo cáo này. Hãy xem lại tùy chọn báo cáo hiện tại.",
  "reporting.filters.unavailable": "Một số bộ lọc trước đó không dùng được cho báo cáo này. Hãy xem lại bộ lọc trước khi tạo.",
  "reporting.job.generationFailed": "Không tạo được CSV. Yêu cầu báo cáo của bạn vẫn được giữ.",
  "reporting.job.outputUnavailable": "Máy chủ không lưu được tệp xuất. Nhờ quản trị viên cấp quyền ghi cho thư mục xuất, rồi thử lại báo cáo này.",
  "reporting.job.expired": "Tệp này đã hết hạn. Chạy lại báo cáo với kỳ mới.",
  "reporting.job.notReady": "Báo cáo này chưa sẵn sàng để tải.",
  "reporting.job.notFound": "Không tìm thấy báo cáo này.",
  "reporting.saved.library": "Báo cáo dùng chung",
  "reporting.saved.search": "Tìm báo cáo dùng chung",
  "reporting.saved.loading": "Đang tải báo cáo dùng chung…",
  "reporting.saved.loadError": "Không tải được báo cáo dùng chung",
  "reporting.saved.empty": "Chưa có báo cáo dùng chung nào được lưu.",
  "reporting.saved.shared": "Mọi người có quyền dùng báo cáo đều xem được.",
  "reporting.saved.open": "Mở",
  "reporting.saved.save": "Lưu báo cáo",
  "reporting.saved.update": "Cập nhật báo cáo dùng chung",
  "reporting.saved.copy": "Lưu bản sao",
  "reporting.saved.delete": "Xóa báo cáo dùng chung",
  "reporting.saved.name": "Tên báo cáo",
  "reporting.saved.confirmSave": "Lưu báo cáo dùng chung",
  "reporting.saved.confirmDelete": "Xóa",
  "reporting.saved.confirmUpdate": "Cập nhật",
  "reporting.saved.cancel": "Hủy",
  "reporting.saved.copyName": "Bản sao của {name}",
  "reporting.saved.created": "Đã lưu với tên {name}.",
  "reporting.saved.updated": "Đã cập nhật {name}.",
  "reporting.saved.freshDates": "Chọn ngày mới trước khi chạy báo cáo này.",
  "reporting.saved.deleteHelp": "Xóa {name} khỏi thư viện báo cáo dùng chung? Các tệp đã tạo trước đó vẫn được giữ lại.",
  "reporting.saved.updateHelp": "Thay {name} bằng các lựa chọn đang hiển thị trong trình tạo báo cáo?",
  "reporting.saved.changed": "Có người đã sửa báo cáo dùng chung này sau khi bạn mở. Các lựa chọn của bạn vẫn còn; hãy mở lại báo cáo đã lưu hiện tại hoặc lưu bản sao.",
  "reporting.saved.invalid": "Kiểm tra lại các lựa chọn báo cáo trước khi lưu.",
  "reporting.saved.nameInvalid": "Nhập tên báo cáo tối đa 200 ký tự.",
  "reporting.saved.notFound": "Báo cáo dùng chung này không còn sẵn.",
  "reporting.saved.pageInvalid": "Yêu cầu tải danh sách báo cáo dùng chung không hợp lệ.",
  "accept.action.button": "Chấp nhận",
  "accessDenied.message": "Bạn không có quyền truy cập module này, vui lòng liên hệ quản trị viên hệ thống",
  "accessDenied.okButton": "OK",
  "accessDenied.title": "Từ chối truy cập",
  "accession.entry": "Nhập số mã mẫu",
  "activityReportByPanel": "Báo cáo hoạt động theo bộ xét nghiệm",
  "activityReportByTest": "Báo cáo hoạt động theo xét nghiệm",
  "activityReportByTestSection": "Báo cáo hoạt động theo nhóm xét nghiệm",
  "add.age.range": "Thêm khoảng tuổi khác +",
  "add.aliquot": "Thêm phần mẫu con",
  "add.new.dictionary.menu": "Thêm mục từ điển mới",
  "address.search.label": "Tìm địa chỉ nhanh",
  "address.level.provinsi": "Tỉnh/Thành phố",
  "address.level.kabupaten": "Quận/Huyện",
  "address.level.kecamatan": "Xã/Phường",
  "address.level.kelurahan": "Thôn/Ấp/Khu phố",
  "adjustment.button": "Điều chỉnh số lượng",
  "adjustment.newQuantity": "Số lượng mới",
  "adjustment.notes": "Ghi chú",
  "adjustment.notes.placeholder": "Mô tả chi tiết việc điều chỉnh này",
  "adjustment.reason": "Lý do điều chỉnh",
  "adjustment.reason.select": "Chọn lý do",
  "adjustment.success": "Đã điều chỉnh số lượng LOT thành công",
  "adjustment.title": "Điều chỉnh số lượng LOT",
  "admin.dashboard.subtitle": "Chọn một khu vực quản trị để cấu hình OpenELIS.",
  "admin.dashboard.title": "Bàn làm việc quản trị",
  "admin.formEntryConfig": "Cấu hình chung",
  "admin.programs.title": "Chương trình",
  "admin.programs.subtitle": "Các chương trình mà chỉ định được xếp vào — mỗi chương trình có một lĩnh vực, một hoặc nhiều nhóm xét nghiệm và một bảng câu hỏi nhập chỉ định tùy chọn.",
  "admin.programs.add": "Thêm chương trình",
  "admin.programs.search": "Tìm theo tên",
  "admin.programs.selector.new": "Chương trình mới",
  "admin.programs.row.expand.aria": "Sửa chương trình",
  "admin.programs.row.actions.aria": "Thao tác chương trình",
  "admin.programs.list.column.name": "Tên",
  "admin.programs.list.column.domain": "Lĩnh vực",
  "admin.programs.list.column.active": "Trạng thái",
  "admin.programs.list.column.units": "Nhóm xét nghiệm",
  "admin.programs.list.status.active": "Đang dùng",
  "admin.programs.list.status.inactive": "Ngừng dùng",
  "admin.programs.list.filter.domain.label": "Lĩnh vực",
  "admin.programs.list.filter.domain.all": "Tất cả lĩnh vực",
  "admin.programs.list.toggle.showDeactivated": "Hiện mục đã ngừng dùng",
  "admin.programs.action.deactivate": "Ngừng dùng",
  "admin.programs.action.reactivate": "Kích hoạt lại",
  "admin.programs.deactivate.modal.title": "Ngừng dùng chương trình này?",
  "admin.programs.deactivate.modal.body.noOrders": "\"{programName}\" chưa có chỉ định nào và sẽ không còn hiện khi nhập chỉ định mới. Bạn có thể kích hoạt lại bất cứ lúc nào từ danh sách Chương trình.",
  "admin.programs.deactivate.modal.confirm": "Ngừng dùng",
  "admin.programs.deactivate.modal.cancel": "Hủy",
  "admin.programs.reactivate.success": "Đã kích hoạt lại {programName}",
  "admin.programs.deactivate.success": "Đã ngừng dùng {programName}",
  "admin.programs.domain.confirm.heading": "Đổi lĩnh vực chương trình?",
  "admin.programs.domain.confirm.body": "Các chỉ định cũ được đánh giá theo quy tắc của lĩnh vực {from}. Đổi sang {to} chỉ áp dụng từ nay về sau: chỉ định hiện có giữ nguyên mã chương trình và không bị mã hóa lại; từ giờ chương trình chỉ xuất hiện trên chỉ định thuộc {to}.",
  "admin.programs.list.empty": "Không có chương trình nào khớp với tìm kiếm và bộ lọc hiện tại.",
  "admin.programs.basicInfo.labUnits.selectAll": "Chọn tất cả",
  "admin.programs.basicInfo.labUnits.placeholder": "Gõ để lọc nhóm xét nghiệm",
  "orderEntry.programPicker.empty": "Hiện chưa có chương trình nào đang dùng. Quản trị viên có thể kích hoạt một chương trình trong Quản trị › Chương trình.",
  "orderEntry.programPicker.empty.domain": "Hiện chưa có chương trình {domain} nào đang dùng. Quản trị viên có thể kích hoạt một chương trình trong Quản trị › Chương trình.",
  "admin.programs.basicInfo.programName.label": "Tên chương trình",
  "admin.programs.basicInfo.programName.placeholder": "VD: Sàng lọc viêm gan B thai kỳ",
  "admin.programs.basicInfo.code.label": "Mã chương trình",
  "admin.programs.basicInfo.code.placeholder": "VD: HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Chỉ dùng chữ cái, chữ số, khoảng trắng hoặc dấu gạch dưới.",
  "admin.programs.basicInfo.programName.tooLong": "Dùng tối đa {max} ký tự.",
  "admin.programs.basicInfo.labUnits.label": "Nhóm xét nghiệm",
  "admin.programs.basicInfo.showOnMicroCase.off": "Tắt",
  "admin.programs.basicInfo.showOnMicroCase.on": "Bật",
  "admin.programs.basicInfo.showOnMicroCase.label": "Hiện trên ca vi sinh",
  "admin.programs.basicInfo.showOnMicroCase.helper": "Cho phép chương trình này dùng cho ca vi sinh. Ca mới kế thừa từ chỉ định; không thay đổi cách phân luồng công việc.",
  "admin.programs.basicInfo.domain.label": "Lĩnh vực",
  "admin.programs.basicInfo.domain.required": "Bắt buộc chọn lĩnh vực",
  "admin.programs.editor.status.label": "Trạng thái:",
  "admin.programs.guidance.domain.toggle.show": "Mỗi lĩnh vực nghĩa là gì?",
  "admin.programs.guidance.domain.toggle.hide": "Ẩn",
  "admin.programs.guidance.domain.clinical": "Xét nghiệm trên bệnh nhân — biểu mẫu ghi nhận mã định danh bệnh nhân, bác sĩ chỉ định, tiền sử.",
  "admin.programs.guidance.domain.environmental": "Lấy mẫu kiểm soát/giám sát tuân thủ (nước, thực phẩm, không khí). Không có trường thông tin bệnh nhân.",
  "admin.programs.guidance.domain.vector": "Giám sát mẫu vật trung gian (muỗi, ve) — loài, bảng danh sách mẫu gộp.",
  "admin.programs.guidance.gui.emptyState.body": "Chưa có câu hỏi nào — thêm từng câu hỏi, hoặc dán Questionnaire ở chế độ JSON.",
  "admin.programs.guidance.gui.emptyState.action": "Thêm câu hỏi đầu tiên",
  "admin.programs.guidance.json.referenceCard.format": "Định dạng: FHIR R4 Questionnaire",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "— item.type được phép: {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Trình tạo trực quan",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Nội dung câu hỏi",
  "admin.programs.questionnaire.question.type.label": "Loại câu hỏi",
  "admin.programs.questionnaire.question.addNew": "Thêm câu hỏi mới",
  "admin.programs.questionnaire.question.actions.aria": "Thao tác câu hỏi",
  "admin.programs.questionnaire.question.actions.delete": "Xóa câu hỏi",
  "admin.programs.questionnaire.answerOptions.section.title": "Lựa chọn trả lời",
  "admin.programs.questionnaire.answerOptions.addOption": "Thêm lựa chọn",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Xóa lựa chọn",
  "admin.programs.questionnaire.answerOptions.empty": "Chưa có lựa chọn nào — thêm ít nhất một lựa chọn để tiếp nhận có thể chọn giá trị.",
  "admin.programs.questionnaire.answerOptions.coded": "có mã",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Các lựa chọn có mã lấy từ danh mục thuật ngữ và chỉ xem được ở đây. Sửa trong chế độ JSON.",
  "admin.programs.questionnaire.preview.label": "Ví dụ",
  "admin.programs.questionnaire.preview.empty": "Chưa có câu hỏi nào — bắt đầu thêm câu hỏi để xem trước.",
  "admin.programs.questionnaire.preview.untitled": "(chưa đặt tên)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Có ◯ Không",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "số",
  "admin.programs.questionnaire.preview.quantity.unit": "đơn vị",
  "admin.programs.questionnaire.json.validate": "Kiểm tra JSON",
  "admin.programs.questionnaire.json.reformat": "Định dạng lại",
  "admin.programs.questionnaire.json.validated": "Hợp lệ — {count} câu hỏi",
  "admin.programs.questionnaire.json.error.title": "Questionnaire không hợp lệ",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType phải là \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item phải là một mảng",
  "admin.programs.questionnaire.json.error.itemShape": "mỗi item phải có linkId, text và type thuộc [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "linkId \"{linkId}\" bị trùng — mỗi item phải có một linkId riêng",
  "admin.programs.guidance.json.referenceCard.advanced": "Các tính năng nâng cao (enableWhen, đơn vị Quantity qua unit/unitOption, item lồng nhau) được sửa ở đây bằng JSON — Trình tạo trực quan giữ nguyên chúng nhưng không hiển thị.",
  "admin.programs.basicInfo.domain.helper": "Quyết định chương trình xuất hiện ở đâu — tiếp nhận chỉ thấy các chương trình khớp lĩnh vực của chỉ định.",
  "admin.programs.editor.status.noHardDelete": "Không xóa hẳn — ngừng dùng sẽ giữ lại lịch sử.",
  "admin.programs.deactivate.modal.body": "\"{programName}\" sẽ không còn hiện trong danh sách chương trình khi nhập chỉ định mới. {orderCount, plural, one {# chỉ định cũ vẫn giữ mã chương trình} other {# chỉ định cũ vẫn giữ mã chương trình}} và mọi số liệu chỉ số đều được giữ nguyên. Bạn có thể kích hoạt lại bất cứ lúc nào từ danh sách Chương trình.",
  "admin.programs.deactivate.modal.body.unknownCount": "\"{programName}\" sẽ không còn hiện trong danh sách chương trình khi nhập chỉ định mới. Các chỉ định cũ vẫn giữ mã chương trình và mọi số liệu chỉ số được giữ nguyên. Bạn có thể kích hoạt lại bất cứ lúc nào từ danh sách Chương trình.",
  "admin.programs.questionnaire.question.unsupported": "Đây là item loại \"{type}\", trình tạo này không sửa được. Khi lưu, item được giữ nguyên như cũ. Hãy sửa ở chế độ JSON.",
  "admin.programs.questionnaire.question.type.boolean": "Có / Không",
  "admin.programs.questionnaire.question.type.choice": "Chọn một",
  "admin.programs.questionnaire.question.type.checkbox": "Chọn nhiều",
  "admin.programs.questionnaire.question.type.integer": "Số nguyên",
  "admin.programs.questionnaire.question.type.decimal": "Số thập phân",
  "admin.programs.questionnaire.question.type.date": "Ngày",
  "admin.programs.questionnaire.question.type.time": "Giờ",
  "admin.programs.questionnaire.question.type.string": "Văn bản ngắn",
  "admin.programs.questionnaire.question.type.text": "Văn bản dài",
  "admin.programs.questionnaire.question.type.quantity": "Số lượng kèm đơn vị",
  "admin.programs.questionnaire.question.typeExample.boolean": "Trả lời có/không. Ví dụ: \"Lần khám thai đầu tiên?\"",
  "admin.programs.questionnaire.question.typeExample.choice": "Chọn một trong danh sách cố định. Ví dụ: \"Tình trạng mẫu\".",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Có thể chọn nhiều lựa chọn. Ví dụ: \"Các triệu chứng hiện có\".",
  "admin.programs.questionnaire.question.typeExample.integer": "Chỉ số nguyên. Ví dụ: \"Tuổi thai (tuần)\".",
  "admin.programs.questionnaire.question.typeExample.decimal": "Số có phần thập phân. Ví dụ: \"Cân nặng mẹ (kg)\".",
  "admin.programs.questionnaire.question.typeExample.date": "Ngày dương lịch. Ví dụ: \"Ngày kinh cuối\".",
  "admin.programs.questionnaire.question.typeExample.time": "Giờ trong ngày. Ví dụ: \"Giờ lấy mẫu\".",
  "admin.programs.questionnaire.question.typeExample.string": "Văn bản tự do ngắn. Ví dụ: \"Tên bác sĩ\".",
  "admin.programs.questionnaire.question.typeExample.text": "Văn bản tự do dài. Ví dụ: \"Ghi chú lâm sàng\".",
  "admin.programs.questionnaire.question.typeExample.quantity": "Một số kèm đơn vị (VD: \"Thể tích thu được — 5 mL\"). Đơn vị cho phép lấy từ FHIR extension ở chế độ JSON; Quantity chỉ tạo bằng giao diện sẽ nhận mọi đơn vị.",
  "admin.config.logo.error.fileTooLarge": "Ảnh quá lớn. Kích thước tối đa là 2MB.",
  "admin.config.logo.formats": "Định dạng: JPG, PNG, GIF (tối đa 2MB)",
  "admin.label": "Quản trị",
  "admin.labUnit.basicInfo.domain.clinical": "Lâm sàng",
  "admin.labUnit.basicInfo.domain.environmental": "Môi trường",
  "admin.labUnit.basicInfo.domain.label": "Lĩnh vực",
  "admin.labUnit.basicInfo.domain.vector": "Vật trung gian",
  "admin.labUnit.domain.confirm.body": "Chỉ định và kết quả cũ được đánh giá theo quy tắc của lĩnh vực trước đó. Chỉ định mới sẽ dùng quy tắc của lĩnh vực mới.",
  "admin.labUnit.domain.confirm.heading": "Đổi lĩnh vực nhóm xét nghiệm?",
  "admin.labUnit.edit.select": "Chọn nhóm xét nghiệm",
  "admin.labUnit.edit.title": "Sửa lĩnh vực nhóm xét nghiệm",
  "admin.labUnit.list.filter.domain": "Lọc theo lĩnh vực",
  "admin.legacy": "Quản trị (cũ)",
  "button.back": "← Về danh sách",
  "button.labUnit.add": "Thêm nhóm xét nghiệm",
  "button.labUnit.create": "Tạo nhóm xét nghiệm",
  "button.labUnit.creating": "Đang tạo...",
  "button.labUnit.tests.assign": "Gán xét nghiệm",
  "button.labUnit.tests.assign.confirm": "Gán {count, plural, one {# xét nghiệm} other {# xét nghiệm}}",
  "button.labUnit.tests.reassign": "Chuyển các mục đã chọn ({count})",
  "button.labUnit.tests.reassign.confirm": "Chuyển {count, plural, one {# xét nghiệm} other {# xét nghiệm}}",
  "configuration.labUnit.manage": "Quản lý nhóm xét nghiệm",
  "error.labUnit.description.maxLength": "Mô tả tối đa {max} ký tự",
  "error.labUnit.domain.required": "Bắt buộc chọn lĩnh vực",
  "error.labUnit.list.load": "Lỗi tải nhóm xét nghiệm",
  "error.labUnit.name.duplicate": "Tên nhóm xét nghiệm này đã tồn tại",
  "error.labUnit.name.maxLength": "Tên tối đa {max} ký tự",
  "error.request.unreadable": "Chưa lưu gì: máy chủ không chấp nhận một giá trị đã gửi. Kiểm tra lại biểu mẫu và thử lại.",
  "error.labUnit.name.required": "Bắt buộc nhập tên",
  "heading.labUnit.add": "Thêm nhóm xét nghiệm mới",
  "heading.labUnit.editing": "Đang sửa: {name}",
  "heading.labUnit.filtered": "Hiển thị {filtered} / {total} nhóm xét nghiệm",
  "heading.labUnit.management": "Quản lý nhóm xét nghiệm",
  "heading.labUnit.subtitle": "Cấu hình nhóm xét nghiệm, phân loại lĩnh vực, gán xét nghiệm và thứ tự hiển thị.",
  "heading.labUnit.total": "Tổng: {total} nhóm xét nghiệm",
  "helper.labUnit.description": "Mô tả nội bộ ngắn của nhóm xét nghiệm để nhân viên tham khảo",
  "helper.labUnit.domain": "Quyết định trường nhập chỉ định và lấy mẫu nào áp dụng cho chỉ định chuyển tới nhóm xét nghiệm này.",
  "helper.labUnit.name": "Nhập tên duy nhất cho nhóm xét nghiệm này (VD: \"Huyết học\", \"Vi sinh\")",
  "label.labUnit.actions": "Thao tác",
  "label.labUnit.active": "Đang dùng",
  "label.labUnit.description": "Mô tả",
  "label.labUnit.displayOrder": "Vị trí",
  "label.labUnit.displayOrder.addHint": "Lưu nhóm xét nghiệm này trước, rồi mới đặt thứ tự hiển thị.",
  "label.labUnit.displayOrder.current": "Hiện tại",
  "label.labUnit.displayOrder.intro": "Đặt vị trí nhóm xét nghiệm này trong các menu và danh sách thả xuống toàn hệ thống. Nhập vị trí rồi lưu — các nhóm còn lại sẽ tự đánh số lại.",
  "label.labUnit.displayOrder.loading": "Đang tải thứ tự hiển thị...",
  "label.labUnit.displayOrder.saved": "Đã lưu thứ tự hiển thị",
  "label.labUnit.displayOrder.saveError": "Lưu thứ tự hiển thị thất bại",
  "label.labUnit.domain": "Lĩnh vực",
  "label.labUnit.filterStatus": "Lọc theo trạng thái",
  "label.labUnit.list.loading": "Đang tải nhóm xét nghiệm...",
  "label.labUnit.loading": "Đang tải nhóm xét nghiệm...",
  "label.labUnit.notFound": "Nhóm xét nghiệm này không tồn tại. Quay lại danh sách để chọn nhóm khác.",
  "label.labUnit.editorLoadError": "Không tải được các nhóm xét nghiệm. Làm mới trang để thử lại.",
  "label.labUnit.name": "Tên",
  "label.labUnit.nameInLocale": "Tên ({language})",
  "error.labUnit.tests.action": "Thao tác gán xét nghiệm thất bại",
  "error.labUnit.deactivate.failed": "Nhóm xét nghiệm chưa được ngừng dùng. Kiểm tra các tùy chọn và thử lại.",
  "error.labUnit.deactivate.destinationInactive": "Nhóm xét nghiệm đích đang ngừng dùng. Chọn một nhóm đang dùng, hoặc kích hoạt lại nhóm đó trước.",
  "heading.labUnit.tests.assign": "Gán xét nghiệm cho nhóm này",
  "heading.labUnit.tests.reassign": "Chuyển xét nghiệm",
  "label.labUnit.tests.assign.explain": "Mỗi xét nghiệm chỉ thuộc đúng một nhóm xét nghiệm. Gán xét nghiệm ở đây sẽ chuyển nó khỏi nhóm hiện tại (hiển thị cạnh từng xét nghiệm).",
  "label.labUnit.tests.assign.none": "Không tìm thấy xét nghiệm nào có thể gán.",
  "label.labUnit.tests.reassign.destination": "Nhóm xét nghiệm đích",
  "label.labUnit.tests.reassign.explain": "Việc chuyển có hiệu lực ngay. Chỉ định mới sẽ đi tới nhóm đích; kết quả đã hoàn tất giữ nguyên dữ liệu gốc.",
  "label.labUnit.tests.reassign.inactiveDestination": "Nhóm này đang ngừng dùng: các xét nghiệm được chuyển sẽ không thể chỉ định cho đến khi nhóm được kích hoạt lại. Kết quả đã hoàn tất giữ nguyên dữ liệu gốc.",
  "label.labUnit.inactiveOption": "{name} (ngừng dùng)",
  "label.labUnit.tests.reassign.moving": "{count, plural, other {# xét nghiệm}} will be moved:",
  "message.labUnit.tests.assigned": "Đã gán xét nghiệm cho nhóm này.",
  "message.labUnit.tests.reassigned": "Chuyển xét nghiệm thành công.",
  "placeholder.labUnit.tests.reassign.destination": "Chọn nhóm đích...",
  "placeholder.labUnit.tests.search": "Tìm xét nghiệm...",
  "label.labUnit.section.assigned-tests": "Xét nghiệm đã gán",
  "label.labUnit.section.basic-info": "Thông tin cơ bản",
  "label.labUnit.section.display-order": "Thứ tự hiển thị",
  "label.labUnit.status": "Trạng thái",
  "label.labUnit.testCount": "Xét nghiệm",
  "label.labUnit.tests.addHint": "Lưu nhóm xét nghiệm này trước, rồi mới gán xét nghiệm cho nhóm.",
  "label.labUnit.tests.count": "{count, plural, other {Đã gán # xét nghiệm}}",
  "label.labUnit.tests.loadError": "Không tải được danh sách xét nghiệm đã gán",
  "label.labUnit.tests.loading": "Đang tải xét nghiệm đã gán...",
  "label.labUnit.tests.none": "Nhóm xét nghiệm này chưa có xét nghiệm nào được gán.",
  "label.labUnit.tests.testName": "Tên xét nghiệm",
  "message.labUnit.add.success": "Tạo nhóm xét nghiệm thành công.",
  "message.labUnit.edit.success": "Lưu nhóm xét nghiệm thành công.",
  "message.labUnit.noResults": "Không tìm thấy nhóm xét nghiệm nào khớp tiêu chí",
  "placeholder.labUnit.filter.domain": "Tất cả lĩnh vực",
  "placeholder.labUnit.filter.status": "Tất cả trạng thái",
  "placeholder.labUnit.search": "Tìm nhóm xét nghiệm...",
  "sidenav.label.admin.labUnit.addingNew": "Đang thêm nhóm xét nghiệm mới",
  "sidenav.label.admin.labUnit.backToList": "← Tất cả nhóm xét nghiệm",
  "sidenav.label.admin.labUnit.editing": "Đang sửa: {name}",
  "sidenav.label.admin.labUnit.editingGeneric": "Đang sửa nhóm xét nghiệm",
  "sidenav.label.admin.labUnit.sectionsHelper": "Bấm vào một nhóm xét nghiệm để sửa các mục của nhóm",
  "sidenav.label.admin.labUnitManagement": "Trình sửa nhóm xét nghiệm",
  "warning.labUnit.deactivateInUse": "{count, plural, other {Có # xét nghiệm đang dùng được gán cho nhóm xét nghiệm này. Ngừng dùng nhóm sẽ ẩn các xét nghiệm khỏi màn chỉ định nhưng vẫn giữ việc gán.}}",
  "heading.labUnit.deactivate": "Ngừng dùng nhóm xét nghiệm",
  "button.labUnit.deactivate.confirm": "Ngừng dùng nhóm xét nghiệm",
  "label.labUnit.deactivate.loading": "Đang kiểm tra ảnh hưởng…",
  "label.labUnit.deactivate.impact": "Nhóm xét nghiệm này hiện đang giữ:",
  "label.labUnit.deactivate.impact.tests": "{count} xét nghiệm đã gán ({active} đang dùng)",
  "label.labUnit.deactivate.impact.pending": "{count} phân tích đang chờ",
  "label.labUnit.deactivate.impact.historical": "{count} phân tích đã hoàn tất (lịch sử không bao giờ bị xóa)",
  "info.labUnit.deactivate.pending": "Nhóm xét nghiệm này vẫn nằm trên danh sách công việc cho đến khi {count} phân tích đang chờ được hoàn tất.",
  "label.labUnit.deactivate.option": "Xử lý các xét nghiệm đã gán thế nào?",
  "label.labUnit.deactivate.option.keep": "Giữ nguyên việc gán — xét nghiệm vẫn thuộc nhóm, nhóm ngừng nhận chỉ định mới",
  "label.labUnit.deactivate.option.deactivateAll": "Ngừng dùng luôn toàn bộ xét nghiệm đã gán",
  "label.labUnit.deactivate.option.reassign": "Chuyển xét nghiệm sang nhóm khác trước",
  "label.labUnit.deactivate.confirm": "Gõ DEACTIVATE để xác nhận",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Thêm",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Ngừng dùng",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Thoát",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Sửa",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Lưu",
  "admin.page.configuration.formEntryConfigMenu.description": "Mô tả",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Sửa bản ghi",
  "admin.page.configuration.formEntryConfigMenu.name": "Tên",
  "admin.page.configuration.formEntryConfigMenu.select": "Chọn",
  "admin.page.configuration.formEntryConfigMenu.value": "Giá trị",
  "admin.labelPresets.title": "Mẫu nhãn",
  "admin.labelPresets.addButton": "Thêm mẫu",
  "admin.labelPresets.search.placeholder": "Tìm mẫu...",
  "admin.labelPresets.col.name": "Tên",
  "admin.labelPresets.col.barcodeType": "Loại mã vạch",
  "admin.labelPresets.col.dimensions": "Kích thước",
  "admin.labelPresets.col.scope": "Phạm vi",
  "admin.labelPresets.col.status": "Trạng thái",
  "admin.labelPresets.col.actions": "Thao tác",
  "admin.labelPresets.systemTag": "Hệ thống",
  "admin.labelPresets.status.active": "Đang dùng",
  "admin.labelPresets.status.inactive": "Ngừng dùng",
  "admin.labelPresets.scope.order": "Chỉ định",
  "admin.labelPresets.scope.sample": "Mẫu",
  "admin.labelPresets.action.edit": "Sửa",
  "admin.labelPresets.action.duplicate": "Nhân bản",
  "admin.labelPresets.action.activate": "Kích hoạt",
  "admin.labelPresets.action.deactivate": "Ngừng dùng",
  "admin.labelPresets.duplicateName": "Bản sao của {name}",
  "admin.labelPresets.duplicated": "Đã nhân bản mẫu",
  "admin.labelPresets.duplicateFailed": "Nhân bản thất bại",
  "admin.labelPresets.activated": "Đã kích hoạt mẫu",
  "admin.labelPresets.deactivated": "Đã ngừng dùng mẫu",
  "admin.labelPresets.toggleFailed": "Đổi trạng thái thất bại",
  "admin.labelPresets.saveFailed": "Lưu thất bại",
  "admin.labelPresets.saveFailed.detail": "Máy chủ trả về {status}: {message}",
  "admin.labelPresets.saveFailed.noResponse": "Máy chủ không phản hồi. Kiểm tra kết nối và thử lại.",
  "error.labelpreset.fields.unique": "Mỗi trường nội dung và mỗi vị trí hiển thị chỉ được dùng một lần trong mỗi mẫu.",
  "error.labelpreset.field.required": "Mỗi mục trường nội dung phải chọn một trường.",
  "admin.labelPresets.created": "Đã tạo mẫu",
  "admin.labelPresets.updated": "Đã cập nhật mẫu",
  "admin.labelPresets.editor.titleAdd": "Thêm mẫu nhãn",
  "admin.labelPresets.editor.titleEdit": "Sửa mẫu nhãn",
  "admin.labelPresets.editor.section.basicInfo": "Thông tin cơ bản",
  "admin.labelPresets.editor.section.dimensions": "Kích thước (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Cài đặt mã vạch",
  "admin.labelPresets.editor.section.printScope": "Phạm vi in và số lượng",
  "admin.labelPresets.field.name": "Tên mẫu",
  "admin.labelPresets.field.isActive": "Đang dùng",
  "admin.labelPresets.field.heightMm": "Chiều cao (mm)",
  "admin.labelPresets.field.widthMm": "Chiều rộng (mm)",
  "admin.labelPresets.field.barcodeType": "Loại mã vạch",
  "admin.labelPresets.field.defaultPerOrder": "Mặc định mỗi chỉ định",
  "admin.labelPresets.field.maxPerOrder": "Tối đa mỗi chỉ định",
  "admin.labelPresets.field.defaultPerSample": "Mặc định mỗi mẫu",
  "admin.labelPresets.field.maxPerSample": "Tối đa mỗi mẫu",
  "admin.labelPresets.validation.name.required": "Bắt buộc nhập tên",
  "admin.labelPresets.validation.name.toolong": "Tên không được vượt quá 120 ký tự",
  "admin.labelPresets.validation.dimension.range": "Kích thước phải từ 5 đến 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Bắt buộc chọn loại mã vạch",
  "admin.labelPresets.validation.scope.required": "Phải chọn ít nhất một phạm vi in (Chỉ định hoặc Mẫu)",
  "admin.labelPresets.validation.max.lte": "Số tối đa phải lớn hơn hoặc bằng số mặc định",
  "admin.labelPresets.editor.section.fields": "Trường nội dung",
  "admin.labelPresets.fields.helper": "Các trường in phía trên mã vạch, theo thứ tự này. Số mã mẫu luôn đứng đầu.",
  "admin.labelPresets.fields.locked": "Luôn đứng đầu",
  "admin.labelPresets.fields.required": "Bắt buộc",
  "admin.labelPresets.fields.required.aria": "Bắt buộc: {field}",
  "admin.labelPresets.fields.moveUp": "Đưa {field} lên",
  "admin.labelPresets.fields.moveDown": "Đưa {field} xuống",
  "admin.labelPresets.fields.remove": "Bỏ {field}",
  "admin.labelPresets.fields.add.label": "Thêm một trường",
  "admin.labelPresets.fields.add.placeholder": "Chọn trường",
  "admin.labelPresets.fields.add.button": "Thêm",
  "admin.labelPresets.fields.allAdded": "Mọi trường có sẵn đã có trên nhãn này.",
  "admin.labelPresets.fields.fitHint": "{count, plural, one {Trường đã chọn} other {# trường đã chọn}} có thể không vừa nhãn {height} mm; phía trên mã vạch chỉ vừa khoảng {rows, plural, one {# dòng} other {# dòng}}. Bạn vẫn có thể lưu.",
  "admin.labelPresets.fields.position": "Vị trí {position}",
  "admin.labelPresets.fieldKey.LAB_NUMBER": "Số mã mẫu",
  "admin.labelPresets.fieldKey.PATIENT_NAME": "Tên bệnh nhân",
  "admin.labelPresets.fieldKey.PATIENT_ID": "Mã bệnh nhân",
  "admin.labelPresets.fieldKey.PATIENT_DOB": "Ngày sinh bệnh nhân",
  "admin.labelPresets.fieldKey.PATIENT_SEX": "Phái bệnh nhân",
  "admin.labelPresets.fieldKey.SITE_ID": "Mã đơn vị gửi",
  "admin.labelPresets.fieldKey.COLLECTION_DATETIME": "Ngày giờ lấy mẫu",
  "admin.labelPresets.fieldKey.COLLECTED_BY": "Người lấy mẫu",
  "admin.labelPresets.fieldKey.TESTS": "Xét nghiệm",
  "admin.labelPresets.fieldKey.SPECIMEN_TYPE": "Loại mẫu",
  "admin.labelPresets.fieldKey.BLOCK_ID": "Mã block",
  "admin.labelPresets.fieldKey.SLIDE_ID": "Mã lam",
  "admin.labelPresets.fieldKey.STAIN_TYPE": "Loại nhuộm",
  "admin.labelPresets.fieldKey.CASE_NUMBER": "Số ca",
  "admin.labelPresets.fieldKey.STORAGE_LOCATION": "Vị trí lưu trữ",
  "admin.labelPresets.fieldKey.EXPIRY_DATE": "Ngày hết hạn",
  "error.labelpreset.field.key.unknown": "Trường nội dung không xác định.",
  "admin.labelPresets.siteWide.title": "Cài đặt mã vạch toàn cơ sở",
  "admin.labelPresets.siteWide.scope": "Áp dụng toàn phòng xét nghiệm",
  "admin.labelPresets.siteWide.prePrint.legend": "Số nhãn in sẵn lấy từ",
  "admin.labelPresets.siteWide.prePrint.orderEntry": "Cùng định dạng và dải số với nhập chỉ định",
  "admin.labelPresets.siteWide.prePrint.separate": "Một dãy nhãn in sẵn riêng",
  "admin.labelPresets.siteWide.prefix.label": "Tiền tố",
  "admin.labelPresets.siteWide.prefix.helper": "Đúng 4 chữ cái hoặc chữ số. Số in sẵn bắt đầu bằng tiền tố này, rồi đến năm và số thứ tự.",
  "admin.labelPresets.siteWide.prefix.invalid": "Tiền tố phải đúng 4 chữ cái hoặc chữ số",
  "admin.labelPresets.siteWide.save": "Lưu cài đặt",
  "admin.labelPresets.siteWide.saved": "Đã lưu cài đặt mã vạch toàn cơ sở",
  "admin.labelPresets.siteWide.saveFailed": "Chưa lưu được cài đặt mã vạch toàn cơ sở",
  "admin.labelPresets.siteWide.loadFailed": "Không tải được cài đặt mã vạch toàn cơ sở. Tải lại trang để thử lại.",
  "error.sitesettings.barcode.prefix.format": "Tiền tố in sẵn phải đúng 4 chữ cái hoặc chữ số khi dùng dãy riêng",
  "advanced.search": "Tìm nâng cao",
  "alert.expired.title": "Hàng đã hết hạn",
  "alert.expiring.title": "Sắp hết hạn",
  "alert.lowStock.title": "Cảnh báo sắp hết hàng",
  "alerts.acknowledge.button": "Xác nhận",
  "alerts.acknowledge.comment": "Ghi chú xử lý",
  "alerts.acknowledge.comment.placeholder": "Mô tả cách đã xử lý cảnh báo này...",
  "alerts.acknowledge.comment.required": "Bắt buộc có ghi chú xử lý với cảnh báo nghiêm trọng",
  "alerts.acknowledge.error": "Xác nhận cảnh báo thất bại",
  "alerts.acknowledge.success": "Đã xác nhận cảnh báo",
  "alerts.acknowledge.title": "Xác nhận cảnh báo",
  "alerts.autoRefresh": "Tự làm mới mỗi 60 giây",
  "alerts.dashboard.title": "Bảng cảnh báo",
  "alerts.empty": "Không có cảnh báo nào để hiển thị",
  "alerts.eqaDeadlineSummary.critical": "Khẩn",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} hạn sắp tới",
  "alerts.eqaDeadlineSummary.subtitle": "Các hạn nộp kết quả EQA sắp tới, nhóm theo nhà cung cấp",
  "alerts.eqaDeadlineSummary.title": "Tóm tắt hạn EQA",
  "alerts.eqaDeadlineSummary.viewAll": "Xem tất cả",
  "alerts.filter.myAlerts": "Cảnh báo của tôi",
  "alerts.filter.search": "Tìm cảnh báo...",
  "alerts.filter.severity": "Mức độ",
  "alerts.filter.status": "Trạng thái",
  "alerts.filter.type": "Loại cảnh báo",
  "alerts.severity.critical": "Nghiêm trọng",
  "alerts.severity.warning": "Cảnh báo",
  "alerts.status.acknowledged": "Đã xác nhận",
  "alerts.status.open": "Đang mở",
  "alerts.status.resolved": "Đã xử lý",
  "alerts.summary.critical": "Cảnh báo nghiêm trọng",
  "alerts.summary.eqaDeadlines": "Hạn EQA",
  "alerts.summary.sampleExpiration": "Mẫu sắp hết hạn",
  "alerts.summary.statOverdue": "Chỉ định STAT quá hạn",
  "alerts.summary.totalOpen": "Tổng đang mở",
  "alerts.table.actions": "Thao tác",
  "alerts.table.created": "Tạo lúc",
  "alerts.table.message": "Nội dung",
  "alerts.table.severity": "Mức độ",
  "alerts.table.status": "Trạng thái",
  "alerts.table.type": "Loại",
  "alerts.type.critical_result": "Kết quả nghiêm trọng",
  "alerts.type.equipment_failure": "Thiết bị hỏng",
  "alerts.type.freezer_humidity": "Độ ẩm tủ lạnh sâu",
  "alerts.type.freezer_offline": "Tủ lạnh sâu ngừng kết nối",
  "alerts.type.freezer_temperature": "Nhiệt độ tủ lạnh sâu",
  "alerts.type.inventory_low": "Tồn kho thấp",
  "alerts.type.other": "Khác",
  "alerts.type.referral_critical_result": "Kết quả nghiêm trọng của mẫu gửi đi",
  "alerts.type.referral_rejected": "Mẫu gửi đi bị từ chối",
  "alerts.type.sample_tracking": "Theo dõi mẫu",
  "alerts.type.critical_unacknowledged": "Nghiêm trọng chưa xác nhận",
  "alerts.type.eqa_deadline": "Hạn EQA",
  "alerts.type.eqa_submission_failed": "Nộp EQA thất bại",
  "alerts.type.microbiology_critical": "Vi sinh nghiêm trọng",
  "alerts.type.required_by_deadline": "Đến hạn yêu cầu",
  "alerts.type.sample_expiration": "Mẫu hết hạn",
  "alerts.type.stat_overdue": "STAT quá hạn",
  "alerts.type.stat_upcoming": "STAT sắp đến hạn",
  "aliquot": "Phần mẫu con",
  "aliquot.analyses.count": "Phân tích: {count}",
  "aliquot.id": "Mã phần mẫu con",
  "aliquot.quantity": "Số lượng phần mẫu con",
  "aliquot.quantity.not.balanced": "Số lượng không cân đối với loại mẫu",
  "aliquot.save.error": "Lỗi khi lưu dữ liệu chia phần mẫu con.",
  "aliquot.save.success": "Đã lưu dữ liệu chia phần mẫu con.",
  "aliquot.tests.not.assigned": "Chưa gán xét nghiệm cho loại mẫu",
  "aliquot.validation.errors": "Lỗi kiểm tra",
  "aliquoting": "Chia phần mẫu con",
  "aliquoting.section": "Mục chia phần mẫu con",
  "all.label": "Tất cả",
  "all.tests.assigned": "Đã gán tất cả xét nghiệm",
  "allocated.to.aliquots": "Đã phân bổ cho phần mẫu con",
  "analysis.count": "Số phân tích",
  "analysis.details": "Chi tiết phân tích",
  "analyzer.adoption.error.heldResults": "{record} vẫn còn kết quả bị giữ từ bản {revision}. Xử lý chúng trước khi áp dụng.",
  "analyzer.adoption.error.inactiveTest": "{record} được ánh xạ tới một xét nghiệm không còn hoạt động. Chọn xét nghiệm khác trước khi áp dụng.",
  "analyzer.adoption.error.missingAnswers": "{record} cần quyết định cho từng đáp án. Còn thiếu: {answers}.",
  "analyzer.adoption.error.missingDecisions": "Mọi bản ghi mà bản mới hơn giữ lại đều cần quyết định. Còn thiếu: {records}.",
  "analyzer.adoption.error.notNewer": "Việc áp dụng chỉ chuyển máy sang bản mới hơn bản {revision}.",
  "analyzer.adoption.error.revisionInactive": "Bản {revision} của loại máy này không còn hoạt động.",
  "analyzer.bridge.connection.httpStatus": "Analyzer Bridge từ chối yêu cầu.",
  "analyzer.bridge.connection.invalidEvidence": "Analyzer Bridge trả lời cho một máy hoặc loại máy khác.",
  "analyzer.bridge.connection.invalidRequest": "Yêu cầu gửi tới Analyzer Bridge chưa đầy đủ.",
  "analyzer.bridge.connection.notConfigured": "Máy chủ này chưa cấu hình Analyzer Bridge.",
  "analyzer.bridge.connection.reconcileRequired": "OpenELIS giữ ánh xạ cũ của máy, nhưng Analyzer Bridge có thể vẫn đang dùng ánh xạ mới. Khi Bridge kết nối được, hãy áp dụng lại ánh xạ để đồng bộ.",
  "analyzer.bridge.connection.referenceNotStored": "Không lưu được kết nối Analyzer Bridge cho máy này.",
  "analyzer.bridge.connection.unreachable": "Không kết nối được Analyzer Bridge.",
  "analyzer.mapping.error.catalogNotCurrent": "Một xét nghiệm hoặc đáp án đã ánh xạ không còn hoạt động trong danh mục xét nghiệm. Chọn cái khác trước khi xác nhận.",
  "analyzer.mapping.error.changedSinceLoaded": "Ánh xạ của máy này đã thay đổi sau khi trang được tải. Tải lại trang để xem ánh xạ hiện tại.",
  "analyzer.mapping.error.componentRequired": "{record} rơi vào một thành phần của xét nghiệm. Chọn thành phần đó, hoặc để bản ghi chưa xử lý.",
  "analyzer.mapping.error.confirmBeforeApply": "Xác nhận ánh xạ hiện tại của máy trước khi áp dụng.",
  "analyzer.mapping.error.resultNotCurrent": "Một đáp án đã ánh xạ không còn hoạt động cho xét nghiệm của nó. Chọn đáp án khác.",
  "analyzer.mapping.error.testNotCurrent": "Một xét nghiệm đã ánh xạ không còn hoạt động trong danh mục. Chọn xét nghiệm khác.",
  "analyzer.setup.assays.continue": "Tiếp tục để kiểm tra",
  "analyzer.setup.assays.count": "{on} / {total} assay đang bật",
  "analyzer.setup.assays.help": "Bật các assay mà máy này chạy, giống trong cài đặt mã xét nghiệm của chính máy. Bước Kiểm tra chỉ ánh xạ các assay đang bật. Kết quả của assay đang tắt sẽ bị giữ lại, không mất.",
  "analyzer.setup.assays.loadError": "Không tải được các assay của máy.",
  "analyzer.setup.assays.loading": "Đang tải assay",
  "analyzer.setup.assays.match.ambiguous": "Nhiều xét nghiệm trong danh mục của phòng khớp với",
  "analyzer.setup.assays.match.bound": "Khớp với {name}",
  "analyzer.setup.assays.match.excluded": "Đặt là không nhận",
  "analyzer.setup.assays.match.incompatible": "Có xét nghiệm khớp nhưng không chứa được các kết quả này",
  "analyzer.setup.assays.match.noMatch": "Không có xét nghiệm nào trong danh mục của phòng",
  "analyzer.setup.assays.none": "Loại máy này không khai báo assay nào nên không có gì để ánh xạ. Kết quả máy gửi lên sẽ bị giữ như xét nghiệm chưa biết và có thể ánh xạ từ kết quả bị giữ.",
  "analyzer.setup.assays.saveError": "Không lưu được các assay.",
  "analyzer.setup.assays.title": "Assay",
  "analyzer.setup.error.adoptToMove": "Để chuyển máy này sang bản {revision}, hãy áp dụng từ trang loại máy.",
  "analyzer.setup.error.profileKept": "Máy đã cấu hình sẽ giữ nguyên loại máy.",
  "analyzer.reset.error.profileAvailable": "Loại máy của máy này vẫn còn. Áp dụng một bản mới hơn để chuyển máy.",
  "analyzer.setup.connect.reset": "Đặt lại loại máy",
  "analyzer.setup.connect.reset.failed": "Không đặt lại được loại máy. Thử lại.",
  "analyzer.action.activate": "Kích hoạt",
  "analyzer.action.add": "Thêm máy xét nghiệm",
  "analyzer.action.configureConnection": "Cấu hình kết nối",
  "analyzer.action.deactivate": "Ngừng dùng",
  "analyzer.action.editSetup": "Sửa cài đặt",
  "analyzer.action.qualityControl": "Kiểm soát chất lượng",
  "analyzer.action.reactivate": "Kích hoạt lại",
  "analyzer.action.restore": "Restore",
  "analyzer.action.retire": "Retire",
  "analyzer.bridgePairing.automatic": "OpenELIS tự ghép đôi với mã mà nó được cấu hình. Bạn cũng có thể nhập mã tại đây.",
  "analyzer.bridgePairing.cancel": "Hủy",
  "analyzer.bridgePairing.code.label": "Mã ghép đôi",
  "analyzer.bridgePairing.error.certificateMismatch": "Bridge trả lời bằng chứng chỉ khác với chứng chỉ nó đã đưa ra, nên OpenELIS không ghép đôi.",
  "analyzer.bridgePairing.error.closed": "Bridge không nhận ghép đôi. Hãy cấu hình mã ghép đôi mới trên Bridge, khởi động lại, rồi ghép đôi lại.",
  "analyzer.bridgePairing.error.codeRequired": "Nhập mã ghép đôi.",
  "analyzer.bridgePairing.error.identity": "OpenELIS không tạo hoặc đọc được khóa của mình cho Bridge.",
  "analyzer.bridgePairing.error.invalidAnswer": "Không đọc được phản hồi của Bridge.",
  "analyzer.bridgePairing.error.notConfigured": "Chưa cấu hình địa chỉ Analyzer Bridge cho OpenELIS.",
  "analyzer.bridgePairing.error.refused": "Bridge từ chối ghép đôi.",
  "analyzer.bridgePairing.error.unreachable": "OpenELIS không kết nối được Analyzer Bridge.",
  "analyzer.bridgePairing.error.wrongCode": "Bridge không chấp nhận mã đó.",
  "analyzer.bridgePairing.pair": "Ghép đôi",
  "analyzer.bridgePairing.pairAgain": "Ghép đôi lại",
  "analyzer.bridgePairing.paired.detail": "{url} · chứng chỉ Bridge {fingerprint} · ghép đôi lúc {pairedAt}",
  "analyzer.bridgePairing.paired.title": "Đã ghép đôi với Analyzer Bridge",
  "analyzer.bridgePairing.stale.bridgeUnpaired.subtitle": "The Bridge at {url} presents the paired certificate {fingerprint} but no longer holds a pairing, so it refuses OpenELIS's calls and holds results.",
  "analyzer.bridgePairing.stale.bridgeUnpaired.title": "The Analyzer Bridge lost its pairing",
  "analyzer.bridgePairing.stale.otherCertificate.subtitle": "The Bridge at {url} presents a certificate other than the paired one ({fingerprint}). OpenELIS refuses its results until it pairs again.",
  "analyzer.bridgePairing.stale.otherCertificate.title": "Paired with a different Bridge certificate",
  "analyzer.bridgePairing.unpaired.subtitle": "Nhập mã ghép đôi mà Bridge hiển thị trong nhật ký, hoặc mã đã cấu hình cho nó. Kết quả sẽ chờ trong Bridge cho đến khi được ghép đôi.",
  "analyzer.bridgePairing.unpaired.title": "Analyzer Bridge chưa được ghép đôi",
  "analyzer.combinationName.notification": "Tổ hợp máy và tên xét nghiệm của máy phải là duy nhất",
  "analyzer.fhirImport.error.importFailed": "Nhập gói FHIR thất bại",
  "analyzer.fhirImport.error.invalidBundleType": "Loại bundle phải là 'transaction' hoặc 'batch', nhận được: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle không chứa Observation nào có kết quả",
  "analyzer.deliveryIssues.attention.review": "Xem kết quả chưa gửi được",
  "analyzer.deliveryIssues.attention.subtitle": "Analyzer Bridge đang giữ các kết quả chưa gửi được tới OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, other {# kết quả từ máy}} not delivered",
  "analyzer.deliveryIssues.column.actions": "Thao tác",
  "analyzer.deliveryIssues.column.analyzer": "Máy",
  "analyzer.deliveryIssues.column.detail": "Chi tiết",
  "analyzer.deliveryIssues.column.reason": "Lý do",
  "analyzer.deliveryIssues.column.received": "Nhận lúc",
  "analyzer.deliveryIssues.column.sender": "Bên gửi",
  "analyzer.deliveryIssues.column.status": "Trạng thái",
  "analyzer.deliveryIssues.description": "Các kết quả Bridge đã nhận nhưng chưa gửi được tới OpenELIS. Thử lại sẽ gửi lại kết quả sau khi sửa nguyên nhân; Bỏ qua sẽ ẩn kết quả và giữ nó trong Bridge để kiểm tra.",
  "analyzer.deliveryIssues.dismiss": "Bỏ qua",
  "analyzer.deliveryIssues.empty": "Bridge không có kết quả nào chưa gửi được.",
  "analyzer.deliveryIssues.error.actionFailed": "Không hoàn tất được thao tác. Tải lại và thử lại.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "Analyzer Bridge gửi một phản hồi mà OpenELIS không đọc được.",
  "analyzer.deliveryIssues.error.incompleteList": "Analyzer Bridge có nhiều kết quả chưa gửi hơn mức màn hình này tải được. Hãy kiểm tra hàng đợi gửi của Bridge trực tiếp.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS chưa cấu hình địa chỉ Analyzer Bridge.",
  "analyzer.deliveryIssues.error.bridgeRefused": "Bridge từ chối thao tác này ({reason}). Tải lại để xem trạng thái hiện tại.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "Không kết nối được Analyzer Bridge.",
  "analyzer.deliveryIssues.error.invalidId": "Tham chiếu kết quả này không hợp lệ.",
  "analyzer.deliveryIssues.loadFailed": "Không tải được danh sách kết quả chưa gửi từ Analyzer Bridge.",
  "analyzer.deliveryIssues.loading": "Đang kiểm tra Analyzer Bridge về các kết quả chưa gửi",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "Có hơn một kết nối máy có thể sở hữu thông điệp này. Hãy gán cho mỗi máy một địa chỉ riêng, rồi thử lại.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "Máy gửi qua một loại kết nối mà cài đặt của nó không chấp nhận.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS từ chối kết quả do cài đặt của chính hệ thống. Sửa cài đặt máy, rồi thử lại.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS đã từ chối kết quả.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS trả về chuyển hướng nên kết quả chưa được gửi. Kiểm tra địa chỉ OpenELIS trong Bridge.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "Thông điệp không chứa kết quả nào để gửi.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "Bridge không chuyển đổi được thông điệp cho OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS không kết nối được cho đến khi hết mọi lần thử lại. Kết quả vẫn còn nguyên; hãy thử lại khi OpenELIS kết nối được.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "Kết nối của máy không gắn bản loại máy nào nên không đọc được kết quả.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "Người gửi không khớp kết nối máy nào đã lưu. Thiết lập máy, rồi thử lại.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS chưa nhận kết quả; Bridge tiếp tục thử lại.",
  "analyzer.deliveryIssues.reason.unknown": "Bridge không gửi được kết quả này ({code}).",
  "analyzer.deliveryIssues.retry": "Thử lại",
  "analyzer.deliveryIssues.state.deadLettered": "Chưa gửi được",
  "analyzer.deliveryIssues.state.retrying": "Đang thử lại",
  "analyzer.deliveryIssues.title": "Kết quả máy chưa gửi được",
  "analyzer.deliveryIssues.unrecognizedSender": "Không nhận diện được người gửi {source}",
  "analyzer.importIssues.accession": "Số mã mẫu",
  "analyzer.importIssues.action": "Thao tác",
  "analyzer.importIssues.description": "Xem các sự kiện máy vi sinh không khớp hoặc không xử lý được. Kết quả bị giữ được xem trong hàng đợi kết quả của từng máy.",
  "analyzer.importIssues.empty": "Không có sự kiện máy vi sinh lỗi nào cần xử lý",
  "analyzer.importIssues.event": "Sự kiện",
  "analyzer.importIssues.event.astQcFail": "Kiểm soát chất lượng AST thất bại",
  "analyzer.importIssues.event.astResultAvailable": "Có kết quả AST",
  "analyzer.importIssues.event.unknown": "Sự kiện máy ({code})",
  "analyzer.importIssues.events.description": "Sửa ánh xạ máy hoặc thông tin đích trước khi nguồn gửi lại kết quả.",
  "analyzer.importIssues.events.title": "Sự kiện máy bị kẹt",
  "analyzer.importIssues.failure.astRunNotMatched": "Không có lượt AST nào khớp mã máy và mã thẻ.",
  "analyzer.importIssues.failure.processingFailed": "Không xử lý được sự kiện máy.",
  "analyzer.importIssues.failure.unknown": "Không xử lý được sự kiện máy ({code}).",
  "analyzer.importIssues.loadFailed": "Không tải được các vấn đề nhập từ máy",
  "analyzer.importIssues.loading": "Đang tải các vấn đề nhập từ máy",
  "analyzer.importIssues.openMappings": "Mở ánh xạ",
  "analyzer.importIssues.openResults": "Mở kết quả máy",
  "analyzer.importIssues.reason": "Lý do lỗi",
  "analyzer.importIssues.received": "Nhận lúc",
  "analyzer.importIssues.result": "Kết quả",
  "analyzer.importIssues.source": "Mã nguồn",
  "analyzer.importIssues.staging.description": "Các dòng kết quả nhập này cần sửa cấu hình máy trước khi kiểm tra.",
  "analyzer.importIssues.staging.title": "Vấn đề kết quả đang chờ",
  "analyzer.importIssues.target": "Tham chiếu đích",
  "analyzer.importIssues.test": "Xét nghiệm",
  "analyzer.importIssues.title": "Vấn đề nhập từ máy xét nghiệm",
  "analyzer.fieldCreation.acceptedUnits.label": "Đơn vị chấp nhận",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Chọn đơn vị chấp nhận",
  "analyzer.fieldCreation.cancel": "Hủy",
  "analyzer.fieldCreation.confirmation": "Tôi hiểu trường này sẽ có thể ánh xạ ngay sau khi tạo",
  "analyzer.fieldCreation.create": "Tạo trường",
  "analyzer.fieldCreation.createNew": "Tạo trường mới",
  "analyzer.fieldCreation.description.label": "Mô tả (tùy chọn)",
  "analyzer.fieldCreation.description.placeholder": "Nhập mô tả trường",
  "analyzer.fieldCreation.entityType.label": "Loại đối tượng",
  "analyzer.fieldCreation.entityType.placeholder": "Chọn loại đối tượng",
  "analyzer.fieldCreation.error.generic": "Tạo trường thất bại",
  "analyzer.fieldCreation.error.title": "Lỗi khi tạo trường",
  "analyzer.fieldCreation.fieldName.label": "Tên trường",
  "analyzer.fieldCreation.fieldName.placeholder": "Nhập tên trường",
  "analyzer.fieldCreation.fieldType.label": "Kiểu trường",
  "analyzer.fieldCreation.fieldType.placeholder": "Chọn kiểu trường",
  "analyzer.fieldCreation.loincCode.label": "Mã LOINC (tùy chọn)",
  "analyzer.fieldCreation.loincCode.placeholder": "Nhập mã LOINC",
  "analyzer.fieldCreation.modal.subtitle": "Tạo một trường mới sẽ có thể ánh xạ ngay",
  "analyzer.fieldCreation.modal.title": "Tạo trường OpenELIS mới",
  "analyzer.fieldCreation.success.message": "Trường này đã sẵn sàng để ánh xạ",
  "analyzer.fieldCreation.success.title": "Tạo trường thành công",
  "analyzer.fieldCreation.validation.entityType.required": "Bắt buộc chọn loại đối tượng",
  "analyzer.fieldCreation.validation.fieldName.required": "Bắt buộc nhập tên trường",
  "analyzer.fieldCreation.validation.unique": "Đã có trường với tên này",
  "analyzer.fieldCreation.validation.units.required": "Trường số bắt buộc có đơn vị chấp nhận",
  "analyzer.filter.lifecycleStage.all": "Mọi giai đoạn vòng đời",
  "analyzer.filter.lifecycleStage.label": "Giai đoạn vòng đời",
  "analyzer.filter.showRetired": "Show retired analyzers",
  "analyzer.filter.status": "Trạng thái",
  "analyzer.filter.status.all": "Mọi trạng thái",
  "analyzer.filter.status.label": "Trạng thái",
  "analyzer.filter.testUnit": "Nhóm xét nghiệm",
  "analyzer.filter.type": "Loại máy",
  "analyzer.form.activeStatus": "Trạng thái hoạt động",
  "analyzer.form.activeStatus.description": "Bật máy này để thu thập dữ liệu",
  "analyzer.form.addTitle": "Thêm máy xét nghiệm mới",
  "analyzer.form.cancel": "Hủy",
  "analyzer.form.communicationMode": "Chế độ giao tiếp",
  "analyzer.form.communicationMode.analyzerInitiated": "Máy → LIS (máy kết nối tới OpenELIS)",
  "analyzer.form.communicationMode.both": "Hai chiều (cả hai hướng)",
  "analyzer.form.communicationMode.help": "Bên nào khởi tạo kết nối. Hầu hết máy dùng Máy → LIS.",
  "analyzer.form.communicationMode.lisInitiated": "LIS → Máy (OpenELIS kết nối tới máy)",
  "analyzer.form.createdBy": "Người tạo",
  "analyzer.form.createdDate": "Ngày giờ tạo",
  "analyzer.form.defaults.error": "Không tải được cấu hình mặc định",
  "analyzer.form.defaults.loaded": "Đã tải cấu hình mặc định",
  "analyzer.form.defaults.loaded.subtitle": "Đã tải mẫu cho {name}. Hãy tùy chỉnh trước khi lưu.",
  "analyzer.form.editTitle": "Sửa máy xét nghiệm",
  "analyzer.form.error.invalidCommunicationMode": "Chế độ giao tiếp không hợp lệ: {value}. Giá trị hợp lệ: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Phiên bản giao thức không hợp lệ: {value}. Giá trị hợp lệ: {validValues}",
  "analyzer.form.error.save": "Lưu máy xét nghiệm thất bại",
  "analyzer.form.error.unknown": "Đã xảy ra lỗi không xác định",
  "analyzer.form.fileProtocol.description": "Máy này nhập kết quả từ tệp. Cài đặt nhập tệp sẽ được cấu hình sau khi lưu.",
  "analyzer.form.fileProtocol.title": "Giao thức nhập tệp",
  "analyzer.form.identifierPattern": "Mẫu nhận diện",
  "analyzer.form.identifierPattern.helperText": "Biểu thức chính quy để khớp mã nhận diện thông điệp đến nhằm định tuyến",
  "analyzer.form.identifierPattern.placeholder": "VD: ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "Địa chỉ IP",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Ngày giờ sửa cuối",
  "analyzer.form.loadDefaultConfig": "Tải hồ sơ máy",
  "analyzer.form.loadDefaultConfig.helperText": "Thiết lập nhanh bằng mẫu hồ sơ máy có sẵn",
  "analyzer.form.loadDefaultConfig.placeholder": "Chọn một hồ sơ máy có sẵn",
  "analyzer.form.name": "Tên máy",
  "analyzer.form.name.placeholder": "VD: Máy huyết học 1",
  "analyzer.form.pluginType": "Loại plugin",
  "analyzer.form.pluginType.helperText": "Plugin máy sẽ xử lý các thông điệp đến",
  "analyzer.form.pluginType.placeholder": "Chọn loại plugin...",
  "analyzer.form.port": "Số cổng",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Phiên bản giao thức",
  "analyzer.form.save": "Lưu",
  "analyzer.form.status": "Trạng thái",
  "analyzer.form.status.helperText": "Trạng thái tự chuyển theo tình trạng máy. Chỉ được ghi đè thủ công sang NGỪNG, CÀI ĐẶT hoặc KIỂM TRA.",
  "analyzer.form.subtitle": "Cấu hình kết nối máy và các nhóm xét nghiệm",
  "analyzer.form.success.save": "Đã lưu máy xét nghiệm",
  "analyzer.form.testConnection": "Kiểm tra kết nối",
  "analyzer.form.testConnection.error": "Kết nối thất bại",
  "analyzer.form.testUnits": "Gán nhóm xét nghiệm",
  "analyzer.form.testUnits.helper": "Chọn một hoặc nhiều nhóm xét nghiệm cho máy này",
  "analyzer.form.testUnits.placeholder": "Chọn nhóm xét nghiệm...",
  "analyzer.form.type": "Loại máy",
  "analyzer.form.type.helperText": "Chọn Loại máy dùng lại được cho kết nối đã cài đặt này.",
  "analyzer.form.type.invalidSelection": "Bản loại máy này không có sẵn hoặc đã ngừng dùng",
  "analyzer.form.type.loadError": "Không tải được danh sách Loại máy",
  "analyzer.form.type.other": "Khác",
  "analyzer.form.type.placeholder": "Chọn loại máy",
  "analyzer.form.type.revision": "{name}, bản {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "Định dạng địa chỉ IP không hợp lệ",
  "analyzer.form.validation.name.required": "Bắt buộc nhập tên máy",
  "analyzer.form.validation.type.required": "Bắt buộc chọn loại máy",
  "analyzer.hl7.insertError": "Lỗi chèn HL7",
  "analyzer.hl7.parseError": "Lỗi phân tích HL7",
  "analyzer.hl7.unknownAnalyzer": "Không xác định được máy từ MSH của HL7 (ứng dụng/cơ sở gửi)",
  "analyzer.list.subtitle": "Quản lý máy xét nghiệm và ánh xạ trường",
  "analyzer.list.title": "Máy xét nghiệm",
  "analyzer.lifecycle.activate.blockedMessage": "Hoàn tất các yêu cầu cài đặt sau trước khi kích hoạt. Mở Sửa cài đặt của máy này để kiểm tra ánh xạ và kết nối.",
  "analyzer.lifecycle.activate.blockedTitle": "Máy chưa sẵn sàng",
  "analyzer.lifecycle.activate.cancel": "Hủy kích hoạt",
  "analyzer.lifecycle.activate.confirm": "Kích hoạt máy",
  "analyzer.lifecycle.activate.error": "Không kích hoạt được máy.",
  "analyzer.lifecycle.activate.errorTitle": "Kích hoạt thất bại",
  "analyzer.lifecycle.activate.message": "Kích hoạt {name}? Cài đặt sẽ được kiểm tra trước khi máy được dùng.",
  "analyzer.lifecycle.activate.title": "Kích hoạt máy",
  "analyzer.lifecycle.deactivate.cancel": "Hủy ngừng dùng",
  "analyzer.lifecycle.deactivate.confirm": "Ngừng dùng máy",
  "analyzer.lifecycle.deactivate.error": "Không ngừng dùng được máy.",
  "analyzer.lifecycle.deactivate.errorTitle": "Ngừng dùng thất bại",
  "analyzer.lifecycle.deactivate.message": "Ngừng dùng {name}? Việc sử dụng máy khi chạy sẽ dừng. Cấu hình và lịch sử được giữ lại, và có thể kích hoạt lại sau.",
  "analyzer.lifecycle.deactivate.title": "Ngừng dùng máy",
  "analyzer.lifecycle.delete.cancel": "Keep analyzer",
  "analyzer.lifecycle.delete.confirm": "Delete analyzer",
  "analyzer.lifecycle.delete.error": "The analyzer could not be deleted.",
  "analyzer.lifecycle.delete.errorTitle": "Delete refused",
  "analyzer.lifecycle.delete.message": "Delete {name}? This is for an analyzer that never received a result and was never activated; one that was used is refused, so retire it instead.",
  "analyzer.lifecycle.delete.title": "Delete analyzer",
  "analyzer.lifecycle.error.inUse": "This analyzer has results or history. Retire it instead.",
  "analyzer.lifecycle.error.notRetired": "The analyzer is not retired.",
  "analyzer.lifecycle.error.running": "Deactivate the analyzer before retiring it.",
  "analyzer.lifecycle.reactivate.blockedMessage": "Hoàn tất các yêu cầu cài đặt sau trước khi kích hoạt lại. Mở Sửa cài đặt của máy này để kiểm tra ánh xạ và kết nối.",
  "analyzer.lifecycle.reactivate.blockedTitle": "Máy chưa sẵn sàng",
  "analyzer.lifecycle.reactivate.cancel": "Hủy kích hoạt lại",
  "analyzer.lifecycle.reactivate.confirm": "Kích hoạt lại máy",
  "analyzer.lifecycle.reactivate.error": "Không kích hoạt lại được máy.",
  "analyzer.lifecycle.reactivate.errorTitle": "Kích hoạt lại thất bại",
  "analyzer.lifecycle.reactivate.message": "Kích hoạt lại {name}? Cài đặt sẽ được kiểm tra lại trước khi máy được dùng.",
  "analyzer.lifecycle.reactivate.title": "Kích hoạt lại máy",
  "analyzer.lifecycle.restore.cancel": "Keep retired",
  "analyzer.lifecycle.restore.confirm": "Restore analyzer",
  "analyzer.lifecycle.restore.error": "The analyzer could not be restored.",
  "analyzer.lifecycle.restore.errorTitle": "Restore failed",
  "analyzer.lifecycle.restore.message": "Restore {name}? It comes back inactive, to be set up and activated again.",
  "analyzer.lifecycle.restore.title": "Restore analyzer",
  "analyzer.lifecycle.retire.cancel": "Keep analyzer",
  "analyzer.lifecycle.retire.confirm": "Retire analyzer",
  "analyzer.lifecycle.retire.error": "The analyzer could not be retired.",
  "analyzer.lifecycle.retire.errorTitle": "Retire failed",
  "analyzer.lifecycle.retire.message": "Retire {name}? Its results and history are kept, and it is hidden from this list unless you show retired analyzers.",
  "analyzer.lifecycle.retire.title": "Retire analyzer",
  "analyzer.connection.choice.select": "Chọn một giá trị",
  "analyzer.connection.field.apiToken": "API token",
  "analyzer.connection.field.connectionRole": "Vai trò kết nối",
  "analyzer.connection.field.directory": "Thư mục",
  "analyzer.connection.field.directory.help": "Thư mục trên máy chủ Analyzer Bridge",
  "analyzer.connection.field.enabled": "Bật",
  "analyzer.connection.field.filePattern": "Mẫu tên tệp",
  "analyzer.connection.field.filePattern.help": "Mẫu tên tệp mà Analyzer Bridge theo dõi",
  "analyzer.connection.field.host": "Máy chủ (host)",
  "analyzer.connection.field.host.help": "Địa chỉ IP của máy xét nghiệm. Không bắt buộc khi máy kết nối tới Analyzer Bridge. Để trống nếu máy tới Bridge qua NAT hoặc proxy, và dùng tên hệ thống của thiết bị thay thế.",
  "analyzer.connection.field.numberFormat": "Dấu thập phân trong kết quả",
  "analyzer.connection.numberFormat.comma": "Dấu phẩy (12,5)",
  "analyzer.connection.numberFormat.point": "Dấu chấm (12.5)",
  "analyzer.connection.field.port": "Cổng",
  "analyzer.connection.field.senderId": "Tên hệ thống thiết bị",
  "analyzer.connection.field.senderId.help": "Tên mà thiết bị gửi trong thông điệp (ASTM H.5 hoặc HL7 MSH-3), ví dụ System Name của GeneXpert. Chỉ cần khi nhiều máy dùng chung cổng và địa chỉ.",
  "analyzer.connection.field.received": "Received from instruments:",
  "analyzer.connection.field.serialPort": "Thiết bị cổng nối tiếp",
  "analyzer.connection.field.transport": "Phương thức truyền",
  "analyzer.connection.field.unavailable": "Cài đặt kết nối",
  "analyzer.connection.readiness.profileUnavailable": "Kết nối này đang gắn với {profileId} bản {revision}, mà Analyzer Bridge không còn có. Hãy đặt lại loại máy, rồi chọn một loại có sẵn để kết nối lại. Máy giữ nguyên tên, nhóm xét nghiệm, kết nối và lịch sử.",
  "analyzer.connection.readiness.restoreFailed": "Analyzer Bridge không khởi động lại được kết nối này. Kích hoạt lại; nếu vẫn lỗi, xem nhật ký Bridge.",
  "analyzer.connection.role.client": "Máy khách (client)",
  "analyzer.connection.role.server": "Máy chủ (server)",
  "analyzer.connection.reference.configured": "Đã cấu hình kết nối Bridge",
  "analyzer.connection.reference.missing": "Cần thiết lập kết nối",
  "analyzer.connection.transport.RS-232": "Nối tiếp (RS-232)",
  "analyzer.connection.transport.TCP/IP": "Mạng (TCP/IP)",
  "analyzer.connection.validation.invalid": "Kiểm tra giá trị này.",
  "analyzer.connection.validation.required": "Bắt buộc nhập trường này.",
  "analyzer.setup.close": "Đóng cài đặt máy",
  "analyzer.setup.connect.address.required": "Nhập địa chỉ máy",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge chưa xác nhận đúng cài đặt này.",
  "analyzer.activation.blocker.connection": "Cài đặt kết nối chưa đầy đủ hoặc không hợp lệ.",
  "analyzer.activation.blocker.dataFlow": "Luồng dữ liệu đã chọn không được loại máy này hỗ trợ.",
  "analyzer.activation.blocker.labUnit": "Gán ít nhất một nhóm xét nghiệm đang dùng.",
  "analyzer.activation.blocker.mappings": "Cần kiểm tra lại ánh xạ của máy.",
  "analyzer.activation.blocker.name": "Nhập tên máy.",
  "analyzer.activation.blocker.profile": "Bản loại máy đã chọn không có sẵn hoặc không còn khớp với máy này.",
  "analyzer.activation.blocker.retired": "This analyzer is retired. Restore it before activating it.",
  "analyzer.activation.blocker.recognition": "Cần kiểm tra lại nhận diện mẫu chứng.",
  "analyzer.activation.blocker.transport": "Phương thức kết nối đã chọn không được loại máy này hỗ trợ.",
  "analyzer.setup.connect.activation.active": "Máy đang hoạt động",
  "analyzer.setup.connect.activation.activating": "Đang kích hoạt máy",
  "analyzer.setup.connect.activation.blockerUnknown": "Cài đặt máy chưa sẵn sàng để kích hoạt.",
  "analyzer.setup.connect.activation.cancel": "Hủy",
  "analyzer.setup.connect.activation.error": "Không kiểm tra được độ sẵn sàng của máy.",
  "analyzer.setup.connect.activation.finish": "Hoàn tất và kích hoạt",
  "analyzer.setup.connect.activation.loading": "Đang kiểm tra độ sẵn sàng của máy",
  "analyzer.setup.connect.activation.readiness": "Độ sẵn sàng kích hoạt",
  "analyzer.setup.connect.activation.ready": "Máy đã sẵn sàng để kích hoạt",
  "analyzer.setup.connect.activation.saveChanges": "Lưu thay đổi",
  "analyzer.setup.connect.activation.saveLater": "Lưu và hoàn tất sau",
  "analyzer.setup.connect.activation.saving": "Đang lưu máy",
  "analyzer.setup.connect.activation.verifyMappings": "Kiểm tra ánh xạ",
  "analyzer.setup.connect.analyzerAddress": "Địa chỉ máy",
  "analyzer.setup.connect.check.analyzer.address.missing": "Chưa lưu địa chỉ máy nên chưa kiểm tra được máy. Kết quả từ máy gửi tới sẽ chứng minh kết nối hoạt động.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "Không phân giải được địa chỉ máy {host} nên chưa kiểm tra được máy. Kết quả từ máy gửi tới sẽ chứng minh kết nối hoạt động.",
  "analyzer.setup.connect.check.analyzer.reachable": "Bridge đã kết nối được tới máy tại {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "Bridge không kết nối được tới máy tại {host}. Các máy kết nối tới Bridge thường không thể được Bridge gọi ngược lại (do tường lửa, NAT hoặc máy chủ đặt ở ngoài). Kết quả từ máy gửi tới sẽ chứng minh kết nối hoạt động.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "Chế độ kết nối này không được Bridge hỗ trợ.",
  "analyzer.setup.connect.check.directory.configuration.missing": "Nhập thư mục tệp của máy trước khi kiểm tra.",
  "analyzer.setup.connect.check.directory.not.directory": "Đường dẫn đã cấu hình không phải là thư mục.",
  "analyzer.setup.connect.check.directory.not.found": "Không tìm thấy thư mục đã cấu hình.",
  "analyzer.setup.connect.check.directory.not.readable": "Bridge không đọc được thư mục đã cấu hình.",
  "analyzer.setup.connect.check.directory.path.invalid": "Đường dẫn thư mục đã cấu hình không hợp lệ.",
  "analyzer.setup.connect.check.directory.ready": "Thư mục đã sẵn sàng.",
  "analyzer.setup.connect.check.http.configuration.missing": "Nhập địa chỉ web của máy trước khi kiểm tra.",
  "analyzer.setup.connect.check.http.connection.error": "Bridge không kết nối được tới địa chỉ web của máy.",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "Máy này gửi thông điệp tới Bridge, nên kết nối này phải được kiểm chứng bằng việc gửi một kết quả.",
  "analyzer.setup.connect.check.http.interrupted": "Kiểm tra kết nối web bị gián đoạn.",
  "analyzer.setup.connect.check.http.ready": "Địa chỉ web của máy có thể truy cập được.",
  "analyzer.setup.connect.check.http.server.error": "Địa chỉ web của máy trả về lỗi máy chủ.",
  "analyzer.setup.connect.check.http.timeout": "Địa chỉ web của máy không phản hồi trước khi hết thời gian chờ.",
  "analyzer.setup.connect.check.http.url.invalid": "Địa chỉ web của máy không hợp lệ.",
  "analyzer.setup.connect.check.listener.configuration.missing": "Chưa cấu hình trình lắng nghe Bridge dùng chung. Nhờ quản trị viên Bridge kiểm tra cài đặt trình lắng nghe.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "Chưa cấu hình địa chỉ trình lắng nghe của Bridge.",
  "analyzer.setup.connect.check.listener.not.listening": "Trình lắng nghe của Bridge không nhận kết nối.",
  "analyzer.setup.connect.check.listener.port.in.use": "Cổng trình lắng nghe Bridge đã cấu hình đang được dùng.",
  "analyzer.setup.connect.check.listener.profile.unsupported": "Bản loại máy đã ghim không định nghĩa trình lắng nghe Bridge tương thích.",
  "analyzer.setup.connect.check.listener.ready": "Trình lắng nghe Bridge đã sẵn sàng.",
  "analyzer.setup.connect.check.listener.timeout": "Trình lắng nghe Bridge không phản hồi trước khi hết thời gian chờ.",
  "analyzer.setup.connect.check.remote.astm.ready": "Máy đã hoàn tất bắt tay ASTM.",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "Máy trả về phản hồi bắt tay ASTM không hợp lệ.",
  "analyzer.setup.connect.check.remote.configuration.missing": "Kiểm tra địa chỉ máy và cài đặt đích gửi đi. Có thể ghi đè cổng tùy chọn để thay mặc định của loại máy hoặc của Bridge.",
  "analyzer.setup.connect.check.remote.connection.error": "Bridge không kết nối được tới máy.",
  "analyzer.setup.connect.check.remote.hl7.ready": "Máy đã hoàn tất bắt tay HL7.",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "Máy trả về phản hồi bắt tay HL7 không hợp lệ.",
  "analyzer.setup.connect.check.remote.host.unknown": "Không phân giải được địa chỉ máy.",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "Giao thức máy này không hỗ trợ kiểm tra kết nối từ xa.",
  "analyzer.setup.connect.check.remote.refused": "Máy từ chối kết nối.",
  "analyzer.setup.connect.check.remote.timeout": "Máy không phản hồi trước khi hết thời gian chờ.",
  "analyzer.setup.connect.check.serial.configuration.missing": "Nhập thiết bị cổng nối tiếp của máy trước khi kiểm tra.",
  "analyzer.setup.connect.check.serial.not.found": "Không tìm thấy thiết bị cổng nối tiếp đã cấu hình.",
  "analyzer.setup.connect.check.serial.not.readable": "Bridge không đọc được thiết bị cổng nối tiếp đã cấu hình.",
  "analyzer.setup.connect.check.serial.path.invalid": "Đường dẫn thiết bị cổng nối tiếp đã cấu hình không hợp lệ.",
  "analyzer.setup.connect.check.serial.ready": "Thiết bị cổng nối tiếp của máy đã sẵn sàng.",
  "analyzer.setup.connect.checkKind.analyzer": "Máy (để tham khảo)",
  "analyzer.setup.connect.checkKind.directory": "Thư mục",
  "analyzer.setup.connect.checkKind.http_endpoint": "Địa chỉ web",
  "analyzer.setup.connect.checkKind.http_input": "Thông điệp đến từ máy",
  "analyzer.setup.connect.checkKind.listener": "Trình lắng nghe Bridge",
  "analyzer.setup.connect.checkKind.other": "Kiểm tra kết nối",
  "analyzer.setup.connect.checkKind.remote_protocol": "Giao thức máy",
  "analyzer.setup.connect.checkKind.serial_device": "Thiết bị cổng nối tiếp",
  "analyzer.setup.connect.checkStatus.failed": "Kiểm tra kết nối thất bại.",
  "analyzer.setup.connect.checkStatus.missing_configuration": "Cài đặt kết nối chưa đầy đủ.",
  "analyzer.setup.connect.checkStatus.passed": "Kiểm tra kết nối đạt.",
  "analyzer.setup.connect.checkStatus.skipped": "Không chạy được kiểm tra này.",
  "analyzer.setup.connect.checkStatus.timed_out": "Kiểm tra kết nối hết thời gian chờ.",
  "analyzer.setup.connect.configureEndpoint": "Cấu hình máy để dùng",
  "analyzer.setup.connect.dataFlow": "Luồng dữ liệu",
  "analyzer.setup.connect.dataFlow.resultsOnly": "Chỉ nhận kết quả",
  "analyzer.setup.connect.dataFlow.twoWay": "Hai chiều",
  "analyzer.setup.connect.destination": "Đích: {host}, cổng {port}",
  "analyzer.setup.connect.destinationRemediation": "Kiểm tra địa chỉ máy, cổng đích, dịch vụ đang lắng nghe và quyền truy cập mạng, rồi kiểm tra lại.",
  "analyzer.setup.connect.listenerPort": "Cổng trình lắng nghe Bridge: {port}",
  "analyzer.setup.connect.portSource": "Cổng lấy từ: {source}",
  "analyzer.setup.connect.portSource.override": "Ghi đè kết nối",
  "analyzer.setup.connect.portSource.profile": "Mặc định của loại máy",
  "analyzer.setup.connect.portSource.bridge": "Mặc định của Bridge",
  "analyzer.setup.connect.directory": "Thư mục tệp của máy",
  "analyzer.setup.connect.directory.required": "Nhập thư mục tệp của máy",
  "analyzer.setup.connect.error": "Không lưu hoặc kiểm tra được cài đặt kết nối.",
  "analyzer.setup.connect.evidence": "Bằng chứng kết nối",
  "analyzer.setup.connect.loadError": "Không tải được kết nối máy đã lưu.",
  "analyzer.setup.connect.loading": "Đang tải kết nối máy",
  "analyzer.setup.connect.outcome.failure": "Kết nối thất bại",
  "analyzer.setup.connect.outcome.missing_configuration": "Cài đặt kết nối chưa đầy đủ",
  "analyzer.setup.connect.outcome.success": "Kết nối sẵn sàng",
  "analyzer.setup.connect.outcome.timeout": "Kết nối hết thời gian chờ",
  "analyzer.setup.connect.port": "Cổng máy",
  "analyzer.setup.connect.port.invalid": "Nhập cổng từ 1 đến 65535",
  "analyzer.setup.connect.sourceAddress": "Địa chỉ nguồn của máy",
  "analyzer.setup.connect.test": "Kiểm tra kết nối",
  "analyzer.setup.connect.testing": "Đang kiểm tra kết nối",
  "analyzer.setup.connect.title": "Kết nối",
  "analyzer.setup.connect.useResultsOnly": "Dùng Chỉ nhận kết quả",
  "analyzer.setup.instrument.continue": "Tiếp tục tới Assay",
  "analyzer.setup.instrument.labUnits": "Nhóm xét nghiệm",
  "analyzer.setup.instrument.labUnits.placeholder": "Chọn nhóm xét nghiệm",
  "analyzer.setup.instrument.labUnits.required": "Chọn ít nhất một nhóm xét nghiệm",
  "analyzer.setup.instrument.name": "Tên máy",
  "analyzer.setup.instrument.name.required": "Nhập tên máy",
  "analyzer.setup.instrument.notListed": "Không thấy máy trong danh sách?",
  "analyzer.setup.instrument.saveError": "Không lưu được máy. Thử lại.",
  "analyzer.setup.instrument.saving": "Đang lưu máy",
  "analyzer.setup.instrument.summary": "Chi tiết máy đã lưu",
  "analyzer.setup.step.edit": "Sửa {step}",
  "analyzer.setup.instrument.type": "Loại máy",
  "analyzer.setup.instrument.type.helper": "Chọn đúng loại máy được liệt kê, kể cả khi máy chỉ gửi kết quả. Máy chỉ gửi kết quả hay cũng nhận chỉ định được cài sau, ở bước Kết nối.",
  "analyzer.setup.instrument.type.placeholder": "Tìm loại máy",
  "analyzer.setup.instrument.type.required": "Chọn loại máy",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · bản {revision}",
  "analyzer.setup.instrument.title": "Thiết bị",
  "analyzer.setup.steps": "Các bước cài đặt máy",
  "analyzer.setup.title": "Cài đặt máy mới",
  "analyzer.setup.title.named": "Cài đặt {name}",
  "analyzer.setup.verify.confirm": "Xác nhận các ánh xạ bên dưới để tiếp tục.",
  "analyzer.setup.verify.noAssays": "Chưa bật assay nào cho máy này. Bật các assay mà máy chạy trong mục Assay.",
  "analyzer.setup.verify.unresolved": "{count, plural, other {# bản ghi hoặc giá trị}} of the assays that are on still need mapping. Map them below, or turn the assay off in Assays if this instrument does not run it.",
  "analyzer.setup.verify.continue": "Tiếp tục tới Kết nối",
  "analyzer.setup.verify.selecting": "Đang áp dụng ánh xạ...",
  "analyzer.setup.verify.selectionError": "Không áp dụng được các ánh xạ đã duyệt. Tải lại bước Kiểm tra và thử lại.",
  "analyzer.setup.verify.loading": "Đang tải kiểm tra ánh xạ",
  "analyzer.setup.verify.summary": "Các ánh xạ đã duyệt cho cài đặt này",
  "analyzer.setup.verify.summary.stale": "Cần kiểm tra lại các ánh xạ",
  "analyzer.setup.verify.title": "Kiểm tra",
  "analyzer.navigation.analyzerTypes": "Loại máy xét nghiệm",
  "analyzer.navigation.analyzers": "Máy xét nghiệm",
  "analyzer.navigation.analyzersList": "Danh sách máy",
  "analyzer.navigation.fieldMappings": "Ánh xạ trường",
  "analyzer.navigation.qc": "Kiểm soát chất lượng",
  "analyzer.navigation.qcDashboard": "Bảng điều khiển QC",
  "analyzer.navigation.qcAlerts": "Cảnh báo & vi phạm QC",
  "analyzer.navigation.qcCorrectiveActions": "Hành động khắc phục",
  "analyzerType.action.deactivate": "Ngừng dùng",
  "analyzerType.action.editMappings": "Xem ánh xạ mặc định",
  "analyzerType.action.history": "Xem lịch sử",
  "analyzerType.action.reactivate": "Kích hoạt lại",
  "analyzerType.action.updateShared": "Cập nhật dùng chung",
  "analyzerType.adoption.adopted": "Đã áp dụng bản {revision}. Xác nhận ánh xạ bên dưới, rồi áp dụng để chuyển máy này.",
  "analyzerType.adoption.blocked.heldResults": "{code} vẫn còn kết quả bị giữ từ bản {revision}. Xử lý chúng trước khi áp dụng.",
  "analyzerType.adoption.blocked.inactiveTest": "Đang ánh xạ tới một xét nghiệm không còn hoạt động. Chọn xét nghiệm khác.",
  "analyzerType.adoption.blocked.reviewHeld": "Xem kết quả bị giữ",
  "analyzerType.adoption.bucket.blocked": "Bị chặn",
  "analyzerType.adoption.bucket.blocked.help": "Việc áp dụng chờ đến khi các mục này được xử lý.",
  "analyzerType.adoption.bucket.changed": "Đã đổi",
  "analyzerType.adoption.bucket.changed.help": "Bản mới đề xuất giá trị khác cho các mục này. Giữ lựa chọn hiện tại hoặc dùng mặc định mới.",
  "analyzerType.adoption.bucket.needs_mapping": "Cần ánh xạ",
  "analyzerType.adoption.bucket.needs_mapping.help": "Mới trong bản này, hoặc không còn được chuyển tiếp. Ánh xạ ngay hoặc để sau.",
  "analyzerType.adoption.bucket.retired": "Không còn gửi",
  "analyzerType.adoption.bucket.retired.help": "Bản {revision} không còn gửi các mục này nên ánh xạ của chúng sẽ bị bỏ.",
  "analyzerType.adoption.bucket.unchanged": "Không đổi",
  "analyzerType.adoption.bucket.unchanged.help": "Các mục này được giữ nguyên.",
  "analyzerType.adoption.changed.current": "Hiện tại: {name}",
  "analyzerType.adoption.changed.newDefault": "Mặc định mới: {name}",
  "analyzerType.adoption.error.save": "Không lưu được việc áp dụng",
  "analyzerType.adoption.keepCurrent": "Giữ hiện tại",
  "analyzerType.adoption.notice.subtitle": "Máy này vẫn nhận theo bản {from} cho đến khi bạn lưu, xác nhận và áp dụng.",
  "analyzerType.adoption.notice.title": "Đang áp dụng bản {revision}",
  "analyzerType.adoption.save": "Lưu thành bản {revision}",
  "analyzerType.adoption.title": "Áp dụng bản {revision} của {name}",
  "analyzerType.adoption.useNewDefault": "Dùng mặc định mới",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, other {Các máy dùng loại này}}",
  "analyzerType.affectedAnalyzers.adopt": "Áp dụng bản {revision}",
  "analyzerType.affectedAnalyzers.verify": "Kiểm tra ánh xạ đã lưu",
  "analyzerType.affectedAnalyzers.current": "Confirmed and current",
  "analyzerType.affectedAnalyzers.behind": "Behind",
  "analyzerType.actions.ariaLabel": "Thao tác cho {name}",
  "analyzerType.button.create": "Tạo hồ sơ",
  "analyzerType.button.cancel": "Hủy",
  "analyzerType.button.duplicate": "Nhân bản hồ sơ",
  "analyzerType.button.publish": "Xuất bản hồ sơ",
  "analyzerType.button.startUpdate": "Bắt đầu cập nhật",
  "analyzerType.column.actions": "Thao tác",
  "analyzerType.column.protocol": "Giao thức",
  "analyzerType.column.resultsMapped": "Kết quả đã ánh xạ",
  "analyzerType.column.status": "Trạng thái",
  "analyzerType.column.testsMapped": "Xét nghiệm đã ánh xạ",
  "analyzerType.column.type": "Loại máy",
  "analyzerType.column.usedBy": "Đang dùng bởi",
  "analyzerType.dataFlow.resultsOnly": "Chỉ nhận kết quả",
  "analyzerType.dataFlow.twoWay": "Hai chiều",
  "analyzerType.duplicate.lineage.subtitle": "Hồ sơ mới bắt đầu từ {name} bản {revision}. Các thay đổi sau này không làm đổi hồ sơ gốc hay các máy của nó.",
  "analyzerType.duplicate.lineage.title": "Hồ sơ mới giữ nguyên nguồn gốc",
  "analyzerType.draft.created.subtitle": "Bản nháp được lưu trong Analyzer Bridge. Phải hoàn tất và kiểm tra trước khi xuất bản để cài đặt máy.",
  "analyzerType.draft.created.title": "Đã tạo bản nháp hồ sơ",
  "analyzerType.draft.loading": "Đang tải bản nháp hồ sơ",
  "analyzerType.draft.publish.ready.subtitle": "{name} có định danh riêng do Bridge quản lý và giữ nguyên nguồn gốc.",
  "analyzerType.draft.publish.ready.title": "Sẵn sàng xuất bản",
  "analyzerType.draft.publish.review.subtitle": "Xem lại và lưu hành vi nhận diện mẫu chứng của {name} trước khi xuất bản.",
  "analyzerType.draft.publish.review.title": "Hoàn tất rà soát hồ sơ",
  "analyzerType.draft.update.loading": "Đang tải bản nháp cập nhật hồ sơ",
  "analyzerType.draft.update.subtitle": "Loại máy dùng chung không đổi cho đến khi bản nháp này được hoàn tất và xuất bản. Các máy hiện có vẫn ghim vào bản đang dùng.",
  "analyzerType.draft.update.title": "Đã tạo bản nháp cập nhật hồ sơ",
  "analyzerType.empty.subtitle": "Điều chỉnh tìm kiếm hoặc bộ lọc để xem loại máy khác.",
  "analyzerType.empty.title": "Không có loại máy nào khớp",
  "analyzerType.explainer.subtitle": "Các máy giống nhau có thể dùng chung một loại. Nhân bản loại khi một máy cần hành vi khác; ngừng dùng loại thay vì xóa lịch sử.",
  "analyzerType.explainer.title": "Cài đặt máy dùng lại được",
  "analyzerType.error.nameUnique": "Tên hồ sơ phải là duy nhất",
  "analyzerType.field.connectionTest": "Hỗ trợ kiểm tra kết nối",
  "analyzerType.field.dataFlow": "Luồng dữ liệu",
  "analyzerType.field.fileFormat": "Định dạng tệp",
  "analyzerType.field.filePattern": "Mẫu tên tệp",
  "analyzerType.field.manufacturer": "Hãng sản xuất",
  "analyzerType.field.model": "Model",
  "analyzerType.field.newProfileName": "Tên hồ sơ mới",
  "analyzerType.field.profileName": "Tên hồ sơ",
  "analyzerType.field.protocol": "Giao thức",
  "analyzerType.field.resultColumn": "Cột kết quả",
  "analyzerType.field.sampleColumn": "Cột mã mẫu",
  "analyzerType.field.sourceProfile.placeholder": "Chọn loại máy",
  "analyzerType.field.sourceProfile": "Loại máy nguồn",
  "analyzerType.field.testColumn": "Cột mã xét nghiệm",
  "analyzerType.filter.all": "Tất cả",
  "analyzerType.filter.mapping": "Trạng thái ánh xạ",
  "analyzerType.filter.protocol": "Giao thức",
  "analyzerType.filter.showDeactivated": "Hiện mục đã ngừng dùng",
  "analyzerType.filter.source": "Tạo bởi",
  "analyzerType.history.action.created": "Đã tạo",
  "analyzerType.history.action.deactivated": "Đã ngừng dùng",
  "analyzerType.history.action.duplicated": "Đã nhân bản",
  "analyzerType.history.action.reactivated": "Đã kích hoạt lại",
  "analyzerType.history.action.shipped": "Có sẵn trong gói",
  "analyzerType.history.action.updated": "Đã cập nhật",
  "analyzerType.history.actor": "Người thay đổi",
  "analyzerType.history.change": "Thay đổi",
  "analyzerType.history.loading": "Đang tải lịch sử hồ sơ",
  "analyzerType.history.revisionValue": "Bản {revision}",
  "analyzerType.history.revision": "Bản",
  "analyzerType.history.status": "Trạng thái",
  "analyzerType.history.time": "Thay đổi lúc",
  "analyzerType.lineage": "Bắt nguồn từ {profileId} bản {revision}",
  "analyzerType.loading": "Đang tải loại máy",
  "analyzerType.mapping.complete": "Đã ánh xạ đầy đủ",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.allDecided": "{decided} decided: {mapped} mapped, {excluded} excluded",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} đánh dấu Không nhận",
  "analyzerType.mapping.incomplete": "Cần ánh xạ",
  "analyzerType.mapping.notApplicable": "Không áp dụng",
  "analyzerType.mapping.notStarted": "Chưa ánh xạ",
  "analyzerType.mappingEditor.applyToAnalyzer": "Áp dụng ánh xạ và thử lại kết quả bị giữ",
  "analyzerType.mappingEditor.appliedToAnalyzer": "Đã áp dụng ánh xạ hiện tại cho máy này. Các kết quả bị giữ đủ điều kiện đã được thử lại.",
  "analyzerType.mappingEditor.error.applyToAnalyzer": "Không áp dụng được ánh xạ cho máy này.",
  "analyzerType.mappingEditor.alias": "Bí danh: {alias}",
  "analyzerType.mappingEditor.confirm": "Xác nhận ánh xạ và nhận diện mẫu chứng",
  "analyzerType.mappingEditor.confirmation.by": "Xác nhận bởi {actor} lúc {date}",
  "analyzerType.mappingEditor.confirmation.current": "Xác nhận hiện tại",
  "analyzerType.mappingEditor.confirmation.stale": "Xác nhận đã cũ",
  "analyzerType.mappingEditor.confirmation.summary.current": "Hiện tại",
  "analyzerType.mappingEditor.confirmation.summary.stale": "Cũ",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "Chưa xác nhận",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "Chưa xác nhận",
  "analyzerType.mappingEditor.confirmation": "Xác nhận",
  "analyzerType.mappingEditor.confirmed": "Đã xác nhận ánh xạ và nhận diện mẫu chứng",
  "analyzerType.mappingEditor.error.confirm": "Xác nhận thất bại",
  "analyzerType.mappingEditor.error.load": "Không tải được ánh xạ máy",
  "analyzerType.mappingEditor.error.route": "Cần một máy hoặc bản Loại máy hợp lệ",
  "analyzerType.mappingEditor.error.save": "Không lưu được ánh xạ",
  "analyzerType.mappingEditor.excludeResult.short": "Không nhận",
  "analyzerType.mappingEditor.excludeResult": "Không nhận {value}",
  "analyzerType.mappingEditor.callComponentPicker": "Kết quả gọi cho {code} đi tới",
  "analyzerType.mappingEditor.componentPicker": "Thành phần OpenELIS cho {code}",
  "analyzerType.mappingEditor.componentPicker.required": "Chọn thành phần mà bản ghi này rơi vào.",
  "analyzerType.mappingEditor.componentPicker.placeholder": "Chọn thành phần",
  "analyzerType.mappingEditor.excludeTest": "Không nhận {code}",
  "analyzerType.mappingEditor.partial": "{count} ánh xạ chưa xử lý. Bạn có thể xác nhận và kết nối; các kết quả bị ảnh hưởng sẽ được lưu để sửa trước khi dùng.",
  "analyzerType.mappingEditor.incomplete": "Sửa các lựa chọn xét nghiệm hoặc kết quả không khả dụng trước khi xác nhận.",
  "analyzerType.mappingEditor.loading": "Đang tải ánh xạ máy",
  "analyzerType.mappingEditor.observed": "Thấy trong kết quả bị giữ",
  "analyzerType.mappingEditor.recognition.heading": "Nhận diện kết quả mẫu chứng",
  "analyzerType.mappingEditor.recognition.none": "Loại máy này khai báo rõ rằng giao diện không truyền kết quả mẫu chứng nào.",
  "analyzerType.mappingEditor.resultPicker.placeholder": "Chọn một kết quả OpenELIS",
  "analyzerType.mappingEditor.resultPicker": "Kết quả OpenELIS cho {value}",
  "analyzerType.mappingEditor.tests.none": "Loại máy này không khai báo xét nghiệm nào nên không có gì để ánh xạ. Người tạo có thể thêm xét nghiệm vào bản mới của loại máy.",
  "analyzerType.mappingEditor.results.empty": "Xét nghiệm này không có tùy chọn kết quả đang dùng",
  "analyzerType.mappingEditor.results.heading": "Kết quả - {name}",
  "analyzerType.mappingEditor.results.loading": "Đang tải tùy chọn kết quả",
  "analyzerType.mappingEditor.results.openCatalog": "Thêm tùy chọn kết quả trong Danh mục xét nghiệm",
  "analyzerType.mappingEditor.results.testFirst": "Chọn một xét nghiệm OpenELIS trước khi ánh xạ kết quả của nó",
  "analyzerType.mappingEditor.reason.result.ambiguous": "Chưa ánh xạ: có nhiều đáp án của xét nghiệm này mang mã giá trị này. Chọn một.",
  "analyzerType.mappingEditor.reason.result.incompatible": "Chưa ánh xạ: không có đáp án nào của xét nghiệm này chứa được giá trị này.",
  "analyzerType.mappingEditor.reason.result.no_match": "Chưa ánh xạ: không có đáp án nào của xét nghiệm này mang mã giá trị này.",
  "analyzerType.mappingEditor.reason.test.ambiguous": "Chưa ánh xạ: có nhiều xét nghiệm trong danh mục của phòng mang mã này. Chọn một.",
  "analyzerType.mappingEditor.reason.test.incompatible": "Chưa ánh xạ: một xét nghiệm trong danh mục của phòng mang mã này nhưng không chứa được các kết quả này.",
  "analyzerType.mappingEditor.reason.test.no_match": "Chưa ánh xạ: không có xét nghiệm nào trong danh mục của phòng mang mã này.",
  "analyzerType.mappingEditor.results": "Kết quả đã ánh xạ",
  "analyzerType.mappingEditor.return": "Quay lại",
  "analyzerType.mappingEditor.save": "Lưu ánh xạ",
  "analyzerType.mappingEditor.saved": "Đã lưu ánh xạ",
  "analyzerType.mappingEditor.own.title": "Ánh xạ riêng của máy này",
  "analyzerType.mappingEditor.own.subtitle": "Thay đổi ở đây chỉ áp dụng cho máy này. Chúng có hiệu lực khi bạn xác nhận và áp dụng ánh xạ.",
  "analyzerType.mappingEditor.defaults.title": "Mặc định cho máy mới",
  "analyzerType.mappingEditor.defaults.subtitle": "Đây là những gì một máy mới thuộc loại này sẽ bắt đầu với, khớp theo mã chuẩn với danh mục hiện tại. Không có gì ở đây được lưu; mỗi máy giữ ánh xạ riêng.",
  "analyzerType.mappingEditor.origin.override": "Đã sửa",
  "analyzerType.mappingEditor.changes.heading": "Xem lại thay đổi trước khi lưu",
  "analyzerType.mappingEditor.changes.save": "Lưu thay đổi",
  "analyzerType.mappingEditor.changes.none": "Chưa có thay đổi nào kể từ lần lưu trước.",
  "analyzerType.mappingEditor.changes.row": "{from} thành {to}",
  "analyzerType.mappingEditor.sourceCode": "Mã máy",
  "analyzerType.mappingEditor.state.bound": "Đã ánh xạ",
  "analyzerType.mappingEditor.state.excluded": "Không nhận",
  "analyzerType.mappingEditor.state.unresolved": "Cần ánh xạ",
  "analyzerType.mappingEditor.subtitle": "{protocol} · bản {revision}",
  "analyzerType.mappingEditor.suggestion": "Gợi ý khớp: {name}",
  "analyzerType.mappingEditor.summary": "Tóm tắt ánh xạ",
  "analyzerType.mappingEditor.testPicker.placeholder": "Tìm theo tên, mã hoặc LOINC",
  "analyzerType.mappingEditor.testPicker": "Xét nghiệm OpenELIS cho {code}",
  "analyzerType.mappingEditor.tests.heading": "Ánh xạ xét nghiệm và kết quả",
  "analyzerType.mappingEditor.tests.help": "Xem từng mã máy riêng. Ánh xạ nó tới một xét nghiệm OpenELIS đang dùng hoặc đánh dấu rõ là không nhận.",
  "analyzerType.mappingEditor.tests": "Xét nghiệm đã ánh xạ",
  "analyzerType.mappingEditor.title": "Ánh xạ của {name}",
  "analyzerType.mappingEditor.unsaved": "Có thay đổi ánh xạ chưa lưu",
  "analyzerType.mappingEditor.useSuggestion": "Dùng xét nghiệm được gợi ý",
  "analyzerType.modal.deactivate.subtitle": "Các máy hiện có và lịch sử bản sửa đổi vẫn được liên kết. Hồ sơ này sẽ không còn sẵn để cài đặt máy mới.",
  "analyzerType.modal.deactivate.title": "Ngừng dùng {name}",
  "analyzerType.modal.history.title": "Lịch sử {name}",
  "analyzerType.modal.reactivate.subtitle": "Hồ sơ này sẽ sẵn sàng để cài đặt máy mới trở lại. Các máy hiện có vẫn ghim vào bản đã chọn.",
  "analyzerType.modal.reactivate.title": "Kích hoạt lại {name}",
  "analyzerType.modal.update.subtitle": "Thao tác này tạo một bản mới bất biến từ bản {revision}. {count, plural, one {# máy vẫn ghim vào bản hiện tại của nó.} other {# máy vẫn ghim vào bản hiện tại của chúng.}}",
  "analyzerType.modal.update.title": "Cập nhật {name}",
  "analyzerType.notification.action.error.subtitle": "Thử lại thao tác với hồ sơ.",
  "analyzerType.notification.action.error": "Thao tác hồ sơ thất bại",
  "analyzerType.notification.create.success": "Đã tạo hồ sơ",
  "analyzerType.notification.deactivate.success": "Đã ngừng dùng hồ sơ",
  "analyzerType.notification.duplicate.success": "Đã nhân bản hồ sơ",
  "analyzerType.notification.update.success": "Đã cập nhật hồ sơ",
  "analyzerType.notification.loadError.subtitle": "Kiểm tra kết nối Analyzer Bridge, rồi thử lại.",
  "analyzerType.notification.catalogIssues": "Một số hồ sơ máy không tải được",
  "analyzerType.notification.catalogIssues.subtitle": "Analyzer Bridge đã tách các tệp này sang một bên và vẫn phục vụ mọi hồ sơ khác. Sửa hoặc xóa từng tệp, rồi khởi động lại Bridge.",
  "analyzerType.notification.loadError": "Không tải được loại máy",
  "analyzerType.notification.reactivate.success": "Đã kích hoạt lại hồ sơ",
  "analyzerType.page.subtitle": "Các cài đặt dùng lại được đứng sau các máy của bạn.",
  "analyzerType.page.title": "Loại máy xét nghiệm",
  "analyzerType.protocol.file": "Tệp phẳng (flat file)",
  "analyzerType.recognition.none.affirmation": "Tôi xác nhận giao diện này không truyền kết quả mẫu chứng",
  "analyzerType.recognition.none.subtitle": "Chỉ xuất bản hồ sơ này khi giao diện máy không gửi kết quả mẫu chứng. Hồ sơ có truyền mẫu chứng cần quy tắc nhận diện rõ ràng.",
  "analyzerType.recognition.none.title": "Không tự động nhận diện kết quả mẫu chứng",
  "analyzerType.recognition.condition.add": "Thêm điều kiện",
  "analyzerType.recognition.condition.fieldValue": "Giá trị {source}",
  "analyzerType.recognition.condition.new": "Điều kiện nhận diện mới",
  "analyzerType.recognition.condition.prefixValue": "Tiền tố mã mẫu",
  "analyzerType.recognition.condition.remove": "Xóa điều kiện",
  "analyzerType.recognition.condition.select.placeholder": "Chọn điều kiện",
  "analyzerType.recognition.condition.select": "Điều kiện mới",
  "analyzerType.recognition.condition.sourceContains": "{source} chứa",
  "analyzerType.recognition.condition.sourceEquals": "{source} bằng",
  "analyzerType.recognition.condition.specimenPrefix": "Mã mẫu bắt đầu bằng",
  "analyzerType.recognition.condition.summary.configuredPattern": "Mã mẫu khớp một mẫu đã cấu hình",
  "analyzerType.recognition.condition.summary.contains": "{source} chứa {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} bằng {value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} bắt đầu bằng {value}",
  "analyzerType.recognition.condition.summary.unknown": "Nhận diện kết quả mẫu chứng",
  "analyzerType.recognition.error.load": "Không tải được nhận diện mẫu chứng.",
  "analyzerType.recognition.error.save": "Không lưu được nhận diện mẫu chứng.",
  "analyzerType.recognition.error.title": "Nhận diện mẫu chứng cần xem xét",
  "analyzerType.recognition.heading": "Nhận diện kết quả mẫu chứng",
  "analyzerType.recognition.loading": "Đang tải nhận diện mẫu chứng",
  "analyzerType.recognition.mode.none": "Giao diện này không truyền kết quả mẫu chứng",
  "analyzerType.recognition.mode.none.short": "Không nhận diện mẫu chứng",
  "analyzerType.recognition.mode.rules": "Nhận diện mẫu chứng theo các điều kiện sau",
  "analyzerType.recognition.mode.rules.short": "Nhận diện mẫu chứng theo quy tắc",
  "analyzerType.recognition.mode.unconfigured.short": "Chưa cấu hình nhận diện mẫu chứng",
  "analyzerType.recognition.mode.unconfigured": "Chưa cấu hình quy tắc nhận diện mẫu chứng nào. Kết quả mẫu chứng có thể không được nhận diện tự động.",
  "analyzerType.recognition.mode": "Giao diện này nhận diện kết quả mẫu chứng bằng cách nào?",
  "analyzerType.recognition.rules.help": "Một kết quả được coi là mẫu chứng khi bất kỳ điều kiện nào khớp.",
  "analyzerType.recognition.save": "Lưu nhận diện mẫu chứng",
  "analyzerType.recognition.saved": "Đã lưu nhận diện mẫu chứng",
  "analyzerType.recognition.source.specimenId": "Mã mẫu",
  "analyzerType.revision": "bản {revision}",
  "analyzerType.search.label": "Tìm loại máy",
  "analyzerType.search.placeholder": "Tìm theo tên, hãng hoặc model",
  "analyzerType.source.shipped": "Có sẵn",
  "analyzerType.source.site": "Tạo tại đơn vị",
  "analyzerType.status.active": "Đang dùng",
  "analyzerType.status.inactive": "Đã ngừng dùng",
  "analyzerType.summary.ariaLabel": "Tóm tắt loại máy",
  "analyzerType.summary.deactivated": "Đã ngừng dùng",
  "analyzerType.summary.inUse": "Đang dùng",
  "analyzerType.summary.needsAttention": "Cần xử lý",
  "analyzerType.summary.total": "Loại máy",
  "analyzerType.usedBy": "{count, plural, =0 {Chưa dùng} one {# máy} other {# máy}}",
  "analyzer.navigation.qcControlLots": "LOT mẫu chứng",
  "analyzer.navigation.qcRuleConfig": "Cấu hình quy tắc",
  "analyzer.page.addButton": "Thêm máy xét nghiệm",
  "analyzer.page.hierarchy.list": "Danh sách máy",
  "analyzer.page.hierarchy.mappings": "Ánh xạ trường",
  "analyzer.page.hierarchy.root": "Máy xét nghiệm",
  "analyzer.page.title": "Máy xét nghiệm",
  "analyzer.plugin.missing": "Thiếu plugin",
  "analyzer.qc.alerts.message": "Tính năng cảnh báo và vi phạm sẽ sớm ra mắt.",
  "analyzer.qc.alerts.title": "Cảnh báo & vi phạm QC",
  "analyzer.qc.corrective.message": "Tính năng hành động khắc phục sẽ sớm ra mắt.",
  "analyzer.qc.corrective.title": "Hành động khắc phục",
  "analyzer.qc.placeholder.message": "Tính năng kiểm soát chất lượng sẽ sớm ra mắt.",
  "analyzer.qc.placeholder.title": "Kiểm soát chất lượng",
  "analyzer.action.viewResults": "Xem kết quả",
  "analyzer.results.held.assayNotEnabled": "Assay này đang tắt trong cài đặt máy nên kết quả bị giữ. Bật nó ở bước Assay trong cài đặt nếu máy này chạy assay đó; kết quả sẽ được thử lại khi áp dụng ánh xạ.",
  "analyzer.results.held.code": "Mã máy: {code}",
  "analyzer.results.held.enableAssay": "Bật assay",
  "analyzer.results.held.instrumentNote": "Ghi chú của máy: {note}",
  "analyzer.results.instrumentReported": "Máy báo cáo",
  "analyzer.results.instrumentReported.assay": "Assay: {assay}",
  "analyzer.results.instrumentReported.assayVersion": "Assay: {assay}, phiên bản {version}",
  "analyzer.results.instrumentReported.flag": "Cờ: {flag}",
  "analyzer.results.instrumentReported.operator": "Người vận hành: {operator}",
  "analyzer.results.failedRun.dismiss": "Bỏ qua như lượt chạy lỗi",
  "analyzer.results.held.remove": "Remove from review",
  "analyzer.results.held.removed": "The held result is removed from review. The audit trail keeps it.",
  "analyzer.results.held.removeError": "The held result could not be removed",
  "analyzer.results.failedRun.dismissed": "Lượt chạy lỗi được ghi nhận trên chỉ định và xét nghiệm vẫn mở để chạy lại.",
  "analyzer.results.failedRun.error": "Không bỏ qua được lượt chạy lỗi",
  "analyzer.results.held.conflictingAnswerMapping": "The received spelling and its canonical answer have conflicting local mappings. Make their mapping decisions consistent, then retry this held result.",
  "analyzer.results.held.qcTargetMissing": "Mẫu chứng này có báo kết quả, nhưng xét nghiệm và mức mẫu chứng chưa có giá trị đích QC để đối chiếu. Đặt kết quả kỳ vọng, rồi áp dụng ánh xạ của máy để thử lại.",
  "analyzer.results.held.setQcTarget": "Đặt giá trị đích QC",
  "analyzer.results.held.reviewMapping": "Xem ánh xạ máy",
  "analyzer.results.sampleFlags": "Cờ của máy: {flags}",
  "analyzer.results.held.subtitle": "Kết quả bị giữ không thể chấp nhận. Mỗi kết quả cho biết cần làm gì: xem ánh xạ của máy này, hoặc bỏ qua một lượt chạy lỗi để xét nghiệm vẫn mở cho lần chạy lại.",
  "analyzer.results.held.tag": "Bị giữ",
  "analyzer.results.held.title": "{count, plural, other {# kết quả từ máy cần xử lý}}",
  "analyzer.qualitativeMapping.isDefault": "Mặc định",
  "analyzer.qualitativeMapping.mappings": "Ánh xạ giá trị",
  "analyzer.qualitativeMapping.noValues": "Không có giá trị máy nào để ánh xạ",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Chọn mã OpenELIS",
  "analyzer.qualitativeMapping.subtitle": "Ánh xạ giá trị định tính cho {fieldName}",
  "analyzer.qualitativeMapping.title": "Ánh xạ giá trị định tính",
  "analyzer.qualitativeMapping.validation.error": "Lỗi kiểm tra",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Vui lòng sửa các lỗi bên dưới",
  "analyzer.qualitativeMapping.validation.noDefault": "Chưa có giá trị mặc định",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "Cần ít nhất một ánh xạ được đánh dấu mặc định",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "Bắt buộc có mã OpenELIS",
  "analyzer.query.button": "Truy vấn máy",
  "analyzer.query.cancel": "Hủy",
  "analyzer.query.modal.logs": "Nhật ký kết nối",
  "analyzer.query.modal.noLogs": "Chưa có nhật ký.",
  "analyzer.query.modal.progress": "Tiến độ",
  "analyzer.query.modal.state": "Trạng thái",
  "analyzer.query.modal.subtitle": "Lấy các trường có sẵn từ máy",
  "analyzer.query.modal.title": "Truy vấn máy",
  "analyzer.query.progress": "Hoàn thành {percent}%",
  "analyzer.search.label": "Tìm kiếm",
  "analyzer.search.placeholder": "Tìm máy xét nghiệm...",
  "analyzer.attention.review": "Xem kết quả bị giữ",
  "analyzer.attention.subtitle": "Ánh xạ xét nghiệm hoặc giá trị kết quả chưa biết trước khi dùng các kết quả này cho lâm sàng.",
  "analyzer.attention.tag": "Cần xử lý",
  "analyzer.attention.title.many": "{count} máy có kết quả bị giữ",
  "analyzer.attention.title.one": "{name} có kết quả bị giữ",
  "analyzer.stat.active": "Đang dùng",
  "analyzer.stat.inactive": "Ngừng dùng",
  "analyzer.stat.needsAttention": "Cần xử lý",
  "analyzer.stat.setup": "Đang cài đặt",
  "analyzer.stat.total": "Tổng số máy",
  "analyzer.stats.active": "Máy đang dùng",
  "analyzer.stats.inactive": "Máy ngừng dùng",
  "analyzer.stats.total": "Tổng số máy",
  "analyzer.status.active": "Đang dùng",
  "analyzer.status.deleted": "Đã xóa",
  "analyzer.status.error_pending": "Lỗi đang chờ",
  "analyzer.status.inactive": "Ngừng dùng",
  "analyzer.status.offline": "Ngoại tuyến",
  "analyzer.status.retired": "Đã gỡ bỏ",
  "analyzer.status.setup": "Cài đặt",
  "analyzer.status.validation": "Kiểm tra",
  "analyzer.success.save": "Đã lưu máy xét nghiệm",
  "analyzer.table.actions": "Thao tác",
  "analyzer.table.connection": "Kết nối",
  "analyzer.table.header.connection": "Kết nối",
  "analyzer.table.header.lastModified": "Sửa lần cuối",
  "analyzer.table.header.name": "Tên",
  "analyzer.table.header.status": "Trạng thái",
  "analyzer.table.header.testUnits": "Nhóm xét nghiệm",
  "analyzer.table.header.type": "Loại máy",
  "analyzer.table.lastModified": "Sửa lần cuối",
  "analyzer.table.name": "Tên",
  "analyzer.table.status": "Trạng thái",
  "analyzer.table.testUnits": "Nhóm xét nghiệm",
  "analyzer.table.type": "Loại",
  "analyzer.table.type.loading": "Đang tải loại máy",
  "analyzer.table.type.unavailable": "Loại máy không khả dụng",
  "analyzer.testUnits.count": "{count, plural, other {# đơn vị}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "Không kết nối được endpoint kiểm tra tình trạng Bridge tại {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge trả về HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Chưa cấu hình Bridge",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge trả về phản hồi không đọc được",
  "analyzer.testConnection.bridge.unreachable": "Không kết nối được Bridge: {detail}",
  "analyzer.testConnection.close": "Đóng",
  "analyzer.testConnection.logs": "Nhật ký kết nối",
  "analyzer.testConnection.requestBuildFailed": "Không tạo được yêu cầu: {detail}",
  "analyzer.testConnection.success": "Kết nối thành công",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Chưa cấu hình Bridge nên không kiểm tra được khả năng kết nối tới máy",
  "analyzer.testConnection.testAgain": "Kiểm tra lại",
  "analyzer.testConnection.testing": "Đang kiểm tra kết nối...",
  "analyzer.testConnection.title": "Kiểm tra kết nối",
  "analyzer.testMapping.activeMappings": "{count} ánh xạ đang dùng",
  "analyzer.testMapping.analyzerInfo": "Thông tin máy",
  "analyzer.testMapping.analyzerName": "Tên máy",
  "analyzer.testMapping.analyzerType": "Loại máy",
  "analyzer.testMapping.appliedMappings": "Ánh xạ đã áp dụng",
  "analyzer.testMapping.entityPreview": "Xem trước đối tượng OpenELIS",
  "analyzer.testMapping.errors": "Lỗi",
  "analyzer.testMapping.loading": "Đang xử lý xem trước...",
  "analyzer.testMapping.messageInput": "Thông điệp ASTM mẫu",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} ký tự",
  "analyzer.testMapping.messageInput.helper": "Nhập một thông điệp ASTM mẫu để xem trước cách nó sẽ được diễn giải",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Thông điệp ASTM mẫu *",
  "analyzer.testMapping.noResults": "Chưa có kết quả xem trước. Nhập một thông điệp ASTM mẫu rồi bấm Xem trước ánh xạ.",
  "analyzer.testMapping.parsedFields": "Các trường đã phân tích",
  "analyzer.testMapping.parsedFields.astmRef": "Tham chiếu ASTM",
  "analyzer.testMapping.parsedFields.fieldName": "Tên trường",
  "analyzer.testMapping.parsedFields.interpretation": "Diễn giải",
  "analyzer.testMapping.parsedFields.mappedTo": "Ánh xạ tới",
  "analyzer.testMapping.parsedFields.rawValue": "Giá trị gốc",
  "analyzer.testMapping.pluginConfigSnapshot": "Ảnh chụp cấu hình plugin",
  "analyzer.testMapping.previewOptions": "Tùy chọn xem trước",
  "analyzer.testMapping.previewOptions.detailedParsing": "Hiện các bước phân tích chi tiết",
  "analyzer.testMapping.previewOptions.validateAll": "Kiểm tra tất cả ánh xạ",
  "analyzer.testMapping.results": "Kết quả xem trước",
  "analyzer.testMapping.saveTestCase": "Lưu thành ca kiểm thử",
  "analyzer.testMapping.submit": "Xem trước ánh xạ",
  "analyzer.testMapping.subtitle": "Xem trước cách các thông điệp ASTM mẫu sẽ được diễn giải",
  "analyzer.testMapping.testAnother": "Kiểm thử thông điệp khác",
  "analyzer.testMapping.title": "Kiểm thử ánh xạ trường",
  "analyzer.testMapping.validation.invalidFormat": "Định dạng thông điệp ASTM không hợp lệ",
  "analyzer.testMapping.validation.messageRequired": "Bắt buộc có thông điệp ASTM",
  "analyzer.testMapping.validation.messageTooLarge": "Thông điệp ASTM vượt kích thước tối đa 10KB",
  "analyzer.testMapping.warnings": "Cảnh báo",
  "analyzer.unitMapping.analyzerUnit": "Đơn vị nguồn (máy)",
  "analyzer.unitMapping.analyzerUnit.helper": "Đơn vị do máy báo cáo",
  "analyzer.unitMapping.conversionFactor": "Hệ số chuyển đổi",
  "analyzer.unitMapping.conversionFactor.helper": "Hệ số để chuyển từ {from} sang {to} (VD: 0.0555 cho mg/dL sang mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Đơn vị đích (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Đơn vị chuẩn dùng trong OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Chọn đơn vị đích",
  "analyzer.unitMapping.rejectIfMismatch": "Từ chối nếu đơn vị không khớp",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Từ chối thông điệp nếu đơn vị không khớp và không có hệ số chuyển đổi",
  "analyzer.unitMapping.subtitle": "Cấu hình ánh xạ đơn vị cho {fieldName}",
  "analyzer.unitMapping.title": "Ánh xạ đơn vị",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Bắt buộc có đơn vị nguồn",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Hệ số chuyển đổi phải là số dương",
  "analyzer.unitMapping.validation.conversionFactor.required": "Bắt buộc có hệ số chuyển đổi khi đơn vị khác nhau",
  "analyzer.unitMapping.validation.error": "Lỗi kiểm tra",
  "analyzer.unitMapping.validation.error.subtitle": "Vui lòng sửa các lỗi bên dưới",
  "analyzer.unitMapping.validation.openelisUnit.required": "Bắt buộc có đơn vị đích",
  "analyzerTestName.header.analyzerName": "Máy - Tên xét nghiệm của máy",
  "analyzerTestName.modal.add.heading": "Thêm tên xét nghiệm của máy",
  "analyzerTestName.modal.update.heading": "Cập nhật tên xét nghiệm của máy",
  "assigned.cytopathologist.label": "Bác sĩ tế bào học được phân công",
  "assigned.pathologist.label": "Bác sĩ giải phẫu bệnh được phân công",
  "assigned.technician.label": "Kỹ thuật viên được phân công",
  "audittrail.table.heading.action": "Thao tác",
  "audittrail.table.heading.identifier": "Định danh",
  "audittrail.table.heading.item": "Mục",
  "audittrail.table.heading.newvalue": "Giá trị mới",
  "audittrail.table.heading.oldvalue": "Giá trị cũ",
  "audittrail.table.heading.time": "Thời gian",
  "audittrail.table.heading.user": "Người dùng",
  "audittrail.table.title.patientResults": "Kết quả bệnh nhân",
  "availabletests.title": "Xét nghiệm có sẵn",
  "availabletests.none": "Every orderable test of the existing samples is already on this order.",
  "back.action.button": "Quay lại",
  "banner.menu.administration": "Quản trị",
  "banner.menu.alerts": "Cảnh báo",
  "banner.menu.alerts.tooltip": "Bảng cảnh báo và đảm bảo chất lượng",
  "banner.menu.aliquot": "Phần mẫu con",
  "banner.menu.aliquot.tooltip": "Chia phần mẫu con",
  "banner.menu.billing": "Thanh toán",
  "banner.menu.billing.tooltip": "Thanh toán",
  "banner.menu.createDouble": "Nhập kép",
  "banner.menu.createInitial": "Nhập ban đầu",
  "banner.menu.eorders": "Chỉ định đến",
  "banner.menu.eqa": "EQA",
  "banner.menu.eqa.distribution": "Đợt phân phối EQA",
  "banner.menu.eqa.distribution.tooltip": "Tạo và quản lý đợt phân phối EQA",
  "banner.menu.eqa.management": "Chương trình EQA",
  "banner.menu.eqa.management.tooltip": "Tạo và quản lý chương trình EQA",
  "banner.menu.eqa.mgmt": "Quản lý EQA",
  "banner.menu.eqa.mgmt.distributions": "Đợt phân phối",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Tạo và quản lý đợt phân phối EQA",
  "banner.menu.eqa.mgmt.participants": "Đơn vị tham gia",
  "banner.menu.eqa.mgmt.participants.tooltip": "Quản lý việc đăng ký của tổ chức vào chương trình EQA",
  "banner.menu.eqa.mgmt.programs": "Chương trình",
  "banner.menu.eqa.mgmt.programs.tooltip": "Tạo và quản lý chương trình EQA",
  "banner.menu.eqa.mgmt.results": "Kết quả & phân tích",
  "banner.menu.eqa.mgmt.results.tooltip": "Thu thập kết quả EQA và phân tích thống kê",
  "banner.menu.eqa.mgmt.tooltip": "Quản lý chương trình, đơn vị tham gia và đợt phân phối EQA",
  "banner.menu.eqa.tests": "Xét nghiệm EQA",
  "banner.menu.eqa.tests.myPrograms": "Chương trình EQA của tôi",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Quản lý tự đăng ký vào chương trình EQA bên ngoài",
  "banner.menu.eqa.tests.orders": "Chỉ định",
  "banner.menu.eqa.tests.orders.tooltip": "Xem và quản lý chỉ định xét nghiệm EQA",
  "banner.menu.eqa.tests.tooltip": "Chỉ định xét nghiệm EQA và đăng ký chương trình",
  "banner.menu.eqa.tooltip": "Đảm bảo chất lượng bên ngoài",
  "banner.menu.generic.sample": "Mẫu tổng quát",
  "banner.menu.generic.sample.edit": "Sửa chỉ định",
  "banner.menu.generic.sample.import": "Nhập mẫu",
  "banner.menu.generic.sample.order": "Tạo chỉ định",
  "banner.menu.generic.sample.results": "Nhập kết quả",
  "banner.menu.help": "Trợ giúp",
  "banner.menu.help.about": "Video hướng dẫn",
  "banner.menu.help.contact": "Ghi chú phát hành",
  "banner.menu.help.documents": "Tài liệu quy trình",
  "banner.menu.help.formDBS": "Biểu mẫu DBS",
  "banner.menu.help.formVL": "Biểu mẫu VL",
  "banner.menu.help.usermanual": "Hướng dẫn sử dụng",
  "banner.menu.home": "Bàn làm việc",
  "banner.menu.inventory": "Kho",
  "banner.menu.inventory.catalog": "Quản lý danh mục",
  "banner.menu.inventory.dashboard": "Bảng điều khiển",
  "banner.menu.inventory.list": "Vật tư trong kho",
  "banner.menu.inventory.reports": "Báo cáo",
  "banner.menu.nonconformity": "Không phù hợp",
  "banner.menu.nonconformity.correctiveActions": "Hành động khắc phục",
  "banner.menu.nonconformity.dashboard": "Tất cả sự kiện không phù hợp",
  "banner.menu.nonconformity.report": "Báo cáo sự kiện không phù hợp",
  "banner.menu.nonconformity.view": "Xem sự kiện không phù hợp mới",
  "banner.menu.patient": "Bệnh nhân",
  "banner.menu.patient.Create": "Nghiên cứu",
  "banner.menu.patient.addOrEdit": "Thêm/Sửa bệnh nhân",
  "banner.menu.patient.merge": "Gộp bệnh nhân",
  "banner.menu.patient.merge.tooltip": "Gộp các hồ sơ bệnh nhân trùng",
  "banner.menu.patientConsult": "Xem",
  "banner.menu.patientEdit": "Sửa",
  "banner.menu.patienthistory": "Lịch sử bệnh nhân",
  "banner.menu.printBarcode": "Mã vạch",
  "banner.menu.referredOut": "Đã gửi đi",
  "banner.menu.report.validation.backlog": "Duyệt bị trễ",
  "banner.menu.reports": "Báo cáo",
  "banner.menu.reports.routine": "Thường quy",
  "banner.menu.reports.study": "Nghiên cứu",
  "banner.menu.results": "Kết quả",
  "banner.menu.results.CobasIntegra400": "Sinh hóa: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Miễn dịch: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Miễn dịch: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Miễn dịch: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Sinh hóa: Bộ nhập Fully analyzer",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpert Analyzer",
  "banner.menu.results.GeneXpertanalyzer": "Bộ nhập GeneXpert",
  "banner.menu.results.PocH100iAnalyzer": "PocH100i Analyzer",
  "banner.menu.results.SysmeXT": "Huyết học: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "SysmexXNL Analyzer",
  "banner.menu.results.SysmexXNLanalyzer": "SysmexXNL Analyzer",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXP Analyzer",
  "banner.menu.results.SysmexXPanalyzer": "SysmexXP Analyzer",
  "banner.menu.results.accession": "Theo chỉ định",
  "banner.menu.results.analyzer": "Máy xét nghiệm",
  "banner.menu.results.cobasc111analyzer": "Sinh hóa: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "Theo nhóm",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Chương trình chỉ định",
  "banner.menu.results.patient": "Theo bệnh nhân",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "Theo xét nghiệm, ngày hoặc trạng thái",
  "banner.menu.results.sysmexanalyzer": "Huyết học: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Huyết học: Bộ nhập Sysmex XT",
  "banner.menu.results.taqman48dbsanalyzer": "Virus học: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "Theo ngày xét nghiệm",
  "banner.menu.results.unified": "Nhập kết quả",
  "banner.menu.results.unified.tooltip": "Danh sách công việc nhập kết quả thống nhất",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Duyệt",
  "banner.menu.resultvalidation.bacteria": "Vi khuẩn",
  "banner.menu.resultvalidation.bench": "Theo bàn làm việc",
  "banner.menu.resultvalidation.biochemistry": "Sinh hóa",
  "banner.menu.resultvalidation.cytobacteriology": "Tế bào - vi khuẩn học",
  "banner.menu.resultvalidation.dnapcr": "DNA PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Nội tiết",
  "banner.menu.resultvalidation.genotyping": "Giải trình tự gen (genotyping)",
  "banner.menu.resultvalidation.hemato-immunology": "Huyết học - Miễn dịch",
  "banner.menu.resultvalidation.hematology": "Huyết học",
  "banner.menu.resultvalidation.immunology": "Miễn dịch",
  "banner.menu.resultvalidation.immunology.Haiti": "Miễn dịch - Virus học",
  "banner.menu.resultvalidation.immunologyHematology": "Miễn dịch - Huyết học",
  "banner.menu.resultvalidation.liquidBio": "Sinh học dịch",
  "banner.menu.resultvalidation.malaria": "Sốt rét",
  "banner.menu.resultvalidation.molecularBio": "Sinh học phân tử",
  "banner.menu.resultvalidation.mycobacteriology": "Vi khuẩn lao",
  "banner.menu.resultvalidation.mycology": "Nấm học",
  "banner.menu.resultvalidation.parasitology": "Ký sinh trùng",
  "banner.menu.resultvalidation.serology": "Huyết thanh học",
  "banner.menu.resultvalidation.serology-immunology": "Huyết thanh - Miễn dịch",
  "banner.menu.resultvalidation.viralload": "Tải lượng virus",
  "banner.menu.resultvalidation.virology": "Virus học",
  "banner.menu.resultvalidation_routine": "Thường quy",
  "banner.menu.resultvalidation_study": "Nghiên cứu",
  "banner.menu.sample": "Chỉ định",
  "banner.menu.sample.shipment": "Vận chuyển mẫu",
  "banner.menu.sampleAdd": "Thêm chỉ định",
  "banner.menu.sampleBatchEntry": "Nhập chỉ định hàng loạt",
  "banner.menu.sampleConsult": "Xem",
  "banner.menu.sampleCreate": "Nghiên cứu",
  "banner.menu.sampleEdit": "Sửa chỉ định",
  "banner.menu.sampleManagement": "Quản lý mẫu",
  "banner.menu.sampleManagement.tooltip": "Menu quản lý mẫu",
  "banner.menu.storage": "Lưu trữ",
  "banner.menu.storage.tooltip": "Quản lý lưu trữ mẫu",
  "banner.menu.study.eorders": "Chỉ định điện tử",
  "banner.menu.workplan": "Phiếu công việc",
  "banner.menu.workplan.batch": "Phiếu công việc theo lô",
  "banner.menu.workplan.batch.tooltip": "Phiếu công việc theo lô",
  "banner.menu.workplan.bench": "Theo nhóm",
  "banner.menu.workplan.panel": "Theo bộ xét nghiệm",
  "banner.menu.workplan.priority": "Theo ưu tiên",
  "banner.menu.workplan.test": "Theo loại xét nghiệm",
  "banner.menu.workplan.unit": "Theo nhóm xét nghiệm",
  "barcode.additionalInvalidLevels.message": "Mã vạch chứa các cấp vượt quá phần hợp lệ. Chỉ các cấp hợp lệ được điền sẵn.",
  "barcode.additionalInvalidLevels.warning": "Phát hiện thêm cấp không hợp lệ",
  "barcode.autoOpenForm": "Đang mở biểu mẫu vị trí với phân cấp hợp lệ",
  "barcode.debounce.warning": "Vui lòng đợi trước khi quét mã vạch khác",
  "barcode.error": "Mã vạch không hợp lệ",
  "barcode.firstMissingLevel": "Cấp thiếu đầu tiên: {level}",
  "barcode.format": "Định dạng mã vạch",
  "barcode.header": "Mã vạch",
  "barcode.invalidFormat": "Định dạng mã vạch không hợp lệ. Mong đợi: ROOM-DEVICE hoặc ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "Nhãn block",
  "barcode.label.freezer": "Nhãn tủ lạnh sâu",
  "barcode.label.helper.text": "Nhập giá trị theo đơn vị: mm",
  "barcode.label.order": "Nhãn chỉ định",
  "barcode.label.slide": "Nhãn lam",
  "barcode.label.specimen": "Nhãn mẫu",
  "barcode.label.info.blockCaseNumber": "Số ca của block",
  "barcode.label.info.blockId": "Mã block",
  "barcode.label.info.blockNumber": "Số block",
  "barcode.label.info.boxid": "Mã hộp",
  "barcode.label.info.caseNumber": "Số ca",
  "barcode.label.info.collectedBy": "Người lấy mẫu",
  "barcode.label.info.collectionDate": "Ngày lấy mẫu",
  "barcode.label.info.collectionDateTime": "Ngày giờ lấy mẫu",
  "barcode.label.info.created": "Ngày tạo",
  "barcode.label.info.destination": "Nơi đến",
  "barcode.label.info.expiryDate": "Ngày hết hạn",
  "barcode.label.info.labNumber": "Số mã mẫu",
  "barcode.label.info.patientDobFull": "Ngày sinh bệnh nhân",
  "barcode.label.info.patientId": "Mã bệnh nhân",
  "barcode.label.info.patientName": "Tên bệnh nhân",
  "barcode.label.info.patientSexFull": "Phái bệnh nhân",
  "barcode.label.info.samplecount": "Số mẫu",
  "barcode.label.info.siteId": "Mã đơn vị gửi",
  "barcode.label.info.slideId": "Mã lam",
  "barcode.label.info.slideNumber": "Số lam",
  "barcode.label.info.specimenType": "Loại mẫu",
  "barcode.label.info.stainType": "Loại nhuộm",
  "barcode.label.info.storageLocation": "Vị trí lưu trữ",
  "barcode.label.info.temperature": "Nhiệt độ",
  "barcode.label.info.tests": "Xét nghiệm",
  "barcode.labels.order.row": "Nhãn chỉ định",
  "barcode.labels.running.total": "Tổng cộng dồn",
  "barcode.labels.sample.row": "Nhãn mẫu số {sampleNumber}",
  "barcode.labels.section.title": "Số lượng nhãn",
  "barcode.locationNotFound": "Không tìm thấy vị trí",
  "barcode.notification.save": "Đã lưu cấu hình mã vạch.",
  "barcode.partialMatch": "Khớp một phần - một số thành phần hợp lệ",
  "barcode.print.button": "In",
  "barcode.print.labels.title": "Nhãn của chỉ định này",
  "barcode.print.all.button": "In tất cả",
  "barcode.print.all.saved": "In mọi nhãn đã lưu với chỉ định này theo số lượng đã lưu.",
  "barcode.print.all.legacy": "In {orderCount, plural, one {# nhãn chỉ định} other {# nhãn chỉ định}} và {specimenCount, plural, one {# nhãn} other {# nhãn}} cho mỗi mẫu.",
  "barcode.print.col.label": "Nhãn",
  "barcode.print.col.accession": "Số mã mẫu",
  "barcode.print.col.info": "Thông tin thêm",
  "barcode.print.col.quantity": "Số lượng in",
  "barcode.print.quantity.for": "Số nhãn cần in cho {label}",
  "barcode.print.size": "{height} × {width} mm",
  "barcode.print.max.hint": "Tối đa {max}",
  "barcode.print.max.total": "Tối đa {max} tổng cộng, tính cả các lần in trước",
  "barcode.print.row.button": "In {label}",
  "error.labels.quantity.max": "Số lượng vượt mức tối đa của mẫu cần ghi đè nhãn.",
  "error.labels.quantity.min": "In ít nhất một nhãn.",
  "barcode.print.dialog.quantityFor": "Số lượng in cho {label}",
  "barcode.print.dialog.title": "In nhãn",
  "barcode.print.done": "Xong",
  "barcode.print.later": "Bỏ qua — In sau",
  "barcode.print.preprint": "In trước mã vạch",
  "barcode.print.preprint.button": "In trước nhãn",
  "barcode.print.preprint.note": "LƯU Ý: Nếu có thêm đơn vị và/hoặc mẫu và xét nghiệm, chúng sẽ được in trên MỌI nhãn",
  "barcode.print.skip": "Bỏ qua",
  "barcode.print.title": "In nhãn mã vạch",
  "barcode.ready": "Sẵn sàng quét",
  "barcode.scan": "Quét mã vạch",
  "barcode.scan.error": "Không tìm thấy chỉ định",
  "barcode.scan.placeholder": "Quét mã vạch hoặc nhập mã mẫu...",
  "barcode.scan.success": "Đã tải chỉ định",
  "barcode.scanning": "Đang quét...",
  "barcode.scanOrType": "Quét mã vạch hoặc nhập vị trí",
  "barcode.success": "Đã tìm thấy vị trí",
  "barcode.validHierarchyPrefilled": "Đã điền sẵn các cấp phân cấp hợp lệ",
  "barcode.validation.altPrefix": "Dữ liệu nhập phải là chữ và số, tối đa 4 ký tự.",
  "barcode.validationFailed": "Kiểm tra mã vạch thất bại",
  "barcodeconfiguration.browse.title": "Cấu hình mã vạch",
  "breadcrumb.home": "Bàn làm việc",
  "breadcrumb.caseView": "Xem hồ sơ ca",
  "breadcrums.admin.managment": "Quản lý quản trị",
  "calendar.management.title": "Quản lý lịch",
  "calendar.management.description": "Quản lý ngày lễ và cấu hình cuối tuần để tính TAT theo thời gian làm việc",
  "calendar.management.addHoliday": "Thêm ngày lễ",
  "calendar.management.editHoliday": "Sửa ngày lễ",
  "calendar.management.deleteConfirm": "Bạn có chắc muốn xóa ngày lễ này?",
  "calendar.management.holidayName": "Tên ngày lễ",
  "calendar.management.date": "Ngày",
  "calendar.management.recurring": "Lặp lại",
  "calendar.management.annual": "Hằng năm",
  "calendar.management.oneTime": "Một lần",
  "calendar.management.active": "Đang dùng",
  "calendar.management.inactive": "Ngừng dùng",
  "calendar.management.weekend": "Cuối tuần",
  "calendar.management.weekendDays": "Ngày cuối tuần (không tính vào thời gian làm việc)",
  "calendar.management.weekendSaved": "Đã lưu cấu hình cuối tuần",
  "calendar.management.importCsv": "Nhập CSV",
  "calendar.management.exportCsv": "Xuất CSV",
  "calendar.management.importPreview": "Xem trước nhập liệu",
  "calendar.management.year": "Năm",
  "calendar.management.noHolidays": "Chưa cấu hình ngày lễ cho {year}. Nhấn “Thêm ngày lễ” để bắt đầu.",
  "calendar.management.duplicateDate": "Đã có ngày lễ cho ngày này",
  "calendar.management.imported": "Đã nhập {count} ngày lễ",
  "calendar.management.skipped": "Đã bỏ qua {count} ngày lễ",
  "calendar.management.holidayCount": "Đã cấu hình {count} ngày lễ cho {year}",
  "calendar.management.saveError": "Lỗi khi lưu ngày lễ",
  "calendar.management.loadError": "Lỗi khi tải ngày lễ",
  "calendar.management.save": "Lưu",
  "calendar.management.cancel": "Hủy",
  "calendar.management.actions": "Thao tác",
  "calendar.management.status": "Trạng thái",
  "calendar.management.column.date": "Ngày",
  "calendar.management.column.holidayName": "Tên ngày lễ",
  "calendar.management.column.recurring": "Lặp lại",
  "calendar.management.column.status": "Trạng thái",
  "calendar.management.column.actions": "Thao tác",
  "calendar.management.day.sun": "CN",
  "calendar.management.day.mon": "T2",
  "calendar.management.day.tue": "T3",
  "calendar.management.day.wed": "T4",
  "calendar.management.day.thu": "T5",
  "calendar.management.day.fri": "T6",
  "calendar.management.day.sat": "T7",
  "calendar.management.chooseFile": "Chọn tệp CSV",
  "calendar.management.csvColumns": "Các cột: ngày, tên, lặp lại (true/false)",
  "calendar.management.rowsFound": "Tìm thấy {count} dòng",
  "calendar.management.column.csvDate": "Ngày",
  "calendar.management.column.csvName": "Tên",
  "calendar.management.column.csvRecurring": "Lặp lại",
  "calendar.management.importing": "Đang nhập...",
  "caseView.action.discard": "Hủy thay đổi",
  "caseView.action.saveDraft": "Lưu nháp",
  "caseView.action.showDeactivated": "Hiện mục đã ngừng dùng",
  "caseView.banner.unsavedChanges": "Hồ sơ ca này có thay đổi chưa lưu. Rời trang và mất các thay đổi này?",
  "caseView.badge.deactivated": "Đã ngừng dùng",
  "caseView.badge.notApplicable": "Không áp dụng",
  "caseView.badge.readOnly": "Chỉ đọc",
  "caseView.label.assignedStaff": "{role}: {name}",
  "caseView.label.caseProgress": "Tiến độ ca",
  "caseView.label.caseSummary": "Tóm tắt ca",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "— chưa ghi nhận",
  "caseView.label.unsavedChanges": "Thay đổi chưa lưu",
  "caseView.locked.awaitingStage": "Sẽ mở khi ca đến giai đoạn {stage}",
  "caseView.locked.prerequisite": "Sẽ mở khi các bước trước của ca này đã hoàn thành",
  "column.qc.accession": "Mẫu QC",
  "column.qc.detail": "Chi tiết",
  "column.qc.result": "Kết quả",
  "column.qc.test": "Xét nghiệm",
  "column.qc.type": "Loại",
  "compliance.dashboard.chart.comparison.title": "So sánh điểm lấy mẫu — Tỷ lệ tuân thủ kỳ hiện tại %",
  "compliance.dashboard.chart.drilldown.title": "Chi tiết theo điểm — Xu hướng từng thông số",
  "compliance.dashboard.chart.trend.title": "Xu hướng tỷ lệ tuân thủ — Tất cả điểm",
  "compliance.dashboard.descriptive.excluded": "Thông số mô tả không đưa vào biểu đồ xu hướng",
  "compliance.dashboard.drilldown.placeholder": "Chọn điểm…",
  "compliance.dashboard.empty": "Không có dữ liệu khớp bộ lọc đã chọn",
  "compliance.dashboard.export.pdf": "Xuất PDF",
  "compliance.dashboard.filter.allStandards": "Tất cả tiêu chuẩn",
  "compliance.dashboard.filter.dateRange": "Khoảng thời gian",
  "compliance.dashboard.filter.dateRangeEnd": "Đến ngày",
  "compliance.dashboard.filter.drilldownSite": "Xem chi tiết theo điểm",
  "compliance.dashboard.filter.sites": "Điểm lấy mẫu",
  "compliance.dashboard.filter.sites.placeholder": "Tất cả điểm",
  "compliance.dashboard.filter.standard": "Tiêu chuẩn tuân thủ",
  "compliance.dashboard.kpi.complianceRate": "Tỷ lệ tuân thủ",
  "compliance.dashboard.kpi.exceedances": "Tổng số vượt ngưỡng",
  "compliance.dashboard.kpi.sitesMonitored": "Số điểm giám sát",
  "compliance.dashboard.kpi.totalOrders": "Tổng số chỉ định",
  "compliance.dashboard.loading.comparison": "Đang tải so sánh…",
  "compliance.dashboard.loading.drilldown": "Đang tải chi tiết…",
  "compliance.dashboard.loading.exceedances": "Đang tải vượt ngưỡng…",
  "compliance.dashboard.loading.generating": "Đang tạo…",
  "compliance.dashboard.loading.trend": "Đang tải xu hướng…",
  "compliance.dashboard.lowData": "Dữ liệu ít (< 3 chỉ định)",
  "compliance.dashboard.status.fail": "KHÔNG ĐẠT",
  "compliance.dashboard.table.col.date": "Ngày",
  "compliance.dashboard.table.col.labNumber": "Mã mẫu",
  "compliance.dashboard.table.col.parameter": "Thông số",
  "compliance.dashboard.table.col.result": "Kết quả",
  "compliance.dashboard.table.col.site": "Điểm",
  "compliance.dashboard.table.col.status": "Trạng thái",
  "compliance.dashboard.table.col.threshold": "Ngưỡng",
  "compliance.dashboard.table.exceedances.title": "Tóm tắt vượt ngưỡng",
  "compliance.dashboard.title": "Bảng theo dõi tuân thủ môi trường",
  "error.referOut.emailFormat": "Nhập địa chỉ email hợp lệ (ví dụ lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Cần nhập Ngày/giờ bàn giao để gửi đi.",
  "error.referOut.maxLength": "Tối đa {max} ký tự.",
  "error.referOut.phoneFormat": "Nhập số điện thoại hợp lệ có mã quốc gia (ví dụ +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Chọn phòng xét nghiệm tham chiếu.",
  "error.validation.qc.ackFailed": "Không ghi nhận được xác nhận QC. Vui lòng thử lại.",
  "holding.time.exceeded.message": "Đã vượt thời gian lưu mẫu tối đa theo SOP cho: {tests}",
  "holding.time.exceeded.note": "CẢNH BÁO: Kết quả được nhập sau khi đã vượt thời gian lưu mẫu tối đa theo SOP.",
  "holding.time.exceeded.title": "Vượt thời gian lưu mẫu",
  "label.button.edit.details": "Sửa chi tiết",
  "label.expand.poolDetails": "Mở chi tiết mẫu gộp",
  "label.pool.collapse": "Ẩn từng mẫu riêng lẻ",
  "label.pool.expand": "Hiện từng mẫu riêng lẻ",
  "label.pool.expansion.next": "Sau",
  "label.pool.expansion.page": "Trang {page} / {total}",
  "label.pool.expansion.prev": "Trước",
  "label.pool.expansion.title": "Mẫu {animal} ({count})",
  "label.qc.fail": "Không đạt",
  "label.qc.pass": "Đạt",
  "label.referOut.action.dispatch": "Gửi đi",
  "label.referOut.action.edit": "Sửa",
  "label.referOut.action.referOut": "Gửi mẫu đi",
  "label.referOut.action.save": "Lưu phiếu gửi",
  "label.referOut.action.view": "Xem",
  "label.referOut.column.actions": "Thao tác",
  "label.referOut.column.referringLab": "Phòng XN tham chiếu",
  "label.referOut.column.sampleId": "Mã mẫu",
  "label.referOut.column.sampleType": "Loại mẫu",
  "label.referOut.column.status": "Trạng thái gia công ngoài",
  "label.referOut.column.tests": "Xét nghiệm",
  "label.referOut.dispatch.error": "Gửi đi thất bại.",
  "label.referOut.dispatch.notSaved": "Lưu phiếu gửi mẫu trước khi gửi đi.",
  "label.referOut.dispatch.success": "Đã gửi mẫu đi.",
  "label.referOut.empty.subtitle": "Mẫu sẽ hiện ở đây sau khi được lưu. Hãy lưu chỉ định trước khi gửi mẫu đi.",
  "label.referOut.empty.title": "Không có mẫu để gửi đi",
  "label.referOut.field.agreementReference": "Số hợp đồng/thỏa thuận",
  "label.referOut.field.cocContactEmail": "Email liên hệ chuỗi bảo quản (CoC)",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Tên liên hệ chuỗi bảo quản (CoC)",
  "label.referOut.field.cocContactPhone": "Điện thoại liên hệ chuỗi bảo quản (CoC)",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Ngày dự kiến trả kết quả",
  "label.referOut.field.handoffDate": "Ngày bàn giao",
  "label.referOut.field.handoffDatetime": "Ngày/giờ bàn giao",
  "label.referOut.field.handoffTime": "Giờ bàn giao",
  "label.referOut.field.handoffTime.placeholder": "HH:mm",
  "label.referOut.field.notes": "Ghi chú",
  "label.referOut.field.referringLab": "Phòng XN tham chiếu",
  "label.referOut.field.referringLab.placeholder": "Chọn phòng XN tham chiếu",
  "label.referOut.save.error": "Lưu phiếu gửi mẫu thất bại.",
  "label.referOut.save.success": "Đã lưu phiếu gửi mẫu.",
  "label.referOut.section.description": "Gửi mẫu đến phòng xét nghiệm bên ngoài. Mỗi mẫu đi kèm đầy đủ thông tin chuỗi bảo quản.",
  "label.referOut.section.title": "Gửi mẫu đi / Gia công ngoài",
  "label.referOut.status.cancelled": "Đã hủy",
  "label.referOut.status.closed": "Đã đóng",
  "label.referOut.status.completed": "Hoàn thành",
  "label.referOut.status.dispatched": "Đã gửi đi",
  "label.referOut.status.draft": "Nháp",
  "label.referOut.status.inProgress": "Đang xử lý",
  "label.referOut.status.notReferred": "Tại đơn vị",
  "label.referOut.status.received": "Đã nhận",
  "label.referOut.status.rejected": "Bị từ chối",
  "label.referOut.status.requested": "Đã yêu cầu",
  "label.referOut.status.resultsReturned": "Đã trả kết quả",
  "label.referOut.field.reason": "Lý do",
  "label.referOut.field.reason.placeholder": "Chọn lý do (không bắt buộc)",
  "label.referOut.action.referOutAll": "Gửi đi toàn bộ mẫu tại đơn vị",
  "label.referOut.status.pendingSave": "Chờ lưu",
  "label.referOut.staged.success": "Đã chuẩn bị cho {count} mẫu. Phiếu gửi sẽ được lưu cùng bước Lưu này.",
  "order.status.referredOut": "Đã gửi đi",
  "order.referral.partial": "{referred} / {total} xét nghiệm đã gửi đến {lab}",
  "order.referral.fully": "Tất cả {total} xét nghiệm đã gửi đến {lab}",
  "label.sampleKind.blank": "MẪU TRẮNG",
  "label.sampleKind.client": "Mẫu khách hàng",
  "label.sampleKind.control": "MẪU CHỨNG",
  "label.sampleKind.duplicate": "MẪU LẶP",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "Tôi đã xem các lỗi QC và đánh giá ảnh hưởng của chúng đến việc phát hành kết quả",
  "label.validation.qc.ack.heading": "Xác nhận bắt buộc",
  "label.validation.qc.banner.subtitle": "Xem và xác nhận bên dưới trước khi phát hành kết quả.",
  "label.validation.qc.banner.title": "Phát hiện lỗi QC — {count} mẫu QC không đạt tiêu chí chấp nhận",
  "label.validation.qc.failedSamples": "Mẫu QC không đạt",
  "label.validation.qc.justification": "Lý do biện giải",
  "label.validation.checkBeforeRelease": "Kiểm tra trước khi duyệt",
  "label.validation.triage.filterLabel": "Lọc theo tín hiệu",
  "label.validation.filter.all": "Tất cả",
  "label.validation.filter.needsReview": "Cần xem lại",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "QC không đạt",
  "label.validation.filter.modified": "Đã sửa",
  "label.validation.filter.ackPending": "Chờ xác nhận",
  "label.validation.search.box": "Mã mẫu",
  "label.validation.search.rangeHint": "Khoảng: A..B, hoặc A.. để từ A trở đi",
  "label.validation.search.fromDate": "Từ",
  "label.validation.search.toDate": "Đến",
  "label.validation.search.loadError": "Không tải được hàng đợi duyệt.",
  "label.validation.filter.critical": "Nguy kịch",
  "label.validation.filter.abnormal": "Bất thường",
  "label.validation.lane.clear": "Không vấn đề",
  "label.validation.lane.needsReview": "Cần xem lại",
  "label.validation.signal.nce": "NCE đang mở",
  "label.validation.signal.qcFail": "QC không đạt",
  "label.validation.signal.modified": "Đã sửa",
  "label.validation.signal.ackPending": "Chờ xác nhận",
  "label.validation.signal.nonconforming": "Không phù hợp",
  "label.validation.signal.critical": "Nguy kịch",
  "label.validation.review.result": "Kết quả",
  "label.validation.review.units": "Đơn vị",
  "label.validation.review.normalRange": "CSBT",
  "label.validation.review.criticalRange": "Khoảng nguy kịch",
  "label.validation.review.method": "Phương pháp",
  "label.validation.review.analyzer": "Máy xét nghiệm",
  "label.validation.review.performedAt": "Thực hiện lúc",
  "label.validation.review.enteredBy": "Nhập bởi",
  "label.validation.review.enteredDate": "Nhập ngày",
  "label.validation.review.collected": "Lấy mẫu",
  "label.validation.review.qc": "QC",
  "label.validation.review.qc.PASS": "QC đạt",
  "label.validation.review.qc.FAIL": "QC không đạt",
  "label.validation.review.notRecorded": "Chưa ghi nhận",
  "label.validation.review.beforeRelease": "Trước khi duyệt, kiểm tra:",
  "label.validation.review.components": "Thành phần",
  "label.validation.review.component": "Thành phần",
  "label.validation.review.flag": "Cờ",
  "label.validation.review.primary": "Chính",
  "label.validation.review.reference": "Tham chiếu",
  "label.validation.review.notes": "Ghi chú",
  "label.validation.review.notes.summary": "{count} ghi chú",
  "label.validation.review.notes.empty": "Chưa có ghi chú",
  "label.validation.review.notes.add": "Ghi chú duyệt",
  "label.validation.review.notes.placeholder": "Thêm ghi chú duyệt…",
  "label.validation.review.notes.visibility": "Hiển thị",
  "label.validation.review.notes.internal": "Nội bộ",
  "label.validation.review.notes.external": "Gửi kèm kết quả",
  "label.validation.review.notes.externalWarning": "Ghi chú này sẽ xuất hiện trên phiếu kết quả của bệnh nhân.",
  "label.validation.review.notes.contextHint": "Ngữ cảnh: Duyệt (ghi nhận tự động).",
  "label.validation.review.notes.context.result": "Ghi chú kết quả",
  "label.validation.review.modify.reason": "Lý do sửa đổi",
  "label.validation.review.modify.reasonRequired": "Cần nhập lý do để sửa kết quả.",
  "label.validation.review.modify.newValue": "Kết quả mới",
  "label.validation.review.modify.notEditable": "Loại kết quả này được sửa tại trang Nhập kết quả.",
  "label.validation.review.qcSection": "QC",
  "label.validation.review.reagents.followUp": "Lô thuốc thử và lô mẫu chứng của xét nghiệm này được xem tại trang Nhập kết quả.",
  "label.validation.review.action.release": "Duyệt & phát hành",
  "label.validation.review.action.modify": "Sửa kết quả",
  "label.validation.review.action.saveModification": "Lưu sửa đổi",
  "label.validation.review.action.cancel": "Hủy",
  "label.validation.review.action.refer": "Gửi xét nghiệm này đi",
  "label.validation.review.release.qcAckFirst": "Xác nhận các mẫu QC không đạt bên dưới trước khi phát hành.",
  "label.validation.review.error.notAwaitingValidation": "Kết quả này đã thay đổi từ khi trang được tải. Tải lại và xem lại.",
  "label.validation.review.error.qcAcknowledgmentRequired": "Các mẫu QC không đạt trong đợt này phải được xác nhận trước khi phát hành.",
  "label.validation.review.error.modificationReasonRequired": "Cần nhập lý do để sửa kết quả.",
  "label.validation.review.error.modifyRoleRequired": "Vai trò của bạn không được phép sửa kết quả.",
  "label.validation.review.error.resultRequired": "Nhập giá trị kết quả trước khi lưu.",
  "label.validation.review.error.invalidResult": "Kết quả chưa đầy đủ; kiểm tra giá trị có điều kiện.",
  "label.validation.review.error.generic": "Không thể hoàn thành thao tác.",
  "label.validation.review.success.released": "Đã duyệt và phát hành kết quả.",
  "label.validation.review.success.accepted": "Đã duyệt thành phần. Xét nghiệm sẽ được phát hành khi các thành phần còn lại được duyệt.",
  "label.validation.review.success.modified": "Đã sửa kết quả. Kết quả vẫn nằm trong hàng đợi duyệt.",
  "esig.context.validateSingle": "Duyệt và phát hành {test} cho mã mẫu {accession}",
  "label.validation.bulk.releaseAllClear": "Phát hành tất cả kết quả không vấn đề ({count})",
  "label.validation.bulk.heading": "Phát hành tất cả kết quả không vấn đề",
  "label.validation.bulk.bodyClear": "{count, plural, other {# kết quả này}} in the Clear lane: in range, no recorded QC failure, no non-conformity, not modified, not critical. A result that stops being clear before the release is skipped.",
  "label.validation.bulk.bodyEsig": "Phát hành sẽ tạo một chữ ký điện tử cho cả nhóm.",
  "label.validation.bulk.disabled": "Phát hành hàng loạt đã tắt cho phòng xét nghiệm này.",
  "label.validation.emptyState.signals": "{count} kết quả trong hàng đợi này cần kiểm tra trước khi phát hành.",
  "label.validation.emptyState.signalsDetail": "Phổ biến nhất: {signals}.",
  "label.validation.emptyState.noReference": "{count} kết quả thuộc xét nghiệm chưa có giá trị tham chiếu trong danh mục xét nghiệm, nên không thể đánh giá là bình thường.",
  "label.validation.emptyState.noReferenceHint": "Ghi giá trị bình thường mong đợi cho các xét nghiệm này trong Danh mục xét nghiệm để kết quả của chúng được duyệt.",
  "label.validation.emptyState.rangeNotApplied": "{count} kết quả chưa áp dụng CSBT vì chưa ghi nhận giới tính hoặc tuổi của bệnh nhân. Xem lại từng kết quả, hoặc bổ sung thông tin còn thiếu cho bệnh nhân.",
  "label.validation.emptyState.queueEmpty": "Không có kết quả nào đang chờ duyệt.",
  "label.validation.release.scope": "Kiểm tra không vấn đề gồm: khoảng tham chiếu, cờ kết quả, sự không phù hợp, chỉnh sửa sau khi lưu và xác nhận nguy kịch; đồng thời loại bỏ kết quả có lỗi QC đã ghi nhận. Bước này không xác nhận rằng QC đã được thực hiện.",
  "label.validation.bulk.none": "Không có kết quả không vấn đề để phát hành.",
  "label.validation.bulk.column.accession": "Mã mẫu",
  "label.validation.bulk.success": "Đã phát hành {count} kết quả không vấn đề.",
  "label.validation.bulk.partial": "Đã phát hành {released}; bỏ qua {skipped} vì không còn ở trạng thái không vấn đề.",
  "label.validation.bulk.error.bulkReleaseDisabled": "Phát hành hàng loạt đã tắt cho phòng xét nghiệm này.",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "Các mẫu QC không đạt trong đợt này phải được xác nhận trước khi phát hành.",
  "label.validation.bulk.error.nothingReleased": "Không còn kết quả nào trong số đã chọn ở trạng thái không vấn đề; không có kết quả nào được phát hành.",
  "label.validation.bulk.error.generic": "Không thể hoàn thành phát hành hàng loạt.",
  "label.validation.review.action.review": "Xem lại →",
  "esig.context.releaseAllClear": "Phát hành {count} kết quả không vấn đề cho {accession}",
  "instructions.validation.bulk.release": "Khi bật, trang Duyệt có nút “Phát hành tất cả không vấn đề”, chỉ phát hành các kết quả trong nhóm Không vấn đề (trong khoảng tham chiếu, không có lỗi QC đã ghi nhận, không có tín hiệu) dưới một chữ ký điện tử. Tắt để yêu cầu từng kết quả được phát hành riêng sau khi xem lại.",
  "instructions.validation.retest.note": "Khi bật, người duyệt trả kết quả để làm lại phải ghi chú cho người thực hiện.",
  "label.validation.review.action.retest": "Gửi làm lại",
  "label.validation.review.action.reject": "Từ chối (lập NCE)",
  "label.validation.review.retest.note": "Ghi chú cho người thực hiện",
  "label.validation.review.retest.noteRequired": "Cần ghi chú để gửi kết quả làm lại.",
  "label.validation.review.retest.hint": "Kết quả sẽ quay về Nhập kết quả và quy trình bắt đầu lại từ cấp 1.",
  "label.validation.review.reject.hint": "Từ chối sẽ lập một sự kiện không phù hợp; hoàn tất biểu mẫu để ghi nhận.",
  "label.validation.review.reject.disabled": "Tính năng từ chối kết quả đã tắt cho phòng xét nghiệm này.",
  "label.validation.review.error.stale": "Kết quả này đã được {who} thay đổi lúc {when}. Đang tải lại hàng đợi…",
  "label.validation.review.error.retestNoteRequired": "Cần ghi chú để gửi kết quả làm lại.",
  "label.validation.review.error.rejectionDisabled": "Tính năng từ chối kết quả đã tắt cho phòng xét nghiệm này.",
  "label.validation.review.success.retest": "Đã trả kết quả về để làm lại.",
  "label.validation.review.success.rejected": "Đã từ chối kết quả; sự kiện không phù hợp đã được ghi nhận.",
  "label.validation.bulk.error.stale": "Hàng đợi đã thay đổi khi bạn đang xem. Đang tải lại…",
  "label.validation.autoValidated.toggle": "Hiện kết quả tự động duyệt",
  "label.validation.autoValidated.heading": "Kết quả tự động duyệt ({count})",
  "label.validation.autoValidated.tag": "Tự động duyệt",
  "label.validation.autoValidated.empty": "Không có kết quả tự động duyệt cho mã mẫu này.",
  "label.validation.autoValidated.hint": "Đã phát hành khi nhập kết quả mà không qua người duyệt; chỉ hiển thị để xem lại.",
  "label.validation.autoValidated.releasedOn": "Phát hành ngày",
  "label.validation.signal.rangeNotApplied": "Chưa áp dụng CSBT",
  "result.rangeNotApplied.sexMissing": "Chưa áp dụng CSBT: chưa ghi nhận giới tính bệnh nhân",
  "result.rangeNotApplied.ageMissing": "Chưa áp dụng CSBT: chưa ghi nhận tuổi bệnh nhân",
  "result.rangeNotApplied.sexAndAgeMissing": "Chưa áp dụng CSBT: chưa ghi nhận giới tính và tuổi bệnh nhân",
  "laporanHasil.action.generatePdf": "Tạo PDF",
  "laporanHasil.action.regeneratePdf": "Tạo lại PDF",
  "laporanHasil.col.actions": "Thao tác",
  "laporanHasil.col.collectionDate": "Ngày lấy mẫu",
  "laporanHasil.col.compliance": "Tuân thủ",
  "laporanHasil.col.labNumber": "Mã mẫu",
  "laporanHasil.col.lastGenerated": "Lần tạo gần nhất",
  "laporanHasil.col.site": "Điểm",
  "laporanHasil.col.standard": "Tiêu chuẩn",
  "laporanHasil.col.tests": "Xét nghiệm",
  "laporanHasil.detail.ambientTemp": "Nhiệt độ môi trường",
  "laporanHasil.detail.collectionDateTime": "Ngày/giờ lấy mẫu",
  "laporanHasil.detail.collectionMethod": "Phương pháp lấy mẫu",
  "laporanHasil.detail.complianceSummary": "Tóm tắt tuân thủ",
  "laporanHasil.detail.conditions": "Điều kiện lấy mẫu",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Kỹ thuật viên phân tích",
  "laporanHasil.detail.labManager": "Trưởng phòng XN",
  "laporanHasil.detail.parameter": "Thông số",
  "laporanHasil.detail.ppNo": "Số PP",
  "laporanHasil.detail.preservation": "Bảo quản mẫu",
  "laporanHasil.detail.result": "Kết quả",
  "laporanHasil.detail.signatures": "Chữ ký",
  "laporanHasil.detail.site": "Điểm",
  "laporanHasil.detail.siteInfo": "Thông tin điểm lấy mẫu",
  "laporanHasil.detail.standard": "Tiêu chuẩn",
  "laporanHasil.detail.status": "Trạng thái",
  "laporanHasil.detail.threshold": "Ngưỡng",
  "laporanHasil.detail.waterTemp": "Nhiệt độ nước",
  "laporanHasil.detail.weather": "Thời tiết",
  "laporanHasil.empty": "Không tìm thấy chỉ định nào với bộ lọc đã chọn.",
  "laporanHasil.error": "Không tải được báo cáo. Vui lòng thử lại.",
  "laporanHasil.filter.all": "Tất cả",
  "laporanHasil.filter.allSites": "Tất cả điểm",
  "laporanHasil.filter.allStandards": "Tất cả tiêu chuẩn",
  "laporanHasil.filter.complianceStatus": "Trạng thái tuân thủ",
  "laporanHasil.filter.dateFrom": "Từ ngày",
  "laporanHasil.filter.dateTo": "Đến ngày",
  "laporanHasil.filter.generated": "Đã tạo",
  "laporanHasil.filter.generationStatus": "Trạng thái tạo",
  "laporanHasil.filter.notGenerated": "Chưa tạo",
  "laporanHasil.filter.samplingSite": "Điểm lấy mẫu",
  "laporanHasil.filter.standard": "Tiêu chuẩn tuân thủ",
  "laporanHasil.loading": "Đang tải báo cáo tuân thủ...",
  "laporanHasil.status.borderline": "Ngưỡng biên",
  "laporanHasil.status.compliant": "Đạt",
  "laporanHasil.status.ineligible": "Chưa gắn tiêu chuẩn",
  "laporanHasil.status.nonCompliant": "Không đạt",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Tạo chứng nhận tuân thủ cho các chỉ định môi trường đã duyệt",
  "laporanHasil.tile.generated": "Đã tạo",
  "laporanHasil.tile.ineligible": "Không đủ điều kiện",
  "laporanHasil.tile.ineligible.desc": "Chưa duyệt hoặc chưa gắn tiêu chuẩn",
  "laporanHasil.tile.notGenerated": "Chưa tạo",
  "laporanHasil.title": "Báo cáo tuân thủ",
  "lhu.amendment.error.generic": "Không phát hành lại được báo cáo. Vui lòng thử lại.",
  "lhu.amendment.modal.description": "Bạn đang phát hành lại LHU cho mã mẫu {labNumber}. Báo cáo phát hành lại sẽ được ghi nhận là bản điều chỉnh của chứng nhận đã phát hành trước đó.",
  "lhu.amendment.modal.heading": "Phát hành lại LHU kèm điều chỉnh",
  "lhu.amendment.modal.submit": "Phát hành lại & Tải PDF",
  "lhu.amendment.reason.helper": "Nêu lý do điều chỉnh báo cáo gốc (bắt buộc theo ISO 17025 §7.8.8).",
  "lhu.amendment.reason.label": "Lý do điều chỉnh",
  "lhu.amendment.reason.placeholder": "Ví dụ: Kết quả pH sai — máy chưa được hiệu chuẩn",
  "lhu.amendment.reason.required": "Cần nhập lý do điều chỉnh",
  "lhu.amendment.reissue": "Phát hành lại kèm điều chỉnh",
  "lhu.amendment.submitting": "Đang phát hành lại…",
  "nce.close.error": "Không đóng được NCE",
  "nce.close.success": "Đã đóng NCE",
  "nce.correctiveAction.error": "Không chuyển được trạng thái NCE",
  "nce.correctiveAction.success": "Đã chuyển NCE sang Hành động khắc phục",
  "notificationtrigger.activetriggers.heading": "Điều kiện thông báo đang bật",
  "notificationtrigger.activetriggers.subtitle": "Mỗi dòng điều khiển một loại sự kiện thông báo. Bật để kích hoạt. Kênh và người nhận chỉ có hiệu lực khi điều kiện được bật.",
  "notificationtrigger.channel.email": "Email",
  "notificationtrigger.channel.sms": "SMS",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.template.disallowed": "Loại tin này không được chứa {fields}. Dùng các trường ghép liệt kê bên dưới mẫu.",
  "notificationtrigger.column.channels": "Kênh",
  "notificationtrigger.column.enabled": "Bật",
  "notificationtrigger.column.eventcode": "Mã sự kiện",
  "notificationtrigger.column.override": "Ghi đè theo đơn vị",
  "notificationtrigger.column.recipients": "Người nhận",
  "notificationtrigger.column.trigger": "Điều kiện",
  "notificationtrigger.config.subtitle": "Bật hoặc tắt điều kiện thông báo, chọn kênh gửi và cấu hình loại người nhận cho từng sự kiện.",
  "notificationtrigger.config.title": "Cấu hình điều kiện thông báo",
  "notificationtrigger.disabled.hint": "Bật điều kiện này để cấu hình kênh và người nhận.",
  "notificationtrigger.override.comingsoon": "Chưa hỗ trợ ghi đè theo đơn vị.",
  "notificationtrigger.override.configure": "Cấu hình",
  "notificationtrigger.recipient.coccontact": "Liên hệ CoC",
  "notificationtrigger.recipient.orderingprovider": "Bác sĩ chỉ định",
  "notificationtrigger.recipient.submittinguser": "Người gửi chỉ định",
  "notificationtrigger.referralout.defaultoff": "Mặc định TẮT — phải bật thủ công.",
  "notificationtrigger.referralout.description": "Gửi khi một mẫu được gửi đến phòng xét nghiệm bên ngoài.",
  "notificationtrigger.referralout.firesoncenote": "Kích hoạt một lần cho mỗi phiếu gửi đã lưu. Nếu một chỉ định có phiếu gửi đến hai phòng khác nhau, sẽ gửi hai thông báo.",
  "notificationtrigger.referralout.name": "Gửi mẫu đi",
  "notificationtrigger.sentmessages.action.resend": "Gửi lại",
  "notificationtrigger.sentmessages.action.viewlog": "Xem nhật ký",
  "notificationtrigger.sentmessages.channel.failed": "lỗi",
  "notificationtrigger.sentmessages.channel.sent": "đã gửi",
  "notificationtrigger.sentmessages.column.actions": "Thao tác",
  "notificationtrigger.sentmessages.column.channels": "Kênh",
  "notificationtrigger.sentmessages.column.datetime": "Ngày / Giờ",
  "notificationtrigger.sentmessages.column.recipient": "Người nhận",
  "notificationtrigger.sentmessages.column.reference": "Tham chiếu",
  "notificationtrigger.sentmessages.column.status": "Trạng thái",
  "notificationtrigger.sentmessages.column.type": "Loại",
  "notificationtrigger.sentmessages.count": "{count} / {total} thông báo",
  "notificationtrigger.sentmessages.empty.heading": "Chưa có thông báo nào được gửi.",
  "notificationtrigger.sentmessages.filter.status.all": "Tất cả trạng thái",
  "notificationtrigger.sentmessages.filter.status.failed": "Lỗi",
  "notificationtrigger.sentmessages.filter.status.label": "Trạng thái",
  "notificationtrigger.sentmessages.filter.status.sent": "Đã gửi",
  "notificationtrigger.sentmessages.filter.type.all": "Tất cả loại",
  "notificationtrigger.sentmessages.filter.type.label": "Loại",
  "notificationtrigger.sentmessages.heading": "Thông báo đã gửi",
  "notificationtrigger.sentmessages.resend.disclaimer": "Gửi lại sẽ phát đúng nội dung và địa chỉ người nhận ban đầu. Để gửi đến địa chỉ khác, hãy sửa hồ sơ bệnh nhân và kích hoạt một sự kiện mới.",
  "notificationtrigger.sentmessages.resend.failure": "Gửi lại thất bại. Xem nhật ký máy chủ để biết chi tiết.",
  "notificationtrigger.sentmessages.resend.success": "Đã gửi lại thông báo.",
  "notificationtrigger.sentmessages.status.failed": "Lỗi",
  "notificationtrigger.sentmessages.status.sent": "Đã gửi",
  "notificationtrigger.sentmessages.subtitle": "Tất cả thông báo đi do OpenELIS gửi, theo mọi loại điều kiện và kênh.",
  "notificationtrigger.sentmessages.viewlog.channels": "Kết quả theo kênh",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Số lần thử",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Kênh",
  "notificationtrigger.sentmessages.viewlog.column.error": "Lỗi",
  "notificationtrigger.sentmessages.viewlog.column.status": "Trạng thái",
  "notificationtrigger.sentmessages.viewlog.heading": "Nhật ký thông báo",
  "notificationtrigger.sentmessages.viewlog.message": "Nội dung tin nhắn",
  "notificationtrigger.sentmessages.viewlog.subject": "Tiêu đề",
  "notificationtrigger.status.new": "MỚI",
  "notificationtrigger.subcontractdispatched.description": "Gửi khi mẫu đã được chuyển đi thực tế đến phòng xét nghiệm nhận.",
  "notificationtrigger.subcontractdispatched.name": "Đã gửi mẫu gia công ngoài",
  "notificationtrigger.tabs.sentmessages": "Thông báo đã gửi",
  "notificationtrigger.tabs.sentmessages.placeholder": "Thông báo đã gửi — sẽ có trong một mốc phát triển sau.",
  "notificationtrigger.tabs.templates": "Mẫu nội dung",
  "notificationtrigger.tabs.templates.placeholder": "Trình soạn mẫu — sẽ có trong một mốc phát triển sau.",
  "notificationtrigger.tabs.triggers": "Điều kiện",
  "notificationtrigger.templates.body.help": "Văn bản tự do với các trường ghép. Mẫu này không do i18n quản lý — hãy sửa trực tiếp.",
  "notificationtrigger.templates.body.label": "Nội dung tin nhắn",
  "notificationtrigger.templates.button.reset": "Khôi phục mặc định",
  "notificationtrigger.templates.button.save": "Lưu mẫu",
  "notificationtrigger.templates.channel.help": "Mỗi kênh có các trường mẫu riêng. Chuyển kênh để sửa riêng từng kênh.",
  "notificationtrigger.templates.channel.label": "Kênh",
  "notificationtrigger.templates.heading": "Cấu hình mẫu thông báo",
  "notificationtrigger.templates.mergefields.heading": "Trường ghép có sẵn",
  "notificationtrigger.templates.mergefields.help": "Các trường dưới đây dành riêng cho sự kiện {eventCode}. Nhấn vào một trường để chèn tại vị trí con trỏ.",
  "notificationtrigger.templates.mergefields.optionalnote": "Nếu [expectedReturn] không được đặt trên phiếu gửi, trường sẽ để trống — không báo lỗi.",
  "notificationtrigger.templates.preview.label": "Xem trước nội dung",
  "notificationtrigger.templates.referralout.description": "Gửi cho liên hệ khách hàng (Bác sĩ chỉ định) và/hoặc nhân viên nội bộ (Người gửi chỉ định) khi phiếu gửi được lưu.",
  "notificationtrigger.templates.subcontractdispatched.description": "Gửi cho liên hệ CoC của phòng xét nghiệm nhận và khách hàng khi mẫu được chuyển đi thực tế đến phòng xét nghiệm nhận.",
  "notificationtrigger.templates.subject.label": "Tiêu đề",
  "notificationtrigger.templates.subtitle": "Soạn mẫu tin nhắn cho từng loại sự kiện thông báo. Mẫu là văn bản tự do với các trường ghép.",
  "order.clinicalInfo.helper": "Thông tin bổ sung để hỗ trợ chọn xét nghiệm và báo cáo — không được ghi nhận như một chẩn đoán đã xác nhận.",
  "order.complete.processing.description": "{labNumber} hiện ở trạng thái {status} và sẽ xuất hiện trong danh sách công việc V-03 Định danh véc-tơ.",
  "order.complete.processing.description.plain": "{labNumber} hiện ở trạng thái Đang xử lý và sẽ xuất hiện trong danh sách công việc V-03 Định danh véc-tơ.",
  "order.complete.processing.title": "Hoàn tất chỉ định — Đang xử lý",
  "order.context.poolOf": "Mẫu gộp gồm {count} {animal}",
  "order.paymentStatus.helper": "Cách thanh toán cho chỉ định này.",
  "order.priority.helper": "ROUTINE: xử lý thường. STAT: xử lý ngay.",
  "order.referral.sampleType.ambiguous": "Chỉ định gửi đi này yêu cầu {items}, nhưng không xác định được loại mẫu tự động. Vui lòng chọn loại mẫu bên dưới và chọn (các) xét nghiệm được yêu cầu.",
  "order.requester.section.helper": "Chọn đơn vị đã chỉ định xét nghiệm và bác sĩ phụ trách.",
  "panel.domain.clinical": "Lâm sàng",
  "panel.domain.environmental": "Môi trường",
  "panel.domain.eqa": "EQA",
  "panel.domain.vector": "Véc-tơ",
  "panel.filter.domain": "Lĩnh vực",
  "panel.organism.flea": "Bọ chét",
  "panel.organism.fly": "Ruồi",
  "panel.organism.mosquito": "Muỗi",
  "panel.organism.rodent": "Gặm nhấm",
  "panel.organism.selectPlaceholder": "Chọn nhóm sinh vật",
  "panel.organism.tick": "Ve",
  "patient.search.section.helper": "Tìm theo bất kỳ tổ hợp trường nào. Tên khớp chính xác hoặc theo chữ cái đầu. 'Tìm bên ngoài' truy vấn Danh bạ khách hàng và cần ít nhất họ tên và ngày sinh.",
  "placeholder.validation.qc.justification": "Bắt buộc (tối đa 500 ký tự)",
  "provider.add.new": "+ Thêm bác sĩ mới “{name}”",
  "providerTitle.abbreviation": "Viết tắt",
  "providerTitle.add": "Thêm chức danh",
  "providerTitle.confirm.activate": "Kích hoạt “{title}”?",
  "providerTitle.confirm.activate.body": "Chức danh này sẽ được đưa lại vào danh sách khi chọn chức danh của bác sĩ.",
  "providerTitle.confirm.deactivate": "Ngừng dùng “{title}”?",
  "providerTitle.confirm.deactivate.body": "Chức danh này sẽ không còn được đề xuất khi chọn mới. {count} bác sĩ đang dùng chức danh này vẫn giữ nguyên.",
  "providerTitle.duplicate": "“{value}” đã có trong danh sách",
  "providerTitle.edit": "Sửa chức danh",
  "providerTitle.edit.warning": "Đổi chức danh sẽ đổi cách hiển thị trên mọi bác sĩ đang dùng chức danh này.",
  "providerTitle.empty": "Chưa cấu hình chức danh bác sĩ nào.",
  "providerTitle.filter.status": "Trạng thái",
  "providerTitle.filter.status.active": "Đang dùng",
  "providerTitle.filter.status.all": "Tất cả",
  "providerTitle.filter.status.inactive": "Ngừng dùng",
  "providerTitle.inUse": "Đang dùng",
  "providerTitle.search": "Tìm chức danh",
  "providerTitle.sortOrder": "Thứ tự sắp xếp",
  "providerTitle.summary": "{total} chức danh: {active} đang dùng, {inactive} ngừng dùng.",
  "providerTitle.title": "Chức danh",
  "providerTitle.titles": "Chức danh bác sĩ",
  "provider.email.field": "Email bác sĩ",
  "provider.fax.field": "Fax bác sĩ",
  "provider.title.field": "Chức danh",
  "provider.title.inName": "Trông giống một chức danh. Cân nhắc chuyển vào trường Chức danh để danh sách sắp xếp theo họ.",
  "provider.title.filter": "Lọc theo chức danh",
  "provider.title.filter.all": "Tất cả chức danh",
  "provider.title.placeholder": "Chọn chức danh...",
  "provider.firstName.field": "Tên",
  "provider.lastName.field": "Họ",
  "provider.new.helper": "Sẽ được tạo thành bác sĩ mới khi chỉ định này được lưu.",
  "provider.new.tag": "Mới",
  "provider.no.match": "Không tìm thấy bác sĩ phù hợp.",
  "provider.phone.field": "Điện thoại",
  "qc.add.blank": "+ QC mẫu trắng",
  "qc.add.control": "+ QC mẫu chứng",
  "qc.add.duplicate": "+ QC mẫu lặp",
  "qc.collect.inheritsFromParent": "Thông tin lấy mẫu được kế thừa từ mẫu gốc",
  "qc.expectedValue.placeholder": "Ví dụ: 50.0",
  "qc.samples.label": "Mẫu QC:",
  "qc.samples.numericOnly": "QC hiện chỉ hỗ trợ xét nghiệm có kết quả số. Các xét nghiệm đã chọn là kết quả mã hóa — hãy chọn một xét nghiệm số để gắn QC.",
  "qc.samples.thresholdsMissing": "Cấu hình ngưỡng QC cho {tests} trong Quản trị → Cấu hình xét nghiệm trước khi thêm mẫu QC.",
  "qc.status.current": "Trạng thái QC hiện tại",
  "qc.status.failed.warning.message": "Các lô không đạt QC sẽ bị loại khỏi xét nghiệm và khỏi tồn kho sẵn sàng sử dụng.",
  "qc.status.failed.warning.title": "Lô này sẽ không dùng được",
  "qc.status.new": "Trạng thái QC mới",
  "qc.status.notes": "Ghi chú QC",
  "qc.status.notes.placeholder": "Lý do kết quả QC, xét nghiệm đã thực hiện hoặc tài liệu tham chiếu",
  "qc.type.blank": "QC: Mẫu trắng",
  "qc.type.control": "QC: Mẫu chứng",
  "qc.type.duplicate": "QC: Mẫu lặp",
  "referral.accept.error": "Không thể chấp nhận kết quả. Vui lòng thử lại.",
  "referral.action.accept": "Chấp nhận",
  "referral.action.acceptToAnalysis": "Chấp nhận để phân tích",
  "referral.action.clearFilters": "Xóa bộ lọc",
  "referral.action.enterResult": "Nhập kết quả",
  "referral.action.markLost": "Đánh dấu thất lạc",
  "referral.action.notifyReferenceLab": "Thông báo phòng XN tham chiếu",
  "referral.action.openResultEntry": "Mở tại Nhập kết quả",
  "referral.action.reject": "Từ chối",
  "referral.banner.filterToStuck": "Chỉ lọc các phiếu bị kẹt",
  "referral.banner.stuckReferralsSubtitle": "{count} phiếu gửi đã nằm tại phòng XN tham chiếu quá {threshold} ngày.",
  "referral.banner.stuckReferralsTitle": "Phát hiện phiếu gửi bị kẹt",
  "referral.box.cannotReconcileMessage": "Không thể đối chiếu hộp — {count} mẫu vẫn chờ đối chiếu kết quả. Xem Kết quả phòng XN tham chiếu.",
  "referral.box.viewBlockedReferrals": "Xem tại Kết quả phòng XN tham chiếu",
  "referral.breadcrumb.referenceLabResults": "Kết quả phòng XN tham chiếu",
  "referral.chip.ariaLabel": "Màn hình kết quả phòng XN tham chiếu",
  "referral.chip.history": "Lịch sử",
  "referral.chip.outstanding": "Đang chờ",
  "referral.chip.returned": "Đã trả về — cần xử lý",
  "referral.column.actions": "Thao tác",
  "referral.column.boxId": "Mã hộp",
  "referral.column.closedDate": "Ngày đóng",
  "referral.column.daysOutstanding": "Số ngày chờ",
  "referral.column.daysTotal": "Tổng số ngày",
  "referral.column.labNumber": "Mã mẫu",
  "referral.column.outcome": "Kết cục",
  "referral.column.patient": "Bệnh nhân",
  "referral.column.priority": "Ưu tiên",
  "referral.column.referenceLab": "Phòng XN tham chiếu",
  "referral.column.requestor": "Người chỉ định gốc",
  "referral.column.resultSummary": "Tóm tắt kết quả",
  "referral.column.returnedDate": "Ngày trả về",
  "referral.column.sentDate": "Ngày gửi",
  "referral.column.status": "Trạng thái",
  "referral.column.tests": "Xét nghiệm",
  "referral.expand.criticalBadge": "NGUY KỊCH",
  "referral.expand.detail.ageYears": "{years, plural, other {# tuổi}}",
  "referral.expand.detail.boxId": "Mã hộp",
  "referral.expand.detail.boxReceivedDate": "Đã nhận tại phòng XN tham chiếu",
  "referral.expand.detail.collected": "Lấy mẫu",
  "referral.expand.detail.currentStatus": "Trạng thái hiện tại",
  "referral.expand.detail.daysOutstanding": "Số ngày chờ",
  "referral.expand.detail.dispatched": "Đã gửi đi",
  "referral.expand.detail.fhirTask": "FHIR Task",
  "referral.expand.detail.labNumber": "Mã mẫu",
  "referral.expand.detail.patient": "Bệnh nhân",
  "referral.expand.detail.priority": "Ưu tiên",
  "referral.expand.detail.referenceLab": "Phòng XN tham chiếu",
  "referral.expand.detail.requestor": "Người chỉ định gốc",
  "referral.expand.detail.sampleType": "Loại mẫu",
  "referral.expand.detail.tests": "Xét nghiệm",
  "referral.expand.noResultPayload": "Phòng XN tham chiếu không trả về kết quả có cấu trúc.",
  "referral.expand.originalOrderContext": "Bối cảnh chỉ định gốc",
  "referral.expand.outcomeDetail": "Chi tiết kết cục",
  "referral.expand.receptionAction": "Thao tác tiếp nhận",
  "referral.expand.receptionHint": "Xem kết quả trả về bên dưới, rồi Chấp nhận để ghi vào hồ sơ bệnh nhân, hoặc Từ chối nếu kết quả không dùng được.",
  "referral.expand.referenceLabTransit": "Quá trình vận chuyển tới phòng XN tham chiếu",
  "referral.expand.result": "Kết quả",
  "referral.expand.statusDetail": "Chi tiết trạng thái",
  "referral.filter.allPriorities": "Tất cả mức ưu tiên",
  "referral.filter.allRefLabs": "Tất cả phòng XN tham chiếu",
  "referral.filter.dateRange": "Khoảng thời gian",
  "referral.filter.daysOutstandingBucket": "Số ngày chờ",
  "referral.filter.daysOutstandingBucket.stuck": "Bị kẹt (> {threshold} ngày)",
  "referral.filter.priority": "Ưu tiên",
  "referral.filter.referenceLab": "Phòng XN tham chiếu",
  "referral.markLost.cancelButton": "Hủy",
  "referral.markLost.confirmButton": "Đánh dấu thất lạc",
  "referral.markLost.description": "Thao tác này đánh dấu phiếu gửi là thất lạc trên đường vận chuyển và đưa khỏi danh sách Đang chờ. Đội lâm sàng sẽ cần lấy lại và gửi lại mẫu.",
  "referral.markLost.modalTitle": "Đánh dấu phiếu gửi là thất lạc",
  "referral.markLost.reasonLabel": "Lý do",
  "referral.markLost.reasonPlaceholder": "Ví dụ: Đơn vị vận chuyển xác nhận thất lạc. Hộp không bao giờ tới phòng XN tham chiếu.",
  "referral.markLost.reasonRequired": "Cần nhập lý do.",
  "referral.metric.outstanding": "Đang chờ",
  "referral.metric.reconciledToday": "Đã đối chiếu hôm nay",
  "referral.metric.rejectedThisWeek": "Bị từ chối tuần này",
  "referral.metric.returned": "Đã trả về — cần xử lý",
  "referral.notification.accepted": "Đã chấp nhận kết quả vào hồ sơ bệnh nhân.",
  "referral.notification.rejected": "Đã từ chối kết quả. Bác sĩ đã được thông báo để lấy mẫu lại.",
  "referral.notify.errorRetry": "Không thông báo được cho phòng XN tham chiếu. Thử lại.",
  "referral.notify.toast": "Đã thông báo cho phòng XN tham chiếu.",
  "referral.page.title": "Kết quả phòng XN tham chiếu",
  "referral.reject.cancelButton": "Hủy",
  "referral.reject.confirmButton": "Từ chối và thông báo bác sĩ",
  "referral.reject.description": "Từ chối sẽ đóng hẳn xét nghiệm gốc và thông báo bác sĩ lấy mẫu lại và gửi lại.",
  "referral.reject.error": "Không thể từ chối kết quả. Vui lòng thử lại.",
  "referral.reject.modalTitle": "Từ chối kết quả đã trả về",
  "referral.reject.reason.clotted": "Mẫu bị đông",
  "referral.reject.reason.damagedContainer": "Hộp đựng bị hỏng",
  "referral.reject.reason.hemolyzed": "Mẫu bị vỡ hồng cầu",
  "referral.reject.reason.insufficientVolume": "Không đủ thể tích",
  "referral.reject.reason.mislabeled": "Ghi nhãn sai",
  "referral.reject.reason.other": "Khác",
  "referral.reject.reason.temperatureDeviation": "Sai lệch nhiệt độ",
  "referral.reject.reason.wrongSampleType": "Sai loại mẫu",
  "referral.reject.reasonLabel": "Lý do",
  "referral.reject.reasonTextLabel": "Chi tiết",
  "referral.reject.reasonTextPlaceholder": "Mô tả lý do kết quả trả về này không dùng được.",
  "referral.reject.reasonTextRequired": "Cần nhập chi tiết.",
  "referral.reject.warningTitle": "Thao tác này không thể hoàn tác",
  "referral.result.interp.Abnormal": "Bất thường",
  "referral.result.interp.Critical": "Nguy kịch",
  "referral.result.interp.Normal": "Bình thường",
  "referral.status.cancelled": "Đã hủy",
  "referral.status.completed": "Đã trả kết quả",
  "referral.status.draft": "Nháp",
  "referral.status.inProgress": "Đang xử lý tại phòng XN tham chiếu",
  "referral.status.received": "Tại phòng XN tham chiếu",
  "referral.status.reconciled": "Đã đối chiếu",
  "referral.status.rejected": "Bị phòng XN tham chiếu từ chối",
  "referral.status.requested": "Đã gửi — chờ tiếp nhận",
  "referral.table.count": "{count, plural, =0 {Không có phiếu gửi} one {# phiếu gửi} other {# phiếu gửi}}",
  "referral.table.history.title": "Lịch sử",
  "referral.table.outstanding.title": "Phiếu gửi đang chờ",
  "referral.table.returned.title": "Đã trả về — cần xử lý",
  "referral.tag.manuallyEntered": "Nhập thủ công",
  "reports.tat.title": "Báo cáo thời gian trả kết quả (TAT)",
  "reports.tat.description": "Phân tích thời gian trả kết quả của phòng xét nghiệm theo các mốc quy trình",
  "reports.tat.generateReport": "Tạo báo cáo",
  "reports.tat.clearFilters": "Xóa bộ lọc",
  "reports.tat.segment.orderToCollection": "Từ chỉ định đến lấy mẫu",
  "reports.tat.segment.collectionToReceipt": "Từ lấy mẫu đến nhận mẫu",
  "reports.tat.segment.receiptToTesting": "Từ nhận mẫu đến bắt đầu xét nghiệm",
  "reports.tat.segment.receiptToResult": "Từ nhận mẫu đến nhập kết quả",
  "reports.tat.segment.receiptToValidation": "Từ nhận mẫu đến duyệt",
  "reports.tat.segment.resultToValidation": "Từ nhập kết quả đến duyệt",
  "reports.tat.segment.overall": "TAT tổng",
  "reports.tat.calendarTime": "Thời gian lịch",
  "reports.tat.workingTime": "Thời gian làm việc",
  "reports.tat.workingTimeInfo": "Chế độ thời gian làm việc: Loại trừ {weekendDays} và {holidayCount} ngày lễ trong khoảng ngày đã chọn",
  "reports.tat.configuredWeekends": "ngày cuối tuần đã cấu hình",
  "reports.tat.noHolidaysWarning": "Chưa cấu hình ngày lễ. Hãy cấu hình tại Quản trị > Quản lý lịch.",
  "reports.tat.manageCalendar": "Quản lý lịch",
  "reports.tat.totalResults": "Tổng số kết quả",
  "reports.tat.meanTat": "TAT trung bình",
  "reports.tat.medianTat": "TAT trung vị",
  "reports.tat.percentile90": "Phân vị 90",
  "reports.tat.minTat": "TAT nhỏ nhất",
  "reports.tat.maxTat": "TAT lớn nhất",
  "reports.tat.stdDeviation": "Độ lệch chuẩn",
  "reports.tat.distribution": "Phân bố TAT",
  "reports.tat.breakdownBy": "Phân tách theo",
  "reports.tat.clickRowHint": "Nhấn vào một dòng để xem từng kết quả",
  "reports.tat.summary": "Tóm tắt",
  "reports.tat.detailList": "Danh sách chi tiết",
  "reports.tat.trends": "Xu hướng",
  "reports.tat.noResults": "Không tìm thấy kết quả nào với bộ lọc đã chọn. Thử điều chỉnh khoảng ngày hoặc tiêu chí lọc.",
  "reports.tat.insufficientData": "Dữ liệu chưa đủ",
  "reports.tat.loadError": "Lỗi khi tải dữ liệu báo cáo",
  "reports.tat.dateRange": "Khoảng thời gian",
  "reports.tat.labUnit": "Nhóm xét nghiệm",
  "reports.tat.testPanel": "Xét nghiệm / Bộ xét nghiệm",
  "reports.tat.priority.all": "Tất cả",
  "reports.tat.priority.routine": "Thường quy",
  "reports.tat.priority.stat": "CẤP CỨU",
  "reports.tat.priority.asap": "Càng sớm càng tốt",
  "reports.tat.sampleType": "Loại mẫu",
  "reports.tat.orderingSite": "Điểm chỉ định",
  "reports.tat.priority": "Ưu tiên",
  "reports.tat.includeCancelled": "Bao gồm phiếu đã hủy/từ chối",
  "reports.tat.export": "Xuất",
  "reports.tat.exportCsv": "Xuất CSV",
  "reports.tat.exportPdf": "Xuất PDF",
  "reports.tat.labNumber": "Mã mẫu",
  "reports.tat.patient": "Bệnh nhân",
  "reports.tat.test": "Xét nghiệm",
  "reports.tat.orderCreated": "Tạo chỉ định",
  "reports.tat.collected": "Lấy mẫu",
  "reports.tat.received": "Nhận mẫu",
  "reports.tat.testingStarted": "Bắt đầu xét nghiệm",
  "reports.tat.resultEntered": "Nhập kết quả",
  "reports.tat.validated": "Duyệt",
  "reports.tat.selectedTat": "TAT đã chọn",
  "reports.tat.overallTat": "TAT tổng",
  "reports.tat.columns": "Cột",
  "reports.tat.rowsPerPage": "Số dòng mỗi trang",
  "reports.tat.showing": "Hiển thị {from}-{to} trên tổng {total} kết quả",
  "reports.tat.trend": "Xu hướng",
  "reports.tat.aggregation": "Gom nhóm",
  "reports.tat.daily": "Theo ngày",
  "reports.tat.weekly": "Theo tuần",
  "reports.tat.monthly": "Theo tháng",
  "reports.tat.compareBy": "So sánh theo",
  "reports.tat.showVolume": "Hiện số lượng chỉ định",
  "reports.tat.mean": "Trung bình",
  "reports.tat.median": "Trung vị",
  "reports.tat.notApplicable": "Không áp dụng",
  "reports.tat.dateRangeFrom": "Khoảng thời gian (Từ)",
  "reports.tat.dateRangeTo": "Khoảng thời gian (Đến)",
  "reports.tat.tatSegment": "Đoạn TAT",
  "reports.tat.metrics": "Chỉ số",
  "reports.tat.compareNone": "Không",
  "reports.tat.comparePriority": "Ưu tiên",
  "reports.tat.column.labNumber": "Mã mẫu",
  "reports.tat.column.test": "Xét nghiệm",
  "reports.tat.column.labUnit": "Nhóm xét nghiệm",
  "reports.tat.column.priority": "Ưu tiên",
  "reports.tat.column.ordered": "Chỉ định",
  "reports.tat.column.collected": "Lấy mẫu",
  "reports.tat.column.received": "Nhận mẫu",
  "reports.tat.column.started": "Bắt đầu",
  "reports.tat.column.resulted": "Có kết quả",
  "reports.tat.column.validated": "Duyệt",
  "reports.tat.column.selectedTat": "TAT đã chọn",
  "reports.tat.column.overallTat": "TAT tổng",
  "reports.tat.column.name": "Tên",
  "reports.tat.column.count": "Số lượng",
  "reports.tat.column.mean": "Trung bình",
  "reports.tat.column.median": "Trung vị",
  "reports.tat.column.p90": "Phân vị 90",
  "reports.tat.column.max": "Lớn nhất",
  "reports.tat.home": "Bàn làm việc",
  "reports.tat.all": "Tất cả",
  "reports.tat.preset.today": "Hôm nay",
  "reports.tat.preset.7days": "7 ngày gần nhất",
  "reports.tat.preset.30days": "30 ngày gần nhất",
  "reports.tat.preset.90days": "90 ngày gần nhất",
  "reports.tat.preset.thisMonth": "Tháng này",
  "reports.tat.preset.lastMonth": "Tháng trước",
  "reports.tat.preset.thisQuarter": "Quý này",
  "button.cancel": "Hủy",
  "button.activate": "Kích hoạt",
  "button.adjust": "Điều chỉnh",
  "button.deactivate": "Ngừng dùng",
  "button.dispose": "Tiêu hủy",
  "button.edit": "Sửa",
  "button.generate": "Tạo",
  "button.label.genarateReport": "Tạo báo cáo",
  "button.label.loadnext": "Tải gói kế tiếp",
  "button.label.loadprevious": "Tải gói trước",
  "button.label.showHidePram": "Hiện/Ẩn tham số báo cáo",
  "button.record": "Ghi nhận",
  "button.save": "Lưu",
  "button.save.draft": "Lưu nháp",
  "button.save.next": "Lưu & Tiếp",
  "button.save.stay": "Lưu",
  "button.send": "Gửi",
  "button.update": "Cập nhật",
  "calculatedTests": "Xét nghiệm tính toán",
  "catalog.item.activate.success": "Đã kích hoạt mục danh mục",
  "catalog.item.category": "Nhóm",
  "catalog.item.code": "Mã",
  "catalog.item.code.hint": "Mã định danh ổn định dùng cho tích hợp. Để trống, hệ thống sẽ tạo từ tên, ví dụ PAR-500MG-001.",
  "catalog.item.code.locked": "Mã sẽ bị khóa sau khi lưu để các tích hợp và tham chiếu hiện có tiếp tục hoạt động.",
  "catalog.item.code.placeholder": "Để trống để tự tạo từ tên",
  "catalog.item.code.preview": "Sẽ được lưu là {code}",
  "catalog.item.compatibleAnalyzers": "Máy xét nghiệm tương thích",
  "catalog.item.deactivate.confirm.button": "Ngừng dùng",
  "catalog.item.deactivate.confirm.message": "Bạn có chắc muốn ngừng dùng {itemName}?",
  "catalog.item.deactivate.confirm.title": "Xác nhận ngừng dùng",
  "catalog.item.deactivate.implications.1": "Mục này sẽ không còn xuất hiện trong danh sách mục đang dùng",
  "catalog.item.deactivate.implications.2": "Các lô hiện có của mục này vẫn truy cập được",
  "catalog.item.deactivate.implications.3": "Có thể kích hoạt lại mục này sau nếu cần",
  "catalog.item.deactivate.implications.title": "Hệ quả:",
  "catalog.item.deactivate.label": "Ngừng dùng mục",
  "catalog.item.deactivate.success": "Đã ngừng dùng mục",
  "catalog.item.error.saveGeneric": "Lỗi khi lưu mục danh mục",
  "catalog.item.error.stabilityRequired": "Cần nhập thời hạn ổn định sau khi mở đối với thuốc thử",
  "catalog.item.form.title.add": "Thêm mục danh mục mới",
  "catalog.item.form.title.edit": "Sửa mục danh mục",
  "catalog.item.lowStockThreshold": "Ngưỡng tồn kho thấp",
  "catalog.item.manufacturer": "Nhà sản xuất",
  "catalog.item.minimumStock": "Mức tồn kho tối thiểu",
  "catalog.item.name": "Tên mục",
  "catalog.item.reorderLevel": "Mức đặt hàng lại",
  "catalog.item.reorderQuantity": "Số lượng đặt hàng lại",
  "catalog.item.save.error": "Lỗi khi lưu mục danh mục",
  "catalog.item.save.success": "Đã lưu mục danh mục",
  "catalog.item.stabilityAfterOpening": "Thời hạn ổn định sau khi mở (ngày)",
  "catalog.item.status": "Trạng thái",
  "catalog.item.storageRequirements": "Yêu cầu bảo quản",
  "catalog.item.testTypes": "Loại xét nghiệm",
  "catalog.item.testsPerCartridge": "Số xét nghiệm mỗi cartridge",
  "catalog.item.testsPerKit": "Số xét nghiệm mỗi bộ kit",
  "catalog.item.units": "Đơn vị",
  "catalog.search.placeholder": "Tìm theo tên hoặc mã mục",
  "choose.availablepanel": "Chọn bộ xét nghiệm có sẵn",
  "coldStorage.action.createSuccess": "Đã tạo hành động khắc phục",
  "coldStorage.action.retractSuccess": "Đã thu hồi hành động khắc phục",
  "coldStorage.action.updateSuccess": "Đã cập nhật hành động khắc phục",
  "coldStorage.actions": "Thao tác",
  "coldStorage.activated": "đã kích hoạt",
  "coldStorage.addDevicesMessage": "Vui lòng thêm thiết bị trong Quản lý thiết bị để cấu hình ngưỡng nhiệt độ.",
  "coldStorage.addNewDevice": "Thêm thiết bị mới",
  "coldStorage.alert.acknowledged": "Đã xác nhận cảnh báo",
  "coldStorage.alert.actionFailed": "Không thể {action} cảnh báo {alertId}",
  "coldStorage.alert.equipment": "Lỗi thiết bị",
  "coldStorage.alert.equipment.description": "Cảnh báo khi thiết bị trục trặc hoặc mất kết nối",
  "coldStorage.alert.inventory": "Cảnh báo tồn kho",
  "coldStorage.alert.inventory.description": "Cảnh báo khi tồn kho thấp hoặc cần quản lý kho",
  "coldStorage.alert.resolved": "Đã xử lý xong cảnh báo",
  "coldStorage.alert.saveFailed": "Không lưu được tùy chọn thông báo: ",
  "coldStorage.alert.saveSuccess": "Đã lưu tùy chọn thông báo. Mỗi loại cảnh báo sẽ dùng các phương thức thông báo đã cấu hình.",
  "coldStorage.alert.temperature": "Cảnh báo nhiệt độ & độ ẩm",
  "coldStorage.alert.temperature.description": "Cảnh báo khi nhiệt độ hoặc độ ẩm tương đối của một tủ ra khỏi khoảng đã cấu hình",
  "coldStorage.alert.type": "Loại cảnh báo",
  "coldStorage.alertConfiguration": "Cấu hình cảnh báo",
  "coldStorage.autoEscalate": "Tự động chuyển cấp cảnh báo chưa xử lý",
  "coldStorage.button.delete": "Xóa",
  "coldStorage.configuredDevices": "Thiết bị đã cấu hình",
  "coldStorage.correctiveAction.column.actionId": "Mã hành động",
  "coldStorage.correctiveAction.column.created": "Ngày tạo",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "Cập nhật lần cuối bởi",
  "coldStorage.correctiveAction.column.performedBy": "Thực hiện bởi",
  "coldStorage.correctiveAction.edited": "Đã sửa",
  "coldStorage.correctiveAction.status.cancelled": "Đã hủy",
  "coldStorage.correctiveAction.status.completed": "Hoàn thành",
  "coldStorage.correctiveAction.status.inProgress": "Đang thực hiện",
  "coldStorage.correctiveAction.status.pending": "Chờ xử lý",
  "coldStorage.correctiveAction.status.retracted": "Đã thu hồi",
  "coldStorage.correctiveAction.type.calibration": "Hiệu chuẩn",
  "coldStorage.correctiveAction.type.calibration.description": "Hiệu chuẩn thiết bị hoặc cảm biến",
  "coldStorage.correctiveAction.type.equipmentRepair": "Sửa chữa thiết bị",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "Sửa chữa hoặc thay thế thiết bị",
  "coldStorage.correctiveAction.type.itemReorder": "Đặt hàng lại",
  "coldStorage.correctiveAction.type.itemReorder.description": "Đặt hàng lại vật tư tồn kho",
  "coldStorage.correctiveAction.type.maintenance": "Bảo trì",
  "coldStorage.correctiveAction.type.maintenance.description": "Thực hiện công việc bảo trì",
  "coldStorage.correctiveAction.type.other": "Khác",
  "coldStorage.correctiveAction.type.other.description": "Hành động khắc phục khác hoặc tùy chỉnh",
  "coldStorage.correctiveAction.type.sampleRelocation": "Chuyển vị trí mẫu",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "Chuyển mẫu sang vị trí khác",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "Điều chỉnh nhiệt độ",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "Điều chỉnh cài đặt nhiệt độ",
  "coldStorage.criticalThreshold": "Ngưỡng nguy kịch (°C)",
  "coldStorage.dashboard.acknowledge": "Xác nhận",
  "coldStorage.dashboard.activeAlerts": "Cảnh báo đang mở ({count})",
  "coldStorage.dashboard.column.currentTemp": "Nhiệt độ hiện tại",
  "coldStorage.dashboard.column.currentTemp2": "Nhiệt độ đầu dò 2",
  "coldStorage.dashboard.column.device": "Thiết bị",
  "coldStorage.dashboard.column.duration": "Thời lượng",
  "coldStorage.dashboard.column.humidity": "Độ ẩm",
  "coldStorage.dashboard.column.lastReading": "Lần đọc gần nhất",
  "coldStorage.dashboard.column.location": "Vị trí",
  "coldStorage.dashboard.column.severity": "Mức độ",
  "coldStorage.dashboard.column.started": "Bắt đầu",
  "coldStorage.dashboard.column.targetTemp": "Nhiệt độ mục tiêu",
  "coldStorage.dashboard.column.temperature": "Nhiệt độ",
  "coldStorage.dashboard.column.unitId": "Mã tủ",
  "coldStorage.dashboard.column.unitName": "Tên tủ",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} tủ bảo quản đang vượt nhiệt độ nguy kịch",
  "coldStorage.dashboard.criticalAlertTitle": "CẢNH BÁO NGUY KỊCH",
  "coldStorage.dashboard.deviceTypeFilter": "Loại thiết bị",
  "coldStorage.dashboard.kpi.critical": "Cảnh báo nguy kịch",
  "coldStorage.dashboard.kpi.normal": "Trạng thái bình thường",
  "coldStorage.dashboard.kpi.totalUnits": "Tổng số tủ bảo quản",
  "coldStorage.dashboard.kpi.warnings": "Cảnh báo",
  "coldStorage.dashboard.lastUpdate": "Cập nhật lần cuối: {time}",
  "coldStorage.dashboard.loadingUnits": "Đang tải tủ bảo quản…",
  "coldStorage.dashboard.noActiveAlerts": "Không có cảnh báo đang mở",
  "coldStorage.dashboard.noUnitsFound": "Không tìm thấy tủ bảo quản nào.",
  "coldStorage.dashboard.online": "Trực tuyến",
  "coldStorage.dashboard.refresh": "Làm mới",
  "coldStorage.dashboard.refreshing": "Đang làm mới",
  "coldStorage.dashboard.refreshingEllipsis": "Đang làm mới...",
  "coldStorage.dashboard.searchLabel": "Tìm theo mã hoặc tên tủ",
  "coldStorage.dashboard.statusFilter": "Trạng thái",
  "coldStorage.dashboard.storageUnitsTitle": "Tủ bảo quản",
  "coldStorage.dashboard.subtitle": "Giám sát nhiệt độ thời gian thực & tuân thủ",
  "coldStorage.dashboard.systemStatus": "Trạng thái hệ thống: {status}",
  "coldStorage.dashboard.tab.correctiveActions": "Hành động khắc phục",
  "coldStorage.dashboard.tab.dashboard": "Bảng theo dõi",
  "coldStorage.dashboard.tab.historicalTrends": "Xu hướng lịch sử",
  "coldStorage.dashboard.tab.reports": "Báo cáo",
  "coldStorage.dashboard.tab.settings": "Cài đặt",
  "coldStorage.dashboard.viewAlertDetails": "Xem chi tiết cảnh báo",
  "coldStorage.deactivated": "đã ngừng dùng",
  "coldStorage.description": "Mô tả",
  "coldStorage.device.activate": "Kích hoạt thiết bị",
  "coldStorage.device.activateMessage": "Kích hoạt thiết bị này sẽ bật giám sát và thu thập dữ liệu.",
  "coldStorage.device.changeStatus": "Đổi trạng thái thiết bị",
  "coldStorage.device.changeStatusOf": "Đổi trạng thái của {name}:",
  "coldStorage.device.created": "Đã tạo thiết bị",
  "coldStorage.device.createdSuccess": "Đã tạo thiết bị “{name}” thành công",
  "coldStorage.device.deactivate": "Ngừng dùng thiết bị",
  "coldStorage.device.deactivateMessage": "Ngừng dùng thiết bị này sẽ dừng giám sát và thu thập dữ liệu. Dữ liệu lịch sử vẫn được giữ lại.",
  "coldStorage.device.delete": "Xóa thiết bị",
  "coldStorage.device.deleteConfirm": "Bạn có chắc muốn xóa {name}?",
  "coldStorage.device.deleteWarning": "Thao tác này đánh dấu thiết bị là không hoạt động và đưa khỏi giám sát. Dữ liệu lịch sử vẫn được giữ lại.",
  "coldStorage.device.deleted": "Đã xóa thiết bị “{name}” thành công",
  "coldStorage.device.deviceStatus": "Trạng thái thiết bị",
  "coldStorage.device.edit": "Sửa thiết bị",
  "coldStorage.device.id": "Mã thiết bị",
  "coldStorage.device.ipAddress": "Địa chỉ IP",
  "coldStorage.device.port": "Cổng",
  "coldStorage.device.protocol": "Giao thức",
  "coldStorage.device.registerCount": "Số thanh ghi mỗi giá trị",
  "coldStorage.device.registerCount.help": "1 cho giá trị 16-bit, 2 cho giá trị 32-bit trải trên hai thanh ghi",
  "coldStorage.device.roomFacility": "Phòng/Cơ sở",
  "coldStorage.device.rs485": "RS-485 bán song công (không bắt buộc)",
  "coldStorage.device.rs485.delayAfter": "Độ trễ sau khi truyền (ms)",
  "coldStorage.device.rs485.delayBefore": "Độ trễ trước khi truyền (ms)",
  "coldStorage.device.rs485.mode": "Bật thời gian điều khiển driver RS-485",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS mức cao khi đang truyền",
  "coldStorage.device.rs485.rxDuringTx": "Giữ bộ thu hoạt động khi đang truyền",
  "coldStorage.device.rs485.termination": "Bật điện trở đầu cuối bus",
  "coldStorage.device.secondProbe": "Đầu dò nhiệt độ thứ hai (không bắt buộc)",
  "coldStorage.device.secondProbe.offset": "Nhiệt độ gốc 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "Độ lệch gốc cho đầu dò thứ hai",
  "coldStorage.device.secondProbe.register": "Thanh ghi nhiệt độ 2",
  "coldStorage.device.secondProbe.registerHelp": "Địa chỉ thanh ghi Modbus cho đầu dò nhiệt độ thứ hai, độc lập. Số đọc được ghi lại và vẽ biểu đồ; cảnh báo ngưỡng chỉ phát từ đầu dò thứ nhất.",
  "coldStorage.device.secondProbe.scale": "Hệ số nhiệt độ 2",
  "coldStorage.device.secondProbe.scaleHelp": "Hệ số quy đổi (ví dụ 0.1 để chia cho 10)",
  "coldStorage.device.statusChanged": "Thiết bị “{name}” đã được {status} thành công",
  "coldStorage.device.type": "Loại",
  "coldStorage.device.updated": "Đã cập nhật thiết bị",
  "coldStorage.device.wordOrder": "Thứ tự word",
  "coldStorage.device.wordOrder.bigEndian": "Big endian (word có nghĩa lớn nhất đứng trước)",
  "coldStorage.device.wordOrder.help": "Thứ tự hai thanh ghi trong giá trị 32-bit; bỏ qua khi chỉ đọc một thanh ghi",
  "coldStorage.device.wordOrder.littleEndian": "Little endian (word có nghĩa nhỏ nhất đứng trước)",
  "coldStorage.deviceHistory.averageMetric": "Trung bình {metric}",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "Xác nhận / Thực hiện bởi",
  "coldStorage.deviceHistory.column.date": "Ngày",
  "coldStorage.deviceHistory.column.eventId": "Mã sự kiện",
  "coldStorage.deviceHistory.column.eventType": "Loại sự kiện",
  "coldStorage.deviceHistory.column.summaryTitle": "Tóm tắt / Tiêu đề",
  "coldStorage.deviceHistory.column.time": "Giờ",
  "coldStorage.deviceHistory.correctiveActions": "Hành động khắc phục",
  "coldStorage.deviceHistory.dataPoints": "Số điểm dữ liệu",
  "coldStorage.deviceHistory.exportCsv": "Xuất CSV",
  "coldStorage.deviceHistory.loadingEvents": "Đang tải lịch sử sự kiện...",
  "coldStorage.deviceHistory.loadingTemperature": "Đang tải dữ liệu nhiệt độ...",
  "coldStorage.deviceHistory.maxMetric": "Lớn nhất {metric}",
  "coldStorage.deviceHistory.metric": "Chỉ số:",
  "coldStorage.deviceHistory.minMetric": "Nhỏ nhất {metric}",
  "coldStorage.deviceHistory.noEventsFound": "Không tìm thấy sự kiện nào.",
  "coldStorage.deviceHistory.noTemperatureData": "Không có dữ liệu nhiệt độ trong khoảng thời gian đã chọn.",
  "coldStorage.deviceHistory.searchEvents": "Tìm sự kiện",
  "coldStorage.deviceHistory.searchPlaceholder": "Tìm theo mã sự kiện, tóm tắt hoặc người dùng...",
  "coldStorage.deviceHistory.tab.eventHistory": "Lịch sử sự kiện",
  "coldStorage.deviceHistory.tab.temperatureTrends": "Xu hướng nhiệt độ",
  "coldStorage.deviceHistory.timeRange": "Khoảng thời gian:",
  "coldStorage.deviceHistory.title": "Lịch sử thiết bị - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "Tổng cảnh báo",
  "coldStorage.deviceHistory.totalEvents": "Tổng sự kiện",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Thông báo qua Email và SMS",
  "coldStorage.error.createAction": "Không tạo được hành động khắc phục. Vui lòng thử lại.",
  "coldStorage.error.createDevice": "Không tạo được thiết bị: ",
  "coldStorage.error.createRoom": "Không tạo được phòng: ",
  "coldStorage.error.deleteDevice": "Không xóa được thiết bị: ",
  "coldStorage.error.loadActions": "Không tải được hành động khắc phục. Vui lòng thử lại.",
  "coldStorage.error.loadAuditTrail": "Không tải được nhật ký kiểm soát",
  "coldStorage.error.loadAuditTrailDetail": "Lỗi không mong đợi khi tải bản ghi kiểm soát.",
  "coldStorage.error.loadDevices": "Không tải được thiết bị: ",
  "coldStorage.error.loadExcursions": "Không tải được lịch sử vượt ngưỡng",
  "coldStorage.error.loadExcursionsDetail": "Lỗi không mong đợi khi tải dữ liệu vượt ngưỡng.",
  "coldStorage.error.loadFailed": "Không tải được dữ liệu giám sát bảo quản lạnh.",
  "coldStorage.error.loadLocations": "Không tải được vị trí: ",
  "coldStorage.error.loadUsers": "Không tải được danh sách người dùng. Vui lòng thử lại sau.",
  "coldStorage.error.noCurrentUser": "Không xác định được người dùng hiện tại. Vui lòng đăng nhập lại.",
  "coldStorage.error.retractAction": "Không thu hồi được hành động khắc phục. Vui lòng thử lại.",
  "coldStorage.error.saveThreshold": "Không lưu được cấu hình ngưỡng: ",
  "coldStorage.error.toggleStatus": "Không đổi được trạng thái thiết bị: ",
  "coldStorage.error.updateAction": "Không cập nhật được hành động khắc phục. Vui lòng thử lại.",
  "coldStorage.error.updateDevice": "Không cập nhật được thiết bị: ",
  "coldStorage.error.updateFailed": "Không cập nhật được dữ liệu bảo quản lạnh",
  "coldStorage.escalationDelay": "Thời gian chờ chuyển cấp (phút)",
  "coldStorage.escalationDelayHelper": "Thời gian chờ trước khi chuyển cấp một cảnh báo chưa xử lý",
  "coldStorage.escalationRules": "Quy tắc chuyển cấp",
  "coldStorage.filter.activeOnly": "Chỉ đang dùng",
  "coldStorage.filter.all": "Tất cả thiết bị",
  "coldStorage.filter.inactiveOnly": "Chỉ ngừng dùng",
  "coldStorage.footer": "Giám sát bảo quản lạnh v2.1.0 | Tuân thủ hướng dẫn CAP, CLIA, FDA và WHO | Xử lý dữ liệu theo chuẩn HIPAA",
  "coldStorage.granularNotificationControl": "Kiểm soát thông báo chi tiết",
  "coldStorage.granularNotificationControlDesc": "Cấu hình thông báo email và SMS cho từng loại cảnh báo một cách độc lập. Bật các phương thức thông báo mong muốn cho từng nhóm cảnh báo.",
  "coldStorage.howNotificationsWork": "Cách thông báo hoạt động",
  "coldStorage.howNotificationsWorkDesc": "Khi một cảnh báo được kích hoạt (vi phạm ngưỡng nhiệt độ, lỗi thiết bị, v.v.), hệ thống sẽ:",
  "coldStorage.loadingDevices": "Đang tải thiết bị...",
  "coldStorage.loadingPrefs": "Đang tải tùy chọn thông báo...",
  "coldStorage.name": "Tên",
  "coldStorage.noConfigFound": "Không tìm thấy cấu hình",
  "coldStorage.noDevicesConfigured": "Chưa cấu hình thiết bị nào",
  "coldStorage.notification.createRecord": "Tạo bản ghi cảnh báo trong hệ thống (hiển thị trên Bảng theo dõi)",
  "coldStorage.notification.logAttempt": "Ghi nhật ký lần gửi thông báo để phục vụ kiểm soát",
  "coldStorage.notification.sendEmail": "Gửi thông báo EMAIL nếu được bật (đến người nhận đã cấu hình)",
  "coldStorage.notification.sendSms": "Gửi thông báo SMS nếu được bật (đến số điện thoại đã cấu hình)",
  "coldStorage.pollInterval": "Chu kỳ đọc (giây)",
  "coldStorage.reports.column.action": "Hành động",
  "coldStorage.reports.column.details": "Chi tiết",
  "coldStorage.reports.column.excursionId": "Mã vượt ngưỡng",
  "coldStorage.reports.column.freezer": "Tủ đông",
  "coldStorage.reports.column.freezerId": "Mã tủ đông",
  "coldStorage.reports.column.startTime": "Thời điểm bắt đầu",
  "coldStorage.reports.column.temperatureRange": "Khoảng nhiệt độ",
  "coldStorage.reports.column.timestamp": "Thời điểm",
  "coldStorage.reports.column.user": "Người dùng",
  "coldStorage.reports.downloadReport": "Tải báo cáo {format}",
  "coldStorage.reports.endDate": "Đến ngày",
  "coldStorage.reports.excursionHistory": "Lịch sử vượt ngưỡng nhiệt độ",
  "coldStorage.reports.exportFormat": "Định dạng xuất",
  "coldStorage.reports.footer": "Giám sát bảo quản lạnh v2.1.0 | Tuân thủ CAP, CLIA, FDA & WHO | Sẵn sàng xử lý dữ liệu theo HIPAA",
  "coldStorage.reports.freezer": "Tủ đông",
  "coldStorage.reports.generateReport": "Tạo báo cáo",
  "coldStorage.reports.loadingAudit": "Đang tải các mục kiểm soát…",
  "coldStorage.reports.loadingExcursions": "Đang tải các lần vượt ngưỡng…",
  "coldStorage.reports.noAuditActivity": "Không có hoạt động kiểm soát nào với bộ lọc đã chọn.",
  "coldStorage.reports.noAuditMatch": "Không có mục kiểm soát nào khớp với tìm kiếm.",
  "coldStorage.reports.noExcursions": "Không có lần vượt ngưỡng nào với bộ lọc đã chọn.",
  "coldStorage.reports.regulatoryCompliance": "Tuân thủ quy định",
  "coldStorage.reports.regulatoryComplianceDesc": "Báo cáo tuân theo hướng dẫn của CAP (Trường Bệnh học Hoa Kỳ), CLIA (Cải tiến Xét nghiệm Lâm sàng), FDA (Cục Quản lý Thực phẩm và Dược phẩm) và WHO (Tổ chức Y tế Thế giới) cho việc bảo quản có kiểm soát nhiệt độ.",
  "coldStorage.reports.reportType": "Loại báo cáo",
  "coldStorage.reports.searchAuditTrail": "Tìm trong nhật ký kiểm soát...",
  "coldStorage.reports.startDate": "Từ ngày",
  "coldStorage.reports.tab.auditTrail": "Nhật ký kiểm soát",
  "coldStorage.reports.tab.excursions": "Vượt ngưỡng nhiệt độ",
  "coldStorage.reports.title": "Báo cáo theo quy định",
  "coldStorage.room.addNew": "Thêm phòng mới",
  "coldStorage.room.create": "Tạo phòng",
  "coldStorage.room.created": "Đã tạo phòng",
  "coldStorage.room.description": "Mô tả",
  "coldStorage.room.descriptionPlaceholder": "Nhập mô tả phòng (không bắt buộc)",
  "coldStorage.room.name": "Tên phòng",
  "coldStorage.room.namePlaceholder": "Nhập tên phòng (ví dụ Phòng bảo quản A)",
  "coldStorage.saveNotificationPrefs": "Lưu tùy chọn thông báo",
  "coldStorage.saveThresholdConfig": "Lưu cấu hình ngưỡng",
  "coldStorage.saving": "Đang lưu...",
  "coldStorage.search.placeholder": "Tìm theo mã hoặc tên thiết bị",
  "coldStorage.selectType": "Chọn loại",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Trạng thái",
  "coldStorage.status.active": "ĐANG DÙNG",
  "coldStorage.status.inactive": "NGỪNG DÙNG",
  "coldStorage.status.noData": "Chưa có dữ liệu",
  "coldStorage.status.offline": "Ngoại tuyến",
  "coldStorage.status.unknown": "Không rõ",
  "coldStorage.supervisorEmail": "Email người giám sát",
  "coldStorage.supervisorEmailHelper": "Địa chỉ email nhận cảnh báo đã chuyển cấp",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.targetTemperature": "Nhiệt độ mục tiêu (°C)",
  "coldStorage.threshold.saveSuccess": "Đã lưu cấu hình ngưỡng",
  "coldStorage.thresholdConfiguration": "Cấu hình ngưỡng nhiệt độ",
  "coldStorage.trends.averageMetric": "Trung bình {metric}",
  "coldStorage.trends.axis.humidity": "Độ ẩm (%)",
  "coldStorage.trends.axis.temperature": "Nhiệt độ (°C)",
  "coldStorage.trends.axis.temperature2": "Nhiệt độ - Đầu dò 2 (°C)",
  "coldStorage.trends.maxMetric": "Lớn nhất {metric}",
  "coldStorage.trends.metric": "Chỉ số",
  "coldStorage.trends.metric.humidity": "Độ ẩm",
  "coldStorage.trends.metric.temperature": "Nhiệt độ",
  "coldStorage.trends.metric.temperature2": "Nhiệt độ (Đầu dò 2)",
  "coldStorage.trends.minMetric": "Nhỏ nhất {metric}",
  "coldStorage.usingDefaults": "Đang dùng tùy chọn thông báo mặc định. Lưu để tạo cấu hình.",
  "coldStorage.validation.error": "Lỗi kiểm tra dữ liệu",
  "coldStorage.validation.retractionReason": "Vui lòng nhập lý do thu hồi",
  "coldStorage.validation.selectActionType": "Vui lòng chọn loại hành động",
  "coldStorage.validation.selectDevice": "Vui lòng chọn thiết bị",
  "coldStorage.validation.selectRoom": "Vui lòng chọn phòng/vị trí cho thiết bị",
  "coldStorage.warningThreshold": "Ngưỡng cảnh báo (°C)",
  "collect.addSample.button": "Thêm mẫu",
  "collect.assign.addToSample": "Thêm vào mẫu đã có",
  "collect.assign.button": "Gán xét nghiệm",
  "collect.assign.description": "Gán các xét nghiệm đã yêu cầu vào ống mẫu",
  "collect.assign.newSample": "Tạo mẫu mới",
  "collect.assign.newSampleHelp": "Chọn loại mẫu cho ống mới",
  "collect.assign.noExisting": "Chưa có mẫu nào",
  "collect.assign.title": "Gán xét nghiệm",
  "collect.multiSampleExample.description": "Khi cần nhiều loại mẫu",
  "collect.multiSampleExample.result": "Tạo ống riêng cho từng loại",
  "collect.multiSampleExample.title": "Ví dụ lấy nhiều mẫu",
  "collect.noSampleYet": "Chưa lấy mẫu nào",
  "collect.noCompatibleSampleTypes": "Chưa thiết lập loại mẫu cho xét nghiệm này trong danh mục xét nghiệm",
  "collect.noTestsOrdered": "Chưa có xét nghiệm nào được chỉ định",
  "collect.noTestsWarning.subtitle": "Thêm mẫu kèm xét nghiệm ở Bước 1 trước khi tiếp tục",
  "collect.noTestsWarning.title": "Không có xét nghiệm để lấy mẫu",
  "collect.requestedTests.info": "Các xét nghiệm được yêu cầu cho chỉ định này",
  "collect.requestedTests.title": "Xét nghiệm được yêu cầu",
  "collect.sample.assignedTests": "Xét nghiệm đã gán",
  "collect.sample.collectionConditions": "Điều kiện lấy mẫu",
  "collect.sample.collectionConditions.placeholder": "Ghi chú các điều kiện đặc biệt...",
  "collect.sample.collectionDate": "Ngày lấy mẫu",
  "collect.sample.collectionMethod": "Phương pháp lấy mẫu",
  "collect.addTests.title": "Thêm xét nghiệm hoặc bộ xét nghiệm",
  "collect.addTests.helper": "Thêm xét nghiệm mà bác sĩ yêu cầu sau khi chỉ định đã nhập, hoặc xét nghiệm chỉ phù hợp khi đã có mẫu trong tay.",
  "collect.consentRequired.title": "Cần có sự đồng ý được thông tin",
  "collect.consentRequired.subtitle": "Phòng xét nghiệm này yêu cầu ghi nhận sự đồng ý trước khi tiến hành lấy mẫu.",
  "sample.holdingLimit": "Thời gian lưu mẫu: {limit}",
  "sample.holdingLimit.testBy": "xét nghiệm trước {deadline}",
  "env.sample.receivedAtLab": "Đã nhận tại phòng XN",
  "collect.sample.specimenOrigin": "Nguồn gốc mẫu",
  "collect.sample.temperature": "Nhiệt độ mẫu",
  "collect.sample.temperature.placeholder": "Ví dụ: 4 C",
  "collect.sample.collectionDate.helper": "Mặc định là hôm nay — sửa lại nếu mẫu được lấy trước đó",
  "collect.sample.collectionTime": "Giờ lấy mẫu",
  "collect.sample.collector": "Người lấy mẫu",
  "collect.sample.header": "Mẫu {number}",
  "collect.sample.labPerformedSampling": "Phòng XN thực hiện lấy mẫu",
  "collect.sample.nce.link": "Báo cáo sự kiện không phù hợp",
  "collect.sample.noTests": "Mẫu này chưa được gán xét nghiệm nào",
  "collect.sample.printLabels": "In nhãn",
  "collect.printMoreLabels.helper": "Lấy nhiều hơn dự kiến, hoặc cần loại mẫu khác? Dùng Thêm mẫu, rồi in nhãn từ thẻ mẫu hoặc mục Nhãn.",
  "collect.sample.quantity": "Số lượng",
  "collect.sample.receivedAtLab": "Đã nhận tại phòng XN",
  "collect.sample.receivedAtLab.helper": "Đánh dấu nếu mẫu đã được nhận tại phòng xét nghiệm",
  "collect.sample.receivedDate": "Ngày nhận mẫu",
  "collect.sample.receivedTime": "Giờ nhận mẫu",
  "collect.sample.remove": "Xóa mẫu",
  "collect.samples.title": "Mẫu",
  "collect.table.compatibleTypes": "Loại mẫu tương thích",
  "collect.table.sampleAssignments": "Gán mẫu",
  "collect.table.testPanel": "Xét nghiệm/Bộ xét nghiệm",
  "heading.informedConsent.sectionTitle": "Đồng ý được thông tin",
  "heading.informedConsent.auditRecord": "Nhật ký đồng ý",
  "label.informedConsent.consentGiven": "Bệnh nhân đã ký đồng ý",
  "label.informedConsent.formReference": "Số tham chiếu mẫu đồng ý",
  "label.informedConsent.recordedBy": "Ghi nhận bởi",
  "label.informedConsent.recordedAt": "Ghi nhận ngày",
  "label.informedConsent.statusTag": "Đã ghi nhận đồng ý",
  "label.informedConsent.notRecorded": "Chưa ghi nhận",
  "placeholder.informedConsent.formReference": "Ví dụ: CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "Ví dụ: BS. Nguyễn Văn A",
  "error.informedConsent.formReferenceMaxLength": "Số tham chiếu mẫu đồng ý tối đa 100 ký tự",
  "error.informedConsent.formReferenceInvalidChars": "Chỉ cho phép chữ cái, chữ số, dấu gạch ngang và khoảng trắng",
  "coldstorage.label.dashboard": "Bảng theo dõi bảo quản lạnh",
  "collection.date": "Ngày lấy mẫu",
  "collector": "Người lấy mẫu",
  "collector.label": "Người lấy mẫu",
  "column.actions": "Thao tác",
  "column.name.accept": "Chấp nhận",
  "column.name.analyzerResult": "Kết quả máy",
  "column.name.currentResult": "Kết quả hiện tại",
  "column.name.ignore": "Bỏ qua",
  "column.name.normalRange": "Khoảng bình thường",
  "column.name.notes": "Ghi chú",
  "column.name.pastNotes": "Ghi chú trước",
  "column.name.qcDetail": "Chi tiết",
  "column.name.qcStatus": "Trạng thái QC",
  "column.name.reject": "Từ chối",
  "column.name.result": "Kết quả",
  "column.name.retest": "Làm lại",
  "column.name.sampleInfo": "Thông tin mẫu",
  "column.name.sampleKind": "Loại mẫu",
  "column.name.save": "Lưu",
  "column.name.statusPerRegulation": "Trạng thái — Theo quy định",
  "column.name.testDate": "Ngày xét nghiệm",
  "column.name.testId": "Mã xét nghiệm",
  "column.name.testName": "Tên xét nghiệm",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "Mã phải có ít nhất một chữ cái, chữ số hoặc dấu gạch dưới.",
  "common.properties.title": "Thuộc tính chung",
  "configuration.batch.test.reassignment": "Gán lại và hủy xét nghiệm theo lô",
  "configuration.method": "Quản lý phương pháp",
  "configuration.method.create": "Tạo phương pháp mới",
  "configuration.testCatalog.tests.explain": "Tạo, sửa, đổi tên, kích hoạt và thiết lập khả năng chỉ định của xét nghiệm, cùng khoảng tham chiếu, tùy chọn kết quả, phương pháp và nhãn",
  "configuration.testCatalog.panels.explain": "Tạo và sửa bộ xét nghiệm, gán xét nghiệm và thiết lập thứ tự hiển thị",
  "configuration.testCatalog.sampleTypes.explain": "Tạo và sửa loại mẫu, gán xét nghiệm và thiết lập thứ tự hiển thị",
  "configuration.testCatalog.labUnits.explain": "Tạo và sửa nhóm xét nghiệm và gán xét nghiệm cho nhóm",
  "configuration.testCatalog.import.explain": "Nạp xét nghiệm, bộ xét nghiệm, loại mẫu và nhóm xét nghiệm từ tệp CSV",
  "configuration.testCatalog.methods.explain": "Thêm phương pháp; phương pháp mới sẽ hoạt động khi có xét nghiệm sử dụng",
  "configuration.selectList.add": "Thêm danh sách chọn kết quả",
  "configuration.selectList.add.alert": "Để sửa chính tả các mục hiện có trong danh sách kết quả, dùng Đổi tên tùy chọn danh sách kết quả hiện có",
  "configuration.selectList.add.explain": "Dùng để tạo danh sách chọn kết quả cho xét nghiệm",
  "configuration.selectList.rename": "Đổi tên tùy chọn danh sách kết quả hiện có",
  "configuration.selectList.rename.explain": "Đổi tên tùy chọn danh sách kết quả hiện có",
  "configuration.test.activate": "Kích hoạt/Ngừng kích hoạt xét nghiệm",
  "configuration.test.activate.explain": "Dùng để kích hoạt hoặc ngừng kích hoạt một xét nghiệm hiện có.",
  "configuration.test.catalog": "Xem danh mục xét nghiệm",
  "configuration.test.catalog.explain": "Xem danh mục xét nghiệm hiện tại",
  "configuration.test.orderable": "Bật/tắt khả năng chỉ định xét nghiệm",
  "configuration.test.orderable.explain": "Xét nghiệm có thể chỉ định được sẽ đặt được khi tiếp nhận. Nếu không, chỉ có thể chỉ định khi được kích hoạt tự động từ xét nghiệm khác (reflex)",
  "configuration.testCatalog.uom.explain": "Liệt kê đơn vị đo và sửa tên, mã, mã UCUM của đơn vị",
  "configuration.uom.title": "Đơn vị đo",
  "configuration.uom.explain": "Các đơn vị dùng để báo cáo kết quả số. Có thể tạo đơn vị ngay khi đang sửa xét nghiệm.",
  "configuration.uom.add": "Thêm đơn vị",
  "configuration.uom.edit": "Sửa đơn vị",
  "configuration.uom.empty": "Không có đơn vị đo nào khớp",
  "method.modal.edit.heading": "Sửa phương pháp",
  "configuration.method.create.duplicate": "Đã có phương pháp cùng tên. Vui lòng dùng tên khác.",
  "configuration.panel.assign": "Gán xét nghiệm",
  "configuration.panel.assign.explain": "Chọn các xét nghiệm cần gán lại sang bộ xét nghiệm khác bằng cách nhấn vào tên xét nghiệm; chúng được hiển thị dưới bộ xét nghiệm đang gán.",
  "configuration.panel.confirmation.explain": "Bộ xét nghiệm này sẽ chưa hoạt động cho đến khi có ít nhất một xét nghiệm được gán vào.",
  "configuration.panel.create": "Tạo bộ xét nghiệm mới",
  "configuration.panel.create.duplicate": "Đã tồn tại loại bộ xét nghiệm trùng tên. Vui lòng hủy hoặc dùng tên khác.",
  "configuration.panel.order": "Thiết lập thứ tự bộ xét nghiệm",
  "configuration.panel.order.explain": "Sắp xếp bộ xét nghiệm bằng cách nhấn vào một loại và kéo vào đúng vị trí.",
  "configuration.panel.order.explain.limits": "Chỉ có thể sắp xếp các bộ xét nghiệm đã có xét nghiệm được gán. Với bộ mới, hãy gán xét nghiệm trước khi sắp xếp.",
  "configuration.sampleType.assign.explain": "Chọn các xét nghiệm cần gán lại sang loại mẫu khác bằng cách nhấn vào tên xét nghiệm; chúng được hiển thị dưới loại mẫu đang gán.",
  "configuration.sampleType.assign.new.type": "Gán cho loại mẫu",
  "configuration.sampleType.confirmation.explain": "Loại mẫu này sẽ chưa hoạt động cho đến khi có ít nhất một xét nghiệm được gán vào.",
  "configuration.sampleType.create": "Tạo loại mẫu mới",
  "configuration.sampleType.create.duplicate": "Đã tồn tại loại mẫu xét nghiệm trùng tên. Vui lòng hủy hoặc dùng tên khác.",
  "configuration.sampleType.manage": "Quản lý loại mẫu",
  "configuration.sampleType.manage.explain": "Dùng để tạo, thiết lập thứ tự hiển thị hoặc gán xét nghiệm cho loại mẫu",
  "configuration.sampleType.order": "Thiết lập thứ tự loại mẫu",
  "configuration.sampleType.order.explain": "Sắp xếp loại mẫu bằng cách nhấn vào một loại và kéo vào đúng vị trí.",
  "configuration.sampleType.order.explain.limits": "Chỉ có thể sắp xếp các loại mẫu đã có xét nghiệm được gán. Với loại mới, hãy gán xét nghiệm trước khi sắp xếp.",
  "configuration.selectList.assign.description": "Mục mới có thể gán cho xét nghiệm hoặc lưu mà chưa gán. Chọn một hoặc nhiều xét nghiệm để gán rồi điều chỉnh thứ tự hiển thị. Nếu mục mới là giá trị bình thường của xét nghiệm đã chọn, đánh dấu ô `Normal`. Nếu muốn kỹ thuật viên nhập thêm chữ cùng lựa chọn kết quả, đánh dấu ô `Qualifiable`. Ví dụ: nếu các lựa chọn là danh sách vi sinh vật và mục cuối là `Other` thì người dùng có thể nhập một vi sinh vật không có trong danh sách.",
  "configuration.selectList.assign.header": "Gán lựa chọn kết quả mới cho xét nghiệm",
  "configuration.selectList.assign.new": "Tùy chọn danh sách mới",
  "configuration.selectList.confirmChange": "Giá trị bình thường sẽ được đổi từ %oldvalue% thành %newvalue%, bạn có chắc muốn tiếp tục?",
  "configuration.selectList.description": "Nhập cả tiếng Anh và tiếng Pháp cho tùy chọn mới. Nếu chưa biết bản dịch, từ đã nhập sẽ được dùng cho cả hai ngôn ngữ.",
  "configuration.selectList.header": "Tạo tùy chọn lựa chọn kết quả mới",
  "configuration.test.management.ocl": "Nhập khái niệm OCL",
  "configuration.test.management.organization": "Tổ chức xét nghiệm",
  "configuration.test.modify.tab.configuration": "Cấu hình",
  "configuration.test.modify.tab.compliance": "Ngưỡng tuân thủ",
  "configuration.test.modify.filter.instruction": "Chọn loại mẫu hoặc nhóm xét nghiệm để hiển thị xét nghiệm.",
  "configuration.test.modify.filter.noTestsFound": "Không tìm thấy xét nghiệm nào khớp tiêu chí đã chọn.",
  "configuration.test.modify.filter.selectToBegin": "Vui lòng chọn loại mẫu hoặc nhóm xét nghiệm để bắt đầu xem xét nghiệm.",
  "configuration.testUnit.assign.new.unit": "Gán cho nhóm xét nghiệm",
  "configuration.testUnit.confirmation.explain": "Nhóm xét nghiệm này sẽ chưa hoạt động cho đến khi có ít nhất một xét nghiệm được gán vào.",
  "configuration.testUnit.create": "Tạo nhóm xét nghiệm mới",
  "configuration.testUnit.create.duplicate": "Đã tồn tại nhóm xét nghiệm trùng tên. Vui lòng hủy hoặc dùng tên khác.",
  "configuration.testUnit.order": "Thiết lập thứ tự nhóm xét nghiệm",
  "configuration.testUnit.order.explain": "Sắp xếp nhóm bằng cách nhấn vào một nhóm và kéo vào đúng vị trí.",
  "configuration.testUnit.order.explain.limits": "Chỉ có thể sắp xếp các nhóm xét nghiệm đã có xét nghiệm được gán. Với nhóm mới, hãy gán xét nghiệm trước khi sắp xếp.",
  "heading.sampleType.management": "Trình sửa loại mẫu",
  "heading.sampleType.subtitle": "Cấu hình loại mẫu, thứ tự hiển thị, liên kết xét nghiệm và phân loại lĩnh vực.",
  "heading.sampleType.editing": "Đang sửa: {name}",
  "label.sampleType.domain": "Lĩnh vực mẫu",
  "label.domain.CLINICAL": "Lâm sàng",
  "label.domain.ENVIRONMENTAL": "Môi trường",
  "label.domain.VECTOR": "Véc-tơ",
  "label.sampleType.domain.clinical": "Lâm sàng",
  "label.sampleType.domain.environmental": "Môi trường",
  "label.sampleType.domain.helper": "Quyết định loại mẫu này xuất hiện trong chế độ làm việc nào (Lâm sàng hay Môi trường).",
  "label.sampleType.filterDomain": "Lọc theo lĩnh vực",
  "label.sampleType.testCount": "Xét nghiệm",
  "label.sampleType.actions": "Thao tác",
  "label.sampleType.status": "Trạng thái",
  "placeholder.sampleType.search": "Tìm loại mẫu...",
  "placeholder.sampleType.filter.domain": "Tất cả lĩnh vực",
  "button.sampleType.add": "Thêm loại mẫu",
  "configuration.uom.create": "Tạo đơn vị đo mới",
  "configure.labNumber.title": "Quản lý mã mẫu",
  "confirmation.rename": "Xác nhận các thay đổi bạn đã thực hiện ở trên.",
  "currentests.title": "Xét nghiệm hiện tại",
  "cytology.label.cellabnomality": "Bất thường tế bào biểu mô",
  "cytology.label.confirmSelect": "Nếu chọn tùy chọn này, mọi thông tin chẩn đoán hiện tại sẽ bị xóa",
  "cytology.label.dashboard": "Bảng theo dõi tế bào học",
  "cytology.label.glandular": "Tuyến",
  "cytology.label.negative": "Âm tính với tổn thương trong biểu mô hoặc ác tính",
  "cytology.label.neoplastic": "Biến đổi tế bào không tân sinh",
  "cytology.label.organisms": "Vi sinh vật",
  "cytology.label.other": "Tân sinh ác tính khác",
  "cytology.label.otherResult": " Kết quả chẩn đoán khác",
  "cytology.label.reactive": "Thay đổi tế bào phản ứng",
  "cytology.label.review": "Chờ bác sĩ tế bào học xem lại",
  "cytology.label.specimen": "Mức độ đầy đủ của mẫu",
  "cytology.label.squamous": "Vảy",
  "cytology.label.title": "Tế bào học",
  "cytology.status.completed": "Hoàn thành",
  "cytology.status.preparingSlides": "Đang chuẩn bị tiêu bản",
  "cytology.status.readyForCytopathologist": "Sẵn sàng cho bác sĩ tế bào học",
  "cytology.status.screening": "Đang sàng lọc",
  "dashboard.avg.turn.around.label": "Thời gian trả kết quả trung bình",
  "dashboard.avg.turn.around.reception.to.result.label": "TB từ nhận mẫu đến nhập kết quả",
  "dashboard.avg.turn.around.reception.to.validation.label": "TB từ nhận mẫu đến duyệt",
  "dashboard.avg.turn.around.result.to.validation.label": "TB từ nhập kết quả đến duyệt",
  "dashboard.avg.turn.around.subtitle.label": "Từ nhận mẫu đến duyệt",
  "dashboard.complete.orders.label": "Chỉ định hoàn thành hôm nay",
  "dashboard.in.progress.label": "Đang xử lý",
  "dashboard.in.progress.subtitle.label": "Chờ nhập kết quả",
  "dashboard.metrics.loadFailed": "Không tải được số liệu bảng theo dõi.",
  "dashboard.partially.completed.label": "Hoàn thành một phần hôm nay",
  "dashboard.partially.completed.subtitle.label": "Chờ các xét nghiệm còn lại",
  "dashboard.rejected.orders": "Chỉ định bị từ chối hôm nay",
  "dashboard.turn.around.label": "Trả kết quả bị trễ",
  "dashboard.turn.around.subtitle.label": "Quá 96 giờ",
  "dashboard.unprints.results.label": "Kết quả chưa in hôm nay",
  "dashboard.user.orders.label": "Chỉ định người dùng nhập hôm nay",
  "dashboard.user.orders.today.label": "Chỉ định người dùng nhập hôm nay",
  "dashboard.user.ordersEntered": "Chỉ định đã nhập",
  "dashboard.validation.ready.label": "Sẵn sàng duyệt",
  "dashboard.validation.ready.subtitle.label": "Chờ xem xét",
  "dataexport.status.actions": "Thao tác",
  "dataexport.status.attempt.duration": "Thời lượng",
  "dataexport.status.attempt.endTime": "Thời điểm kết thúc",
  "dataexport.status.attempt.startTime": "Thời điểm bắt đầu",
  "dataexport.status.attempt.status": "Trạng thái",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "Chưa cấu hình người nhận FHIR nào. Đặt org.openelisglobal.fhir.subscriber trong common.properties và khởi động lại máy chủ để đăng ký.",
  "dataexport.status.endpoint": "Điểm cuối",
  "dataexport.status.failed24h": "Lỗi / Tổng (24 giờ)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Chu kỳ thử lại",
  "dataexport.status.intervalValue": "{value} phút",
  "dataexport.status.lastAttempt": "Lần thử gần nhất",
  "dataexport.status.lastRefreshed": "Làm mới lần cuối",
  "dataexport.status.lastStatus": "Trạng thái gần nhất",
  "dataexport.status.lastSuccess": "Thành công gần nhất",
  "dataexport.status.loadingAttempts": "Đang tải lịch sử lần thử…",
  "dataexport.status.never": "Chưa bao giờ",
  "dataexport.status.noAttempts": "Chưa có lần thử nào",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Làm mới",
  "dataexport.status.retry": "Thử lại ngay",
  "dataexport.status.retryInFlight": "Đang kích hoạt…",
  "dataexport.status.title": "Trạng thái xuất dữ liệu FHIR",
  "datasubmission.siteid": "Mã điểm",
  "database.clean": "Dọn dẹp cơ sở dữ liệu",
  "database.clean.button": "Dọn dẹp cơ sở dữ liệu",
  "database.clean.confirm.message": "Bạn có chắc muốn dọn dẹp cơ sở dữ liệu? Thao tác này sẽ xóa toàn bộ dữ liệu bệnh nhân và xét nghiệm.",
  "database.clean.confirm.title": "Xác nhận dọn dẹp cơ sở dữ liệu",
  "database.clean.confirm.warning": "Thao tác này không thể hoàn tác!",
  "database.clean.error": "Không dọn dẹp được cơ sở dữ liệu.",
  "database.clean.not.training": "Chỉ có thể dọn dẹp cơ sở dữ liệu trên máy đào tạo.",
  "database.clean.success": "Đã dọn dẹp cơ sở dữ liệu.",
  "database.clean.warning": "Thao tác này sẽ xóa vĩnh viễn toàn bộ dữ liệu bệnh nhân, dữ liệu mẫu và kết quả khỏi cơ sở dữ liệu.",
  "date.created": "Ngày tạo",
  "datepicker.future.notAllowed": "Ngày không được ở tương lai.",
  "datepicker.past.notAllowed": "Ngày không được ở quá khứ.",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "Lỗi khi xóa",
  "delete.success.msg": "Đã xóa thành công",
  "description.active": "Nếu xét nghiệm đang hoạt động thì có thể chỉ định trên phiếu chỉ định hoặc như một phần của thuật toán xét nghiệm. Nếu không hoạt động thì không thể chỉ định hoặc nằm trong thuật toán",
  "description.ageRange": "Nếu khoảng tuổi (theo tháng) ảnh hưởng đến giá trị, sẽ ghi rõ tại đây.",
  "description.name": "Tên xét nghiệm như hiển thị trong openELIS. Hiển thị cả tiếng Anh và tiếng Pháp",
  "description.normalRange": "Mọi kết quả số nằm trong khoảng này là giá trị mong đợi ở người khỏe mạnh.",
  "description.note": "n/a nghĩa là không có. Giá trị chưa được quy định.",
  "description.orderable": "Nếu xét nghiệm đang hoạt động và có thể chỉ định thì có thể chỉ định trên phiếu chỉ định. Nếu đang hoạt động nhưng không chỉ định được thì chỉ thực hiện khi được kích hoạt tự động từ xét nghiệm khác",
  "description.panel": "Nếu xét nghiệm này thuộc một bộ xét nghiệm thì tên bộ sẽ được ghi tại đây.",
  "description.referenceValue": "Giá trị của một lựa chọn ở người khỏe mạnh. Chỉ áp dụng cho kết quả dạng danh sách chọn.",
  "description.reportName": "Tên xét nghiệm như hiển thị trong báo cáo. Hiển thị cả tiếng Anh và tiếng Pháp",
  "description.resultLimits": "Giới hạn bình thường và giới hạn kết quả hợp lệ cho xét nghiệm số. Giá trị có thể phụ thuộc vào cả tuổi và giới tính của bệnh nhân.",
  "description.resultType": "Loại kết quả của xét nghiệm này:",
  "description.resultType.alphanumeric": "A - Chữ và số:",
  "description.resultType.alphanumericDesc": " Nhận số hoặc chữ trong ô văn bản. Không đánh giá là bình thường hay hợp lệ.",
  "description.resultType.cascadingMultiSelectList": "C - Danh sách chọn nhiều phân cấp:",
  "description.resultType.cascadingMultiSelectListDesc": " Tương tự chọn nhiều nhưng người dùng có thể chọn nhiều nhóm từ danh sách thả xuống.",
  "description.resultType.kind": "Loại kết quả của xét nghiệm này:",
  "description.resultType.multiSelectList": "M - Danh sách chọn nhiều:",
  "description.resultType.multiSelectListDesc": " Người dùng có thể chọn một hoặc nhiều giá trị từ danh sách thả xuống. Không quy định giá trị tham chiếu.",
  "description.resultType.numeric": "N - Số:",
  "description.resultType.numericDesc": " Chỉ nhận kết quả số trong ô văn bản. Kết quả có thể được đánh giá là trong khoảng bình thường hoặc hợp lệ.",
  "description.resultType.selectList": "D - Danh sách chọn:",
  "description.resultType.selectListDesc": " Người dùng chọn từ danh sách thả xuống. Giá trị bình thường được quy định làm giá trị tham chiếu.",
  "description.resultType.textArea": "R - Văn bản tự do:",
  "description.resultType.textAreaDesc": " Nhận tối đa 200 ký tự trong ô văn bản nhiều dòng. Không đánh giá là bình thường hay hợp lệ.",
  "description.sampleType": "Loại mẫu dùng để thực hiện xét nghiệm. Nếu kỹ thuật viên tiếp nhận có thể chọn loại mẫu sau khi chỉ định xét nghiệm, mục này được đánh dấu là user để cho biết người dùng sẽ tự chọn loại mẫu",
  "description.selectValues": "Chỉ quy định cho kết quả danh sách chọn, chọn nhiều hoặc chọn nhiều phân cấp. Đây là các lựa chọn hiển thị cho người dùng. Nếu lựa chọn được đánh dấu 'qualifiable' thì khi người dùng chọn giá trị đó, họ có thể nhập thêm thông tin vào ô văn bản.",
  "description.sex": "Nếu giới tính bệnh nhân ảnh hưởng đến giá trị, sẽ ghi rõ tại đây.",
  "description.significantDigits": "Số chữ số có nghĩa cho kết quả số. Kết quả nhập vào sẽ được làm tròn hoặc thêm số 0 để đủ số chữ số. Khoảng bình thường cũng được hiển thị với đúng số chữ số có nghĩa.",
  "description.testUnit": "Nhóm nào của phòng xét nghiệm thực hiện xét nghiệm. Còn gọi là nhóm xét nghiệm.",
  "description.uom": "Đơn vị đo của xét nghiệm. Thường chỉ áp dụng cho kiểu kết quả số hoặc chữ-số.",
  "description.validRange": "Kết quả số nằm ngoài khoảng này cho thấy xét nghiệm có thể đã không được thực hiện đúng.",
  "dictionary.category.isActive": "Đang dùng",
  "dictionary.category.label": "Nhóm từ điển",
  "dictionary.category.localAbbreviation": "Viết tắt nội bộ",
  "dictionary.category.name": "Nhóm",
  "dictionary.dictEntry": "Mục từ điển",
  "dictionary.error.dictEntryRequired": "Enter the dictionary entry.",
  "dictionary.error.localAbbreviationRequired": "Enter a local abbreviation.",
  "dictionary.error.localAbbreviationTooLong": "A local abbreviation has at most 60 characters.",
  "dictionary.label.modify": "Menu từ điển",
  "dictionary.loincCode": "Mã LOINC",
  "dictionary.loincCode.help": "Nhập mã định danh LOINC chuẩn",
  "dictionary.loincCode.helpText": "Mã định danh chuẩn cho chỉ số xét nghiệm",
  "dictionary.loincCode.invalid": "Sai định dạng LOINC (ví dụ: 12345-6 hoặc LP12345-6)",
  "dictionary.loincCode.placeholder": "Ví dụ: 12345-6",
  "dictionary.menu.deactivate.fail": "Ngừng dùng menu từ điển thất bại",
  "dictionary.menu.deactivate.success": "Đã ngừng dùng menu từ điển",
  "dictionary.modal.add.heading": "Thêm từ điển",
  "dictionary.modal.edit.heading": "Sửa từ điển",
  "dictionary.number.label": "Số từ điển",
  "disposal.button": "Tiêu hủy lô",
  "disposal.notes": "Ghi chú tiêu hủy",
  "disposal.notes.placeholder": "Ghi chi tiết việc tiêu hủy (phương pháp tiêu hủy, người chứng kiến, v.v.)",
  "disposal.reason": "Lý do tiêu hủy",
  "disposal.reason.select": "Chọn lý do",
  "disposal.success": "Đã tiêu hủy lô",
  "disposal.title": "Tiêu hủy lô",
  "disposal.warning.message": "Thao tác này không thể hoàn tác. Lô sẽ được đánh dấu đã tiêu hủy và đưa ra khỏi tồn kho đang dùng.",
  "disposal.warning.title": "Cảnh báo",
  "emergencyContactInfo.title": "Thông tin liên hệ khẩn cấp",
  "english.current": "TIẾNG ANH hiện tại",
  "english.label": "Tiếng Anh",
  "enterText.label": "Nhập phần chữ còn lại",
  "eorder.allInfo": "Tất cả thông tin",
  "eorder.button.editOrder": "Sửa chỉ định",
  "eorder.button.enterOrder": "Nhập chỉ định",
  "eorder.buttons": " ",
  "eorder.date.end": "Đến ngày",
  "eorder.date.start": "Từ ngày",
  "eorder.facility.requesting": "Cơ sở yêu cầu",
  "eorder.header": "Tìm yêu cầu xét nghiệm đến",
  "eorder.id.national": "Số CCCD",
  "eorder.id.subjectNumber": "Mã bệnh nhân",
  "eorder.instructions.enter1": "Yêu cầu xét nghiệm khớp với tìm kiếm — Trong menu ",
  "eorder.instructions.enter2": " nhập mã mẫu và chọn ",
  "eorder.instructions.enter3": " để chấp nhận chỉ định như hiện có, hoặc chọn ",
  "eorder.instructions.enter4": " để chỉnh sửa ",
  "eorder.labNumber": "Mã mẫu",
  "eorder.labnumber.referring": "Mã mẫu của đơn vị gửi",
  "eorder.name.first": "Tên",
  "eorder.name.last": "Họ",
  "eorder.passport.number": "Số hộ chiếu",
  "eorder.priority": "Ưu tiên",
  "eorder.requestDate": "Ngày yêu cầu",
  "eorder.search.noresults": "Không có chỉ định điện tử",
  "eorder.search1.text": "Tìm theo họ, số CCCD, mã mẫu từ đơn vị gửi hoặc số hộ chiếu",
  "eorder.search2.text": "Tìm theo ngày và trạng thái. Nhập khoảng ngày của yêu cầu xét nghiệm. Tìm theo ngày gửi hoặc ngày chỉ định của yêu cầu điện tử",
  "eorder.searchValue": "Giá trị tìm kiếm",
  "eorder.status": "Trạng thái",
  "eorder.test.name": "Tên xét nghiệm",
  "eqa.action.deactivate": "Ngừng dùng",
  "eqa.action.edit": "Sửa",
  "eqa.action.enterResults": "Nhập kết quả",
  "eqa.action.enterViewResults": "Nhập/Xem kết quả",
  "eqa.action.reactivate": "Kích hoạt lại",
  "eqa.action.viewOrder": "Xem chỉ định",
  "eqa.action.viewResults": "Xem kết quả",
  "eqa.admin.addProgram": "Thêm chương trình",
  "eqa.admin.col.actions": "Thao tác",
  "eqa.admin.col.category": "Nhóm",
  "eqa.admin.col.frequency": "Tần suất",
  "eqa.admin.col.participants": "Số đơn vị tham gia",
  "eqa.admin.col.programName": "Tên chương trình",
  "eqa.admin.col.provider": "Đơn vị tổ chức",
  "eqa.admin.delete": "Xóa",
  "eqa.admin.form.addHeading": "Thêm chương trình EQA mới",
  "eqa.admin.form.category.placeholder": "Chọn nhóm",
  "eqa.admin.form.description.placeholder": "Mô tả và mục tiêu của chương trình...",
  "eqa.admin.form.editHeading": "Sửa chương trình EQA",
  "eqa.admin.form.frequency.placeholder": "Chọn tần suất",
  "eqa.admin.form.name.placeholder": "Ví dụ: Cấy và kháng sinh đồ lao",
  "eqa.admin.form.provider.placeholder": "Tên tổ chức điều hành chương trình",
  "eqa.admin.form.subtitle": "Đăng ký tham gia một chương trình đánh giá chất lượng ngoài mới",
  "eqa.admin.programs.subtitle": "Quản lý các chương trình EQA đã đăng ký và đơn vị tổ chức",
  "eqa.admin.programs.title": "Chương trình EQA",
  "eqa.admin.provider.placeholder": "Ví dụ: WHO, CDC, CAP",
  "eqa.admin.subtitle": "Quản lý chương trình EQA",
  "eqa.admin.tab.participants": "Đơn vị tham gia",
  "eqa.admin.tab.userManagement": "Quản lý người dùng",
  "eqa.admin.tile.acrossAllPrograms": "Trên tất cả chương trình",
  "eqa.admin.tile.activePrograms": "Chương trình đang chạy",
  "eqa.admin.tile.canManageEqa": "Có quyền quản lý EQA",
  "eqa.admin.tile.enrolledParticipants": "Đơn vị đã đăng ký",
  "eqa.admin.tile.systemUsers": "Người dùng hệ thống",
  "eqa.admin.tile.totalParticipants": "Tổng số đơn vị tham gia",
  "eqa.admin.tile.totalPrograms": "{count} chương trình",
  "eqa.admin.title": "Quản trị chương trình",
  "eqa.admin.userManagement.placeholder": "Quản lý người dùng sẽ có sau.",
  "eqa.column.actions": "Thao tác",
  "eqa.deadline.label": "Hạn chót xét nghiệm",
  "eqa.distribution.action.continue": "Tiếp tục",
  "eqa.distribution.action.ship": "Gửi đi",
  "eqa.distribution.action.track": "Theo dõi",
  "eqa.distribution.action.viewReport": "Xem báo cáo",
  "eqa.distribution.advance": "Chuyển trạng thái",
  "eqa.distribution.backToDashboard": "Quay lại danh sách phân phối",
  "eqa.distribution.barcodes": "Tạo mã vạch",
  "eqa.distribution.col.actions": "Thao tác",
  "eqa.distribution.col.deadline": "Hạn chót",
  "eqa.distribution.col.participants": "Đơn vị tham gia",
  "eqa.distribution.col.program": "Chương trình",
  "eqa.distribution.col.responses": "Phản hồi",
  "eqa.distribution.col.round": "Đợt",
  "eqa.distribution.col.samples": "Mẫu",
  "eqa.distribution.col.shipmentId": "Mã lô gửi",
  "eqa.distribution.col.status": "Trạng thái",
  "eqa.distribution.create": "Tạo phân phối",
  "eqa.distribution.createError": "Không tạo được phân phối.",
  "eqa.distribution.createShipment": "Tạo lô gửi mới",
  "eqa.distribution.createSuccess": "Đã tạo phân phối.",
  "eqa.distribution.dashboard.subtitle": "Phân phối mẫu EQA cho các phòng xét nghiệm tham gia",
  "eqa.distribution.dashboard.title": "Phân phối EQA",
  "eqa.distribution.deadline": "Hạn nộp kết quả",
  "eqa.distribution.detail.title": "Chi tiết phân phối",
  "eqa.distribution.empty": "Không tìm thấy phân phối nào",
  "eqa.distribution.filter.allShipments": "Tất cả lô gửi",
  "eqa.distribution.filter.program": "Lọc theo chương trình",
  "eqa.distribution.filter.status": "Lọc theo trạng thái",
  "eqa.distribution.list.title": "Phân phối EQA",
  "eqa.distribution.manageParticipants": "Quản lý đơn vị tham gia",
  "eqa.distribution.name": "Tên phân phối",
  "eqa.distribution.name.placeholder": "Ví dụ: Đợt 1 - Sinh hóa 2026",
  "eqa.distribution.network.active": "Đơn vị đang tham gia",
  "eqa.distribution.network.active.sub": "Đang đăng ký",
  "eqa.distribution.network.responseRate": "Tỷ lệ phản hồi trung bình",
  "eqa.distribution.network.responseRate.sub": "4 quý gần nhất",
  "eqa.distribution.network.subtitle": "Tổng quan các phòng xét nghiệm tham gia đã đăng ký",
  "eqa.distribution.network.title": "Mạng lưới đơn vị tham gia",
  "eqa.distribution.network.total": "Tổng số đơn vị tham gia",
  "eqa.distribution.network.total.sub": "Trên tất cả quốc gia",
  "eqa.distribution.participants": "Tổ chức tham gia",
  "eqa.distribution.participants.min": "Cần ít nhất 2 tổ chức tham gia",
  "eqa.distribution.participants.none": "Chưa có phòng xét nghiệm nào đang đăng ký tham gia chương trình này.",
  "eqa.distribution.participants.select": "Chọn tổ chức",
  "eqa.distribution.program": "Chương trình EQA",
  "eqa.distribution.program.select": "Chọn một chương trình",
  "eqa.distribution.responseRate": "tỷ lệ phản hồi",
  "eqa.distribution.shipments.subtitle": "Theo dõi mẫu EQA đã phân phối và phản hồi của đơn vị tham gia",
  "eqa.distribution.shipments.title": "Lô gửi EQA",
  "eqa.distribution.shipped": "Đã gửi",
  "eqa.distribution.status.completed": "Hoàn thành",
  "eqa.distribution.status.draft": "Nháp",
  "eqa.distribution.status.prepared": "Đã chuẩn bị",
  "eqa.distribution.status.shipped": "Đã gửi",
  "eqa.distribution.step.confirmation": "Xác nhận",
  "eqa.distribution.step.details": "Chương trình & chi tiết",
  "eqa.distribution.step.participants": "Đơn vị tham gia",
  "eqa.distribution.summary.completed": "Hoàn thành",
  "eqa.distribution.summary.completed.sub": "Đã nhận đủ phản hồi",
  "eqa.distribution.summary.draft": "Lô gửi nháp",
  "eqa.distribution.summary.draft.sub": "Đang chuẩn bị",
  "eqa.distribution.summary.participants": "Đơn vị tham gia",
  "eqa.distribution.summary.participants.sub": "Đã đăng ký",
  "eqa.distribution.summary.shipped": "Đã gửi",
  "eqa.distribution.summary.shipped.sub": "Chờ phản hồi",
  "eqa.enrollment.allStatuses": "Tất cả trạng thái",
  "eqa.enrollment.alreadyEnrolled": "Đã đăng ký",
  "eqa.enrollment.alreadyEnrolledCount": "{count} tổ chức đã đăng ký",
  "eqa.enrollment.confirmWithdraw": "Xác nhận rút đăng ký",
  "eqa.enrollment.created.success": "Đã tạo đăng ký chương trình",
  "eqa.enrollment.deactivated": "Đã ngừng đăng ký chương trình",
  "eqa.enrollment.description": "Mô tả",
  "eqa.enrollment.district": "Quận/Huyện",
  "eqa.enrollment.editing": "Đang sửa: {name}",
  "eqa.enrollment.empty": "Chưa có đăng ký nào cho chương trình này",
  "eqa.enrollment.enroll": "Đăng ký",
  "eqa.enrollment.enrollParticipant": "Đăng ký đơn vị tham gia",
  "eqa.enrollment.enrollSelected": "Đăng ký các mục đã chọn",
  "eqa.enrollment.enrollmentDate": "Ngày đăng ký",
  "eqa.enrollment.error": "Chưa lưu được đăng ký. Vui lòng thử lại.",
  "eqa.enrollment.labUnits": "Nhóm xét nghiệm",
  "eqa.enrollment.new": "Đăng ký chương trình EQA mới",
  "eqa.enrollment.organizationCode": "Mã tổ chức",
  "eqa.enrollment.organizationName": "Tên tổ chức",
  "eqa.enrollment.panels": "Bộ xét nghiệm",
  "eqa.enrollment.programName": "Tên chương trình",
  "eqa.enrollment.programName.placeholder": "Nhập tên chương trình",
  "eqa.enrollment.provider": "Đơn vị tổ chức",
  "eqa.enrollment.provider.placeholder": "Nhập tên đơn vị tổ chức",
  "eqa.enrollment.reactivate": "Kích hoạt lại",
  "eqa.enrollment.reactivated": "Đã kích hoạt lại đăng ký chương trình",
  "eqa.enrollment.save": "Lưu đăng ký",
  "eqa.enrollment.saveChanges": "Lưu thay đổi",
  "eqa.enrollment.searchOrgs": "Tìm tổ chức...",
  "eqa.enrollment.searchPlaceholder": "Tìm theo tên hoặc mã tổ chức...",
  "eqa.enrollment.selectLabUnits": "Chọn nhóm xét nghiệm...",
  "eqa.enrollment.selectOrg": "Chọn một tổ chức...",
  "eqa.enrollment.selectOrgsPrompt": "Chọn tổ chức để đăng ký",
  "eqa.enrollment.selectPanels": "Chọn bộ xét nghiệm...",
  "eqa.enrollment.selectProgram": "Chọn chương trình",
  "eqa.enrollment.selectProgramPrompt": "Chọn một chương trình để xem đăng ký",
  "eqa.enrollment.selectTests": "Chọn xét nghiệm...",
  "eqa.enrollment.selected": "đã chọn",
  "eqa.enrollment.status": "Trạng thái",
  "eqa.enrollment.status.active": "Đang hoạt động",
  "eqa.enrollment.status.suspended": "Tạm ngưng",
  "eqa.enrollment.status.withdrawn": "Đã rút",
  "eqa.enrollment.success": "Đăng ký thành công",
  "eqa.enrollment.suspend": "Tạm ngưng",
  "eqa.enrollment.tests": "Xét nghiệm",
  "eqa.enrollment.thisLab": "Phòng XN này",
  "eqa.enrollment.updated.success": "Đã cập nhật đăng ký chương trình",
  "eqa.enrollment.withdraw": "Rút đăng ký",
  "eqa.enrollment.withdrawReason": "Lý do rút khỏi chương trình",
  "eqa.enrollment.withdrawReasonPlaceholder": "Nhập lý do rút đơn vị tham gia này...",
  "eqa.filter.allPriorities": "Tất cả mức ưu tiên",
  "eqa.filter.allPrograms": "Tất cả chương trình",
  "eqa.filter.allStatuses": "Tất cả trạng thái",
  "eqa.filter.eqaOnly": "Chỉ mẫu EQA",
  "eqa.filter.priority": "Ưu tiên",
  "eqa.filter.program": "Chương trình",
  "eqa.filter.status": "Trạng thái",
  "eqa.management.action.enterResults": "Nhập kết quả",
  "eqa.management.action.submit": "Gửi",
  "eqa.management.bulkUpload": "Tải lên kết quả hàng loạt",
  "eqa.management.col.accession": "Mã mẫu (SID)",
  "eqa.management.col.actions": "Thao tác",
  "eqa.management.col.deadline": "Hạn chót",
  "eqa.management.col.progress": "Tiến độ",
  "eqa.management.col.provider": "Đơn vị cung cấp/Chương trình",
  "eqa.management.col.sampleId": "Mã mẫu",
  "eqa.management.col.status": "Trạng thái",
  "eqa.management.daysLeft": "ngày còn lại",
  "eqa.management.distributions.title": "Phân phối mẫu",
  "eqa.management.filter.allSamples": "Tất cả mẫu",
  "eqa.management.overdue": "Quá hạn",
  "eqa.management.participants.subtitle": "Quản lý đăng ký tham gia chương trình EQA của đơn vị",
  "eqa.management.participants.title": "Đơn vị tham gia",
  "eqa.management.performance.onTime": "Tỷ lệ nộp đúng hạn",
  "eqa.management.performance.participation": "Tỷ lệ tham gia",
  "eqa.management.performance.participation.sub": "Đã đăng ký tất cả chương trình",
  "eqa.management.performance.subtitle": "Chỉ số hiệu năng EQA của phòng xét nghiệm",
  "eqa.management.performance.title": "Tóm tắt hiệu năng",
  "eqa.management.performance.zScore": "Z-score trung bình",
  "eqa.management.performance.zScore.sub": "Trong khoảng chấp nhận được",
  "eqa.management.programs.subtitle": "Quản lý các chương trình do phòng xét nghiệm này phân phối",
  "eqa.management.programs.title": "Chương trình EQA",
  "eqa.management.results.title": "Kết quả & Phân tích",
  "eqa.management.samples.empty": "Không tìm thấy mẫu EQA",
  "eqa.management.samples.subtitle": "Quản lý mẫu EQA đã nhận và gửi kết quả",
  "eqa.management.samples.title": "Mẫu EQA",
  "eqa.management.status.completed": "Hoàn thành",
  "eqa.management.status.completed.sub": "Sẵn sàng gửi",
  "eqa.management.status.inProgress": "Đang làm",
  "eqa.management.status.inProgress.sub": "Đang xét nghiệm",
  "eqa.management.status.in_progress": "Đang làm",
  "eqa.management.status.overdue": "Quá hạn",
  "eqa.management.status.pending": "Chờ",
  "eqa.management.status.pending.sub": "Chưa bắt đầu",
  "eqa.management.status.submitted": "Đã gửi",
  "eqa.management.status.submitted.sub": "Đã gửi kết quả",
  "eqa.management.subtitle": "Nhận và quản lý mẫu EQA từ đơn vị cung cấp bên ngoài",
  "eqa.management.title": "Quản lý EQA",
  "eqa.management.viewPerformance": "Xem hiệu năng",
  "eqa.myProgram.helperText": "Chọn đăng ký sẽ tự điền sẵn xét nghiệm và bộ xét nghiệm",
  "eqa.myProgram.label": "Đăng ký chương trình của tôi",
  "eqa.myProgram.prePopulated.subtitle": "Đã chọn sẵn {tests} xét nghiệm và {panels} bộ xét nghiệm từ đăng ký",
  "eqa.myProgram.prePopulated.title": "Đã điền sẵn xét nghiệm/bộ xét nghiệm",
  "eqa.myProgram.select": "Chọn đăng ký để điền sẵn xét nghiệm...",
  "eqa.myPrograms.action.deactivate": "Ngừng dùng",
  "eqa.myPrograms.action.edit": "Sửa",
  "eqa.myPrograms.action.reactivate": "Kích hoạt lại",
  "eqa.myPrograms.description": "Mô tả",
  "eqa.myPrograms.enrollButton": "Đăng ký chương trình",
  "eqa.myPrograms.enrollInProgram": "Đăng ký chương trình",
  "eqa.myPrograms.labUnits": "Nhóm xét nghiệm",
  "eqa.myPrograms.panels": "Bộ xét nghiệm",
  "eqa.myPrograms.programName": "Tên chương trình",
  "eqa.myPrograms.provider": "Đơn vị cung cấp",
  "eqa.myPrograms.search.placeholder": "Tìm chương trình...",
  "eqa.myPrograms.status": "Trạng thái",
  "eqa.myPrograms.status.active": "Đang dùng",
  "eqa.myPrograms.status.inactive": "Ngừng dùng",
  "eqa.myPrograms.subtitle": "Các chương trình phòng xét nghiệm này tham gia",
  "eqa.myPrograms.testMapping": "Ánh xạ xét nghiệm (không bắt buộc)",
  "eqa.myPrograms.testMappingHint": "Chọn xét nghiệm và bộ xét nghiệm để tự điền khi nhập chỉ định với chương trình này",
  "eqa.myPrograms.tests": "Xét nghiệm",
  "eqa.myPrograms.title": "Chương trình EQA của tôi",
  "eqa.order.deadline": "Hạn trả kết quả",
  "eqa.order.form.title": "Thông tin mẫu EQA",
  "eqa.order.participantId": "Mã đơn vị tham gia",
  "eqa.order.priority": "Ưu tiên EQA",
  "eqa.order.programme": "Chương trình",
  "eqa.order.provider": "Đơn vị cung cấp",
  "eqa.order.providerSampleId": "Mã mẫu của đơn vị cung cấp",
  "eqa.orders.completedThisMonth": "Hoàn thành trong tháng",
  "eqa.orders.enterNewTest": "Nhập xét nghiệm EQA mới",
  "eqa.orders.inProgress": "Đang làm",
  "eqa.orders.overdue": "Quá hạn",
  "eqa.orders.pending": "Chờ",
  "eqa.orders.search.placeholder": "Tìm theo mã mẫu hoặc chương trình...",
  "eqa.participant.id": "Mã đơn vị tham gia",
  "eqa.priority.critical": "Rất khẩn",
  "eqa.priority.label": "Ưu tiên",
  "eqa.priority.standard": "Thường",
  "eqa.priority.urgent": "Khẩn",
  "eqa.program.activate": "Kích hoạt",
  "eqa.program.active": "Đang dùng",
  "eqa.program.addProgram": "Thêm chương trình",
  "eqa.program.cancel": "Hủy",
  "eqa.program.create": "Tạo chương trình",
  "eqa.program.createTitle": "Tạo chương trình EQA",
  "eqa.program.deactivate": "Ngừng dùng",
  "eqa.program.description": "Mô tả",
  "eqa.program.description.placeholder": "Mô tả chương trình EQA...",
  "eqa.program.edit": "Sửa chương trình",
  "eqa.program.editTitle": "Sửa chương trình EQA",
  "eqa.program.empty": "Không tìm thấy chương trình EQA",
  "eqa.program.inactive": "Ngừng dùng",
  "eqa.program.label": "Chương trình EQA",
  "eqa.program.management.title": "Quản lý chương trình EQA",
  "eqa.program.name": "Tên chương trình",
  "eqa.program.name.placeholder": "VD: Thử nghiệm năng lực Sinh hóa",
  "eqa.program.name.required": "Cần nhập tên chương trình",
  "eqa.program.provider.required": "Cần chọn đơn vị cung cấp",
  "eqa.program.participantCount": "Số đơn vị đã đăng ký",
  "eqa.program.provider": "Đơn vị cung cấp",
  "eqa.program.required": "Cần chọn chương trình EQA khi đăng ký mẫu EQA",
  "eqa.program.save": "Lưu chương trình",
  "eqa.program.select": "Chọn chương trình EQA",
  "eqa.program.status": "Trạng thái",
  "eqa.program.tests": "Xét nghiệm được gán",
  "eqa.program.tests.assign": "Gán xét nghiệm",
  "eqa.program.tests.select": "Chọn xét nghiệm để gán",
  "eqa.provider.label": "Tổ chức cung cấp EQA",
  "eqa.provider.sampleId": "Mã mẫu của đơn vị cung cấp",
  "eqa.provider.select": "Chọn tổ chức cung cấp EQA",
  "eqa.results.acceptable": "Đạt",
  "eqa.results.batch.import": "Nhập hàng loạt",
  "eqa.results.col.deadline": "Hạn chót",
  "eqa.results.col.labNumber": "Mã mẫu (SID)",
  "eqa.results.col.priority": "Ưu tiên",
  "eqa.results.col.programme": "Chương trình",
  "eqa.results.col.provider": "Đơn vị cung cấp",
  "eqa.results.col.status": "Trạng thái",
  "eqa.results.import.confirm": "Xác nhận nhập",
  "eqa.results.import.errors": "{count} dòng có lỗi",
  "eqa.results.import.success": "Đã nhập thành công {count} kết quả",
  "eqa.results.import.upload": "Tải lên tệp CSV",
  "eqa.results.manual.entry": "Nhập kết quả thủ công",
  "eqa.results.mean": "Trung bình",
  "eqa.results.minimum.participants": "Cần tối thiểu 5 đơn vị tham gia để phân tích thống kê",
  "eqa.results.noResults": "Không tìm thấy kết quả xét nghiệm EQA.",
  "eqa.results.organization": "Tổ chức",
  "eqa.results.organization.select": "Chọn tổ chức",
  "eqa.results.participant.count": "Số đơn vị tham gia",
  "eqa.results.performance": "Hiệu năng",
  "eqa.results.questionable": "Cần xem xét",
  "eqa.results.report.downloading": "Đang tải báo cáo...",
  "eqa.results.report.generate": "Tạo báo cáo",
  "eqa.results.search.placeholder": "Tìm theo mã mẫu, chương trình hoặc đơn vị cung cấp...",
  "eqa.results.standardDeviation": "Độ lệch chuẩn",
  "eqa.results.statistics": "Thống kê",
  "eqa.results.submit": "Gửi kết quả",
  "eqa.results.test": "Xét nghiệm",
  "eqa.results.test.select": "Chọn xét nghiệm",
  "eqa.results.title": "Kết quả & Phân tích EQA",
  "eqa.results.unacceptable": "Không đạt",
  "eqa.results.value": "Giá trị kết quả",
  "eqa.results.zscore": "Z-score",
  "eqa.sample.badge": "EQA",
  "eqa.sample.checkbox": "Mẫu EQA",
  "eqa.sample.checkbox.helper": "Đánh dấu nếu đây là mẫu Đánh giá chất lượng ngoài (EQA)",
  "eqa.sample.demographics.disabled": "Thông tin nhân khẩu bị tắt với mẫu EQA",
  "eqa.sample.patient.readonly.body": "Các trường thông tin bệnh nhân được tự động đặt cho mẫu EQA và không thể sửa.",
  "eqa.sample.patient.readonly.title": "Mẫu EQA — Thông tin bệnh nhân đã khóa",
  "eqa.section.title": "Chi tiết mẫu EQA",
  "eqa.status.active": "Đang dùng",
  "eqa.status.completed": "Hoàn thành",
  "eqa.status.inProgress": "Đang làm",
  "eqa.status.inactive": "Ngừng dùng",
  "eqa.status.inprogress": "Đang làm",
  "eqa.status.overdue": "Quá hạn",
  "eqa.status.pending": "Chờ",
  "eqa.submission.audit": "Nhật ký gửi kết quả",
  "eqa.submission.date": "Ngày gửi",
  "eqa.submission.error": "Gửi thất bại",
  "eqa.submission.fhir": "Gửi qua FHIR",
  "eqa.submission.fhir.description": "Gửi kết quả cho đơn vị EQA bên ngoài qua FHIR R4",
  "eqa.submission.late.approve": "Duyệt gửi muộn",
  "eqa.submission.late.justification": "Lý do gửi muộn",
  "eqa.submission.late.justification.placeholder": "Nêu lý do gửi muộn...",
  "eqa.submission.late.supervisor": "Mã người dùng giám sát",
  "eqa.submission.late.warning": "Đã quá hạn gửi. Cần giám sát viên duyệt.",
  "eqa.submission.method": "Phương thức gửi",
  "eqa.submission.success": "Đã gửi kết quả thành công",
  "eqa.submission.title": "Gửi kết quả",
  "eqa.tests.action.enterResults": "Nhập kết quả",
  "eqa.tests.action.viewOrder": "Xem chỉ định",
  "eqa.tests.action.viewResults": "Xem kết quả",
  "eqa.tests.dateEntered": "Ngày nhập",
  "eqa.tests.deadline": "Hạn chót",
  "eqa.tests.enterNew": "Nhập xét nghiệm EQA mới",
  "eqa.tests.labNumber": "Mã mẫu (SID)",
  "eqa.tests.orders.subtitle": "Chỉ định thử nghiệm năng lực cho phòng xét nghiệm này",
  "eqa.tests.orders.title": "Chỉ định EQA",
  "eqa.tests.priority": "Ưu tiên",
  "eqa.tests.program": "Chương trình EQA",
  "eqa.tests.provider": "Đơn vị cung cấp",
  "eqa.tests.searchPlaceholder": "Tìm theo mã mẫu, chương trình hoặc đơn vị cung cấp...",
  "eqa.tests.status": "Trạng thái",
  "eqa.tests.status.completed": "Hoàn thành",
  "eqa.tests.status.inProgress": "Đang làm",
  "eqa.tests.status.overdue": "Quá hạn",
  "eqa.tests.status.pending": "Chờ",
  "eqa.tests.summary.completedThisMonth": "Hoàn thành trong tháng",
  "eqa.tests.summary.inProgress": "Đang làm",
  "eqa.tests.summary.overdue": "Quá hạn",
  "eqa.tests.summary.pending": "Chờ",
  "eqa.validation.deadline.required": "Cần nhập hạn chót xét nghiệm",
  "eqa.validation.program.required": "Cần chọn chương trình EQA",
  "eqa.validation.provider.required": "Cần chọn tổ chức cung cấp EQA",
  "error.add.edited.msg": "Lỗi khi sửa/thêm",
  "error.barcode.dimension.positive": "Kích thước nhãn phải là số dương",
  "error.barcode.labelcount.default.lte.max": "Số nhãn mặc định không được vượt mức tối đa cho loại nhãn này",
  "error.delete.msg": "Lỗi khi xóa",
  "error.duplicate.calculationname": "Trùng tên phép tính hoặc lỗi khi lưu",
  "error.fetch.boxDetails": "Không tải được chi tiết hộp",
  "error.fetch.boxes": "Không tải được danh sách hộp gửi",
  "error.fetch.facilities": "Không tải được danh sách cơ sở",
  "error.fetch.unassignedSamples": "Không tải được mẫu chưa gán",
  "error.field.required": "Trường này là bắt buộc",
  "error.import.patient": "Lỗi khi nhập bệnh nhân vào OpenELIS",
  "error.invalid.email": "Email không hợp lệ",
  "error.invalidcredentials": "Tên đăng nhập hoặc mật khẩu không đúng",
  "error.locale.format": "Định dạng không hợp lệ. Dùng: en, fr, es hoặc en-US, fr-CA, v.v.",
  "error.no.patient.data": "Không có dữ liệu bệnh nhân để nhập",
  "error.nonconform.report": "Vui lòng nhập giá trị",
  "error.report.csv.date": "Vui lòng chọn loại ngày.",
  "error.report.csv.study": "Vui lòng chọn loại nghiên cứu.",
  "error.report.status": "Lỗi khi tạo báo cáo",
  "error.report.linkIncomplete": "Liên kết không cho biết {0} nào cần mở nên không thể hiển thị báo cáo. Hãy chọn từ danh sách báo cáo.",
  "error.report.linkIncomplete.title": "Liên kết báo cáo này không đầy đủ",
  "error.required.destination": "Cần nhập cơ sở đích",
  "error.results.loadFailed": "Không tải được danh sách công việc kết quả",
  "error.results.loadFailed.detail": "Đây không phải danh sách trống — yêu cầu đã lỗi nên các công việc đang chờ ở đây không hiển thị. Thử lại, và báo quản trị viên nếu vẫn lỗi.",
  "error.results.precision": "Xét nghiệm này báo cáo với {0} chữ số thập phân. Nhập giá trị đúng số lẻ này, nếu không bản ghi và giá trị báo cáo sẽ khác nhau.",
  "error.results.staleSave": "Kết quả này đã được {0} cập nhật lúc {1} — làm mới để xem giá trị mới nhất",
  "error.results.save.noResponse": "Kết quả chưa được lưu vì máy chủ không phản hồi. Kiểm tra kết nối và thử lại.",
  "error.order.staleSave": "Chỉ định này đã được {0} cập nhật lúc {1}. Làm mới để xem phiên bản mới nhất, rồi thực hiện thay đổi lại.",
  "error.patient.staleSave": "Bệnh nhân này đã được {0} cập nhật lúc {1}. Làm mới để xem phiên bản mới nhất, rồi thực hiện thay đổi lại.",
  "error.testCatalog.staleSave": "Xét nghiệm này đã được {0} cập nhật lúc {1}. Làm mới để xem phiên bản mới nhất, rồi thực hiện thay đổi lại.",
  "error.testCatalog.storage.invalidField": "{field}: giá trị này không được chấp nhận. Chọn một điều kiện có trong danh sách, nhập thời hạn từ 0 trở lên và giữ văn bản trong giới hạn độ dài.",
  "error.staleSave.section": "Có người khác đã thay đổi mục này sau khi bạn mở. Chưa có gì được lưu. Làm mới để xem phiên bản mới nhất, rồi thực hiện thay đổi lại.",
  "error.load.failed": "Không tải được danh sách này. Tải lại để thử lần nữa.",
  "error.save.failed": "Lưu thất bại",
  "error.save.msg": "Lỗi khi lưu",
  "error.save.order": "Lỗi khi lưu chỉ định",
  "error.save.patient": "Lỗi khi lưu bệnh nhân",
  "error.title": "Lỗi",
  "errorBoundary.reload": "Tải lại",
  "errorBoundary.route.patientResultsViewer.message": "Đã xảy ra lỗi khi hiển thị kết quả của bệnh nhân này. Tải lại để thử lần nữa.",
  "errorBoundary.route.patientResultsViewer.title": "Không tải được kết quả bệnh nhân",
  "errorBoundary.route.resultsSearch.message": "Đã xảy ra lỗi ở trang kết quả. Tải lại để thử lần nữa.",
  "errorBoundary.route.resultsSearch.title": "Không tải được kết quả",
  "errorBoundary.route.modifyOrder.message": "Đã xảy ra lỗi ở trang sửa chỉ định. Tải lại để thử lần nữa.",
  "errorBoundary.route.modifyOrder.title": "Không tải được trang sửa chỉ định",
  "errorBoundary.route.orderEntry.message": "Đã xảy ra lỗi ở trang nhập chỉ định. Tải lại để thử lần nữa.",
  "errorBoundary.route.orderEntry.title": "Không tải được trang nhập chỉ định",
  "errorBoundary.route.samplePatientEntry.message": "Đã xảy ra lỗi ở trang nhập mẫu. Tải lại để thử lần nữa.",
  "errorBoundary.route.samplePatientEntry.title": "Không tải được trang nhập mẫu",
  "errorBoundary.route.storage.message": "Đã xảy ra lỗi ở trang này. Tải lại để thử lần nữa, hoặc dùng menu để chuyển sang trang khác.",
  "errorBoundary.route.storage.title": "Không tải được trang lưu trữ",
  "errorBoundary.route.analyzers.message": "Đã xảy ra lỗi khi tải trang này. Tải lại để thử lần nữa.",
  "errorBoundary.route.analyzers.title": "Không tải được module máy xét nghiệm",
  "errorBoundary.route.analyzerResults.message": "Đã xảy ra lỗi khi tải kết quả. Tải lại để thử lần nữa.",
  "errorBoundary.route.analyzerResults.title": "Không tải được kết quả máy xét nghiệm",
  "serverReconnect.title": "Không kết nối được máy chủ",
  "serverReconnect.retryIn": "Sẽ thử lại sau {seconds} giây",
  "serverReconnect.trying": "Đang thử lại ngay…",
  "serverReconnect.tryNow": "Thử ngay",
  "errors.no.sample": "Chọn mẫu phù hợp cho từng xét nghiệm.",
  "errors.requester.org.or.requestor.required": "Nhập ít nhất một trong hai: Cơ sở chỉ định hoặc Liên hệ người chỉ định.",
  "esig.button.certify": "Xác nhận & Tiếp tục",
  "esig.button.reject": "Từ chối",
  "esig.button.saveAndSign": "Lưu",
  "esig.button.saveModification": "Lưu",
  "esig.button.sign": "Ký",
  "esig.button.validate": "Duyệt",
  "esig.certification.acknowledge": "Tôi đã đọc và hiểu nội dung cam kết trên",
  "esig.certification.intro": "Trước khi sử dụng chữ ký điện tử, bạn phải xác nhận rằng chữ ký điện tử có giá trị pháp lý tương đương chữ ký tay.",
  "esig.error.disabled": "Chữ ký điện tử chưa được bật",
  "esig.error.generic": "Đã xảy ra lỗi",
  "esig.error.invalidCredentials": "Thông tin đăng nhập không hợp lệ",
  "esig.error.keycloakNotSupported": "Xác thực Keycloak chưa hỗ trợ chữ ký điện tử",
  "esig.error.loadingStatus": "Không tải được trạng thái chữ ký",
  "esig.error.mustAcknowledge": "Bạn phải xác nhận nội dung cam kết",
  "esig.error.passwordRequired": "Cần nhập mật khẩu",
  "esig.error.rejectionReasonRequired": "Cần nhập lý do từ chối",
  "esig.error.title": "Lỗi",
  "esig.error.usernameRequired": "Cần nhập tên đăng nhập",
  "esig.info.fullAuth": "Đây là chữ ký đầu tiên trong phiên này. Vui lòng nhập tên đăng nhập và mật khẩu để xác thực.",
  "esig.info.legalBinding": "Khi nhập thông tin đăng nhập, bạn tạo một chữ ký điện tử có giá trị pháp lý theo 21 CFR Part 11.",
  "esig.info.passwordOnly": "Bạn đang có phiên ký còn hiệu lực. Nhập mật khẩu để tiếp tục.",
  "esig.label.context": "Thao tác:",
  "esig.label.meaning": "Ý nghĩa chữ ký:",
  "esig.label.password": "Mật khẩu",
  "esig.label.rejectionReason": "Lý do từ chối",
  "esig.label.signingAs": "Ký với tư cách: {userName}",
  "esig.label.username": "Tên đăng nhập",
  "esig.meaning.authored": "Đã tạo",
  "esig.meaning.modified": "Đã sửa",
  "esig.meaning.rejected": "Đã từ chối",
  "esig.meaning.validatedAndReleased": "Đã duyệt và phát hành",
  "esig.placeholder.password": "Nhập mật khẩu để xác nhận",
  "esig.placeholder.rejectionReason": "Nhập lý do từ chối",
  "esig.placeholder.username": "Nhập tên đăng nhập",
  "esig.title.certification": "Xác nhận chữ ký điện tử",
  "esig.title.signature": "Chữ ký điện tử",
  "example": "Ví dụ",
  "external.id": "Mã bên ngoài",
  "external.referrals.report": "Báo cáo gửi mẫu ra ngoài",
  "externalReferredOutTests.title": "Báo cáo gửi mẫu ra ngoài",
  "externalconnections.active": "Đang dùng",
  "externalconnections.add.title": "Thêm kết nối bên ngoài",
  "externalconnections.authtype": "Kiểu xác thực",
  "externalconnections.authtype.basic.password": "Mật khẩu",
  "externalconnections.authtype.basic.username": "Tên đăng nhập",
  "externalconnections.browse.title": "Kết nối bên ngoài",
  "externalconnections.deactivate.success": "Đã ngừng dùng kết nối bên ngoài thành công.",
  "externalconnections.description": "Mô tả",
  "externalconnections.edit.title": "Sửa kết nối bên ngoài",
  "externalconnections.name": "Tên",
  "externalconnections.name.placeholder": "Nhập tên kết nối",
  "externalconnections.programmedconnection": "Loại kết nối",
  "externalconnections.save.success": "Đã lưu kết nối bên ngoài thành công.",
  "externalconnections.search": "Tìm kết nối bên ngoài",
  "externalconnections.search.placeholder": "Tìm theo tên hoặc loại",
  "externalconnections.select": "Chọn",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "VD: https://máy-chủ:cổng",
  "false.label": "Sai",
  "field.active": "Đang dùng/Không dùng",
  "field.ageRange": "Khoảng tuổi",
  "field.dictionaryValues": "Giá trị từ điển",
  "field.loinc": "Loinc",
  "field.name": "Tên",
  "field.normalRange": "Khoảng bình thường",
  "field.note": "Ghi chú",
  "field.orderable": "Cho phép chỉ định/Không cho phép",
  "field.panel": "Bộ xét nghiệm",
  "field.referenceValue": "Giá trị tham chiếu",
  "field.reportName": "Tên báo cáo",
  "field.resultLimits": "Giới hạn kết quả",
  "field.resultType": "Kiểu kết quả",
  "field.sampleType": "Loại mẫu",
  "field.select.testSection": "Chọn nhóm xét nghiệm",
  "field.selectValues": "Chọn giá trị",
  "field.sex": "Giới tính",
  "field.significantDigits": "Chữ số có nghĩa",
  "field.testSection": "Nhóm xét nghiệm",
  "field.testUnit": "Đơn vị xét nghiệm",
  "field.uom": "Đơn vị đo",
  "field.validRange": "Khoảng hợp lệ",
  "file.import.configuration.active": "Đang dùng",
  "file.import.configuration.analyzer": "Máy xét nghiệm",
  "file.import.configuration.analyzer.emptyState": "Chưa cài plugin nhập tệp nào",
  "file.import.configuration.analyzer.placeholder": "Chọn máy xét nghiệm",
  "file.import.configuration.cancel": "Hủy",
  "file.import.configuration.columnMappings": "Ánh xạ cột",
  "file.import.configuration.columnMappings.helperText": "Ánh xạ JSON từ cột CSV sang trường OpenELIS (VD: {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Ký tự phân cách",
  "file.import.configuration.delimiter.helperText": "Ký tự phân cách CSV (mặc định: dấu phẩy)",
  "file.import.configuration.error.save": "Lưu cấu hình nhập tệp thất bại",
  "file.import.configuration.error.unknown": "Đã xảy ra lỗi không xác định",
  "file.import.configuration.fileFormat": "Định dạng tệp",
  "file.import.configuration.fileFormat.placeholder": "Chọn định dạng tệp",
  "file.import.configuration.filePattern": "Mẫu tên tệp",
  "file.import.configuration.filePattern.helperText": "Mẫu glob để khớp tên tệp (VD: *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Có dòng tiêu đề",
  "file.import.configuration.importDirectory": "Thư mục nhập",
  "file.import.configuration.importDirectory.helperText": "Thư mục theo dõi tệp mới",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Lưu",
  "file.import.configuration.success.created": "Đã tạo cấu hình nhập tệp thành công",
  "file.import.configuration.success.updated": "Đã cập nhật cấu hình nhập tệp thành công",
  "file.import.configuration.title.add": "Thêm cấu hình nhập tệp",
  "file.import.configuration.title.edit": "Sửa cấu hình nhập tệp",
  "file.import.configuration.validation.analyzerId.required": "Cần chọn máy xét nghiệm",
  "file.import.configuration.validation.columnMappings.invalid": "Định dạng JSON của ánh xạ cột không hợp lệ",
  "file.import.configuration.validation.importDirectory.required": "Cần nhập thư mục nhập",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Bộ lọc",
  "freezer.alert.detail.acknowledge": "Xác nhận đã biết",
  "freezer.alert.detail.acknowledgedAt": "Xác nhận lúc",
  "freezer.alert.detail.acknowledgedBy": "Xác nhận bởi",
  "freezer.alert.detail.acknowledgmentNotes": "Ghi chú xác nhận",
  "freezer.alert.detail.actions": "Hành động đã thực hiện",
  "freezer.alert.detail.close": "Đóng",
  "freezer.alert.detail.correctiveAction": "Hành động khắc phục",
  "freezer.alert.detail.correctiveActionDescription": "Mô tả",
  "freezer.alert.detail.correctiveActionFailed": "Ghi hành động khắc phục thất bại",
  "freezer.alert.detail.correctiveActionType": "Loại hành động",
  "freezer.alert.detail.delete": "Xóa cảnh báo",
  "freezer.alert.detail.deleteConfirm": "Xóa vĩnh viễn cảnh báo này?",
  "freezer.alert.detail.deleteFailed": "Xóa cảnh báo thất bại",
  "freezer.alert.detail.deletePermanently": "Xóa vĩnh viễn",
  "freezer.alert.detail.deleteWarning": "Thời điểm bắt đầu, mức độ, xác nhận và ghi chú sẽ bị xóa mà không có nhật ký kiểm toán và không thể khôi phục.",
  "freezer.alert.detail.freezer": "Tủ lạnh/tủ đông",
  "freezer.alert.detail.id": "Mã cảnh báo",
  "freezer.alert.detail.logCorrectiveAction": "Ghi hành động khắc phục",
  "freezer.alert.detail.message": "Nội dung",
  "freezer.alert.detail.method": "Phương thức",
  "freezer.alert.detail.notes": "Ghi chú",
  "freezer.alert.detail.notesPlaceholder": "Thêm ghi chú về cảnh báo này...",
  "freezer.alert.detail.notifications": "Thông báo đã gửi",
  "freezer.alert.detail.overview": "Tổng quan cảnh báo",
  "freezer.alert.detail.recipient": "Người nhận",
  "freezer.alert.detail.resolutionNotes": "Ghi chú xử lý",
  "freezer.alert.detail.resolve": "Xử lý xong",
  "freezer.alert.detail.resolvedAt": "Xử lý lúc",
  "freezer.alert.detail.resolvedBy": "Xử lý bởi",
  "freezer.alert.detail.sentAt": "Gửi lúc",
  "freezer.alert.detail.severity": "Mức độ",
  "freezer.alert.detail.startTime": "Thời điểm bắt đầu",
  "freezer.alert.detail.status": "Trạng thái",
  "freezer.alert.detail.summary": "Tóm tắt",
  "freezer.alert.detail.takenAt": "Thực hiện lúc",
  "freezer.alert.detail.takenBy": "Thực hiện bởi",
  "freezer.alert.detail.title": "Chi tiết cảnh báo",
  "freezer.alert.severity.critical": "Nghiêm trọng",
  "freezer.alert.severity.warning": "Cảnh báo",
  "freezer.alert.status.acknowledged": "Đã xác nhận",
  "freezer.alert.status.closed": "Đã đóng",
  "freezer.alert.status.escalated": "Đã chuyển cấp",
  "freezer.alert.status.open": "Đang mở",
  "freezer.alert.status.resolved": "Đã xử lý",
  "freezer.nav.corrective": "Hành động khắc phục",
  "freezer.nav.corrective.tooltip": "Quản lý hành động khắc phục",
  "freezer.nav.dashboard": "Bảng điều khiển",
  "freezer.nav.dashboard.tooltip": "Xem bảng giám sát bảo quản lạnh",
  "freezer.nav.reports": "Báo cáo",
  "freezer.nav.reports.tooltip": "Tạo báo cáo bảo quản lạnh",
  "freezer.nav.settings": "Cài đặt",
  "freezer.nav.settings.tooltip": "Cấu hình cài đặt bảo quản lạnh",
  "freezer.nav.trends": "Xu hướng lịch sử",
  "freezer.nav.trends.tooltip": "Xem xu hướng nhiệt độ theo thời gian",
  "french.current": "Tiếng Pháp hiện tại",
  "french.label": "Tiếng Pháp",
  "from.title": "Từ",
  "genericSample.edit.success": "Đã cập nhật mẫu thành công",
  "genericSample.edit.success.accession": "Mã mẫu: {accessionNumber}",
  "genericSample.edit.title": "Sửa mẫu",
  "genericSample.field.by": "Bởi",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Ngày",
  "genericSample.field.from": "Từ",
  "genericSample.field.id": "Mã",
  "genericSample.field.labPersonReceived": "Người nhận mẫu tại phòng XN",
  "genericSample.field.project": "Dự án",
  "genericSample.field.storageLocation": "Tủ lạnh # & vị trí lưu",
  "genericSample.field.type": "Loại",
  "genericSample.notebook.selection.title": "Chọn sổ ghi chép (không bắt buộc)",
  "genericSample.order.error.labNoRequired": "Vui lòng tạo số lab trước khi lưu.",
  "genericSample.order.generateLabNo": "Tạo số lab",
  "genericSample.order.labNo.placeholder": "Nhấn 'Tạo số lab' để tạo",
  "genericSample.order.success.details": "Chi tiết mẫu",
  "genericSample.order.success.message": "Đã tạo chỉ định mẫu thành công với mã mẫu: {accessionNumber}",
  "genericSample.order.title": "Nhận mẫu",
  "gps.accuracy.display": "Độ chính xác ±{accuracy}m",
  "gps.accuracy.warning.message": "Độ chính xác GPS là {accuracy}m, vượt ngưỡng yêu cầu {required}m. Hãy thử lấy lại vị trí ở chỗ thoáng hơn.",
  "gps.accuracy.warning.title": "Cảnh báo độ chính xác GPS",
  "gps.button.clear": "Xóa",
  "gps.button.getting.location": "Đang lấy vị trí...",
  "gps.button.location.captured": "Đã lấy vị trí",
  "gps.button.use.my.location": "Dùng vị trí của tôi",
  "gps.collapse": "Thu gọn mục GPS",
  "gps.config.accuracy.helper": "Độ chính xác GPS tối đa chấp nhận được, tính bằng mét. Đặt 0 để tắt kiểm tra độ chính xác.",
  "gps.config.accuracy.label": "Độ chính xác yêu cầu (mét)",
  "gps.config.enabled.description": "Khi bật, các trường tọa độ GPS sẽ xuất hiện trong quy trình Nhập chỉ định để ghi vị trí lấy mẫu.",
  "gps.config.enabled.label": "Bật tọa độ GPS",
  "gps.config.error.load": "Không tải được cấu hình GPS",
  "gps.config.save.error": "Không lưu được cấu hình GPS",
  "gps.config.save.success": "Đã lưu cấu hình GPS thành công",
  "gps.config.saving": "Đang lưu...",
  "gps.config.section.general": "Cài đặt GPS",
  "gps.config.timeout.helper": "Thời gian tối đa chờ lấy vị trí GPS, tính bằng giây.",
  "gps.config.timeout.label": "Thời gian chờ (giây)",
  "gps.config.title": "Cấu hình tọa độ GPS",
  "gps.config.unsaved.changes": "Bạn có thay đổi chưa lưu. Chắc chắn muốn rời trang?",
  "gps.config.unsaved.subtitle": "Nhớ lưu thay đổi trước khi rời trang.",
  "gps.config.unsaved.title": "Thay đổi chưa lưu",
  "gps.config.validation.accuracy.negative": "Độ chính xác yêu cầu không được âm",
  "gps.config.validation.accuracy.too.high": "Độ chính xác yêu cầu không được vượt 10.000 mét",
  "gps.config.validation.timeout.too.high": "Thời gian chờ không được vượt 120 giây",
  "gps.config.validation.timeout.too.low": "Thời gian chờ tối thiểu là 1 giây",
  "gps.coordinates.captured.via": "Lấy qua {method}",
  "gps.coordinates.current": "Tọa độ hiện tại",
  "gps.error.not.supported": "Trình duyệt này không hỗ trợ GPS",
  "gps.error.permission.denied": "Quyền truy cập GPS bị từ chối. Vui lòng bật quyền vị trí và thử lại.",
  "gps.error.position.unavailable": "Không lấy được vị trí GPS. Vui lòng kiểm tra cài đặt vị trí của thiết bị.",
  "gps.error.timeout": "Yêu cầu GPS quá thời gian. Vui lòng thử lại.",
  "gps.error.title": "Lỗi GPS",
  "gps.error.unknown": "Đã xảy ra lỗi GPS không xác định. Vui lòng thử lại.",
  "gps.info.description": "Tọa độ GPS ghi lại vị trí địa lý nơi lấy mẫu. Điều này hỗ trợ giám sát dịch tễ và lập bản đồ bệnh.",
  "gps.info.title": "Tọa độ GPS",
  "gps.latitude.helper": "Độ Bắc (+) hoặc Nam (-), trong khoảng -90 đến 90",
  "gps.latitude.invalid": "Vĩ độ phải nằm trong khoảng -90 đến 90 độ",
  "gps.latitude.label": "Vĩ độ",
  "gps.latitude.placeholder": "VD: -1.286389",
  "gps.longitude.helper": "Độ Đông (+) hoặc Tây (-), trong khoảng -180 đến 180",
  "gps.longitude.invalid": "Kinh độ phải nằm trong khoảng -180 đến 180 độ",
  "gps.longitude.label": "Kinh độ",
  "gps.longitude.placeholder": "VD: 36.817223",
  "gps.manual.entry.off": "Tắt",
  "gps.manual.entry.on": "Bật",
  "gps.manual.entry.title": "Nhập tọa độ thủ công",
  "gps.manual.entry.toggle": "Nhập tọa độ thủ công",
  "gps.not.captured": "Chưa lấy",
  "gps.section.description": "Ghi lại vị trí địa lý nơi lấy mẫu để theo dõi dịch tễ",
  "gps.section.title": "Vị trí lấy mẫu (GPS)",
  "gps.status.captured": "Đã lấy",
  "gps.status.optional": "Không bắt buộc",
  "gps.tile.collapse": "Thu gọn mục GPS",
  "gps.tile.expand": "Mở rộng để thêm tọa độ GPS",
  "gps.warning.partial.coordinates": "Cần nhập cả vĩ độ và kinh độ để có vị trí hợp lệ.",
  "header.ID": "Mã",
  "header.assign": "Gán",
  "header.cancel.test": "Hủy xét nghiệm",
  "header.formname": "Tên biểu mẫu",
  "header.icon.help": "Trợ giúp",
  "header.icon.lang": "Ngôn ngữ",
  "header.icon.menu.close": "Đóng menu",
  "header.icon.menu.open": "Mở menu",
  "header.icon.menu.pin": "Ghim menu",
  "header.icon.menu.unpin": "Bỏ ghim menu",
  "header.icon.notifications": "Thông báo",
  "header.icon.search": "Tìm kiếm",
  "header.icon.user": "Người dùng",
  "header.label.ARV": "ARV-ban đầu",
  "header.label.EID": "Chẩn đoán trẻ em bằng DBS-PCR",
  "header.label.changeLab": "Chọn phòng XN",
  "header.label.followup": "ARV-Theo dõi",
  "header.label.intialFollowup": "ARV --> Ban đầu-Theo dõi-VL",
  "header.label.logout": "Đăng xuất",
  "header.label.nonconformityByDate": "Báo cáo sự không phù hợp theo ngày",
  "header.label.selectLab": "Chọn phòng XN",
  "header.label.selectlocale": "Chọn ngôn ngữ",
  "header.label.specialRequest": "Yêu cầu đặc biệt",
  "header.label.study.ciexport": "Xuất tệp CSV theo ngày",
  "header.label.study.vlloadtrends": "Báo cáo xuất dữ liệu tải lượng virus",
  "header.label.version": "Phiên bản:",
  "header.reject": "Từ chối",
  "header.rejection.reason": "Lý do từ chối",
  "header.results.recorded": "Kết quả đã ghi",
  "hide.aliquoting": "Ẩn chia mẫu",
  "holder.choose.availabletest": "Chọn xét nghiệm có sẵn",
  "home.dashboard.title": "Bảng điều khiển",
  "home.label": "Bàn làm việc",
  "immunohistochemistry.label.addreport": "Thêm báo cáo",
  "immunohistochemistry.label.averageChrom": "Số tín hiệu nhiễm sắc thể 17 trung bình trên mỗi nhân",
  "immunohistochemistry.label.averageHer2": "HER2 trung bình trên mỗi nhân",
  "immunohistochemistry.label.cellIntensity": "cường độ . Điểm Allred",
  "immunohistochemistry.label.cellPercent": "% tế bào nhuộm nhân dương với",
  "immunohistochemistry.label.dashboard": "Bảng điều khiển Hóa mô miễn dịch",
  "immunohistochemistry.label.her2Assesment": "Đánh giá protein HER 2 là",
  "immunohistochemistry.label.her2Pattern": "Kiểu nhuộm CerbB2/HER 2",
  "immunohistochemistry.label.her2ScoreOf": "với điểm",
  "immunohistochemistry.label.historicalDiagnosis": "Chẩn đoán mô bệnh học",
  "immunohistochemistry.label.ihcRatio": "Tỷ lệ tín hiệu Her2/neu trên nhiễm sắc thể 17",
  "immunohistochemistry.label.ihcScore": "IHC (điểm Cerb2)",
  "immunohistochemistry.label.mibName": " MiB 1(ki-67) (Chỉ số tăng sinh): ",
  "immunohistochemistry.label.molecularType": " Phân nhóm phân tử",
  "immunohistochemistry.label.numberOfCancer": "Số nhân tế bào ung thư",
  "immunohistochemistry.label.outOf8": "trên 8",
  "immunohistochemistry.label.report": "Báo cáo",
  "immunohistochemistry.label.reports": "Báo cáo",
  "immunohistochemistry.label.review": "Chờ duyệt Hóa mô miễn dịch",
  "immunohistochemistry.label.title": "Hóa mô miễn dịch",
  "immunohistochemistry.label.tumorCells": "tế bào khối u dương tính (ngưỡng 20%)",
  "immunohistochemistry.status.completed": "Hoàn thành",
  "immunohistochemistry.status.inProgress": "Đang làm",
  "immunohistochemistry.status.readyPathologist": "Sẵn sàng cho bác sĩ giải phẫu bệnh",
  "import.autoGenerated": "Tự động tạo",
  "import.created": "Đã tạo",
  "import.error.failed": "Nhập thất bại",
  "import.error.importFile": "Không nhập được tệp",
  "import.error.selectFile": "Vui lòng chọn tệp trước",
  "import.error.validateFile": "Không kiểm tra được tệp",
  "import.error.validateFirst": "Vui lòng kiểm tra tệp trước và sửa mọi lỗi",
  "import.error.validationFailed": "Kiểm tra thất bại. Vui lòng xem các lỗi bên dưới.",
  "import.failed": "Nhập thất bại",
  "import.failedCount": "Thất bại",
  "import.header.collectionDate": "Ngày lấy mẫu",
  "import.header.errorMessage": "Thông báo lỗi",
  "import.header.field": "Trường",
  "import.header.from": "Từ",
  "import.header.labNo": "Số lab",
  "import.header.quantity": "Số lượng",
  "import.header.row": "Dòng",
  "import.header.sampleType": "Loại mẫu",
  "import.header.samplesToCreate": "Mẫu sẽ tạo",
  "import.importing": "Đang nhập...",
  "import.invalidRows": "Dòng không hợp lệ",
  "import.selectFile": "Chọn tệp",
  "import.status.invalid": "Không hợp lệ",
  "import.status.valid": "Hợp lệ",
  "import.success": "Nhập thành công",
  "import.totalRows": "Tổng số dòng",
  "import.totalSamplesToCreate": "Tổng số mẫu sẽ tạo",
  "import.uploadFile": "Tải lên tệp",
  "import.uploadFileDesc": "Tải lên tệp CSV hoặc Excel ({types})",
  "import.validRows": "Dòng hợp lệ",
  "import.validating": "Đang kiểm tra...",
  "import.validationStatus": "Trạng thái kiểm tra",
  "input.error.same.panel.type": "Đã tồn tại loại bộ xét nghiệm trùng tên. Vui lòng hủy hoặc dùng tên khác.",
  "input.placeholder.labNo": "Nhập số lab",
  "input.placeholder.patientFirstName": "Nhập tên bệnh nhân",
  "input.placeholder.patientId": "Nhập mã bệnh nhân",
  "input.placeholder.patientLastName": "Nhập họ bệnh nhân",
  "input.placeholder.prevLabNumber": "Nhập số lab trước đó",
  "input.placeholder.providerEmail": "Nhập email người chỉ định",
  "input.placeholder.providerFax": "Nhập số fax người chỉ định",
  "input.placeholder.providerWorkPhone": "Nhập số điện thoại người chỉ định",
  "input.placeholder.provisionalClinicalDiagnosis": "Nhập chẩn đoán lâm sàng sơ bộ",
  "input.placeholder.requesterFirstName": "Nhập tên người chỉ định",
  "input.placeholder.requesterLastName": "Nhập họ người chỉ định",
  "input.placeholder.searchTestName": "Tìm tên xét nghiệm tại đây",
  "input.placeholder.selectPanel": "Chọn loại bộ xét nghiệm",
  "input.placeholder.selectPriority": "Chọn mức ưu tiên",
  "input.placeholder.selectTest": "Chọn loại xét nghiệm",
  "input.placeholder.selectTestSection": "Chọn loại nhóm xét nghiệm",
  "instructions.copy.labnum": "Sao chép số lab",
  "instructions.order.entry.eqa.enabled": "Khi bật, một ô đánh dấu sẽ hiện trên màn hình Nhập chỉ định để nhân viên đánh dấu mẫu là mẫu EQA (Đánh giá chất lượng ngoài). Thông tin nhân khẩu bệnh nhân sẽ tự điền N/A và khóa.",
  "instructions.order.entry.requester": "Khi bật, Tìm người chỉ định, Tên và Họ người chỉ định sẽ là trường bắt buộc trên màn hình Thêm chỉ định. Khi tắt (mặc định), cả ba trường đều không bắt buộc.",
  "instructions.test.activation": "Xét nghiệm đang dùng: ô đánh dấu cho biết xét nghiệm đã kích hoạt. Để kích hoạt, đánh dấu ô; để ngừng, bỏ dấu. Các loại mẫu không có xét nghiệm đang dùng sẽ bị ngừng và xuống cuối, dưới mục 'Loại mẫu không dùng'. Nếu một xét nghiệm được kích hoạt, loại mẫu của nó cũng sẽ được kích hoạt.",
  "instructions.test.activation.confirm": "Kiểm tra lại các thay đổi này. Nếu đúng thì lưu. Nếu sai, dùng nút quay lại để sửa.",
  "instructions.test.activation.sort": "Thứ tự hiển thị: danh sách các loại mẫu có xét nghiệm mới kích hoạt. Sắp xếp xét nghiệm để quyết định thứ tự hiển thị trên màn hình nhập chỉ định. Có thể sắp xếp bằng cách kéo thả đến vị trí mong muốn.",
  "instructions.test.order": "Xét nghiệm có dấu tick là cho phép chỉ định, không tick thì không. Đổi tick để đổi trạng thái. Để chỉ định được khi nhận mẫu, xét nghiệm phải vừa đang dùng vừa cho phép chỉ định. Xét nghiệm đang dùng nhưng không cho phép chỉ định vẫn có thể được yêu cầu như một phản xạ xét nghiệm.",
  "invalid.json": "JSON không hợp lệ",
  "inventory.add.button": "Thêm lô mới",
  "inventory.addItem.button": "Thêm mặt hàng danh mục",
  "inventory.consume.error.noLots": "Không còn tồn kho cho {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "Không có tồn kho đã đạt QC cho {name} ({code}): {count} lô còn tồn đang chờ QC. Đánh dấu QC đạt để sử dụng.",
  "inventory.consume.error.noLotsQcFailed": "Không có tồn kho dùng được cho {name} ({code}): {count} lô còn tồn không đạt QC",
  "inventory.consume.error.noLotsQuarantined": "Không có tồn kho dùng được cho {name} ({code}): {count} lô còn tồn đang cách ly",
  "inventory.dashboard.title": "Bảng điều khiển kho",
  "inventory.export.button": "Xuất",
  "inventory.filter.all": "Tất cả",
  "inventory.filter.status": "Lọc theo trạng thái",
  "inventory.item.error.duplicateCode": "Đã có mặt hàng kho với mã \"{code}\".",
  "inventory.item.error.codeGenerationExhausted": "Không tìm được mã trống cho tiền tố \"{prefix}\". Hãy nhập mã thủ công.",
  "inventory.list.title": "Mặt hàng kho",
  "inventory.lot.error.duplicateBarcode": "Mã vạch \"{barcode}\" đã gán cho lô {lotNumber}",
  "inventory.lot.search.placeholder": "Tìm theo tên mặt hàng, số lô hoặc mã vạch",
  "inventory.metrics.expired": "Hết hạn",
  "inventory.metrics.expiringSoon": "Sắp hết hạn",
  "inventory.metrics.lowStock": "Tồn thấp",
  "inventory.metrics.totalLots": "Tổng số lô",
  "inventory.tab.catalog": "Danh mục",
  "inventory.tab.dashboard": "Bảng điều khiển",
  "inventory.tab.reports": "Báo cáo",
  "inventory.title": "Quản lý kho",
  "label.action": "Thao tác",
  "labNumber.format.current": "Định dạng hiện tại",
  "labNumber.format.new": "Định dạng mới",
  "labNumber.prefix": "Tiền tố",
  "labNumber.type": "Loại số lab",
  "labNumber.usePrefix": "Dùng tiền tố",
  "label.actions": "Thao tác",
  "label.active": "Đang dùng",
  "label.actualTestName": "Tên xét nghiệm thực tế",
  "label.add": "Thêm",
  "label.add.notification": "Thêm thông báo bật lên cho người dùng",
  "label.all": "Tất cả",
  "label.analysisNotStarted": "Chưa bắt đầu phân tích",
  "label.any": "Bất kỳ",
  "label.audittrail": "Số lab",
  "label.audittrail.Reports": "Báo cáo nhật ký kiểm toán",
  "label.audittrail.labNo.invalidaccessionnumber": "Mã mẫu không hợp lệ",
  "label.audittrail.labNo.missing": "Cần nhập số lab!",
  "label.audittrailreport.nextvisitdate": "Ngày tái khám",
  "label.audittrailreport.priority": "Ưu tiên",
  "label.audittrailreport.program": "Chương trình",
  "label.audittrailreport.receiveddate": "Ngày nhận",
  "label.audittrailreport.requestdate": "Ngày chỉ định",
  "label.audittrailreport.requester": "Người chỉ định",
  "label.audittrailreport.requester.firstname": "Tên người chỉ định",
  "label.audittrailreport.requester.lastname": "Họ người chỉ định",
  "label.audittrailreport.sitename": "Tên cơ sở",
  "label.autoFilledFromServer": "Tự điền từ máy chủ",
  "label.barcode": "Mã vạch",
  "label.barcode.labelsets": "Số bộ nhãn",
  "label.barcode.orderlabel": "Số nhãn chỉ định mỗi bộ",
  "label.barcode.specimenlabel": "Số nhãn mẫu mỗi bộ",
  "label.barcode.totallabel": "Tổng nhãn cần in",
  "label.button.action": "Thao tác",
  "label.button.add": "Thêm",
  "label.button.add.question": "Thêm câu hỏi mới",
  "label.button.cancel": "Hủy",
  "label.button.close": "Đóng",
  "label.button.changepassword": "Đổi mật khẩu",
  "label.button.clear": "Xóa",
  "label.button.confirm": "Xác nhận",
  "label.button.confirmAction": "Xác nhận thao tác",
  "label.button.confirmDelete": "Xác nhận xóa",
  "label.button.confirmTitle": "Bạn có chắc không?",
  "label.button.delete": "Xóa",
  "label.button.descritpion": "Mô tả",
  "label.button.edit": "Sửa",
  "label.button.activate": "Kích hoạt",
  "label.button.deactivate": "Ngừng dùng",
  "label.button.exit": "Thoát",
  "label.button.externalsearch": "Tìm bên ngoài",
  "label.button.field": "Trường",
  "label.button.finish": "Hoàn thành",
  "label.button.finished": "Đã hoàn thành",
  "label.button.generatePrintableVersion": "Tạo bản in",
  "label.button.import": "Nhập",
  "label.button.login": "Đăng nhập",
  "label.button.login.sso": "Đăng nhập một lần (SSO)",
  "label.button.newEntry": "Nhập mới",
  "label.button.ok": "Đồng ý",
  "label.button.previous": "Trước",
  "label.button.range": "Khoảng",
  "label.button.remove": "Gỡ",
  "label.button.remove.report": "Gỡ báo cáo",
  "label.button.remove.slide": "Gỡ lam",
  "label.button.reset": "Đặt lại",
  "label.button.sample": "Mẫu",
  "label.button.save": "Lưu",
  "label.button.saveconfig": "Lưu cấu hình",
  "label.button.search": "Tìm",
  "label.button.select": "Chọn",
  "label.button.select.pathologist": "Chọn bác sĩ giải phẫu bệnh",
  "label.button.select.status": "Chọn trạng thái",
  "label.button.select.technician": "Chọn kỹ thuật viên",
  "label.button.select.test": "Chọn xét nghiệm",
  "label.button.start": "Bắt đầu",
  "label.button.submit": "Gửi",
  "label.button.update": "Cập nhật",
  "label.button.uploadfile": "Tải lên tệp",
  "label.button.validate": "Duyệt",
  "label.button.viewReport": "Xem báo cáo",
  "label.cancel": "Hủy",
  "label.cancel.test.no.replace": "Hủy xét nghiệm cho các số lab đã chọn, không gán xét nghiệm mới",
  "label.checkedWillBeModified": "Số lab được đánh dấu sẽ bị sửa",
  "label.clear": "Xóa bộ lọc",
  "label.content": "Nội dung nhãn",
  "label.confirm": "Xác nhận",
  "label.created.samples": "Mẫu đã tạo",
  "label.critical.range": "Khoảng nguy kịch",
  "label.currentTest": "Xét nghiệm hiện tại",
  "label.days": "ngày",
  "label.default.result": "Kết quả mặc định",
  "label.delete": "Xóa",
  "label.description": "Mô tả",
  "label.edit": "Sửa",
  "label.electronic.orders": "Chỉ định điện tử",
  "label.equals": "bằng",
  "label.error": "Lỗi",
  "label.existing.methods": "Phương pháp hiện có",
  "label.existing.test.sets": "Bộ xét nghiệm hiện có",
  "label.filters.mycases": "Ca của tôi",
  "label.filters.status": "Trạng thái",
  "label.field.required": "Trường này là bắt buộc",
  "label.status": "Trạng thái",
  "label.form.searchby": "Tìm theo",
  "label.id": "Mã",
  "label.import.errors": "Lỗi nhập",
  "label.inactive": "Ngừng dùng",
  "label.inactive.methods": "Phương pháp ngừng dùng. Gán xét nghiệm để kích hoạt.",
  "label.includeInactiveTests": "Bao gồm xét nghiệm ngừng dùng",
  "label.inside.normalrange": "nằm trong khoảng bình thường",
  "label.lastPrinted": "In lần cuối: {date} {time} bởi {user}",
  "label.loading": "Đang tải...",
  "label.required": "bắt buộc",
  "label.loinc": "LOINC",
  "label.management.title": "Quản lý nhãn",
  "label.no": "Không",
  "label.no.options.available": "Không có lựa chọn",
  "label.none": "Không (không lọc)",
  "label.notValidated": "Chưa duyệt",
  "label.notequals": "khác",
  "label.order.labNrPrefix": "Số lab",
  "label.order.patientPrefix": "Bệnh nhân",
  "label.order.scan.text": "Quét HOẶC nhập tay HOẶC",
  "label.orderable": "Cho phép chỉ định",
  "label.outside.normalrange": "nằm ngoài khoảng bình thường",
  "label.page.patientHistory": "Lịch sử bệnh nhân",
  "label.preview.data": "Xem trước dữ liệu",
  "label.print": "In nhãn",
  "label.print.error": "Lỗi khi tạo nhãn. Vui lòng thử lại.",
  "label.print.error.popupBlocked": "Cửa sổ bật lên bị chặn. Vui lòng cho phép cửa sổ bật lên với trang này để in nhãn.",
  "label.print.openDirectly": "Mở nhãn trong tab mới",
  "label.print.generating": "Đang tạo...",
  "label.print.success": "Đã in nhãn thành công",
  "label.print.description": "In nhãn cho chỉ định và mẫu",
  "label.print.helper": "Chọn loại và số lượng nhãn cần in",
  "label.print.success.count": "Đã in {count} nhãn thành công",
  "label.print.title": "In nhãn",
  "label.printAll": "In tất cả nhãn",
  "label.printAll.success": "Đã in tất cả nhãn thành công",
  "label.printConfirmation.message": "In nhãn cho {name}{code}?",
  "label.printConfirmation.title": "In nhãn",
  "label.printHistory": "Lịch sử in",
  "label.printHistory.byUser": "Bởi {user}",
  "label.printHistory.count": "{count} nhãn",
  "label.printHistory.loading": "Đang tải lịch sử in...",
  "label.printHistory.never": "Chưa in lần nào",
  "label.printHistory.unknownUser": "Không rõ",
  "label.printHistory.viewAll": "Xem lịch sử",
  "label.printLabel": "In nhãn",
  "label.program": "Chương trình",
  "label.qualifiers": "Ký hiệu chất lượng",
  "label.quantity": "Số lượng",
  "label.readonly": "Chỉ đọc",
  "label.reference.value": "Giá trị tham chiếu",
  "label.refertest.referencelab": "Gửi xét nghiệm sang phòng xét nghiệm tham chiếu",
  "label.rejectedByBiologist": "Bị từ chối bởi bác sĩ xét nghiệm",
  "label.rejectedByTechnician": "Bị từ chối bởi kỹ thuật viên",
  "label.remove": "Gỡ",
  "label.replaceWith": "Thay bằng",
  "label.report.byNationalId": "Theo số CCCD / Mã y tế duy nhất",
  "label.reporting.range": "Khoảng báo cáo",
  "label.result.order": "Thứ tự kết quả",
  "label.resultSelectList": "Danh sách chọn kết quả",
  "label.results.actions": "Thao tác",
  "label.results.anotherUser": "người dùng khác",
  "label.results.date": "Ngày xét nghiệm",
  "label.results.domain": "Lâm sàng",
  "label.results.domain.env": "Chất lượng nước",
  "label.results.domain.vector": "Giám sát véc-tơ",
  "label.results.edit": "Sửa",
  "label.results.inReviewBy": "Đang duyệt bởi {0}",
  "label.results.labUnit": "Nhóm xét nghiệm",
  "label.results.load": "Tải kết quả",
  "label.results.loading": "Đang tải kết quả...",
  "label.results.range": "Khoảng tham chiếu",
  "label.results.range.env": "Giới hạn quy định",
  "label.results.range.vector": "Diễn giải",
  "label.results.reflexTriggered": "Đã thêm xét nghiệm phản xạ/tính toán cho:",
  "label.results.refresh": "Làm mới",
  "label.results.result": "Kết quả",
  "label.results.resultFor": "Kết quả cho {0}",
  "label.results.retry": "Thử lại",
  "label.results.save": "Lưu",
  "label.results.search": "Tìm theo số lab",
  "label.results.searchByPatient": "Tìm theo bệnh nhân",
  "label.results.selectAnotherPatient": "Chọn bệnh nhân khác",
  "label.results.selectedPatient": "Bệnh nhân đã chọn",
  "label.results.selectedPatient.none": "Không có",
  "label.results.status": "Trạng thái",
  "label.results.status.all": "Tất cả",
  "label.results.subject": "Mẫu / Bệnh nhân",
  "label.results.subject.env": "Mẫu / Điểm lấy",
  "label.results.subject.vector": "Mẫu / Bẫy",
  "label.results.table.caption": "Danh sách công việc kết quả",
  "label.results.test": "Xét nghiệm",
  "label.results.titer.placeholder": "VD: 1:10",
  "label.results.method": "Phương pháp",
  "label.results.analyzer": "Máy xét nghiệm",
  "label.results.analyzer.none": "Không từ máy xét nghiệm",
  "label.results.fromAnalyzer": "từ máy xét nghiệm",
  "label.results.methodAnalyzerHint": "Phương pháp là loại máy xét nghiệm; Máy xét nghiệm là thiết bị cụ thể.",
  "label.results.expandRow": "Mở rộng dòng",
  "label.results.collapseRow": "Thu gọn dòng",
  "label.results.referredOut": "Đã gửi đi",
  "label.results.notes": "Ghi chú",
  "label.results.note.context": "Ngữ cảnh",
  "label.results.note.context.entry": "Nhập kết quả",
  "label.results.note.context.modification": "Chỉnh sửa",
  "label.results.note.context.auto": "Tự động đặt theo thao tác bạn đang làm.",
  "label.results.note.visibility": "Hiển thị",
  "label.results.note.internal": "Chỉ trong phòng XN",
  "label.results.note.external": "Gửi kèm kết quả",
  "label.results.note.analysisLevel": "Mức phân tích",
  "label.results.note.externalWarning": "Ghi chú này sẽ hiện trên phiếu kết quả của bệnh nhân.",
  "label.results.note.placeholder": "Thêm ghi chú…",
  "label.results.dilution.measured": "Giá trị đo được",
  "label.results.dilution.factor": "Hệ số pha loãng",
  "label.results.dilution.reported": "Giá trị báo cáo: {0}",
  "label.results.saveHint": "Khi lưu, chữ ký điện tử của bạn được ghi nhận. Xác nhận giá trị nguy kịch không bao giờ chặn Lưu.",
  "label.results.flag.normal": "Bình thường",
  "label.results.flag.abnormal": "Bất thường",
  "label.results.flag.critical": "Nguy kịch",
  "label.results.flag.invalid": "Không hợp lệ",
  "label.results.sample": "Mẫu",
  "label.results.flag": "Cờ",
  "label.results.order.clinician": "Bác sĩ chỉ định",
  "label.results.order.phone": "Điện thoại",
  "label.results.order.site": "Cơ sở chỉ định",
  "label.results.order.priority": "Ưu tiên",
  "label.results.order.collection": "Lấy mẫu",
  "label.results.section.program": "Thông tin chương trình",
  "label.results.program.name": "Chương trình",
  "label.results.program.eqa": "EQA",
  "label.results.program.readonly": "Các trường chương trình chỉ đọc tại đây — sửa trên chỉ định gốc.",
  "label.results.section.storage": "Lưu trữ & hủy mẫu",
  "label.results.storage.location": "Vị trí",
  "label.results.storage.position": "Vị trí trong khay",
  "label.results.storage.notes": "Ghi chú",
  "label.results.storage.unassigned": "Chưa gán nơi lưu trữ",
  "label.results.storage.assignLocation": "Gán vị trí",
  "label.results.storage.moveLocation": "Chuyển đến vị trí",
  "label.results.program.capturedData": "Dữ liệu chương trình",
  "label.results.sampleStatus.title": "Trạng thái mẫu",
  "label.results.sampleStatus.volume": "Thể tích: còn {0} trên {1} · trạng thái {2}.",
  "label.results.sampleStatus.noVolume": "Trạng thái {0}.",
  "label.results.sampleStatus.available": "còn dùng được",
  "label.results.sampleStatus.usedUp": "đã dùng hết",
  "label.results.sampleStatus.disposed": "đã hủy",
  "label.results.sampleStatus.recordUse": "Ghi lượng đã dùng",
  "label.results.sampleStatus.markUsedUp": "Đánh dấu đã dùng hết",
  "label.results.sampleStatus.startDisposal": "Bắt đầu hủy mẫu",
  "label.results.sampleStatus.amountUsed": "Lượng đã dùng cho xét nghiệm này",
  "label.results.sampleStatus.record": "Ghi nhận",
  "label.results.sampleStatus.recordHint": "Trừ vào thể tích còn lại — mẫu chưa được hủy cho đến khi dùng hết hoặc được đánh dấu đã dùng hết.",
  "label.results.sampleStatus.usedUpNote": "Mẫu đã dùng hết và được đưa vào quy trình hủy. Hủy mẫu sẽ ghi ai, khi nào và bằng phương pháp nào.",
  "label.results.sampleStatus.disposalReason": "Lý do hủy",
  "label.results.sampleStatus.disposalMethod": "Phương pháp hủy",
  "label.results.sampleStatus.disposalNotes": "Ghi chú",
  "label.results.sampleStatus.confirmDisposal": "Xác nhận hủy",
  "label.results.sampleStatus.updateFailed": "Trạng thái mẫu chưa được cập nhật vì máy chủ không phản hồi. Kiểm tra kết nối và thử lại.",
  "label.results.sampleStatus.reason.expired": "Hết hạn",
  "label.results.sampleStatus.reason.contaminated": "Nhiễm bẩn",
  "label.results.sampleStatus.reason.patient_request": "Theo yêu cầu bệnh nhân",
  "label.results.sampleStatus.reason.testing_complete": "Đã xét nghiệm xong",
  "label.results.sampleStatus.reason.other": "Khác",
  "label.results.sampleStatus.method.autoclave": "Nồi hấp tiệt trùng chất thải sinh học",
  "label.results.sampleStatus.method.neutralization": "Trung hòa hóa học",
  "label.results.sampleStatus.method.incineration": "Đốt",
  "label.results.sampleStatus.method.other": "Khác",
  "label.results.sampleStatus.footnote": "Dùng một phần sẽ ghi lượng tiêu hao vào thể tích còn lại của mẫu; dùng hết (hoặc Đánh dấu đã dùng hết) sẽ kích hoạt hủy mẫu.",
  "label.results.section.reagents": "Hóa chất, QC & Chứng",
  "label.results.reagents.summary.analyzer": "lô do máy báo",
  "label.results.reagents.summary.manual": "nhập thủ công",
  "label.results.reagents.mode.analyzer": "chế độ ghi nhận: do máy báo",
  "label.results.reagents.mode.manual": "chế độ ghi nhận: thủ công (không bắt buộc)",
  "label.results.reagents.analyzerNote": "Do {0} báo trong dữ liệu kết quả — chỉ đọc.",
  "label.results.reagents.lotsUsed": "Lô hóa chất đã dùng",
  "label.results.reagents.noneLinked": "Chưa liên kết hóa chất nào với xét nghiệm này — liên kết được cấu hình trong Danh mục xét nghiệm.",
  "label.results.reagents.noLots": "Không có lô nào còn tồn kho cho hóa chất này.",
  "label.results.reagents.perTest": "{0} {1} mỗi xét nghiệm",
  "label.results.reagents.fefo": "Gợi ý FEFO",
  "label.results.reagents.expires": "HSD {0} ·",
  "label.results.reagents.remaining": "còn {0} {1}",
  "label.results.reagents.quantityUsed": "Số lượng đã dùng",
  "label.results.reagents.recordUse": "Ghi nhận sử dụng",
  "label.results.reagents.recorded": "Đã ghi nhận {0} {1} — trừ theo FEFO trên các lô.",
  "label.results.reagents.recordFailed": "Không ghi nhận được việc sử dụng hóa chất.",
  "label.results.reagents.amountInvalid": "Số lượng đã dùng phải là số dương.",
  "label.results.reagents.consumeNote": "Ghi nhận sử dụng sẽ trừ tồn kho (FEFO) và tạo giao dịch tiêu hao gắn với phân tích này.",
  "label.results.control.title": "Kết quả mẫu chứng",
  "label.results.control.noneConfigured": "Chưa cấu hình lô mẫu chứng cho xét nghiệm và máy này.",
  "label.results.control.viewResults": "Xem kết quả mẫu chứng",
  "label.results.control.capture.controlLine": "Vạch chứng",
  "label.results.control.capture.valid": "Hợp lệ",
  "label.results.control.capture.invalid": "Không hợp lệ",
  "label.results.control.capture.kitLot": "Lô bộ kit",
  "label.results.control.capture.outcome": "Kết luận",
  "label.results.control.capture.lot": "Lô mẫu chứng",
  "label.results.control.capture.measured": "Giá trị đo được",
  "label.results.control.capture.expected": "Giá trị mong đợi",
  "label.results.control.capture.uncertainty": "Độ không đảm bảo (±)",
  "label.results.control.capture.record": "Ghi nhận kết quả mẫu chứng",
  "label.results.control.capture.recorded": "Đã ghi nhận kết quả mẫu chứng.",
  "label.results.control.capture.recordedBlocked": "Đã ghi nhận kết quả mẫu chứng. Các kết quả liên quan bị chặn báo cáo cho đến khi ghi nhận một lần chạy lại đạt.",
  "label.results.control.capture.blockedHint": "Mẫu chứng không đạt sẽ chặn báo cáo các kết quả liên quan — cần chạy lại.",
  "label.results.control.capture.noBenchLots": "Chưa cấu hình lô mẫu chứng tại bàn cho xét nghiệm này — hãy thêm trong QC → Lô mẫu chứng trước khi ghi nhận mẫu chứng định lượng.",
  "label.results.control.capture.incomplete": "Hoàn tất các trường kết quả mẫu chứng trước khi ghi nhận.",
  "label.results.control.capture.failed": "Ghi nhận kết quả mẫu chứng thất bại.",
  "label.results.dilution.title": "Pha loãng",
  "label.results.section.attachments": "Tệp đính kèm",
  "label.results.attachments.summary": "{0} tệp",
  "label.results.attachments.none": "không có",
  "label.results.attachments.empty": "Chưa có tệp đính kèm trên chỉ định này.",
  "label.results.attachments.add": "Thêm tệp đính kèm",
  "label.results.attachments.tooLarge": "Tệp vượt giới hạn 10 MB.",
  "label.results.attachments.uploadFailed": "Tải lên thất bại — PDF, JPG, PNG hoặc TIFF tối đa 10 MB.",
  "label.results.attachments.resultsScope": "Kết quả",
  "label.results.attachments.orderScope": "Nhập chỉ định",
  "label.results.attachments.view": "Xem",
  "label.results.attachments.download": "Tải về",
  "label.results.section.interpretation": "Diễn giải",
  "label.results.interpretation.summary": "nhập qua quy tắc hoặc văn bản tự do",
  "label.results.interpretation.ruleFired": "quy tắc đã khớp ({0}) · tự mở",
  "label.results.interpretation.autoOpen": "quy tắc đã khớp · tự mở",
  "label.results.interpretation.ruleBanner": "Khớp quy tắc (cấu hình trên xét nghiệm): giá trị nhập {0} nằm trong {1}. Chọn một nhóm để áp dụng nội dung diễn giải, rồi sửa nếu cần.",
  "label.results.interpretation.match": "khớp giá trị",
  "label.results.interpretation.freeText": "Diễn giải (văn bản tự do)",
  "label.results.interpretation.footnote": "Diễn giải có thể được đặt bởi quy tắc cấu hình trên xét nghiệm (các nhóm phân loại, tự khớp với giá trị) hoặc nhập văn bản tự do. Nội dung theo quy tắc chỉ là gợi ý, không ràng buộc cho đến khi được áp dụng hoặc sửa. Khi lưu, nội dung được gửi kèm kết quả lên phiếu.",
  "label.results.nce.disposition": "Xử lý kết quả",
  "label.results.nce.disposition.hint": "Được áp dụng khi gửi NCE. Gửi đi ngoài là thao tác riêng trên dòng, không phải cách xử lý.",
  "label.results.nce.disposition.none": "Không",
  "label.results.nce.disposition.none.detail": "Lập NCE mà không thay đổi kết quả.",
  "label.results.nce.disposition.cancel": "Hủy kết quả",
  "label.results.nce.disposition.cancel.detail": "Đã vô hiệu. Không báo cáo giá trị nào. Thường gặp với NCE tiền phân tích.",
  "label.results.nce.disposition.reject": "Từ chối + lý do",
  "label.results.nce.disposition.reject.detail": "Xóa giá trị và ghi lý do. Được áp dụng khi bạn Lưu bằng chữ ký điện tử.",
  "label.results.nce.disposition.retest": "Xét nghiệm lại",
  "label.results.nce.disposition.retest.detail": "Chỉ định lại chính xét nghiệm này trên mẫu này; lần lặp lại sẽ hiện là đang chờ.",
  "label.results.nce.disposition.rejectArmed": "Đã đặt từ chối trên dòng — Lưu (chữ ký điện tử) để áp dụng.",
  "label.results.nce.disposition.cancelled": "Đã hủy kết quả.",
  "label.results.nce.disposition.retested": "Đã chỉ định xét nghiệm lại.",
  "label.results.critical.range": "Nguy kịch",
  "label.results.critical.banner.title": "Giá trị nguy kịch — cần thông báo cho bác sĩ",
  "label.results.critical.banner.notify": "Bác sĩ phụ trách phải được thông báo. Ghi nhận việc này trên bảng Cảnh báo và ghi lại cuộc gọi bên dưới.",
  "label.results.critical.acknowledge": "Tôi đã xác nhận",
  "label.results.critical.acknowledged": "Đã xác nhận",
  "label.results.critical.comment": "Ghi chú xác nhận",
  "label.results.critical.comment.placeholder": "VD: Đã thông báo cho bác sĩ qua điện thoại",
  "label.results.section.history": "Lịch sử (phân tích này)",
  "label.results.history.summary": "{0} sự kiện",
  "label.results.history.summary.unloaded": "lần sửa · trạng thái · xét nghiệm lại",
  "label.results.history.when": "Thời điểm",
  "label.results.history.event": "Sự kiện",
  "label.results.history.detail": "Chi tiết",
  "label.results.history.by": "Bởi",
  "label.results.history.event.CREATED": "Tạo mới",
  "label.results.history.event.STATUS": "Trạng thái",
  "label.results.history.event.RESULT": "Kết quả",
  "label.results.history.event.NOTE": "Ghi chú",
  "label.results.history.event.RETEST": "Xét nghiệm lại",
  "label.results.history.event.REFLEX": "Phản xạ",
  "label.results.history.event.OTHER": "Sự kiện",
  "label.results.history.empty": "Chưa có sự kiện nào được ghi nhận cho phân tích này.",
  "label.results.history.footnote": "Chỉ phân tích này — các lần sửa, chuyển trạng thái, xét nghiệm lại, hiệu chỉnh, ghi chú và mục kiểm toán. Xu hướng bệnh nhân nằm trong hồ sơ bệnh nhân; quy tắc Westgard nằm trên bảng QC.",
  "label.results.nce.report": "Báo cáo sự không phù hợp",
  "label.results.reject.result": "Từ chối kết quả",
  "label.results.reject.reason": "Lý do từ chối",
  "label.results.reject.hint": "Lưu kèm từ chối sẽ xóa giá trị, ghi lý do và đánh dấu phân tích là Kỹ thuật từ chối.",
  "label.results.referral.refer": "Gửi xét nghiệm này đi",
  "label.results.referral.editing": "Đang chờ gửi đi — sửa",
  "label.results.referral.organization": "Phòng xét nghiệm tham chiếu",
  "label.results.referral.reason": "Lý do gửi đi",
  "label.results.referral.date": "Ngày gửi đi",
  "label.results.referral.reportDate": "Ngày báo cáo của phòng tham chiếu",
  "label.results.referral.hint": "Việc gửi đi được ghi nhận khi bạn Lưu dòng này và chuyển sang bảng Gửi mẫu đi.",
  "label.results.referral.cancel": "Bỏ",
  "label.results.referral.incomplete": "Chọn phòng xét nghiệm tham chiếu và lý do gửi đi, hoặc bỏ phiếu gửi mẫu, trước khi lưu dòng này.",
  "label.results.section.aliquots": "Phân mẫu con",
  "label.results.aliquots.summary": "{0} mẫu con",
  "label.results.aliquots.summary.unloaded": "danh sách · tạo",
  "label.results.aliquots.labNo": "Số lab",
  "label.results.aliquots.quantity": "Số lượng",
  "label.results.aliquots.createdDate": "Ngày tạo",
  "label.results.aliquots.empty": "Chưa có mẫu con nào cho mẫu này.",
  "label.results.aliquots.count": "Số mẫu con",
  "label.results.aliquots.totalQuantity": "Tổng lượng cần chuyển",
  "label.results.aliquots.notes": "Ghi chú",
  "label.results.aliquots.create": "Tạo mẫu con",
  "label.results.aliquots.created": "Đã tạo mẫu con.",
  "label.results.aliquots.failed": "Không tạo được mẫu con.",
  "label.results.aliquots.remaining": "Lượng còn lại của mẫu gốc",
  "label.results.history.event.REFERRAL": "Đã gửi đi",
  "label.results.history.event.NCE": "Không phù hợp",
  "label.results.history.event.CRITICAL_ACK": "Đã xác nhận nguy kịch",
  "label.results.history.event.INVALID_CONFIRMED": "Đã xác nhận ngoài khoảng hợp lệ",
  "label.results.alert.critical.title": "Kết quả nguy kịch",
  "label.results.alert.critical.defaultMessage": "Đây là kết quả nguy kịch. Hãy thông báo cho bác sĩ phụ trách theo quy trình của phòng xét nghiệm.",
  "label.results.alert.invalid.title": "Giá trị ngoài khoảng hợp lệ",
  "label.results.alert.invalid.body": "Giá trị này nằm ngoài khoảng hợp lệ của xét nghiệm này ({low} đến {high}). Hãy kiểm tra trước khi lưu.",
  "label.results.alert.correct": "Sửa giá trị",
  "label.results.alert.keepValue": "Giữ giá trị này",
  "label.results.alert.confirmAndSave": "Xác nhận và lưu",
  "label.results.alert.acknowledgeAndSave": "Xác nhận và lưu",
  "label.results.callback.logged": "Đã ghi nhận gọi lại",
  "label.results.referenceZone": "Tham chiếu & ngữ cảnh",
  "label.results.layoutRemembered": "Đã ghi nhớ bố cục",
  "label.results.resetLayout": "Đặt lại bố cục",
  "label.results.section.orderInfo": "Thông tin chỉ định",
  "label.results.sampleType": "Loại mẫu",
  "label.results.testDate": "Ngày xét nghiệm",
  "label.results.receivedDate": "Ngày nhận",
  "label.results.technician": "Kỹ thuật viên",
  "label.routine.Reports": "Báo cáo định kỳ",
  "label.sample.types.activate": "Các loại mẫu sau sẽ được kích hoạt:",
  "label.sample.types.deactivate": "Các loại mẫu sau sẽ bị ngừng dùng vì không có xét nghiệm nào:",
  "label.save": "Lưu",
  "label.saving": "Đang lưu...",
  "label.search.available.targetest": "Tìm xét nghiệm có sẵn",
  "label.search.availablepanel": "Tìm bộ xét nghiệm có sẵn",
  "label.search.labno.family": "Tìm theo số lab hoặc họ",
  "label.search.patient": "Tìm bệnh nhân",
  "label.select": "Chọn",
  "label.select.dateRange": "Chọn khoảng thời gian cho báo cáo",
  "label.select.list.options": "Các lựa chọn của danh sách",
  "label.selectTestSectionCatalog": "Chọn nhóm xét nghiệm để xem danh mục của nhóm đó",
  "label.sex.dependent": "Phụ thuộc giới tính",
  "label.shortCode": "Mã rút gọn",
  "label.shortCode.error.invalidChars": "Mã rút gọn chỉ được chứa chữ cái, số, dấu gạch ngang và gạch dưới",
  "label.shortCode.error.maxLength": "Mã rút gọn tối đa 10 ký tự",
  "label.shortCode.error.network": "Không kiểm tra được tính duy nhất. Vui lòng kiểm tra thủ công.",
  "label.shortCode.error.save": "Lỗi khi lưu mã rút gọn: {error}",
  "label.shortCode.error.startChar": "Mã rút gọn phải bắt đầu bằng chữ cái hoặc số",
  "label.shortCode.helper": "Tối đa 10 ký tự, chữ và số, gạch ngang, gạch dưới",
  "label.shortCode.optional.helper": "Không bắt buộc (sẽ dùng mã nếu ≤10 ký tự). Tối đa 10 ký tự, chữ và số, có gạch ngang/gạch dưới",
  "label.shortCode.required.helper": "Bắt buộc khi mã dài hơn 10 ký tự. Tối đa 10 ký tự, chữ và số, có gạch ngang/gạch dưới",
  "label.shortCode.update.success": "Đã cập nhật mã rút gọn thành công",
  "label.shortCodeRequired": "Cần có mã rút gọn để in nhãn. Vui lòng đặt mã rút gọn trong form Sửa trước.",
  "label.shortCodeWarning": "Đổi mã rút gọn sẽ làm nhãn hiện có không còn hiệu lực",
  "label.showChildren": "Hiện phần tử con",
  "label.study.Reports": "Báo cáo nghiên cứu",
  "label.test.name": "Tên xét nghiệm",
  "label.test.activate": "Các xét nghiệm sau sẽ được kích hoạt:",
  "label.test.add": "Thêm xét nghiệm vào chỉ định",
  "label.test.batch.cancel.finish": "Thao tác này không thể hoàn tác.",
  "label.test.batch.cancel.start": "Bạn đã chọn hủy xét nghiệm",
  "label.test.batch.no.change.finish": "xét nghiệm sẽ không bị thay đổi.",
  "label.test.batch.replace.start": "Các",
  "label.test.deactivate": "Các xét nghiệm sau sẽ bị ngừng dùng:",
  "label.test.display.order": "Thứ tự hiển thị xét nghiệm",
  "label.test.order.confirm": "Kiểm tra: Bật/tắt khả năng chỉ định xét nghiệm",
  "label.test.activation.confirm": "Kiểm tra: Kích hoạt/ngừng xét nghiệm",
  "label.test.orderable": "Các xét nghiệm sau sẽ được chỉ định từ phiếu chỉ định.",
  "label.test.results": "Kết quả xét nghiệm",
  "label.test.resultsData": "Dữ liệu kết quả xét nghiệm",
  "label.test.unorderable": "Các xét nghiệm sau sẽ không được chỉ định trên phiếu. Chúng chỉ được chỉ định dưới dạng xét nghiệm phản xạ.",
  "label.testActivate": "Kích hoạt xét nghiệm",
  "label.testName": "Tên xét nghiệm",
  "label.text.generate": "tạo",
  "label.total.tests": "Tổng số xét nghiệm",
  "label.type": "Loại nhãn",
  "label.type.order": "Nhãn chỉ định",
  "label.type.pool": "Gộp {count} {animal}",
  "label.type.sample": "Nhãn mẫu",
  "label.unit": "Đơn vị",
  "label.user.notestsection": "Người dùng hiện tại chưa được gán nhóm xét nghiệm. Vui lòng liên hệ quản trị viên",
  "label.validation.errors": "Lỗi kiểm tra",
  "label.validation.results": "Kết quả kiểm tra",
  "label.view": "Xem",
  "label.viewtestCatalog": "Danh mục xét nghiệm",
  "label.warning": "Cảnh báo",
  "label.yes": "Có",
  "labno.alt.prefix.instruction": "Tiền tố cho nhãn mã vạch in sẵn (4 ký tự):",
  "labno.alt.prefix.note": "LƯU Ý: Nếu tiền tố này đã từng dùng, việc đánh số sẽ tiếp tục từ số cuối cùng đã tạo.",
  "labno.alt.prefix.use": "Dùng cùng định dạng số mẫu và nhóm số còn trống như Tạo số trong Nhập chỉ định.",
  "language.select.label": "Tiếng Anh",
  "legend.search.availabletests": "Tìm trong các xét nghiệm có sẵn",
  "loading": "Đang tải...",
  "loading.boxes": "Đang tải hộp...",
  "loading.description": "Đang tải...",
  "location.collection.title": "Vị trí lấy mẫu",
  "location.environmentalConditions": "Điều kiện môi trường",
  "location.environmentalConditions.placeholder": "VD: 25°C, trời quang",
  "location.gps.error": "Không lấy được vị trí",
  "location.gps.getCurrent": "Lấy vị trí hiện tại",
  "location.gps.getting": "Đang lấy vị trí...",
  "location.gps.latitude": "Vĩ độ GPS",
  "location.gps.longitude": "Kinh độ GPS",
  "location.gps.notSupported": "Trình duyệt của bạn không hỗ trợ định vị",
  "location.gps.permissionDenied": "Quyền truy cập vị trí bị từ chối",
  "location.gps.timeout": "Yêu cầu vị trí quá thời gian",
  "location.gps.unavailable": "Không có thông tin vị trí",
  "location.helper": "Phân cấp vị trí (Vùng / Huyện / Xã-Thôn) dùng cấu trúc Vị trí có sẵn của hệ thống. Hồ sơ quy trình môi trường cho phép một số dòng không gắn nhãn để tạo tập dòng đơn giản hoặc ngắn hơn khi cần thiết lập.",
  "location.requesterReference": "Tham chiếu của người chỉ định",
  "location.requesterReference.placeholder": "VD: EPA Method 524.2",
  "location.select.placeholder": "Chọn {levelName}...",
  "location.siteDescription": "Mô tả điểm lấy mẫu",
  "location.siteDescription.placeholder": "VD: Điểm lấy nước của nguồn cấp nước đô thị",
  "locale.active": "Đang dùng",
  "locale.add": "Thêm ngôn ngữ",
  "locale.add.title": "Thêm ngôn ngữ",
  "locale.code": "Mã ngôn ngữ",
  "locale.code.helper": "VD: en, fr, es, pt",
  "locale.create.success": "Đã tạo ngôn ngữ thành công",
  "locale.delete.confirm.message": "Bạn có chắc muốn xóa ngôn ngữ này? Thao tác này không thể hoàn tác.",
  "locale.delete.confirm.title": "Xóa ngôn ngữ",
  "locale.delete.error": "Xóa ngôn ngữ thất bại",
  "locale.delete.fallback.error": "Không thể xóa ngôn ngữ dự phòng. Hãy đặt ngôn ngữ khác làm dự phòng trước.",
  "locale.delete.success": "Đã xóa ngôn ngữ thành công",
  "locale.displayName": "Tên hiển thị",
  "locale.displayName.helper": "VD: English, Français, Español",
  "locale.edit.title": "Sửa ngôn ngữ",
  "locale.fallback": "Dự phòng",
  "locale.fallback.error": "Đặt ngôn ngữ dự phòng thất bại",
  "locale.fallback.success": "Đã cập nhật ngôn ngữ dự phòng",
  "locale.management.description": "Quản lý các ngôn ngữ được hỗ trợ cho bản dịch siêu dữ liệu.",
  "locale.management.title": "Quản lý ngôn ngữ",
  "locale.setFallback": "Đặt làm dự phòng",
  "locale.sortOrder": "Thứ tự sắp xếp",
  "locale.status": "Trạng thái",
  "locale.update.success": "Đã cập nhật ngôn ngữ thành công",
  "log.submitting.aliquot.data": "Đang gửi dữ liệu mẫu con:",
  "log.submitting.aliquot.data2": "Đang gửi dữ liệu mẫu con (JSON):",
  "logging.management.apply": "Áp dụng mức ghi nhật ký",
  "logging.management.description": "Thay đổi mức ghi nhật ký phía máy chủ khi đang chạy. Hữu ích để gỡ lỗi mà không cần khởi động lại máy chủ. Thay đổi có hiệu lực ngay nhưng không được giữ lại sau khi máy chủ khởi động lại.",
  "logging.management.label": "Cấu hình nhật ký",
  "logging.management.level": "Mức nhật ký",
  "logging.management.logger": "Tên bộ ghi nhật ký",
  "logging.management.logger.helper": "VD: org.openelisglobal, root",
  "logging.management.success": "Đã đặt mức nhật ký {level} cho {logger}",
  "login.account.disabled": "Tài khoản đã bị vô hiệu",
  "login.account.locked": "Tài khoản đã bị khóa",
  "login.complexity.message": "Mật khẩu phải: ",
  "login.complexity.message.1": "Tối thiểu 7 ký tự",
  "login.complexity.message.2": "Có thể gồm chữ hoa, chữ thường hoặc số",
  "login.complexity.message.3": "Phải chứa ít nhất một trong các ký tự sau: *, $, #, !",
  "login.complexity.message.4": "Không được chứa ký tự nào khác",
  "login.complexity.new.message": "Mật khẩu mới phải: ",
  "login.complexity.new.message.1": "Không được trùng với mật khẩu hiện tại",
  "login.error.account.disable": "Tài khoản của bạn đã bị vô hiệu. Vui lòng liên hệ quản trị hệ thống.",
  "login.error.password.current.incorrect": "Mật khẩu hiện tại bạn nhập không đúng. Vui lòng thử lại.",
  "login.error.password.expired": "Mật khẩu của bạn đã hết hạn. Vui lòng liên hệ quản trị hệ thống.",
  "login.error.update.message": "Cập nhật mật khẩu thất bại. Vui lòng thử lại.",
  "login.login.": "Nhập lại mật khẩu",
  "login.login.current.password": "Mật khẩu hiện tại",
  "login.login.first": "Tên",
  "login.login.last": "Họ",
  "login.login.name": "Tên đăng nhập",
  "login.login.new.password": "Mật khẩu mới",
  "login.login.password": "Mật khẩu",
  "login.login.repeat.password": "Nhập lại mật khẩu",
  "login.msg.password": "Mật khẩu",
  "login.msg.password.missing": "Cần nhập mật khẩu",
  "login.msg.username": "Tên đăng nhập",
  "login.msg.username.missing": "Cần nhập tên đăng nhập",
  "login.notice.message": "Lưu ý: Dịch vụ này chỉ dành cho nhân sự được ủy quyền. Nếu bạn không có sự cho phép rõ ràng của quản trị viên, hãy thoát ngay. Tổ chức nghiêm cấm truy cập, tiết lộ, sao chép, sửa đổi, chuyển hướng, phá hủy, làm mất, lạm dụng hoặc đánh cắp thông tin của mình.",
  "login.password.expired.date": "Ngày hết hạn mật khẩu",
  "login.password.expired.date.placeholder": "(dd/mm/yyyy)",
  "login.redirecting.sso": "Đang chuyển sang đăng nhập một lần...",
  "login.subtitle": "Đăng nhập",
  "login.timeout": "Thời gian chờ người dùng (phút)",
  "login.timeout.placeholder": "Nhập theo ms",
  "login.title": "Đăng nhập",
  "lot.barcode": "Mã vạch",
  "lot.barcode.assign": "Lô này chưa có mã vạch. Nhập ngay; mã sẽ bị khóa sau khi lưu.",
  "lot.barcode.hint": "Để trống để tạo từ mã mặt hàng và số lô.",
  "lot.barcode.locked": "Mã vạch được khóa sau khi lưu để nhãn đã in tiếp tục hoạt động.",
  "lot.barcode.placeholder": "Để trống để tự tạo",
  "lot.barcode.placeholder.assign": "Nhập mã vạch",
  "lot.calculatedExpiry": "Hạn dùng tính toán",
  "lot.currentQuantity": "Số lượng hiện tại",
  "lot.dateOpened": "Ngày mở",
  "lot.details.no.movements": "Chưa ghi nhận lần chuyển nào cho lô này",
  "lot.details.no.transactions": "Chưa ghi nhận giao dịch nào cho lô này",
  "lot.details.no.usage": "Chưa có lịch sử sử dụng cho lô này",
  "lot.details.section.basic": "Thông tin cơ bản",
  "lot.details.section.dates": "Các ngày quan trọng",
  "lot.details.section.movements": "Lịch sử chuyển kho",
  "lot.details.section.quantities": "Số lượng",
  "lot.details.section.storage": "Vị trí lưu trữ",
  "lot.details.section.transactions": "Lịch sử giao dịch",
  "lot.details.section.usage": "Lịch sử sử dụng",
  "lot.details.tab.info": "Thông tin",
  "lot.details.tab.transactions": "Giao dịch",
  "lot.details.tab.usage": "Lịch sử sử dụng",
  "lot.details.title": "Chi tiết lô",
  "lot.details.view": "Xem chi tiết",
  "lot.expirationDate": "Ngày hết hạn",
  "lot.form.title.add": "Nhập lô hàng tồn kho mới",
  "lot.form.title.edit": "Sửa lô hàng tồn kho",
  "lot.initialQuantity": "Số lượng ban đầu",
  "lot.label.print": "In nhãn",
  "lot.label.print.failed": "Không tạo được nhãn. Vui lòng thử lại.",
  "lot.number": "Số lô",
  "lot.number.hint": "Mã định danh ổn định cho lô này. Để trống, hệ thống sẽ tạo từ mã mặt hàng và ngày hôm nay.",
  "lot.number.placeholder": "Để trống để tự tạo",
  "lot.qcStatus.FAILED": "Không đạt",
  "lot.qcStatus.PASSED": "Đạt",
  "lot.qcStatus.PENDING": "Chờ",
  "lot.qcStatus.QUARANTINED": "Cách ly",
  "lot.qcStatus.hint": "Lô vẫn không dùng được cho xét nghiệm cho đến khi QC được đánh dấu Đạt.",
  "lot.qcStatus": "Trạng thái QC",
  "lot.receiptDate": "Ngày nhập",
  "lot.save.error": "Lỗi khi lưu lô",
  "lot.save.error.locationAfterCreate": "Lô đã được tạo, nhưng gán vị trí lưu trữ thất bại. Nhấn Lưu lại để chỉ thử gán vị trí, để lô không bị nhập hai lần. {reason}",
  "lot.save.success": "Đã lưu lô thành công",
  "lot.selectItem": "Chọn mặt hàng danh mục",
  "lot.selectLocation": "Chọn vị trí lưu trữ",
  "lot.status": "Trạng thái",
  "lot.status.ACTIVE": "Đang dùng",
  "lot.status.CONSUMED": "Đã tiêu hao",
  "lot.status.DISPOSED": "Đã hủy",
  "lot.status.EXPIRED": "Hết hạn",
  "lot.status.IN_USE": "Đang sử dụng",
  "lot.status.QUARANTINED": "Cách ly",
  "lot.storageLocation": "Vị trí lưu trữ",
  "manage.testing.algorithms.add.reflex.tests": "Quản lý thuật toán xét nghiệm và xét nghiệm phản xạ",
  "master.lists.page": "Trang danh mục gốc",
  "master.lists.page.analyzer": "Menu tên xét nghiệm của máy",
  "master.lists.page.barcode": "Cấu hình mã vạch",
  "master.lists.page.batchtest": "Gán lại và hủy xét nghiệm hàng loạt",
  "master.lists.page.external.connections": "Menu kết nối bên ngoài",
  "master.lists.page.field": "Cấu hình kiểm tra trường nhập",
  "master.lists.page.list": "Plugin danh sách",
  "master.lists.page.menu": "Cấu hình menu",
  "master.lists.page.notification": "Cấu hình thông báo xét nghiệm",
  "master.lists.page.order.entry": "Cấu hình nhập chỉ định",
  "master.lists.page.org": "Menu tổ chức",
  "master.lists.page.patient": "Cấu hình nhập bệnh nhân",
  "master.lists.page.printed": "Cấu hình báo cáo in",
  "master.lists.page.provider": "Đơn vị cung cấp",
  "master.lists.page.report.result": "Cấu hình báo cáo kết quả",
  "master.lists.page.result": "Cấu hình nhập kết quả",
  "master.lists.page.site": "Thông tin cơ sở",
  "master.lists.page.test.management": "Quản lý xét nghiệm",
  "master.lists.page.user": "Quản lý người dùng",
  "master.lists.page.work.plan": "Cấu hình phiếu công việc",
  "menu.accession.validation": "Theo chỉ định",
  "menu.accession.validation.range": "Theo khoảng số chỉ định",
  "menu.billing.active": "Menu thanh toán đang bật",
  "menu.billing.address": "URL thanh toán",
  "menu.billing.title": "Quản lý menu thanh toán",
  "menu.genericSample": "Mẫu chung",
  "menu.genericSample.edit": "Sửa chỉ định",
  "menu.genericSample.import": "Nhập",
  "menu.genericSample.order": "Chỉ định",
  "menu.global.title": "Quản lý menu chung",
  "menu.label.filter": "Bộ lọc : ",
  "menu.label.filter.active": "Chỉ mục đang dùng",
  "menu.label.filter.admin": "Chỉ quản trị viên",
  "menu.label.filter.role": "Theo vai trò nhóm xét nghiệm",
  "menu.nonconform.active": "Menu không phù hợp đang bật",
  "menu.nonconform.title": "Quản lý menu không phù hợp",
  "menu.patient.active": "Menu bệnh nhân đang bật",
  "menu.patient.title": "Quản lý menu bệnh nhân",
  "menu.results.range": "Theo khoảng số chỉ định",
  "menu.sidenav.active": "Thanh điều hướng bên đang bật",
  "menu.study.active": "Menu nghiên cứu đang bật",
  "menu.study.title": "Cấu hình menu nghiên cứu",
  "menu.validation.date": "Theo ngày",
  "message.method.activation": "Nhóm phương pháp này sẽ không được kích hoạt cho đến khi có ít nhất một xét nghiệm được gán vào.",
  "message.propertiesupdate.success": "Đã cập nhật thuộc tính thành công",
  "method.browse.title": "Nhóm phương pháp",
  "method.methodName": "Tên phương pháp",
  "method.modal.add.heading": "Thêm phương pháp mới",
  "modal.add.method": "Thêm phương pháp mới",
  "move.back": "Chuyển lại",
  "move.to.aliquot": "Chuyển sang mẫu con",
  "new.patient.label": "Bệnh nhân mới",
  "next.action.button": "Tiếp",
  "nextLabel.action.button": "Nhãn tiếp theo",
  "no.aliquots": "Không có mẫu con",
  "no.analysis.found": "Không tìm thấy phân tích nào",
  "no.data.found": "Không có dữ liệu",
  "no.option": "Không",
  "noTestsFound.matching": "Không tìm thấy xét nghiệm nào khớp với",
  "nonconform.add.new.date": "Thêm ngày mới",
  "nonconform.corrective.action": "Hành động khắc phục đã lên kế hoạch hoặc khuyến nghị:",
  "nonconform.corrective.actionType": "Loại hành động",
  "nonconform.corrective.comment": "Nhận xét",
  "nonconform.corrective.control": "Hành động phòng ngừa khắc phục đã lên kế hoạch hoặc khuyến nghị, hoặc kiểm soát đồng thời:",
  "nonconform.corrective.title": "Hành động khắc phục sự kiện không phù hợp",
  "nonconform.date.completed": "Ngày hoàn thành",
  "nonconform.date.discussion.nce": "Ngày thảo luận với nhân viên NCE",
  "nonconform.date.event": "Ngày xảy ra sự kiện",
  "nonconform.description.nce": "Mô tả NCE",
  "nonconform.field.date": "Ngày NCE",
  "nonconform.field.reporting.data": "Ngày báo cáo",
  "nonconform.goToNceForm": "Đến form báo cáo NCE",
  "nonconform.lab.componenet.nce": "Thành phần phòng xét nghiệm nơi xảy ra NCE",
  "nonconform.label.highseverity": "9 = mức độ rất cao — cần hành động ngay",
  "nonconform.label.lowseverity": "1 = mức độ rất thấp — không cần hành động ngay",
  "nonconform.label.prescibernamesite": "Tên và cơ sở của bác sĩ kê đơn",
  "nonconform.label.proposed.action": "Hành động đề xuất",
  "nonconform.label.reportingunit": "Đơn vị báo cáo",
  "nonconform.label.suspected.cause.nce": "Nguyên nhân nghi ngờ của NCE",
  "nonconform.nce.concurrent.control.action": "hành động kiểm soát đồng thời",
  "nonconform.nce.number": "Số NCE",
  "nonconform.nce.preventive.action": "hành động phòng ngừa",
  "nonconform.nce.resolution": "Xử lý NCE",
  "nonconform.nce.resolution.description": "Các hành động khắc phục và kiểm soát phòng ngừa/đồng thời có hiệu quả trong việc giải quyết sự kiện không phù hợp và ngăn không cho tái diễn không?",
  "nonconform.nce.turnaround.time": "Thời gian trả kết quả",
  "nonconform.order.save.fail": "Lưu thất bại",
  "nonconform.order.save.failBecause": "Save failed: {reason}",
  "nonconform.search.nceNumber": "Số NCE",
  "nonconform.column.date": "Ngày",
  "nonconform.column.labSection": "Lab Section/Unit",
  "nonconform.search.lastName": "Họ",
  "nonconform.search.firstName": "Tên (đệm + tên)",
  "nonconform.search.patientCode": "Patient Identification Code",
  "nonconform.search.labNumber": "Mã mẫu (SID)",
  "nonconform.search.specimenType": "Loại bệnh phẩm",
  "nonconform.order.save.success": "Lưu thành công",
  "nonconform.person.reporting.different": "Tên người báo cáo NCE (nếu khác)",
  "nonconform.person.responsible": "Người chịu trách nhiệm",
  "nonconform.report": "Báo cáo sự kiện không phù hợp (NCE)",
  "nonconform.report.field.date": "Ngày báo cáo",
  "nonconform.severity.score": "Điểm mức độ nghiêm trọng",
  "nonconform.view.comments": "Nhận xét",
  "nonconform.view.corrective.action.description": "Mô tả hành động khắc phục cần thực hiện",
  "nonconform.view.event.date": "Ngày xảy ra sự kiện",
  "nonconform.view.event.description": "Mô tả sự kiện",
  "nonconform.view.lab.component": "Thành phần phòng xét nghiệm",
  "nonconform.view.nce.category": "Phân loại NCE",
  "nonconform.view.nce.likely.occur": "NCE có khả năng tái diễn đến mức nào?",
  "nonconform.view.nce.severity": "Mức độ nghiêm trọng",
  "nonconform.view.nce.type": "Loại NCE",
  "nonconform.view.preventive.description": "Nếu có, mô tả hành động phòng ngừa hoặc kiểm soát đồng thời",
  "nonconform.view.report": "Xem NCE mới",
  "nonconform.view.reporting.person": "Người báo cáo",
  "nonconform.view.severe.consequences": "Hậu quả hoặc tác động của NCE nghiêm trọng đến mức nào?",
  "nonconform.view.specimen": "Mẫu",
  "nce.attachment.dropzone": "Kéo và thả tệp vào đây hoặc bấm để tải lên",
  "nce.attachment.error.maxFiles": "Tối đa {maxFiles} tệp",
  "nce.attachment.error.size": "Kích thước tệp vượt mức tối đa {maxSize}",
  "nce.attachment.error.type": "Không cho phép loại tệp này. Các loại được chấp nhận: {types}",
  "nce.attachment.error.upload": "Lỗi khi tải tệp lên",
  "nce.attachment.files": "tệp",
  "nce.attachment.hint": "(Không bắt buộc — tối đa {maxFiles} tệp, mỗi tệp 10MB)",
  "nce.attachment.uploading": "Đang tải lên...",
  "nce.category.administrative": "Hành chính",
  "nce.category.analytical": "Phân tích",
  "nce.category.postanalytical": "Hậu phân tích",
  "nce.category.preanalytical": "Tiền phân tích",
  "nce.field.attachments": "Tệp đính kèm",
  "nce.field.notes": "Ghi chú",
  "nce.field.description.placeholder": "Mô tả việc đã xảy ra, phát hiện khi nào và bối cảnh liên quan...",
  "nce.field.immediateAction": "Hành động xử lý ngay",
  "nce.field.immediateAction.placeholder": "Các bước khắc phục đã thực hiện ngay...",
  "nce.field.linkedItems": "Mẫu/kết quả liên quan",
  "nce.field.severity": "Mức độ nghiêm trọng",
  "nce.field.title": "Tiêu đề",
  "nce.field.title.placeholder": "Mô tả ngắn về sự kiện...",
  "nce.severity.critical": "Nghiêm trọng",
  "nce.severity.critical.description": "Rủi ro an toàn người bệnh, vi phạm quy định",
  "nce.severity.major": "Lớn",
  "nce.severity.major.description": "Ảnh hưởng đáng kể đến chất lượng hoặc vận hành",
  "nce.severity.minor": "Nhỏ",
  "nce.severity.minor.description": "Ảnh hưởng hạn chế, dễ khắc phục",
  "nce.severity.low": "Thấp",
  "nce.severity.low.description": "Ảnh hưởng tối thiểu, không cần hành động khắc phục",
  "nce.status.open": "Đang mở",
  "nce.status.underInvestigation": "Đang điều tra",
  "nce.tree.empty": "Không tìm thấy chỉ định. Tìm theo số lab để bắt đầu.",
  "nce.tree.loading": "Đang tải chỉ định...",
  "nce.tree.order": "Chỉ định",
  "nce.tree.search": "Lọc theo xét nghiệm hoặc mẫu...",
  "nce.tree.selected": "Đã chọn {sampleCount} mẫu, {resultCount} kết quả",
  "nce.trigger.order_cancellation": "Hủy chỉ định có thể cần lập hồ sơ NCE",
  "nce.trigger.partial_sample_rejection": "Từ chối một phần mẫu cần lập hồ sơ NCE",
  "nce.trigger.pathology_rejection": "Từ chối ca giải phẫu bệnh có thể cần lập hồ sơ NCE",
  "nce.trigger.premature_disposal": "Hủy mẫu sớm có thể cần lập hồ sơ NCE",
  "nce.trigger.qc_invalidation": "Vô hiệu hóa QC cần lập hồ sơ NCE",
  "nce.trigger.referral_rejection": "Từ chối gửi mẫu đi cần lập hồ sơ NCE",
  "nce.trigger.result_rejection_no_retest": "Từ chối kết quả không xét nghiệm lại cần lập hồ sơ NCE",
  "nce.trigger.result_rejection_retest": "Từ chối kết quả có xét nghiệm lại có thể cần lập hồ sơ NCE",
  "nce.trigger.sample_rejection": "Từ chối mẫu cần lập hồ sơ NCE",
  "nce.trigger.test_cancel_no_results": "Hủy xét nghiệm có thể cần lập hồ sơ NCE",
  "nce.trigger.test_cancel_with_results": "Hủy xét nghiệm đã có kết quả cần lập hồ sơ NCE",
  "nce.type.calibration_failure": "Hiệu chuẩn thất bại",
  "nce.type.communication_failure": "Lỗi truyền thông",
  "nce.type.contamination": "Nhiễm bẩn",
  "nce.type.documentation_error": "Lỗi tài liệu",
  "nce.type.equipment_malfunction": "Thiết bị trục trặc",
  "nce.type.labeling_error": "Lỗi dán nhãn",
  "nce.type.patient_id_mismatch": "Không khớp mã bệnh nhân",
  "nce.type.policy_violation": "Vi phạm quy định",
  "nce.type.procedure_deviation": "Sai lệch quy trình",
  "nce.type.qc_failure": "QC không đạt",
  "nce.type.reagent_issue": "Sự cố hóa chất",
  "nce.type.report_delay": "Chậm trễ báo cáo",
  "nce.type.report_distribution_error": "Lỗi phân phát báo cáo",
  "nce.type.requisition_incomplete": "Phiếu chỉ định chưa đầy đủ",
  "nce.type.resource_shortage": "Thiếu nguồn lực",
  "nce.type.result_interpretation_error": "Lỗi diễn giải kết quả",
  "nce.type.sample_collection_error": "Lỗi lấy mẫu",
  "nce.type.staff_competency_issue": "Vấn đề năng lực nhân sự",
  "nce.type.storage_error": "Lỗi bảo quản",
  "nce.type.system_error": "Lỗi hệ thống",
  "nce.type.training_gap": "Thiếu đào tạo",
  "nce.type.transcription_error": "Lỗi chép kết quả",
  "nce.type.transport_issue": "Sự cố vận chuyển",
  "nce.type.request_form_error": "Lỗi phiếu yêu cầu",
  "nce.type.equipment_failure": "Hỏng thiết bị",
  "nce.type.procedure_error": "Lỗi quy trình",
  "nce.type.calibration_error": "Lỗi hiệu chuẩn",
  "nce.type.cross_contamination": "Nhiễm chéo",
  "nce.type.result_transcription_error": "Lỗi chép kết quả",
  "nce.type.report_delivery_error": "Lỗi giao báo cáo",
  "nce.type.critical_value_not_reported": "Giá trị nguy kịch không được báo",
  "nce.type.delayed_result": "Kết quả bị trễ",
  "nce.type.result_amendment": "Sửa đổi kết quả",
  "nce.type.training_issue": "Vấn đề đào tạo",
  "nce.category.analysis": "Analysis",
  "nce.category.general": "General",
  "nce.category.order": "Thứ tự",
  "nce.category.sample": "Mẫu",
  "nce.type.barcodeIssue": "Barcode Issue",
  "nce.type.brokenTubeContainer": "Broken Tube/Container",
  "nce.type.calibrationIssue": "Calibration Issue",
  "nce.type.coagulatedSample": "Coagulated Sample",
  "nce.type.contaminationClient": "Contamination - client",
  "nce.type.contaminationInternal": "Contamination - internal",
  "nce.type.demographicError": "Demographic error",
  "nce.type.employeeConcern": "Employee concern",
  "nce.type.expiredReagentMaterial": "Expired Reagent/Material",
  "nce.type.formIncorrect": "Form incorrect",
  "nce.type.formMissing": "Form missing",
  "nce.type.haemolyticSample": "Hemolytic sample",
  "nce.type.improperSpecimenCollection": "Improper Specimen Collection",
  "nce.type.inadequateSampling": "Inadequate Sampling",
  "nce.type.incorrectMeasurement": "Incorrect measurement of sample or reagent",
  "nce.type.instrumentDowntime": "Instrument Downtime",
  "nce.type.insufficientAmount": "Insufficient Amount",
  "nce.type.inventoryStorage": "Inventory Storage",
  "nce.type.leakage": "Leakage",
  "nce.type.lostSpecimenIrreplacable": "Lost Specimen - Irreplaceable",
  "nce.type.lostSpecimenRedraw": "Lost Specimen - Redraw",
  "nce.type.lotNumberIssue": "Lot Number Issue",
  "nce.type.mislabeledUnlabeled": "Mislabeled/unlabeled specimen",
  "nce.type.missingSample": "Missing Sample",
  "nce.type.otherDescribe": "Other, please describe",
  "nce.type.rerunEquipmentFailure": "Rerun - Equipment Failure",
  "nce.type.rerunInconsistentResults": "Rerun - Inconsistent Results",
  "nce.type.rerunQCFailure": "Rerun- QC Failure",
  "nce.type.resultReported": "Result reported when quality control sample tested out of range",
  "nce.type.sopDeviation": "SOP Deviation (please describe)",
  "nce.type.specimenReceiptDelay": "Specimen Receipt Delay",
  "nce.type.spill": "Spill",
  "nce.type.technologyIssue": "Technology/Computer issue",
  "nce.type.transmissionDelay": "Transmission Delay",
  "nce.type.wrongSpecimen": "Wrong specimen",
  "nce.type.wrongTemperature": "Wrong temperature",
  "nce.type.wrongTestKit": "Wrong Test Kit",
  "nce.button.createNce": "Tạo NCE",
  "nce.button.skip": "Bỏ qua",
  "nce.creating": "Đang tạo NCE...",
  "nce.description.placeholder": "Mô tả sự kiện không phù hợp...",
  "nce.error.create.failed": "Tạo NCE thất bại",
  "nce.error.severity.required": "Cần chọn mức độ nghiêm trọng",
  "nce.trigger.mandatory.message": "Bạn phải tạo NCE trước khi tiếp tục thao tác này.",
  "nce.trigger.mandatory.title": "Bắt buộc có NCE",
  "nce.trigger.order_cancellation.message": "Hủy chỉ định có thể cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.order_cancellation.title": "Hủy chỉ định - NCE",
  "nce.trigger.partial_sample_rejection.message": "Từ chối một phần mẫu cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.partial_sample_rejection.title": "Từ chối một phần mẫu - Cần NCE",
  "nce.trigger.pathology_rejection.message": "Từ chối ca giải phẫu bệnh có thể cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.pathology_rejection.title": "Từ chối giải phẫu bệnh - NCE",
  "nce.trigger.premature_disposal.message": "Hủy mẫu sớm có thể cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.premature_disposal.title": "Hủy mẫu sớm - NCE",
  "nce.trigger.qc_invalidation.message": "Vô hiệu hóa QC cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.qc_invalidation.title": "Vô hiệu hóa QC - Cần NCE",
  "nce.trigger.referral_rejection.message": "Từ chối gửi mẫu đi cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.referral_rejection.title": "Từ chối gửi mẫu đi - Cần NCE",
  "nce.trigger.result_rejection_no_retest.message": "Từ chối kết quả không xét nghiệm lại cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.result_rejection_no_retest.title": "Từ chối kết quả - Cần NCE",
  "nce.trigger.result_rejection_retest.message": "Từ chối kết quả có xét nghiệm lại có thể cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.result_rejection_retest.title": "Từ chối kết quả - NCE",
  "nce.trigger.sample_rejection.message": "Từ chối mẫu cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.sample_rejection.title": "Từ chối mẫu - Cần NCE",
  "nce.trigger.test_cancel_no_results.message": "Hủy xét nghiệm có thể cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.test_cancel_no_results.title": "Hủy xét nghiệm - NCE",
  "nce.trigger.test_cancel_with_results.message": "Hủy xét nghiệm đã có kết quả cần ghi nhận một sự kiện không phù hợp.",
  "nce.trigger.test_cancel_with_results.title": "Hủy xét nghiệm - Cần NCE",
  "nce.admin.trigger.config.title": "Cấu hình kích hoạt NCE",
  "nce.admin.trigger.config.description": "Cấu hình thời điểm sự kiện không phù hợp được tự động tạo hoặc nhắc lập.",
  "nce.admin.trigger.behaviors.title": "Hành vi kích hoạt",
  "nce.admin.rejection.mappings.title": "Ánh xạ lý do từ chối",
  "nce.admin.rejection.mappings.description": "Ánh xạ lý do từ chối sang phân loại NCE để tự động điền.",
  "nce.trigger.behavior.mandatory": "Bắt buộc",
  "nce.trigger.behavior.prompted": "Nhắc nhở",
  "nce.trigger.behavior.disabled": "Tắt",
  "nce.trigger.column.type": "Loại kích hoạt",
  "nce.trigger.column.description": "Mô tả",
  "nce.trigger.column.behavior": "Hành vi",
  "nce.trigger.column.active": "Đang dùng",
  "nce.trigger.type.sampleRejection": "Từ chối mẫu",
  "nce.trigger.type.resultRejection": "Từ chối kết quả",
  "nce.trigger.type.qaEvent": "Sự kiện QA",
  "nce.trigger.type.manual": "Thủ công",
  "nce.trigger.update.success": "Đã cập nhật cấu hình kích hoạt",
  "nce.trigger.update.error": "Cập nhật cấu hình kích hoạt thất bại",
  "nce.mapping.add": "Thêm ánh xạ",
  "nce.mapping.edit": "Sửa ánh xạ",
  "nce.mapping.column.rejectionReason": "Lý do từ chối",
  "nce.mapping.column.category": "Phân loại NCE",
  "nce.mapping.column.type": "Loại NCE",
  "nce.mapping.column.severity": "Mức độ mặc định",
  "nce.mapping.column.active": "Đang dùng",
  "nce.mapping.noData": "Chưa cấu hình ánh xạ từ chối nào",
  "nce.mapping.validation.error": "Bắt buộc có lý do từ chối và phân loại",
  "nce.mapping.save.success": "Đã lưu ánh xạ thành công",
  "nce.mapping.active": "Đang dùng",
  "nce.field.category": "Phân loại",
  "nce.field.type": "Loại",
  "nce.select.category": "Chọn phân loại",
  "nce.select.type": "Chọn loại",
  "nce.error.dateOfEvent.required": "Cần nhập ngày xảy ra sự kiện",
  "nce.error.reportingUnit.required": "Cần nhập đơn vị báo cáo",
  "nce.error.description.required": "Cần nhập mô tả",
  "nce.error.suspectedCauses.required": "Cần nhập nguyên nhân nghi ngờ",
  "nce.error.proposedAction.required": "Cần nhập hành động đề xuất",
  "nce.error.category.required": "Cần nhập phân loại",
  "nce.attachment.saveFirst": "Lưu sự kiện NCE để bật đính kèm tệp",
  "nce.attachment.error.noEvent": "Vui lòng lưu sự kiện NCE trước khi tải tệp đính kèm lên",
  "nce.attachment.download": "Tải về",
  "nce.attachment.delete": "Xóa",
  "requester.add.new.restricted": "Quản trị viên đã tắt chức năng thêm tổ chức mới.",
  "requester.add.new.restricted.organization.contact": "Quản trị viên đã tắt chức năng nhập thông tin liên hệ của tổ chức mới. Hãy tìm tổ chức có sẵn ở trên.",
  "requester.add.new.restricted.provider": "Quản trị viên đã tắt chức năng thêm đơn vị cung cấp mới.",
  "requester.add.new.restricted.provider.contact": "Quản trị viên đã tắt chức năng nhập thông tin liên hệ của đơn vị cung cấp mới. Hãy tìm đơn vị có sẵn ở trên.",
  "requester.add.new.restricted.requestor": "Quản trị viên đã tắt chức năng thêm người chỉ định mới. Hãy tìm người chỉ định có sẵn ở trên.",
  "requester.contact.search": "Tìm người chỉ định",
  "requester.contact.search.helper": "Tìm người liên hệ yêu cầu các xét nghiệm này, hoặc nhập người mới bên dưới. Cần có ít nhất một trong hai: Cơ sở chỉ định hoặc Người chỉ định.",
  "requester.organization.add.new": "+ Thêm tổ chức mới \"{name}\"",
  "requester.organization.email": "Email tổ chức",
  "requester.organization.fax": "Fax tổ chức",
  "requester.organization.new.helper": "Sẽ được tạo thành tổ chức mới khi chỉ định này được lưu.",
  "requester.organization.new.tag": "Mới",
  "requester.organization.no.match": "Không tìm thấy tổ chức phù hợp.",
  "requester.organization.phone": "Điện thoại tổ chức",
  "requester.organization.search": "Tìm cơ sở chỉ định",
  "requestor.add.new": "+ Thêm người chỉ định mới \"{name}\"",
  "requestor.add.new.restricted": "Quản trị viên đã tắt chức năng thêm người chỉ định mới.",
  "requestor.department": "Khoa/phòng",
  "requestor.email": "Email",
  "requestor.fax": "Fax",
  "requestor.firstName": "Tên",
  "requestor.lastName": "Họ",
  "requestor.name": "Tên người chỉ định",
  "requestor.name.placeholder": "Nhập tên người chỉ định",
  "requestor.new.helper": "Sẽ được tạo thành người chỉ định mới khi chỉ định này được lưu.",
  "requestor.new.tag": "Mới",
  "requestor.no.match": "Không tìm thấy người chỉ định phù hợp.",
  "requestor.phone": "Điện thoại",
  "requestor.search.helper": "Nhập ít nhất 2 ký tự để tự động tìm.",
  "result.compliance.fail": "KHÔNG ĐẠT",
  "result.compliance.pass": "ĐẠT",
  "result.pool.filter.allLots": "Tất cả lô",
  "result.pool.filter.allPools": "Tất cả nhóm gộp",
  "result.pool.filter.clear": "Xóa bộ lọc",
  "result.pool.filter.count": "Đang hiển thị {shown} trên {total} kết quả",
  "result.pool.filter.lot": "Lọc theo lô",
  "result.pool.filter.pool": "Lọc theo nhóm gộp",
  "result.pool.intake": "Nhóm gộp nhận mẫu",
  "result.pool.subpool": "Nhóm gộp con {n}",
  "result.vectorPool.label": "Gộp {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "Độ không đảm bảo phải là số không âm.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Mẫu",
  "sample.priority.ASAP": "Càng sớm càng tốt",
  "sample.priority.FUTURE_STAT": "STAT tương lai",
  "sample.priority.ROUTINE": "Thường quy",
  "sample.priority.STAT": "STAT (Khẩn)",
  "sample.priority.TIMED": "Theo giờ",
  "sample.referToReferenceLab.helper": "Đánh dấu nếu mẫu này cần xét nghiệm tại phòng xét nghiệm tham chiếu bên ngoài.",
  "sampleAcceptance.action.moveDown": "Chuyển xuống",
  "sampleAcceptance.action.moveUp": "Chuyển lên",
  "sampleAcceptance.banner.resampledFrom": "Đây là mẫu thay thế được tạo do lấy lại mẫu #{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Mẫu thay thế",
  "sampleAcceptance.banner.resampledTo": "Mẫu này đã bị từ chối và được lấy lại. Chỉ định thay thế: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Đã lấy lại mẫu",
  "sampleAcceptance.button.addItem": "Thêm mục",
  "sampleAcceptance.col.active": "Đang dùng",
  "sampleAcceptance.col.label": "Nhãn",
  "sampleAcceptance.col.order": "Thứ tự",
  "sampleAcceptance.col.statusForDomain": "Trạng thái cho lĩnh vực này",
  "sampleAcceptance.domain.all": "Tất cả lĩnh vực",
  "sampleAcceptance.domain.clinical": "Lâm sàng",
  "sampleAcceptance.domain.environmental": "Môi trường",
  "sampleAcceptance.domain.vector": "Véc-tơ",
  "sampleAcceptance.enforcement.help": "Mức bắt buộc được đặt theo nhóm xét nghiệm (domain), không theo nhóm kỹ thuật. Nhân viên tiếp nhận làm việc với nhiều nhóm kỹ thuật.",
  "sampleAcceptance.enforcement.label": "Bắt buộc checklist — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Bắt buộc — chặn Bước 3 cho tới khi hoàn tất",
  "sampleAcceptance.enforcement.off": "Tắt — ẩn checklist",
  "sampleAcceptance.enforcement.optional": "Không bắt buộc — chỉ ghi nhận, không chặn",
  "sampleAcceptance.gate.blocked": "Nhóm này bắt buộc nghiệm thu mẫu khi tiếp nhận — hãy nghiệm thu từng mẫu (hoặc báo NCE / lấy lại mẫu) trước khi chỉ định này được tiếp tục.",
  "sampleAcceptance.labWide.heading": "Mục áp dụng toàn phòng XN (trừ khi nhóm có danh sách riêng)",
  "sampleAcceptance.labWide.inherited": "Mục toàn phòng XN — đang kế thừa (dự phòng đang hoạt động)",
  "sampleAcceptance.labWide.superseded": "Mục toàn phòng XN — đã thay thế tại đây (sửa ở “Tất cả nhóm”)",
  "sampleAcceptance.notify.enforcementSaved": "Đã cập nhật mức bắt buộc",
  "sampleAcceptance.notify.itemAdded": "Đã thêm mục checklist",
  "sampleAcceptance.notify.itemSaved": "Đã lưu mục checklist",
  "sampleAcceptance.notify.recordFailed": "Ghi nhận nghiệm thu thất bại",
  "sampleAcceptance.notify.rejectFailed": "Từ chối mẫu thất bại",
  "sampleAcceptance.notify.resampleFailed": "Yêu cầu lấy lại mẫu thất bại",
  "sampleAcceptance.ownItems.empty": "Chưa có mục nào — nhóm này đang dùng danh sách toàn phòng XN bên dưới.",
  "sampleAcceptance.ownItems.heading": "Mục của {domain}",
  "sampleAcceptance.qa.accepted.success": "Đã ghi nhận nghiệm thu",
  "sampleAcceptance.qa.answer.fail": "Không đạt",
  "sampleAcceptance.qa.answer.na": "Không áp dụng",
  "sampleAcceptance.qa.answer.pass": "Đạt",
  "sampleAcceptance.qa.button.accept": "Nghiệm thu mẫu",
  "sampleAcceptance.qa.button.reject": "Từ chối",
  "sampleAcceptance.qa.button.resample": "Lấy lại mẫu",
  "sampleAcceptance.qa.context.collected": "Lấy mẫu",
  "sampleAcceptance.qa.context.longTransit": "vận chuyển lâu — anh/chị quyết định",
  "sampleAcceptance.qa.context.note": "Thời gian vận chuyển chỉ để tham khảo — không tự chấm điểm. Danh sách đang áp dụng: {domain}.",
  "sampleAcceptance.qa.context.received": "Nhận mẫu",
  "sampleAcceptance.qa.context.transit": "Thời gian vận chuyển",
  "sampleAcceptance.qa.empty": "Nhóm này chưa cấu hình checklist nghiệm thu.",
  "sampleAcceptance.qa.failHint": "Mẫu này có mục không đạt — hãy báo NCE hoặc lấy lại mẫu thay vì nghiệm thu.",
  "sampleAcceptance.qa.failHint.reject": "Mẫu này không đạt kiểm tra. Hãy báo cáo NCE hoặc từ chối mẫu thay vì chấp nhận.",
  "sampleAcceptance.qa.noSample": "Lưu thông tin lấy mẫu để thực hiện nghiệm thu cho mẫu này.",
  "sampleAcceptance.qa.note.label": "Ghi chú (không bắt buộc)",
  "sampleAcceptance.qa.note.placeholder": "Không bắt buộc — ghi chú tình trạng mẫu quan sát được",
  "sampleAcceptance.qa.status.accepted": "Đã nghiệm thu",
  "sampleAcceptance.qa.status.pending": "Chưa xử lý",
  "sampleAcceptance.qa.status.rejected": "Đã từ chối",
  "sampleAcceptance.qa.status.review": "Cần xem lại",
  "sampleAcceptance.qa.subtitle": "Hoàn tất checklist nghiệm thu cho mẫu này",
  "sampleAcceptance.qa.subtitle.rejected": "Mẫu này đã bị từ chối và lấy lại — chỉ xem.",
  "sampleAcceptance.qa.subtitle.rejectedEqa": "Mẫu này đã bị từ chối — chỉ xem.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "Mẻ thu này đã bị từ chối — chỉ xem.",
  "sampleAcceptance.qa.title": "Nghiệm thu mẫu khi tiếp nhận",
  "sampleAcceptance.reject.commit": "Xác nhận từ chối",
  "sampleAcceptance.reject.comment.label": "Bình luận (không bắt buộc)",
  "sampleAcceptance.reject.info": "Từ chối mẻ thu này vì không dùng được. Mẫu không thể thu lại nên sẽ không tạo chỉ định thay thế.",
  "sampleAcceptance.reject.info.eqa": "Từ chối mẫu thử nghiệm năng lực này. Mẫu PT không lấy lại được nên sẽ không tạo chỉ định thay thế.",
  "sampleAcceptance.reject.reason.label": "Lý do (tự điền từ các mục không đạt — có thể sửa)",
  "sampleAcceptance.reject.reason.required": "Cần nhập lý do",
  "sampleAcceptance.reject.success": "Đã từ chối mẫu.",
  "sampleAcceptance.reject.title": "Từ chối — {labNumber}",
  "sampleAcceptance.resample.commit": "Xác nhận lấy lại mẫu",
  "sampleAcceptance.resample.info": "Từ chối mẫu này và tạo chỉ định lấy mẫu mới để thu lại. Người chỉ định sẽ được thông báo.",
  "sampleAcceptance.resample.reason.label": "Lý do (tự điền từ các mục không đạt — có thể sửa)",
  "sampleAcceptance.resample.reason.required": "Nhập lý do lấy lại mẫu.",
  "sampleAcceptance.resample.success": "Đã tạo yêu cầu lấy lại mẫu — chỉ định mới {accession}. Đã thông báo người chỉ định.",
  "sampleAcceptance.resample.title": "Lấy lại mẫu — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Đủ điều kiện",
  "sampleAcceptance.review.col.labNo": "Mã mẫu",
  "sampleAcceptance.review.col.sampleType": "Loại mẫu",
  "sampleAcceptance.review.col.transit": "Vận chuyển",
  "sampleAcceptance.review.noSamples": "Chưa có mẫu đã lấy để xem xét.",
  "sampleAcceptance.review.subtitle": "Chọn một mẫu để hoàn tất checklist nghiệm thu",
  "sampleAcceptance.review.title": "Nghiệm thu mẫu khi tiếp nhận",
  "sampleAcceptance.status.active": "Đang áp dụng",
  "sampleAcceptance.status.inactive": "Không áp dụng",
  "sampleAcceptance.status.inheritedActive": "Đang áp dụng (kế thừa)",
  "sampleAcceptance.status.superseded": "Đã thay thế",
  "sampleAcceptance.title": "Checklist nghiệm thu mẫu",
  "sidenav.label.admin.nceTriggerConfig": "Cấu hình điều kiện kích hoạt",
  "sidenav.label.admin.nceCategoryType": "Nhóm & loại",
  "sidenav.label.admin.nceConfig": "Cấu hình NCE",
  "nce.admin.categorytype.title": "Cấu hình nhóm & loại sự không phù hợp (NCE)",
  "nce.admin.categorytype.description": "Quản lý các nhóm và loại dùng cho sự kiện không phù hợp (NCE).",
  "nce.admin.tab.categories": "Nhóm",
  "nce.admin.tab.types": "Loại",
  "nce.admin.category.add": "Thêm nhóm",
  "nce.admin.category.edit": "Sửa nhóm",
  "nce.admin.category.name.required": "Cần nhập tên nhóm",
  "nce.admin.category.save.success": "Đã lưu nhóm",
  "nce.admin.category.save.error": "Lưu nhóm thất bại",
  "nce.admin.type.add": "Thêm loại",
  "nce.admin.type.edit": "Sửa loại",
  "nce.admin.type.validation.error": "Cần nhập tên loại và chọn nhóm",
  "nce.admin.type.save.success": "Đã lưu loại",
  "nce.admin.type.save.error": "Lưu loại thất bại",
  "nce.admin.column.name": "Tên",
  "nce.admin.column.displayKey": "Khóa hiển thị",
  "nce.admin.column.typesCount": "Số loại",
  "nce.admin.column.category": "Nhóm",
  "nce.admin.column.actions": "Thao tác",
  "nce.admin.field.name": "Tên",
  "nce.admin.field.displayKey": "Khóa hiển thị (cho i18n)",
  "nce.admin.field.displayKey.helper": "Không bắt buộc. Dùng cho bản dịch.",
  "nce.admin.field.category": "Nhóm",
  "nce.admin.delete.confirm.title": "Xác nhận xóa",
  "nce.admin.delete.confirm.message": "Bạn có chắc muốn xóa '{name}'? Thao tác này không thể hoàn tác.",
  "nce.admin.delete.success": "Đã xóa",
  "nce.inline.title": "Báo sự kiện không phù hợp (NCE)",
  "nce.inline.context": "BỐI CẢNH (tự động điền)",
  "nce.dashboard.breadcrumb": "NCE > All NCEs",
  "nce.dashboard.title": "Tất cả NCE",
  "nce.dashboard.subtitle": "Tất cả NCE đang mở trong phòng XN",
  "nce.dashboard.daysSince": "{count} days",
  "nce.button.reportNce": "Báo NCE",
  "nce.search.placeholder": "Tìm NCE...",
  "nce.filter.allStatus": "Mọi trạng thái",
  "nce.filter.allCategories": "Mọi nhóm",
  "nce.filter.allSeverities": "Mọi mức độ",
  "nce.filter.clearAll": "Xóa lọc",
  "nce.summary.critical": "Nghiêm trọng",
  "nce.summary.major": "Lớn",
  "nce.summary.minor": "Nhỏ",
  "nce.summary.overdue": "Quá hạn",
  "nce.tag.overdue": "Quá hạn",
  "nce.tab.eventDetails": "Chi tiết sự kiện",
  "nce.tab.investigation": "Điều tra",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "Lịch sử",
  "nce.field.suspectedCauses": "Nguyên nhân nghi ngờ",
  "nce.field.proposedAction": "Hành động đề xuất",
  "nce.field.trigger": "Điều kiện kích hoạt",
  "nce.capReason.time_24h": "{count} mẫu liên kết — giới hạn trong 24 giờ",
  "nce.capReason.count_50": "{count} mẫu liên kết — giới hạn 50 mẫu gần nhất",
  "nce.capa.noItems": "Chưa ghi nhận hành động khắc phục/phòng ngừa nào.",
  "nce.capa.dueDate": "Hạn hoàn thành",
  "nce.history.noItems": "Chưa có lịch sử.",
  "nce.history.system": "Hệ thống",
  "nce.action.acknowledge": "Xác nhận đã nhận",
  "nce.action.assignTo": "Giao cho",
  "nce.action.addNote": "Thêm ghi chú",
  "nce.action.close": "Đóng NCE",
  "nce.action.startCorrectiveAction": "Bắt đầu hành động khắc phục",
  "nce.link.duplicate.warning": "Các mẫu này đã được liên kết với NCE này",
  "nce.list.empty": "Không tìm thấy NCE nào khớp tiêu chí.",
  "nce.modal.addNote": "Thêm ghi chú",
  "nce.modal.addNoteDescription": "Thêm ghi chú cho NCE {nceNumber}",
  "nce.modal.notePlaceholder": "Nhập ghi chú...",
  "nce.modal.assign": "Giao NCE",
  "nce.modal.assignDescription": "Giao NCE {nceNumber} cho người dùng",
  "nce.modal.selectUser": "Chọn người dùng",
  "nce.modal.searchUser": "Tìm người dùng...",
  "nce.assign.selectUser": "Vui lòng chọn người dùng để giao việc",
  "nce.assign.success": "Đã giao NCE",
  "nce.assign.error": "Giao NCE thất bại",
  "nce.acknowledge.success": "Đã xác nhận NCE",
  "nce.acknowledge.error": "Xác nhận NCE thất bại",
  "nce.note.empty": "Vui lòng nhập ghi chú",
  "nce.note.success": "Đã thêm ghi chú",
  "nce.note.error": "Thêm ghi chú thất bại",
  "nce.attachment.downloadError": "Tải tệp đính kèm thất bại",
  "nce.attachment.viewError": "Mở tệp đính kèm thất bại",
  "not.available": "Không có sẵn",
  "not.specified": "Chưa xác định",
  "notAuthenticated": "Chưa xác thực",
  "notebook.attachments.title": "Tệp đính kèm",
  "notebook.attachments.uploadPrompt": "bấm để tải tệp lên",
  "notebook.auditTrail.action.archived": "Đã lưu trữ",
  "notebook.auditTrail.action.created": "Đã tạo",
  "notebook.auditTrail.action.finalized": "Đã hoàn tất",
  "notebook.auditTrail.action.locked": "Đã khóa",
  "notebook.auditTrail.action.submitted": "Đã gửi duyệt",
  "notebook.auditTrail.action.updated": "Đã cập nhật",
  "notebook.auditTrail.comingSoon": "Chức năng nhật ký kiểm toán sẽ có sớm.",
  "notebook.auditTrail.none.subtitle": "Chưa có mục nhật ký kiểm toán nào cho sổ này.",
  "notebook.auditTrail.none.title": "Chưa có nhật ký kiểm toán",
  "notebook.auditTrail.title": "Nhật ký kiểm toán",
  "notebook.button.edit": "Sửa",
  "notebook.button.editResults": "Sửa kết quả",
  "notebook.button.enterResults": "Nhập kết quả",
  "notebook.button.newLabNotebook": "Dự án",
  "notebook.button.view": "Xem",
  "notebook.comments.add.button": "Thêm bình luận",
  "notebook.comments.add.label": "Thêm bình luận",
  "notebook.comments.none.subtitle": "Chưa có bình luận nào.",
  "notebook.comments.none.title": "Chưa có bình luận",
  "notebook.comments.title": "Bình luận",
  "notebook.error.notAssigned": "Bạn chưa được giao dự án này",
  "notebook.heading.allEntries": "Tất cả mục",
  "notebook.heading.notebooks": "Dự án",
  "notebook.icon.edit": "Sửa",
  "notebook.instruments.title": "Thiết bị",
  "notebook.label.addpage": "Thêm trang",
  "notebook.label.author": "Tác giả",
  "notebook.label.basicinfo": "Thông tin cơ bản",
  "notebook.label.content": "Nội dung chính",
  "notebook.label.dashboard": "Bàn làm việc sổ ghi chép",
  "notebook.label.drafts": "Bản nháp",
  "notebook.label.entry": "Mục sổ ghi chép",
  "notebook.label.entryFiles": "Tệp của mục",
  "notebook.label.instanceEntry": "Mục sổ ghi chép (bản thể)",
  "notebook.label.entryTags": "Thẻ của mục",
  "notebook.label.experimentDoc": "Tài liệu thí nghiệm",
  "notebook.label.experimentType": "Loại thí nghiệm",
  "notebook.label.filter.types": "Loại thí nghiệm",
  "notebook.label.finalized": "Đã hoàn tất trong tuần này",
  "notebook.label.formEntry": "Mục biểu mẫu sổ ghi chép",
  "notebook.label.objective": "Mục tiêu",
  "notebook.label.pages": "Các trang quy trình",
  "notebook.label.pending": "Chờ xem xét",
  "notebook.label.project": "Dự án",
  "notebook.label.project.title": "Tên dự án",
  "notebook.label.projectFiles": "Tệp dự án",
  "notebook.label.projectTags": "Thẻ dự án",
  "notebook.label.protocol": "Mã quy trình",
  "notebook.label.questionnaire": "Phiếu khảo sát",
  "notebook.label.sampleManagement": "Quản lý mẫu",
  "notebook.label.status": "Trạng thái",
  "notebook.label.technician": "Kỹ thuật viên",
  "notebook.label.title": "Tiêu đề mục",
  "notebook.label.total": "Tổng số mục",
  "notebook.page.completed": "Đã hoàn thành",
  "notebook.page.content": "Nội dung:",
  "notebook.page.instructions": "Hướng dẫn:",
  "notebook.page.markComplete": "Đánh dấu hoàn thành",
  "notebook.page.modal.add.errorRequired": "Cần nhập tiêu đề và nội dung.",
  "notebook.page.modal.add.title": "Thêm trang mới",
  "notebook.page.modal.content.label": "Nội dung",
  "notebook.page.modal.edit.title": "Sửa trang",
  "notebook.page.modal.instructions.label": "Hướng dẫn",
  "notebook.page.modal.title.label": "Tiêu đề",
  "notebook.page.title": "Sổ ghi chép",
  "notebook.pages.none.subtitle": "Bấm để thêm trang",
  "notebook.pages.none.title": "Chưa có trang nào",
  "notebook.project.definition.form.title": "Biểu mẫu định nghĩa dự án",
  "notebook.project.entry.form.title": "Biểu mẫu mục dự án",
  "notebook.results.modal.title": "Kết quả cho {accession}",
  "notebook.results.noAccession": "Mẫu này chưa có số chỉ định",
  "notebook.results.none.subtitle": "Không tìm thấy kết quả với số chỉ định đã nhập.",
  "notebook.results.none.title": "Không có kết quả",
  "notebook.results.title": "Kết quả",
  "notebook.sample.result.dateCreated": "Ngày tạo",
  "notebook.samples.available": "Mẫu có sẵn",
  "notebook.samples.none.subtitle": "Tìm mẫu theo bệnh nhân hoặc số chỉ định",
  "notebook.samples.none.subtitle.selected": "Bấm để thêm mẫu",
  "notebook.samples.none.title": "Không có mẫu",
  "notebook.samples.none.title.selected": "Chưa chọn mẫu",
  "notebook.samples.resultsRecorded": "Đã ghi kết quả:",
  "notebook.samples.selected": "Mẫu đã chọn",
  "notebook.search.byAccession": "Tìm theo số chỉ định",
  "notebook.search.byPatient": "Tìm theo bệnh nhân",
  "notebook.select.label": "Chọn sổ ghi chép",
  "notebook.select.none": "Không — chỉ các trường mặc định",
  "notebook.select.optional": "Chọn sổ ghi chép (không bắt buộc)",
  "notebook.status.archived": "Lưu trữ mục",
  "notebook.status.assignment.title": "Trạng thái và phân công",
  "notebook.status.draft": "Lưu nháp",
  "notebook.status.finalized": "Hoàn tất mục",
  "notebook.status.locked": "Khóa mục",
  "notebook.status.metadata.title": "Trạng thái & siêu dữ liệu",
  "notebook.status.submitted": "Gửi duyệt",
  "notebook.tab.attachments": "Tệp đính kèm",
  "notebook.tab.auditTrail": "Nhật ký kiểm toán",
  "notebook.tab.comments": "Bình luận",
  "notebook.tab.content": "Nội dung",
  "notebook.tab.entryDetails": "Chi tiết mục",
  "notebook.tab.metadata": "Siêu dữ liệu",
  "notebook.tab.results": "Kết quả",
  "notebook.tab.samples": "Mẫu",
  "notebook.tab.workflow": "Quy trình",
  "notebook.table.header.entries": "Mục",
  "notebook.tag.placeholder": "Nhập thẻ",
  "notebook.tags.add": "Thêm thẻ",
  "notebook.tags.modal.add.errorRequired": "Cần nhập thẻ.",
  "notebook.tags.modal.add.label": "Thẻ",
  "notebook.tags.modal.add.title": "Thêm thẻ mới",
  "notebook.tags.title": "Thẻ",
  "notebook.validation.content.required": "Cần nhập nội dung chính.",
  "notebook.validation.objective.required": "Cần nhập mục tiêu.",
  "notebook.validation.project.required": "Cần chọn dự án.",
  "notebook.validation.protocol.required": "Cần nhập mã quy trình.",
  "notebook.validation.title.required": "Cần nhập tiêu đề.",
  "notebook.validation.type.required": "Cần chọn loại thí nghiệm.",
  "notification.error": "Lỗi",
  "notification.info": "Thông tin",
  "notification.invalid.confirm.password": "Mật khẩu nhập lại không khớp với mật khẩu phía trên.",
  "notification.invalid.loginName": "Tên đăng nhập chỉ được chứa chữ cái và các ký tự . _ @ - (không có chữ số).",
  "notification.invalid.name": "Vui lòng chỉ nhập chữ và số.",
  "notification.invalid.password": "Vui lòng nhập mật khẩu theo hướng dẫn.",
  "notification.login.generic.error": "Lỗi khi đăng nhập",
  "notification.login.syntax.error": "Lỗi khi đăng nhập — không đọc được phản hồi JSON",
  "notification.organization.post.delete.success": "Đã ngừng hoạt động tổ chức.",
  "notification.organization.post.internetAddress": "Nhập địa chỉ URL tổ chức hợp lệ.",
  "notification.organization.post.save.success": "Đã thêm thông tin tổ chức.",
  "notification.organization.post.success": "Đã cập nhật thông tin tổ chức.",
  "notification.password.change.fail": "Đổi mật khẩu thất bại",
  "notification.password.change.success": "Đã đổi mật khẩu",
  "notification.response.syntax.error": "Lỗi — không đọc được phản hồi JSON",
  "notification.resultSelectList.post.save.success": "Đã lưu danh sách chọn kết quả.",
  "notification.resultSelectList.post.update.success": "Đã cập nhật danh sách chọn kết quả.",
  "notification.slideover.button.hideread": "Ẩn đã đọc",
  "notification.slideover.button.markallasread": "Đánh dấu tất cả đã đọc",
  "notification.slideover.button.markasread": "Đánh dấu đã đọc",
  "notification.slideover.button.reload": "Tải lại",
  "notification.slideover.button.showread": "Hiện đã đọc",
  "notification.slideover.button.subscribe": "Đăng ký nhận trên thiết bị này",
  "notification.slideover.button.subscribe.fail": "Đăng ký thất bại",
  "notification.slideover.button.subscribe.success": "Đã đăng ký",
  "notification.slideover.button.unsubscribe": "Hủy đăng ký",
  "notification.slideover.button.unsubscribe.fail": "Hủy đăng ký thất bại",
  "notification.slideover.button.unsubscribe.success": "Đã hủy đăng ký",
  "notification.slideover.empty.header": "Bạn đã xem hết thông báo",
  "notification.sliderover.empty.message": "Hiện không có thông báo nào.",
  "notification.success": "Thành công",
  "notification.title": "Thông báo",
  "notification.user.add.success": "Đã thêm thông tin người dùng.",
  "notification.user.post.delete.success": "Đã ngừng hoạt động người dùng.",
  "notification.user.post.save.success": "Đã thêm thông tin người dùng.",
  "notification.user.update.success": "Đã cập nhật thông tin người dùng.",
  "notify.error": "Cần chọn người dùng và nhập nội dung thông báo",
  "notify.main.title": "Thông báo người dùng",
  "notify.message": "Nội dung",
  "notify.user.by": "Người dùng cần thông báo",
  "notify.user.success.notification": "Đã gửi thông báo",
  "of": "trên",
  "openreports.activity.title": "Báo cáo hoạt động",
  "openreports.aggregate.title": "Báo cáo tổng hợp",
  "openreports.all.test.summary.title": "Tổng hợp báo cáo xét nghiệm",
  "openreports.all.tests.aggregate": "Tổng hợp tất cả xét nghiệm",
  "openreports.hiv.aggregate": "Tổng hợp xét nghiệm HIV",
  "openreports.management.title": "Báo cáo quản lý",
  "openreports.mgt.nonconformity.date": "Báo cáo sự không phù hợp theo ngày",
  "openreports.mgt.nonconformity.section": "Báo cáo sự không phù hợp theo đơn vị và nguyên nhân",
  "openreports.mgt.rejection": "Báo cáo từ chối mẫu",
  "openreports.patient.EID.version1": "EID phiên bản 1",
  "openreports.patient.EID.version2": "EID phiên bản 2",
  "openreports.patient.VL.version1": "VL phiên bản quốc gia",
  "openreports.patientTestStatus": "Báo cáo trạng thái bệnh nhân",
  "openreports.patientreports.title": "Báo cáo trạng thái bệnh nhân",
  "openreports.stat.aggregate": "Báo cáo thống kê",
  "order.accept": "Nhận",
  "order.accept.error": "Nhận chỉ định thất bại",
  "order.additionalInfo": "Thông tin bổ sung",
  "order.additionalInfo.helper": "Ghi chú thêm về chỉ định này (không bắt buộc)",
  "order.clinicalInfo": "Thông tin lâm sàng",
  "order.continue": "Tiếp tục",
  "order.current.time": "Giờ hiện tại (hh:mm)",
  "order.dashboard.empty": "Không tìm thấy chỉ định nào",
  "order.dashboard.title": "Bảng chỉ định",
  "order.department.label": "khoa/phòng/đơn vị:",
  "order.diagnosis.helper": "Chẩn đoán làm việc — để chọn xét nghiệm. Không ghi nhận như chẩn đoán xác định.",
  "order.diagnosis.placeholder": "Nhập chẩn đoán hoặc ghi chú lâm sàng",
  "order.entry.setup": "Thiết lập nhập chỉ định hàng loạt",
  "order.external": "Bên ngoài",
  "order.facility": "Cơ sở",
  "order.filter.priority": "Lọc theo ưu tiên",
  "order.filter.status": "Lọc theo trạng thái",
  "order.fixIssue": "Sửa lỗi",
  "order.form.label": "Biểu mẫu:",
  "order.form.select": "Chọn biểu mẫu",
  "order.generate.barcode": "Tạo mã vạch và lưu",
  "order.generate.barcode.history": "Số chỉ định đã dùng trước đó",
  "order.if.other.label": "nếu khác, ghi rõ:",
  "order.invalid.requester.name.label": "tên người chỉ định không hợp lệ",
  "order.invalid.site.name": "Tên đơn vị không hợp lệ",
  "order.labNumber": "Mã mẫu",
  "order.labNumber.generate": "Tạo mã mẫu",
  "order.labNumber.helper": "Mã định danh duy nhất cho chỉ định này",
  "order.attachment.action.delete": "Xóa tệp đính kèm",
  "order.attachment.action.download": "Tải tệp đính kèm",
  "order.attachment.action.view": "Xem tệp đính kèm",
  "order.attachment.column.actions": "Thao tác",
  "order.attachment.column.fileName": "Tên tệp",
  "order.attachment.column.fileSize": "Dung lượng",
  "order.attachment.column.fileType": "Loại",
  "order.attachment.column.uploadedAt": "Tải lên lúc",
  "order.attachment.delete.confirm.body": "Bạn có chắc muốn xóa \"{fileName}\"? Không thể hoàn tác.",
  "order.attachment.delete.confirm.title": "Xóa tệp đính kèm",
  "order.attachment.delete.failed": "Không thể xóa tệp đính kèm. Vui lòng thử lại.",
  "order.attachment.dropzone": "Kéo và thả tệp vào đây, hoặc bấm để chọn",
  "order.attachment.empty": "Chưa có tệp đính kèm.",
  "order.attachment.saveFirst": "Lưu chỉ định trước khi thêm tệp đính kèm.",
  "order.attachment.error.maxFiles": "Tối đa {maxFiles} tệp đính kèm.",
  "order.attachment.error.size": "Mỗi tệp phải có dung lượng tối đa {maxSize}.",
  "order.attachment.error.type": "Loại tệp được phép: {types}",
  "order.attachment.heading": "Tệp đính kèm",
  "order.attachment.hint": "Không bắt buộc. Tối đa {maxFiles} tệp, mỗi tệp 10MB. Cho phép: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "Một hoặc nhiều tệp đính kèm không tải lên được.",
  "order.labNumber.placeholder": "Nhập hoặc tạo mã mẫu",
  "order.label.add": "Thêm chỉ định",
  "order.label.modify": "Sửa chỉ định",
  "order.legend.EDTATube": "Ống EDTA",
  "order.legend.commonFields": "Trường chung",
  "order.legend.configureBarcode": "Cấu hình nhập mã vạch",
  "order.legend.dryBloodSpot": "Giọt máu khô",
  "order.legend.dryTube": "Ống khô",
  "order.legend.facility": "Cơ sở",
  "order.legend.onDemand": "Theo yêu cầu",
  "order.legend.optionalFields": "Trường tùy chọn",
  "order.legend.patient": "Thông tin bệnh nhân",
  "order.legend.preDemand": "In sẵn",
  "order.legend.sample": "Mẫu",
  "order.legend.selectMethod": "Chọn phương thức",
  "order.legend.siteName": "Tên đơn vị",
  "order.legend.specimen.collected": "Mẫu đã lấy",
  "order.legend.tests": "Xét nghiệm",
  "order.legend.viralLoadTest": "Xét nghiệm tải lượng virus",
  "order.lastUpdated": "Cập nhật lần cuối",
  "order.load.error": "Tải chỉ định thất bại",
  "order.location": "Vị trí",
  "order.new": "Chỉ định mới",
  "order.payment.status.label": "Tình trạng thanh toán của bệnh nhân:",
  "order.paymentStatus": "Tình trạng thanh toán",
  "order.previousLabNumber": "Mã mẫu trước đó",
  "order.previousLabNumber.placeholder": "Nhập mã mẫu trước đó nếu có",
  "order.printLabels": "In nhãn",
  "order.printLabels.info": "In mã vạch cho chỉ định này",
  "order.priority": "Ưu tiên",
  "order.progress": "Tiến độ",
  "order.provisionalDiagnosis": "Chẩn đoán sơ bộ",
  "order.received.time": "Giờ nhận mẫu (hh:mm)",
  "order.reception.time": "Giờ tiếp nhận (hh:mm) :",
  "order.remember.site.and.requester.label": "Ghi nhớ đơn vị và người chỉ định",
  "order.readonly.message": "Chỉ định này đang ở chế độ chỉ xem",
  "order.requester": "Người chỉ định",
  "order.requester.email.label": "Email người chỉ định:",
  "order.requester.fax.label": "Số fax người chỉ định:",
  "order.requester.firstName.label": "Tên đệm + tên người chỉ định:",
  "order.requester.lastName.label": "Họ người chỉ định:",
  "order.requester.phone.label": "Điện thoại người chỉ định:",
  "order.requester.provisionalDiagnosis.label": "Chẩn đoán lâm sàng sơ bộ:",
  "order.result.reporting.heading": "BÁO CÁO KẾT QUẢ",
  "order.sampleCategory": "Nhóm mẫu",
  "order.sampleCategory.helper": "Chọn nhóm mẫu cần lấy",
  "order.sampling.performed.label": "Lấy mẫu để phân tích:",
  "order.search.requester.label": "Tìm người chỉ định",
  "order.saveStatus.error": "Lưu thất bại",
  "order.saveStatus.saved": "Đã lưu",
  "order.saveStatus.saving": "Đang lưu...",
  "order.saveStatus.unsaved": "Có thay đổi chưa lưu",
  "order.save.blocked": "Chỉ định chưa được lưu",
  "order.save.notPersisted": "Máy chủ đã nhận chỉ định nhưng không lưu mẫu nào cho chỉ định này. Hãy kiểm tra lại chỉ định trước khi tiếp tục.",
  "order.save.incomplete": "Vui lòng thêm bệnh nhân (hoặc điểm lấy mẫu) và ít nhất một loại mẫu trước khi lưu.",
  "order.save.incomplete.fields": "Thêm {fields} trước khi lưu.",
  "order.save.incomplete.and": "và",
  "order.save.requirements.title": "Cần có trước khi lưu",
  "order.save.requirement.labNumber": "mã mẫu",
  "order.save.requirement.patient": "bệnh nhân",
  "order.save.requirement.samplingSite": "điểm lấy mẫu",
  "order.save.requirement.collectionSite": "nơi lấy mẫu",
  "order.save.requirement.requesterOrRequestor": "đơn vị hoặc người chỉ định",
  "order.sample.missingTests": "Mẫu {sampleNumber} đã có loại mẫu nhưng chưa có xét nghiệm. Thêm xét nghiệm hoặc xóa mẫu trước khi lưu.",
  "order.sample.missingTests.named": "Mẫu {sampleNumber}: {sampleType} chưa có xét nghiệm. Thêm xét nghiệm hoặc gỡ mẫu trước khi lưu.",
  "order.save.requirement.sampleType": "ít nhất một loại mẫu",
  "order.save.requirement.site": "đơn vị gửi chỉ định",
  "order.save.requirement.patientSex": "giới tính bệnh nhân",
  "order.save.requirement.patientBirthDate": "ngày sinh bệnh nhân",
  "order.save.requirement.nationalId": "số CCCD của bệnh nhân",
  "order.save.requirement.validEmail": "địa chỉ email hợp lệ",
  "order.requestDate": "Ngày chỉ định",
  "order.nextVisitDate": "Ngày tái khám",
  "order.sampleHandling": "Xử lý mẫu",
  "sampleAcceptance.qa.button.continueWithTesting": "Tiếp tục xét nghiệm",
  "sampleAcceptance.qa.continueWithTesting.reason": "Vì sao mẫu này vẫn được xét nghiệm dù có mục không đạt?",
  "sampleAcceptance.qa.continueWithTesting.record": "Ghi nhận và tiếp tục",
  "order.eqaSample": "Mẫu đánh giá chất lượng bên ngoài (EQA)",
  "order.noPatient": "Chỉ định này không có bệnh nhân",
  "order.noPatient.reason": "Lý do chỉ định không có bệnh nhân",
  "order.noPatient.reason.eqa": "Mẫu đánh giá chất lượng bên ngoài",
  "order.noPatient.warning.title": "Kết quả sẽ không được đối chiếu với khoảng tham chiếu",
  "order.noPatient.warning.subtitle": "Không có bệnh nhân thì không có tuổi và giới tính để chọn khoảng tham chiếu, nên kết quả của chỉ định này sẽ không được đánh dấu bình thường hay bất thường.",
  "order.noPatient.butPatientChosen": "Chỉ định đã gắn bệnh nhân nên quyết định “không có bệnh nhân” sẽ không được ghi nhận.",
  "order.rangeNotApplied.warning.title": "Một số kết quả sẽ không được đối chiếu với khoảng tham chiếu",
  "order.rangeNotApplied.warning.subtitle": "Chưa ghi nhận giới tính hoặc tuổi của bệnh nhân, trong khi các xét nghiệm này có khoảng tham chiếu phụ thuộc vào yếu tố đó: {tests}. Kết quả cần được xem xét trước khi phát hành.",
  "order.rangeNotApplied.warning.reportNce": "Báo NCE",
  "order.eqa.program": "Chương trình EQA",
  "order.eqa.providerSampleId": "Mã mẫu của nhà cung cấp",
  "order.eqa.deadline": "Hạn nộp kết quả",
  "order.eqa.priority": "Ưu tiên EQA",
  "order.rememberSiteAndRequester": "Ghi nhớ đơn vị và người chỉ định cho chỉ định kế tiếp",
  "order.testLocationCode": "Lấy mẫu thực hiện tại",
  "order.testLocationCode.other": "Khác",
  "order.testLocationCode.otherLabel": "Nếu khác, ghi rõ",
  "provider.fax.invalid": "Nhập số fax hợp lệ, chỉ gồm chữ số và các ký tự + ( ) -.",
  "provider.email.invalid": "Nhập địa chỉ email hợp lệ, ví dụ lab@example.org.",
  "order.save.requirement.provider": "bác sĩ chỉ định",
  "order.save.requirement.testsPerSample": "ít nhất một xét nghiệm hoặc bộ xét nghiệm trên mỗi mẫu",
  "order.saved.draft": "Đã lưu nháp",
  "order.saved.title": "Đã lưu chỉ định {labNumber}",
  "order.saved.next": "Tiếp theo: {step}",
  "order.search.placeholder": "Tìm chỉ định...",
  "order.search.site.name": "Tìm tên đơn vị",
  "order.send.toAnalyzer": "Gửi tới máy xét nghiệm",
  "order.send.modal.title": "Gửi chỉ định tới máy xét nghiệm",
  "order.send.modal.confirm": "Gửi",
  "order.send.modal.cancel": "Hủy",
  "order.send.modal.analyzerLabel": "Máy xét nghiệm đích",
  "order.send.modal.accession": "Số chỉ định: {accession}",
  "order.send.modal.noAnalyzers": "Chưa cấu hình máy xét nghiệm nào để LIS chủ động gửi chỉ định.",
  "order.send.success": "Đã gửi chỉ định",
  "order.send.error": "Gửi chỉ định thất bại",
  "order.send.unknownError": "Lỗi cầu nối không xác định",
  "order.send.missingAccession": "Chỉ định chưa có số chỉ định để đối chiếu kết quả.",
  "order.site.name": "Tên đơn vị:",
  "order.step.collect": "Lấy mẫu",
  "order.step.complete": "Hoàn tất",
  "order.step.enter": "Nhập chỉ định",
  "order.step.label": "Dán nhãn & lưu",
  "order.step.patient.info": "Thông tin bệnh nhân",
  "order.step.program.selection": "Chọn chương trình",
  "order.step.qa": "Xem xét QA",
  "order.step.prepare": "Chuẩn bị mẫu",
  "order.step.sampleCheck": "Kiểm tra mẫu",
  "order.step.notStarted": "Chưa bắt đầu",
  "order.step.done": "Xong",
  "order.step.doneAt": "Xong {time}",
  "order.step.toDo": "còn {count} việc",
  "order.step.ready": "Sẵn sàng",
  "order.nav.saveExit": "Lưu và thoát",
  "order.nav.saveNext": "Lưu và tiếp",
  "order.nav.saveFinish": "Lưu và hoàn tất",
  "order.nav.discard.title": "Bỏ các thay đổi chưa lưu?",
  "order.nav.discard.body": "Các thay đổi chưa lưu ở trang này sẽ mất ({samples} mẫu, {tests} xét nghiệm).",
  "order.nav.discard.order": "Bỏ chỉ định",
  "order.nav.discard.changes": "Bỏ thay đổi",
  "order.continue.heading": "Để tiếp tục tới {step}",
  "order.continue.count": "Cần {count} mục để tiếp tục",
  "order.continue.countOne": "Cần 1 mục để tiếp tục",
  "order.continue.item.patient": "Chọn hoặc tạo bệnh nhân",
  "order.continue.item.labNumber": "Thêm mã mẫu",
  "order.continue.item.nationalId": "Nhập số CCCD của bệnh nhân",
  "order.continue.item.patientSex": "Chọn giới tính bệnh nhân",
  "order.continue.item.birthDate": "Nhập ngày sinh bệnh nhân",
  "order.continue.item.sampleType": "Thêm ít nhất một loại mẫu",
  "order.continue.item.provider": "Thêm bác sĩ chỉ định",
  "order.continue.item.noTests": "Mẫu {number}: chọn ít nhất một xét nghiệm",
  "order.continue.item.noTestsOnSample": "{sample} chưa có xét nghiệm. Thêm ở Nhập chỉ định hoặc xóa mẫu",
  "errors.samples.with.no.tests": "Có mẫu chưa có xét nghiệm. Thêm xét nghiệm ở Nhập chỉ định hoặc xóa mẫu.",
  "order.continue.item.collectionTime": "Ngày và giờ lấy mẫu của {sample}",
  "order.continue.item.consent": "Ghi nhận sự đồng ý",
  "order.continue.item.acceptance": "Trả lời checklist nghiệm thu mẫu",
  "order.status.entered": "Đã nhập",
  "order.status.samplesPrepared": "Đã chuẩn bị mẫu",
  "order.status.readyForTesting": "Sẵn sàng xét nghiệm",
  "order.status.cancelled": "Đã hủy",
  "order.status.complete": "Hoàn tất",
  "order.cancelled.notice": "Chỉ định này đã bị hủy: {reason}",
  "order.cancelled": "Chỉ định này đã bị hủy",
  "order.notFound": "Không tìm thấy chỉ định",
  "order.cancel.reasonRequired": "Cần nhập lý do hủy",
  "order.cancel.complete": "Đã nhập xong chỉ định; không thể hủy chỉ định này tại đây nữa",
  "order.cancel.inProgress": "Đã bắt đầu xét nghiệm cho chỉ định này; không thể hủy tại đây nữa",
  "order.release.prepareIncomplete": "Chưa hoàn tất Chuẩn bị mẫu",
  "order.release.reasonRequired": "Cần nhập lý do chuyển xét nghiệm khi chưa nghiệm thu đủ mọi mẫu",
  "order.finish.title": "Đã hoàn tất chỉ định {labNo}",
  "order.finish.subtitle": "Đã nhập xong chỉ định. Có thể nhập kết quả khi có.",
  "order.finish.backToOrders": "Quay về danh sách chỉ định",
  "order.finish.awaiting": "Vẫn chờ mẫu: {tests}",
  "order.sampleCheck.release": "Chuyển sang xét nghiệm",
  "order.sampleCheck.return": "Quay lại Chuẩn bị mẫu",
  "order.sampleCheck.proceedReason": "Lý do chuyển xét nghiệm khi chưa nghiệm thu đủ mọi mẫu",
  "order.sampleCheck.notAcceptedYet": "Chưa nghiệm thu: {samples}. Câu trả lời chỉ được tính sau khi bấm Nghiệm thu mẫu.",
  "order.sampleCheck.released": "Đã chuyển chỉ định {labNo} sang xét nghiệm",
  "order.sampleCheck.disabled.incomplete": "Chưa hoàn tất Chuẩn bị mẫu. Hãy mở và hoàn tất các mẫu trước.",
  "order.dashboard.cancelOrder": "Hủy chỉ định",
  "order.dashboard.cancel.reason": "Lý do hủy",
  "order.dashboard.cancel.reasonOther": "Mô tả lý do",
  "order.dashboard.cancel.other": "Khác",
  "order.dashboard.cancel.confirm": "Hủy chỉ định {labNo}?",
  "order.dashboard.cancel.body": "Các xét nghiệm của chỉ định sẽ bị hủy và mẫu sẽ bị vô hiệu. Không có gì bị xóa.",
  "order.dashboard.cancelled": "Đã hủy chỉ định {labNo}",
  "order.dashboard.filter.cancelled": "Đã hủy",
  "order.dashboard.open": "Mở",
  "order.samples.printLabels": "In nhãn mẫu",
  "order.samples.notStored": "Chưa lưu kho",
  "storage.noSamples": "Thêm mẫu ở trên để lưu kho.",
  "common.discard": "Bỏ",
  "common.stay": "Ở lại",
  "order.start.new": "Bắt đầu chỉ định mới",
  "order.submit.labNumber": "Gửi với mã mẫu",
  "order.submit.success": "Đã gửi chỉ định",
  "order.submit.success.labNumber": "Mã mẫu: {labNumber}",
  "order.submitted.success.msg": "Đã gửi chỉ định thành công",
  "order.summary.accessionNumber": "Số chỉ định",
  "order.summary.collectionDate": "Ngày lấy mẫu",
  "order.dashboard.status.all": "Mọi trạng thái",
  "order.dashboard.status.inProgress": "Đang thực hiện",
  "order.dashboard.status.pendingQa": "Chờ kiểm tra mẫu",
  "order.dashboard.status.completed": "Hoàn tất",
  "order.dashboard.status.hasReferred": "Có xét nghiệm đã gửi đi",
  "order.dashboard.status.referredOut": "Đã gửi đi",
  "order.dashboard.priority.all": "Mọi mức ưu tiên",
  "order.dashboard.priority.stat": "CẤP CỨU",
  "order.dashboard.priority.asap": "Sớm nhất",
  "order.dashboard.priority.timed": "Theo giờ",
  "order.dashboard.priority.routine": "Thường quy",
  "order.summary.patientName": "Tên bệnh nhân",
  "order.summary.sampleType": "Loại mẫu",
  "order.summary.title": "Tóm tắt chỉ định",
  "order.test.request.heading": "Yêu cầu xét nghiệm",
  "order.title": "CHỈ ĐỊNH",
  "ordertests.title": "Xét nghiệm chỉ định",
  "organization.add.placeholder": "Giá trị chữ và số",
  "organization.add.placeholder.active": "Y hoặc N",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Tổ chức cha",
  "organization.add.title": "Thêm tổ chức",
  "organization.city": "Thành phố",
  "organization.clia.number": "Số CLIA",
  "organization.edit.title": "Sửa tổ chức",
  "organization.internetaddress": "Địa chỉ Internet",
  "organization.isActive": "Đang hoạt động",
  "organization.main.title": "Quản lý tổ chức",
  "organization.next": "Trang sau",
  "organization.organizationName": "Tên tổ chức",
  "organization.parent": "Tổ chức cha",
  "organization.previous": "Trang trước",
  "organization.search.byorgname": "Tìm theo tên tổ chức",
  "organization.search.parent.name": "Tên tổ chức cha",
  "organization.search.placeHolder": "Tìm theo tên tổ chức...",
  "organization.select": "Chọn",
  "organization.short.CI": "Tiền tố tổ chức",
  "organization.streetAddress": "Địa chỉ đường",
  "organization.type.CI": "Loại hoạt động",
  "organization.type.CI.description": "Loại hoạt động : Mô tả",
  "organization.type.CI.name": "Loại hoạt động : Tên",
  "organization.type.CI.select": "Loại hoạt động : Chọn",
  "otherMalignant.placeholder": "Ác tính khác",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Quay lại",
  "pagination.backward": "Trang trước",
  "pagination.forward": "Trang sau",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} trên {total} mục",
  "pagination.items-on-page": "{count} {count, plural, one {mục} other {mục}} trên trang này",
  "pagination.items-per-page": "Số mục mỗi trang",
  "pagination.itemsPerPage": "Số mục mỗi trang:",
  "pagination.nextPage": "Trang sau",
  "pagination.page": "trang {page}",
  "pagination.page-number": "Số trang",
  "pagination.page-range": "trên {total} {total, plural, one {trang} other {trang}}",
  "pagination.previousPage": "Trang trước",
  "panel.existing": "Bộ xét nghiệm hiện có",
  "panel.existing.inactive": "Bộ xét nghiệm không hoạt động (gán xét nghiệm để kích hoạt)",
  "panel.new": "Bộ xét nghiệm mới",
  "panel.panelName": "Tên bộ xét nghiệm",
  "pathology.action.addCassette": "Thêm cassette",
  "pathology.action.addSlide": "Thêm lam",
  "pathology.action.deactivateBlock": "Ngừng dùng khối {designation}",
  "pathology.action.deactivateCassette": "Ngừng dùng cassette {designation}",
  "pathology.action.deactivateSlide": "Ngừng dùng lam {barcode}",
  "pathology.action.printCassetteLabels": "In tất cả nhãn cassette",
  "pathology.action.printSlideLabels": "In tất cả nhãn lam",
  "pathology.badge.cassetteCount": "{count, plural, other {# cassette}}",
  "pathology.badge.openRequestCount": "{count} đang mở",
  "pathology.badge.openRequests": "Yêu cầu đang mở: {names}",
  "pathology.badge.openRequestsMore": "Yêu cầu đang mở: {names} và {count} yêu cầu khác",
  "pathology.badge.slideCount": "{count, plural, other {# lam}}",
  "pathology.banner.transitionsLater": "Chuyển giai đoạn sẽ có ở bản phát hành sau. Hiện tại chỉ đặt giai đoạn tại đây.",
  "pathology.empty.noReports": "Chưa có báo cáo. Hoàn tất mô tả và kết luận để tạo báo cáo.",
  "pathology.empty.stageNotRecorded": "OpenELIS chưa ghi nhận công việc ở giai đoạn này. Ca bệnh vẫn có thể chuyển qua giai đoạn này.",
  "pathology.error.designationConflict": "Ca này vừa bị một lần lưu khác thay đổi cùng lúc. Tải lại ca rồi thử lại.",
  "pathology.label.addslide": "Thêm lam",
  "pathology.label.block": "Khối",
  "pathology.label.block.number": "Số khối",
  "pathology.label.blocks": "Khối",
  "pathology.label.case": "Ca giải phẫu bệnh",
  "pathology.label.caseTitle": "Ca giải phẫu bệnh {labNumber}",
  "pathology.label.casesInProgress": "Ca đang thực hiện",
  "pathology.label.cassette": "Cassette",
  "pathology.label.cassettes": "Cassette",
  "pathology.label.complete": "Hoàn tất",
  "pathology.label.conclusion": "Kết luận",
  "pathology.label.dashboard": "Bảng giải phẫu bệnh",
  "pathology.label.deactivating": "Đang ngừng dùng",
  "pathology.label.designationPending": "Gán số khi lưu",
  "pathology.label.grossexam": "Đại thể",
  "pathology.label.location": "Vị trí",
  "pathology.label.microexam": "Vi thể",
  "pathology.label.newCassette": "Cassette mới {position}",
  "pathology.label.newSlide": "Lam mới {position}",
  "pathology.label.parentBlock": "Cắt từ khối",
  "pathology.label.printlabel": "In nhãn",
  "pathology.label.refer": "Chuyển sang hóa mô miễn dịch",
  "pathology.label.release": "Sẵn sàng phát hành",
  "pathology.label.report": "Báo cáo giải phẫu bệnh",
  "pathology.label.request": "Yêu cầu",
  "pathology.label.requests": "Yêu cầu giải phẫu bệnh bổ sung",
  "pathology.label.review": "Chờ bác sĩ giải phẫu bệnh duyệt",
  "pathology.label.slide": "Lam",
  "pathology.label.slide.add.number": "Số lam cần thêm",
  "pathology.label.slide.number": "Số lam",
  "pathology.label.slides": "Lam",
  "pathology.label.stage": "Giai đoạn",
  "pathology.label.techniques": "Kỹ thuật đã dùng",
  "pathology.label.textconclusion": "Kết luận bằng văn bản",
  "pathology.label.title": "Giải phẫu bệnh",
  "pathology.label.view": "Xem tệp",
  "pathology.locked.nothingToPrint": "Chưa có nhãn đã lưu để in",
  "pathology.locked.reasonRequired": "Nhập lý do trước khi ngừng dùng",
  "pathology.locked.releaseNoPathologist": "Phải phân công bác sĩ giải phẫu bệnh trước khi phát hành ca này",
  "pathology.locked.releaseNoTechnician": "Phải phân công kỹ thuật viên trước khi phát hành ca này",
  "pathology.locked.saveBeforeDeactivate": "Lưu hoặc bỏ thay đổi trước khi ngừng dùng",
  "pathology.locked.slideNeedsBlock": "Chọn khối đã cắt ra lam này",
  "pathology.locked.slideNeedsSavedBlock": "Lưu một cassette trước khi thêm lam",
  "pathology.locked.stageDisabled": "Phòng XN này không theo dõi giai đoạn này",
  "pathology.modal.deactivateBlockHeading": "Ngừng dùng khối {designation}?",
  "pathology.modal.deactivateBody": "Bản ghi vẫn được giữ và xem được ở mục Hiện mục đã ngừng dùng. Cassette, khối và lam không bao giờ bị xóa.",
  "pathology.modal.deactivateCassetteHeading": "Ngừng dùng cassette {designation}?",
  "pathology.modal.deactivateFailed": "Yêu cầu ngừng dùng bị từ chối. Tải lại ca rồi thử lại.",
  "pathology.modal.deactivateSlideHeading": "Ngừng dùng lam {barcode}?",
  "pathology.section.caseInfo": "Thông tin ca bệnh",
  "pathology.section.findings": "Mô tả & kết luận",
  "pathology.section.review": "Bác sĩ giải phẫu bệnh duyệt",
  "pathology.stage.accessioned": "Đã tiếp nhận",
  "pathology.stage.completed": "Hoàn tất",
  "pathology.stage.coverslipping": "Đậy lamen & QC",
  "pathology.stage.decalcification": "Khử vôi",
  "pathology.stage.embedding": "Đúc khối",
  "pathology.stage.grossing": "Cắt đại thể",
  "pathology.stage.microtomy": "Cắt lát",
  "pathology.stage.processing": "Xử lý mô",
  "pathology.stage.readyPathologist": "Sẵn sàng cho bác sĩ giải phẫu bệnh",
  "pathology.stage.staining": "Nhuộm",
  "pathology.stage.underReview": "Đang chờ bác sĩ giải phẫu bệnh duyệt",
  "pathology.toast.blockDeactivated": "Đã ngừng dùng khối {designation}",
  "pathology.toast.cassetteDeactivated": "Đã ngừng dùng cassette {designation}",
  "pathology.toast.slideDeactivated": "Đã ngừng dùng lam {barcode}",
  "patient.address.camp": "Trại/Xã",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Thôn / Lô",
  "patient.address.healthdistrict": "Quận/Huyện",
  "patient.address.healthregion": "Vùng",
  "patient.address.province": "Tỉnh/Thành",
  "patient.address.street": "Đường",
  "patient.address.town": "Thị trấn",
  "patient.age.days": "Ngày",
  "patient.age.months": "Tháng",
  "patient.age.years": "Tuổi/Năm",
  "patient.alias": "Bí danh",
  "patient.dataSourceName": "Tên nguồn dữ liệu",
  "patient.dob": "Ngày sinh",
  "patient.dob.future": "Ngày sinh không thể ở tương lai.",
  "patient.validation.contactEmailInvalid": "Nhập địa chỉ email hợp lệ cho người liên hệ.",
  "patient.validation.dobInvalid": "Nhập ngày sinh hợp lệ.",
  "patient.validation.dobOrAgeRequired": "Nhập ngày sinh hoặc tuổi tính theo năm, tháng hoặc ngày.",
  "patient.validation.emailInvalid": "Nhập địa chỉ email hợp lệ.",
  "patient.validation.nationalIdRequired": "Nhập số CCCD.",
  "patient.validation.sexRequired": "Chọn giới tính bệnh nhân.",
  "patient.eduction": "Trình độ học vấn",
  "patient.emergency.additional.camp": "Nhập Trại/Xã",
  "patient.emergency.additional.district": "Nhập Quận/Huyện",
  "patient.emergency.additional.education": "Nhập trình độ học vấn",
  "patient.emergency.additional.maritalstatus": "Nhập tình trạng hôn nhân",
  "patient.emergency.additional.nationnality": "Nhập quốc tịch",
  "patient.emergency.additional.othernationality": "Nhập quốc tịch khác",
  "patient.emergency.additional.region": "Nhập vùng",
  "patient.emergency.additional.street": "Nhập đường",
  "patient.emergency.additional.town": "Nhập thị trấn",
  "patient.emergency.email": "Nhập email người liên hệ khẩn cấp",
  "patient.emergency.firstname": "Nhập tên đệm + tên người liên hệ khẩn cấp",
  "patient.emergency.lastname": "Nhập họ người liên hệ khẩn cấp",
  "patient.emergency.phone": "Nhập số điện thoại người liên hệ khẩn cấp",
  "patient.externalId": "Số CCCD",
  "patient.female": "Nữ",
  "patient.first.name": "Tên đệm + tên",
  "patient.gender": "Giới tính",
  "patient.gps.latitude": "Vĩ độ GPS",
  "patient.gps.latitude.placeholder": "ví dụ: -18.879190 (từ -90 đến 90)",
  "patient.gps.longitude": "Kinh độ GPS",
  "patient.gps.longitude.placeholder": "ví dụ: 47.507905 (từ -180 đến 180)",
  "patient.id": "Mã bệnh nhân",
  "patient.information.age": "Nhập tuổi",
  "patient.information.days": "Nhập số ngày",
  "patient.information.email": "Nhập email bệnh nhân",
  "patient.information.firstname": "Nhập tên đệm + tên bệnh nhân",
  "patient.information.healthid": "Nhập mã định danh y tế duy nhất",
  "patient.information.lastname": "Nhập họ bệnh nhân",
  "patient.information.months": "Nhập số tháng",
  "patient.information.nationalid": "Nhập số định danh quốc gia",
  "patient.information.primaryphone": "Nhập số điện thoại chính của bệnh nhân",
  "patient.label": "Bệnh nhân",
  "patient.label.additionalInfo": "Thông tin bổ sung",
  "patient.label.age": "Tuổi",
  "patient.label.customNotes": "Ghi chú tùy chỉnh",
  "patient.label.diseaseProgramme": "Chương trình bệnh mục tiêu",
  "patient.label.occupation": "Nghề nghiệp",
  "patient.label.contactphone": "Điện thoại liên hệ:{PHONE_FORMAT}",
  "patient.label.email": "Email",
  "patient.label.info": "Thông tin bệnh nhân",
  "patient.label.modify": "Thêm hoặc sửa bệnh nhân",
  "patient.label.name": "Họ tên",
  "patient.label.nopatientid": "Không có thông tin bệnh nhân",
  "patient.label.primaryphone": "Điện thoại chính:{PHONE_FORMAT}",
  "patient.label.sex": "Giới tính",
  "patient.last.name": "Họ",
  "phone.format.international.label": "Quốc tế",
  "phone.format.local.label": "Trong nước",
  "patient.male": "Nam",
  "patient.maritalstatus": "Tình trạng hôn nhân",
  "patient.merge.activeOrders": "Chỉ định đang mở",
  "patient.merge.address": "Địa chỉ",
  "patient.merge.addressesDiffer": "Địa chỉ khác nhau: {primary} và {secondary}",
  "patient.merge.auditEntries": "Mục nhật ký kiểm toán (sẽ giữ bệnh nhân gốc)",
  "patient.merge.back": "Quay lại",
  "patient.merge.cancelButton": "Hủy",
  "patient.merge.clinicalSummary": "Tóm tắt lâm sàng",
  "patient.merge.confirmButton": "Xác nhận gộp",
  "patient.merge.confirmCheckbox": "Tôi hiểu thao tác này không thể hoàn tác và đã xác minh đúng hai bệnh nhân cần gộp",
  "patient.merge.confirmMerge": "Xác nhận gộp bệnh nhân",
  "patient.merge.conflictNote": "(Sẽ dùng thông tin nhân khẩu của bệnh nhân chính)",
  "patient.merge.conflictingInfo": "Phát hiện thông tin mâu thuẫn",
  "patient.merge.contactInfo": "Thông tin liên hệ",
  "patient.merge.county": "Quận/Tỉnh",
  "patient.merge.dataToConsolidate": "Dữ liệu sẽ được hợp nhất",
  "patient.merge.demographics": "Thông tin nhân khẩu",
  "patient.merge.dob": "Ngày sinh",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "Email khác nhau: {primary} và {secondary}",
  "patient.merge.error.alreadyMerged": "Bệnh nhân này đã được gộp",
  "patient.merge.error.executionFailed": "Gộp bệnh nhân thất bại",
  "patient.merge.error.noPermission": "Chỉ Quản trị viên toàn cục mới được gộp bệnh nhân",
  "patient.merge.error.patientNotFound": "Không tìm thấy bệnh nhân",
  "patient.merge.error.samePatient": "Không thể gộp bệnh nhân với chính mình",
  "patient.merge.error.selectBoth": "Vui lòng chọn cả hai bệnh nhân để tiếp tục",
  "patient.merge.error.selectPrimary": "Vui lòng chọn bệnh nhân nào sẽ là hồ sơ chính",
  "patient.merge.error.validationFailed": "Kiểm tra gộp thất bại",
  "patient.merge.externalIds": "Mã định danh bên ngoài",
  "patient.merge.gender": "Giới tính",
  "patient.merge.identifiers": "Mã định danh",
  "patient.merge.identifiersToPreserve": "Mã định danh sẽ giữ lại (cả hai bệnh nhân)",
  "patient.merge.mergeSummary": "Tóm tắt gộp",
  "patient.merge.mergingFrom": "Gộp từ",
  "patient.merge.mergingLabel": "Đang gộp",
  "patient.merge.name": "Họ tên",
  "patient.merge.nationalId": "Số CCCD",
  "patient.merge.nationalIds": "Số CCCD",
  "patient.merge.nextStep": "Bước tiếp theo",
  "patient.merge.noIdentifiers": "Chưa ghi nhận mã định danh",
  "patient.merge.noPatientSelected": "Chưa chọn bệnh nhân",
  "patient.merge.notRecorded": "Chưa ghi nhận",
  "patient.merge.orders": "Chỉ định",
  "patient.merge.ordersCount": "{count} ({active} đang mở)",
  "patient.merge.patientId": "Mã bệnh nhân",
  "patient.merge.patientIds": "Mã bệnh nhân",
  "patient.merge.patientResults": "Kết quả bệnh nhân",
  "patient.merge.phone": "Điện thoại",
  "patient.merge.phonesDiffer": "Số điện thoại khác nhau: {primary} và {secondary}",
  "patient.merge.postalCode": "Mã bưu chính",
  "patient.merge.primaryLabel": "Chính",
  "patient.merge.primaryPatient": "Bệnh nhân chính",
  "patient.merge.reason": "Lý do gộp (bắt buộc)",
  "patient.merge.reasonPlaceholder": "Nhập lý do gộp các hồ sơ bệnh nhân này...",
  "patient.merge.recordsReassigned": "{count} bản ghi đã được chuyển sang bệnh nhân chính",
  "patient.merge.samples": "Mẫu",
  "patient.merge.searchDifferent": "Tìm bệnh nhân khác",
  "patient.merge.selectFirstPatient": "Chọn bệnh nhân thứ nhất",
  "patient.merge.selectPrimaryDescription": "Bệnh nhân nào sẽ là hồ sơ chính?",
  "patient.merge.selectPrimaryRecord": "Chọn hồ sơ bệnh nhân chính",
  "patient.merge.selectSecondPatient": "Chọn bệnh nhân thứ hai",
  "patient.merge.step.compare": "Chọn bệnh nhân chính",
  "patient.merge.step.confirm": "Xác nhận gộp",
  "patient.merge.step.select": "Chọn bệnh nhân",
  "patient.merge.streetAddress": "Địa chỉ đường",
  "patient.merge.success": "Đã gộp bệnh nhân thành công",
  "patient.merge.successMessage": "Bệnh nhân {mergedId} đã được gộp vào bệnh nhân {primaryId}. Mã kiểm toán: {auditId}",
  "patient.merge.testResults": "Kết quả xét nghiệm",
  "patient.merge.title": "Gộp hồ sơ bệnh nhân",
  "patient.merge.totalContacts": "Liên hệ",
  "patient.merge.totalRelations": "Quan hệ",
  "patient.merge.totalResults": "Tổng kết quả",
  "patient.merge.totalSamples": "Mẫu",
  "patient.merge.town": "Thị trấn/Thành phố",
  "patient.merge.tryDifferentSearch": "Thử điều chỉnh tiêu chí tìm kiếm hoặc dùng mã định danh bệnh nhân khác.",
  "patient.merge.warning.dataLink": "Mọi dữ liệu về sau sẽ được gắn với bệnh nhân chính. Bệnh nhân không được chọn sẽ được đánh dấu đã gộp và ngừng hoạt động.",
  "patient.merge.warning.irreversible": "Thao tác này KHÔNG thể hoàn tác. Mọi dữ liệu sẽ được hợp nhất vĩnh viễn.",
  "patient.merge.warning.samePatient": "Đã chọn cùng một bệnh nhân",
  "patient.merge.warning.samePatientDescription": "Bạn đã chọn cùng một bệnh nhân cho cả hai hồ sơ. Vui lòng chọn hai bệnh nhân khác nhau để gộp.",
  "patient.natioanalid": "Số CCCD",
  "patient.nationalid": "Số CCCD",
  "patient.nationality": "Quốc tịch",
  "patient.nationality.other": "Ghi rõ quốc tịch khác",
  "patient.photo.active.camera": "Bấm để bật camera",
  "patient.photo.add": "Thêm ảnh",
  "patient.photo.browse": "Bấm để chọn tệp",
  "patient.photo.camera.permission.denied": "Chưa được cấp quyền camera. Vui lòng kiểm tra cài đặt trình duyệt.",
  "patient.photo.cancel": "Hủy",
  "patient.photo.capture": "Chụp ảnh",
  "patient.photo.captured": "Ảnh đã chụp:",
  "patient.photo.change": "Đổi ảnh",
  "patient.photo.confirm": "Xác nhận",
  "patient.photo.dragndrop": "Kéo và thả ảnh vào đây",
  "patient.photo.error.fileTooLarge": "Ảnh quá lớn. Dung lượng tối đa là 2MB.",
  "patient.photo.formats": "Định dạng: JPG, PNG (tối đa 2MB)",
  "patient.photo.import": "Nhập",
  "patient.photo.label": "Ảnh bệnh nhân",
  "patient.photo.modal.heading": "Chọn ảnh bệnh nhân",
  "patient.photo.modal.options": "Cách chọn ảnh",
  "patient.photo.preview": "Xem trước:",
  "patient.photo.preview.alt": "Xem trước ảnh bệnh nhân",
  "patient.photo.preview.captured.alt": "Ảnh bệnh nhân đã chụp",
  "patient.photo.retake": "Chụp lại",
  "patient.photo.start.camera": "Bật camera",
  "patient.photo.take": "Chụp ảnh",
  "patient.photo.view": "Xem ảnh",
  "patient.idDoc.title": "Giấy tờ tùy thân",
  "patient.idDoc.addDocument": "Thêm giấy tờ",
  "patient.idDoc.selectImage": "Chọn ảnh",
  "patient.idDoc.documentType": "Loại giấy tờ",
  "patient.idDoc.description": "Mô tả",
  "patient.idDoc.description.placeholder": "Nhập mô tả giấy tờ",
  "patient.idDoc.category.nationalId": "Căn cước công dân",
  "patient.idDoc.category.insuranceCard": "Thẻ bảo hiểm",
  "patient.idDoc.category.other": "Khác",
  "patient.idDoc.view": "Xem",
  "patient.idDoc.edit": "Sửa",
  "patient.idDoc.delete": "Xóa",
  "patient.idDoc.remove": "Gỡ",
  "patient.idDoc.pending": "Chưa lưu",
  "patient.idDoc.empty": "Chưa tải lên giấy tờ tùy thân nào",
  "patient.idDoc.viewDocument": "Xem giấy tờ",
  "patient.idDoc.editDocument": "Sửa giấy tờ",
  "patient.idDoc.confirmDelete": "Xóa giấy tờ",
  "patient.idDoc.deleteWarning": "Bạn có chắc muốn xóa giấy tờ này? Thao tác này không thể hoàn tác.",
  "patient.idDoc.upload": "Tải lên",
  "patient.idDoc.dragndrop": "Kéo và thả tệp vào đây",
  "patient.idDoc.browse": "hoặc bấm để chọn tệp",
  "patient.idDoc.formats": "Định dạng: JPEG, PNG, PDF (tối đa 10MB)",
  "patient.idDoc.useCamera": "Dùng camera",
  "patient.idDoc.pdfSelected": "Đã chọn tài liệu PDF",
  "patient.idDoc.error.invalidFormat": "Định dạng tệp không hợp lệ. Chấp nhận: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "Tệp quá lớn. Dung lượng tối đa là 10MB.",
  "patient.prev.lab.no": "Mã mẫu trước đó",
  "patient.report.associated.name": "Phiếu kết quả bệnh nhân liên quan",
  "patient.report.collection.name": "Phiếu kết quả ARV đã lấy mẫu",
  "patient.search.nopatient": "Không tìm thấy bệnh nhân khớp từ khóa",
  "patient.st.number": "Số ST",
  "patient.subject.number": "Số mã y tế duy nhất",
  "patient.yrs": "tuổi",
  "patientcontact.person.email": "Email người liên hệ",
  "patientcontact.person.firstname": "Tên đệm + tên người liên hệ",
  "patientcontact.person.lastname": "Họ người liên hệ",
  "placeholder.accession.number": "Nhập số chỉ định",
  "print.barcode": "In mã vạch",
  "process.testAdd.pressNext.ageRangeSelectiong": "Bấm Tiếp không cần bước chọn khoảng tuổi!",
  "process.testAdd.pressNext.selectGroupDictionary": "Bấm Tiếp không cần bước chọn danh sách nhóm từ điển!",
  "program.name.label": "Tên chương trình",
  "project.ARVFollowupStudy.name": "ARV theo dõi",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV ban đầu",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Không xác định",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Xét nghiệm thời gian nhiễm",
  "project.SequencingStudy.name": "Giải trình tự",
  "project.SpecialRequestStudy.name": "Yêu cầu đặc biệt",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Thêm dự án",
  "project.add.title": "Thêm dự án",
  "project.browse.title": "Dự án",
  "project.completedDate": "Ngày hoàn thành",
  "project.desc.short": "Mô tả DA",
  "project.description": "Mô tả dự án",
  "project.edit.subtitle": "Sửa dự án",
  "project.edit.title": "Sửa dự án",
  "project.external.reference": "Tham chiếu bên ngoài",
  "provider.browse.title": "Quản lý bác sĩ chỉ định",
  "provider.email": "Email",
  "provider.fax": "Fax",
  "provider.isActive": "Đang hoạt động",
  "provider.modal.add.heading": "Thêm bác sĩ chỉ định",
  "provider.modal.update.heading": "Cập nhật bác sĩ chỉ định",
  "provider.providerFirstName": "Tên đệm + tên bác sĩ",
  "provider.providerLastName": "Họ bác sĩ",
  "provider.search": "Tìm bác sĩ chỉ định",
  "provider.search.placeholder": "Tìm tên bác sĩ...",
  "provider.select": "Chọn bác sĩ chỉ định",
  "provider.telephone": "Điện thoại",
  "qa.checklist.incomplete": "Checklist QA chưa hoàn tất",
  "qa.checklist.instructions": "Hoàn tất mọi mục bắt buộc trước khi gửi",
  "qa.checklist.samplingSiteCorrect": "Thông tin điểm lấy mẫu chính xác",
  "qa.checklist.title": "Checklist QA",
  "qa.summary.noSamples": "Không có mẫu để xem xét",
  "qa.summary.noTests": "Chưa chọn xét nghiệm",
  "qa.summary.order": "Chi tiết chỉ định",
  "qa.summary.panel": "Bộ xét nghiệm",
  "qa.summary.patient": "Thông tin bệnh nhân",
  "qa.summary.poolOf": "Gộp {count} {animal}",
  "qa.summary.samples": "Tóm tắt mẫu",
  "qa.summary.samplingSite": "Điểm lấy mẫu",
  "qa.summary.siteCode": "Mã đơn vị",
  "qa.summary.siteName": "Tên đơn vị",
  "qc.comments.add": "Thêm bình luận",
  "qc.comments.empty": "Chưa có bình luận",
  "qc.comments.placeholder": "Nhập bình luận QC...",
  "qc.comments.title": "Bình luận QC",
  "qc.expectedValue": "Giá trị kỳ vọng",
  "qc.frequency.compliance": "Chỉ số tuân thủ",
  "qc.frequency.config": "Cấu hình tần suất QC",
  "qc.frequency.daily": "Mỗi ngày khi khởi động",
  "qc.frequency.everyHours": "Mỗi N giờ",
  "qc.frequency.everySamples": "Mỗi N mẫu",
  "qc.frequency.manual": "Chỉ khi kích hoạt thủ công",
  "qc.frequency.notConfigured": "Chưa cấu hình",
  "qc.frequency.perShift": "Mỗi ca",
  "qc.frequency.save": "Lưu cấu hình",
  "qc.frequency.type": "Loại tần suất",
  "qc.frequency.value": "Giá trị tần suất",
  "qc.leveyJennings.mean": "Trung bình",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "Chưa có dữ liệu QC",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Biểu đồ kiểm soát Levey-Jennings",
  "qc.notes": "Ghi chú QC",
  "qc.notes.placeholder": "Nhập ghi chú và quan sát QC",
  "qc.parentSample": "Mẫu gốc",
  "qc.signature.comment": "Bình luận (không bắt buộc)",
  "qc.signature.comment.placeholder": "Thêm bình luận...",
  "qc.signature.ipAddress": "Địa chỉ IP",
  "qc.signature.noSignatures": "Chưa có chữ ký",
  "qc.signature.sign": "Ký báo cáo",
  "qc.signature.signedAt": "Ký lúc",
  "qc.signature.success": "Đã ký báo cáo thành công",
  "qc.signature.title": "Chữ ký điện tử",
  "qc.signature.userId": "Mã người dùng",
  "qc.status": "Trạng thái QC",
  "qc.status.failed": "Không đạt",
  "qc.status.notRequired": "Không yêu cầu",
  "qc.status.passed": "Đạt",
  "qc.status.pending": "Chờ QC",
  "qc.status.select": "Chọn trạng thái QC",
  "qc.status.update.button": "Cập nhật trạng thái QC",
  "qc.status.update.success": "Đã cập nhật trạng thái QC",
  "qc.status.update.title": "Cập nhật trạng thái QC",
  "qc.status.warning.message": "Đánh dấu LOT này là 'Không đạt' sẽ chặn việc sử dụng cho đến khi trạng thái QC được cập nhật.",
  "qc.status.warning.title": "Cảnh báo QC không đạt",
  "qc.westgard.noViolations": "Không phát hiện vi phạm",
  "qc.westgard.rule.disabled": "Tắt",
  "qc.westgard.rule.enabled": "Bật",
  "qc.westgard.rules": "Quy tắc Westgard",
  "qc.westgard.rules.description": "Cấu hình đánh giá QC đa quy tắc Westgard",
  "qc.westgard.violations": "Vi phạm",
  "quantity": "Số lượng",
  "quantity.balanced": "Số lượng đã cân đối",
  "quantity.not.balanced": "Số lượng chưa cân đối",
  "quick.entry.accession.number": "Số chỉ định",
  "referTest.referralLabel": "Gửi xét nghiệm sang phòng XN tham chiếu",
  "referral.button.labSearch": "Tìm chuyển gửi theo mã mẫu",
  "referral.button.patientSearch": "Tìm bệnh nhân",
  "referral.button.unitTestSearch": "Tìm chuyển gửi theo đơn vị & xét nghiệm",
  "referral.date.end": "Ngày kết thúc (dd/mm/yyyy)",
  "referral.date.start": "Ngày bắt đầu (dd/mm/yyyy)",
  "referral.emptyState": "Không có phiếu chuyển gửi nào khớp bộ lọc đã chọn.",
  "referral.error": "Không có phiếu chuyển gửi khớp tiêu chí",
  "referral.input": "Quét hoặc nhập tay",
  "referral.label.institute": "Cơ sở",
  "referral.label.reason": "Lý do chuyển gửi",
  "referral.label.referredOutTests": "Xét nghiệm đã gửi đi",
  "referral.label.sentdate": "Ngày gửi",
  "referral.label.testmethod": "Phương pháp",
  "referral.label.testtoperform": "Xét nghiệm cần thực hiện",
  "referral.main.button": "Tìm chuyển gửi theo bệnh nhân",
  "referral.matching.search": "Xét nghiệm đã gửi khớp tìm kiếm",
  "referral.out.head": "Chuyển gửi",
  "referral.out.note": "Lưu ý: nếu tìm theo ngày có kết quả, chỉ hiện các xét nghiệm đã có kết quả.",
  "referral.out.request": "Kết quả theo ngày / xét nghiệm / loại ngày đơn vị :",
  "referral.print.selected.patient.reports": "In phiếu kết quả bệnh nhân đã chọn",
  "referral.print.selected.patient.reports.selectall.button": "Chọn tất cả",
  "referral.print.selected.patient.reports.selectnone.button": "Bỏ chọn tất cả",
  "referral.result.labNumber": "Kết quả theo mã mẫu",
  "referral.result.referenceRange": "Khoảng tham chiếu",
  "referral.search": "Tìm kiếm",
  "referral.search.column.analysisId": "Mã phân tích",
  "referral.search.column.referenceLab": "Phòng XN tham chiếu",
  "referral.search.column.resultDate": "Ngày có kết quả",
  "referral.search.column.sentDate": "Ngày gửi",
  "referral.test": "Xét nghiệm",
  "referral.testresult.pastnote": "Ghi chú trước đây",
  "referral.units": "Đơn vị",
  "referrer.label": "người chuyển",
  "reflexTests": "Xét nghiệm phản xạ",
  "reject.action.button": "Từ chối",
  "reject.order.sample.notification": "Bạn đang từ chối một mẫu. Mẫu này sẽ bị từ chối, không xuất hiện trong phiếu công việc sau khi lưu, và không thể nhập kết quả cho chỉ định này.",
  "remaining.quantity": "Số lượng còn lại:",
  "remove.aliquot": "Xóa phần chia mẫu",
  "report.enter.labNumber.headline": "Tạo phiếu kết quả hoặc một dải phiếu theo số chỉ định / mã mẫu",
  "report.enter.patient.headline": "Tạo toàn bộ phiếu kết quả của một khách hàng",
  "report.enter.patient.headline.description": "Tìm bệnh nhân theo mã mẫu cũ, mã bệnh nhân (là số mã y tế duy nhất hoặc số CCCD) hoặc các trường khác.",
  "report.enter.site.headline": "Tạo phiếu kết quả theo đơn vị",
  "report.labe.byLabNumber": "Phiếu kết quả theo mã mẫu",
  "report.labe.byPatient": "Phiếu kết quả theo bệnh nhân",
  "report.labe.date": "Phiếu kết quả theo ngày",
  "report.labe.site": "Phiếu kết quả theo đơn vị",
  "report.label.site.dateType": "Loại ngày",
  "report.label.site.onlyResults": "Chỉ phiếu đã có kết quả",
  "report.patient.site.description": "Tạo phiếu theo ngày có kết quả hoặc theo ngày chỉ định. Theo ngày có kết quả chỉ hiện các phiếu đã có kết quả. Nếu chọn chỉ phiếu đã có kết quả, mọi phiếu có tất cả xét nghiệm đang thực hiện sẽ không được tạo.",
  "report.patient.title.final": "Kết quả: phiếu chính thức",
  "report.patient.title.partial": "Kết quả: phiếu chưa đủ kết quả",
  "report.patient.labDirector": "Trưởng phòng xét nghiệm",
  "report.patient.block.order": "Chỉ định",
  "report.patient.block.dates": "Ngày",
  "report.patient.siteWard": "Cơ sở / khoa",
  "report.patient.completed": "Hoàn thành",
  "report.patient.completed.pending": "Chưa hoàn thành",
  "report.patient.contactTracing.indexName": "Tên ca chỉ điểm (truy vết tiếp xúc)",
  "report.patient.contactTracing.indexRecordNumber": "Số hồ sơ ca chỉ điểm (truy vết tiếp xúc)",
  "report.patient.samples": "Số mẫu",
  "report.patient.sample.number": "#",
  "report.patient.sample.condition": "Tình trạng",
  "report.patient.sample.rejected": "Từ chối: {0}",
  "report.patient.sample.notRecorded": "Chưa ghi nhận",
  "report.patient.strip.collected": "Lấy mẫu {0}",
  "report.patient.strip.collectedFirst": "Lấy mẫu {0} (mẫu đầu tiên trong {1} mẫu)",
  "report.patient.result.sampleRejected": "Mẫu bị từ chối",
  "report.patient.result.rejected": "Bị từ chối",
  "report.patient.col.sample": "Mẫu",
  "report.patient.col.completed": "Hoàn thành",
  "report.patient.flag.low": "L",
  "report.patient.flag.high": "H",
  "report.patient.flag.criticalLow": "LL",
  "report.patient.flag.criticalHigh": "HH",
  "report.patient.flag.abnormal": "*",
  "report.patient.flag.referred": "R",
  "report.patient.flag.confirm": "C",
  "report.patient.legend": "Chú thích",
  "report.patient.legend.high": "cao hơn bình thường",
  "report.patient.legend.low": "thấp hơn bình thường",
  "report.patient.legend.critical": "nguy kịch",
  "report.patient.legend.referred": "đã gửi đi, chờ kết quả",
  "report.patient.legend.confirm": "xét nghiệm khẳng định",
  "report.patient.notAccredited": "Ngoài phạm vi được công nhận của phòng xét nghiệm",
  "report.patient.awaitingValidation": "Chờ duyệt",
  "report.patient.performedBy": "Thực hiện bởi {0}",
  "report.patient.accred.notesLine": "Các xét nghiệm trên phiếu này được công nhận bởi: {0}.",
  "report.patient.callback.line": "Gọi báo: {0}, {1}, bởi {2}. {3}.",
  "report.patient.callback.more": "(+{0} lần gọi trước đó)",
  "report.patient.callback.confirmed": "Đã xác nhận đọc lại",
  "report.patient.callback.noReadback": "Đã liên hệ, không đọc lại",
  "report.patient.callback.unreachable": "Không liên hệ được",
  "report.patient.corrected.line": "Phiếu đã hiệu chỉnh. Thay cho phiếu phát hành {0}. Nội dung sửa: {1}.",
  "report.patient.corrected.seeReplaced": "Xem phiếu đã bị thay thế",
  "report.patient.version": "Phiên bản {0}.",
  "report.patient.footer.version": "Version {0}",
  "report.patient.comments": "Nhận xét chung",
  "report.patient.releasedBy": "Người duyệt và phát hành",
  "report.patient.endOfReport": "Hết phiếu kết quả",
  "report.patient.issued": "Phát hành",
  "report.patient.page": "Trang",
  "report.select.site": "Chọn đơn vị",
  "report.select.studttype": "Chọn loại dự án",
  "reporting.label.testName": "Tên xét nghiệm trên phiếu",
  "reports.auditTrail": "Nhật ký kiểm toán",
  "reports.systemAuditTrail": "Nhật ký kiểm toán hệ thống",
  "reports.button": "Tạo báo cáo",
  "reports.dateRange": "Khoảng thời gian",
  "reports.endDate": "Ngày kết thúc",
  "reports.error.dateRangeRequired": "Loại báo cáo này cần khoảng thời gian",
  "reports.error.generationFailed": "Tạo báo cáo thất bại. Vui lòng thử lại.",
  "reports.error.invalidDate": "Ngày không hợp lệ",
  "reports.error.invalidDateRange": "Ngày kết thúc phải sau ngày bắt đầu",
  "reports.error.unknownExportFormat": "Định dạng xuất không xác định",
  "reports.error.unknownReportType": "Loại báo cáo không xác định",
  "reports.export": "Xuất",
  "reports.export.byDate": "Xuất theo ngày",
  "reports.export.byDate_routine": "Báo cáo CSV thường quy",
  "reports.export.general": "Xuất tổng quát",
  "reports.export.specific": "Xuất dữ liệu tải lượng virus",
  "reports.export.valid": "Hợp lệ",
  "reports.export.whonet": "Báo cáo WHONET",
  "reports.followupRequired.byLocation": "Cần theo dõi",
  "reports.format": "Định dạng xuất",
  "reports.format.select": "Chọn định dạng",
  "reports.generate.title": "Tạo báo cáo tồn kho",
  "reports.generating": "Đang tạo...",
  "reports.generation.success": "Đã tạo và tải báo cáo thành công",
  "reports.groupByLocation": "Nhóm theo vị trí lưu kho",
  "reports.groupByType": "Nhóm theo loại vật tư",
  "reports.grouping": "Tùy chọn nhóm",
  "reports.help.description": "Dùng các báo cáo này để phân tích dữ liệu tồn kho:",
  "reports.help.tip1": "Dùng khoảng thời gian để phân tích xu hướng",
  "reports.help.tip2": "Lọc theo thẻ để báo cáo riêng một nhóm vật tư",
  "reports.help.tip3": "Xuất ra Excel để phân tích thêm",
  "reports.help.title": "Mẹo dùng báo cáo",
  "reports.includeExpired": "Bao gồm LOT hết hạn",
  "reports.includeInactive": "Bao gồm vật tư không hoạt động",
  "reports.info.message": "Chọn loại báo cáo và tùy chọn bên dưới. Báo cáo có thể mất một lúc để tạo.",
  "reports.info.title": "Tạo báo cáo",
  "reports.label.cistudyexport": "Báo cáo tổng quát",
  "reports.label.indicator": "Chỉ số",
  "reports.label.indicator.performance": "Hiệu suất theo nhóm",
  "reports.label.referred.out": "Báo cáo xét nghiệm đã gửi đi",
  "reports.label.trends": "Xu hướng",
  "reports.menu.covid": "Báo cáo Covid",
  "reports.nonConformity.byDate.report": "Theo ngày",
  "reports.nonConformity.byLabno.report": "Theo mã mẫu",
  "reports.nonConformity.bySectionReason.report": "Theo đơn vị và nguyên nhân",
  "reports.nonConformity.bySectionReason.title": "Báo cáo sự không phù hợp theo đơn vị và nguyên nhân",
  "reports.nonConformity.menu": "Báo cáo sự không phù hợp",
  "reports.nonConformity.notification.report": "Thông báo sự không phù hợp",
  "reports.nonConformity.notification.report.instructions": "Nếu chọn một dịch vụ thì mọi thông báo sự không phù hợp chưa in sẽ được in. Nếu không có dịch vụ nào trong danh sách thì mọi thông báo đã in xong. Nhập mã mẫu sẽ in thông báo kể cả khi đã in trước đó. Không bắt buộc chọn dịch vụ.",
  "reports.options": "Tùy chọn lọc",
  "reports.patient.ARV.version1": "ARV-Phiên bản",
  "reports.patient.ARV.version1 ": "ARV-Phiên bản 1",
  "reports.patient.ARVFollowup.version1": "ARV theo dõi - Phiên bản 1",
  "reports.patient.ARVFollowup.version2": "ARV theo dõi - Phiên bản 2",
  "reports.patient.ARVInitial.version1": "ARV ban đầu - Phiên bản 1",
  "reports.patient.ARVInitial.version2": "ARV ban đầu - Phiên bản 2",
  "reports.patient.Indeterminate.location": "Không xác định theo dịch vụ",
  "reports.patient.Indeterminate.version1": "Không xác định - Phiên bản 1",
  "reports.patient.Indeterminate.version2": "Không xác định - Phiên bản 2",
  "reports.startDate": "Ngày bắt đầu",
  "reports.type": "Loại báo cáo",
  "reports.type.expirationForecast": "Dự báo hết hạn",
  "reports.type.expirationForecast.description": "Vật tư hết hạn trong khoảng thời gian đã chọn",
  "reports.type.lotTraceability": "Truy xuất LOT",
  "reports.type.lotTraceability.description": "Truy xuất đầy đủ việc nhập, xuất và sử dụng LOT",
  "reports.type.lowStock": "Cảnh báo tồn thấp",
  "reports.type.lowStock.description": "Vật tư hiện đang dưới mức tồn tối thiểu",
  "reports.type.select": "Chọn loại báo cáo",
  "reports.type.stockLevels": "Báo cáo mức tồn kho",
  "reports.type.stockLevels.description": "Mức tồn kho hiện tại của mọi vật tư",
  "reports.type.transactionHistory": "Lịch sử giao dịch",
  "reports.type.transactionHistory.description": "Mọi giao dịch trong khoảng thời gian",
  "reports.type.usageTrends": "Xu hướng sử dụng",
  "reports.type.usageTrends.description": "Mô hình sử dụng và xu hướng tiêu hao theo thời gian",
  "request.samesite.order": "Tạo chỉ định cùng đơn vị",
  "requester.label": "Người chỉ định",
  "required.invalidtext": "Trường này là bắt buộc",
  "result.acceptasis.warning": "Tick ô này để xác nhận chấp nhận kết quả vô điều kiện.\nCác trường hợp dùng:\n1. Xét nghiệm đã làm lại và kết quả giống nhau.\n2. Không có kết quả cho xét nghiệm nhưng không muốn hủy.\n3. Kết quả đã được sửa và kỹ thuật viên muốn cho bác sĩ có cơ hội ghi chú khi duyệt, giải thích lý do thay đổi.\nDù trường hợp nào, hãy ghi chú lý do bạn thực hiện thao tác này.\n",
  "result.acceptasis.trigger": "Chấp nhận",
  "result.acceptasis.reason.label": "Lý do chấp nhận vô điều kiện",
  "result.acceptasis.reason.placeholder": "Bắt buộc — ví dụ: đã làm lại hai lần cho cùng kết quả, hoặc không có kết quả",
  "result.acceptasis.confirm": "Xác nhận chấp nhận",
  "result.acceptasis.cancel": "Hủy",
  "result.acceptasis.committed": "Đã chấp nhận",
  "result.acceptasis.undo": "Hoàn tác",
  "result.entry.error.accessionRequired": "Vui lòng nhập số chỉ định",
  "result.entry.error.title": "Lỗi",
  "result.entry.info.title": "Thông tin",
  "result.entry.label": "Nhập kết quả",
  "result.entry.noResults": "Không tìm thấy mẫu với số chỉ định {accessionNumber}",
  "result.entry.noTestsFound": "Không tìm thấy xét nghiệm đang chờ kết quả cho số chỉ định {accessionNumber}",
  "result.entry.results.accessionNumber": "Số chỉ định",
  "result.entry.results.sampleCount": "Mẫu",
  "result.entry.results.testCount": "Xét nghiệm",
  "result.entry.results.title": "Xét nghiệm chờ kết quả",
  "result.entry.saveSuccess": "Đã lưu kết quả cho {testName}",
  "result.entry.search.accessionLabel": "Số chỉ định",
  "result.entry.search.accessionPlaceholder": "Nhập số chỉ định...",
  "result.entry.search.button": "Tìm",
  "result.entry.search.searching": "Đang tìm...",
  "result.entry.search.title": "Tìm theo số chỉ định",
  "result.entry.success.title": "Thành công",
  "result.entry.table.action": "Thao tác",
  "result.entry.table.header.sampleId": "Mã mẫu",
  "result.entry.table.header.sampleType": "Loại mẫu",
  "result.entry.table.header.testCount": "Xét nghiệm",
  "result.entry.table.noSamples": "Không tìm thấy mẫu có xét nghiệm",
  "result.entry.table.noTests": "Mẫu này chưa có xét nghiệm",
  "result.entry.table.result": "Kết quả",
  "result.entry.table.resultPlaceholder": "Nhập kết quả",
  "result.entry.table.save": "Lưu",
  "result.entry.table.saving": "Đang lưu...",
  "result.entry.table.status": "Trạng thái",
  "result.entry.table.testName": "Tên xét nghiệm",
  "result.entry.table.testsTitle": "Xét nghiệm ({count})",
  "result.entry.title": "Nhập kết quả",
  "result.noTestsFound": "Không tìm thấy xét nghiệm phù hợp.",
  "result.nonconforming.item": "Mẫu hoặc chỉ định không phù hợp HOẶC xét nghiệm đã bị từ chối",
  "result.outOfValidRange.msg": "Giá trị bạn nhập (ô màu đỏ) nằm ngoài khoảng giá trị cho phép của bản ghi này. Vui lòng kiểm tra lại giá trị",
  "result.notNumeric.msg": "{test}: \"{value}\" không phải là số. Nhập số thập phân thường hoặc ký hiệu khoa học như 1.5e5 hoặc 1.5 x 10^5, rồi lưu lại.",
  "result.reject.warning": "Từ chối kết quả sẽ xóa vĩnh viễn kết quả xét nghiệm \nKết quả sẽ không còn sẵn có.",
  "result.report.queue.size": "Số lượng hàng đợi :",
  "result.search.noresult": "Không tìm thấy kết quả",
  "resultreporting.browse.title": "Cấu hình gửi kết quả",
  "resultreporting.config.url": "URL của trang web nhận kết quả. Ví dụ http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Gửi xét nghiệm sang phòng XN tham chiếu",
  "routine.reports": "Báo cáo thường quy",
  "rulebuilder.error.invalidNumeric": "Giá trị số không hợp lệ",
  "rulebuilder.error.invalidTest": "Xét nghiệm không hợp lệ",
  "rulebuilder.label.add.externaltrigger": "Thêm thông điệp `được kích hoạt bởi` bên ngoài",
  "rulebuilder.label.add.internaltrigger": "Thêm thông điệp `được kích hoạt bởi` nội bộ",
  "rulebuilder.label.addAction": "Thêm hành động",
  "rulebuilder.label.addCondition": "Thêm điều kiện",
  "rulebuilder.label.addExternalNote": "Thêm ghi chú bên ngoài",
  "rulebuilder.label.addInternalNote": "Thêm ghi chú nội bộ",
  "rulebuilder.label.addPopup": "Thêm cửa sổ bật lên",
  "rulebuilder.label.addRule": "Thêm quy tắc",
  "rulebuilder.label.addRuleConditions": "Thêm điều kiện quy tắc phản xạ",
  "rulebuilder.label.confirmDelete": "Bạn có chắc muốn vô hiệu hóa quy tắc này?",
  "rulebuilder.label.dictValue": "Giá trị từ điển",
  "rulebuilder.label.noSuggestions": "Không có gợi ý",
  "rulebuilder.label.numericValue": "Giá trị số",
  "rulebuilder.label.numericValue2": "Giá trị số 2",
  "rulebuilder.label.overallOptions": "Tùy chọn chung",
  "rulebuilder.label.perfomActions": "Thực hiện các hành động sau",
  "rulebuilder.label.relation": "Quan hệ",
  "rulebuilder.label.removeAction": "Xóa hành động",
  "rulebuilder.label.removeCondition": "Xóa điều kiện",
  "rulebuilder.label.removeRule": "Vô hiệu hóa quy tắc",
  "rulebuilder.label.rule": "Quy tắc",
  "rulebuilder.label.ruleDetails": "Xem quy tắc",
  "rulebuilder.label.ruleName": "Tên quy tắc",
  "rulebuilder.label.searchTest": "Tìm xét nghiệm",
  "rulebuilder.label.selectSample": "Chọn mẫu",
  "rulebuilder.label.textValue": "Giá trị văn bản",
  "rulebuilder.label.toggleRule": "Kích hoạt / Vô hiệu hóa",
  "sample.accession.number": "Số chỉ định mẫu",
  "sample.add.action": "Thêm mẫu",
  "sample.collection.date": "Ngày lấy mẫu",
  "sample.collection.method": "Phương pháp lấy mẫu",
  "sample.collection.method.placeholder": "ví dụ: chọc tĩnh mạch, mao mạch, ống dẫn",
  "sample.collection.time": "Giờ lấy mẫu",
  "sample.currentDate": "Ngày hiện tại",
  "sample.requiredBy": "Yêu cầu trước ngày",
  "sample.specimen.origin": "Nguồn mẫu (phòng XN gửi)",
  "sample.specimen.origin.placeholder": "Tên phòng XN gửi mẫu",
  "sample.temperature": "Nhiệt độ mẫu",
  "sample.temperature.placeholder": "ví dụ: nhiệt độ phòng, ướp đá, tủ lạnh",
  "sample.entry.available.tests": "Xét nghiệm có sẵn",
  "sample.entry.nextVisit.date": "Ngày tái khám",
  "sample.entry.panels": "Bộ xét nghiệm",
  "sample.entry.project.patient.and.testName": "Tên/Mã bệnh nhân {br} Tên xét nghiệm",
  "sample.entry.project.testName": "Tên xét nghiệm",
  "sample.entry.search.barcode": "In mã vạch cho chỉ định đã có",
  "sample.id": "Mã mẫu",
  "sample.item.info": "Thông tin mẫu",
  "sample.items.for.accession": "Các mẫu thuộc số chỉ định:",
  "sample.label.accessionNumber": "Số chỉ định",
  "sample.label.collectionDate": "Ngày lấy mẫu",
  "sample.label.dept": "Khoa/Phòng/Đơn vị",
  "sample.label.facility": "Cơ sở gửi mẫu",
  "sample.label.labnumber": "Mã mẫu",
  "sample.label.labnumber.generate": "Tạo",
  "sample.label.labnumber.new": "Mã mẫu mới",
  "sample.labnumber.reassign.button": "Gán lại mã mẫu",
  "sample.labnumber.reassign.confirm": "Gán lại",
  "sample.labnumber.reassign.current": "Mã mẫu hiện tại",
  "sample.labnumber.reassign.heading": "Gán lại mã mẫu",
  "sample.labnumber.reassign.pending": "Mẫu này sẽ được gán lại thành {number} khi bạn lưu.",
  "sample.labnumber.reassign.pending.title": "Đang chờ gán lại mã mẫu",
  "sample.labnumber.reassign.undo": "Hoàn tác",
  "sample.labnumber.reassign.warning": "Gán lại sẽ thay đổi vĩnh viễn mã mẫu của mẫu này. Nhãn, phiếu kết quả và các tham chiếu đến số hiện tại sẽ không còn khớp. Chỉ làm việc này để sửa mẫu bị dán nhãn sai.",
  "sample.label.noorder": "Chỉ định không tồn tại",
  "sample.label.orderdate": "Ngày chỉ định",
  "sample.label.orderpanel": "Bộ xét nghiệm chỉ định",
  "sample.label.requester": "Người chỉ định",
  "sample.label.search.Order": "Tìm chỉ định",
  "sample.label.search.labnumber": "Tìm theo số chỉ định",
  "sample.label.search.patient": "Tìm theo bệnh nhân",
  "sample.label.typeOfSample": "Loại mẫu",
  "sample.label.types": "Loại mẫu",
  "sample.management.action.clearSelection": "Bỏ chọn",
  "sample.management.action.createAliquot": "Tạo phần chia mẫu",
  "sample.management.action.selectAllAliquots": "Chọn mọi phần chia mẫu",
  "sample.management.action.selectAllParents": "Chọn mọi mẫu gốc",
  "sample.management.addTests.button": "Thêm xét nghiệm",
  "sample.management.addTests.error.addFailed": "Thêm xét nghiệm thất bại. Vui lòng thử lại.",
  "sample.management.addTests.error.loadSampleTypes": "Lỗi tải loại mẫu",
  "sample.management.addTests.error.loadTests": "Lỗi tải danh sách xét nghiệm có sẵn",
  "sample.management.addTests.error.noEligibleSamples": "Không thể thêm xét nghiệm: tất cả mẫu đã chọn đã được phân phát hết",
  "sample.management.addTests.error.noTests": "Vui lòng chọn ít nhất một xét nghiệm",
  "sample.management.addTests.modal.add": "Thêm xét nghiệm",
  "sample.management.addTests.modal.addCount": "Thêm {count} xét nghiệm",
  "sample.management.addTests.modal.adding": "Đang thêm...",
  "sample.management.addTests.modal.aliquotsIncluded": "phần chia mẫu đã bao gồm",
  "sample.management.addTests.modal.bulkAliquotNote": "Xét nghiệm sẽ được thêm vào mọi mẫu đã chọn, kể cả các phần chia mẫu.",
  "sample.management.addTests.modal.cancel": "Hủy",
  "sample.management.addTests.modal.noEligibleSamples": "Không có mẫu đủ điều kiện",
  "sample.management.addTests.modal.noTestsAvailable": "Không có xét nghiệm nào cho loại mẫu này.",
  "sample.management.addTests.modal.noTestsSelected": "Chưa chọn xét nghiệm",
  "sample.management.addTests.modal.panels": "Bộ xét nghiệm",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Tìm xét nghiệm...",
  "sample.management.addTests.modal.selectSampleType": "Loại mẫu",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Vui lòng chọn loại mẫu để xem bộ xét nghiệm và xét nghiệm có sẵn.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Chọn loại mẫu...",
  "sample.management.addTests.modal.selectTests": "Chọn xét nghiệm",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Tìm và chọn xét nghiệm...",
  "sample.management.addTests.modal.selectedTests": "Xét nghiệm đã chọn",
  "sample.management.addTests.modal.subtitle": "Thêm xét nghiệm cho {count} mẫu đã chọn",
  "sample.management.addTests.modal.tests": "Xét nghiệm",
  "sample.management.addTests.modal.title": "Thêm xét nghiệm cho mẫu",
  "sample.management.addTests.resultItem": "{sampleId}: đã thêm {added}",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: đã thêm {added}, bỏ qua {skipped}",
  "sample.management.addTests.success": "Đã thêm {count} xét nghiệm thành công",
  "sample.management.addTests.successDetailed": "Đã thêm {count} xét nghiệm cho {samples} mẫu: {details}",
  "sample.management.addTests.successDetailedWithSkipped": "Đã thêm {added} xét nghiệm cho {samples} mẫu, bỏ qua {skipped}: {details}",
  "sample.management.addTests.successWithSkipped": "Đã thêm {added} xét nghiệm, bỏ qua {skipped} (đã chỉ định trước đó)",
  "sample.management.addTests.title": "Thêm xét nghiệm",
  "sample.management.addTests.warning.dispensedSamples": "{count} mẫu không còn thể tích và sẽ bị bỏ qua. Xét nghiệm sẽ được thêm vào {eligible} mẫu đủ điều kiện.",
  "sample.management.addTests.warning.dispensedSamples.title": "Đã loại các mẫu đã phân phát",
  "sample.management.aliquot.error.createFailed": "Tạo phần chia mẫu thất bại. Vui lòng thử lại.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Số phần chia mẫu phải từ 1 đến 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Số lượng yêu cầu ({requested}) vượt quá số lượng còn lại ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Số lượng mỗi phần chia ({quantityPerAliquot}) sẽ nhỏ hơn mức tối thiểu (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Số lượng phải lớn hơn 0",
  "sample.management.aliquot.error.quantityRequired": "Cần nhập số lượng",
  "sample.management.aliquot.error.title": "Lỗi",
  "sample.management.aliquot.modal.cancel": "Hủy",
  "sample.management.aliquot.modal.create": "Tạo phần chia mẫu",
  "sample.management.aliquot.modal.createMultiple": "Tạo {count} phần chia mẫu",
  "sample.management.aliquot.modal.creating": "Đang tạo...",
  "sample.management.aliquot.modal.notesLabel": "Ghi chú (không bắt buộc)",
  "sample.management.aliquot.modal.notesPlaceholder": "Thêm ghi chú về phần chia mẫu này...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Nhập số phần chia có thể tích bằng nhau cần tạo (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Số phần chia",
  "sample.management.aliquot.modal.parentInfo": "Thông tin mẫu gốc",
  "sample.management.aliquot.modal.preview": "Xem trước",
  "sample.management.aliquot.modal.previewText": "Sẽ tạo {count} phần chia, mỗi phần {quantityEach} {unit}",
  "sample.management.aliquot.modal.quantityHelper": "Nhập số lượng cần chuyển, đơn vị {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Số lượng cần chuyển",
  "sample.management.aliquot.modal.quantityPlaceholder": "Nhập số lượng",
  "sample.management.aliquot.modal.subtitle": "Tạo phần chia từ mẫu {externalId}",
  "sample.management.aliquot.modal.title": "Tạo phần chia mẫu",
  "sample.management.aliquot.modal.totalQuantityHelper": "Nhập tổng số lượng cần chia đều cho mọi phần chia, đơn vị {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Tổng số lượng cần chuyển",
  "sample.management.aliquot.success": "Đã tạo phần chia {externalId} thành công. Vui lòng tìm kiếm lại để xem kết quả cập nhật.",
  "sample.management.aliquot.successMultiple": "Đã tạo {count} phần chia thành công ({externalIds}). Vui lòng tìm kiếm lại để xem kết quả cập nhật.",
  "sample.management.breadcrumb.title": "Quản lý mẫu",
  "sample.management.cancelTest.error": "Hủy xét nghiệm thất bại. Vui lòng thử lại.",
  "sample.management.cancelTest.success": "Đã hủy xét nghiệm \"{testName}\" thành công",
  "sample.management.description": "Tìm kiếm và quản lý mẫu, tạo phần chia và thêm xét nghiệm",
  "sample.management.error.title": "Lỗi",
  "sample.management.hierarchy.aliquotOf": "Phần chia của {parent}",
  "sample.management.hierarchy.aliquots": "phần chia",
  "sample.management.noResults.subtitle": "Không tìm thấy mẫu nào cho số chỉ định: {accessionNumber}",
  "sample.management.noResults.title": "Không có kết quả",
  "sample.management.results.accessionNumber": "Số chỉ định",
  "sample.management.results.aliquots": "phần chia",
  "sample.management.results.aliquotsSelected": "phần chia",
  "sample.management.results.item": "mẫu",
  "sample.management.results.items": "mẫu",
  "sample.management.results.selected": "Đã chọn",
  "sample.management.results.title": "Mẫu tìm được",
  "sample.management.results.totalCount": "Tổng số mẫu",
  "sample.management.search.error.general": "Lỗi tải kết quả mẫu. Vui lòng thử lại.",
  "sample.management.search.label": "Tìm mẫu",
  "sample.management.search.loading": "Đang tìm...",
  "sample.management.search.placeholder": "Nhập số chỉ định để tìm...",
  "sample.management.search.title": "Tìm mẫu",
  "sample.management.status.allVolumeDispensed": "Đã phân phát hết thể tích",
  "sample.management.status.available": "Có sẵn",
  "sample.management.status.consumed": "Đã dùng hết",
  "sample.management.status.inUse": "Đang dùng",
  "sample.management.status.unknown": "Không rõ",
  "sample.management.success.title": "Thành công",
  "sample.management.table.cancelTest": "Hủy xét nghiệm",
  "sample.management.table.cancelling": "Đang hủy...",
  "sample.management.table.header.externalId": "Mã mẫu",
  "sample.management.table.header.hierarchy": "Phân cấp",
  "sample.management.table.header.originalQuantity": "Số lượng ban đầu",
  "sample.management.table.header.quantity": "Số lượng ban đầu",
  "sample.management.table.header.remainingQuantity": "Số lượng còn lại",
  "sample.management.table.header.sampleType": "Loại mẫu",
  "sample.management.table.header.status": "Trạng thái",
  "sample.management.table.header.tests": "Xét nghiệm",
  "sample.management.table.noResults": "Không có mẫu nào để hiển thị. Dùng ô tìm kiếm phía trên để tìm mẫu.",
  "sample.management.table.noTests": "Mẫu này chưa có xét nghiệm nào được chỉ định",
  "sample.management.table.orderedDate": "Ngày chỉ định",
  "sample.management.table.orderedTests": "Xét nghiệm đã chỉ định ({count})",
  "sample.management.title": "Quản lý mẫu",
  "sample.panel.label.text": "Tìm bộ xét nghiệm có sẵn",
  "sample.panel.placeholder": "Chọn bộ xét nghiệm có sẵn",
  "sample.panel.search.error.msg": "Không tìm thấy bộ xét nghiệm khớp với",
  "sample.quantity.label": "Số lượng",
  "sample.receivedDate": "Ngày nhận mẫu",
  "sample.reject.label": "Từ chối mẫu",
  "sample.reject.reason.choose": "Chọn lý do từ chối",
  "sample.reject.reason.label": "Lý do từ chối",
  "sample.reject.reasonRequired": "Chọn lý do từ chối.",
  "sample.remove.action": "Xóa mẫu",
  "sample.requestDate": "Ngày yêu cầu",
  "sample.search.nosample": "Không tìm thấy mẫu với số chỉ định đã nhập.",
  "sample.search.panel.legend.text": "Tìm trong các bộ xét nghiệm có sẵn",
  "sample.search.scanner.instructions": "Quét hoặc nhập tay. Nếu chỉ in một phiếu, để trống ô bên phải",
  "sample.search.scanner.instructions.highaccession": "Nếu chỉ in một phiếu, để trống ô bên phải",
  "sample.search.scanner.instructions2": "Quét hoặc nhập tay.",
  "sample.search.title": "Tìm mẫu",
  "sample.select.type": "Chọn loại mẫu",
  "sample.type": "Loại mẫu",
  "sample.type.and.test.sort.order": "Thứ tự sắp xếp loại mẫu và xét nghiệm",
  "sample.type.helper": "Chọn loại bệnh phẩm — bộ xét nghiệm và xét nghiệm có sẵn sẽ cập nhật sau khi chọn.",
  "sample.uom.label": "Đơn vị đo mẫu",
  "sample.voided.title": "Mẫu đã bị vô hiệu",
  "sampleManagement.actions": "Thao tác",
  "sampleManagement.addTests.button": "Thêm xét nghiệm",
  "sampleManagement.addTests.cancel": "Hủy",
  "sampleManagement.addTests.duplicate": "Xét nghiệm đã được chỉ định cho {sampleId}",
  "sampleManagement.addTests.error": "Lỗi khi thêm xét nghiệm",
  "sampleManagement.addTests.incompatible": "Xét nghiệm không tương thích với loại mẫu ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Chọn mẫu để thêm xét nghiệm",
  "sampleManagement.addTests.selectTests": "Chọn xét nghiệm cần thêm",
  "sampleManagement.addTests.skipped": "Đã bỏ qua {count} xét nghiệm trùng",
  "sampleManagement.addTests.submit": "Thêm xét nghiệm",
  "sampleManagement.addTests.success": "Đã thêm {count} xét nghiệm thành công",
  "sampleManagement.addTests.title": "Thêm xét nghiệm cho mẫu",
  "sampleManagement.aliquot.button": "Tạo phần chia mẫu",
  "sampleManagement.aliquot.cancel": "Hủy",
  "sampleManagement.aliquot.error": "Lỗi khi tạo phần chia mẫu",
  "sampleManagement.aliquot.error.concurrentModification": "Người dùng khác vừa sửa mẫu này. Vui lòng làm mới và thử lại.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Không thể chia: số lượng yêu cầu {requested} vượt quá số còn lại {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Đã phân phát hết thể tích: không còn số lượng để chia phần",
  "sampleManagement.aliquot.notes": "Ghi chú (không bắt buộc)",
  "sampleManagement.aliquot.notesPlaceholder": "Thêm ghi chú về phần chia này...",
  "sampleManagement.aliquot.parentExternalId": "Mã ngoài của mẫu gốc",
  "sampleManagement.aliquot.parentLabel": "Mẫu gốc",
  "sampleManagement.aliquot.quantityPlaceholder": "Nhập số lượng...",
  "sampleManagement.aliquot.quantityToTransfer": "Số lượng cần chuyển",
  "sampleManagement.aliquot.remainingQuantity": "Số lượng còn lại",
  "sampleManagement.aliquot.submit": "Tạo phần chia mẫu",
  "sampleManagement.aliquot.success": "Đã tạo phần chia {externalId} thành công",
  "sampleManagement.aliquot.title": "Tạo phần chia mẫu",
  "sampleManagement.aliquot.unit": "Đơn vị",
  "sampleManagement.aliquot.validation.exceeds": "Số lượng vượt quá số lượng còn lại",
  "sampleManagement.aliquot.validation.min": "Số lượng phải ít nhất 0.001",
  "sampleManagement.aliquot.validation.required": "Cần nhập số lượng cần chuyển",
  "sampleManagement.clearSelection": "Bỏ chọn",
  "sampleManagement.hierarchy.children": "Phần chia:",
  "sampleManagement.hierarchy.collapse": "Thu gọn phân cấp",
  "sampleManagement.hierarchy.expand": "Mở rộng phân cấp",
  "sampleManagement.hierarchy.level": "Cấp {level}",
  "sampleManagement.hierarchy.parent": "Mẫu gốc:",
  "sampleManagement.notification.refreshResults": "Đã làm mới kết quả",
  "sampleManagement.results.children": "Phần chia",
  "sampleManagement.results.collectionDate": "Ngày lấy mẫu",
  "sampleManagement.results.count": "Tìm thấy {count} mẫu",
  "sampleManagement.results.externalId": "Mã ngoài",
  "sampleManagement.results.originalQuantity": "Số lượng ban đầu",
  "sampleManagement.results.parent": "Mẫu gốc",
  "sampleManagement.results.remainingQuantity": "Số lượng còn lại",
  "sampleManagement.results.sampleType": "Loại mẫu",
  "sampleManagement.results.status": "Trạng thái",
  "sampleManagement.results.tests": "Xét nghiệm",
  "sampleManagement.results.title": "Kết quả tìm kiếm",
  "sampleManagement.search.button": "Tìm",
  "sampleManagement.search.error": "Lỗi khi tìm mẫu",
  "sampleManagement.search.label": "Tìm theo số chỉ định",
  "sampleManagement.search.loading": "Đang tìm...",
  "sampleManagement.search.noResults": "Không tìm thấy mẫu nào với số chỉ định này",
  "sampleManagement.search.placeholder": "Nhập số chỉ định...",
  "sampleManagement.selectSamples": "Chọn mẫu",
  "sampleManagement.selectedCount": "Đã chọn {count}",
  "sampleManagement.test.name": "Tên xét nghiệm",
  "sampleManagement.test.orderedDate": "Ngày chỉ định",
  "sampleManagement.test.status": "Trạng thái",
  "sampleManagement.test.status.CANCELLED": "Đã hủy",
  "sampleManagement.test.status.COMPLETED": "Hoàn tất",
  "sampleManagement.test.status.IN_PROGRESS": "Đang thực hiện",
  "sampleManagement.test.status.ORDERED": "Đã chỉ định",
  "sampleManagement.title": "Quản lý mẫu",
  "sampleManagement.validation.accessionNumberRequired": "Cần nhập số chỉ định",
  "sampleManagement.validation.parentSampleRequired": "Cần chọn mẫu gốc",
  "sampleManagement.validation.samplesRequired": "Cần chọn ít nhất một mẫu",
  "sampleManagement.validation.testsRequired": "Cần chọn ít nhất một xét nghiệm",
  "sampleType.existing": "Loại mẫu hiện có",
  "sampleType.existing.inactive": "Loại mẫu không hoạt động. Gán xét nghiệm để kích hoạt.",
  "sampleType.new": "Loại mẫu mới",
  "sampleType.typeName": "Tên loại mẫu",
  "save.aliquot.changes": "Lưu thay đổi phần chia",
  "save.config.success.msg": "Đã cập nhật cấu hình thành công",
  "save.order.success.msg": "Đã lưu nhập chỉ định mẫu",
  "save.success": "Lưu thành công",
  "saving": "Đang lưu...",
  "search.by.dictionary.entry": "Tìm theo mục từ điển",
  "search.label": "Tìm kiếm",
  "search.label.accession": "Nhập số chỉ định",
  "search.label.analysis": "Chọn trạng thái phân tích",
  "search.label.collectiondate": "Nhập ngày lấy mẫu",
  "search.label.fromaccession": "Từ số chỉ định",
  "search.label.loadnext": "Tải 99 bản ghi kế tiếp bắt đầu từ mã mẫu",
  "search.label.receiveddate": "Nhập ngày nhận mẫu",
  "search.label.sample": "Chọn trạng thái mẫu",
  "search.label.test": "Chọn tên xét nghiệm",
  "search.label.testdate": "Nhập ngày xét nghiệm",
  "search.label.testunit": "Chọn đơn vị xét nghiệm",
  "search.label.toaccession": "Đến số chỉ định",
  "search.patient.label": "Tìm bệnh nhân",
  "search.placeholder": "Tìm kiếm...",
  "searchTests.label": "Tìm xét nghiệm có sẵn",
  "searchTests.legend": "Tìm trong các xét nghiệm có sẵn",
  "searchindexmanagement.description": "Chỉ mục tìm kiếm tự cập nhật khi có dữ liệu được thêm hoặc sửa. Nếu cần cập nhật chỉ mục thủ công, bấm nút Bắt đầu lập chỉ mục lại. Việc này có thể mất một lúc.",
  "searchindexmanagement.label": "Quản lý chỉ mục tìm kiếm",
  "searchindexmanagement.reindex": "Bắt đầu lập chỉ mục lại",
  "searchindexmanagement.reindex.error": "Lập chỉ mục lại thất bại",
  "searchindexmanagement.reindex.success": "Đã lập chỉ mục lại thành công",
  "select.aliquot": "Chọn phần chia",
  "select.datarange.label": "Khoảng ngày là thời điểm các phiếu chuyển gửi được tạo",
  "select.dateRange": "Chọn khoảng ngày cho tổng hợp báo cáo xét nghiệm",
  "select.default.option.label": "Chọn một mục",
  "select.end.date.referredTests": "Ngày kết thúc (dd/mm/yyyy)",
  "select.labUnits": "Chọn các nhóm xét nghiệm bạn muốn tạo xét nghiệm, có thể chọn nhiều nhóm",
  "select.label.analyser": "Chọn máy xét nghiệm",
  "select.priority.tests": "Chọn mức ưu tiên của các xét nghiệm muốn hiển thị",
  "select.program": "Chương trình",
  "select.referral.centre": "Trung tâm hoặc phòng XN chuyển gửi",
  "select.referral.centre.is.required": " Cần nhập trung tâm hoặc phòng XN chuyển gửi",
  "select.start.date.referredTests": "Ngày bắt đầu (dd/mm/yyyy)",
  "select.timeFrame": "Chọn khoảng thời gian muốn tạo báo cáo",
  "select.timeFrame.Note": "LƯU Ý: mọi ngày và giờ đều tính theo thời điểm nhận mẫu. VD: xét nghiệm nhận lúc 23:59 ngày 31/1 và có kết quả lúc 9:30 ngày 1/2 sẽ được tính là ngoài giờ hành chính của tháng 1",
  "select.year.report": "Chọn năm muốn tạo báo cáo",
  "selectListRenameEntry.selectList": "Đổi tên mục danh sách chọn",
  "selectListRenameEntry.selectListEdit": "Sửa đổi tên mục danh sách chọn",
  "selectReportValues.title": "Chọn giá trị báo cáo",
  "selectResult.title": "Chọn kết quả",
  "serial.config.active.label": "Đang hoạt động",
  "serial.config.baudRate.label": "Tốc độ baud",
  "serial.config.connect.button": "Kết nối",
  "serial.config.connect.error": "Lỗi kết nối cổng nối tiếp",
  "serial.config.connect.success": "Đã kết nối cổng nối tiếp thành công",
  "serial.config.create.title": "Tạo cấu hình cổng nối tiếp",
  "serial.config.dataBits.label": "Bit dữ liệu",
  "serial.config.disconnect.button": "Ngắt kết nối",
  "serial.config.disconnect.error": "Lỗi ngắt kết nối cổng nối tiếp",
  "serial.config.disconnect.success": "Đã ngắt kết nối cổng nối tiếp thành công",
  "serial.config.edit.title": "Sửa cấu hình cổng nối tiếp",
  "serial.config.flowControl.label": "Điều khiển luồng",
  "serial.config.flowControl.none": "Không",
  "serial.config.form.legend": "Thiết lập cổng nối tiếp",
  "serial.config.parity.even": "Chẵn",
  "serial.config.parity.label": "Kiểm tra chẵn lẻ",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "Không",
  "serial.config.parity.odd": "Lẻ",
  "serial.config.parity.space": "Space",
  "serial.config.portName.label": "Tên cổng",
  "serial.config.save.error": "Lỗi lưu cấu hình cổng nối tiếp",
  "serial.config.save.success": "Đã lưu cấu hình cổng nối tiếp thành công",
  "serial.config.status.label": "Trạng thái kết nối",
  "serial.config.stopBits.label": "Bit dừng",
  "serial.config.validation.analyzerId.required": "Cần nhập mã máy xét nghiệm",
  "serial.config.validation.baudRate.invalid": "Tốc độ baud phải từ 9600 đến 115200",
  "serial.config.validation.dataBits.invalid": "Bit dữ liệu phải là 7 hoặc 8",
  "serial.config.validation.portName.required": "Cần nhập tên cổng",
  "server.error.msg": "Rất tiếc, lỗi máy chủ. Vui lòng liên hệ quản trị viên",
  "common.retry": "Thử lại",
  "show.aliquoting": "Hiện phần chia mẫu",
  "showing": "Đang hiển thị",
  "breadcrumb.label.addOrder": "Nhập chỉ định",
  "sidenav.label.admin": "Quản trị",
  "sidenav.label.admin.backToMainMenu": "Về menu chính",
  "sidenav.label.admin.barcodeconfiguration": "Cấu hình mã vạch",
  "sidenav.label.admin.labelPresets": "Mẫu nhãn có sẵn",
  "sidenav.label.admin.commonproperties": "Thuộc tính ứng dụng",
  "sidenav.label.admin.eqaProgram": "Quản lý chương trình EQA",
  "sidenav.label.admin.formEntry.menustatementconfig": "Cấu hình menu thông báo",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Cấu hình sự không phù hợp",
  "sidenav.label.admin.formEntry.patientconfig": "Cấu hình nhập bệnh nhân",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Cấu hình phiếu kết quả đã in",
  "sidenav.label.admin.formEntry.resultConfig": "Cấu hình nhập kết quả",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Cấu hình nhập chỉ định",
  "sidenav.label.admin.formEntry.siteBranding": "Nhận diện đơn vị",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Thông tin đơn vị",
  "sidenav.label.admin.formEntry.validationconfig": "Cấu hình kiểm tra dữ liệu",
  "sidenav.label.admin.formEntry.Workplanconfig": "Cấu hình phiếu công việc",
  "sidenav.label.admin.labNumber": "Quản lý mã mẫu",
  "sidenav.label.admin.localization": "Bản địa hóa",
  "sidenav.label.admin.menu": "Cấu hình menu",
  "sidenav.label.admin.menu.billing": "Cấu hình menu thanh toán",
  "sidenav.label.admin.menu.global": "Cấu hình menu chung",
  "sidenav.label.admin.menu.nonconform": "Cấu hình menu sự không phù hợp",
  "sidenav.label.admin.menu.patient": "Cấu hình menu bệnh nhân",
  "sidenav.label.admin.menu.study": "Cấu hình menu dự án",
  "sidenav.label.admin.organizationmgt": "Quản lý tổ chức",
  "sidenav.label.admin.testmgt": "Cấu hình xét nghiệm phản xạ",
  "sidenav.label.admin.testmgt.calculated": "Quản lý xét nghiệm giá trị tính toán",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Trình sửa danh mục xét nghiệm",
  "sidenav.label.admin.testCatalog": "Quản lý danh mục xét nghiệm",
  "sidenav.label.admin.testCatalog.backToList": "← Tất cả xét nghiệm",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Bấm một xét nghiệm để sửa các phần của nó",
  "sidenav.label.admin.testCatalog.editing": "Đang sửa: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Đang sửa xét nghiệm",
  "label.testCatalog.editor": "Trình sửa danh mục xét nghiệm",
  "label.testCatalog.editor.empty": "Bấm một xét nghiệm để sửa các phần của nó",
  "label.testCatalog.editor.empty.helper": "Mở một xét nghiệm từ danh sách Danh mục xét nghiệm để sửa.",
  "label.testCatalog.editor.loadError": "Không thể tải xét nghiệm này. Vui lòng thử lại.",
  "label.testCatalog.editor.saveAsNew": "Lưu thành xét nghiệm mới…",
  "label.testCatalog.editor.save.pending": "Chức năng lưu sẽ có khi các phần sửa xét nghiệm được triển khai.",
  "label.testCatalog.editor.clone.pending": "Lưu thành xét nghiệm mới sẽ có khi các phần sửa xét nghiệm được triển khai.",
  "label.testCatalog.section.pending": "Trình sửa của phần này sẽ được triển khai ở giai đoạn sau.",
  "label.testCatalog.section.basic-info": "Thông tin cơ bản",
  "label.testCatalog.section.sample-results": "Mẫu & kết quả",
  "label.testCatalog.section.methods": "Phương pháp",
  "label.testCatalog.section.ranges": "Khoảng tham chiếu",
  "label.testCatalog.section.qc-targets": "Mục tiêu QC",
  "label.testCatalog.section.storage": "Lưu trữ mẫu",
  "label.testCatalog.section.panels": "Bộ xét nghiệm",
  "label.testCatalog.entity.panels": "Trình sửa bộ xét nghiệm",
  "note.panel.domainUpgrade": "Nhóm của bộ xét nghiệm được đặt trên chính bộ đó, không suy ra từ các loại mẫu mà xét nghiệm con sử dụng.",
  "note.panel.domainLaterPhase": "Bộ xét nghiệm có xét nghiệm con dùng loại mẫu thuộc nhóm khác sẽ được đánh dấu Nhóm hỗn hợp.",
  "label.panel.list.description": "Các gói xét nghiệm có thứ tự; loại mẫu được suy ra từ các xét nghiệm con",
  "label.panel.list.empty": "Không có bộ xét nghiệm nào khớp bộ lọc hiện tại.",
  "label.panel.search": "Tìm theo tên hoặc LOINC",
  "button.panel.add": "Thêm bộ xét nghiệm",
  "label.panel.col.name": "Tên bộ xét nghiệm",
  "label.panel.col.tests": "Xét nghiệm",
  "label.panel.col.domain": "Nhóm",
  "label.panel.list.mixedDomain": "Nhóm hỗn hợp",
  "label.panel.list.mixedDomain.detail": "Loại mẫu nằm ngoài nhóm của bộ xét nghiệm này: {sampleTypes}",
  "label.panel.col.sampleTypes": "Loại mẫu (suy ra)",
  "label.panel.col.status": "Trạng thái",
  "label.panel.backToList": "Quay về danh sách",
  "label.panel.notFound": "Bộ xét nghiệm này không tồn tại hoặc không tải được. Quay về danh sách để chọn bộ khác.",
  "title.panel.new": "Bộ xét nghiệm mới",
  "label.panel.name": "Tên bộ xét nghiệm",
  "placeholder.panel.name": "VD: Khảo sát thiếu máu",
  "label.panel.domain": "Lĩnh vực",
  "helper.panel.domainGuard": "Chỉ thêm được xét nghiệm thuộc lĩnh vực {domain} vào bộ này.",
  "helper.panel.loincIsIdentifier": "Mã LOINC của bộ là mã định danh của bộ.",
  "note.panel.sampleTypesDerived": "Loại mẫu được suy ra từ các xét nghiệm trong bộ này.",
  "label.panel.description": "Mô tả",
  "label.panel.active": "Đang dùng",
  "helper.panel.needsTest": "Thêm ít nhất một xét nghiệm trước khi kích hoạt bộ này.",
  "error.panel.save": "Không lưu được bộ xét nghiệm. Kiểm tra lại các trường rồi thử lại.",
  "error.panel.nameRequired": "Bắt buộc nhập tên bộ xét nghiệm.",
  "error.panel.nameTooLong": "Tên bộ xét nghiệm tối đa 20 ký tự.",
  "error.panel.descriptionTooLong": "Mô tả tối đa 60 ký tự.",
  "error.panel.nameDuplicate": "Đã có bộ khác dùng tên này. Nhập tên khác.",
  "error.panel.domainConflict": "Không thể xếp bộ này vào {domain}: {count, plural, one {# xét nghiệm của bộ thuộc} other {# xét nghiệm của bộ thuộc}} lĩnh vực khác ({tests}).",
  "helper.panel.domainConflict.remedy": "Đổi lĩnh vực của các xét nghiệm đó trong Danh mục xét nghiệm, hoặc bỏ chúng khỏi bộ này, rồi lưu lại.",
  "error.panel.tests.domainConflict": "Chưa lưu: {tests} {count, plural, one {không thuộc} other {không thuộc}} lĩnh vực của bộ này ({domain}). Chỉ thêm được xét nghiệm thuộc {domain}.",
  "error.panel.tests.activeNeedsTest": "Chưa lưu: bộ đang dùng cần ít nhất một xét nghiệm. Giữ lại một xét nghiệm, hoặc ngừng dùng bộ ở phần Thông tin cơ bản trước.",
  "error.panel.tests.inactive": "Chưa lưu: {tests} {count, plural, one {đang ngừng dùng} other {đang ngừng dùng}}. Chỉ thêm được xét nghiệm đang dùng vào bộ.",
  "error.panel.tests.loadFailed": "Không tải được các xét nghiệm của bộ nên chưa lưu được gì. Thử tải lại.",
  "error.testCatalog.panels.domainConflict": "Xét nghiệm này không vào được {panelName}: bộ được xếp vào {panelDomain} còn xét nghiệm thuộc {testDomain}.",
  "error.testCatalog.panels.activateFailed": "Panel \"{name}\" was created and this test added, but it could not be switched on. Activate it in the Panel Editor.",
  "error.testCatalog.panels.activeNeedsTest": "Chưa lưu: {panels} sẽ không còn xét nghiệm nào khi đang dùng. Ngừng dùng {count, plural, one {bộ đó} other {các bộ đó}} trước, hoặc giữ xét nghiệm này trong {count, plural, one {bộ đó} other {các bộ đó}}.",
  "success.panel.created": "Đã tạo bộ xét nghiệm. Bộ sẽ ở trạng thái ngừng dùng cho đến khi gán ít nhất một xét nghiệm.",
  "error.panel.create.invalid": "Không tạo được bộ xét nghiệm. Điền đủ mọi trường bắt buộc, kể cả mã LOINC.",
  "label.panel.section.basic-info": "Thông tin cơ bản",
  "label.panel.section.tests": "Xét nghiệm",
  "label.panel.section.terminology": "Danh pháp chuẩn",
  "label.panel.section.localization": "Bản dịch",
  "label.panel.localization.intro": "Sửa bản dịch tên bộ xét nghiệm theo từng ngôn ngữ. Trường chưa dịch sẽ hiện tiếng Anh. Quản lý toàn bộ bản dịch ở trang Quản lý bản dịch.",
  "label.panel.localization.empty": "Bộ xét nghiệm này không có trường tên nào cần dịch.",
  "label.panel.localization.loadError": "Không tải được bản dịch của bộ xét nghiệm này.",
  "label.panel.localization.field.name": "Tên bộ xét nghiệm",
  "sidenav.label.admin.panel.editing": "Đang sửa bộ: {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Bấm vào một bộ để sửa các mục của bộ đó",
  "sidenav.label.admin.panel.addingNew": "Đang thêm bộ mới",
  "label.panel.testsCount": "xét nghiệm",
  "label.panel.addTest": "Thêm xét nghiệm",
  "label.panel.tests.filterBySampleType": "Lọc theo loại mẫu",
  "label.panel.tests.filterBySampleType.all": "Tất cả loại mẫu",
  "placeholder.panel.addTest": "Tìm theo tên hoặc mã…",
  "helper.panel.membershipSync": "Thay đổi thành viên sẽ đồng bộ danh sách bộ của phần nhập chỉ định.",
  "label.panel.col.order": "Thứ tự",
  "label.panel.col.testName": "Tên xét nghiệm",
  "label.panel.col.code": "Mã",
  "label.panel.moveUp": "Đưa lên",
  "label.panel.moveDown": "Đưa xuống",
  "empty.panel.tests": "Chưa có xét nghiệm nào — tìm ở trên để thêm xét nghiệm đầu tiên.",
  "helper.panel.loincRouting": "Đây cũng là khóa định tuyến đang hoạt động — e-order FHIR khớp bộ theo mã này khi tiếp nhận. LOINC chính vẫn nằm trên bộ để hiển thị danh sách và nhập chỉ định.",
  "label.panel.terminology.primary": "Chính",
  "label.panel.terminology.empty": "Chưa có ánh xạ danh pháp nào. Ánh xạ LOINC là mã định danh của bộ.",
  "label.panel.terminology.saved": "Đã lưu ánh xạ danh pháp.",
  "label.panel.terminology.saveInvalid": "Có ánh xạ không hợp lệ. Kiểm tra nguồn, mã và các mục trùng.",
  "label.panel.terminology.codeTooLong": "Chưa lưu: mã {code} dài hơn {max} ký tự.",
  "label.panel.terminology.loincTooLong": "Chưa lưu: {code} không phải mã LOINC. Mã LOINC tối đa 10 ký tự.",
  "label.panel.terminology.saveError": "Không lưu được ánh xạ danh pháp.",
  "note.panel.positionShared": "Thay đổi vị trí ghi vào panel_item.sort_order — cùng trường mà mục Bộ xét nghiệm bên phía xét nghiệm đang sửa.",
  "label.testCatalog.section.labels": "Nhãn",
  "label.testCatalog.section.terminology": "Danh pháp chuẩn",
  "label.testCatalog.labels.col.preset": "Mẫu nhãn",
  "label.testCatalog.labels.col.defaultQty": "SL mặc định",
  "label.testCatalog.labels.col.maxQty": "SL tối đa",
  "label.testCatalog.labels.col.allowOverride": "Cho phép sửa",
  "label.testCatalog.labels.col.actions": "Thao tác",
  "label.testCatalog.labels.addLabelType": "Thêm loại nhãn",
  "label.testCatalog.labels.addLabelType.placeholder": "Chọn một mẫu nhãn…",
  "label.testCatalog.labels.empty": "Chưa cấu hình loại nhãn nào. Thêm mẫu nhãn để tự gợi ý nhãn khi xét nghiệm này được chỉ định.",
  "label.testCatalog.labels.loadError": "Không tải được cấu hình nhãn của xét nghiệm này.",
  "label.testCatalog.labels.saved": "Đã lưu cấu hình nhãn",
  "label.testCatalog.labels.saveError": "Không lưu được cấu hình nhãn.",
  "label.testCatalog.labels.unsaved": "Bạn có thay đổi nhãn chưa lưu. Bấm Lưu để áp dụng.",
  "label.testCatalog.labels.maxLtDefault": "SL tối đa phải lớn hơn hoặc bằng SL mặc định.",
  "label.testCatalog.labels.allowOverride.label": "Cho phép sửa khi nhập chỉ định",
  "label.testCatalog.labels.generationSettings": "Cài đặt tạo nhãn",
  "label.testCatalog.labels.remove.action": "Xóa",
  "label.testCatalog.labels.remove.title": "Xóa loại nhãn",
  "label.testCatalog.labels.remove.confirm": "Xóa",
  "label.testCatalog.labels.remove.body": "Xóa {name} khỏi cấu hình nhãn của xét nghiệm này?",
  "label.testCatalog.section.reagents": "Hóa chất",
  "label.testCatalog.section.analyzers": "Máy xét nghiệm",
  "label.testCatalog.section.alerts": "Cảnh báo",
  "label.testCatalog.section.accreditation": "Công nhận",
  "label.testCatalog.accreditation.add": "Thêm công nhận",
  "label.testCatalog.accreditation.added": "Đã thêm công nhận",
  "label.testCatalog.accreditation.removed": "Đã gỡ công nhận",
  "label.testCatalog.accreditation.empty": "Xét nghiệm này chưa được tổ chức nào công nhận.",
  "label.testCatalog.accreditation.selectBody": "Chọn tổ chức công nhận",
  "label.testCatalog.accreditation.remove": "Gỡ công nhận",
  "label.testCatalog.accreditation.remove.body": "Gỡ xét nghiệm này khỏi {body}? Logo của tổ chức sẽ không còn hiện trên các phiếu chỉ chứa xét nghiệm này.",
  "label.testCatalog.accreditation.manageLink": "Quản lý tổ chức công nhận và ngày hết hạn",
  "label.testCatalog.accreditation.loadError": "Không tải được thông tin công nhận.",
  "label.testCatalog.accreditation.saveError": "Không thêm được công nhận.",
  "label.testCatalog.accreditation.deleteError": "Không gỡ được công nhận.",
  "label.testCatalog.section.reflex-calc": "Phản xạ & Tính toán",
  "label.testCatalog.section.localization": "Bản dịch",
  "label.testCatalog.section.display-order": "Thứ tự hiển thị",
  "label.sampleType.section.basic-info": "Thông tin cơ bản",
  "label.sampleType.section.associated-tests": "Xét nghiệm liên quan",
  "label.sampleType.section.terminology": "Danh pháp chuẩn",
  "label.sampleType.section.localization": "Bản dịch",
  "label.sampleType.localization.intro": "Sửa bản dịch tên loại mẫu theo từng ngôn ngữ. Trường chưa dịch sẽ hiện tiếng Anh. Quản lý toàn bộ bản dịch ở trang Quản lý bản dịch.",
  "label.sampleType.localization.empty": "Loại mẫu này không có trường tên nào cần dịch.",
  "label.sampleType.localization.loadError": "Không tải được bản dịch của loại mẫu này.",
  "label.sampleType.localization.field.name": "Tên loại mẫu",
  "label.sampleType.terminology.intro": "Ánh xạ loại mẫu này sang mã danh pháp chuẩn để liên thông.",
  "label.sampleType.terminology.empty": "Chưa có ánh xạ danh pháp nào.",
  "label.sampleType.terminology.saved": "Đã lưu ánh xạ danh pháp.",
  "label.sampleType.terminology.saveError": "Không lưu được ánh xạ danh pháp.",
  "label.sampleType.terminology.saveInvalid": "Có ánh xạ không hợp lệ. Kiểm tra nguồn, mã và các mục trùng.",
  "label.sampleType.terminology.addHint": "Lưu loại mẫu này trước, rồi mới thêm ánh xạ danh pháp.",
  "label.sampleType.localization.addHint": "Lưu loại mẫu này trước, rồi mới sửa bản dịch.",
  "label.sampleType.name": "Tên",
  "label.sampleType.section.display-order": "Thứ tự hiển thị",
  "label.sampleType.section.disposal": "Hủy bỏ",
  "label.sampleType.displayOrder": "Vị trí trong menu Loại mẫu",
  "label.sampleType.displayOrder.intro": "Đặt vị trí loại mẫu này trong menu Loại mẫu khi nhập chỉ định. Nhập số thứ tự hoặc dùng mũi tên, rồi lưu — mọi loại mẫu sẽ được đánh số lại.",
  "label.sampleType.displayOrder.current": "Loại mẫu này",
  "label.sampleType.displayOrder.loading": "Đang tải các loại mẫu...",
  "label.sampleType.displayOrder.saved": "Đã cập nhật thứ tự hiển thị.",
  "label.sampleType.displayOrder.saveError": "Không cập nhật được thứ tự hiển thị.",
  "label.sampleType.displayOrder.addHint": "Lưu loại mẫu này trước, rồi mới đặt vị trí trong menu.",
  "label.sampleType.disposalInstructions": "Hướng dẫn hủy bỏ",
  "label.sampleType.disposal.intro": "Hướng dẫn tham khảo dạng văn bản tự do về cách hủy loại bệnh phẩm này. Quy trình xử lý có cấu trúc chính thức vẫn nằm ở mục Lưu trữ của từng xét nghiệm và quy trình hủy bệnh phẩm.",
  "label.sampleType.disposal.placeholder": "VD: Hấp khử trùng trước khi bỏ vào rác thải y tế nguy hại",
  "label.sampleType.disposal.loading": "Đang tải hướng dẫn hủy bỏ...",
  "label.sampleType.disposal.saved": "Đã lưu hướng dẫn hủy bỏ.",
  "label.sampleType.disposal.saveError": "Không lưu được hướng dẫn hủy bỏ.",
  "label.sampleType.disposal.addHint": "Lưu loại mẫu này trước, rồi mới thêm hướng dẫn hủy bỏ.",
  "label.sampleType.tests.manageIntro": "Các xét nghiệm gắn với loại mẫu này. Tìm trong danh mục để thêm, hoặc gỡ liên kết hiện có. Có thể quản lý liên kết này cả từ Thông tin cơ bản của xét nghiệm trong Danh mục xét nghiệm.",
  "label.sampleType.tests.search": "Tìm xét nghiệm",
  "label.sampleType.tests.searchPlaceholder": "Tìm theo tên xét nghiệm...",
  "label.sampleType.tests.filterBySampleType": "Lọc theo loại mẫu",
  "label.sampleType.tests.filterBySampleType.all": "Mọi loại mẫu",
  "label.sampleType.tests.pick": "Xét nghiệm cần thêm",
  "label.sampleType.tests.pickPlaceholder": "Chọn một xét nghiệm...",
  "label.sampleType.tests.add": "Thêm xét nghiệm",
  "label.sampleType.tests.addError": "Không liên kết được xét nghiệm với loại mẫu này.",
  "label.sampleType.tests.domainMismatch": "Xét nghiệm này thuộc lĩnh vực khác với loại mẫu này nên không dùng được loại mẫu này.",
  "label.sampleType.tests.remove": "Gỡ xét nghiệm",
  "helper.sampleType.name": "Nhập tên duy nhất cho loại mẫu này (VD: \"Huyết thanh\", \"Máu toàn phần\")",
  "helper.sampleType.description": "Mô tả loại mẫu này để nhân viên phòng xét nghiệm tham khảo",
  "label.sampleType.active": "Đang dùng",
  "label.sampleType.description": "Mô tả",
  "label.sampleType.tests.removeError": "Không gỡ được liên kết xét nghiệm.",
  "label.sampleType.tests.removeLastOfActive": "Chưa gỡ: đây là loại mẫu duy nhất của một xét nghiệm đang dùng, gỡ thì xét nghiệm đó không còn chỉ định được. Gán thêm loại mẫu cho xét nghiệm hoặc ngừng dùng xét nghiệm trước.",
  "label.sampleType.tests.loading": "Đang tải xét nghiệm liên quan...",
  "label.sampleType.tests.none": "Chưa có xét nghiệm nào gắn với loại mẫu này.",
  "message.sampleType.add.success": "Đã lưu loại mẫu.",
  "message.sampleType.edit.success": "Đã cập nhật loại mẫu.",
  "heading.sampleType.add": "Thêm loại mẫu mới",
  "button.sampleType.create": "Tạo loại mẫu",
  "button.sampleType.creating": "Đang tạo...",
  "heading.sampleType.filtered": "Đang hiện {filtered} / {total} loại mẫu",
  "heading.sampleType.total": "Tổng: {total} loại mẫu",
  "label.sampleType.tests.addHint": "Lưu loại mẫu này trước, rồi gắn xét nghiệm từ cấu hình xét nghiệm.",
  "message.sampleType.noResults": "Không tìm thấy loại mẫu nào khớp tiêu chí",
  "error.sampleType.create.invalidName": "Tên chứa ký tự không được phép, như thẻ HTML. Xóa các ký tự đó rồi thử lại.",
  "error.sampleType.create.invalid": "Chưa tạo được loại mẫu. Kiểm tra các trường rồi thử lại.",
  "error.sampleType.create.duplicateName": "Đã có loại mẫu cùng tên này.",
  "error.sampleType.create.duplicateDescription": "Đã có loại mẫu khác trong lĩnh vực này dùng mô tả này.",
  "error.sampleType.update.description.409": "Đã có loại mẫu khác trong lĩnh vực này dùng mô tả này.",
  "error.sampleType.update.abbreviation.409": "Đã có loại mẫu khác trong lĩnh vực này dùng viết tắt này.",
  "error.sampleType.update.abbreviation.400": "Viết tắt tối đa 10 ký tự.",
  "error.sampleType.update.whonetCode.400": "Mã WHONET tối đa 5 ký tự.",
  "error.sampleType.update.description.400": "Mô tả tối đa 40 ký tự.",
  "error.sampleType.nameTooLong": "Tên loại mẫu mới tối đa 40 ký tự.",
  "label.sampleType.loading": "Đang tải loại mẫu...",
  "label.sampleType.notFound": "Loại mẫu này không tồn tại. Quay về danh sách để chọn loại khác.",
  "label.sampleType.editorLoadError": "Không tải được các loại mẫu. Làm mới trang để thử lại.",
  "stock.status.pendingQc": "Chờ QC",
  "stock.status.qcFailed": "Không đạt QC",
  "stock.status.quarantined": "Cách ly",
  "label.sampleType.whonetCode": "Mã bệnh phẩm WHONET",
  "helper.sampleType.whonetCode": "Mã ghi vào trường SPECIMEN_TYPE của WHONET (tối đa 5 ký tự).",
  "label.sampleType.whonetReturn": "Quay về bản xem trước WHONET",
  "warning.sampleType.deactivateInUse": "{count} xét nghiệm đang dùng loại mẫu này; khi loại mẫu ngừng dùng thì các xét nghiệm đó sẽ không chỉ định được.",
  "note.sampleType.associatedTests.viewOnly": "Chỉ xem — bệnh phẩm là một phần định danh của xét nghiệm. Muốn chạy xét nghiệm trên loại mẫu này, hãy tạo biến thể bệnh phẩm trong Danh mục xét nghiệm.",
  "sidenav.label.admin.sampleType.backToList": "← Tất cả loại mẫu",
  "sidenav.label.admin.sampleType.editing": "Đang sửa: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Đang sửa loại mẫu",
  "sidenav.label.admin.sampleType.sectionsHelper": "Bấm vào một loại mẫu để sửa các mục của loại đó",
  "sidenav.label.admin.sampleType.addingNew": "Đang thêm loại mẫu mới",
  "label.testCatalog.localization.locale": "Ngôn ngữ",
  "label.testCatalog.localization.intro": "Sửa bản dịch theo từng ngôn ngữ cho tên và tên báo cáo của xét nghiệm này. Trường chưa dịch sẽ hiện tiếng Anh. Quản lý toàn bộ bản dịch ở trang Quản lý bản dịch.",
  "label.testCatalog.localization.unsaved": "Bạn có thay đổi bản dịch chưa lưu. Bấm Lưu để áp dụng.",
  "label.testCatalog.localization.loadError": "Không tải được bản dịch của xét nghiệm này.",
  "label.testCatalog.localization.empty": "Xét nghiệm này không có trường tên nào cần dịch.",
  "label.testCatalog.localization.saved": "Đã lưu bản dịch",
  "label.testCatalog.localization.saveError": "Không lưu được bản dịch.",
  "label.testCatalog.localization.fallbackRequired": "Khi chưa có bản dịch, mọi màn hình sẽ hiện giá trị tiếng Anh, nên ô này không được để trống.",
  "label.testCatalog.localization.field.name": "Tên xét nghiệm",
  "label.testCatalog.localization.field.reportingName": "Tên trên phiếu kết quả",
  "label.testCatalog.localization.fallback.en": "Mặc định (en)",
  "label.testCatalog.localization.fallback.tooltip": "Đang hiện giá trị tiếng Anh vì chưa cấu hình bản dịch cho {locale}.",
  "label.testCatalog.reflexCalc.loadError": "Không tải được liên kết phản xạ và tính toán của xét nghiệm này.",
  "label.testCatalog.reflexCalc.reflex.heading": "Xét nghiệm phản xạ",
  "label.testCatalog.reflexCalc.reflex.helper": "Quy tắc tự động chỉ định thêm xét nghiệm dựa trên kết quả của xét nghiệm này. Quản lý ở Danh mục chính → Quy tắc phản xạ.",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Tên quy tắc",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Điều kiện kích hoạt",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Xét nghiệm phản xạ được chỉ định",
  "label.testCatalog.reflexCalc.reflex.empty": "Chưa cấu hình quy tắc phản xạ nào. Quy tắc phản xạ quản lý ở Danh mục chính → Quy tắc phản xạ.",
  "label.testCatalog.reflexCalc.reflex.manage": "Quản lý quy tắc phản xạ",
  "label.testCatalog.reflexCalc.calc.heading": "Kết quả tính toán",
  "label.testCatalog.reflexCalc.calc.helper": "Công thức dùng kết quả của xét nghiệm này hoặc cho ra xét nghiệm này làm đầu ra. Quản lý ở Danh mục chính → Kết quả tính toán.",
  "label.testCatalog.reflexCalc.calc.feedsInto": "Xét nghiệm này đi vào",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "Xét nghiệm này được tính từ",
  "label.testCatalog.reflexCalc.calc.col.name": "Tên công thức",
  "label.testCatalog.reflexCalc.calc.col.formula": "Công thức",
  "label.testCatalog.reflexCalc.calc.col.output": "Xét nghiệm đầu ra",
  "label.testCatalog.reflexCalc.calc.empty": "Không có",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "Xét nghiệm này không đi vào kết quả tính toán nào. Phép tính quản lý ở Danh mục chính → Giá trị tính toán.",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "Xét nghiệm này không được tính từ xét nghiệm khác. Phép tính quản lý ở Danh mục chính → Giá trị tính toán.",
  "label.testCatalog.reflexCalc.calc.manage": "Quản lý kết quả tính toán",
  "label.testCatalog.alerts.addRule": "Thêm quy tắc",
  "label.testCatalog.alerts.empty": "Chưa cấu hình quy tắc cảnh báo nào. Thêm quy tắc để báo người nhận khi kết quả khớp điều kiện.",
  "label.testCatalog.alerts.loadError": "Không tải được quy tắc cảnh báo của xét nghiệm này.",
  "label.testCatalog.alerts.saved": "Đã lưu quy tắc cảnh báo",
  "label.testCatalog.alerts.saveError": "Không lưu được quy tắc cảnh báo.",
  "label.testCatalog.alerts.saveRefused": "Quy tắc cảnh báo bị từ chối. Tên, giá trị và email tùy chỉnh tối đa 100 ký tự, số điện thoại tùy chỉnh tối đa 20, và vai trò phải là vai trò nhận được thông báo.",
  "label.testCatalog.alerts.deleted": "Đã xóa quy tắc cảnh báo",
  "label.testCatalog.alerts.deleteError": "Không xóa được quy tắc cảnh báo.",
  "label.testCatalog.alerts.nameRequired": "Bắt buộc nhập tên quy tắc.",
  "label.testCatalog.alerts.valueRequired": "Cần nhập giá trị cụ thể cho điều kiện Giá trị cụ thể.",
  "label.testCatalog.alerts.col.name": "Tên",
  "label.testCatalog.alerts.col.trigger": "Điều kiện",
  "label.testCatalog.alerts.col.channels": "Kênh gửi",
  "label.testCatalog.alerts.col.ack": "Cần xác nhận",
  "label.testCatalog.alerts.col.enabled": "Bật",
  "label.testCatalog.alerts.col.actions": "Thao tác",
  "label.testCatalog.alerts.trigger.ALL": "Mọi kết quả",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Bất thường",
  "label.testCatalog.alerts.trigger.CRITICAL": "Nguy kịch",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Giá trị cụ thể",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Vi phạm tuân thủ",
  "label.testCatalog.alerts.edit.action": "Sửa",
  "label.testCatalog.alerts.delete.action": "Xóa",
  "label.testCatalog.alerts.delete.title": "Xóa quy tắc cảnh báo",
  "label.testCatalog.alerts.delete.confirm": "Xóa",
  "label.testCatalog.alerts.delete.body": "Xóa quy tắc cảnh báo {name}?",
  "label.testCatalog.alerts.modal.addTitle": "Thêm quy tắc cảnh báo",
  "label.testCatalog.alerts.modal.editTitle": "Sửa quy tắc cảnh báo",
  "label.testCatalog.alerts.field.name": "Tên quy tắc",
  "label.testCatalog.alerts.field.trigger": "Cảnh báo khi kết quả là:",
  "label.testCatalog.alerts.field.specificValue": "Giá trị cụ thể",
  "label.testCatalog.alerts.field.channels": "Kênh thông báo",
  "label.testCatalog.alerts.field.recipients": "Người nhận",
  "label.testCatalog.alerts.field.ackRequired": "Yêu cầu xác nhận đã đọc",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Email",
  "label.testCatalog.alerts.recipient.physician": "Bác sĩ chỉ định",
  "label.testCatalog.alerts.recipient.patient": "Bệnh nhân",
  "label.testCatalog.alerts.recipient.facility": "Đơn vị gửi mẫu",
  "label.testCatalog.alerts.recipient.customPhone": "Số điện thoại khác",
  "label.testCatalog.alerts.recipient.customEmail": "Email khác",
  "label.testCatalog.alerts.recipient.roleId": "Thông báo cho người dùng có vai trò",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Chọn vai trò",
  "label.testCatalog.reagents.col.name": "Tên hóa chất",
  "label.testCatalog.reagents.col.usage": "Loại sử dụng",
  "label.testCatalog.reagents.col.qty": "Lượng dùng mỗi xét nghiệm",
  "label.testCatalog.reagents.col.stock": "Tồn kho",
  "label.testCatalog.reagents.col.actions": "Thao tác",
  "label.testCatalog.reagents.empty": "Chưa liên kết hóa chất nào. Liên kết hóa chất từ kho để theo dõi lượng tiêu hao theo từng xét nghiệm.",
  "label.testCatalog.reagents.loadError": "Không tải được hóa chất của xét nghiệm này.",
  "label.testCatalog.reagents.linkButton": "Liên kết hóa chất",
  "label.testCatalog.reagents.linkError": "Không liên kết được một hoặc nhiều hóa chất. Thử lại.",
  "label.testCatalog.reagents.modal.title": "Liên kết hóa chất",
  "label.testCatalog.reagents.modal.linkSelected": "Liên kết mục đã chọn",
  "label.testCatalog.reagents.modal.select.label": "Hóa chất",
  "label.testCatalog.reagents.modal.select.placeholder": "Chọn hóa chất cần liên kết",
  "label.testCatalog.reagents.modal.allLinked": "Mọi hóa chất có sẵn đã được liên kết với xét nghiệm này.",
  "label.testCatalog.reagents.unitPlaceholder": "Đơn vị",
  "label.testCatalog.reagents.updated": "Đã cập nhật hóa chất",
  "label.testCatalog.reagents.saveError": "Không lưu được thay đổi.",
  "label.testCatalog.reagents.unitTooLong": "Đơn vị tối đa 50 ký tự.",
  "label.testCatalog.reagents.unsaved": "Bạn có thay đổi hóa chất chưa lưu. Bấm Lưu để áp dụng.",
  "label.testCatalog.reagents.retry": "Thử lại",
  "label.testCatalog.reagents.unlink.action": "Bỏ liên kết",
  "label.testCatalog.reagents.unlink.title": "Bỏ liên kết hóa chất",
  "label.testCatalog.reagents.unlink.confirm": "Bỏ liên kết",
  "label.testCatalog.reagents.unlink.body": "Bỏ liên kết {name} khỏi xét nghiệm này? Các kết quả đã liên kết với hóa chất này không bị ảnh hưởng.",
  "label.testCatalog.reagents.unlinked": "Đã bỏ liên kết hóa chất",
  "label.testCatalog.reagents.unlinkError": "Không bỏ liên kết được hóa chất. Thử lại.",
  "label.testCatalog.basicInfo.name": "Tên",
  "label.testCatalog.basicInfo.name.helper": "Tên hiển thị đã được dịch — sửa ở mục Bản dịch.",
  "label.testCatalog.basicInfo.reportingName": "Tên trên phiếu kết quả",
  "label.testCatalog.basicInfo.labUnit": "Nhóm xét nghiệm",
  "label.testCatalog.basicInfo.labUnit.inactive": "{name} (ngừng dùng)",
  "label.testCatalog.basicInfo.labUnit.inactiveHelp": "Nhóm xét nghiệm này đang ngừng dùng nên không chỉ định được xét nghiệm. Lưu sẽ giữ trạng thái ngừng dùng; kích hoạt lại ở Quản lý nhóm xét nghiệm.",
  "label.testCatalog.basicInfo.createInactiveHint": "Xét nghiệm được tạo ở trạng thái Ngừng dùng. Cấu hình các mục của nó, rồi kích hoạt để chỉ định được.",
  "sidenav.label.environmental.compliance.tooltip": "Bảng theo dõi tuân thủ môi trường",
  "site.search.helper": "Nhập ít nhất 2 ký tự để tự tìm. Bắt buộc để trả kết quả về đúng đơn vị gửi mẫu.",
  "storage.skipped.title": "Bỏ qua lưu trữ cho {count} mẫu",
  "test.qc.blankThreshold": "Ngưỡng mẫu trắng",
  "test.qc.recoveryWindowPct": "Khoảng thu hồi (%)",
  "test.qc.rpdThreshold": "Ngưỡng RPD (%)",
  "test.qc.thresholds.description": "Ngưỡng tùy chọn để đánh giá QC môi trường/véc-tơ. Để trống nếu không áp dụng.",
  "test.qc.thresholds.heading": "Ngưỡng chấp nhận QC",
  "title.testCatalog.createTest": "Tạo xét nghiệm mới",
  "label.testCatalog.testName": "Tên xét nghiệm",
  "label.testCatalog.testCode": "Mã xét nghiệm",
  "label.testCatalog.domain": "Lĩnh vực",
  "label.testCatalog.specimenType": "Loại mẫu",
  "label.testCatalog.basicInfo.sampleTypes": "Loại mẫu",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Chọn mọi bệnh phẩm mà xét nghiệm này chạy trên. Cấu hình được dùng chung cho các loại đó.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Chọn ít nhất một loại mẫu.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "Lĩnh vực của loại mẫu này không khớp lĩnh vực của xét nghiệm.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Bệnh phẩm",
  "label.testCatalog.override.shared": "Mọi bệnh phẩm (dùng chung)",
  "notice.testCatalog.intake.awaitingSpecimen": "Chờ bệnh phẩm — xét nghiệm này chạy trên nhiều bệnh phẩm; sẽ chốt khi lấy mẫu.",
  "tag.testCatalog.finding.noSampleTypeLink": "Chưa liên kết loại mẫu",
  "error.testCatalog.codeExists": "Đã có xét nghiệm dùng mã này.",
  "error.testCatalog.description.inUse": "Đã có xét nghiệm khác dùng mô tả này. Mô tả phải duy nhất — đổi rồi lưu lại.",
  "notification.testCatalog.testCreated": "Đã tạo xét nghiệm '{name}'. Hoàn tất cấu hình ở các mục bên trái.",
  "label.testCatalog.basicInfo.code": "Mã",
  "label.testCatalog.basicInfo.description": "Mô tả",
  "label.testCatalog.basicInfo.domain": "Lĩnh vực",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Lâm sàng",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Môi trường",
  "label.testCatalog.basicInfo.domain.VECTOR": "Véc-tơ",
  "label.testCatalog.basicInfo.domainModal.title": "Đổi lĩnh vực xét nghiệm?",
  "label.testCatalog.basicInfo.domainModal.body": "Đổi lĩnh vực của xét nghiệm này sang {domain}? Việc này ảnh hưởng đến cách xét nghiệm được phân loại trong danh mục.",
  "label.testCatalog.basicInfo.amr": "Xét nghiệm giám sát kháng thuốc (AMR)",
  "label.testCatalog.basicInfo.active": "Đang dùng",
  "label.testCatalog.basicInfo.status": "Trạng thái",
  "label.testCatalog.basicInfo.orderable": "Cho phép chỉ định",
  "label.testCatalog.basicInfo.saved": "Đã lưu thông tin cơ bản.",
  "error.testCatalog.basicInfo.labUnitInactive": "Nhóm xét nghiệm đó đang ngừng dùng. Chọn một nhóm đang dùng, hoặc kích hoạt lại ở Quản lý nhóm xét nghiệm trước.",
  "error.testCatalog.create.refused": "Chưa tạo được xét nghiệm: loại mẫu hoặc nhóm xét nghiệm không dùng được. Kiểm tra lại rồi thử lại.",
  "error.testCatalog.basicInfo.invalidValue": "Chưa lưu thông tin cơ bản: có một giá trị không lưu được. Sửa trường được đánh dấu.",
  "error.testCatalog.basicInfo.timeHolding": "Nhập số phút nguyên, hoặc để trống.",
  "error.testCatalog.basicInfo.qcThreshold": "Nhập số từ 0 trở lên (tối đa 5 chữ số thập phân), hoặc để trống.",
  "label.testCatalog.sampleResults.saved": "Đã lưu bệnh phẩm & kết quả.",
  "label.testCatalog.sampleResults.empty": "Chưa có thành phần kết quả nào. Thêm một thành phần để xác định cách ghi kết quả của xét nghiệm này.",
  "label.testCatalog.sampleResults.newComponent": "(thành phần mới)",
  "label.testCatalog.sampleResults.code": "Mã thành phần",
  "label.testCatalog.sampleResults.isPrimary": "Thành phần chính",
  "label.testCatalog.sampleResults.showOnReport": "Hiện trên phiếu kết quả bệnh nhân",
  "label.testCatalog.sampleResults.label": "Nhãn thành phần",
  "label.testCatalog.sampleResults.resultType": "Kiểu kết quả",
  "label.testCatalog.sampleResults.resultType.N": "Số",
  "label.testCatalog.sampleResults.resultType.none": "Chưa chọn kiểu kết quả",
  "label.testCatalog.sampleResults.preview.noType": "Chọn kiểu kết quả ở trên để xem kỹ thuật viên sẽ nhập kết quả này như thế nào.",
  "label.testCatalog.sampleResults.resultType.D": "Danh sách chọn một (từ điển)",
  "label.testCatalog.sampleResults.resultType.R": "Văn bản tự do",
  "label.testCatalog.sampleResults.resultType.M": "Danh sách chọn nhiều",
  "label.testCatalog.sampleResults.resultType.C": "Chọn nhiều theo nhóm phụ thuộc",
  "label.testCatalog.sampleResults.resultType.T": "Hiệu giá",
  "label.testCatalog.sampleResults.resultType.A": "Chữ-số (có kiểm tra)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Thông dụng",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Nâng cao / kiểu cũ",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Nâng cao / kiểu cũ",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Ẩn kiểu nâng cao / kiểu cũ",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "Một số đo được có đơn vị (VD: 12,3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "Một giá trị chọn từ tập cố định (VD: Có phát hiện / Không phát hiện).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "Một nhận xét hoặc mô tả gõ tay.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "Một hoặc nhiều giá trị từ danh sách; không có giá trị tham chiếu đơn.",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Các lựa chọn theo nhóm; chọn được nhiều nhóm.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "Tỷ lệ pha loãng như 1:10 hoặc 1:20 (thường gặp trong huyết thanh học).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Văn bản chữ-số có kiểm tra (mã hoặc giá trị mã hóa ngắn).",
  "label.testCatalog.sampleResults.preview": "Xem trước nhập kết quả",
  "label.testCatalog.sampleResults.previewHelper": "Đây là những gì kỹ thuật viên sẽ thấy khi nhập kết quả này.",
  "label.testCatalog.sampleResults.purpose": "Xác định kỹ thuật viên ghi gì cho xét nghiệm này và cách diễn giải kết quả.",
  "label.testCatalog.sampleResults.labelRequired": "Mỗi thành phần kết quả cần có nhãn trước khi lưu.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Chọn kiểu kết quả cho \"{component}\" trước khi lưu.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "Đa số xét nghiệm chỉ có một kết quả. Chỉ thêm thành phần khi xét nghiệm cho ra nhiều giá trị (VD: công thức bạch cầu).",
  "label.testCatalog.sampleResults.displayOrder": "Thứ tự hiển thị",
  "label.testCatalog.sampleResults.uom": "Đơn vị",
  "label.testCatalog.sampleResults.uom.none": "(không có)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Thêm đơn vị mới…",
  "label.testCatalog.sampleResults.uom.newName": "Tên hiển thị",
  "label.testCatalog.sampleResults.uom.newCode": "Mã",
  "label.testCatalog.sampleResults.uom.newUcum": "Mã UCUM",
  "label.testCatalog.sampleResults.uom.newDescription": "Mô tả",
  "label.testCatalog.sampleResults.uom.saveNew": "Tạo đơn vị",
  "label.testCatalog.sampleResults.significantDigits": "Chữ số có nghĩa",
  "label.testCatalog.sampleResults.significantDigits.helper": "Số chữ số giữ lại sau dấu thập phân khi nhập kết quả dạng số. Để trống nếu không làm tròn.",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Giới hạn phát hiện (tùy chọn)",
  "admin.testCatalog.sampleResults.loq.helper": "Giới hạn định lượng (tùy chọn)",
  "error.testCatalog.sampleResults.valueTooLong": "{component}: có giá trị dài hơn mức trường cho phép (nhãn 255, mã 50, kết quả mặc định và giá trị lựa chọn 80; nội dung diễn giải 255, chuỗi so khớp 80, mức độ và màu 20 ký tự).",
  "error.testCatalog.sampleResults.unitUnknown": "{component}: đơn vị đo này không tồn tại.",
  "error.testCatalog.sampleResults.activeNeedsComponent": "Chưa lưu: xét nghiệm đang dùng cần ít nhất một thành phần kết quả. Giữ lại một thành phần, hoặc ngừng dùng xét nghiệm ở Thông tin cơ bản trước.",
  "error.testCatalog.sampleResults.lodGtLoq": "LOD không được lớn hơn LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Giới hạn phát hiện phải từ 0 trở lên.",
  "admin.testCatalog.qcTargets.section.label": "Giá trị đích QC",
  "admin.testCatalog.qcTargets.intro": "Các giá trị đích của mẫu chứng mà mục Nhập kết quả dùng để đánh giá mỗi lượt QC. Nhập một lần ở đây để kỹ thuật viên chỉ cần nhập giá trị đo được.",
  "admin.testCatalog.qcTargets.column.level": "Mức mẫu chứng",
  "admin.testCatalog.qcTargets.column.expected": "Giá trị kỳ vọng",
  "admin.testCatalog.qcTargets.column.uncertainty": "Độ không đảm bảo (±)",
  "admin.testCatalog.qcTargets.column.unit": "Đơn vị",
  "admin.testCatalog.qcTargets.column.overrides": "Ghi đè theo lô",
  "admin.testCatalog.qcTargets.column.status": "Trạng thái",
  "admin.testCatalog.qcTargets.column.actions": "Thao tác",
  "admin.testCatalog.qcTargets.level.low": "Thấp",
  "admin.testCatalog.qcTargets.level.normal": "Bình thường",
  "admin.testCatalog.qcTargets.level.high": "Cao",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Kết quả kỳ vọng",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Chọn kết quả kỳ vọng",
  "admin.testCatalog.qcTargets.addTarget": "Thêm giá trị đích",
  "admin.testCatalog.qcTargets.addOverride": "Thêm ghi đè theo lô",
  "admin.testCatalog.qcTargets.lot.label": "Lô mẫu chứng",
  "admin.testCatalog.qcTargets.lot.placeholder": "Tìm lô mẫu chứng…",
  "admin.testCatalog.qcTargets.lot.emptyLink": "Không có lô nào — quản lý lô ở Quản lý lô QC",
  "admin.testCatalog.qcTargets.overrides.none": "Chưa có ghi đè theo lô",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, other {# ghi đè theo lô}}",
  "admin.testCatalog.qcTargets.empty.level": "Chưa cấu hình giá trị đích — kỹ thuật viên nhập giá trị khi thực hiện",
  "admin.testCatalog.qcTargets.helper.precedence": "Khi nhập kết quả, biểu mẫu mẫu chứng được điền sẵn theo ghi đè của lô nếu có, nếu không thì theo giá trị mặc định của mức.",
  "admin.testCatalog.qcTargets.showDeactivated": "Hiện mục đã ngừng dùng",
  "admin.testCatalog.qcTargets.deactivate": "Ngừng dùng",
  "admin.testCatalog.qcTargets.reactivate": "Kích hoạt lại",
  "admin.testCatalog.qcTargets.edit": "Sửa giá trị đích",
  "admin.testCatalog.qcTargets.done": "Xong",
  "admin.testCatalog.qcTargets.saved": "Đã lưu giá trị đích QC.",
  "admin.testCatalog.qcTargets.loadError": "Không tải được giá trị đích QC.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "Độ không đảm bảo phải là số không âm.",
  "error.testCatalog.qcTargets.required": "Mỗi giá trị đích đang dùng cần có giá trị kỳ vọng và độ không đảm bảo, hoặc có kết quả kỳ vọng.",
  "label.testCatalog.sampleResults.defaultResult": "Kết quả mặc định",
  "label.testCatalog.sampleResults.defaultResult.none": "Không có mặc định",
  "label.testCatalog.sampleResults.allowMultiple": "Cho phép nhiều lần đo",
  "label.testCatalog.sampleResults.options": "Các lựa chọn của danh sách",
  "label.testCatalog.sampleResults.options.empty": "Chưa có lựa chọn nào. Thêm ít nhất một lựa chọn để có thể nhập kết quả này.",
  "label.testCatalog.sampleResults.option.value": "Giá trị",
  "label.testCatalog.sampleResults.option.sortOrder": "Thứ tự sắp xếp",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Kỹ thuật viên thấy các lựa chọn theo thứ tự tăng dần — số nhỏ hơn hiện trước.",
  "label.testCatalog.sampleResults.option.normal": "Bình thường",
  "label.testCatalog.sampleResults.option.qualifiable": "Có thể thêm ghi chú",
  "error.testCatalog.sampleResults.duplicateOption": "{component} có {options} xuất hiện nhiều hơn một lần. Xóa dòng thừa để mỗi lựa chọn chỉ xuất hiện một lần khi nhập kết quả.",
  "label.testCatalog.sampleResults.addOption": "Thêm lựa chọn",
  "label.testCatalog.sampleResults.addCustomOption": "Thêm lựa chọn tùy chỉnh",
  "label.testCatalog.sampleResults.searchDictionary": "Tìm giá trị trong từ điển…",
  "label.testCatalog.sampleResults.removeOption": "Xóa lựa chọn",
  "label.testCatalog.sampleResults.interpretations": "Diễn giải",
  "label.testCatalog.sampleResults.interpretations.empty": "Chưa có diễn giải nào. Thêm để gắn hướng dẫn hoặc mức độ cảnh báo cho kết quả.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Khớp giá trị",
  "label.testCatalog.sampleResults.interp.selectValue": "Chọn một giá trị…",
  "label.testCatalog.sampleResults.interp.numericHint": "VD: >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Diễn giải",
  "label.testCatalog.sampleResults.interp.severity": "Mức độ",
  "label.testCatalog.sampleResults.addInterpretation": "Thêm diễn giải",
  "label.testCatalog.sampleResults.removeInterpretation": "Xóa diễn giải",
  "label.testCatalog.sampleResults.severity.NORMAL": "Bình thường",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Bất thường",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Nguy kịch",
  "label.testCatalog.sampleResults.actions": "Thao tác",
  "label.testCatalog.sampleResults.addComponent": "Thêm thành phần",
  "label.testCatalog.sampleResults.removeComponent": "Xóa thành phần",
  "label.testCatalog.sampleResults.moveUp": "Đưa thành phần lên",
  "label.testCatalog.sampleResults.moveDown": "Đưa thành phần xuống",
  "label.testCatalog.sampleResults.copyFrom": "Sao chép cấu hình từ xét nghiệm",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Chọn một xét nghiệm…",
  "label.testCatalog.sampleResults.copyFromButton": "Sao chép từ xét nghiệm",
  "label.testCatalog.sampleResults.copyConfirm.title": "Thay thế cấu hình kết quả của xét nghiệm này?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Mọi thành phần kết quả, lựa chọn danh sách và diễn giải của xét nghiệm này sẽ được thay bằng của {source}. Chưa có gì thay đổi cho đến khi bấm Lưu. Sau khi lưu thì không hoàn tác được.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Thay thế cấu hình",
  "label.testCatalog.sampleResults.copyStaged": "Đã sao chép cấu hình từ {source}, chưa lưu",
  "label.testCatalog.sampleResults.copyStaged.helper": "Bấm Lưu để thay cấu hình của xét nghiệm này bằng bản sao, hoặc bỏ để giữ cấu hình hiện tại.",
  "label.testCatalog.sampleResults.copyDiscard": "Bỏ cấu hình đã sao chép",
  "label.testCatalog.sampleResults.copyEmpty": "{source} không có cấu hình kết quả nào để sao chép.",
  "label.testCatalog.sampleResults.copyLoadError": "Không tải được cấu hình của {source}.",
  "label.testCatalog.sampleResults.copied": "Đã sao chép cấu hình.",
  "label.testCatalog.ranges.activated": "Đã kích hoạt xét nghiệm.",
  "label.testCatalog.ranges.ackModal.title": "Kích hoạt khi còn khoảng thiếu CSBT?",
  "label.testCatalog.ranges.ackModal.confirm": "Xác nhận và kích hoạt",
  "label.testCatalog.ranges.ackModal.warning": "Xét nghiệm này còn khoảng tuổi thiếu chỉ số bình thường.",
  "label.testCatalog.ranges.ackModal.body": "Các khoảng tuổi sau chưa có chỉ số bình thường — kết quả trong các khoảng đó không thể đánh dấu so với CSBT. Xác nhận để vẫn kích hoạt.",
  "label.testCatalog.ranges.male": "Nam",
  "label.testCatalog.ranges.female": "Nữ",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "ngày",
  "label.testCatalog.ranges.months": "tháng",
  "label.testCatalog.ranges.years": "tuổi",
  "label.testCatalog.ranges.noUpperLimit": "không giới hạn trên",
  "label.testCatalog.ranges.noLowerLimit": "không giới hạn dưới",
  "label.testCatalog.ranges.both": "Cả hai",
  "label.testCatalog.ranges.add": "Thêm khoảng CSBT",
  "label.testCatalog.ranges.empty": "Chưa có khoảng chỉ số bình thường nào.",
  "label.testCatalog.ranges.saved": "Đã lưu chỉ số bình thường.",
  "label.testCatalog.ranges.loadError": "Không tải được chỉ số bình thường.",
  "label.testCatalog.ranges.col.component": "Thành phần",
  "label.testCatalog.ranges.allComponents": "Mọi thành phần",
  "label.testCatalog.ranges.col.sex": "Phái",
  "label.testCatalog.ranges.col.age": "Khoảng tuổi",
  "label.testCatalog.ranges.col.normal": "Bình thường",
  "label.testCatalog.ranges.col.critical": "Nguy kịch",
  "label.testCatalog.ranges.col.valid": "Hợp lệ",
  "label.testCatalog.ranges.col.actions": "Thao tác",
  "label.testCatalog.ranges.anyAge": "Mọi lứa tuổi",
  "label.testCatalog.ranges.coverage.title": "Kiểm tra độ phủ",
  "label.testCatalog.ranges.coverage.gapsHeading": "Các khoảng tuổi chưa được phủ:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Đã phủ đủ",
  "label.testCatalog.ranges.coverage.status.GAP": "Còn khoảng thiếu",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Bị chồng lấn",
  "label.testCatalog.ranges.coverage.status.EMPTY": "Chưa có khoảng nào",
  "label.testCatalog.ranges.modal.titleAdd": "Thêm chỉ số bình thường",
  "label.testCatalog.ranges.modal.titleEdit": "Sửa chỉ số bình thường",
  "label.testCatalog.ranges.modal.sex": "Áp dụng cho",
  "label.testCatalog.ranges.modal.component": "Thành phần kết quả",
  "label.testCatalog.ranges.modal.component.all": "Mọi thành phần",
  "label.testCatalog.ranges.modal.ageUnit": "Đơn vị tuổi",
  "label.testCatalog.ranges.modal.minAge": "Từ tuổi",
  "label.testCatalog.ranges.modal.maxAge": "Đến tuổi (để trống = không giới hạn trên)",
  "label.testCatalog.ranges.modal.lowNormal": "Thấp (bình thường)",
  "label.testCatalog.ranges.modal.highNormal": "Cao (bình thường)",
  "label.testCatalog.ranges.modal.lowCritical": "Thấp (nguy kịch)",
  "label.testCatalog.ranges.modal.highCritical": "Cao (nguy kịch)",
  "label.testCatalog.ranges.modal.lowValid": "Thấp (hợp lệ)",
  "label.testCatalog.ranges.modal.highValid": "Cao (hợp lệ)",
  "label.testCatalog.ranges.modal.lowReporting": "Thấp (báo cáo)",
  "label.testCatalog.ranges.modal.highReporting": "Cao (báo cáo)",
  "error.testCatalog.ranges.reportingInverted": "Giới hạn thấp báo cáo không được cao hơn giới hạn cao báo cáo.",
  "label.testCatalog.ranges.modal.ageError": "“Đến tuổi” phải lớn hơn “Từ tuổi”.",
  "label.testCatalog.ranges.modal.boundsError": "Các giới hạn phải lồng ra ngoài: hợp lệ thấp ≤ nguy kịch thấp ≤ bình thường thấp ≤ bình thường cao ≤ nguy kịch cao ≤ hợp lệ cao.",
  "label.testCatalog.storage.saved": "Đã lưu điều kiện bảo quản mẫu.",
  "label.testCatalog.storage.loadError": "Không tải được cài đặt bảo quản mẫu.",
  "label.testCatalog.storage.history.view": "Xem lịch sử thay đổi",
  "label.testCatalog.storage.history.title": "Bảo quản mẫu — Lịch sử thay đổi",
  "label.testCatalog.storage.history.loadError": "Không tải được lịch sử thay đổi.",
  "label.testCatalog.storage.history.empty": "Chưa ghi nhận thay đổi nào.",
  "label.testCatalog.storage.history.filter": "Lọc theo trường",
  "label.testCatalog.storage.history.col.changedAt": "Thời điểm thay đổi",
  "label.testCatalog.storage.history.col.changedBy": "Người thay đổi",
  "label.testCatalog.storage.history.col.field": "Trường",
  "label.testCatalog.storage.history.col.old": "Giá trị cũ",
  "label.testCatalog.storage.history.col.new": "Giá trị mới",
  "label.testCatalog.storage.storageHeading": "Bảo quản",
  "label.testCatalog.storage.disposalHeading": "Hủy bỏ",
  "label.testCatalog.storage.handlingHeading": "Xử lý đặc biệt",
  "label.testCatalog.storage.condition": "Điều kiện bảo quản",
  "label.testCatalog.storage.conditionCustom": "Điều kiện tùy chỉnh",
  "label.testCatalog.storage.duration": "Thời gian bảo quản tối đa",
  "label.testCatalog.storage.durationUnit": "Đơn vị thời gian",
  "label.testCatalog.storage.stabilityNotes": "Ghi chú độ ổn định",
  "label.testCatalog.storage.protectFromLight": "Tránh ánh sáng",
  "label.testCatalog.storage.doNotFreeze": "Không đông lạnh",
  "label.testCatalog.storage.doNotRefrigerate": "Không làm lạnh",
  "label.testCatalog.storage.disposalMethod": "Phương pháp hủy bỏ",
  "label.testCatalog.storage.disposalTimeframe": "Thời hạn hủy bỏ",
  "label.testCatalog.storage.disposalUnit": "Đơn vị thời hạn",
  "label.testCatalog.storage.specialInstructions": "Hướng dẫn đặc biệt",
  "label.testCatalog.storage.overrideRestricted": "Hạn chế ghi đè thời gian bảo quản",
  "label.testCatalog.storage.none": "— không có —",
  "label.testCatalog.storage.condition.AMBIENT": "Nhiệt độ môi trường",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Phòng nhiệt độ kiểm soát (20–25°C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Phòng mát (8–15°C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Phòng lạnh (2–8°C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Tủ lạnh (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Đông lạnh (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Đông lạnh sâu (−70°C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Tủ siêu lạnh (−80°C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Tủ ấm (35–37°C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Đốt",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Hấp khử trùng",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Khử trùng bằng hóa chất",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Rác thải y tế nguy hại",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Hộp đựng vật sắc nhọn",
  "label.testCatalog.storage.disposal.SEWER": "Xả cống",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Trả lại đơn vị gửi",
  "label.testCatalog.storage.disposal.ARCHIVE": "Lưu trữ dài hạn",
  "label.testCatalog.storage.disposal.STANDARD": "Rác thải thông thường",
  "label.testCatalog.storage.unit.hours": "giờ",
  "label.testCatalog.storage.unit.days": "ngày",
  "label.testCatalog.storage.unit.weeks": "tuần",
  "label.testCatalog.storage.unit.months": "tháng",
  "label.testCatalog.analyzers.infoCard": "Máy xét nghiệm được gắn với xét nghiệm này ở màn hình cấu hình máy. Danh sách này chỉ để xem.",
  "label.testCatalog.analyzers.empty": "Chưa có máy xét nghiệm nào ánh xạ tới xét nghiệm này.",
  "label.testCatalog.analyzers.loadError": "Không tải được máy xét nghiệm của xét nghiệm này.",
  "label.testCatalog.analyzers.col.analyzer": "Máy xét nghiệm",
  "label.testCatalog.analyzers.col.testName": "Tên xét nghiệm trên máy",
  "label.testCatalog.displayOrder.pickSampleType": "Loại mẫu",
  "label.testCatalog.displayOrder.intro": "Sắp lại thứ tự xét nghiệm hiển thị trong một loại mẫu. Thứ tự được lưu tự động.",
  "label.testCatalog.displayOrder.empty": "Chưa có xét nghiệm nào gắn với loại mẫu này.",
  "label.testCatalog.displayOrder.loadError": "Không tải được thứ tự hiển thị.",
  "label.testCatalog.displayOrder.saved": "Đã lưu thứ tự hiển thị.",
  "label.testCatalog.displayOrder.currentTest": "Xét nghiệm này",
  "label.testCatalog.displayOrder.moveUp": "Đưa lên",
  "label.testCatalog.displayOrder.moveDown": "Đưa xuống",
  "label.testCatalog.displayOrder.col.position": "Vị trí",
  "label.testCatalog.displayOrder.col.test": "Xét nghiệm",
  "label.testCatalog.displayOrder.dragHandle": "Kéo để sắp xếp lại",
  "label.testCatalog.terminology.intro": "Ánh xạ xét nghiệm này sang mã danh pháp chuẩn để liên thông.",
  "vector.collectedVolume.helper": "Số cá thể trong mẫu gộp này, VD: số muỗi.",
  "vector.complete.animal": "Động vật",
  "vector.complete.cancel": "Hủy",
  "vector.complete.details.collectionDate": "Ngày thu mẫu",
  "vector.complete.details.collectionSite": "Địa điểm thu mẫu",
  "vector.complete.details.collector": "Người thu mẫu",
  "vector.complete.details.lifecycleStage": "Giai đoạn phát triển",
  "vector.complete.details.tests": "Xét nghiệm",
  "vector.complete.details.title": "Chi tiết chỉ định",
  "vector.complete.details.trapType": "Loại bẫy",
  "vector.complete.labNumber": "Mã mẫu",
  "vector.complete.newOrder": "Chỉ định véc-tơ mới",
  "vector.complete.quantity": "Số lượng",
  "vector.complete.quantity.value": "{count} cá thể",
  "vector.complete.status": "Trạng thái",
  "vector.complete.status.processing": "Đang xử lý",
  "vector.lifecycleStage.helper": "Giai đoạn phát triển của cá thể thu được.",
  "vector.order.collectionContext.helper": "Tùy chọn — ghi lại điều kiện sinh thái lúc thu mẫu (sinh thái học).",
  "vector.order.collectionDate.heading": "Ngày thu mẫu",
  "vector.order.collectionDate.helper": "Ngày lô mẫu được thu thực tế ngoài thực địa. Áp dụng cho mọi mẫu trong chỉ định này.",
  "vector.order.site.add.new": "+ Thêm địa điểm mới \"{name}\"",
  "vector.order.site.add.new.restricted": "Việc thêm địa điểm lấy mẫu mới đã bị quản trị viên tắt.",
  "vector.order.site.new.helper": "Sẽ được tạo thành địa điểm lấy mẫu mới khi lưu chỉ định này.",
  "vector.order.site.new.tag": "Mới",
  "vector.order.site.no.match": "Không tìm thấy địa điểm khớp.",
  "vector.pool.noTests": "Chưa ghi nhận xét nghiệm",
  "vector.pool.summary": "Mẫu gộp {count} {animal}",
  "vector.trapCount.helper": "Số bẫy đã đặt — dùng cùng số đêm để tính mật độ trên mỗi bẫy-đêm.",
  "vector.trapNights.helper": "Số đêm bẫy hoạt động. Để trống nếu không ghi nhận công sức thu mẫu.",
  "vector.trapType.helper": "Phương pháp hoặc thiết bị bắt được dùng — chọn loại mẫu trước.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} đã gán · {pools} mẫu gộp",
  "vectorDec.button.back": "Quay lại",
  "vectorDec.button.discard": "Hủy bỏ",
  "vectorDec.button.previewGrouping": "Xem trước cách gộp",
  "vectorDec.button.savePools": "Lưu mẫu gộp",
  "vectorDec.button.splitIndividuals": "Tách thành cá thể →",
  "vectorDec.button.splitIndividuals.tooltip": "Đặt nhanh: mỗi mẫu gộp một bệnh phẩm",
  "vectorDec.button.view": "Xem",
  "vectorDec.col.children": "Bệnh phẩm con",
  "vectorDec.col.positiveTest": "Xét nghiệm dương tính",
  "vectorDec.col.results": "Kết quả",
  "vectorDec.col.status": "Trạng thái",
  "vectorDec.empty": "Chưa có tác vụ giải gộp nào.",
  "vectorDec.error.initiateFailed": "Không khởi tạo được việc giải gộp.",
  "vectorDec.error.loadWorklist": "Không tải được phiếu công việc giải gộp.",
  "vectorDec.error.minPoolCount": "Số mẫu gộp phải ít nhất là 2.",
  "vectorDec.error.noAssignedSpecimens": "Kéo ít nhất một bệnh phẩm vào mẫu gộp trước khi lưu.",
  "vectorDec.error.noParent": "Không có mẫu gốc (SampleItem) để tách.",
  "vectorDec.error.poolFloorByType": "Lô có {types} loại mẫu ({names}) — cần tối thiểu {types} mẫu gộp khi phân bổ ngẫu nhiên.",
  "vectorDec.error.unassignedSpecimens": "Còn {count} bệnh phẩm chưa gán. Gán hết bệnh phẩm trước khi lưu.",
  "vectorDec.field.howManyPools": "Chia thành bao nhiêu mẫu gộp?",
  "vectorDec.field.notes": "Ghi chú",
  "vectorDec.field.organismsPerPool": "Số cá thể mỗi mẫu gộp",
  "vectorDec.field.poolCount": "Số mẫu gộp",
  "vectorDec.field.strategy": "Cách gán",
  "vectorDec.filter.all": "Tất cả",
  "vectorDec.filter.status": "Lọc theo trạng thái",
  "vectorDec.heading.preview": "Cách gộp mẫu đề xuất",
  "vectorDec.heading.split": "Tách thành mẫu gộp con",
  "vectorDec.heading.worklist": "Giải gộp mẫu",
  "vectorDec.individualMode.badge": "Chế độ cá thể",
  "vectorDec.locationOverride.help": "Ghi đè địa điểm thu mẫu kế thừa từ lô tiếp nhận cho các mẫu gộp con cá thể. Dùng khi một lô được thu từ nhiều địa điểm.",
  "vectorDec.locationOverride.inherit": "Kế thừa từ lô (mặc định)",
  "vectorDec.locationOverride.notes": "Ghi chú phần mẫu tách",
  "vectorDec.locationOverride.site": "Địa điểm thu mẫu",
  "vectorDec.locationOverride.title": "Địa điểm thu mẫu của từng mẫu gộp con (tùy chọn)",
  "vectorDec.message.success": "Đã tạo {count} mẫu gộp con ({labRange}), đã xếp {orders} chỉ định xét nghiệm. Trạng thái → Đang giải gộp.",
  "vectorDec.message.successIndividual": "Đã tạo {count} phần mẫu cá thể ({labRange}), đã xếp {orders} chỉ định xét nghiệm. Trạng thái → Đang giải gộp. VR-07 Xác nhận bào tử trùng sẽ chạy khi có kết quả dương tính được xác nhận.",
  "vectorDec.parent.label": "Mẫu gốc",
  "vectorDec.parent.quantity": "Số lượng: {qty}",
  "vectorDec.preview.body": "{count} mẫu gộp theo {strategy}. Kéo bệnh phẩm giữa các mẫu gộp để chỉnh trước khi lưu.",
  "vectorDec.preview.empty": "Không có bệnh phẩm",
  "vectorDec.preview.organisms": "cá thể",
  "vectorDec.preview.poolN": "Mẫu gộp {n}",
  "vectorDec.preview.poolWithSpecies": "Mẫu gộp {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, other {# mẫu}}",
  "vectorDec.preview.title": "Cách gộp đề xuất",
  "vectorDec.preview.unassigned": "{count, plural, =0 {Đã gán hết bệnh phẩm} one {# chưa gán} other {# chưa gán}}",
  "vectorDec.preview.unassignedHint": "Còn {count} bệnh phẩm chưa gán — các mẫu này vẫn ở mẫu gộp gốc.",
  "vectorDec.reflexPreview.copiedTag": "ĐÃ SAO CHÉP",
  "vectorDec.reflexPreview.eagerTag": "CHỦ ĐỘNG",
  "vectorDec.reflexPreview.heading": "↪ Quy tắc phản xạ sẽ chạy khi lưu",
  "vectorDec.reflexPreview.parentTests": "Chỉ định xét nghiệm gốc ({test}) — chạy lại trên từng bệnh phẩm con",
  "vectorDec.reflexPreview.screeningPanel": "bộ sàng lọc",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Gợi ý: tách thành bệnh phẩm cá thể để cũng chạy {rules} — các quy tắc này chỉ áp dụng cho mẫu gộp có một cá thể.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} bệnh phẩm → ~{perPool} mỗi mẫu gộp{remainder, plural, =0 {} other {, dư +1 cho {remainder} mẫu gộp đầu}}",
  "vectorDec.status.complete": "Đã giải gộp xong",
  "vectorDec.status.confirmed": "Đã xác nhận",
  "vectorDec.status.inProgress": "Đang xử lý",
  "vectorDec.status.pending": "Cần duyệt",
  "vectorDec.strategy.manual": "Gán thủ công — kéo thả bệnh phẩm vào các mẫu gộp",
  "vectorDec.strategy.manual.hint": "Tự kéo thả bệnh phẩm vào các mẫu gộp",
  "vectorDec.strategy.manual.title": "Gán thủ công",
  "vectorDec.strategy.random": "Gán ngẫu nhiên — chia đều bệnh phẩm vào các mẫu gộp",
  "vectorDec.strategy.random.hint": "Chia đều bệnh phẩm vào các mẫu gộp",
  "vectorDec.strategy.random.title": "Gán ngẫu nhiên",
  "vectorDec.strategy.species": "Tự tách mẫu gộp con theo loài — gom các bệnh phẩm cùng loài lại",
  "vectorDec.strategy.species.hint": "Gom bệnh phẩm theo loài — yêu cầu có định danh loài trên bệnh phẩm",
  "vectorDec.strategy.species.title": "Tự tách mẫu gộp con theo loài",
  "vectorDec.totalOrganisms": "Tổng số cá thể",
  "vectorDec.warning.exceedsParent.body": "Các mẫu gộp con yêu cầu tổng {total} cá thể, nhưng mẫu gốc chỉ có {parent}. Hệ thống vẫn sẽ tạo {total} mẫu con.",
  "vectorDec.warning.exceedsParent.title": "Tổng vượt số lượng mẫu gốc",
  "vectorId.batch.selectedCount": "{count, plural, other {Đã chọn # mẫu}}",
  "vectorId.bloodMeal.add": "Thêm bộ xét nghiệm vào chỉ định",
  "vectorId.bloodMeal.added": "Đã thêm bộ định danh bữa máu muỗi vào chỉ định xét nghiệm của bệnh phẩm.",
  "vectorId.bloodMeal.addedSub": "Nguồn gốc: thủ công (kỹ thuật viên đã chấp nhận gợi ý). Theo BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Bộ bữa máu đã gắn sẵn ({skipped} xét nghiệm).",
  "vectorId.bloodMeal.body": "Chỉ định Bộ định danh bữa máu muỗi để xác định loài ký chủ mà bệnh phẩm này đã hút máu.",
  "vectorId.bloodMeal.bulkAdd": "Thêm bộ cho tất cả ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Đã xử lý bộ bữa máu cho {count} bệnh phẩm.",
  "vectorId.bloodMeal.bulkBody": "Thêm Bộ định danh bữa máu muỗi vào mọi bệnh phẩm được chọn để phòng xét nghiệm xác định được loài động vật có xương sống mà muỗi đã hút máu.",
  "vectorId.bloodMeal.bulkSummary": "Bộ bữa máu: {added} đã thêm, {skipped} đã gắn sẵn, {rejected} bị từ chối.",
  "vectorId.bloodMeal.bulkTitle": "Phát hiện muỗi cái đã hút máu ({count} bệnh phẩm)",
  "vectorId.bloodMeal.dismiss": "Bỏ qua",
  "vectorId.bloodMeal.error.add": "Không thêm được Bộ định danh bữa máu muỗi.",
  "vectorId.bloodMeal.error.dismiss": "Không ghi nhận được việc bỏ qua.",
  "vectorId.bloodMeal.title": "Phát hiện muỗi cái đã hút máu",
  "vectorId.bulk.applyToCount": "Áp dụng cho {count} bệnh phẩm",
  "vectorId.bulk.heading": "Áp dụng hàng loạt định danh loài",
  "vectorId.bulk.notice.body": "Các trường chi tiết phân tử (gen đích, phương pháp thử, số accession) không được sao chép hàng loạt — hãy ghi từng bệnh phẩm.",
  "vectorId.bulk.notice.title": "Không sao chép các trường riêng của bệnh phẩm",
  "vectorId.button.bulkApply": "🔖 Áp dụng hàng loạt ({count})",
  "vectorId.button.cancel": "Hủy",
  "vectorId.button.close": "▲ Đóng",
  "vectorId.button.confirm": "Xác nhận",
  "vectorId.button.confirmAll": "✓ Xác nhận cho mọi véc-tơ",
  "vectorId.button.confirmResult": "✓ Xác nhận: {test}",
  "vectorId.button.hideResults": "Ẩn kết quả",
  "vectorId.button.identify": "▼ Định danh",
  "vectorId.button.reviewResults": "Xem kết quả ({n})",
  "vectorId.button.save": "Lưu định danh",
  "vectorId.button.splitPool": "↗ Tách",
  "vectorId.col.collectionDate": "Ngày thu mẫu",
  "vectorId.col.decon": "Giải gộp",
  "vectorId.col.decon.help": "Trạng thái giải gộp — kết quả mẫu gộp đã nhập chưa và các mẫu gộp con có đang chờ duyệt không.",
  "vectorId.col.idStatus": "Trạng thái định danh",
  "vectorId.col.lotId": "Mã lô",
  "vectorId.col.organismGroup": "Nhóm",
  "vectorId.col.progress": "Tiến độ",
  "vectorId.col.site": "Địa điểm lấy mẫu",
  "vectorId.completion.body": "{positive} / {total} mẫu gộp con đã xác nhận ({pct}%)",
  "vectorId.completion.body.confirmed": "Đã xác nhận {total} véc-tơ",
  "vectorId.completion.body.partial": "Đã xác nhận cho mọi véc-tơ trong mẫu gộp này:",
  "vectorId.completion.heading": "Đã giải gộp xong",
  "vectorId.completion.heading.confirmed": "Kết quả đã xác nhận",
  "vectorId.completion.heading.partial": "Kết quả xác nhận một phần",
  "vectorId.completion.tag": "Đã giải gộp xong",
  "vectorId.completion.tag.confirmed": "Đã xác nhận",
  "vectorId.completion.tag.partial": "Xác nhận một phần",
  "vectorId.confidence.confirmed": "Đã xác nhận",
  "vectorId.confidence.presumptive": "Dự kiến",
  "vectorId.distribution.confirmed": "{count} đã xác nhận",
  "vectorId.distribution.heading": "Phân bố loài",
  "vectorId.distribution.notIdentified": "{count} chưa định danh",
  "vectorId.distribution.notYet": "Chưa định danh",
  "vectorId.distribution.presumptive": "{count} dự kiến",
  "vectorId.empty": "Không có lô nào trong hàng đợi này.",
  "vectorId.error.accessionFormat": "Định dạng số accession GenBank: 1–2 chữ cái theo sau là 5–8 chữ số (VD: MW123456).",
  "vectorId.error.confidenceRequired": "Bắt buộc chọn mức độ tin cậy.",
  "vectorId.error.loadSpecimens": "Không tải được bệnh phẩm của lô này.",
  "vectorId.error.loadWorklist": "Không tải được phiếu công việc.",
  "vectorId.error.methodRequired": "Bắt buộc chọn phương pháp định danh.",
  "vectorId.error.notesTooLong": "Ghi chú tối đa 500 ký tự.",
  "vectorId.error.requiredFields": "Bắt buộc có loài, phương pháp và mức độ tin cậy.",
  "vectorId.error.saveFailed": "Không lưu được định danh.",
  "vectorId.error.speciesRequired": "Bắt buộc chọn loài.",
  "vectorId.filter.complete": "Hoàn tất",
  "vectorId.filter.complete.sub": "Đã định danh mọi bệnh phẩm.",
  "vectorId.filter.decon": "Giải gộp",
  "vectorId.filter.decon.sub": "Đã nhập kết quả mẫu gộp, chờ kỹ thuật viên quyết định tách hay xác nhận.",
  "vectorId.filter.label": "Trạng thái",
  "vectorId.filter.notstarted": "Chưa bắt đầu",
  "vectorId.filter.notstarted.sub": "Đã nhận, 0 bệnh phẩm được định danh.",
  "vectorId.filter.partialid": "Định danh một phần",
  "vectorId.filter.partialid.sub": "Đang định danh.",
  "vectorId.filter.pending": "Chờ xử lý",
  "vectorId.filter.pending.sub": "Mọi lô chưa hoàn tất, kể cả mẫu gộp có kết quả đang chờ kỹ thuật viên duyệt.",
  "vectorId.form.assayName": "Tên phương pháp thử",
  "vectorId.form.assayName.placeholder": "RT-PCR đa mồi",
  "vectorId.form.confidence": "Mức độ tin cậy",
  "vectorId.form.genbankAccession": "Số accession GenBank",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Giai đoạn phát triển",
  "vectorId.form.linkedResult": "Liên kết với kết quả tác nhân gây bệnh",
  "vectorId.form.linkedResultPlaceholder": "Chọn một kết quả trên lô này…",
  "vectorId.form.method": "Phương pháp",
  "vectorId.form.molecularDetails": "🔬 Chi tiết phân tử",
  "vectorId.form.notes": "Ghi chú",
  "vectorId.form.physState": "Trạng thái sinh lý",
  "vectorId.form.select": "Chọn…",
  "vectorId.form.species": "Loài",
  "vectorId.form.speciesPlaceholder": "Tìm chi hoặc loài…",
  "vectorId.form.targetGene": "Gen đích",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, 28S rDNA",
  "vectorId.heading.worklist": "Phiếu định danh véc-tơ",
  "vectorId.loading": "Đang tải…",
  "vectorId.message.bulkSuccess": "Đã áp dụng định danh cho {count} bệnh phẩm.",
  "vectorId.message.saveSuccess": "Đã lưu định danh.",
  "vectorId.method.both": "Hình thái + phân tử",
  "vectorId.method.molecular": "Phân tử",
  "vectorId.method.morphological": "Hình thái",
  "vectorId.notif.confirmAll.error": "Không xác nhận được kết quả. Thử lại.",
  "vectorId.notif.confirmAll.success": "Đã xác nhận kết quả cho mọi véc-tơ trong mẫu gộp này.",
  "vectorId.notif.deconNeeded.body": "Đã nhập kết quả cho mẫu gộp này. Tách thành mẫu gộp con để xét nghiệm tiếp, hoặc xác nhận kết quả áp dụng cho mọi véc-tơ.",
  "vectorId.notif.deconNeeded.bodyWithTest": "Một trong các xét nghiệm có kết quả. Tách thành mẫu gộp con để xét nghiệm tiếp, hoặc xác nhận kết quả áp dụng cho mọi véc-tơ.",
  "vectorId.notif.deconNeeded.title": "Kết quả mẫu gộp chờ duyệt",
  "vectorId.physState.blood_fed": "Đã hút máu",
  "vectorId.physState.gravid": "Mang trứng",
  "vectorId.physState.half_gravid": "Mang trứng một phần",
  "vectorId.physState.unfed": "Chưa hút máu",
  "vectorId.physState.unknown": "Không rõ / chưa đánh giá",
  "vectorId.resplit.heading": "Tách: {label}",
  "vectorId.search.placeholder": "Tìm lô…",
  "vectorId.specimen.col.confidence": "Mức độ tin cậy",
  "vectorId.specimen.col.idStatus": "Trạng thái định danh",
  "vectorId.specimen.col.label": "Bệnh phẩm",
  "vectorId.specimen.col.labNo": "Mã mẫu",
  "vectorId.specimen.col.poolOrSpecimen": "Mẫu gộp / Bệnh phẩm",
  "vectorId.specimen.col.species": "Loài",
  "vectorId.specimen.confirmed": "Đã xác nhận",
  "vectorId.specimen.count": "bệnh phẩm",
  "vectorId.specimen.empty": "Không có bệnh phẩm cho lô này.",
  "vectorId.specimen.label": "Bệnh phẩm #{n}",
  "vectorId.specimen.notIdentified": "Chưa định danh",
  "vectorId.specimen.presumptive": "Dự kiến",
  "vectorId.status.complete": "Hoàn tất",
  "vectorId.status.inProgress": "Đang xử lý",
  "vectorId.status.notStarted": "Chưa bắt đầu",
  "vectorId.tag.deconComplete": "Hoàn tất",
  "vectorId.tag.deconInProgress": "Đang giải gộp",
  "vectorId.tag.deconNeeded": "⚠ Duyệt kết quả",
  "vectorId.tag.subPoolPending": "{count} mẫu gộp con có kết quả",
  "vectorId.tree.organisms": "{count, plural, other {# cá thể}}",
  "vectorReport.density.bySite": "Mật độ theo địa điểm và giai đoạn",
  "vectorReport.density.effortNotRecorded": "Chưa ghi nhận công sức thu mẫu",
  "vectorReport.density.period": "Giai đoạn",
  "vectorReport.density.perTrapNight": "Mật độ (trên bẫy-đêm)",
  "vectorReport.density.pools": "Mẫu gộp",
  "vectorReport.density.site": "Địa điểm",
  "vectorReport.density.specimens": "Bệnh phẩm",
  "vectorReport.density.title": "Số lượng bệnh phẩm theo địa điểm",
  "vectorReport.density.trapNights": "Bẫy-đêm",
  "vectorReport.description": "Chỉ số giám sát tính từ các đợt thu mẫu véc-tơ, định danh loài và kết quả tác nhân gây bệnh đã ghi nhận",
  "vectorReport.empty": "Không có dữ liệu trong phạm vi đã chọn.",
  "vectorReport.exportPdf": "Xuất PDF",
  "vectorReport.fieldMap.description": "Sắp xếp lại, ẩn, đổi nhãn hoặc gắn thẻ cổng cho các chỉ số hiển thị trong Trợ lý nhập thủ công.",
  "vectorReport.fieldMap.hidden": "Đã ẩn",
  "vectorReport.fieldMap.label": "Nhãn",
  "vectorReport.fieldMap.metric": "Chỉ số",
  "vectorReport.fieldMap.order": "Thứ tự",
  "vectorReport.fieldMap.portalTag": "Thẻ cổng",
  "vectorReport.fieldMap.title": "Bản đồ trường nhập thủ công",
  "vectorReport.fieldMap.visibility": "Hiển thị",
  "vectorReport.fieldMap.visible": "Hiện",
  "vectorReport.fieldMap.visibleLabel": "Hiện trong Trợ lý nhập thủ công",
  "vectorReport.filter.allSites": "Mọi địa điểm",
  "vectorReport.filter.apply": "Áp dụng",
  "vectorReport.filter.dateRange": "Khoảng thời gian",
  "vectorReport.filter.from": "Từ",
  "vectorReport.filter.site": "Địa điểm lấy mẫu",
  "vectorReport.filter.to": "Đến",
  "vectorReport.freshness": "Độ mới của dữ liệu",
  "vectorReport.freshness.as": "Số liệu tính đến {time}",
  "vectorReport.freshness.unknown": "không rõ",
  "vectorReport.generated": "Tạo lúc:",
  "vectorReport.home": "Trang chủ",
  "vectorReport.loadError": "Không tải được chỉ số giám sát. Thử lại.",
  "vectorReport.manualEntry.confirmBody": "Ghi một bản lưu vết số liệu của tuần này ({periodStart} – {periodEnd})? Gửi lại một tuần sẽ được ghi thành một mục riêng.",
  "vectorReport.manualEntry.confirmSubmit": "Xác nhận",
  "vectorReport.manualEntry.copied": "Đã chép vào bộ nhớ tạm",
  "vectorReport.manualEntry.copy": "Chép giá trị",
  "vectorReport.manualEntry.empty": "Chưa cấu hình chỉ số nào cho giai đoạn này",
  "vectorReport.manualEntry.loading": "Đang tải số liệu của tuần...",
  "vectorReport.manualEntry.lowConfidence": "Độ tin cậy giảm (giải gộp mẫu dưới 95%)",
  "vectorReport.manualEntry.markSubmitted": "Đánh dấu đã gửi tuần này",
  "vectorReport.manualEntry.submitError": "Không ghi nhận được việc gửi",
  "vectorReport.manualEntry.submitted": "Đã đánh dấu tuần đã gửi",
  "vectorReport.manualEntry.title": "Trợ lý nhập thủ công",
  "vectorReport.manualEntry.week": "Tuần báo cáo",
  "vectorReport.mir.classic": "MIR (cổ điển)",
  "vectorReport.mir.observed": "Tỷ lệ nhiễm (quan sát)",
  "vectorReport.mir.pathogen": "Tác nhân",
  "vectorReport.mir.positivePools": "Mẫu gộp dương tính",
  "vectorReport.mir.resolution": "Độ phân giải dương tính",
  "vectorReport.mir.species": "Loài",
  "vectorReport.mir.sporozoite": "Tỷ lệ bào tử trùng",
  "vectorReport.mir.sporozoiteNote": "Độ tin cậy giảm khi độ phân giải giải gộp mẫu dưới 95%.",
  "vectorReport.mir.title": "Tỷ lệ nhiễm tối thiểu theo loài",
  "vectorReport.mir.totalSpecimens": "Tổng số bệnh phẩm",
  "vectorReport.mir.withheld": "Đã giữ lại",
  "vectorReport.positivity.notConfigured": "Chưa cấu hình phân loại dương tính cho hệ thống này, nên không có số liệu tỷ lệ nhiễm, tỷ lệ dương tính và bào tử trùng. Cấu hình ý nghĩa kết quả trong danh mục xét nghiệm để bật.",
  "vectorReport.positivity.pathogen": "Tác nhân",
  "vectorReport.positivity.pct": "Tỷ lệ dương tính",
  "vectorReport.positivity.poolsPositive": "Mẫu gộp dương tính",
  "vectorReport.positivity.poolsTested": "Mẫu gộp đã xét nghiệm",
  "vectorReport.positivity.title": "Tỷ lệ dương tính tác nhân",
  "vectorReport.positivity.unrecognized": "Một số kết quả có giá trị ý nghĩa không thuộc phân loại được nhận (POSITIVE, NEGATIVE hoặc INDETERMINATE) nên bị loại khỏi số đếm dương tính. Rà soát danh mục xét nghiệm để các kết quả này được đếm.",
  "vectorReport.prompt": "Chọn khoảng thời gian và địa điểm, rồi bấm Áp dụng để xem chỉ số giám sát.",
  "vectorReport.qc.detail": "{passed} / {total} lần phân tích đạt",
  "vectorReport.qc.passed": "Lần phân tích đạt",
  "vectorReport.qc.passRate": "Tỷ lệ đạt",
  "vectorReport.qc.title": "Tỷ lệ đạt QC",
  "vectorReport.qc.total": "Tổng số lần phân tích",
  "vectorReport.species.genus": "Chi",
  "vectorReport.species.pct": "Tỷ trọng",
  "vectorReport.species.species": "Loài",
  "vectorReport.species.specimens": "Bệnh phẩm",
  "vectorReport.species.title": "Phân bố loài",
  "vectorReport.sporozoite.title": "Tỷ lệ bào tử trùng (Anopheles)",
  "vectorReport.title": "Giám sát véc-tơ",
  "vfs.abj": "ABJ (Tỷ lệ không có ấu trùng)",
  "vfs.abj.target.below": "✗ ABJ dưới mục tiêu 95% của Kemenkes",
  "vfs.abj.target.met": "✓ ABJ đạt mục tiêu 95% của Kemenkes",
  "vfs.bi": "Chỉ số Breteau (trên 100 nhà)",
  "vfs.ci": "Chỉ số dụng cụ chứa nước (CI)",
  "vfs.containersExamined": "Dụng cụ chứa nước đã kiểm tra",
  "vfs.containersPositive": "Dụng cụ chứa nước dương tính",
  "vfs.err.containersExceeded": "Không được vượt số dụng cụ chứa nước đã kiểm tra.",
  "vfs.err.examinedMin": "Phải ≥ 1 khi đã nhập số liệu ấu trùng.",
  "vfs.err.housesExceeded": "Không được vượt số nhà đã kiểm tra.",
  "vfs.err.negative": "Không được là số âm.",
  "vfs.err.populationMin": "Phải ≥ 1 khi đã nhập số liệu nhộng.",
  "vfs.hi": "Chỉ số nhà (HI)",
  "vfs.housesExamined": "Nhà đã kiểm tra",
  "vfs.housesPositive": "Nhà dương tính",
  "vfs.indices.title": "Chỉ số đã tính (xem trước)",
  "vfs.larval.title": "Khảo sát ấu trùng — Chế độ C",
  "vfs.populationAtRisk": "Quần thể có nguy cơ",
  "vfs.ppi": "Nhộng trên đầu người (PPI)",
  "vfs.pupaeCount": "Số nhộng",
  "vfs.pupal.title": "Khảo sát nhộng — Chế độ D",
  "vfs.surveyMethod": "Phương pháp khảo sát",
  "vfs.surveyMethod.placeholder": "Chọn một phương án",
  "warning.testCatalog.noLoinc": "Xét nghiệm này chưa có mã LOINC. Không nhập được kết quả từ máy xét nghiệm và e-order vào xét nghiệm này.",
  "warning.testCatalog.duplicateLoinc": "Mã LOINC {code} cũng đang được dùng bởi {testName}. Kết quả đến với mã này chỉ được định tuyến tới một xét nghiệm (khớp đầu tiên) — kết quả có thể bị gửi nhầm xét nghiệm.",
  "label.testCatalog.terminology.col.source": "Nguồn",
  "label.testCatalog.terminology.col.code": "Mã",
  "label.testCatalog.terminology.col.displayName": "Tên hiển thị",
  "label.testCatalog.terminology.displayName.placeholder": "VD: Glucose [Khối lượng/thể tích] trong huyết thanh hoặc huyết tương",
  "label.testCatalog.terminology.col.relationship": "Quan hệ",
  "label.testCatalog.terminology.col.appliesTo": "Áp dụng cho",
  "label.testCatalog.terminology.appliesTo.test": "Toàn bộ xét nghiệm",
  "label.testCatalog.terminology.col.actions": "Thao tác",
  "label.testCatalog.terminology.source": "Nguồn danh pháp",
  "label.testCatalog.terminology.sourceTooLong": "A source is at most {max} characters",
  "label.testCatalog.terminology.code": "Mã",
  "label.testCatalog.terminology.relationship": "Quan hệ",
  "label.testCatalog.terminology.addMapping": "Thêm ánh xạ",
  "label.testCatalog.terminology.remove": "Xóa ánh xạ",
  "label.testCatalog.terminology.empty": "Chưa có ánh xạ danh pháp nào.",
  "label.testCatalog.terminology.loadError": "Không tải được ánh xạ danh pháp.",
  "label.testCatalog.terminology.saved": "Đã lưu ánh xạ danh pháp.",
  "error.testCatalog.terminology.duplicate": "Trùng mã {source} {code} — ánh xạ này đã tồn tại cho xét nghiệm này.",
  "error.testCatalog.terminology.invalid": "Không lưu được ánh xạ — kiểm tra mã trùng, nguồn không rõ hoặc quan hệ không hợp lệ.",
  "error.testCatalog.terminology.tooLong": "Mã tối đa 80 ký tự, tên hiển thị tối đa 255 ký tự.",
  "label.testCatalog.terminology.rel.none": "— không có —",
  "label.testCatalog.terminology.rel.SAME_AS": "Tương đương",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Rộng hơn",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Hẹp hơn",
  "label.testCatalog.panels.intro": "Quản lý xét nghiệm này thuộc những bộ nào, và vị trí của nó trong từng bộ.",
  "label.testCatalog.panels.addToPanel": "Thêm vào bộ",
  "label.testCatalog.panels.col.panel": "Bộ xét nghiệm",
  "label.testCatalog.panels.col.position": "Vị trí",
  "label.testCatalog.panels.col.actions": "Thao tác",
  "label.testCatalog.panels.position": "Vị trí",
  "label.testCatalog.panels.remove": "Gỡ khỏi bộ",
  "label.testCatalog.panels.remove.confirm.heading": "Gỡ xét nghiệm khỏi bộ?",
  "label.testCatalog.panels.remove.confirm.body": "Xét nghiệm này sẽ bị gỡ khỏi {panel}. Nó vẫn còn trong danh mục và các bộ khác. Bạn có thể thêm lại sau.",
  "label.testCatalog.panels.moveUp": "Đưa lên trước",
  "label.testCatalog.panels.moveDown": "Đưa xuống sau",
  "label.testCatalog.panels.viewOrder": "Xem thứ tự xét nghiệm của bộ này",
  "label.testCatalog.panels.orderContext": "Các xét nghiệm trong bộ này (theo thứ tự):",
  "label.testCatalog.panels.empty": "Xét nghiệm này chưa thuộc bộ nào.",
  "label.testCatalog.panels.loadError": "Không tải được thành viên bộ xét nghiệm.",
  "label.testCatalog.panels.saved": "Đã lưu thành viên bộ xét nghiệm.",
  "label.testCatalog.panels.createPanel": "Tạo bộ xét nghiệm mới",
  "label.testCatalog.panels.createPanelHint": "Nhập tên để tạo bộ và thêm xét nghiệm này vào. Loại mẫu, các module chỉ định và cài đặt khác sẽ cấu hình sau trong Trình sửa bộ xét nghiệm.",
  "notification.testCatalog.panels.created": "Đã tạo bộ '{name}' và thêm xét nghiệm này. Cấu hình thêm trong Trình sửa bộ xét nghiệm.",
  "label.search": "Tìm",
  "label.testCatalog.list": "Danh mục xét nghiệm",
  "label.testCatalog.list.search": "Tìm theo tên xét nghiệm",
  "label.testCatalog.list.col.status": "Trạng thái",
  "label.testCatalog.list.filter.allDomains": "Mọi lĩnh vực",
  "label.testCatalog.list.filter.allStatus": "Mọi trạng thái",
  "label.testCatalog.list.filter.inactive": "Ngừng dùng",
  "label.testCatalog.list.coverageIncomplete": "Chưa phủ đủ",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Tất cả",
  "label.testCatalog.list.filter.amrOnly": "Chỉ AMR",
  "label.testCatalog.list.filter.nonAmr": "Không phải AMR",
  "label.testCatalog.list.filter.sampleType": "Loại mẫu",
  "label.testCatalog.list.filter.allSampleTypes": "Mọi loại mẫu",
  "label.testCatalog.list.filter.allLabUnits": "Mọi nhóm xét nghiệm",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "Chưa có LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Chỉ xét nghiệm có vấn đề",
  "label.testCatalog.list.health.banner": "{count} xét nghiệm có lỗi cấu hình ({errors} lỗi · {warnings} cảnh báo)",
  "label.testCatalog.list.health.show": "Xem",
  "label.testCatalog.activation.incomplete.heading": "Chưa thể kích hoạt xét nghiệm",
  "label.testCatalog.activation.incomplete.body": "Xử lý các mục sau trước khi kích hoạt xét nghiệm này:",
  "label.testCatalog.list.col.sampleType": "Loại mẫu",
  "button.testCatalog.newTest": "Xét nghiệm mới",
  "button.testCatalog.editRelated": "Sửa các xét nghiệm liên quan cùng lúc",
  "button.testCatalog.editRelatedFromEditor": "Sửa các xét nghiệm liên quan…",
  "label.testCatalog.editor.noRelated": "Không có xét nghiệm nào khác trùng tên với xét nghiệm này.",
  "label.testCatalog.editor.createSaveFirst.title": "Lưu xét nghiệm trước",
  "label.testCatalog.editor.createSaveFirst": "Điền Thông tin cơ bản rồi lưu. Mục này sẽ mở sau khi xét nghiệm được tạo.",
  "label.testCatalog.editingNTests": "Đang sửa {count} xét nghiệm",
  "label.testCatalog.perTestIdentity": "Định danh & LOINC (riêng từng xét nghiệm)",
  "state.testCatalog.differsAcrossTests": "Khác nhau giữa các xét nghiệm",
  "button.testCatalog.setAllTo": "Đặt tất cả theo các giá trị này",
  "label.testCatalog.group.rangesSaved": "Đã lưu chỉ số bình thường cho {count} xét nghiệm.",
  "label.testCatalog.group.storageIntro": "Sửa bảo quản & xử lý một lần; khi lưu, các trường bạn thay đổi sẽ áp dụng cho mọi xét nghiệm đã chọn, các trường khác giữ nguyên giá trị riêng của từng xét nghiệm.",
  "label.testCatalog.group.storageDiffer": "Các trường này không giống nhau trên mọi xét nghiệm đã chọn: {fields}. Biểu mẫu hiện giá trị của xét nghiệm đầu tiên; trường bạn để nguyên sẽ giữ giá trị riêng của từng xét nghiệm.",
  "button.testCatalog.removeFromSet": "Gỡ khỏi nhóm này",
  "label.testCatalog.group.rangesIntro": "Sửa chỉ số bình thường một lần; khi lưu sẽ áp dụng cho mọi xét nghiệm đã chọn. Định danh và LOINC vẫn riêng từng xét nghiệm.",
  "label.testCatalog.group.rangesDiffer": "Chỉ số hiện tại của các xét nghiệm đã chọn không giống nhau. Lưu sẽ đặt tất cả theo các giá trị bên dưới.",
  "label.testCatalog.group.rangesLoadError": "Không tải được chỉ số hiện tại của {tests}, nên chưa áp dụng được gì. Thử tải lại.",
  "label.testCatalog.ranges.table.sex": "Áp dụng cho",
  "label.testCatalog.ranges.table.age": "Khoảng tuổi",
  "label.testCatalog.ranges.table.normal": "Bình thường (thấp / cao)",
  "label.testCatalog.list.filters": "Bộ lọc",
  "label.testCatalog.list.filters.count": "Bộ lọc ({count})",
  "label.testCatalog.list.error": "Không tải được danh mục xét nghiệm. Điều chỉnh bộ lọc hoặc tải lại để thử lại.",
  "label.testCatalog.list.empty": "Không có xét nghiệm nào khớp bộ lọc hiện tại.",
  "sidenav.label.admin.testmgt.ManageMethod": "Quản lý phương pháp",
  "sidenav.label.admin.testmgt.reflex": "Quản lý xét nghiệm phản xạ",
  "sidenav.label.admin.usermgt": "Quản lý người dùng",
  "sideNav.label.arvfollowup1": "Theo dõi ARV - Mẫu 1",
  "sideNav.label.arvfollowup2": "Theo dõi ARV - Mẫu 2",
  "sideNav.label.arvreports1": "ARV ban đầu - Mẫu 1",
  "sideNav.label.arvreports2": "ARV ban đầu - Mẫu 2",
  "sideNav.label.arvversion1": "ARV - Mẫu 1",
  "sideNav.label.associatedpatientreport": "Phiếu kết quả bệnh nhân liên quan",
  "sideNav.label.audittrail": "Nhật ký kiểm toán",
  "sidenav.label.barcode": "Mã vạch",
  "sidenav.label.batchorder": "Nhập chỉ định hàng loạt",
  "sideNav.label.bypaneltype": "Theo loại bộ xét nghiệm",
  "sideNav.label.bytesttype": "Theo loại xét nghiệm",
  "sideNav.label.byunit": "Theo nhóm xét nghiệm",
  "sideNav.label.collectedarvpatientreports": "Phiếu kết quả ARV đã thu thập",
  "sidenav.label.cytology": "Tế bào học",
  "sidenav.label.cytology.dashboard": "Bàn làm việc",
  "sideNav.label.delayedvalidation": "Duyệt trễ",
  "sidenav.label.editorder": "Sửa chỉ định",
  "sideNav.label.eidreports1": "EID - Mẫu 1",
  "sideNav.label.eidreports2": "EID - Mẫu 2",
  "sideNav.label.exportcsvfile": "Xuất file CSV định kỳ",
  "sideNav.label.followuprequired": "Cần theo dõi",
  "sideNav.label.generalreport": "Báo cáo tổng hợp",
  "sideNav.label.hivtestsummary": "Tổng hợp xét nghiệm HIV",
  "sidenav.label.immunochem": "Hóa mô miễn dịch",
  "sidenav.label.immunochem.dashboard": "Bàn làm việc",
  "sidenav.label.incomingorder": "Chỉ định điện tử",
  "sideNav.label.intermediatebyservice": "Trung gian theo dịch vụ",
  "sideNav.label.intermediatereport1": "Trung gian - Mẫu 1",
  "sideNav.label.intermediatereport2": "Trung gian - Mẫu 2",
  "sidenav.label.inventory": "Kho",
  "sidenav.label.inventory.management": "Quản lý kho",
  "sidenav.label.inventory.management.tooltip": "Quản lý vật tư kho, lô và mức tồn kho",
  "sidenav.label.inventory.tooltip": "Quản lý kho hóa chất, bộ kit và vật tư tiêu hao",
  "sideNav.label.laporanHasil": "Báo cáo tuân thủ",
  "sideNav.label.noncomformitynotification": "Thông báo sự không phù hợp",
  "sideNav.label.noncomformityreportsbydate": "Theo ngày",
  "sideNav.label.noncomformityreportsbylabno": "Theo mã mẫu",
  "sideNav.label.noncomformityreportsbyunit": "Theo nhóm xét nghiệm và lý do",
  "sidenav.label.notebook": "Sổ ghi chép",
  "sidenav.label.add.order": "Nhập chỉ định",
  "sidenav.label.clinical.order": "Nhập chỉ định lâm sàng",
  "sidenav.label.environmental.compliance": "Bàn theo dõi tuân thủ",
  "sidenav.label.environmental.order": "Nhập chỉ định môi trường",
  "sidenav.label.vector.order": "Nhập chỉ định véc-tơ",
  "sidenav.label.order": "Chỉ định",
  "sidenav.label.order.collect": "Lấy mẫu",
  "sidenav.label.order.dashboard": "Bàn làm việc",
  "sidenav.label.order.enter": "Nhập chỉ định",
  "sidenav.label.order.label": "Dán nhãn & lưu trữ",
  "sidenav.label.order.qa": "Rà soát QA",
  "sidenav.label.order.prepare": "Chuẩn bị mẫu",
  "sidenav.label.order.sampleCheck": "Kiểm tra mẫu",
  "sidenav.label.pathology": "Giải phẫu bệnh",
  "sidenav.label.pathology.dashboard": "Bàn làm việc",
  "sideNav.label.referredtestreport": "Báo cáo xét nghiệm gửi đi",
  "sideNav.label.rejectionreport": "Báo cáo mẫu từ chối",
  "sidenav.label.reports": "Báo cáo",
  "sidenav.label.reports.routine": "Định kỳ",
  "sidenav.label.reports.study": "Nghiên cứu",
  "sidenav.label.results": "Kết quả",
  "sidenav.label.results.byrange": "Theo khoảng mã mẫu",
  "sidenav.label.results.order": "Theo chỉ định",
  "sidenav.label.results.patient": "Theo bệnh nhân",
  "sidenav.label.results.testdate": "Theo ngày xét nghiệm",
  "sidenav.label.results.unit": "Theo nhóm xét nghiệm",
  "sideNav.label.sectionperformance": "Hiệu suất theo nhóm",
  "sideNav.label.specialrequest": "Yêu cầu đặc biệt ",
  "sidenav.label.statisticsreport": "Báo cáo thống kê",
  "sidenav.label.statusreport": "Báo cáo trạng thái bệnh nhân",
  "sidenav.label.storage.coldstorage": "Giám sát kho lạnh",
  "sidenav.label.storage.coldstorage.tooltip": "Theo dõi nhiệt độ và độ ẩm của tủ đông và tủ lạnh",
  "sidenav.label.storage.management": "Quản lý lưu trữ",
  "sidenav.label.storage.management.tooltip": "Quản lý vị trí và thiết bị lưu trữ",
  "sidenav.label.testsummary": "Tổng hợp tất cả xét nghiệm",
  "sidenav.label.validation": "Duyệt kết quả",
  "sidenav.label.validation.order": "Tìm theo chỉ định",
  "sidenav.label.validation.routine": "Định kỳ",
  "sidenav.label.validation.study": "Nghiên cứu",
  "sidenav.label.validation.testdate": "Tìm theo ngày xét nghiệm",
  "sideNav.label.viralloaddataexport": "Xuất dữ liệu tải lượng virus",
  "sideNav.label.vlversionnational": "VL - Mẫu quốc gia",
  "sidenav.label.workplan": "Phiếu công việc",
  "sidenav.label.workplan.panel": "Theo loại bộ xét nghiệm",
  "sidenav.label.workplan.priority": "Theo mức ưu tiên",
  "sidenav.label.workplan.test": "Theo loại xét nghiệm",
  "sidenav.label.workplan.unit": "Theo nhóm xét nghiệm",
  "sideNav.title.activityreport": "Báo cáo hoạt động",
  "sidenav.title.aggregatereport": "Báo cáo tổng hợp",
  "sideNav.title.arvreports": "Báo cáo ARV",
  "sideNav.title.associatedpatientreport": "Phiếu kết quả bệnh nhân liên quan",
  "sideNav.title.audittrail": "Nhật ký kiểm toán",
  "sideNav.title.collectedarvpatientreports": "Phiếu kết quả ARV đã thu thập",
  "sideNav.title.delayedvalidation": "Duyệt trễ",
  "sideNav.title.eidreports": "Báo cáo EID",
  "sideNav.title.environmentalReports": "Báo cáo môi trường",
  "sideNav.title.exportbydate": "Xuất theo ngày",
  "sideNav.title.exportcsvfile": "Xuất file CSV định kỳ",
  "sideNav.title.indicator": "Chỉ số",
  "sideNav.title.intermediatereport": "Báo cáo trung gian",
  "sideNav.title.noncomformityreports": "Báo cáo sự không phù hợp",
  "sideNav.title.referredtestreport": "Báo cáo xét nghiệm gửi đi",
  "sideNav.title.rejectionreport": "Báo cáo mẫu từ chối",
  "sideNav.title.specialrequest": "Yêu cầu đặc biệt ",
  "sideNav.title.tatreport": "Thời gian trả kết quả (TAT)",
  "sideNav.title.vectorIdentification": "Định danh véc-tơ",
  "sideNav.title.vlreport": "Báo cáo VL",
  "sideNav.label.audittrail.orderEvents": "Sự kiện chỉ định",
  "sideNav.label.audittrail.systemEvents": "Sự kiện hệ thống",
  "sidenav.label.addorder": "Nhập chỉ định chung",
  "sidenav.label.admin.sampleTypeManagement": "Trình sửa loại mẫu",
  "sideNav.label.qa": "Đảm bảo chất lượng",
  "sideNav.label.qa.overview": "Tổng quan QA",
  "sideNav.label.qa.qc": "QC thống kê",
  "sideNav.label.qa.qc.dashboard": "Bàn làm việc QC",
  "sideNav.label.qa.qc.alerts": "Cảnh báo QC",
  "sideNav.label.qa.qc.controlLots": "Quản lý lô QC",
  "sideNav.label.qa.qc.ruleConfig": "Cấu hình quy tắc",
  "sideNav.label.qa.qc.reagentQc": "QC hóa chất",
  "sideNav.label.qa.qc.manualQc": "QC thủ công trên máy",
  "sideNav.label.qa.qi": "Chỉ số chất lượng",
  "sideNav.label.qa.qi.dashboard": "Bàn làm việc chỉ số",
  "sideNav.label.qa.qi.config": "Cấu hình chỉ số",
  "qa.qiConfig.subtitle": "Đặt ngưỡng mục tiêu và ngưỡng hành động cho từng chỉ số, bật hoặc tắt chỉ số, và ghi đè ngưỡng cho từng nhóm xét nghiệm.",
  "qa.qiConfig.column.overrides": "Ghi đè",
  "qa.qiConfig.field.enabled": "Theo dõi chỉ số này",
  "qa.qiConfig.field.target": "Mục tiêu",
  "qa.qiConfig.field.action": "Ngưỡng hành động",
  "qa.qiConfig.field.category": "Nhóm xét nghiệm",
  "qa.qiConfig.editor.title": "Sửa {indicator}",
  "qa.qiConfig.editor.defaults": "Ngưỡng mặc định",
  "qa.qiConfig.editor.overrides": "Ghi đè theo nhóm",
  "qa.qiConfig.editor.usesDefault": "Nhóm xét nghiệm không có ghi đè sẽ dùng ngưỡng mặc định của chỉ số.",
  "qa.qiConfig.editor.noOverrides": "Chưa có ghi đè — mọi nhóm xét nghiệm đều dùng mặc định.",
  "qa.qiConfig.editor.addOverride": "Thêm ghi đè cho nhóm",
  "qa.qiConfig.editor.autoNce": "Khi giá trị lũy kế trong tháng vượt ngưỡng hành động, một sự kiện không phù hợp (NCE) được tạo tự động (mỗi chỉ số một lần mỗi tháng).",
  "qa.qiConfig.indicator.tat": "Thời gian trả kết quả trung bình",
  "qa.qiConfig.indicator.rejection": "Tỷ lệ từ chối mẫu",
  "qa.qiConfig.indicator.amendment": "Tỷ lệ sửa kết quả",
  "qa.qiConfig.indicator.nce": "Nhịp NCE",
  "qa.qiConfig.indicator.callback": "Tuân thủ gọi báo kết quả nguy kịch",
  "qa.qiConfig.validation.required": "Phải nhập cả ngưỡng mục tiêu và ngưỡng hành động.",
  "qa.qiConfig.validation.range": "Ngưỡng phải nằm trong khoảng từ 0 đến 100.",
  "qa.qiConfig.validation.direction": "Thứ tự ngưỡng mục tiêu và ngưỡng hành động không đúng với chỉ số này.",
  "qa.qiConfig.validation.category": "Chọn một nhóm xét nghiệm cho mỗi ghi đè.",
  "qa.qiConfig.validation.duplicateCategory": "Mỗi nhóm xét nghiệm chỉ được ghi đè một lần.",
  "qa.qiConfig.confirmDisableTitle": "Tắt chỉ số này?",
  "qa.qiConfig.confirmDisableBody": "Thao tác này sẽ ẩn ô trên bàn làm việc, không hiện cảnh báo mới và dừng tạo NCE tự động của chỉ số này. Dữ liệu lịch sử được giữ nguyên. Tiếp tục?",
  "qa.qiConfig.saveFailed": "Không lưu được cấu hình chỉ số.",
  "sideNav.label.qa.qms": "QMS & Cải tiến",
  "sideNav.label.qa.qms.esigLog": "Nhật ký chữ ký điện tử",
  "sideNav.label.qa.qms.capaRegister": "Sổ CAPA",
  "sideNav.label.qa.qms.accreditation": "Công nhận",
  "qa.qms.capaRegister.subtitle": "Mọi hành động khắc phục và phòng ngừa trên tất cả sự kiện không phù hợp, kèm hạn xử lý và trạng thái.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Đến hạn tuần này",
  "qa.qms.capaRegister.tile.completed": "Đã hoàn thành (90 ngày)",
  "qa.qms.capaRegister.filter.assignee": "Người phụ trách",
  "qa.qms.capaRegister.filter.from": "Hạn xử lý (từ)",
  "qa.qms.capaRegister.filter.to": "Hạn xử lý (đến)",
  "qa.qms.capaRegister.column.correctiveAction": "Hành động khắc phục / phòng ngừa",
  "qa.qms.capaRegister.column.assignee": "Người chịu trách nhiệm",
  "qa.qms.capaRegister.status.open": "Đang mở",
  "qa.qms.capaRegister.status.overdue": "Quá hạn",
  "qa.qms.capaRegister.status.completed": "Đã hoàn thành",
  "qa.qms.capaRegister.error": "Không tải được sổ CAPA.",
  "qa.qms.accreditation.title": "Công nhận xét nghiệm",
  "qa.qms.accreditation.subtitle": "Tổ chức công nhận và đăng ký theo từng xét nghiệm. Quyết định logo công nhận trên phiếu kết quả và câu trả lời khi thanh tra.",
  "qa.qms.accreditation.error": "Không tải được dữ liệu công nhận.",
  "qa.qms.accreditation.actionError": "Không lưu được thay đổi.",
  "qa.qms.accreditation.tile.total": "Tổ chức",
  "qa.qms.accreditation.inForce": "Đang có hiệu lực: {names}",
  "qa.qms.accreditation.bodies.title": "Tổ chức công nhận",
  "qa.qms.accreditation.bodies.add": "Thêm tổ chức",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Hết hạn",
  "qa.qms.accreditation.status.ACTIVE": "Đang hiệu lực",
  "qa.qms.accreditation.status.EXPIRING": "Sắp hết hạn",
  "qa.qms.accreditation.status.EXPIRED": "Đã hết hạn",
  "qa.qms.accreditation.status.INACTIVE": "Ngừng dùng",
  "qa.qms.accreditation.body.modal.addTitle": "Thêm tổ chức công nhận",
  "qa.qms.accreditation.body.modal.editTitle": "Sửa tổ chức công nhận",
  "qa.qms.accreditation.body.edit": "Sửa tổ chức",
  "qa.qms.accreditation.body.delete": "Xóa tổ chức",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 ký tự: chữ hoa, chữ số và dấu gạch ngang. Không đổi được sau này.",
  "qa.qms.accreditation.body.field.expiresOn": "Công nhận hết hạn",
  "qa.qms.accreditation.body.field.visibilityMode": "Hiện logo trên phiếu kết quả khi",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Phiếu có bất kỳ xét nghiệm được công nhận nào",
  "qa.qms.accreditation.visibility.PERCENTAGE": "Một tỷ lệ xét nghiệm trên phiếu được công nhận",
  "qa.qms.accreditation.body.field.thresholdPct": "Ngưỡng (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG hoặc JPEG, tối thiểu 64×64 pixel, tối đa 500 KB)",
  "qa.qms.accreditation.body.logo.remove": "Gỡ logo",
  "qa.qms.accreditation.body.required": "Bắt buộc nhập mã, tên và ngày hết hạn.",
  "qa.qms.accreditation.body.saveError": "Không lưu được tổ chức công nhận.",
  "qa.qms.accreditation.body.logoError": "Không tải lên được logo. Dùng PNG hoặc JPEG tối thiểu 64×64 pixel và không quá 500 KB.",
  "qa.qms.accreditation.body.delete.title": "Xóa tổ chức công nhận",
  "qa.qms.accreditation.body.delete.body": "Xóa {name}? Không thể hoàn tác.",
  "qa.qms.accreditation.body.delete.blocked": "Không xóa được — có {count} công nhận xét nghiệm đang tham chiếu tổ chức này. Gỡ chúng trước.",
  "qa.qms.accreditation.enrollments.title": "Xét nghiệm đã đăng ký",
  "qa.qms.accreditation.enrollments.add": "Đăng ký xét nghiệm",
  "qa.qms.accreditation.enrollment.column.body": "Tổ chức công nhận",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "Có hiệu lực từ",
  "qa.qms.accreditation.enrollment.column.expires": "Tổ chức hết hạn",
  "qa.qms.accreditation.enrollment.remove": "Hủy đăng ký",
  "qa.qms.accreditation.eqa.title": "Độ phủ EQA của phạm vi được công nhận",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 hỏi mọi xét nghiệm bạn tuyên bố được công nhận có tham gia đánh giá chất lượng ngoài (EQA) hay không. Phần này đối chiếu phạm vi công nhận với các đăng ký EQA đang hiệu lực.",
  "qa.qms.accreditation.eqa.column.scope": "Xét nghiệm trong phạm vi",
  "qa.qms.accreditation.eqa.column.covered": "Đã có EQA",
  "qa.qms.accreditation.eqa.column.gaps": "Thiếu",
  "qa.qms.accreditation.eqa.noGaps": "Phủ đủ",
  "qa.qms.accreditation.eqa.gapsMore": "{names} và {count} mục khác",
  "qa.qms.accreditation.eqa.error": "Không tải được độ phủ EQA.",
  "qa.qms.accreditation.filter.body": "Tổ chức công nhận",
  "qa.qms.accreditation.filter.test": "Xét nghiệm: {name}",
  "qa.qms.accreditation.enroll.modal.title": "Đăng ký xét nghiệm",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "Có hiệu lực từ (tùy chọn)",
  "qa.qms.accreditation.enroll.required": "Chọn một tổ chức công nhận và ít nhất một xét nghiệm.",
  "qa.qms.accreditation.enroll.failed": "Đăng ký bị từ chối.",
  "qa.qms.accreditation.enrollment.delete.title": "Hủy đăng ký",
  "qa.qms.accreditation.enrollment.delete.body": "Hủy đăng ký {test} khỏi {body}?",
  "qa.qms.esigLog.subtitle": "Mọi chữ ký điện tử được ghi nhận trong hệ thống — ai ký gì, lúc nào và vì sao.",
  "qa.qms.esigLog.column.signer": "Người ký",
  "qa.qms.esigLog.column.subject": "Đối tượng",
  "qa.qms.esigLog.filter.subjectType": "Loại đối tượng",
  "qa.qms.esigLog.filter.apply": "Áp dụng bộ lọc",
  "qa.qms.esigLog.export.confirm.title": "Xuất khi không có bộ lọc?",
  "qa.qms.esigLog.export.confirm.body": "Chưa áp dụng bộ lọc nên sẽ xuất mọi chữ ký trong khoảng ngày đã chọn (tối đa 10.000 dòng).",
  "qa.qms.esigLog.meaning.AUTHORED": "Lập",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Duyệt & phát hành",
  "qa.qms.esigLog.meaning.REJECTED": "Từ chối",
  "qa.qms.esigLog.error": "Không tải được nhật ký chữ ký. Thử lại.",
  "qa.qi.dashboard.subtitle": "Năm chỉ số chất lượng, kèm tùy chọn Tuân thủ gọi báo kết quả nguy kịch.",
  "qa.qi.dashboard.window.label": "Khoảng báo cáo",
  "qa.qi.dashboard.window.7d": "7 ngày gần nhất",
  "qa.qi.dashboard.window.30d": "30 ngày gần nhất",
  "qa.qi.dashboard.window.90d": "90 ngày gần nhất",
  "qa.qi.dashboard.window.ytd": "Từ đầu năm đến nay",
  "qa.qi.dashboard.lastRecomputed": "Tính lại lần cuối: {time}",
  "qa.qi.dashboard.viewDetail": "Xem chi tiết",
  "qa.qi.dashboard.tileInfo": "Ô này đo lường gì?",
  "qa.qi.disabled.toast.title": "Chỉ số đã tắt",
  "qa.qi.disabled.toast.message": "Chỉ số chất lượng này đã tắt trong Cấu hình chỉ số; trang chi tiết không khả dụng.",
  "qa.qi.dashboard.tile.tat.label": "TAT trung bình",
  "qa.qi.dashboard.tile.tat.tooltip": "Thời gian trả kết quả trung bình từ lúc nhận mẫu đến lúc duyệt kết quả, trên mọi chỉ định xét nghiệm đã hoàn tất trong khoảng báo cáo.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "so với {days} ngày trước",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "so với giai đoạn trước",
  "qa.qi.dashboard.tile.tat.secondary": "Trên {count, plural, one {# nhóm xét nghiệm} other {# nhóm xét nghiệm}} · Chậm nhất: {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "Không có chỉ định xét nghiệm đã hoàn tất trong khoảng này.",
  "qa.qi.dashboard.tile.tat.error": "Không có dữ liệu thời gian trả kết quả.",
  "qa.qi.dashboard.tile.rejection.label": "Tỷ lệ từ chối",
  "qa.qi.dashboard.tile.amendment.label": "Tỷ lệ sửa kết quả",
  "qa.qi.dashboard.tile.ncePulse.label": "Nhịp NCE",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Sự kiện không phù hợp nguy kịch chưa được xác nhận, tính đến hiện tại. Đây là số đếm hiện tại, không phải xu hướng.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "nguy kịch chờ xử lý",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} đang khắc phục",
  "qa.qi.dashboard.tile.ncePulse.error": "Không có dữ liệu NCE.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Kết quả được sửa sau khi phiếu kết quả bệnh nhân đã phát hành, tính theo tỷ lệ trên tổng kết quả phát hành trong khoảng báo cáo.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "so với {days} ngày trước",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "so với giai đoạn trước",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} sửa trên {released} phát hành",
  "qa.qi.dashboard.tile.amendment.empty": "Không có kết quả nào phát hành trong khoảng này.",
  "qa.qi.dashboard.tile.amendment.error": "Không có dữ liệu sửa kết quả.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Xét nghiệm bị từ chối khi nhập hoặc duyệt kết quả, tính theo tỷ lệ trên số xét nghiệm đã bắt đầu trong khoảng báo cáo.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "so với {days} ngày trước",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "so với giai đoạn trước",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} từ chối trên {total} đã bắt đầu",
  "qa.qi.dashboard.tile.rejection.empty": "Không có xét nghiệm nào bắt đầu trong khoảng này.",
  "qa.qi.dashboard.tile.rejection.error": "Không có dữ liệu từ chối.",
  "qa.qi.dashboard.tile.thresholds": "Mục tiêu {target} · hành động {action}",
  "qa.qi.amendment.title": "Tỷ lệ sửa kết quả — Chi tiết",
  "qa.qi.amendment.subtitle": "Kết quả được sửa sau khi phiếu kết quả bệnh nhân đã phát hành.",
  "qa.qi.amendment.column.amendedAt": "Sửa lúc",
  "qa.qi.amendment.column.priorValue": "Giá trị trước",
  "qa.qi.amendment.column.currentValue": "Giá trị hiện tại",
  "qa.qi.amendment.column.amendedBy": "Người sửa",
  "qa.qi.amendment.column.releasedAt": "Phát hành lúc",
  "qa.qi.amendment.column.timeToAmend": "Thời gian đến lúc sửa",
  "qa.qi.amendment.rate.label": "Tỷ lệ sửa kết quả",
  "qa.qi.amendment.trend.empty": "Không có dữ liệu xu hướng trong khoảng này.",
  "qa.qi.amendment.breakdown.title": "Theo xét nghiệm",
  "qa.qi.amendment.breakdown.column.rate": "Tỷ lệ",
  "qa.qi.rejection.title": "Tỷ lệ từ chối — Chi tiết",
  "qa.qi.rejection.subtitle": "Xét nghiệm bị từ chối khi nhập kết quả, kèm lý do từ chối đã ghi nhận.",
  "qa.qi.rejection.column.rejectedAt": "Từ chối lúc",
  "qa.qi.rejection.column.rejectedBy": "Người từ chối",
  "qa.qi.rejection.heatmap.title": "Bản đồ nhiệt: nơi chỉ định × nhóm xét nghiệm",
  "qa.qi.rejection.heatmap.section": "Nhóm xét nghiệm",
  "qa.qi.rejection.heatmap.unknown": "Không rõ nơi chỉ định",
  "qa.qi.rejection.heatmap.unknownSection": "Không rõ nhóm",
  "qa.qi.rejection.heatmap.legend": "Ô được tô màu theo tỷ lệ so với ngưỡng của phòng: xanh ≤ {target}%, vàng ở giữa, đỏ ≥ {action}%. Rê chuột vào ô để xem số từ chối / số đã bắt đầu.",
  "qa.qi.rejection.rate.label": "Tỷ lệ từ chối",
  "qa.qi.rejection.reasons.title": "Theo lý do (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% số từ chối",
  "qa.qi.rejection.reasons.column.cumulative": "% lũy kế",
  "qa.qi.rejection.reasons.donut.label": "Từ chối",
  "qa.qi.rejection.reasons.insight": "{count} lý do đầu trong tổng {total} lý do chiếm {percent}% số từ chối — xử lý {reason} trước sẽ có tác động lớn nhất.",
  "qa.qi.rejection.breakdown.other": "Khác ({count} xét nghiệm)",
  "qa.qi.rejection.list.title": "Từ chối từng trường hợp",
  "qa.qi.amendment.list.title": "Sửa từng trường hợp",
  "qa.qi.callback.button": "Ghi nhận gọi báo",
  "qa.qi.callback.banner.title": "Kết quả nguy kịch cần bác sĩ được gọi báo",
  "qa.qi.callback.banner.subtitle": "{count, plural, other {# kết quả nguy kịch đã lưu trên trang này chưa ghi nhận gọi báo — bắt buộc đọc lại (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Ghi nhận gọi báo nguy kịch",
  "qa.qi.callback.field.recipientName": "Người được báo",
  "qa.qi.callback.field.recipientName.placeholder": "Tên bác sĩ hoặc điều dưỡng khoa đã liên hệ",
  "qa.qi.callback.field.status": "Kết quả gọi báo",
  "qa.qi.callback.status.CONFIRMED": "Đã xác nhận có đọc lại",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Đã liên hệ, không đọc lại",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Không liên hệ được",
  "qa.qi.callback.save.success": "Đã ghi nhận gọi báo",
  "qa.qi.callback.save.fail": "Không ghi nhận được gọi báo",
  "qa.qi.callback.title": "Tuân thủ gọi báo nguy kịch — Chi tiết",
  "qa.qi.callback.subtitle": "Kết quả nguy kịch đã phát hành và từng kết quả có được gọi điện cho bác sĩ, có đọc lại, trong thời hạn mục tiêu hay không.",
  "qa.qi.callback.distribution.title": "Phân bố thời gian đến lúc xác nhận",
  "qa.qi.callback.distribution.0-5": "0–5 phút",
  "qa.qi.callback.distribution.5-15": "5–15 phút",
  "qa.qi.callback.distribution.15-30": "15–30 phút",
  "qa.qi.callback.distribution.30-60": "30–60 phút",
  "qa.qi.callback.distribution.over60": "Trên 60 phút",
  "qa.qi.callback.distribution.noAck": "Chưa xác nhận",
  "qa.qi.callback.failures.title": "Trường hợp không đạt ({count}) theo lý do",
  "qa.qi.callback.failures.overTarget": "Quá mục tiêu",
  "qa.qi.callback.failures.unableToReach": "Không liên hệ được",
  "qa.qi.callback.failures.noReadback": "Chưa ghi đọc lại",
  "qa.qi.callback.failures.noCallback": "Chưa ghi nhận gọi báo",
  "qa.qi.callback.list.title": "Kết quả nguy kịch trong khoảng",
  "qa.qi.callback.rate.label": "Tuân thủ gọi báo (đọc lại trong {minutes} phút)",
  "qa.qi.callback.status.notLogged": "Chưa ghi nhận",
  "qa.qi.callback.column.status": "Trạng thái gọi báo",
  "qa.qi.callback.column.timeToCallback": "Thời gian đến lúc gọi",
  "qa.qi.callback.column.loggedBy": "Người ghi nhận",
  "qa.qi.dashboard.tile.callback.label": "Tuân thủ gọi báo nguy kịch",
  "qa.qi.dashboard.tile.callback.tooltip": "Kết quả nguy kịch đã phát hành có gọi báo được xác nhận kèm đọc lại trong thời hạn mục tiêu của phòng. Tùy chọn — bật trong Cấu hình chỉ số. Tính lại từ ngưỡng nguy kịch hiện tại.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} trên {critical} kết quả nguy kịch được xử lý trong mục tiêu",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "so với {days} ngày trước",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "so với giai đoạn trước",
  "qa.qi.dashboard.tile.callback.empty": "Không có kết quả nguy kịch nào trong khoảng này.",
  "qa.qi.dashboard.tile.callback.error": "Không có dữ liệu gọi báo.",
  "qa.qi.dashboard.tile.callback.disabled": "Chưa bật — bật trong Cấu hình chỉ số.",
  "qa.empty.callback.title": "Không có kết quả nguy kịch trong khoảng này",
  "qa.empty.callback.subhead": "Kết quả nguy kịch đã phát hành sẽ hiện ở đây cùng trạng thái ghi nhận gọi báo.",
  "qa.overview.rejection.caption": "từ chối khi nhập kết quả (30 ngày)",
  "qa.overview.rejection.ofStarted": "{rejected} trên {total} đã bắt đầu",
  "qa.overview.callback.caption": "tuân thủ đọc lại kết quả nguy kịch (30 ngày)",
  "qa.overview.callback.ofCritical": "{confirmed} trên {critical} đã xác nhận",
  "qa.overview.callback.none": "không có kết quả nguy kịch trong khoảng",
  "qa.overview.week.confirmedCount": "{count} đã xác nhận",
  "qa.overview.amendment.caption": "sửa sau khi đã phát hành báo cáo (30 ngày)",
  "qa.overview.amendment.ofReleased": "{amended} trên {released} đã phát hành",
  "qa.future.subtitle": "Tính năng tương lai — đã có thiết kế; chưa lên lịch xây dựng.",
  "qa.future.questionLabel": "Câu hỏi mà tính năng này trả lời",
  "qa.future.whyLabel": "Vì sao quan trọng",
  "qa.future.readDesignDoc": "Đọc tài liệu thiết kế trên GitHub",
  "qa.future.reagentQc.question": "Lô hóa chất này đã được kiểm chứng trước khi dùng cho bệnh nhân chưa?",
  "qa.future.reagentQc.summary": "Theo dõi tần suất QC theo từng lô. Trước khi đưa lô hóa chất mới vào sử dụng lâm sàng, hệ thống yêu cầu có mẫu kiểm chứng được ghi nhận, so sánh lô mới với lô cũ hoặc với mẫu so sánh chuẩn.",
  "qa.future.reagentQc.why": "Nếu không kiểm chứng lô, một lô hóa chất hỏng có thể làm sai kết quả bệnh nhân cả tuần trước khi ai phát hiện. Hầu hết phòng xét nghiệm hiện làm việc này một cách không chính thức; đưa vào thành tính năng hệ thống sẽ bắt được những trường hợp quy trình không chính thức bị lọt.",
  "qa.future.manualQc.question": "Hôm nay kỹ thuật viên đã chạy mẫu chứng hằng ngày trên máy này chưa, và có đạt không?",
  "qa.future.manualQc.summary": "Nhật ký ĐẠT/KHÔNG ĐẠT hằng ngày cho từng máy. Các máy khác nhau có kiểm tra hằng ngày khác nhau; hệ thống đưa tất cả về một dạng: nhật ký ĐẠT/KHÔNG ĐẠT hằng ngày có người ký, có dấu thời gian, và chặn sử dụng máy nếu KHÔNG ĐẠT.",
  "qa.future.manualQc.why": "Điều đầu tiên thanh tra hỏi khi vào phòng xét nghiệm là \"cho tôi xem nhật ký QC hằng ngày của máy này\". Một nhật ký có ký cho mỗi máy mỗi ngày, ngày nào cũng có. Quên ghi là nguyên nhân làm hỏng kỳ thanh tra.",
  "qa.overview.subtitle": "Ảnh chụp nhanh hằng ngày cho Cán bộ QA",
  "qa.overview.comingSoon": "Sắp có",
  "qa.overview.section.attention": "Cần xử lý",
  "qa.overview.section.thisWeek": "Tuần này",
  "qa.overview.section.pillars": "Tình trạng các trụ cột",
  "qa.overview.section.activity": "Hoạt động gần đây",
  "qa.overview.section.inspector": "Sẵn sàng thanh tra — năm câu hỏi chất lượng ISO 15189",
  "qa.overview.attention.criticalNce": "NCE nguy kịch chờ xác nhận",
  "qa.overview.attention.criticalResults": "Kết quả nguy kịch trong 24 giờ qua",
  "qa.overview.attention.overdueCapas": "CAPA quá hạn",
  "qa.overview.attention.qcViolations": "Vi phạm QC trong 24 giờ qua",
  "qa.overview.attention.effectivenessReview": "Đến hạn đánh giá hiệu lực CAPA",
  "qa.overview.attention.eqaDue": "Hạn nộp EQA trong 14 ngày tới",
  "qa.overview.attention.nceSla": "NCE sắp đến hạn xác nhận (SLA)",
  "qa.overview.tile.criticalCallback": "Gọi báo nguy kịch",
  "qa.overview.week.newNces": "NCE mới",
  "qa.overview.week.ncesResolved": "NCE đã xử lý xong",
  "qa.overview.week.capasCompleted": "CAPA đã hoàn thành",
  "qa.overview.week.qcViolations": "Vi phạm QC",
  "qa.overview.week.criticalResults": "Kết quả nguy kịch",
  "qa.overview.week.eqaSubmissions": "Bài nộp EQA",
  "qa.overview.week.auditEntries": "Mục nhật ký kiểm toán",
  "qa.overview.week.signatureEvents": "Sự kiện chữ ký",
  "qa.overview.inspector.q1": "Các lượt chạy có đang trong kiểm soát không?",
  "qa.overview.inspector.q2": "Kỳ EQA vừa rồi làm thế nào?",
  "qa.overview.inspector.q3": "Các chỉ số QI có đạt mục tiêu không?",
  "qa.overview.inspector.q4": "Còn NCE nguy kịch nào chưa đóng?",
  "qa.overview.inspector.q5": "Tình trạng công nhận thế nào?",
  "qa.overview.inspector.q1.answer": "{inControl} trên {total} máy trong kiểm soát (30 ngày)",
  "qa.overview.inspector.q3.answer": "TAT trung bình {tat} so với 30 ngày trước",
  "qa.overview.inspector.q4.answer": "{count} NCE nguy kịch chờ xác nhận",
  "qa.overview.inspector.q5.answer": "{active} trên {total} đang có hiệu lực, {expiring} sắp hết hạn, {expired} đã hết hạn",
  "qa.overview.inspector.q5.noData": "Chưa cấu hình tổ chức công nhận nào",
  "qa.overview.week.severityBreakdown": "{critical} nguy kịch · {major} nghiêm trọng · {minor} nhẹ",
  "qa.overview.week.overdueCount": "{count} quá hạn",
  "qa.overview.week.currentlyOpen": "đang mở",
  "qa.overview.pillar.qc.text": "{inControl} trên {total} máy trong kiểm soát",
  "qa.overview.pillar.qc.noData": "Chưa có dữ liệu QC",
  "qa.overview.pillar.qi.text": "TAT trung bình {tat}",
  "qa.overview.pillar.qi.noData": "Chưa có dữ liệu TAT",
  "qa.overview.pillar.qi.disabled": "Hiện chưa theo dõi",
  "qa.overview.pillar.qms.text": "{critical} nguy kịch chờ xử lý · {capa} đang khắc phục",
  "qa.overview.activity.viewAudit": "Xem toàn bộ nhật ký kiểm toán",
  "qa.overview.activity.empty": "Không có hoạt động trong 24 giờ qua",
  "qa.empty.activity.subhead": "Các thao tác đã xác nhận ở mọi trụ cột sẽ hiện ở đây khi xảy ra.",
  "qa.empty.attention.title": "Hiện không có mục nào cần xử lý",
  "qa.empty.attention.subhead": "NCE nguy kịch, CAPA quá hạn và vi phạm QC sẽ hiện ở đây khi phát sinh.",
  "qa.empty.amendment.title": "Không có lần sửa kết quả nào trong khoảng này",
  "qa.empty.amendment.subhead": "Lần sửa sẽ hiện ở đây khi một kết quả đã phát hành được sửa lại.",
  "qa.empty.rejection.title": "Không có từ chối nào trong khoảng này",
  "qa.empty.rejection.subhead": "Từ chối sẽ hiện ở đây khi xét nghiệm bị từ chối lúc nhập hoặc duyệt kết quả.",
  "qa.empty.capaRegister.title": "Không có CAPA nào khớp bộ lọc",
  "qa.empty.capaRegister.subhead": "Hành động khắc phục và phòng ngừa sẽ hiện ở đây khi được ghi nhận cho các sự kiện không phù hợp.",
  "qa.empty.accreditation.bodies.title": "Chưa có tổ chức công nhận nào",
  "qa.empty.accreditation.bodies.subhead": "Thêm các tổ chức công nhận phòng xét nghiệm để bắt đầu theo dõi công nhận từng xét nghiệm.",
  "qa.empty.accreditation.enrollments.title": "Không có đăng ký nào khớp bộ lọc",
  "qa.empty.accreditation.enrollments.subhead": "Đăng ký xét nghiệm dưới một tổ chức công nhận để hiện logo của tổ chức trên phiếu kết quả bệnh nhân.",
  "qa.empty.accreditation.eqa.title": "Chưa có gì để đối chiếu",
  "qa.empty.accreditation.eqa.subhead": "Khi xét nghiệm đã đăng ký dưới một tổ chức công nhận, độ phủ EQA của chúng sẽ được đối chiếu ở đây.",
  "qa.empty.esigLog.title": "Không có chữ ký nào trong khoảng này",
  "qa.empty.esigLog.subhead": "Chữ ký sẽ hiện ở đây khi kết quả được lập và duyệt. Thử khoảng ngày rộng hơn hoặc ít bộ lọc hơn.",
  "qa.empty.tat.title": "Không có kết quả nào trong khoảng này",
  "qa.empty.tat.subhead": "Thời gian trả kết quả sẽ hiện ở đây khi chỉ định xét nghiệm được hoàn tất và duyệt. Thử khoảng ngày khác.",
  "qa.empty.sparse.labUnits": "{count, plural, other {# nhóm xét nghiệm}} this period",
  "qa.overview.activity.yesterday": "Hôm qua {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "đã lập kết quả cho",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "đã duyệt & phát hành",
  "qa.overview.activity.meaning.REJECTED": "đã từ chối",
  "qa.overview.activity.qc": "Cảnh báo QC: {rule} ({severity}) trên {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} đã báo cáo {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} đã xác nhận {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} đã phân công {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} đã thêm ghi chú vào {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} đã cập nhật trạng thái {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} đã cập nhật hành động khắc phục của {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} đã xử lý xong {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} đã cập nhật {nce}",
  "sidenav.title.statusreport": "Báo cáo trạng thái bệnh nhân",
  "systemAudit.filter.startDate": "Ngày bắt đầu",
  "systemAudit.filter.endDate": "Ngày kết thúc",
  "systemAudit.filter.entityType": "Loại đối tượng",
  "systemAudit.filter.action": "Thao tác",
  "systemAudit.filter.search": "Tìm",
  "systemAudit.filter.export": "Xuất CSV",
  "systemAudit.table.heading.time": "Thời gian",
  "systemAudit.table.heading.entityType": "Loại đối tượng",
  "systemAudit.table.heading.entityId": "Mã đối tượng",
  "systemAudit.table.heading.action": "Thao tác",
  "systemAudit.table.heading.user": "Người dùng",
  "systemAudit.table.heading.changes": "Thay đổi",
  "systemAudit.noResults": "Không tìm thấy sự kiện hệ thống nào với bộ lọc đã chọn.",
  "systemAudit.filter.all": "Tất cả",
  "systemAudit.filter.user": "Người dùng",
  "systemAudit.filter.searchText": "Tìm",
  "systemAudit.filter.searchText.placeholder": "Tìm theo mã đối tượng...",
  "systemAudit.filter.exportPdf": "Xuất PDF",
  "systemAudit.filter.selectedPatient": "Bệnh nhân đã chọn",
  "systemAudit.filter.selectedPatient.none": "Chưa có",
  "systemAudit.filter.selectPatient": "Chọn bệnh nhân",
  "systemAudit.filter.selectAnotherPatient": "Chọn bệnh nhân khác",
  "systemAudit.action.insert": "Thêm",
  "systemAudit.action.update": "Sửa",
  "systemAudit.action.delete": "Xóa",
  "site.branding.cancel": "Hủy",
  "site.branding.color.format.error": "Định dạng màu không hợp lệ. Dùng màu CSS hợp lệ (VD: #0f62fe)",
  "site.branding.color.hex.label": "Mã màu hex",
  "site.branding.colorPicker.helperText": "Nhập màu CSS bất kỳ (VD: #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe hoặc blue",
  "site.branding.confirm.remove": "Gỡ logo",
  "site.branding.confirm.remove.message": "Bạn có chắc muốn gỡ logo này và quay về logo OpenELIS mặc định?",
  "site.branding.current.logo": "Logo hiện tại",
  "site.branding.description": "Tùy chỉnh nhận diện thương hiệu của tổ chức, gồm logo và màu sắc",
  "site.branding.error.remove": "Lỗi khi gỡ tệp logo.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Biểu tượng hiển thị trên thẻ trình duyệt và dấu trang",
  "site.branding.file.format.error": "Định dạng tệp không được hỗ trợ. Dùng PNG, SVG hoặc JPG/JPEG",
  "site.branding.file.pending": "Đã chọn tệp - bấm Lưu thay đổi để tải lên",
  "site.branding.file.size.error": "Kích thước tệp vượt giới hạn 2MB",
  "site.branding.formats": "Định dạng: PNG, SVG, JPG (tối đa 2MB)",
  "site.branding.header.color": "Màu thanh tiêu đề",
  "site.branding.header.color.description": "Màu nền của thanh tiêu đề ứng dụng",
  "site.branding.header.logo": "Logo tiêu đề",
  "site.branding.header.logo.description": "Logo hiển thị ở góc trên bên trái tiêu đề ứng dụng",
  "site.branding.login.logo": "Logo trang đăng nhập",
  "site.branding.login.logo.description": "Logo hiển thị trên trang đăng nhập",
  "site.branding.login.using.header.logo": "Đang dùng logo tiêu đề cho trang đăng nhập",
  "site.branding.logo.upload.success": "Đã tải logo lên",
  "site.branding.no.logo": "Chưa có logo tùy chỉnh (đang dùng mặc định)",
  "site.branding.preview": "Xem trước",
  "site.branding.primary.color": "Màu chính",
  "site.branding.primary.color.description": "Màu cho nút chính, mục menu đang chọn và liên kết",
  "site.branding.remove.favicon": "Gỡ favicon",
  "site.branding.remove.header.logo": "Gỡ logo tiêu đề",
  "site.branding.remove.login.logo": "Gỡ logo đăng nhập",
  "site.branding.remove.logo": "Gỡ logo",
  "site.branding.reset.confirmation": "Bạn có chắc muốn đặt lại toàn bộ nhận diện về mặc định OpenELIS? Thao tác này sẽ gỡ mọi logo và màu tùy chỉnh.",
  "site.branding.reset.error": "Lỗi khi đặt lại nhận diện về mặc định.",
  "site.branding.reset.success": "Đã đặt lại nhận diện về giá trị mặc định.",
  "site.branding.reset.to.defaults": "Đặt lại nhận diện mặc định",
  "site.branding.save": "Lưu thay đổi",
  "site.branding.save.error": "Lỗi khi lưu cấu hình nhận diện",
  "site.branding.save.success": "Đã lưu cấu hình nhận diện",
  "site.branding.secondary.color": "Màu phụ",
  "site.branding.secondary.color.description": "Màu cho nút phụ, viền và trạng thái không hoạt động",
  "site.branding.section.colors": "Màu sắc",
  "site.branding.section.logos": "Logo",
  "site.branding.title": "Nhận diện trang",
  "site.branding.unsaved.changes": "Bạn có thay đổi chưa lưu. Bạn muốn lưu, bỏ, hay hủy?",
  "site.branding.unsaved.changes.warning": "Bạn có thay đổi chưa lưu. Bấm Lưu để áp dụng.",
  "site.branding.upload.favicon": "Tải favicon lên",
  "site.branding.upload.header.logo": "Tải logo tiêu đề lên",
  "site.branding.upload.login.logo": "Tải logo đăng nhập lên",
  "site.branding.upload.logo": "Tải logo lên",
  "site.branding.use.header.logo.for.login": "Dùng cùng logo với tiêu đề",
  "siteInfo.description.default.barcode": "Nhập số nhãn mã vạch mặc định sẽ in cho mỗi chỉ định và mỗi bệnh phẩm.",
  "siteInfo.description.dimensions": "Nhập kích thước nhãn mã vạch khi in.",
  "siteInfo.description.elements": "Đánh dấu các thành phần tùy chọn sẽ hiện trên nhãn mã vạch của chỉ định và bệnh phẩm.",
  "siteInfo.description.max.barcode": "Nhập số nhãn mã vạch tối đa có thể in cho mỗi chỉ định hoặc bệnh phẩm. Khi đạt tối đa, người dùng không in thêm được nhãn.",
  "siteInfo.elements.mandatory": "Thành phần bắt buộc",
  "siteInfo.elements.optional": "Thành phần tùy chọn",
  "siteInfo.section.altAccession": "Số accession mã vạch in sẵn",
  "siteInfo.section.elements": "Thành phần nhãn mã vạch",
  "siteInfo.section.number": "Số lượng nhãn mã vạch",
  "siteInfo.section.size": "Kích thước nhãn mã vạch",
  "siteInfo.title.default.barcode": "Nhãn mã vạch mặc định",
  "siteInfo.title.default.barcode.block": "Khối",
  "siteInfo.title.default.barcode.height": "Chiều cao",
  "siteInfo.title.default.barcode.order": "Chỉ định",
  "siteInfo.title.default.barcode.order.none": "Không",
  "siteInfo.title.default.barcode.slide": "Lam kính",
  "siteInfo.title.default.barcode.specimen": "Bệnh phẩm",
  "siteInfo.title.default.barcode.freezer": "Tủ đông",
  "siteInfo.title.default.barcode.width": "Chiều rộng",
  "siteInfo.title.max.barcode": "Số nhãn mã vạch tối đa",
  "started.date": "Ngày bắt đầu",
  "status": "Trạng thái",
  "status.in.progress": "Đang xử lý",
  "status.unknown": "Không rõ",
  "stillThere.message": "Phiên đăng nhập sắp hết hạn. Bấm vào bất kỳ đâu để giữ đăng nhập.",
  "stillThere.title": "Vẫn còn đó?",
  "stock.available": "Có sẵn",
  "stock.level": "Mức tồn kho",
  "stock.status": "Trạng thái tồn kho",
  "stock.status.expired": "Hết hạn",
  "stock.status.expiring": "Sắp hết hạn",
  "stock.status.expiringIn": "Sắp hết hạn ({days} ngày)",
  "stock.status.inStock": "Còn hàng",
  "stock.status.lowStock": "Sắp hết hàng",
  "stock.status.outOfStock": "Hết hàng",
  "storage.active": "Đang dùng",
  "storage.add.device": "Thêm thiết bị",
  "storage.add.location": "Vị trí",
  "storage.add.location.option": "Thêm vị trí...",
  "storage.add.new.device": "Thêm thiết bị mới",
  "storage.add.rack": "Thêm giá",
  "storage.add.box": "Thêm hộp",
  "storage.add.room": "Thêm phòng",
  "storage.add.shelf": "Thêm kệ",
  "storage.allAssigned.title": "Đã gán hết bệnh phẩm",
  "storage.assign.button": "Gán vị trí",
  "storage.assign.title": "Gán vị trí lưu trữ",
  "storage.assigned": "Đã gán",
  "storage.assigned.by": "Người gán",
  "storage.assigned.date": "Ngày gán",
  "storage.barcode.scan.placeholder": "Quét mã vạch hoặc nhập tay",
  "storage.bulk.move.auto.assigned": "Vị trí tự động gán (có thể sửa)",
  "storage.bulk.move.preview": "Xem trước chuyển hàng loạt",
  "storage.cannotDelete.hasAssignments": "Không xóa được {entityType} '{name}': đang có {count} bệnh phẩm được gán",
  "storage.cannotDelete.hasChildren": "Không xóa được {entityType} '{name}': đang chứa {count} {childType}",
  "storage.capacity.calculated": "Tự tính",
  "storage.capacity.manual": "Giới hạn nhập tay",
  "storage.capacity.undetermined.tooltip": "Không tính được sức chứa: một số vị trí con chưa có sức chứa xác định",
  "storage.capacity.warning": "{location} đã đầy {percentage}%. Cân nhắc dùng nơi lưu trữ khác.",
  "storage.code.change.acknowledge": "Tôi hiểu và muốn tiếp tục đổi mã",
  "storage.code.change.warning": "Cảnh báo",
  "storage.code.change.warning.message": "Đổi mã sẽ làm mất hiệu lực các nhãn đã in trước đó cho vị trí này.",
  "storage.confirm.add.device": "Bạn có muốn tạo thiết bị mới '{name}'?",
  "storage.conditionNotes": "Ghi chú điều kiện",
  "storage.conditionNotes.placeholder": "Nhập ghi chú về điều kiện bảo quản...",
  "storage.confirm.delete": "Xác nhận xóa",
  "storage.create.room.error": "Không tạo được phòng: {error}",
  "storage.create.room.success": "Đã tạo phòng \"{name}\"",
  "storage.current.location": "Vị trí hiện tại",
  "storage.currentLocation": "Vị trí hiện tại",
  "storage.delete.admin.only": "Chỉ Quản trị viên toàn cục mới xóa được vị trí",
  "storage.delete.are.you.sure": "Bạn có chắc muốn xóa",
  "storage.delete.cannot.be.undone": "Thao tác này không thể hoàn tác.",
  "storage.delete.cascade.confirm": "Xác nhận xóa kéo theo",
  "storage.delete.cascade.confirmation.checkbox": "Tôi xác nhận muốn xóa vị trí này và toàn bộ vị trí con. Mọi bệnh phẩm sẽ bị bỏ gán. Thao tác này không thể hoàn tác.",
  "storage.delete.cascade.summary": "Sẽ xóa {childCount} {childType} và bỏ gán {sampleCount} bệnh phẩm. Bạn có chắc muốn tiếp tục?",
  "storage.delete.cascade.warning": "Cảnh báo xóa kéo theo",
  "storage.delete.checking": "Đang kiểm tra ràng buộc...",
  "storage.delete.confirmation.checkbox": "Tôi xác nhận muốn xóa vị trí này. Thao tác này không thể hoàn tác.",
  "storage.delete.constraints.title": "Không thể xóa",
  "storage.delete.device": "Xóa thiết bị",
  "storage.delete.error": "Không xóa được vị trí",
  "storage.delete.location": "Xóa vị trí",
  "storage.delete.rack": "Xóa giá",
  "storage.delete.room": "Xóa phòng",
  "storage.delete.shelf": "Xóa kệ",
  "storage.device.code": "Mã",
  "storage.device.communicationProtocol": "Giao thức truyền thông",
  "storage.device.communicationProtocol.helper": "Giao thức dùng để giao tiếp với thiết bị (ví dụ: BACnet)",
  "storage.device.ipAddress": "Địa chỉ IP",
  "storage.device.ipAddress.helper": "Địa chỉ IPv4 hoặc IPv6 của thiết bị nối mạng",
  "storage.device.label": "Thiết bị",
  "storage.device.name": "Tên",
  "storage.device.placeholder": "Chọn hoặc gõ để tạo thiết bị...",
  "storage.device.port": "Cổng",
  "storage.device.port.helper": "Số cổng (1-65535) dùng để giao tiếp",
  "storage.device.room": "Phòng",
  "storage.device.type": "Loại",
  "storage.edit.device": "Sửa thiết bị",
  "storage.edit.error.loadLocation": "Không tải được vị trí",
  "storage.edit.error.saveFailed": "Lưu thất bại",
  "storage.edit.error.saveHttp": "Lưu thất bại (HTTP {status})",
  "storage.edit.rack": "Sửa giá",
  "storage.edit.room": "Sửa phòng",
  "storage.edit.shelf": "Sửa kệ",
  "storage.edit.selectParent": "Chọn {parent}",
  "storage.editbox.error.loadBox": "Không tải được hộp",
  "storage.editbox.selectRack": "Chọn giá",
  "storage.box.capacity": "Sức chứa",
  "storage.box.gridSize": "Kích thước lưới",
  "storage.box.rows": "Số hàng",
  "storage.box.columns": "Số cột",
  "storage.box.preset": "Kích thước có sẵn",
  "storage.box.preset.select": "Chọn kích thước",
  "storage.error.location.inactive": "Không thể gán vào vị trí không hoạt động",
  "storage.error.name.duplicate": "Đã có {entityType} trùng tên trong vị trí cha đã chọn",
  "storage.error.position.occupied": "Ô này đã có vật",
  "storage.expanded.capacityLimit": "Giới hạn sức chứa",
  "storage.expanded.createdBy": "Người tạo",
  "storage.expanded.createdDate": "Ngày tạo",
  "storage.expanded.description": "Mô tả",
  "storage.expanded.lastModifiedBy": "Người sửa cuối",
  "storage.expanded.lastModifiedDate": "Ngày sửa cuối",
  "storage.expanded.notAvailable": "Không có",
  "storage.expanded.positionSchemaHint": "Gợi ý sơ đồ vị trí",
  "storage.expanded.temperatureSetting": "Cài đặt nhiệt độ",
  "storage.filter.by.locations": "Lọc theo vị trí",
  "storage.filter.by.locations.placeholder": "Lọc theo vị trí...",
  "storage.filter.device": "Lọc theo thiết bị",
  "storage.filter.room": "Lọc theo phòng",
  "storage.filter.status": "Lọc theo trạng thái",
  "storage.hierarchical.path": "Đường dẫn vị trí",
  "storage.inline.add.device": "Thêm thiết bị mới",
  "storage.inline.add.rack": "Thêm giá mới",
  "storage.inline.add.room": "Thêm phòng mới",
  "storage.inline.add.shelf": "Thêm kệ mới",
  "storage.location": "Vị trí",
  "storage.location.active": "Hoạt động",
  "storage.location.add.button": "Thêm vị trí",
  "storage.location.add.title": "Thêm vị trí lưu trữ",
  "storage.location.current": "Vị trí lưu trữ",
  "storage.location.code": "Mã",
  "storage.location.code.helper": "Tối đa 10 ký tự, chữ và số, cho phép gạch ngang/gạch dưới",
  "storage.location.description": "Mô tả",
  "storage.location.label": "Vị trí lưu trữ",
  "storage.location.name": "Tên vị trí",
  "storage.location.skipped": "Bỏ qua lưu trữ",
  "storage.location.tempMax": "Nhiệt độ tối đa",
  "storage.location.tempMin": "Nhiệt độ tối thiểu",
  "storage.location.type": "Loại vị trí",
  "storage.location.unassigned": "Chưa gán",
  "storage.location.notAssigned": "Chưa gán",
  "storage.location.move": "Chuyển vị trí lưu trữ",
  "storage.location.assign": "Gán vị trí lưu trữ",
  "storage.manageLocation.error.saveFailed": "Lưu thất bại",
  "storage.manageLocation.error.selectTarget": "Chọn thiết bị, kệ, giá hoặc hộp trước khi lưu",
  "storage.nav.box": "Hộp",
  "storage.nav.device": "Thiết bị",
  "storage.nav.room": "Phòng",
  "storage.nav.shelf": "Kệ",
  "storage.picker.currentLocation": "Vị trí hiện tại",
  "storage.picker.heading.assignLocation": "Gán vị trí lưu trữ",
  "storage.picker.heading.move": "Chuyển vật",
  "storage.picker.newLocation": "Vị trí mới",
  "storage.picker.notes": "Ghi chú",
  "storage.picker.orBrowse": "Hoặc chọn từng cấp",
  "storage.picker.position.optional": "Vị trí ô (không bắt buộc)",
  "storage.picker.select": "Chọn {level}",
  "storage.picker.selectDeviceType": "Chọn loại thiết bị",
  "storage.picker.addNewLevel": "Thêm {level} mới",
  "storage.picker.inlineCreate.heading": "Tạo {level} mới",
  "storage.picker.inlineCreate.error.title": "Không tạo được vị trí",
  "storage.picker.inlineCreate.error": "Tạo vị trí thất bại",
  "storage.picker.occupant.identifier": "Định danh",
  "storage.picker.occupant.heading": "Vật",
  "storage.picker.occupant.status": "Trạng thái",
  "storage.picker.occupant.type": "Loại",
  "storage.picker.storageLocation": "Vị trí lưu trữ",
  "storage.metrics.active": "Đang hoạt động",
  "storage.metrics.disposed": "Đã hủy",
  "storage.metrics.total.samples": "Tổng số mẫu lưu",
  "storage.mode.autocomplete": "Tìm gợi ý khi gõ",
  "storage.mode.barcode": "Quét mã vạch",
  "storage.mode.cascading": "Danh sách thả xuống theo cấp",
  "storage.move.button": "Chuyển mẫu",
  "storage.move.reason.label": "Lý do chuyển",
  "storage.nav.boxes": "Hộp",
  "storage.nav.boxes.tooltip": "Quản lý hộp lưu trữ",
  "storage.nav.dashboard": "Bảng điều khiển lưu trữ",
  "storage.nav.devices": "Thiết bị",
  "storage.nav.devices.tooltip": "Quản lý thiết bị lưu trữ",
  "storage.nav.locations": "Vị trí",
  "storage.nav.locations.tooltip": "Quản lý vị trí lưu trữ",
  "storage.nav.racks": "Giá",
  "storage.nav.racks.tooltip": "Quản lý giá lưu trữ",
  "storage.nav.rooms": "Phòng",
  "storage.nav.rooms.tooltip": "Quản lý phòng lưu trữ",
  "storage.nav.sample.items": "Mẫu lưu",
  "storage.nav.sample.items.tooltip": "Xem và quản lý mẫu đã lưu",
  "storage.nav.samples": "Mẫu lưu",
  "storage.nav.samples.tooltip": "Xem và quản lý mẫu đã lưu",
  "storage.nav.shelves": "Kệ",
  "storage.nav.shelves.tooltip": "Quản lý kệ lưu trữ",
  "storage.no.data": "Chưa có dữ liệu",
  "storage.occupancy": "Mức sử dụng",
  "storage.position.label": "Vị trí",
  "storage.rack.device": "Thiết bị",
  "storage.rack.dimensions": "Kích thước",
  "storage.rack.label": "Giá",
  "storage.rack.placeholder": "Chọn hoặc gõ để tạo giá...",
  "storage.rack.room": "Phòng",
  "storage.rack.shelf": "Kệ",
  "storage.room.code": "Mã",
  "storage.room.devices": "Thiết bị",
  "storage.room.label": "Phòng",
  "storage.room.name": "Tên",
  "storage.room.placeholder": "Chọn hoặc gõ để tạo phòng...",
  "storage.room.samples": "Mẫu",
  "storage.sampleitem.id": "ID mẫu lưu",
  "storage.search.boxes.placeholder": "Tìm hộp theo nhãn hoặc mã...",
  "storage.search.devices.placeholder": "Tìm theo tên hoặc mã thiết bị...",
  "storage.search.location.minLength": "Tiếp tục gõ, tối thiểu 2 ký tự",
  "storage.search.location.searching": "Đang tìm...",
  "storage.search.location.error": "Không tìm được vị trí. Vui lòng thử lại.",
  "storage.search.location.noResults": "Không có vị trí lưu trữ nào khớp với “{query}”",
  "storage.search.placeholder": "Tìm theo ID mẫu hoặc vị trí...",
  "storage.search.racks.placeholder": "Tìm theo nhãn giá...",
  "storage.search.rooms.placeholder": "Tìm theo tên hoặc mã phòng...",
  "storage.search.lots.placeholder": "Tìm theo số lô, mã vạch, vật tư hoặc vị trí...",
  "storage.search.samples.placeholder": "Tìm theo ID mẫu hoặc vị trí...",
  "storage.search.shelves.placeholder": "Tìm theo nhãn kệ...",
  "storage.select.location": "Chọn vị trí",
  "storage.selectSample": "Chọn mẫu",
  "storage.shelf.device": "Thiết bị",
  "storage.shelf.label": "Kệ",
  "storage.shelf.placeholder": "Chọn hoặc gõ để tạo kệ...",
  "storage.shelf.room": "Phòng",
  "storage.status": "Trạng thái",
  "storage.status.disposed": "Đã hủy",
  "storage.success.assigned": "Đã gán mẫu vào vị trí lưu trữ thành công",
  "storage.success.moved": "Đã chuyển mẫu sang vị trí mới thành công",
  "storage.tab.ariaLabel": "Các tab quản lý lưu trữ",
  "storage.tab.dashboard": "Bảng điều khiển",
  "storage.tab.inventoryLots": "Lô tồn kho",
  "storage.tab.samples": "Mẫu lưu",
  "storage.target.location": "Vị trí đích",
  "storage.unassigned.title": "Mẫu chưa gán vị trí",
  "storage.skipAssignment": "Không cần lưu trữ - mẫu sẽ được xử lý ngay",
  "success.add.edited.msg": "Đã thêm/sửa thành công",
  "success.delete.msg": "Đã xóa thành công",
  "success.import.patient": "Đã nhập bệnh nhân thành công",
  "success.report.status": "Đã tạo báo cáo thành công",
  "success.save.msg": "Đã lưu thành công",
  "success.save.patient": "Đã lưu bệnh nhân thành công",
  "systemuser.firstName": "Tên (đệm + tên)",
  "systemuser.isActive": "Đang hoạt động",
  "systemuser.lastName": "Họ",
  "systemuser.loginName": "Tên đăng nhập",
  "systemuser.role": "Vai trò",
  "systemuserrole.apply": "Áp dụng",
  "systemuserrole.allLabUnits.confirm.body": "Chuyển dòng này sang Tất cả nhóm xét nghiệm sẽ xóa các quyền nhóm xét nghiệm riêng lẻ. Dòng Tất cả nhóm xét nghiệm bắt đầu với không có quyền nào được chọn.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "không có quyền nào được chọn",
  "systemuserrole.allLabUnits.confirm.primary": "Thay thế quyền",
  "systemuserrole.allLabUnits.confirm.title": "Thay thế quyền nhóm xét nghiệm?",
  "systemuserrole.allLabUnits.exclusive.error": "Không thể kết hợp Tất cả nhóm xét nghiệm với từng nhóm riêng lẻ. Chưa lưu gì cả.",
  "systemuserrole.allLabUnits.exclusive.info": "Tất cả nhóm xét nghiệm không thể kết hợp với từng nhóm riêng lẻ: chọn mục này sẽ thay thế mọi quyền theo nhóm.",
  "systemuserrole.copypermissions": "Sao chép quyền từ người dùng",
  "systemuserrole.copypermissions.placeholder": "Sao chép quyền của người dùng",
  "systemuserrole.instruction.1": "Có hai loại vai trò. Vai trò toàn cục áp dụng cho toàn bộ ứng dụng; vai trò nhóm xét nghiệm có thể đặt cho tất cả nhóm xét nghiệm hoặc từng nhóm cụ thể.",
  "systemuserrole.instruction.2": "Các vai trò toàn cục hiện có: Quản trị viên toàn cục (truy cập mọi chức năng quản trị), Nhật ký kiểm toán (truy cập toàn bộ nhật ký kiểm toán), Quản trị tài khoản người dùng (quản lý tài khoản người dùng, nhưng không có chức năng quản trị khác).",
  "systemuserrole.instruction.3": "Các vai trò nhóm xét nghiệm: Tiếp nhận (truy cập tab Chỉ định, Bệnh nhân và Không phù hợp), Kết quả (truy cập tab Phiếu công việc, Không phù hợp và Kết quả), Duyệt (truy cập tab Duyệt và Không phù hợp), Báo cáo (truy cập tab Báo cáo; riêng xuất CSV chỉ dành cho Quản trị viên toàn cục).",
  "systemuserrole.instruction.4": "Để gán vai trò nhóm xét nghiệm, chọn tất cả nhóm xét nghiệm hoặc một nhóm cụ thể trong danh sách thả xuống, rồi chọn các vai trò cần đặt.",
  "systemuserrole.instruction.5": "Bạn cũng có thể dùng tính năng Sao chép quyền để chép quyền của một người dùng sẵn có. Hãy điền đầy đủ thông tin ở trên, nhập tên người dùng có quyền cần chép vào ô rồi bấm Áp dụng.",
  "systemuserrole.newpermissions": "Thêm quyền mới",
  "systemuserrole.rmpermissions": "Xóa quyền",
  "systemuserrole.roles.global": "Vai trò toàn cục",
  "systemuserrole.roles.labunit": "Vai trò nhóm xét nghiệm",
  "test.add.copy.name": "Sao chép từ tên xét nghiệm",
  "test.antimicrobialResistance": "Kháng kháng sinh",
  "test.description.active": "Nếu xét nghiệm đang hoạt động thì có thể chỉ định trên phiếu chỉ định hoặc là một phần của thuật toán xét nghiệm. Nếu không hoạt động thì không thể chỉ định cũng như không thể là một phần của thuật toán xét nghiệm.",
  "test.description.name": "Tên xét nghiệm sẽ hiển thị trong openELIS. Bắt buộc nhập cả tiếng Anh và tiếng Pháp.",
  "test.description.orderable": "Nếu xét nghiệm đang hoạt động và được phép chỉ định thì có thể chỉ định trên phiếu chỉ định. Nếu đang hoạt động nhưng không cho chỉ định thì chỉ được thực hiện khi được tự động kích hoạt từ xét nghiệm khác.",
  "test.description.panel": "Nếu xét nghiệm này thuộc một bộ xét nghiệm thì có thể thêm bộ đó tại đây. Một xét nghiệm có thể thuộc nhiều hơn một bộ, tuy không phổ biến.",
  "test.description.reportName": "Tên xét nghiệm sẽ hiển thị trên báo cáo. Bắt buộc nhập cả tiếng Anh và tiếng Pháp. Nếu tên và tên trên báo cáo giống nhau, bấm nút để sao chép tên.",
  "test.description.testSection": "Nhóm xét nghiệm nơi xét nghiệm sẽ được thực hiện",
  "test.description.uom": "Đơn vị đo của xét nghiệm. Thường chỉ áp dụng cho kiểu kết quả số hoặc chữ-số.",
  "test.field.active": "Hoạt động",
  "test.field.orderable": "Được chỉ định",
  "test.inLabOnly": "Chỉ tại phòng XN",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Vui lòng chọn xét nghiệm để sửa!",
  "test.modify.header.test": "Xét nghiệm",
  "test.name": "Tên xét nghiệm",
  "test.notifyResults": "Thông báo kết quả cho bệnh nhân",
  "test.section": "Nhóm xét nghiệm",
  "test.section.label": "Nhóm xét nghiệm",
  "test.show.guide": "Hiện hướng dẫn",
  "testcalculation.label.calculation": "Công thức tính",
  "testcalculation.label.finalresult": "Kết quả cuối",
  "testcalculation.label.insertOperation": "Phép toán chèn",
  "testcalculation.label.integer": "Số nguyên",
  "testcalculation.label.mathFucntion": "Hàm toán học",
  "testcalculation.label.name": "Tên công thức",
  "testcalculation.label.patientAttribute": "Thuộc tính bệnh nhân",
  "testcalculation.label.searchNumericTest": "Tìm xét nghiệm số",
  "testcalculation.label.selectDictionaryValue": "Chọn giá trị từ danh mục",
  "testcalculation.label.testResult": "Kết quả xét nghiệm",
  "testcalculation.label.textValue": "Giá trị chữ",
  "testCatalog.header.ageRange": "Khoảng tuổi",
  "testCatalog.header.criticalRange": "Khoảng nguy kịch",
  "testCatalog.header.field": "Trường",
  "testCatalog.header.gender": "Phái",
  "testCatalog.header.normalRange": "CSBT",
  "testCatalog.header.reportingRange": "Khoảng báo cáo",
  "testCatalog.header.validRange": "Khoảng hợp lệ",
  "testCatalog.header.value": "Giá trị",
  "admin.testCatalog.methods.title": "Phương pháp",
  "admin.testCatalog.methods.column.name": "Tên phương pháp",
  "admin.testCatalog.methods.column.code": "Mã",
  "admin.testCatalog.methods.column.default": "Mặc định",
  "admin.testCatalog.methods.column.effectiveDate": "Ngày có hiệu lực",
  "admin.testCatalog.methods.column.actions": "Thao tác",
  "admin.testCatalog.methods.action.edit": "Sửa",
  "admin.testCatalog.methods.action.remove": "Gỡ",
  "admin.testCatalog.methods.btn.linkMethod": "+ Liên kết phương pháp",
  "admin.testCatalog.methods.btn.createMethod": "+ Tạo phương pháp mới",
  "admin.testCatalog.methods.btn.copyFromTest": "Sao chép từ xét nghiệm",
  "admin.testCatalog.methods.modal.link.title": "Liên kết phương pháp",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Chọn phương pháp để liên kết",
  "admin.testCatalog.methods.modal.link.noAvailable": "Tất cả phương pháp đang hoạt động đã được liên kết",
  "admin.testCatalog.methods.inline.nameEnglish": "Tên phương pháp (tiếng Anh)",
  "admin.testCatalog.methods.inline.nameFrench": "Tên phương pháp (tiếng Pháp)",
  "admin.testCatalog.methods.inline.code": "Mã viết tắt",
  "admin.testCatalog.methods.inline.codeHint": "3–10 ký tự chữ in hoa và số, không có khoảng trắng",
  "admin.testCatalog.methods.inline.createAndLink": "Tạo & liên kết",
  "admin.testCatalog.methods.copyFromTest.label": "Sao chép phương pháp từ xét nghiệm",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Chọn xét nghiệm nguồn",
  "admin.testCatalog.methods.effectiveDate.label": "Ngày có hiệu lực",
  "admin.testCatalog.methods.default.label": "Đặt làm mặc định",
  "admin.testCatalog.methods.error.duplicateLink": "Phương pháp này đã được liên kết với xét nghiệm",
  "admin.testCatalog.methods.error.codeFormat": "Mã phải gồm 3–10 ký tự chữ in hoa và số, không có khoảng trắng",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Bắt buộc nhập ngày có hiệu lực",
  "admin.testCatalog.methods.error.duplicateCode": "Đã có phương pháp với mã này. Hãy nhập mã khác.",
  "admin.testCatalog.methods.error.duplicateName": "Đã có phương pháp với tên này. Hãy dùng tên khác, hoặc liên kết phương pháp đang có.",
  "admin.testCatalog.methods.error.invalidRequest": "Yêu cầu bị từ chối. Kiểm tra các trường và thử lại.",
  "admin.testCatalog.methods.error.server": "Máy chủ không thể hoàn thành yêu cầu. Thử lại.",
  "admin.testCatalog.methods.error.removeFailed": "Không gỡ được phương pháp. Phương pháp vẫn còn liên kết; thử lại.",
  "admin.testCatalog.methods.linked": "Đã liên kết phương pháp.",
  "admin.testCatalog.methods.created": "Đã tạo và liên kết phương pháp.",
  "admin.testCatalog.methods.copied": "Từ {source}: đã sao chép {count, plural, one {# phương pháp} other {# phương pháp}}.",
  "admin.testCatalog.methods.copyNothing": "Không sao chép phương pháp nào: {source} không có phương pháp nào chưa được liên kết với xét nghiệm này.",
  "admin.testCatalog.methods.empty": "Chưa có phương pháp nào được liên kết. Dùng “+ Liên kết phương pháp” hoặc “+ Tạo phương pháp mới” để thêm.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Tên xét nghiệm mà thông báo này dành cho",
  "testnotification.instructionis.variables.body.0": "[testResult] : Kết quả xét nghiệm",
  "testnotification.instructionis.variables.header": "Danh sách biến:",
  "testnotification.instructions.body": "Khi tạo thông báo, hệ thống trước hết kiểm tra xem có mẫu tin nhắn nào được định nghĩa cho người nhận/loại tin nhắn không.",
  "testnotification.instructions.body.0": "Nếu không có, hệ thống dùng tin nhắn mặc định của xét nghiệm.",
  "testnotification.instructions.body.1": "Nếu cũng không có, hệ thống dùng tin nhắn mặc định của hệ thống.",
  "testnotification.instructions.body.2": "Các biến sẽ được thay bằng giá trị tương ứng trong nội dung tin nhắn và tiêu đề.",
  "testnotification.instructions.body.3": "Biến luôn phải có dấu ngoặc vuông và không có khoảng trắng.",
  "testnotification.instructions.header": "Hướng dẫn:",
  "testnotification.messagetemplate": "Tin nhắn",
  "testnotification.options": "Tin nhắn riêng lẻ",
  "testnotification.patient.email": "Email bệnh nhân",
  "testnotification.patient.sms": "SMS bệnh nhân",
  "testnotification.patiententry.header": "Gửi kết quả",
  "testnotification.patiententry.info": "Nếu OpenELIS không kết nối được với người nhận kết quả, hệ thống sẽ xếp kết quả vào hàng đợi. Hàng đợi lớn và tăng dần là dấu hiệu cần kiểm tra sự cố, kể cả liên hệ bên nhận.",
  "testnotification.provider.email": "Email bác sĩ",
  "testnotification.provider.sms": "SMS bác sĩ",
  "testnotification.subjecttemplate": "Tiêu đề",
  "testnotification.systemdefault.template": "Tin nhắn mặc định của hệ thống",
  "testnotification.testdefault.editIcon": "Sửa thông báo xét nghiệm",
  "testnotification.testdefault.template": "Tin nhắn mặc định của xét nghiệm",
  "testnotificationconfig.browse.title": "Cấu hình thông báo xét nghiệm",
  "tests.not.assigned": "Xét nghiệm chưa gán",
  "testsection.testSectionName": "Tên nhóm xét nghiệm",
  "testUnit.existing": "Nhóm xét nghiệm hiện có",
  "testUnit.existing.inactive": "Nhóm xét nghiệm không hoạt động. Gán xét nghiệm để kích hoạt.",
  "testUnit.new": "Nhóm xét nghiệm mới",
  "text.length.max": "Độ dài văn bản không được vượt quá 200",
  "title.notestfoundmatching": "Không tìm thấy xét nghiệm khớp với",
  "to.title": "Đến",
  "tooltip.banner.menu.generic.sample.results": "Nhập kết quả xét nghiệm cho mẫu chung",
  "tooltip.banner.menu.workplan.batch": "Phiếu công việc theo lô",
  "total.quantity": "Tổng số lượng",
  "transaction.date": "Ngày",
  "transaction.quantity": "Số lượng",
  "transaction.type": "Loại",
  "transaction.user": "Người dùng",
  "true.label": "Đúng",
  "unifiedSystemUser.add.user": "Thêm người dùng",
  "unifiedSystemUser.browser.button.add": "Thêm người dùng mới",
  "unifiedSystemUser.browser.search": "Tìm theo tên người dùng",
  "unifiedSystemUser.browser.search.placeholder": "Tìm theo tên người dùng...",
  "unifiedSystemUser.browser.title": "Quản lý người dùng",
  "unifiedSystemUser.edit.user": "Sửa người dùng",
  "unifiedSystemUser.select": "Chọn",
  "unknown.section": "Nhóm không xác định",
  "unknown.test": "Xét nghiệm không xác định",
  "uom.browse.title": "Đơn vị đo",
  "uom.create.heading.confirmation": "Xác nhận",
  "uom.existing": "Đơn vị đo hiện có",
  "uom.existing.inactive": "Đơn vị đo không hoạt động. Gán xét nghiệm vào đơn vị này để kích hoạt.",
  "uom.new": "Tạo đơn vị đo mới",
  "uom.new.added": "Đơn vị đo mới sẽ được thêm",
  "uom.notification.duplicate": "Đơn vị đo đã tồn tại",
  "uom.notification.save": "Đã lưu đơn vị đo mới.",
  "uom.uomName": "Tên đơn vị đo",
  "training.installation.message": "Cài đặt đào tạo",
  "translation.edit.title": "Sửa bản dịch",
  "translation.export": "Xuất CSV",
  "translation.export.success": "Đã xuất bản dịch thành công",
  "translation.fallback": "Dự phòng (tiếng Anh)",
  "translation.management.description": "Xem và sửa bản dịch cho dữ liệu nền.",
  "translation.management.title": "Quản lý bản dịch",
  "translation.missing": "Thiếu",
  "translation.search": "Tìm bản dịch...",
  "translation.selectLocale": "Chọn ngôn ngữ",
  "translation.showMissing": "Chỉ hiện mục thiếu",
  "translation.stats.title": "Tiến độ dịch",
  "translation.stats.total": "Tổng số mục: {count}",
  "translation.update.error": "Không cập nhật được bản dịch",
  "translation.update.success": "Đã cập nhật bản dịch thành công",
  "translation.value": "Bản dịch",
  "translation.origin": "Origin",
  "translation.origin.shipped": "Đã gửi đi",
  "translation.origin.siteOverride": "Site override",
  "translation.origin.siteValue": "Site value",
  "translation.shippedLabel": "Shipped translation: {label}",
  "translation.reset": "Reset to shipped translation",
  "translation.reset.confirm": "Replace the lab's label with the shipped translation \"{label}\"?",
  "translation.reset.confirmButton": "Đặt lại",
  "translation.reset.success": "The label is back to the shipped translation.",
  "translation.reset.error": "The label could not be reset.",
  "localization.error.overrideBlank": "A label for a value OpenELIS ships cannot be blank. To drop the lab's label, use Reset to shipped translation.",
  "localization.error.notShipped": "Only a value OpenELIS ships has a shipped translation to return to.",
  "usage.analysisId": "Mã phân tích",
  "usage.date": "Ngày sử dụng",
  "usage.error.quantityPositive": "Số lượng phải lớn hơn 0",
  "usage.fefo.note": "Số lượng sẽ được trừ từ lô đạt QC có hạn sớm nhất của vật tư này (FEFO), có thể không phải lô bạn đã mở để ghi nhận.",
  "usage.item": "Vật tư",
  "usage.notes": "Ghi chú",
  "usage.notes.placeholder": "Thêm ghi chú về lần sử dụng này",
  "usage.quantityUsed": "Số lượng đã dùng",
  "usage.quantityUsed.helper": "Nhập số đơn vị đã tiêu hao",
  "usage.record.button": "Ghi nhận sử dụng",
  "usage.record.error": "Lỗi khi ghi nhận sử dụng",
  "usage.record.success": "Đã ghi nhận sử dụng thành công",
  "usage.record.title": "Ghi nhận sử dụng tồn kho",
  "usage.testResultId": "Mã kết quả xét nghiệm (không bắt buộc)",
  "usage.testResultId.placeholder": "Liên kết với kết quả xét nghiệm để truy vết",
  "user.select.instruction": "Chọn người dùng để sửa hoặc vô hiệu hóa. Bạn có thể đặt bộ lọc, tìm người dùng, hoặc thêm người dùng bằng các nút ở phía trên.",
  "validation.accept.all": "Lưu tất cả kết quả",
  "validation.accept.normal": "Lưu tất cả kết quả bình thường",
  "validation.field.required": "Trường này là bắt buộc",
  "validation.ignore.all": "Bỏ qua tất cả kết quả",
  "validation.label.nonconform": "= Mẫu hoặc chỉ định không phù hợp, hoặc xét nghiệm đã bị từ chối",
  "validation.legend.qcHold": "= Một lần kiểm soát chất lượng bao phủ kết quả này đã không đạt; sự không phù hợp vẫn đang mở",
  "validation.qcHold.tooltip": "Lần chạy kiểm soát cho xét nghiệm này tại nhóm xét nghiệm này đã không đạt. Xem lại sự không phù hợp trước khi duyệt kết quả này.",
  "validation.password.match": "Mật khẩu phải khớp nhau",
  "validation.password.minLength": "Mật khẩu phải có ít nhất 7 ký tự",
  "validation.password.notSameAsOld": "Mật khẩu mới không được trùng mật khẩu cũ",
  "validation.password.specialChar": "Mật khẩu phải có ít nhất một ký tự đặc biệt (*, $, #, !) và chỉ gồm chữ, số hoặc các ký tự đó",
  "validation.no.records.display": "Không có bản ghi để hiển thị",
  "validation.reject.all": "Chỉ định lại tất cả xét nghiệm",
  "validation.save.error": "Không lưu được kết quả từ máy xét nghiệm",
  "validation.save.success": "Đã duyệt kết quả thành công",
  "validation.search.noresult": "Không có kết quả nào để duyệt",
  "validation.search.noresult.analyser": "Không có kết quả từ: ",
  "vl.arvRegimen": "Phác đồ ARV",
  "vl.durationOnARV": "Thời gian dùng ARV (tháng)",
  "vl.durationOnARV.placeholder": "Nhập số tháng đang điều trị",
  "vl.indication": "Chỉ định xét nghiệm VL",
  "vl.lastVLDate": "Ngày có kết quả VL gần nhất",
  "vl.lastVLResult": "Kết quả VL gần nhất (bản sao/mL)",
  "vl.lastVLResult.placeholder": "ví dụ: 150",
  "vl.pregnancyStatus": "Tình trạng mang thai / cho con bú",
  "workplan.batch.action.activate": "Kích hoạt",
  "workplan.batch.action.archive": "Lưu trữ",
  "workplan.batch.action.complete": "Hoàn tất",
  "workplan.batch.batches": "Các lô",
  "workplan.batch.batches.empty": "Không tìm thấy lô nào",
  "workplan.batch.column.actions": "Thao tác",
  "workplan.batch.column.count": "Xét nghiệm",
  "workplan.batch.column.created": "Ngày tạo",
  "workplan.batch.column.method": "Phương pháp",
  "workplan.batch.column.name": "Lô",
  "workplan.batch.column.sampleType": "Loại mẫu",
  "workplan.batch.column.status": "Trạng thái",
  "workplan.batch.column.test": "Xét nghiệm",
  "workplan.batch.column.unit": "Nhóm",
  "workplan.batch.create": "Tạo lô ({count})",
  "workplan.batch.create.error": "Không tạo được lô",
  "workplan.batch.create.success": "Đã tạo lô",
  "workplan.batch.pending.empty": "Không có xét nghiệm nào đang chờ",
  "workplan.batch.pendingTests": "Xét nghiệm đang chờ",
  "workplan.batch.refresh": "Làm mới",
  "workplan.batch.selectPage": "Chọn trang",
  "workplan.batch.selectTest": "Chọn {accessionNumber}",
  "workplan.batch.status.ACTIVE": "Đang hoạt động",
  "workplan.batch.status.ARCHIVED": "Đã lưu trữ",
  "workplan.batch.status.COMPLETED": "Đã hoàn tất",
  "workplan.batch.status.DRAFT": "Nháp",
  "workplan.batch.status.error": "Không cập nhật được trạng thái lô",
  "workplan.batch.status.success": "Đã cập nhật trạng thái lô",
  "workplan.batch.tabs": "Các tab phiếu công việc theo lô",
  "workplan.batch.title": "Phiếu công việc theo lô",
  "workplan.page.title": "Phiếu công việc {0}",
  "workplan.panel.selection.error.msg": "Đây là thông báo lỗi không hợp lệ.",
  "workplan.panel.title": "Phiếu công việc theo bộ xét nghiệm",
  "workplan.panel.types": "Loại bộ xét nghiệm",
  "workplan.print": "In phiếu công việc",
  "workplan.priority.list": "Ưu tiên",
  "workplan.priority.title": "Phiếu công việc theo ưu tiên",
  "workplan.run": "Lấy phiếu công việc",
  "workplan.test.title": "Phiếu công việc theo xét nghiệm",
  "workplan.test.types": "Loại xét nghiệm",
  "workplan.title": "Phiếu công việc",
  "workplan.unit.title": "Phiếu công việc theo nhóm",
  "workplan.unit.types": "Loại nhóm",
  "yes.option": "Có",
  "shipment.module.title": "Quản lý vận chuyển mẫu",
  "shipment.breadcrumb": "Vận chuyển mẫu",
  "shipment.nav.dashboard": "Bàn làm việc",
  "shipment.nav.createBox": "Tạo hộp",
  "shipment.nav.receiveBox": "Nhận hộp",
  "shipment.dashboard.title": "Bàn làm việc vận chuyển",
  "shipment.dashboard.description": "Quản lý hộp vận chuyển và theo dõi mẫu đã gửi đi",
  "shipment.dashboard.tabs.shipments": "Lô vận chuyển",
  "shipment.dashboard.tabs.unassigned": "Xét nghiệm chưa gán",
  "shipment.tab.boxes": "Hộp vận chuyển",
  "shipment.tab.unassignedSamples": "Mẫu chưa gán",
  "shipment.label.boxId": "Mã hộp",
  "shipment.label.createdDate": "Ngày tạo",
  "shipment.label.daysUnassigned": "Số ngày chưa gán",
  "shipment.label.destination": "Nơi nhận",
  "shipment.label.priority": "Ưu tiên",
  "shipment.label.referralTest": "Xét nghiệm gửi đi",
  "shipment.label.sampleCount": "Số mẫu",
  "shipment.label.state": "Trạng thái",
  "shipment.label.tests": "Xét nghiệm",
  "shipment.filter.state": "Lọc theo trạng thái",
  "shipment.filter.facility": "Lọc theo cơ sở",
  "shipment.action.addSelected": "Thêm mục đã chọn",
  "shipment.action.addToBox": "Thêm vào hộp",
  "shipment.action.cancelReferral": "Hủy gửi đi",
  "shipment.action.confirmRejection": "Xác nhận từ chối",
  "shipment.action.createBox": "Tạo hộp mới",
  "shipment.action.markAsLost": "Đánh dấu thất lạc",
  "shipment.action.printManifest": "In phiếu danh sách",
  "shipment.action.rejectSample": "Từ chối mẫu",
  "shipment.action.saveAndMarkReady": "Lưu & đánh dấu sẵn sàng gửi",
  "shipment.action.saveBox": "Lưu hộp",
  "shipment.action.saveDraft": "Lưu nháp",
  "shipment.action.scanSample": "Quét mẫu",
  "shipment.box.addSample": "Thêm mẫu",
  "shipment.box.addSampleDescription": "Chọn mẫu để thêm vào hộp vận chuyển này",
  "shipment.box.addSamples": "Thêm mẫu",
  "shipment.box.details": "Chi tiết hộp",
  "shipment.box.autoGenerate": "Tự động tạo",
  "shipment.box.capacity": "Sức chứa",
  "shipment.box.capacityValue": "{capacity} mẫu",
  "shipment.box.create": "Tạo hộp",
  "shipment.box.createDescription": "Tạo hộp vận chuyển mới cho mẫu gửi đi",
  "shipment.box.created": "Ngày tạo: ",
  "shipment.box.createdBy": "Người tạo :",
  "shipment.box.createdDate": "Ngày tạo",
  "shipment.box.destination": "Nơi nhận",
  "shipment.box.downloadLabel": "Tải nhãn",
  "shipment.box.downloadManifest": "Tải phiếu danh sách",
  "shipment.box.generateLabel": "Tạo nhãn",
  "shipment.box.generateManifest": "Tạo phiếu danh sách",
  "shipment.box.id": "Mã hộp: ",
  "shipment.box.labelDownloaded": "Đã tải nhãn thành công",
  "shipment.box.labelPrefix": "Tiền tố nhãn",
  "shipment.box.labelPrefixHelper": "Do quản trị viên cấu hình trong Cài đặt site",
  "shipment.box.manifest": "Phiếu danh sách",
  "shipment.box.manifestDownloaded": "Đã tải phiếu danh sách thành công",
  "shipment.box.noSamples": "Hộp này chưa có mẫu nào",
  "shipment.box.noUnassignedSamples": "Không tìm thấy mẫu chưa gán cho cơ sở này",
  "shipment.box.notes": "Ghi chú",
  "shipment.box.notesPlaceholder": "Nhập hướng dẫn xử lý đặc biệt hoặc ghi chú...",
  "shipment.box.number": "Số hộp",
  "shipment.box.readyConfirmation": "Bạn có chắc muốn đánh dấu hộp này là sẵn sàng gửi?",
  "shipment.box.readySampleCount": "Hộp này chứa {count} mẫu",
  "shipment.box.readyToSend": "Đánh dấu sẵn sàng gửi",
  "shipment.box.reconcile": "Đối soát",
  "shipment.box.removeSample": "Gỡ mẫu",
  "shipment.box.removeSampleConfirmation": "Bạn có chắc muốn gỡ mẫu này khỏi hộp?",
  "shipment.box.resendManifest": "Gửi lại phiếu danh sách",
  "shipment.box.sampleCount": "Số mẫu",
  "shipment.box.sampleProgress": "{added} / {capacity} (còn {remaining})",
  "shipment.box.samplesAdded": "Mẫu đã thêm",
  "shipment.box.samplesSelected": "Đã chọn {count} mẫu",
  "shipment.box.scanExisting": "Quét hộp có sẵn",
  "shipment.box.scanExistingId": "Quét hoặc nhập mã hộp có sẵn",
  "shipment.box.scanExistingIdPlaceholder": "Quét mã vạch hoặc gõ mã hộp",
  "shipment.box.sendBox": "Gửi hộp",
  "shipment.box.sendConfirmation": "Bạn có chắc muốn gửi hộp này?",
  "shipment.box.sendSampleCount": "Hộp này chứa {count} mẫu sẽ được đánh dấu là đã gửi",
  "shipment.box.state": "Trạng thái",
  "shipment.box.summary": "Tóm tắt",
  "shipment.box.temperature": "Yêu cầu nhiệt độ",
  "shipment.box.title": "Hộp {boxId}",
  "shipment.box.useExistingId": "Chế độ mã hộp",
  "shipment.dashboard.boxNotFound": "Không tìm thấy hộp với mã “{boxId}”. Hãy thử lọc danh sách.",
  "shipment.dashboard.scanBoxPlaceholder": "Tìm hoặc quét mã hộp (nhấn Enter để chuyển đến)",
  "shipment.error.addSample": "Không thêm được mẫu vào hộp",
  "shipment.error.assignToBox": "Không gán được mẫu vào hộp",
  "shipment.error.boxFull": "Hộp đã đầy. Không thể thêm mẫu.",
  "shipment.error.boxNotEmpty": "Hộp phải có ít nhất một mẫu",
  "shipment.error.boxNotFound": "Không tìm thấy hộp",
  "shipment.error.cancelReferral": "Không hủy được gửi đi",
  "shipment.error.confirmReception": "Không xác nhận được việc nhận",
  "shipment.error.createBox": "Không tạo được hộp vận chuyển",
  "shipment.error.exceedsCapacity": "Không thể thêm {requested} mẫu. Chỉ còn {available} chỗ trống.",
  "shipment.error.fetchBox": "Không lấy được thông tin hộp",
  "shipment.error.fetchBoxes": "Không lấy được danh sách hộp khả dụng",
  "shipment.error.generateLabel": "Lỗi khi tạo nhãn vận chuyển",
  "shipment.error.generateManifest": "Lỗi khi tạo phiếu danh sách",
  "shipment.error.invalidState": "Trạng thái hộp không hợp lệ cho thao tác này",
  "shipment.error.markAsLost": "Không đánh dấu được mẫu thất lạc",
  "shipment.error.markReady": "Không đánh dấu được hộp sẵn sàng gửi",
  "shipment.error.noDestinationFacility": "Mẫu này chưa có cơ sở nhận",
  "shipment.error.noReferralId": "Mẫu này không có mã gửi đi",
  "shipment.error.noSampleSelected": "Vui lòng chọn ít nhất một mẫu",
  "shipment.error.partialReception": "Một số cập nhật trạng thái mẫu thất bại. Vui lòng thử lại.",
  "shipment.error.partialSampleAdd": "Chỉ thêm được {added} / {total} mẫu vào hộp. Hộp được giữ ở trạng thái nháp để bạn thêm phần còn lại.",
  "shipment.error.reasonRequired": "Vui lòng nhập lý do",
  "shipment.error.reconcile": "Lỗi khi đối soát hộp",
  "shipment.error.removeSample": "Không gỡ được mẫu khỏi hộp",
  "shipment.error.sampleAlreadyAssigned": "Mẫu này đã được gán vào một hộp",
  "shipment.error.sampleAlreadyInBox": "Mẫu đã có trong hộp",
  "shipment.error.sampleNotFound": "Không tìm thấy mẫu",
  "shipment.error.saveFailed": "Lưu thất bại",
  "shipment.error.searchFailed": "Tìm mẫu thất bại. Vui lòng thử lại.",
  "shipment.error.selectBox": "Vui lòng chọn một hộp",
  "shipment.error.sendBox": "Không gửi được hộp",
  "shipment.filter.clear": "Xóa bộ lọc",
  "shipment.filter.dateFrom": "Từ ngày",
  "shipment.filter.dateTo": "Đến ngày",
  "shipment.filter.referenceLab": "Phòng XN tham chiếu",
  "shipment.label.addedDate": "Ngày thêm",
  "shipment.label.position": "Vị trí",
  "shipment.label.samples": "Mẫu",
  "shipment.label.shippingLabel": "NHÃN VẬN CHUYỂN",
  "shipment.manifest.generated": "Ngày tạo:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Không còn thu hồi phiếu danh sách (đã quá 7 ngày kể từ khi gửi)",
  "shipment.manifest.regenerationExpired": "Không còn tạo lại phiếu danh sách (đã quá 24 giờ kể từ khi gửi)",
  "shipment.manifest.serviceLocation": "Nơi cung cấp dịch vụ:",
  "shipment.manifest.specimenBarcodes": "Mã vạch mẫu",
  "shipment.manifest.title": "Phiếu danh sách vận chuyển",
  "shipment.manifest.totalSamples": "Tổng số mẫu:",
  "shipment.modal.addToBox.existingBox": "Thêm vào hộp có sẵn",
  "shipment.modal.addToBox.mode": "Chọn một tùy chọn",
  "shipment.modal.addToBox.newBox": "Tạo hộp mới",
  "shipment.modal.addToBox.newBoxInfo.message": "Bạn sẽ được chuyển sang trang tạo hộp mới cho mẫu này",
  "shipment.modal.addToBox.newBoxInfo.title": "Tạo hộp mới",
  "shipment.modal.addToBox.noDraftBoxes.message": "Không có hộp nháp nào cho nơi nhận này. Một hộp mới sẽ được tạo.",
  "shipment.modal.addToBox.noDraftBoxes.title": "Không có hộp nháp",
  "shipment.modal.addToBox.selectBox": "Chọn hộp",
  "shipment.modal.addToBox.title": "Thêm mẫu vào hộp",
  "shipment.modal.cancelReferral.reason": "Lý do hủy",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Vui lòng giải thích vì sao hủy gửi đi này...",
  "shipment.modal.cancelReferral.title": "Hủy gửi đi",
  "shipment.modal.cancelReferral.warning.message": "Thao tác này sẽ hủy vĩnh viễn gửi đi và không thể hoàn tác.",
  "shipment.modal.cancelReferral.warning.title": "Cảnh báo",
  "shipment.modal.createBox.cancel": "Hủy",
  "shipment.modal.createBox.submit": "Tạo",
  "shipment.modal.createBox.title": "Tạo hộp mới",
  "shipment.modal.markAsLost.reason": "Lý do đánh dấu thất lạc",
  "shipment.modal.markAsLost.reasonPlaceholder": "Vui lòng giải thích vì sao mẫu này bị đánh dấu thất lạc...",
  "shipment.modal.markAsLost.title": "Đánh dấu mẫu thất lạc",
  "shipment.modal.markAsLost.warning.message": "Thao tác này sẽ đánh dấu vĩnh viễn mẫu là thất lạc và không thể hoàn tác.",
  "shipment.modal.markAsLost.warning.title": "Cảnh báo",
  "shipment.modal.rejectSample": "Từ chối mẫu",
  "shipment.modal.rejectSampleMessage": "Bạn có chắc muốn từ chối mẫu {accession}?",
  "shipment.nav.referenceLabResults": "Kết quả phòng XN tham chiếu",
  "shipment.nav.reports": "Báo cáo",
  "shipment.nav.settings": "Cài đặt",
  "shipment.notification.boxCreated": "Đã tạo hộp thành công",
  "shipment.notification.boxReadyToSend": "Hộp đã được đánh dấu sẵn sàng gửi",
  "shipment.notification.boxReconciled": "Đã đối soát hộp thành công",
  "shipment.notification.boxSent": "Đã gửi hộp thành công",
  "shipment.notification.error": "Đã xảy ra lỗi: {message}",
  "shipment.notification.partialSamplesAdded": "Chỉ thêm được {added} / {total} mẫu. Hộp đã đạt sức chứa ({notAdded} mẫu chưa thêm được).",
  "shipment.notification.receptionComplete": "Đã nhận lô vận chuyển thành công",
  "shipment.notification.referralCancelled": "Đã hủy gửi đi thành công",
  "shipment.notification.sampleAdded": "Đã thêm mẫu {accessionNumber} với {testCount, plural, one {# xét nghiệm} other {# xét nghiệm}}",
  "shipment.notification.sampleAssignedToBox": "Đã gán mẫu vào hộp thành công",
  "shipment.notification.sampleMarkedAsLost": "Đã đánh dấu mẫu thất lạc",
  "shipment.notification.sampleRejected": "Đã từ chối mẫu {accession}: {reason}",
  "shipment.notification.sampleRemoved": "Đã gỡ mẫu khỏi hộp",
  "shipment.notification.samplesAdded": "{count, plural, other {Đã thêm # mẫu vào thùng}}",
  "shipment.notification.samplesRemovedDueToCapacity": "Đã gỡ {removed} mẫu do giảm sức chứa.",
  "shipment.reception.acceptSample": "Chấp nhận mẫu",
  "shipment.reception.applyToAll": "Áp dụng trạng thái cho tất cả...",
  "shipment.reception.awaitingAcceptance": "Chờ chấp nhận",
  "shipment.reception.confirmMessage": "Xác nhận đã nhận {count} mẫu?",
  "shipment.reception.confirmReception": "Xác nhận đã nhận",
  "shipment.reception.damaged": "Hư hỏng",
  "shipment.reception.description": "Quét mã vạch hộp để nhận và kiểm tra mẫu",
  "shipment.reception.enterBoxId": "Vui lòng nhập mã hộp",
  "shipment.reception.generalNotes": "Ghi chú chung",
  "shipment.reception.generalNotesPlaceholder": "Nhập ghi chú chung khi nhận",
  "shipment.reception.importError": "Lỗi khi nhập lô vận chuyển từ máy chủ từ xa",
  "shipment.reception.importFromFhir": "Nhập từ FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {Không tìm thấy lô vận chuyển mới} one {Đã nhập 1 lô vận chuyển} other {Đã nhập {count} lô vận chuyển}}",
  "shipment.reception.incomingBoxes": "Lô vận chuyển đến",
  "shipment.reception.leaked": "Rò rỉ",
  "shipment.reception.markAllMissing": "Đánh dấu thiếu tất cả",
  "shipment.reception.markAllReceived": "Đánh dấu đã nhận tất cả",
  "shipment.reception.missing": "Thiếu",
  "shipment.reception.noIncomingBoxes": "Chưa có lô vận chuyển đến. Bấm “Nhập từ FHIR” để kiểm tra lô mới.",
  "shipment.reception.notes": "Ghi chú",
  "shipment.reception.notesPlaceholder": "Nhập ghi chú nếu cần",
  "shipment.reception.notesRequired": "Bắt buộc ghi chú cho mẫu không nhận được trong tình trạng tốt",
  "shipment.reception.notesRequiredPlaceholder": "Bắt buộc: mô tả vấn đề",
  "shipment.reception.openBox": "Mở",
  "shipment.reception.originFacility": "Từ",
  "shipment.reception.pending": "Đang chờ",
  "shipment.reception.pendingAcceptance": "Mẫu chờ chấp nhận",
  "shipment.reception.received": "Đã nhận",
  "shipment.reception.referralOrder": "Chỉ định gửi đi",
  "shipment.reception.rejected": "Đã từ chối",
  "shipment.reception.sampleCountSummary": "{accepted} đã chấp nhận / {expected} dự kiến",
  "shipment.reception.sampleNotFound": "Không tìm thấy mẫu {accessionNumber} trong hộp này",
  "shipment.reception.sampleScanned": "Mẫu {accessionNumber} đã được ghi nhận là đã nhận",
  "shipment.reception.sampleVerification": "Kiểm tra mẫu",
  "shipment.reception.scanBox": "Mã hộp / Mã vạch",
  "shipment.reception.scanBoxPlaceholder": "Quét hoặc nhập mã vạch hộp",
  "shipment.reception.scanButton": "Quét hộp",
  "shipment.reception.scanSample": "Quét mã mẫu",
  "shipment.reception.scanSampleButton": "Ghi nhận mẫu",
  "shipment.reception.scanSamplePlaceholder": "Quét hoặc gõ mã số mẫu",
  "shipment.reception.shipped": "Đã gửi",
  "shipment.reception.specimen": "Mẫu bệnh phẩm",
  "shipment.reception.status": "Trạng thái nhận",
  "shipment.reception.title": "Nhận lô vận chuyển",
  "shipment.reception.unresolved": "Không khớp chỉ định nào",
  "shipment.rejection.damaged": "Hư hỏng",
  "shipment.rejection.expired": "Hết hạn",
  "shipment.rejection.insufficientVolume": "Không đủ thể tích",
  "shipment.rejection.other": "Khác",
  "shipment.rejection.reason": "Lý do từ chối",
  "shipment.rejection.wrongType": "Sai loại mẫu",
  "shipment.report.contents": "Nội dung",
  "shipment.report.description": "Tạo và xuất báo cáo vận chuyển theo hộp, ngày, nơi nhận hoặc phòng XN tham chiếu",
  "shipment.report.export.excel": "Xuất Excel",
  "shipment.report.export.pdf": "Xuất PDF",
  "shipment.report.generate": "Tạo báo cáo",
  "shipment.report.noResults": "Không có bản ghi vận chuyển nào với bộ lọc đã chọn",
  "shipment.report.receivedDate": "Ngày nhận",
  "shipment.report.receivedStatus": "Trạng thái nhận",
  "shipment.report.receiver": "Bên nhận",
  "shipment.report.receivingUser": "Người nhận",
  "shipment.report.sender": "Bên gửi",
  "shipment.report.sentDate": "Ngày gửi",
  "shipment.report.title": "Báo cáo vận chuyển",
  "shipment.report.totalBoxes": "Tổng số hộp",
  "shipment.report.totalSamples": "Tổng số mẫu",
  "shipment.sample.accessionNumber": "Mã mẫu (SID)",
  "shipment.sample.multipleMatches": "Có nhiều mẫu khớp — chọn mẫu để thêm",
  "shipment.sample.remove": "Gỡ",
  "shipment.sample.search": "Tìm mẫu theo mã mẫu",
  "shipment.sample.searchPlaceholder": "Quét hoặc nhập mã mẫu",
  "shipment.sample.status": "Trạng thái",
  "shipment.sample.type": "Loại mẫu",
  "shipment.settings.administration": "Quản trị",
  "shipment.settings.boxLabelSection": "Cấu hình nhãn hộp",
  "shipment.settings.description": "Cấu hình các thiết lập của module vận chuyển",
  "shipment.settings.fhirConfig": "Tùy chọn ánh xạ FHIR",
  "shipment.settings.fhirConfigDesc": "Cấu hình ánh xạ SupplyDelivery và loại hộp đựng bệnh phẩm để tương tác FHIR",
  "shipment.settings.fhirConfigNote": "Ánh xạ FHIR được cấu hình qua tham số ứng dụng. Liên hệ quản trị hệ thống để thay đổi.",
  "shipment.settings.fhirConfigSaveError": "Lỗi khi lưu cấu hình ánh xạ FHIR",
  "shipment.settings.fhirConfigSaved": "Đã lưu cấu hình ánh xạ FHIR",
  "shipment.settings.fhirContainerType": "Loại hộp đựng bệnh phẩm (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Tên hiển thị",
  "shipment.settings.fhirNonConformity": "Mã không phù hợp (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "Mã SNOMED CT",
  "shipment.settings.manageFacilities": "Quản lý danh mục cơ sở",
  "shipment.settings.manageFacilitiesDesc": "Thêm, sửa hoặc xóa các nơi nhận phòng XN tham chiếu",
  "shipment.settings.manageUsers": "Quản lý người dùng",
  "shipment.settings.manageUsersDesc": "Cấu hình tài khoản người dùng và vai trò cho module vận chuyển",
  "shipment.settings.prefixHelperText": "Tiền tố dùng khi tạo mã hộp mới (ví dụ: BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Xem trước: {preview}",
  "shipment.settings.prefixRequired": "Tiền tố nhãn hộp là bắt buộc",
  "shipment.settings.prefixSaveError": "Lỗi khi lưu tiền tố nhãn hộp",
  "shipment.settings.prefixSaved": "Đã lưu tiền tố nhãn hộp thành công",
  "shipment.settings.siteOrgDescription": "Chọn tổ chức đại diện cho phòng xét nghiệm này. Chỉ các lô vận chuyển gửi đến tổ chức này mới được nhập từ máy chủ FHIR từ xa.",
  "shipment.settings.siteOrgLabel": "Phòng xét nghiệm này",
  "shipment.settings.siteOrgSaveError": "Lỗi khi lưu tổ chức của cơ sở",
  "workflow.clinical": "Lâm sàng",
  "workflow.environmental": "Môi trường / Khác",
  "provider.name": "Tên bác sĩ",
  "provider.name.placeholder": "Nhập tên bác sĩ",
  "provider.phone": "Điện thoại bác sĩ",
  "provider.search.helper": "Nhập tên hoặc số điện thoại bác sĩ rồi bấm Tìm.",
  "site.search": "Tìm đơn vị gửi",
  "site.name": "Tên đơn vị",
  "site.name.placeholder": "Nhập tên đơn vị",
  "site.location": "Địa chỉ",
  "site.type": "Loại",
  "site.department": "Khoa / Phòng / Đơn vị",
  "site.department.selectFirst": "Chọn cơ sở trước...",
  "site.department.choose": "Chọn khoa/phòng...",
  "site.department.none": "Không có đơn vị con",
  "sample.filterByLabUnit": "Lọc theo nhóm xét nghiệm",
  "sample.allLabUnits": "Tất cả nhóm xét nghiệm",
  "sample.orderPanels": "Chỉ định bộ xét nghiệm",
  "sample.orderTests": "Chỉ định xét nghiệm",
  "sample.referToReferenceLab": "Gửi xét nghiệm sang phòng XN tham chiếu",
  "sample.optional.info": "Xét nghiệm có thể chờ: Lưu và thoát sẽ giữ chỉ định mà không có các xét nghiệm này. Lưu và tiếp cần ít nhất một xét nghiệm trên mỗi mẫu.",
  "panel.search.placeholder": "Chọn bộ xét nghiệm còn trống",
  "test.search.placeholder": "Chọn xét nghiệm còn trống",
  "test.timeHolding": "Thời gian lưu tối đa theo SOP (phút)",
  "select.regimen": "Chọn phác đồ...",
  "select": "Chọn...",
  "generating": "Đang tạo...",
  "label.order": "Nhãn chỉ định",
  "label.sample": "Nhãn mẫu",
  "label.slide": "Nhãn lam kính",
  "label.block": "Nhãn khối mô",
  "label.freezer": "Nhãn tủ đông",
  "environmental.coming.soon": "Quy trình môi trường",
  "environmental.location.info": "Các trường phân cấp địa điểm (Vùng/Huyện/Xã-Ấp) và ghi nhận GPS sẽ có ở đây.",
  "env.collectionConditions.title": "Điều kiện lấy mẫu mặc định",
  "env.collectionConditions.subtitle": "Giá trị mặc định áp dụng cho tất cả mẫu trong lô này.",
  "env.collectionMethod": "Phương pháp lấy mẫu",
  "env.waterTemp": "Nhiệt độ nước (°C)",
  "env.ambientTemp": "Nhiệt độ môi trường (°C)",
  "env.weather": "Thời tiết",
  "env.preservationMethod": "Phương pháp bảo quản",
  "env.preservationMethod.placeholder": "ví dụ: axit hóa HNO3, bình làm lạnh 4°C",
  "env.fieldNotes": "Ghi chú hiện trường",
  "env.fieldNotes.placeholder": "Nhập quan sát hiện trường...",
  "env.sample.manifest.title": "Danh sách từng mẫu",
  "env.sample.manifest.subtitle": "mỗi dòng = một mẫu vật lý",
  "env.sample.container": "Dụng cụ chứa",
  "env.sample.gpsLat": "Vĩ độ GPS",
  "env.sample.gpsLat.placeholder": "ví dụ: -6.2088",
  "env.sample.gpsLng": "Kinh độ GPS",
  "env.sample.gpsLng.placeholder": "ví dụ: 106.8456",
  "env.sample.samplingSite": "Điểm lấy mẫu",
  "env.sample.useOrderSite": "Dùng điểm của chỉ định {site}",
  "order.microPreview.site": "Điểm lấy mẫu: {site}",
  "env.sample.locationDetails": "Chi tiết vị trí",
  "env.sample.locationDetails.placeholder": "ví dụ: Cửa vào, Bờ kè...",
  "env.sample.collected": "Đã lấy",
  "env.sample.duplicate": "Mẫu trùng lặp",
  "env.sample.addRow": "+ Thêm dòng mẫu",
  "env.sample.total": "Tổng: {count} {count, plural, one {mẫu} other {mẫu}} trong lô này",
  "env.sample.testsAndPanels": "Xét nghiệm & bộ xét nghiệm",
  "env.sample.tests.required": "bắt buộc",
  "env.complianceStandards.title": "Tiêu chuẩn tuân thủ áp dụng",
  "env.complianceStandards.subtitle": "Chọn các tiêu chuẩn quy định áp dụng cho chỉ định này.",
  "env.complianceStandards.label": "Tiêu chuẩn tuân thủ",
  "env.complianceStandards.placeholder": "Chọn tiêu chuẩn...",
  "env.complianceStandards.empty": "Chưa cấu hình tiêu chuẩn tuân thủ nào đang hoạt động. Thêm tại Quản trị → Tiêu chuẩn tuân thủ.",
  "order.dashboard.samplingSite": "Điểm lấy mẫu",
  "order.search.placeholder.env": "Tìm theo tên điểm lấy mẫu hoặc số mẫu...",
  "order.filter.dateFrom": "Từ",
  "order.filter.dateTo": "Đến",
  "program.placeholder": "Gõ để lọc hoặc chọn từ danh sách",
  "program.helper": "Gõ để lọc hoặc chọn từ danh sách. Khi chọn chương trình, các trường Thông tin chỉ định bổ sung tương ứng sẽ hiện bên dưới.",
  "patient.externalSearch": "Tìm bên ngoài",
  "patient.results": "Kết quả bệnh nhân",
  "patient.id.helper": "Nhập số đối tượng, số CCCD, hoặc mã ST.",
  "patient.id.placeholder": "Nhập mã bệnh nhân",
  "patient.lastName.placeholder": "Nhập họ bệnh nhân",
  "patient.firstName.placeholder": "Nhập tên (đệm + tên) bệnh nhân",
  "patient.natId": "Mã y tế duy nhất",
  "patient.dataSource": "Nguồn dữ liệu",
  "patient.noResults": "0-0 trên 0 mục",
  "patient.new.info": "Nhập thông tin bệnh nhân mới bên dưới. Bệnh nhân sẽ được tạo khi lưu chỉ định.",
  "pagination.showing": "Hiển thị {start}-{end} trên {total} xét nghiệm",
  "results.found.for": "kết quả tìm thấy cho “{term}”",
  "selected": "Đã chọn",
  "shipment.settings.siteOrgSaved": "Đã lưu tổ chức của cơ sở (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Tổ chức cơ sở (FHIR)",
  "shipment.settings.title": "Cài đặt vận chuyển",
  "shipment.state.cancelled": "Đã hủy",
  "shipment.state.draft": "Nháp",
  "shipment.state.inTransit": "Đang vận chuyển",
  "shipment.state.lostInTransit": "Thất lạc khi vận chuyển",
  "shipment.state.partiallyReceived": "Đã nhận một phần",
  "shipment.state.readyToSend": "Sẵn sàng gửi",
  "shipment.state.received": "Đã nhận",
  "shipment.state.reconciled": "Đã đối soát",
  "shipment.state.sent": "Đã gửi",
  "shipment.stats.delivered": "Đã giao",
  "shipment.stats.inTransit": "Đang vận chuyển",
  "shipment.stats.reconciled": "Đã đối soát",
  "shipment.stats.totalSamples": "Tổng số mẫu",
  "shipment.temperature.ambient": "Nhiệt độ thường (nhiệt độ phòng)",
  "shipment.temperature.deepFrozen": "Đông sâu (-80°C)",
  "shipment.temperature.dryIce": "Đá khô",
  "shipment.temperature.frozen": "Đông lạnh (-20°C)",
  "shipment.temperature.refrigerated": "Làm lạnh (2-8°C)",
  "shipment.validation.addSample": "Thêm ít nhất một mẫu",
  "shipment.validation.selectDestination": "Chọn cơ sở nhận",
  "qc.dashboard.title": "Bảng điều khiển kiểm soát chất lượng",
  "qc.dashboard.lastUpdate": "Cập nhật lần cuối",
  "qc.dashboard.complianceStatus": "Trạng thái tuân thủ",
  "qc.dashboard.compliant": "Đạt",
  "qc.dashboard.warning": "Cảnh báo",
  "qc.dashboard.nonCompliant": "Không đạt",
  "qc.dashboard.violationsCount": "{count} vi phạm",
  "qc.dashboard.lastResult": "Kết quả gần nhất",
  "qc.dashboard.noInstruments": "Chưa cấu hình máy nào",
  "qc.dashboard.subtitle": "Theo dõi trạng thái QC và cảnh báo của máy",
  "qc.dashboard.loading": "Đang tải dữ liệu bảng điều khiển...",
  "qc.dashboard.refresh": "Làm mới",
  "qc.dashboard.lastUpdated": "Cập nhật lần cuối",
  "qc.dashboard.export.title": "Xuất dữ liệu QC",
  "qc.dashboard.export.selectInstrument": "Chọn máy",
  "qc.dashboard.export.dateError": "Ngày kết thúc phải bằng hoặc sau ngày bắt đầu.",
  "qc.dashboard.error.title": "Lỗi",
  "qc.dashboard.error.loadFailed": "Không tải được dữ liệu bảng điều khiển. Vui lòng thử lại.",
  "qc.dashboard.tab.instruments": "Máy",
  "qc.dashboard.tab.alerts": "Cảnh báo",
  "qc.dashboard.summary.inControl": "Máy đang kiểm soát tốt",
  "qc.dashboard.summary.warningStatus": "Trạng thái cảnh báo",
  "qc.dashboard.summary.outOfControl": "Mất kiểm soát",
  "qc.dashboard.summary.passRate": "% máy đang kiểm soát tốt",
  "qc.dashboard.summary.ofTotal": "{percentage}% tổng số máy",
  "qc.dashboard.instruments.title": "Trạng thái kiểm soát chất lượng máy",
  "qc.dashboard.instruments.subtitle": "Theo dõi trạng thái tuân thủ và hiệu năng QC của tất cả máy trong phòng xét nghiệm",
  "qc.dashboard.instruments.search": "Tìm máy...",
  "qc.dashboard.instruments.col.id": "Mã máy",
  "qc.dashboard.instruments.col.name": "Tên máy",
  "qc.dashboard.instruments.col.type": "Loại",
  "qc.dashboard.instruments.col.location": "Vị trí",
  "qc.dashboard.instruments.col.status": "Trạng thái",
  "qc.dashboard.instruments.col.analytes": "Chất phân tích",
  "qc.dashboard.instruments.col.violations": "Vi phạm gần đây",
  "qc.dashboard.instruments.col.lastUpdate": "Cập nhật lần cuối",
  "qc.dashboard.instruments.col.actions": "Thao tác",
  "qc.dashboard.instruments.view": "Xem",
  "qc.dashboard.instruments.status.green": "Đang kiểm soát tốt",
  "qc.dashboard.instruments.status.yellow": "Cảnh báo",
  "qc.dashboard.instruments.status.red": "Mất kiểm soát",
  "qc.dashboard.instruments.status.notConfigured": "Chưa cấu hình",
  "qc.dashboard.instruments.status.unknown": "Không rõ",
  "qc.dashboard.instruments.noViolations": "Không có vi phạm",
  "qc.dashboard.instruments.empty": "Không tìm thấy máy nào",
  "qc.dashboard.alerts.title": "Vi phạm & cảnh báo QC",
  "qc.dashboard.alerts.subtitle": "Đang hiển thị vi phạm trong {period} gần nhất",
  "qc.dashboard.alerts.timePeriod": "Khoảng thời gian",
  "qc.dashboard.alerts.timePeriod.24h": "24 giờ gần nhất",
  "qc.dashboard.alerts.timePeriod.72h": "72 giờ gần nhất",
  "qc.dashboard.alerts.timePeriod.7d": "7 ngày gần nhất",
  "qc.dashboard.alerts.timePeriod.30d": "30 ngày gần nhất",
  "qc.dashboard.alerts.timePeriod.all": "Toàn bộ thời gian",
  "qc.dashboard.alerts.active": "Vi phạm QC đang mở",
  "qc.dashboard.alerts.active.count": "{count} vi phạm chưa xác nhận cần xử lý",
  "qc.dashboard.alerts.active.empty": "Không có vi phạm đang mở",
  "qc.dashboard.alerts.acknowledge": "Xác nhận",
  "qc.dashboard.alerts.acknowledged": "Vi phạm đã xác nhận",
  "qc.dashboard.alerts.acknowledged.count": "{count} vi phạm đã được xác nhận",
  "qc.dashboard.alerts.acknowledged.empty": "Chưa có vi phạm nào được xác nhận",
  "qc.dashboard.alerts.col.severity": "Mức độ",
  "qc.dashboard.alerts.col.time": "Thời gian",
  "qc.dashboard.alerts.col.instrument": "Máy",
  "qc.dashboard.alerts.col.analyte": "Chất phân tích",
  "qc.dashboard.alerts.col.rule": "Quy tắc",
  "qc.dashboard.alerts.col.acknowledgedBy": "Người xác nhận",
  "qc.dashboard.alerts.col.acknowledgedDate": "Ngày xác nhận",
  "qc.dashboard.banner.title": "{count} vi phạm QC đang mở cần xử lý",
  "qc.dashboard.banner.viewAll": "Xem tất cả cảnh báo",
  "qc.violations.error.acknowledgeFailed": "Không xác nhận được vi phạm",
  "qc.chart.axis.date": "Ngày/giờ",
  "qc.chart.axis.run": "Lần chạy",
  "qc.chart.axis.value": "Độ lệch chuẩn (σ)",
  "qc.instrument.notFound": "Không tìm thấy máy",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Hiệu năng sigma",
  "qc.chart.sigma.notCalculable": "Không tính được — chưa cấu hình TEa",
  "qc.chart.sigma.bias": "Chưa áp dụng độ chệch (không có dữ liệu so sánh)",
  "qc.chart.sigma.WORLD_CLASS": "Đẳng cấp thế giới",
  "qc.chart.sigma.ACCEPTABLE": "Chấp nhận được",
  "qc.chart.sigma.MARGINAL": "Ranh giới",
  "qc.chart.sigma.POOR": "Kém",
  "qc.chart.title": "Biểu đồ kiểm soát chất lượng",
  "qc.chart.loading": "Đang tải biểu đồ kiểm soát…",
  "qc.chart.error.title": "Không tải được biểu đồ kiểm soát",
  "qc.chart.tabs.label": "Các mức biểu đồ kiểm soát",
  "qc.chart.filter.allLevels": "Tất cả mức",
  "qc.chart.filter.selectLot": "Chọn LOT",
  "qc.chart.action.zoomIn": "Phóng to",
  "qc.chart.action.zoomOut": "Thu nhỏ",
  "qc.chart.action.zoomReset": "Đặt lại phóng to",
  "qc.chart.legend.normal": "Bình thường",
  "qc.chart.legend.violation": "Vi phạm",
  "qc.chart.mean": "Trung bình",
  "qc.chart.noData": "Không có dữ liệu QC",
  "qc.chart.tooltip.date": "Ngày",
  "qc.chart.tooltip.value": "Giá trị",
  "qc.chart.tooltip.violations": "Vi phạm",
  "qc.chart.tooltip.zScore": "Z-score",
  "qc.charts.title": "Biểu đồ kiểm soát",
  "qc.charts.leveyJennings": "Biểu đồ Levey-Jennings",
  "qc.charts.dateRange": "Khoảng ngày",
  "qc.charts.controlLevel": "Mức mẫu chứng",
  "qc.charts.export": "Xuất biểu đồ",
  "qc.charts.noData": "Không có dữ liệu QC",
  "qc.violations.title": "Vi phạm QC",
  "qc.violations.severity": "Mức độ",
  "qc.violations.rule": "Quy tắc",
  "qc.violations.date": "Ngày",
  "qc.violations.status": "Trạng thái",
  "qc.violations.unresolved": "Chưa giải quyết",
  "qc.violations.resolved": "Đã giải quyết",
  "qc.violations.acknowledged": "Đã xác nhận",
  "qc.correctiveActions.title": "Hành động khắc phục",
  "qc.correctiveActions.create": "Tạo hành động khắc phục",
  "qc.correctiveActions.type": "Loại hành động",
  "qc.correctiveActions.description": "Mô tả",
  "qc.correctiveActions.assignedTo": "Giao cho",
  "qc.correctiveActions.status": "Trạng thái",
  "qc.correctiveActions.pending": "Chờ xử lý",
  "qc.correctiveActions.inProgress": "Đang thực hiện",
  "qc.correctiveActions.completed": "Hoàn tất",
  "qc.correctiveActions.resolutionNotes": "Ghi chú xử lý",
  "qc.alerts.title": "Cảnh báo QC",
  "qc.alerts.markAsRead": "Đánh dấu đã đọc",
  "qc.alerts.viewDetails": "Xem chi tiết",
  "qc.rules.title": "Cấu hình quy tắc Westgard",
  "qc.rules.enable": "Bật",
  "qc.rules.disable": "Tắt",
  "qc.rules.preset": "Cấu hình mẫu",
  "qc.rules.basic": "Cơ bản",
  "qc.rules.standard": "Tiêu chuẩn",
  "qc.rules.comprehensive": "Đầy đủ",
  "qc.rules.1₂ₛ.description": "Một mẫu chứng vượt ±2SD",
  "qc.rules.1₃ₛ.description": "Một mẫu chứng vượt ±3SD",
  "qc.rules.2₂ₛ.description": "Hai mẫu chứng liên tiếp cùng vượt ±2SD về một phía",
  "qc.rules.R₄ₛ.description": "Khoảng cách giữa hai mẫu chứng vượt 4SD",
  "qc.rules.4₁ₛ.description": "Bốn mẫu chứng liên tiếp cùng vượt ±1SD về một phía",
  "qc.rules.10ₓ.description": "Mười mẫu chứng liên tiếp cùng nằm một phía của trung bình",
  "qc.rules.3₁ₛ.description": "Ba mẫu chứng liên tiếp cùng vượt ±1SD về một phía",
  "qc.rules.7ₜ.description": "Bảy mẫu chứng liên tiếp có xu hướng cùng một chiều",
  "qc.ruleConfig.title": "Cấu hình quy tắc",
  "qc.ruleConfig.subtitle": "Cấu hình quy tắc Westgard theo từng cặp máy và xét nghiệm",
  "qc.ruleConfig.field.analyzer": "Máy xét nghiệm",
  "qc.ruleConfig.field.selectAnalyzer": "Chọn máy xét nghiệm",
  "qc.ruleConfig.field.test": "Xét nghiệm",
  "qc.ruleConfig.field.selectTest": "Chọn xét nghiệm",
  "qc.ruleConfig.field.severity": "Mức độ",
  "qc.ruleConfig.severity.warning": "Cảnh báo",
  "qc.ruleConfig.severity.rejection": "Loại bỏ kết quả",
  "qc.ruleConfig.category.rejection": "Quy tắc loại bỏ",
  "qc.ruleConfig.category.warning": "Quy tắc cảnh báo",
  "qc.ruleConfig.action.reset": "Đặt lại mặc định",
  "qc.ruleConfig.loading": "Đang tải cấu hình quy tắc...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Chọn máy xét nghiệm và xét nghiệm để cấu hình quy tắc Westgard.",
  "qc.ruleConfig.error.title": "Lỗi",
  "qc.ruleConfig.error.selectAnalyzerTest": "Vui lòng chọn cả máy xét nghiệm và xét nghiệm.",
  "qc.ruleConfig.error.saveFailed": "Không lưu được cấu hình quy tắc.",
  "qc.ruleConfig.success.title": "Thành công",
  "qc.ruleConfig.success.saved": "Đã lưu cấu hình quy tắc thành công.",
  "qc.ruleConfig.table.title": "Bộ quy tắc đã cấu hình",
  "qc.ruleConfig.table.empty": "Không tìm thấy cấu hình quy tắc nào.",
  "qc.ruleConfig.field.enabledRules": "Quy tắc đã bật",
  "qc.ruleConfig.unconfigured.title": "Ánh xạ mẫu chứng chưa cấu hình",
  "qc.ruleConfig.unconfigured.subtitle": "Lô mẫu chứng chưa có cấu hình quy tắc Westgard",
  "qc.ruleConfig.unconfigured.configure": "Cấu hình",
  "qc.ruleConfig.unconfigured.activeLots": "LOT đang hoạt động",
  "qc.ruleConfig.modal.title.edit": "Sửa cấu hình quy tắc",
  "qc.ruleConfig.modal.title.create": "Tạo cấu hình quy tắc",
  "button.saving": "Đang lưu...",
  "qc.controlLots.title": "LOT mẫu chứng",
  "qc.controlLots.create": "Tạo LOT mẫu chứng",
  "qc.controlLots.productName": "Tên sản phẩm",
  "qc.controlLots.lotNumber": "Số LOT",
  "qc.controlLots.level": "Mức mẫu chứng",
  "qc.controlLots.statisticsMethod": "Phương pháp tính thống kê",
  "qc.controlLots.initialRuns": "Các lần chạy ban đầu",
  "qc.controlLots.rolling": "Cửa sổ trượt",
  "qc.controlLots.manufacturerFixed": "Nhà sản xuất cố định",
  "qc.controlLots.activationDate": "Ngày kích hoạt",
  "qc.controlLots.expirationDate": "Ngày hết hạn",
  "qc.controlLots.status.active": "Đang hoạt động",
  "qc.controlLots.status.establishment": "Đang thiết lập",
  "qc.controlLots.status.expired": "Hết hạn",
  "qc.controlLots.subtitle": "Quản lý LOT mẫu chứng QC để đánh giá quy tắc Westgard",
  "qc.controlLots.empty": "Không tìm thấy LOT mẫu chứng nào",
  "qc.controlLot.filter.allStatuses": "Tất cả trạng thái",
  "qc.controlLot.status.establishment": "Đang thiết lập",
  "qc.controlLot.status.active": "Đang hoạt động",
  "qc.controlLot.status.expired": "Hết hạn",
  "qc.controlLot.field.lotNumber": "Số LOT",
  "qc.controlLot.field.lotNumberPlaceholder": "Nhập số LOT",
  "qc.controlLot.field.material": "Vật liệu mẫu chứng",
  "qc.controlLot.field.materialPlaceholder": "Nhập tên vật liệu",
  "qc.controlLot.field.manufacturer": "Nhà sản xuất",
  "qc.controlLot.field.level": "Mức mẫu chứng",
  "qc.controlLot.field.selectLevel": "Chọn mức",
  "qc.controlLot.field.expiration": "Ngày hết hạn",
  "qc.controlLot.field.analyzer": "Máy xét nghiệm",
  "qc.controlLot.field.selectAnalyzer": "Chọn máy xét nghiệm",
  "qc.controlLot.field.analyzerHelper": "Không bắt buộc. Chọn “Bàn thủ công / không có máy” để chạy phương pháp thủ công tại bàn mà không dùng máy.",
  "qc.controlLot.analyzer.bench": "Bàn thủ công / không có máy (phương pháp thủ công)",
  "qc.controlLot.field.test": "Xét nghiệm",
  "qc.controlLot.field.selectTest": "Chọn xét nghiệm",
  "qc.controlLot.field.isActive": "Trạng thái",
  "qc.controlLot.field.inactive": "Không hoạt động",
  "qc.controlLot.field.active": "Hoạt động",
  "qc.controlLot.field.status": "Trạng thái",
  "qc.controlLot.loading": "Đang tải...",
  "qc.controlLot.error.title": "Lỗi",
  "qc.controlLot.error.saveFailed": "Không lưu được LOT mẫu chứng",
  "qc.controlLot.error.statsRequired": "LOT có nhà sản xuất cố định cần giá trị trung bình và độ lệch chuẩn. Bấm “Cấu hình” để nhập trước khi lưu.",
  "qc.controlLot.error.benchNeedsFixedStats": "LOT bàn thủ công không có máy tích lũy các lần chạy, nên phải dùng thống kê do nhà sản xuất cố định. Bấm “Cấu hình” để nhập trung bình và độ lệch chuẩn, hoặc chọn một máy cho LOT này.",
  "qc.controlLot.new.title": "LOT mẫu chứng mới",
  "qc.controlLot.viewChart": "Xem biểu đồ",
  "qc.controlLot.new.subtitle": "Tạo LOT mẫu chứng QC mới",
  "qc.controlLot.edit.title": "Sửa LOT mẫu chứng",
  "qc.controlLot.edit.subtitle": "Cập nhật cấu hình LOT mẫu chứng",
  "qc.controlLot.validation.lotNumberRequired": "Bắt buộc nhập số LOT",
  "qc.controlLot.validation.materialRequired": "Bắt buộc nhập vật liệu",
  "qc.controlLot.validation.levelRequired": "Bắt buộc chọn mức mẫu chứng",
  "qc.controlLot.validation.expirationRequired": "Bắt buộc nhập ngày hết hạn",
  "qc.controlLot.validation.analyzerRequired": "Bắt buộc chọn máy xét nghiệm",
  "qc.controlLot.validation.testRequired": "Bắt buộc chọn xét nghiệm",
  "qc.controlLot.level.low": "Thấp",
  "qc.controlLot.level.normal": "Bình thường",
  "qc.controlLot.level.high": "Cao",
  "qc.controlLot.statistics.title": "Cấu hình thống kê",
  "qc.controlLot.statistics.configure": "Cấu hình",
  "qc.controlLot.statistics.method": "Phương pháp tính",
  "qc.controlLot.statistics.mean": "Trung bình",
  "qc.controlLot.statistics.sd": "Độ lệch chuẩn",
  "qc.controlLot.statistics.config.title": "Cấu hình thống kê",
  "qc.controlLot.statistics.config.label": "Cấu hình phương pháp thống kê",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Nhà sản xuất cố định",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Dùng giá trị trung bình và SD do nhà sản xuất cung cấp",
  "qc.controlLot.statistics.method.rolling": "Cửa sổ trượt",
  "qc.controlLot.statistics.method.rolling.description": "Tính lại từ N kết quả gần nhất",
  "qc.controlLot.statistics.method.initial_runs": "Các lần chạy ban đầu",
  "qc.controlLot.statistics.method.initial_runs.description": "Tính một lần từ N lần chạy thiết lập đầu tiên",
  "qc.controlLot.statistics.manufacturerValues": "Giá trị nhà sản xuất",
  "qc.controlLot.statistics.rollingConfig": "Cấu hình cửa sổ trượt",
  "qc.controlLot.statistics.windowSize": "Kích thước cửa sổ",
  "qc.controlLot.statistics.windowSize.helper": "Số kết quả gần nhất đưa vào tính toán",
  "qc.controlLot.statistics.initialRunsConfig": "Cấu hình các lần chạy ban đầu",
  "qc.controlLot.statistics.initialRunsRequired": "Số lần chạy yêu cầu",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Số lần chạy thiết lập trước khi tính thống kê",
  "qc.instrumentDetail.analytesMonitored": "Chất phân tích được theo dõi",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, other {# vi phạm}}",
  "qc.instrumentDetail.tab.activityTimeline": "Dòng thời gian hoạt động",
  "qc.instrumentDetail.tab.controlChart": "Biểu đồ kiểm soát",
  "qc.instrumentDetail.timeline.empty": "Không có cảnh báo hoặc hành động khắc phục nào trong khoảng thời gian đã chọn",
  "qc.instrumentDetail.timeline.violation": "Vi phạm",
  "qc.instrumentDetail.timeline.correctiveAction": "Hành động khắc phục",
  "qc.instrumentDetail.timeline.loading": "Đang tải dòng thời gian hoạt động...",
  "qc.instrumentDetail.chart.selectAnalyte": "Chọn chất phân tích",
  "qc.instrumentDetail.chart.loading": "Đang tải biểu đồ kiểm soát...",
  "qc.instrumentDetail.chart.noData": "Không có dữ liệu QC cho chất phân tích này",
  "qc.instrumentDetail.chart.activeRules": "Quy tắc QC đang bật",
  "qc.instrumentDetail.chart.noRules": "Chưa cấu hình quy tắc nào đang bật",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Trung bình (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Độ lệch chuẩn (s)",
  "qc.instrumentDetail.error.loadFailed": "Không tải được chi tiết máy",
  "qc.instrumentDetail.notConfigured.title": "Chưa cấu hình QC vận hành",
  "qc.instrumentDetail.notConfigured.description": "Không có LOT mẫu chứng đang hoạt động hoặc kết quả QC nào được liên kết với máy xét nghiệm này.",
  "question.text.required": "Bắt buộc nhập nội dung câu hỏi",
  "compliance.legend.limitTypes": "LOẠI GIỚI HẠN:",
  "compliance.limitType.borderlineShort": "Ranh giới ⚑",
  "compliance.limitType.descriptiveShort": "Định tính",
  "compliance.limitType.MAXIMUM": "Giới hạn trên ≤",
  "compliance.limitType.MINIMUM": "Giới hạn dưới ≥",
  "compliance.limitType.RANGE": "Khoảng bình thường",
  "compliance.limitType.BORDERLINE": "Ranh giới 🚩",
  "compliance.limitType.DESCRIPTIVE": "Định tính",
  "compliance.limitType.EXACT": "Chính xác",
  "compliance.limitType.SELECT_MAP": "Ánh xạ giá trị",
  "compliance.status.ACTIVE": "Đang hoạt động",
  "compliance.status.DRAFT": "Nháp",
  "compliance.status.SUPERSEDED": "Đã thay thế",
  "compliance.status.ARCHIVED": "Đã lưu trữ",
  "compliance.standard.placeholder.name": "ví dụ: PP số 22/2021 — Chất lượng nước",
  "compliance.standard.placeholder.issuingBody": "ví dụ: Chính phủ Indonesia",
  "compliance.standard.placeholder.regulationNumber": "ví dụ: PP 22/2021",
  "compliance.standard.placeholder.version": "ví dụ: 2021",
  "compliance.standard.placeholder.countryRegion": "ví dụ: Indonesia",
  "compliance.standard.placeholder.description": "Không bắt buộc. Mô tả đầy đủ phạm vi của tiêu chuẩn.",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Dưới / Tối thiểu",
  "compliance.threshold.placeholder.upper": "Trên / Tối đa",
  "compliance.threshold.placeholder.unit": "Đơn vị",
  "compliance.standard.archive": "Lưu trữ",
  "compliance.standard.archiveHeading": "Lưu trữ tiêu chuẩn tuân thủ",
  "compliance.standard.archivePrompt": "Lưu trữ tiêu chuẩn này? Các kết quả đã đánh giá vẫn giữ liên kết với nó để kiểm tra, nhưng tiêu chuẩn sẽ bị ẩn khỏi danh sách chọn đang dùng. Có thể hoàn tác bằng cách sửa trạng thái tiêu chuẩn về Đang hoạt động.",
  "compliance.standard.archived": "Đã lưu trữ tiêu chuẩn tuân thủ.",
  "compliance.standard.archiveError": "Không lưu trữ được tiêu chuẩn này.",
  "button.complianceStandard.copy": "Sao chép tiêu chuẩn",
  "compliance.standard.copied": "Đã sao chép tiêu chuẩn tuân thủ thành bản Nháp mới.",
  "compliance.standard.copyError": "Không sao chép được tiêu chuẩn này.",
  "compliance.standard.viewLinkedTests": "Xem xét nghiệm liên kết",
  "compliance.testEditor.groupBy": "Nhóm theo",
  "compliance.testEditor.section.configuration": "Cấu hình",
  "compliance.testEditor.section.organization": "Tổ chức",
  "compliance.testEditor.section.resources": "Tài nguyên",
  "compliance.testEditor.section.automation": "Tự động hóa",
  "compliance.testEditor.section.compliance": "Tuân thủ",
  "compliance.testEditor.tab.compliance": "Tuân thủ",
  "compliance.testEditor.tabPlaceholder": "Sẽ có trong trình soạn xét nghiệm — hiện quản lý tại trang Sửa xét nghiệm.",
  "compliance.parameterGroup.editBtn": "Sửa",
  "compliance.parameterGroup.moveUp": "Đưa lên",
  "compliance.parameterGroup.moveDown": "Đưa xuống",
  "compliance.parameterGroup.updateError": "Không cập nhật được nhóm thông số.",
  "compliance.testEditor.standardInactiveBanner": "Xét nghiệm này có ngưỡng liên kết với {name}, hiện đang ở trạng thái {status}. Kết quả sẽ không còn được đánh giá theo tiêu chuẩn này.",
  "compliance.standard.viewLinkedTests.heading": "Xét nghiệm liên kết — {name}",
  "compliance.standard.viewLinkedTests.empty": "Hiện chưa có xét nghiệm nào liên kết với tiêu chuẩn này.",
  "compliance.filter.status": "Trạng thái",
  "compliance.filter.region": "Vùng",
  "compliance.filter.allStatuses": "Tất cả trạng thái",
  "compliance.filter.allRegions": "Tất cả vùng",
  "compliance.filter.sampleType": "Loại mẫu",
  "compliance.filter.allSampleTypes": "Tất cả loại mẫu",
  "compliance.sampleTypes.addLabel": "Thêm loại mẫu",
  "compliance.sampleTypes.noneConfigured": "Chưa cấu hình",
  "compliance.sampleTypes.noneTitle": "Chưa cấu hình loại mẫu nào.",
  "compliance.sampleTypes.noneSubtitle": "Thêm ít nhất một loại mẫu trước khi liên kết xét nghiệm.",
  "compliance.sampleTypes.counter": "{count, plural, other {Đã cấu hình # loại mẫu}}",
  "compliance.standard.default": "Mặc định",
  "compliance.standard.groups": "Nhóm",
  "compliance.standard.tests": "Xét nghiệm",
  "compliance.standard.expiryDate": "Ngày hết hiệu lực",
  "compliance.parameterGroups.heading": "Nhóm thông số & xét nghiệm liên kết",
  "compliance.parameterGroups.requireSampleTypes": "Hãy cấu hình các trường và loại mẫu của tiêu chuẩn trước, rồi mới liên kết xét nghiệm.",
  "compliance.button.save": "Lưu",
  "compliance.button.saving": "Đang lưu…",
  "compliance.parameterGroup.createError": "Không thêm được nhóm thông số.",
  "compliance.parameterGroup.deleteHeading": "Xóa nhóm thông số",
  "compliance.parameterGroup.deletePrompt": "Xóa nhóm thông số {name} và toàn bộ ngưỡng của nhóm? Thao tác này không thể hoàn tác.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, other {# xét nghiệm}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Không lưu được dòng này.",
  "compliance.threshold.deleteError": "Không gỡ được dòng này.",
  "compliance.validation.required": "Trường này là bắt buộc.",
  "compliance.validation.expiryAfterEffective": "Ngày hết hiệu lực phải bằng hoặc sau ngày có hiệu lực.",
  "compliance.validation.missingUpper": "Bắt buộc nhập giới hạn trên.",
  "compliance.validation.missingLower": "Bắt buộc nhập giới hạn dưới.",
  "compliance.validation.missingBounds": "Bắt buộc nhập cả giới hạn dưới và giới hạn trên.",
  "compliance.validation.lowerGtUpper": "Giới hạn dưới phải nhỏ hơn hoặc bằng giới hạn trên.",
  "compliance.validation.missingDescriptive": "Bắt buộc nhập giá trị định tính.",
  "compliance.linkTest.selectNoOptions": "Xét nghiệm này kiểu danh sách chọn nhưng chưa có tùy chọn trong danh mục xét nghiệm. Hãy thêm tùy chọn kết quả trong quản lý xét nghiệm trước khi liên kết với tiêu chuẩn tuân thủ.",
  "compliance.linkTest.resultTypeLegend": "Kiểu kết quả",
  "compliance.linkTest.resultType.numeric": "Số (dùng giá trị giới hạn)",
  "compliance.linkTest.resultType.select": "Danh sách chọn (ánh xạ tùy chọn sang trạng thái)",
  "compliance.linkTest.optionsHint": "Thêm các tùy chọn kết quả của xét nghiệm này (ví dụ: 'Không có', 'Có'). Bước tiếp theo cho phép bạn ánh xạ từng tùy chọn sang trạng thái tuân thủ.",
  "compliance.linkTest.optionLabel": "Giá trị tùy chọn",
  "compliance.linkTest.optionPlaceholder": "ví dụ: Không có",
  "compliance.linkTest.optionsRequired": "Thêm ít nhất một tùy chọn ở trên trước khi ánh xạ trạng thái.",
  "compliance.admin.title": "Quản trị tiêu chuẩn tuân thủ",
  "compliance.admin.tile.explain": "Quản lý tiêu chuẩn tuân thủ, nhóm thông số và ngưỡng theo từng xét nghiệm (ví dụ: PP 22/2021, Nước uống WHO).",
  "compliance.tabs.standardsAdmin": "Danh sách tiêu chuẩn tuân thủ",
  "compliance.tabs.testThresholds": "Tab Tuân thủ (Trình soạn xét nghiệm)",
  "compliance.testEditor.back": "Quay lại",
  "compliance.testEditor.editTest": "Sửa xét nghiệm:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Loại mẫu:",
  "compliance.testEditor.resultType": "Kiểu kết quả:",
  "compliance.testEditor.saveTest": "Lưu xét nghiệm",
  "compliance.testEditor.saveDisabledHint": "Các tab khác của trình soạn xét nghiệm chưa được kết nối trong đợt này.",
  "compliance.testEditor.thresholdsHeading": "Ngưỡng tuân thủ cho",
  "compliance.testEditor.addThreshold": "Thêm ngưỡng",
  "compliance.testEditor.addThresholdHeading": "Liên kết {name} với một tiêu chuẩn tuân thủ",
  "compliance.testEditor.pickStandard": "Tiêu chuẩn tuân thủ",
  "compliance.testEditor.pickStandardPlaceholder": "-- Chọn tiêu chuẩn --",
  "compliance.testEditor.pickGroup": "Nhóm thông số",
  "compliance.testEditor.pickGroupPlaceholder": "-- Chọn nhóm thông số --",
  "compliance.testEditor.pickGroupHint": "Chọn tiêu chuẩn và nhóm thông số ở trên để cấu hình ngưỡng.",
  "compliance.testEditor.unlink": "Bỏ liên kết",
  "compliance.testEditor.unlinkHeading": "Bỏ liên kết ngưỡng",
  "compliance.testEditor.unlinkPrompt": "Gỡ ngưỡng này khỏi {test}? Bản thân ngưỡng vẫn nằm trong nhóm thông số của tiêu chuẩn; chỉ bỏ liên kết với riêng xét nghiệm này.",
  "compliance.testEditor.linkedBanner": "Xét nghiệm này được liên kết với {count, plural, one {# tiêu chuẩn tuân thủ} other {# tiêu chuẩn tuân thủ}}. Ngưỡng được đánh giá khi duyệt kết quả.",
  "compliance.testEditor.expandRow": "Mở rộng dòng",
  "compliance.testEditor.col.standard": "Tiêu chuẩn",
  "compliance.testEditor.col.parameterGroup": "Nhóm thông số",
  "compliance.testEditor.col.limitType": "Loại giới hạn",
  "compliance.testEditor.col.thresholdRange": "Ngưỡng / Khoảng",
  "compliance.testEditor.col.unit": "Đơn vị",
  "compliance.testEditor.col.effective": "Hiệu lực",
  "compliance.testEditor.col.status": "Trạng thái",
  "compliance.testThresholds.selectHint": "Chọn một xét nghiệm để xem các ngưỡng tuân thủ được liên kết qua các tiêu chuẩn.",
  "compliance.testThresholds.overviewHeading": "Xét nghiệm liên kết với tiêu chuẩn tuân thủ",
  "compliance.testThresholds.overviewCount": "{filtered} / {total} xét nghiệm{total, plural, one {} other {}}",
  "compliance.testThresholds.overviewEmpty": "Chưa có xét nghiệm nào liên kết với tiêu chuẩn tuân thủ.",
  "compliance.testThresholds.overviewEmptyHint": "Ngưỡng nạp từ CSV ở cấp nhóm thông số hiển thị ở Tab 1 (Quản trị tiêu chuẩn tuân thủ), không hiển thị ở đây. Tìm ở trên để chọn xét nghiệm từ danh mục và liên kết với một tiêu chuẩn.",
  "compliance.testThresholds.noLinkedMatches": "Không có xét nghiệm liên kết nào khớp với “{q}”.",
  "compliance.testThresholds.addSection": "Thêm xét nghiệm vào tuân thủ",
  "compliance.testThresholds.col.test": "Xét nghiệm",
  "compliance.testThresholds.col.code": "Mã",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Loại mẫu",
  "compliance.testThresholds.col.thresholdCount": "Số ngưỡng",
  "compliance.testThresholds.col.standardCount": "Số tiêu chuẩn",
  "compliance.testThresholds.openEditor": "Mở",
  "compliance.testThresholds.title": "Ngưỡng tuân thủ của xét nghiệm",
  "compliance.testThresholds.tile.explain": "Xem các ngưỡng tuân thủ liên kết với một xét nghiệm cụ thể, nhóm theo tiêu chuẩn và nhóm thông số.",
  "compliance.testThresholds.searchLabel": "Tìm xét nghiệm",
  "compliance.testThresholds.searchPlaceholder": "Lọc danh sách xét nghiệm…",
  "compliance.testThresholds.test": "Xét nghiệm",
  "compliance.testThresholds.selectPlaceholder": "-- Chọn xét nghiệm --",
  "compliance.testThresholds.empty": "Chưa có ngưỡng tuân thủ nào liên kết với xét nghiệm này. Bấm + Thêm ngưỡng ở trên để liên kết với nhóm thông số của một tiêu chuẩn tuân thủ.",
  "compliance.testThresholds.parameter": "Thông số",
  "compliance.testThresholds.type": "Loại giới hạn",
  "compliance.testThresholds.value": "Giá trị",
  "compliance.testThresholds.note": "Ghi chú",
  "compliance.testThresholds.unknownStandard": "Tiêu chuẩn không xác định",
  "compliance.button.openAdmin": "Mở quản trị tiêu chuẩn tuân thủ",
  "compliance.button.addStandard": "Thêm tiêu chuẩn",
  "compliance.button.saveStandard": "Lưu tiêu chuẩn",
  "compliance.button.linkTest": "Liên kết xét nghiệm vào nhóm",
  "compliance.button.saveLimits": "Lưu giới hạn",
  "compliance.button.saveMapping": "Lưu ánh xạ",
  "compliance.search": "Tìm tiêu chuẩn",
  "compliance.search.placeholder": "Tìm theo tên, cơ quan ban hành, quy định, quốc gia…",
  "compliance.list.empty": "Chưa có tiêu chuẩn tuân thủ nào.",
  "compliance.standard.name": "Tên tiêu chuẩn",
  "compliance.standard.issuingBody": "Cơ quan ban hành",
  "compliance.standard.regulationNumber": "Số quy định",
  "compliance.standard.version": "Phiên bản",
  "compliance.standard.countryRegion": "Quốc gia / Vùng",
  "compliance.standard.status": "Trạng thái",
  "compliance.standard.effectiveDate": "Ngày có hiệu lực",
  "compliance.standard.description": "Mô tả",
  "compliance.standard.addNew": "Thêm tiêu chuẩn tuân thủ mới",
  "compliance.standard.edit": "Sửa tiêu chuẩn tuân thủ",
  "compliance.standard.preSeeded": "Có sẵn trong hệ thống",
  "compliance.standard.saved": "Đã lưu tiêu chuẩn tuân thủ.",
  "compliance.standard.saveError": "Không lưu được tiêu chuẩn.",
  "compliance.standard.saveBeforeGroups": "Hãy lưu tiêu chuẩn trước khi thêm nhóm thông số.",
  "compliance.standard.deleted": "Đã xóa tiêu chuẩn tuân thủ.",
  "compliance.standard.deleteError": "Không xóa được tiêu chuẩn (có thể là tiêu chuẩn có sẵn hoặc đang có ngưỡng liên kết).",
  "compliance.standard.deleteHeading": "Xóa tiêu chuẩn tuân thủ",
  "compliance.standard.deletePrompt": "Bạn có chắc muốn xóa tiêu chuẩn này? Tiêu chuẩn có sẵn và tiêu chuẩn đang có ngưỡng liên kết không thể xóa.",
  "compliance.sampleTypes.heading": "Loại mẫu áp dụng",
  "compliance.sampleTypes.explicitHint": "Khai báo nhóm loại mẫu mà tiêu chuẩn này áp dụng. Các lựa chọn này sẽ lọc danh sách xét nghiệm khi liên kết.",
  "compliance.sampleTypes.empty": "Chưa khai báo loại mẫu nào.",
  "compliance.sampleTypes.selectPlaceholder": "Chọn loại mẫu...",
  "compliance.sampleTypes.addBtn": "Thêm loại mẫu",
  "compliance.sampleTypes.remove": "Gỡ",
  "compliance.parameterGroups": "Nhóm thông số",
  "compliance.parameterGroups.empty": "Chưa định nghĩa nhóm thông số nào.",
  "compliance.parameterGroups.add": "Thêm nhóm thông số",
  "compliance.parameterGroup.name": "Tên nhóm",
  "compliance.parameterGroup.description": "Mô tả",
  "compliance.parameterGroup.deleteBtn": "Xóa",
  "compliance.label.tests": "xét nghiệm",
  "compliance.linkedTest.name": "Xét nghiệm",
  "compliance.linkedTest.sampleTypes": "Loại mẫu",
  "compliance.linkedTest.limits": "Giới hạn đã cấu hình",
  "compliance.linkedTest.editLimits": "Sửa giới hạn",
  "compliance.linkedTest.unlink": "Gỡ khỏi nhóm",
  "compliance.linkedTest.unlinkHeading": "Gỡ xét nghiệm khỏi nhóm",
  "compliance.linkedTest.unlinkConfirm": "Gỡ",
  "compliance.linkedTest.unlinkPrompt": "Gỡ xét nghiệm này khỏi nhóm? Mọi định nghĩa ngưỡng của xét nghiệm này trong nhóm sẽ bị xóa.",
  "compliance.group.noTests": "Chưa có xét nghiệm nào liên kết với nhóm này. Liên kết xét nghiệm để định nghĩa ngưỡng tuân thủ phục vụ đánh giá.",
  "compliance.linkTest.heading": "Liên kết xét nghiệm vào nhóm",
  "compliance.linkTest.step1": "Bước 1 — Lọc theo loại mẫu",
  "compliance.linkTest.step2": "Bước 2 — Tìm & chọn xét nghiệm",
  "compliance.linkTest.step3Numeric": "Bước 3 — Cấu hình giới hạn",
  "compliance.linkTest.step3Select": "Bước 3 — Ánh xạ giá trị tuân thủ",
  "compliance.linkTest.filterByST": "Lọc theo loại mẫu:",
  "compliance.linkTest.searchTest": "Tìm trong danh mục xét nghiệm",
  "compliance.linkTest.searchPlaceholder": "Gõ để tìm theo tên hoặc mã...",
  "compliance.linkTest.noResults": "Không tìm thấy xét nghiệm nào khớp.",
  "compliance.linkTest.selectListBadge": "Danh sách chọn",
  "compliance.linkTest.clearSelection": "Bỏ chọn",
  "compliance.multiLimit.editHeading": "Cấu hình giới hạn",
  "compliance.multiLimit.hint": "Bật một hoặc nhiều loại giới hạn cho xét nghiệm này. Phải bật ít nhất một loại giới hạn.",
  "compliance.multiLimit.type": "Loại giới hạn",
  "compliance.multiLimit.lower": "Dưới",
  "compliance.multiLimit.upper": "Trên",
  "compliance.multiLimit.unit": "Đơn vị",
  "compliance.multiLimit.note": "Ghi chú / Khuyến cáo",
  "compliance.multiLimit.descriptive.placeholder": "ví dụ: Không mùi, Không có, Trong",
  "compliance.multiLimit.note.placeholder": "Ghi chú (không bắt buộc)",
  "compliance.limitType.high": "Giới hạn trên ≤",
  "compliance.limitType.high.hint": "Không đạt nếu kết quả vượt giới hạn trên",
  "compliance.limitType.low": "Giới hạn dưới ≥",
  "compliance.limitType.low.hint": "Không đạt nếu kết quả thấp hơn giới hạn dưới",
  "compliance.limitType.range": "Khoảng bình thường",
  "compliance.limitType.range.hint": "Đạt khi nằm trong khoảng dưới–trên",
  "compliance.limitType.borderline": "Ranh giới (khuyến cáo)",
  "compliance.limitType.borderline.hint": "Vùng khuyến cáo — kích hoạt cờ xem xét, không phải không đạt",
  "compliance.limitType.descriptive": "Định tính / Mô tả",
  "compliance.limitType.descriptive.hint": "Giá trị văn bản do kỹ thuật viên đánh giá",
  "compliance.selectMap.editHeading": "Ánh xạ tuân thủ",
  "compliance.selectMap.hint": "Ánh xạ từng tùy chọn kết quả sang trạng thái tuân thủ của nó. Các tùy chọn lấy từ danh mục xét nghiệm.",
  "compliance.selectMap.option": "Tùy chọn kết quả",
  "compliance.selectMap.status": "Trạng thái tuân thủ",
  "compliance.selectMap.preview": "Xem trước",
  "compliance.selectMap.badge": "Ánh xạ giá trị",
  "compliance.selectMap.optionsLabel": "tùy chọn đã ánh xạ",
  "compliance.selectMap.statusForOption": "Trạng thái tuân thủ cho {option}",
  "compliance.status.compliant": "Đạt",
  "compliance.status.borderline": "Ranh giới",
  "compliance.status.nonCompliant": "Không đạt",
  "compliance.status.compliantWithIcon": "Đạt ✓",
  "compliance.status.borderlineWithIcon": "Ranh giới ⚑",
  "compliance.status.nonCompliantWithIcon": "Không đạt ✗",
  "compliance.linkedTest.noLimits": "Chưa cấu hình giới hạn",
  "compliance.threshold.savedThresholds": "Đã liên kết ngưỡng tuân thủ với xét nghiệm.",
  "compliance.threshold.savedValueMap": "Đã lưu ngưỡng ánh xạ giá trị.",
  "compliance.threshold.savedPartialError": "Một số ngưỡng không lưu được. Hãy xem các dòng được đánh dấu.",
  "compliance.threshold.unlinked": "Đã bỏ liên kết ngưỡng khỏi xét nghiệm.",
  "compliance.threshold.unlinkError": "Không bỏ liên kết được ngưỡng này.",
  "notification.title.success": "Thành công",
  "notification.title.error": "Lỗi",
  "sidenav.label.admin.vectorSurveillance": "Giám sát véc-tơ",
  "vector.admin.title": "Thiết lập giám sát véc-tơ",
  "vector.admin.groups": "Nhóm sinh vật",
  "vector.admin.group.code": "Mã",
  "vector.admin.group.label": "Nhãn",
  "vector.admin.group.colorTag": "Thẻ màu",
  "vector.admin.group.description": "Mô tả",
  "vector.admin.active": "Hoạt động",
  "vector.admin.system": "Hệ thống",
  "vector.admin.trapTypes": "Loại bẫy",
  "vector.admin.trapType.name": "Tên",
  "vector.admin.trapType.description": "Mô tả",
  "vector.admin.species": "Loài",
  "vector.admin.selectGroup": "Chọn một nhóm bên trái để quản lý loại bẫy và loài của nhóm đó.",
  "vector.admin.newGroup": "Nhóm mới (chưa lưu)",
  "vector.admin.newTrapType": "Loại bẫy mới",
  "vector.admin.newSpecies": "Loài mới",
  "vector.admin.saveGroup": "Lưu nhóm",
  "vector.admin.saveTrap": "Lưu bẫy",
  "vector.admin.saveSpecies": "Lưu loài",
  "vector.admin.addGroup": "+ Thêm nhóm",
  "vector.admin.addTrapType": "+ Thêm loại bẫy",
  "vector.admin.addSpecies": "+ Thêm loài",
  "vector.admin.locked": "đã khóa",
  "vector.admin.systemGroup": "Nhóm được hệ thống bảo vệ",
  "vector.admin.systemGroup.desc": "Mã đã bị khóa vì nhóm này được các báo cáo lõi và dữ liệu mẫu tham chiếu. Bạn vẫn có thể sửa nhãn, màu và mô tả.",
  "vector.admin.usedBy": "Được dùng bởi",
  "vector.admin.status": "Trạng thái",
  "vector.admin.status.active": "Đang hoạt động",
  "vector.admin.status.inactive": "Không hoạt động",
  "vector.admin.group": "Nhóm sinh vật",
  "vector.admin.trapType.group": "Nhóm sinh vật mục tiêu",
  "vector.admin.trapType.groups": "Nhóm sinh vật",
  "vector.admin.trapType.sampleTypes": "Loại mẫu",
  "vector.admin.sampleType": "Loại mẫu",
  "vector.admin.search.groups": "Tìm theo mã hoặc nhãn...",
  "vector.admin.search.traps": "Tìm theo tên hoặc mô tả bẫy...",
  "vector.admin.search.species": "Tìm theo chi hoặc loài...",
  "vector.admin.samplingSites": "Điểm lấy mẫu",
  "vector.admin.samplingSite.newSite": "Điểm mới",
  "vector.admin.samplingSite.allSites": "Tất cả điểm",
  "vector.admin.samplingSite.code": "Mã",
  "vector.admin.samplingSite.name": "Tên điểm",
  "vector.admin.samplingSite.type": "Loại điểm",
  "vector.admin.samplingSite.region": "Vùng",
  "vector.admin.samplingSite.district": "Huyện",
  "vector.admin.samplingSite.contactName": "Người liên hệ",
  "vector.admin.samplingSite.contactPhone": "Điện thoại liên hệ",
  "vector.admin.samplingSite.gpsLatitude": "Vĩ độ GPS",
  "vector.admin.samplingSite.gpsLongitude": "Kinh độ GPS",
  "vector.admin.samplingSite.environmentalZone": "Vùng môi trường",
  "vector.admin.samplingSite.address": "Địa chỉ",
  "vector.admin.samplingSite.description": "Mô tả",
  "vector.admin.samplingSite.source": "Nguồn",
  "vector.admin.samplingSite.source.local": "NỘI BỘ",
  "vector.admin.samplingSite.source.hub": "TRUNG TÂM",
  "vector.admin.samplingSite.lastCollection": "Lần lấy mẫu gần nhất",
  "vector.admin.samplingSite.search": "Tìm theo mã, tên, vùng...",
  "vector.admin.samplingSite.saveSite": "Lưu điểm",
  "vector.admin.samplingSites.registry": "Danh mục điểm lấy mẫu",
  "vector.admin.samplingSite.deactivate": "Ngừng hoạt động",
  "vector.admin.samplingSite.activate": "Kích hoạt",
  "vector.admin.samplingSite.location": "Vị trí",
  "vector.admin.samplingSite.allTypes": "Tất cả loại",
  "vector.admin.samplingSite.subtype": "Phân loại",
  "vector.admin.samplingSite.subtype.placeholder": "ví dụ: Sông, Giếng, BG-Sentinel, Trạm cố định",
  "vector.admin.samplingSite.city": "Thành phố",
  "vector.admin.samplingSite.addressLocation": "Vị trí địa chỉ",
  "vector.admin.samplingSite.addressSearch.placeholder": "Tìm vị trí để tự điền các ô chọn...",
  "vector.admin.samplingSite.gpsCoordinates": "Tọa độ GPS",
  "vector.admin.samplingSite.lastModified": "Sửa lần cuối",
  "label.noResults": "Không tìm thấy kết quả",
  "vector.admin.addSite": "+ Điểm mới",
  "vector.order.title": "Chỉ định giám sát véc-tơ mới",
  "vector.order.subtitle": "Nhóm xét nghiệm: Phòng XN giám sát véc-tơ — miền véc-tơ đang hoạt động.",
  "vector.order.samplingSite": "Điểm lấy mẫu",
  "vector.order.site.code": "Mã điểm",
  "vector.order.site.helper": "Chỉ các điểm giám sát đang hoạt động mới xuất hiện trong kết quả. Tọa độ GPS được tự điền từ hồ sơ điểm.",
  "vector.order.site.name": "Tên điểm",
  "vector.order.site.placeholder": "Tìm theo tên hoặc mã điểm...",
  "vector.order.site.type": "Loại điểm",
  "vector.order.specimen": "Bệnh phẩm",
  "vector.order.organism": "Động vật / Sinh vật",
  "vector.order.organism.hint": "Tên thường gọi — ví dụ: Muỗi, Ve, Chuột, Muỗi cát.",
  "vector.order.organism.placeholder": "Tìm sinh vật hoặc loài...",
  "vector.order.quantity": "Số lượng",
  "vector.order.quantity.hint": "Số cá thể trong gộp mẫu này.",
  "vector.order.requester.section": "Người chỉ định / Chương trình đặt",
  "vector.order.requester": "Người chỉ định",
  "vector.order.requester.placeholder": "Tìm theo tên hoặc mã tổ chức...",
  "vector.order.panels": "Bộ xét nghiệm chỉ định",
  "vector.order.panels.search": "Chọn bộ xét nghiệm còn trống",
  "vector.order.tests": "Xét nghiệm chỉ định",
  "vector.order.tests.search": "Chọn xét nghiệm còn trống",
  "vector.order.collectionContext": "Bối cảnh lấy mẫu (không bắt buộc — ghi nhận sinh thái học)",
  "vector.order.timeOfDay": "Thời điểm trong ngày",
  "vector.order.timeOfDay.dawn": "Rạng sáng",
  "vector.order.timeOfDay.day": "Ban ngày",
  "vector.order.timeOfDay.dusk": "Chạng vạng",
  "vector.order.timeOfDay.night": "Ban đêm",
  "vector.order.restingContext": "Nơi trú ẩn",
  "vector.order.restingContext.outdoor": "Ngoài trời (ưa ngoài nhà)",
  "vector.order.restingContext.indoor": "Trong nhà (ưa trong nhà)",
  "vector.order.restingContext.peridomestic": "Quanh nhà",
  "vector.order.humanBitingCatch": "Bắt từ người bị đốt",
  "vector.order.humanBitingCatch.hint": "mẫu được thu từ người bị đốt khi đậu lên người",
  "vector.order.collectionNotes": "Ghi chú lấy mẫu",
  "vector.order.collectionNotes.placeholder": "Thời tiết, tình trạng bẫy, bất thường...",
  "vector.admin.group.code.placeholder": "ví dụ: SANDFLY",
  "vector.admin.group.label.placeholder": "ví dụ: Muỗi cát",
  "vector.species.genus.placeholder": "ví dụ: Mansonia",
  "vector.species.species.placeholder": "ví dụ: uniformis",
  "vector.species.subspecies.placeholder": "ví dụ: diardii",
  "vector.species.genus": "Chi",
  "vector.species.species": "Loài",
  "vector.species.subspecies": "Phân loài",
  "vector.species.pathogensOfInterest": "Tác nhân gây bệnh quan tâm",
  "vector.species.lifecycleStages": "Các giai đoạn vòng đời",
  "vector.species.pathogenCategory": "Nhóm tác nhân gây bệnh",
  "vector.species.lifecycleCategory": "Nhóm vòng đời",
  "workflow.vector": "Giám sát véc-tơ",
  "vector.sampleType": "Loại mẫu",
  "vector.organismGroup": "Nhóm sinh vật",
  "vector.species": "Loài",
  "vector.animalOrganism": "Động vật/Sinh vật",
  "vector.animalOrganism.add": "Thêm động vật/sinh vật",
  "vector.animalOrganism.remove": "Gỡ động vật/sinh vật",
  "vector.collectedVolume": "Số lượng trong gộp mẫu",
  "vector.lifecycleStage": "Giai đoạn vòng đời",
  "vector.trapCount": "Số bẫy đặt",
  "vector.trapNights": "Số đêm đặt bẫy",
  "vector.trapType": "Loại bẫy",
  "vector.poolingMethod": "Phương pháp gộp mẫu",
  "vector.poolCount": "Số gộp mẫu",
  "vector.samplesPerPool": "Số cá thể mỗi gộp mẫu",
  "vector.totalSpecimens": "Tổng số cá thể",
  "vector.pathogensOfInterest": "Tác nhân gây bệnh quan tâm",
  "vector.homogeneous": "Đồng nhất",
  "vector.random": "Ngẫu nhiên",
  "vector.collectionSite": "Điểm lấy mẫu",
  "vector.collectionSiteName": "Tên điểm lấy mẫu",
  "vector.gpsLatitude": "Vĩ độ GPS",
  "vector.gpsLongitude": "Kinh độ GPS",
  "patient.search.merged.tag": "Đã gộp",
  "patient.merged.banner.title": "Hồ sơ bệnh nhân này đã được gộp",
  "patient.merged.banner.subtitle": "Các hồ sơ đang hoạt động được giữ tại Bệnh nhân {target}.",
  "patient.merged.banner.subtitle.noTarget": "Hồ sơ này đã được gộp vào một bệnh nhân khác.",
  "admin.testCatalog.tabs.ariaLabel": "Các tab chi tiết xét nghiệm",
  "admin.testCatalog.tabs.details": "Chi tiết",
  "admin.testCatalog.tabs.labels": "Nhãn",
  "admin.testCatalog.labels.masterOverride.label": "Cho phép ghi đè khi nhập chỉ định",
  "admin.testCatalog.labels.masterOverride.on": "Bật",
  "admin.testCatalog.labels.masterOverride.off": "Tắt",
  "admin.testCatalog.labels.linkedPresets.title": "Mẫu nhãn đã liên kết",
  "admin.testCatalog.labels.linkedPresets.empty": "Chưa liên kết mẫu nhãn nào. Dùng danh sách bên dưới để thêm.",
  "admin.testCatalog.labels.col.presetName": "Tên mẫu nhãn",
  "admin.testCatalog.labels.col.defaultQty": "SL mặc định",
  "admin.testCatalog.labels.col.maxQty": "SL tối đa",
  "admin.testCatalog.labels.col.allowOverride": "Cho phép ghi đè",
  "admin.testCatalog.labels.col.actions": "Thao tác",
  "admin.testCatalog.labels.action.remove": "Gỡ liên kết mẫu nhãn",
  "admin.testCatalog.labels.addPreset.label": "Thêm loại nhãn",
  "admin.testCatalog.labels.addPreset.placeholder": "Chọn mẫu nhãn",
  "admin.testCatalog.labels.preview.title": "Xem trước khi nhập chỉ định",
  "admin.testCatalog.labels.preview.col.locked": "Khóa",
  "admin.testCatalog.labels.preview.locked": "Khóa",
  "admin.testCatalog.labels.preview.unlocked": "Có thể sửa",
  "admin.testCatalog.labels.save.success": "Đã lưu cấu hình nhãn.",
  "admin.testCatalog.labels.save.error": "Không lưu được cấu hình nhãn.",
  "orderEntry.labels.orderTable.title": "Nhãn chỉ định",
  "orderEntry.labels.sampleTable.title": "Nhãn mẫu",
  "orderEntry.labels.col.row": "Dòng",
  "orderEntry.labels.col.sample": "Mẫu",
  "orderEntry.labels.col.quantity": "Số lượng",
  "orderEntry.labels.orderRow.header": "Chỉ định",
  "orderEntry.labels.sampleRow.header": "Mẫu {number}",
  "orderEntry.labels.input.sample": "Số lượng {column} của mẫu {number}",
  "orderEntry.labels.input.sampleNamed": "Số lượng {column} của {sample}",
  "orderEntry.labels.source.test": "Từ xét nghiệm",
  "orderEntry.labels.source.presetDefault": "Mặc định của mẫu nhãn",
  "orderEntry.labels.source.saved": "Đã lưu",
  "orderEntry.labels.locked.tooltipFor": "{label} bị khóa bởi cấu hình xét nghiệm và không thể thay đổi.",
  "orderEntry.labels.total": "Tổng số nhãn: {total}",
  "orderEntry.labels.heading": "NHÃN",
  "orderEntry.labels.title": "Nhãn",
  "orderEntry.labels.printRow": "In nhãn cho {label}",
  "orderEntry.labels.printColumn": "In tất cả nhãn {label}",
  "orderEntry.labels.printAll": "In tất cả nhãn",
  "orderEntry.labels.pendingSave": "In sau khi lưu",
  "orderEntry.labels.empty": "Thêm một mẫu ở trên để xem nhãn của mẫu đó.",
  "orderEntry.labels.loadFailed": "Không tải được số lượng nhãn từ các mẫu nhãn.",
  "orderEntry.labels.printFailed": "Không tạo được nhãn.",
  "orderEntry.labels.printFailed.detail": "Máy chủ trả về {status}.",
  "orderEntry.labels.printFailed.unreachable": "Không kết nối được máy chủ.",
  "orderEntry.labels.nothingToPrint": "Chưa cấu hình nhãn nào cho lựa chọn này.",
  "orderEntry.labels.downloaded": "Cửa sổ in bị chặn, nên nhãn đã được tải về thay thế.",
  "orderEntry.labels.retry": "Thử lại",
  "label.patientHistory.filterByCategory": "Lọc theo nhóm xét nghiệm",
  "label.patientHistory.testCategories": "Nhóm xét nghiệm",
  "label.patientHistory.tree": "Dạng cây",
  "label.patientHistory.showTree": "Hiện dạng cây",
  "label.patientHistory.resetTree": "Đặt lại dạng cây",
  "label.patientHistory.viewResults": "Xem {count} kết quả",
  "label.patientHistory.emptyState": "Không có {displayText} nào để hiển thị cho bệnh nhân này",
  "label.patientHistory.record": "Ghi nhận {displayText}",
  "label.patientHistory.dataLoadError": "Lỗi tải dữ liệu",
  "label.patientHistory.errorCopy": "Xin lỗi, đã xảy ra sự cố khi hiển thị thông tin này. Bạn có thể tải lại trang hoặc liên hệ quản trị viên của cơ sở và cung cấp mã lỗi ở trên.",
  "label.patientHistory.backToTimeline": "Quay lại dòng thời gian",
  "label.patientHistory.returnToTimeline": "Trở về dòng thời gian",
  "label.patientHistory.timeOfTest": "Thời điểm xét nghiệm",
  "label.patientHistory.observations": "quan sát",
  "label.patientHistory.range.oneDay": "1 ngày",
  "label.patientHistory.range.fiveDays": "5 ngày",
  "label.patientHistory.range.oneMonth": "1 tháng",
  "label.patientHistory.range.sixMonths": "6 tháng",
  "label.patientHistory.range.oneYear": "1 năm",
  "label.patientHistory.range.fiveYears": "5 năm",
  "label.patientHistory.range.all": "Tất cả",
  "label.patientHistory.date": "Ngày",
  "address.search.no.results": "Không tìm thấy địa chỉ nào cho “{term}”",
  "address.search.placeholder": "Tìm địa chỉ (nhập ít nhất 2 ký tự)...",
  "address.search.results.count": "Tìm thấy {count} kết quả",
  "alert.error": "Lỗi",
  "alert.warning": "Cảnh báo",
  "analyzer.errorDetails.noLogsAvailable": "Không có nhật ký",
  "analyzer.fieldSelector.placeholder": "Tìm và chọn trường...",
  "analyzer.fieldSelector.title": "Chọn trường OpenELIS",
  "analyzer.form.columnMappings": "Ánh xạ cột (JSON)",
  "analyzer.form.columnMappings.helperText": "Ánh xạ tên cột trong tệp sang tên trường nội bộ",
  "analyzer.form.delimiter": "Ký tự phân cách",
  "analyzer.form.fileFormat": "Định dạng tệp",
  "analyzer.form.fileImport.title": "Cài đặt nhập tệp",
  "analyzer.form.filePattern": "Mẫu tên tệp",
  "analyzer.form.filePattern.helperText": "Mẫu glob để khớp các tệp kết quả",
  "analyzer.form.hasHeader": "Tệp có dòng tiêu đề",
  "analyzer.form.importDirectory": "Thư mục nhập",
  "analyzer.form.importDirectory.helperText": "Thư mục mà cầu nối theo dõi để nhận tệp kết quả",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/may-cua-toi/incoming",
  "analyzer.form.validation.columnMappings.invalid": "Ánh xạ cột phải là JSON hợp lệ",
  "analyzer.form.validation.importDirectory.required": "Bắt buộc có thư mục nhập cho máy xét nghiệm dùng tệp",
  "analyzer.form.validation.port.invalid": "Cổng phải là số từ 1 đến 65535",
  "analyzer.qc.batch.failure.subtitle": "Mẫu chứng QC trong lô này có lỗi. Xem kết quả QC bên dưới trước khi duyệt kết quả bệnh nhân.",
  "analyzer.qc.batch.failure.title": "Mẫu chứng QC không đạt",
  "analyzer.qc.controls.hidden": "Mẫu chứng QC đã ẩn khỏi giao diện bệnh nhân",
  "analyzer.qc.controls.section.title": "Mẫu chứng QC ({count})",
  "audittrail.table.heading": "Thông tin chỉ định",
  "barcode.label.info.labnumber": "Mã mẫu",
  "button.close": "Đóng",
  "button.collapse": "Thu gọn",
  "button.expand": "Mở rộng",
  "button.home": "Bàn làm việc",
  "button.new.search": "Tìm mới",
  "column.name.labNo": "Mã mẫu #",
  "env.collectionConditions.helper": "Tìm điểm lấy mẫu có sẵn hoặc tạo điểm mới. Các điểm có thể dùng lại cho nhiều chỉ định — giống bệnh nhân trong quy trình lâm sàng.",
  "env.collectionMethod.placeholder": "ví dụ: Mẫu lấy tức thời, Gộp mẫu 24h",
  "env.conditions": "Điều kiện môi trường",
  "env.conditions.placeholder": "ví dụ: 20°C, trời quang, mùa khô",
  "env.regulatoryReference": "Căn cứ quy định",
  "env.regulatoryReference.placeholder": "ví dụ: PP số 22/2021 Chất lượng nước",
  "env.samplingSite.title": "Đối tượng — Điểm lấy mẫu",
  "env.site.address": "Địa chỉ",
  "env.site.addressSearch.placeholder": "Tìm vị trí để tự điền các ô chọn bên dưới...",
  "env.site.code": "Mã điểm",
  "env.site.code.placeholder": "Tự động tạo (hoặc nhập thủ công)",
  "env.site.contactPerson": "Người liên hệ",
  "env.site.contactPerson.placeholder": "Tên người quản lý hoặc liên hệ của điểm",
  "env.site.contactPhone": "Điện thoại liên hệ",
  "env.site.description": "Mô tả điểm",
  "env.site.description.placeholder": "ví dụ: Điểm giám sát hạ lưu gần cống",
  "env.site.helperText": "Đăng ký điểm lấy mẫu mới. Điểm sẽ được lưu vào Danh mục điểm và có thể dùng lại cho các chỉ định sau.",
  "env.site.name": "Tên điểm",
  "env.site.name.placeholder": "ví dụ: Sông Ciliwung — Manggarai",
  "env.site.newTab": "Điểm mới",
  "env.site.saveAndSelect": "Lưu & chọn điểm",
  "env.site.searchLabel": "Tên điểm quan trắc",
  "env.site.searchPlaceholder": "vd: Sông Ciliwung - Manggarai",
  "env.site.searchTab": "Tìm điểm quan trắc",
  "env.site.streetAddress": "Địa chỉ",
  "env.site.streetAddress.placeholder": "Địa chỉ đường phố hoặc mốc vị trí",
  "env.site.subtype": "Phân loại con",
  "env.site.subtype.placeholder": "vd: Sông, Giếng, BG-Sentinel, Trạm cố định",
  "env.site.type": "Loại điểm quan trắc",
  "env.site.type.select": "Chọn loại...",
  "env.site.zone": "Vùng môi trường",
  "env.site.zone.select": "Chọn vùng...",
  "error.dateRange.start": "Vui lòng chọn ngày bắt đầu và ngày kết thúc.",
  "error.loading.metrics": "Lỗi tải chỉ số",
  "error.nonconform.report.data.found": "Không có dữ liệu",
  "error.report.csv.dateType": "Vui lòng chọn loại ngày.",
  "error.required.fields": "Vui lòng điền đầy đủ các trường bắt buộc",
  "error.save.sample": "Lỗi lưu mẫu",
  "error.validation.failed": "Kiểm tra dữ liệu thất bại",
  "error.value": "Vui lòng chọn một giá trị.",
  "esig.context.saveResults": "Lưu {count} kết quả cho mã mẫu {accession}",
  "esig.context.saveResultsMulti": "Lưu {count} kết quả trên {accessionCount} mã mẫu",
  "esig.context.validateResults": "Duyệt {count} kết quả cho mã mẫu {accession}",
  "esig.context.validateResultsMulti": "Duyệt {count} kết quả trên {accessionCount} mã mẫu",
  "fhir.questionnaire.title": "Thông tin bổ sung",
  "genericSample.default.fields.title": "Thông tin mẫu",
  "genericSample.import.success": "Nhập thành công",
  "genericSample.notebook.label": "Chọn sổ ghi chép",
  "genericSample.order.newOrder": "Tạo mẫu khác",
  "genericSample.search.title": "Tìm theo mã mẫu",
  "http.success": "Thành công!",
  "label.button.assign": "Gán",
  "label.button.create": "Tạo",
  "label.button.saving": "Đang lưu...",
  "label.button.view": "Xem phiếu kết quả",
  "label.code": "Mã",
  "label.editing": "Đang sửa",
  "label.label": "Nhãn",
  "label.name": "Tên",
  "label.panel": "Bộ xét nghiệm",
  "label.tests": "xét nghiệm",
  "loading.label": "Đang tải...",
  "loading.metrics": "Đang tải chỉ số...",
  "locale.save.error": "Lưu ngôn ngữ thất bại",
  "logging.management.tail.clear": "Xóa",
  "logging.management.tail.disconnected": "Mất kết nối luồng. Tắt rồi bật lại để kết nối lại.",
  "logging.management.tail.label": "Nhật ký ứng dụng trực tiếp",
  "logging.management.tail.off": "Tắt",
  "logging.management.tail.on": "Bật",
  "logging.management.tail.stream": "Luồng trực tiếp",
  "nationalID.title": "Số CCCD",
  "nce.button.linkSelected": "Liên kết mẫu đã chọn",
  "nce.button.submit": "Gửi NCE",
  "nce.error.numberGeneration": "Không tạo được số NCE. Vui lòng thử lại.",
  "nce.error.unknownOrder": "No order has the lab number {0}.",
  "nce.field.dateOfEvent": "Ngày xảy ra sự việc",
  "nce.field.description": "Mô tả",
  "nce.field.nceNumber": "Số NCE",
  "nce.field.proposedAction.helper": "Tách biệt với hành động CAPA được giao trong quy trình hành động khắc phục",
  "nce.field.proposedAction.placeholder": "Các bước tiếp theo được đề xuất...",
  "nce.field.reporterName": "Tên người báo cáo",
  "nce.field.reportingUnit": "Đơn vị báo cáo",
  "nce.field.subcategory": "Phân loại con",
  "nce.field.suspectedCauses.helper": "Chỉ là đánh giá ban đầu - nguyên nhân gốc chính thức sẽ được xác định trong quá trình điều tra",
  "nce.field.suspectedCauses.placeholder": "Người báo cáo",
  "nce.form.subtitle": "Ghi nhận sự kiện chất lượng và liên kết với các mẫu, kết quả bị ảnh hưởng",
  "nce.form.title": "Báo cáo sự kiện không phù hợp",
  "nce.linkSamples.helper": "Tìm các chỉ định ở trên để liên kết mẫu với NCE này. Bước này không bắt buộc.",
  "nce.section.attachments": "Tệp đính kèm",
  "nce.section.classification": "Phân loại",
  "nce.section.details": "Chi tiết",
  "nce.section.linkSamples": "Liên kết với mẫu / kết quả (không bắt buộc)",
  "nce.section.reporterContext": "Bối cảnh người báo cáo và sự kiện",
  "nce.select.subcategory": "Chọn phân loại con...",
  "nce.severity.critical.desc": "Rủi ro an toàn bệnh nhân, vi phạm quy định",
  "nce.severity.major.desc": "Ảnh hưởng đáng kể đến chất lượng hoặc vận hành",
  "nce.severity.minor.desc": "Ảnh hưởng hạn chế, dễ khắc phục",
  "nonconform.corrective.requiredFields": "Điền đầy đủ các trường hành động khắc phục (hành động, người phụ trách, ngày hoàn thành và ít nhất một loại hành động), hoặc để trống hoàn toàn dòng này.",
  "nonconform.view.requiredFields": "Bộ phận xét nghiệm, nhóm NCE, loại NCE, mức hậu quả và mức tái diễn đều là bắt buộc.",
  "notebook.sample.create": "Tạo",
  "notebook.sample.create.title": "Tạo mẫu mới",
  "notebook.sample.edit": "Sửa",
  "notebook.sample.edit.title": "Sửa mẫu",
  "notebook.sample.import": "Nhập",
  "notebook.sample.import.title": "Nhập mẫu",
  "notebook.sample.order.info": "Mẫu này sẽ được gắn với sổ ghi chép hiện tại.",
  "notebook.sample.order.title": "Tạo mẫu cho sổ ghi chép",
  "notification.warning": "Cảnh báo",
  "order.entry.setup.batch": "Nhập chỉ định hàng loạt",
  "order.legend.patient1": "Thông tin bệnh nhân",
  "pagination.next": "Trang sau",
  "pagination.previous": "Trang trước",
  "patient.fetch.error": "Không tải được bệnh nhân. Mã có thể không hợp lệ hoặc không kết nối được máy chủ.",
  "patient.firstName": "Tên (đệm + tên)",
  "patient.lastName": "Họ",
  "print.barcode.all": "In tất cả mã vạch ({count})",
  "sample.item.id": "Mã mục mẫu",
  "sample.label": "Mẫu",
  "sample.noPanels": "Không có bộ xét nghiệm cho loại mẫu này",
  "sample.noTests": "Không có xét nghiệm cho loại mẫu này",
  "sample.testsLoadFailed": "Không tải được xét nghiệm của loại mẫu này.",
  "sample.noTestsMatchSearch": "Không có xét nghiệm khớp với tìm kiếm",
  "sample.noPanelsMatchSearch": "Không có bộ xét nghiệm khớp với tìm kiếm",
  "sample.selectType.first": "Chọn loại mẫu ở trên để xem bộ xét nghiệm và xét nghiệm có sẵn",
  "sample.testsCount": "Có {count} xét nghiệm",
  "sample.types": "Mẫu",
  "sample.referral.listsFailed": "Không tải được lý do gửi hoặc danh sách phòng xét nghiệm. Mọi thông tin bạn nhập vẫn được giữ; nhấn Thử lại để gửi xét nghiệm.",
  "sample.tests.loadFailed": "Không tải được xét nghiệm của {sampleType}.",
  "sample.tests.loadFailed.hint": "Mọi thông tin bạn nhập vẫn được giữ. Kiểm tra kết nối hoặc đăng nhập lại, rồi nhấn Thử lại.",
  "sample.tests.loading": "Đang tải xét nghiệm…",
  "save.error.msg": "Lỗi khi lưu",
  "saving.label": "Đang lưu...",
  "select.label.analyzer": "Chọn máy xét nghiệm",
  "site.code": "Mã",
  "steps.complete": "bước",
  "storage.audit.empty": "Chưa ghi nhận lần di chuyển nào cho mẫu này.",
  "storage.audit.empty.title": "Chưa có di chuyển",
  "storage.audit.fetch.error": "Không tải được nhật ký truy vết.",
  "storage.audit.fetch.error.title": "Lỗi",
  "storage.audit.from": "Từ",
  "storage.audit.movedBy": "Người chuyển",
  "storage.audit.movementDate": "Ngày chuyển",
  "storage.audit.reason": "Lý do",
  "storage.audit.to": "Đến",
  "storage.box.code.helper": "Tối đa 10 ký tự",
  "storage.confirm.disposal": "Xác nhận tiêu hủy",
  "storage.dashboard.title": "Lưu trữ",
  "storage.disposal.method": "Phương thức tiêu hủy",
  "storage.disposal.method.placeholder": "Chọn phương thức...",
  "storage.disposal.notes": "Ghi chú thêm (không bắt buộc)",
  "storage.disposal.notes.placeholder": "Nhập ghi chú thêm...",
  "storage.disposal.reason": "Lý do tiêu hủy",
  "storage.disposal.reason.placeholder": "Chọn lý do...",
  "storage.dispose.confirmation": "Tôi xác nhận muốn tiêu hủy vĩnh viễn mẫu này. Hành động này không thể hoàn tác.",
  "storage.dispose.error": "Tiêu hủy thất bại",
  "storage.dispose.instructions.subtitle": "Vui lòng đảm bảo thực hiện đúng quy trình tiêu hủy theo quy định an toàn của phòng xét nghiệm.",
  "storage.dispose.instructions.title": "Hướng dẫn tiêu hủy",
  "storage.dispose.location.note": "Mẫu sẽ được gỡ khỏi vị trí này khi tiêu hủy",
  "storage.dispose.sample": "Tiêu hủy mẫu",
  "storage.dispose.sample.subtitle": "Tiêu hủy vĩnh viễn mẫu {sampleId}",
  "storage.dispose.warning.subtitle": "Mẫu sẽ được đánh dấu đã tiêu hủy và gỡ khỏi kho.",
  "storage.dispose.warning.title": "Hành động này không thể hoàn tác",
  "storage.edit.heading": "Sửa {type}",
  "storage.edit.title": "Sửa",
  "storage.editbox.heading": "Sửa hộp",
  "storage.error": "Lỗi",
  "storage.error.save": "Lưu vị trí thất bại",
  "storage.filter.select.location": "Chọn vị trí...",
  "storage.filter.selected": "Đã chọn:",
  "storage.location.assigned.error": "Gán vị trí thất bại",
  "storage.location.assigned.success": "Đã gán vị trí thành công",
  "storage.location.created": "Đã tạo {level}",
  "storage.location.deleted": "Đã xóa {level}",
  "storage.location.no.results": "Không tìm thấy vị trí",
  "storage.location.type.devices": "thiết bị",
  "storage.location.type.racks": "giá",
  "storage.location.type.rooms": "phòng",
  "storage.location.type.shelves": "kệ",
  "storage.location.updated": "Đã cập nhật {level}",
  "storage.manage.location": "Quản lý vị trí",
  "storage.nav.rack": "Giá",
  "storage.sample.actions": "Thao tác mẫu",
  "storage.sampleitem.accession": "Mã mẫu",
  "storage.sampleitem.location": "Vị trí lưu trữ",
  "storage.sampleitem.status": "Trạng thái",
  "storage.sampleitem.type": "Loại",
  "storage.search.location.label": "Tìm vị trí lưu trữ",
  "storage.search.location.placeholder": "Nhập từ 2 ký tự trở lên để tìm…",
  "storage.skipRemaining": "Bỏ qua lưu trữ cho mẫu chưa gán ({count}) - sẽ xử lý ngay",
  "storage.view.audit": "Xem nhật ký",
  "storage.view.audit.subtitle": "Lịch sử di chuyển của mẫu {sampleId}",
  "storage.view.audit.title": "Nhật ký truy vết lưu trữ",
  "systemDefaultPayloadTemplate.messageTemplate": "Mẫu nội dung",
  "systemDefaultPayloadTemplate.subjectTemplate": "Mẫu tiêu đề",
  "tests.count": "{count, plural, other {xét nghiệm}}",
  "validation.invalid.ip": "Định dạng địa chỉ IP không hợp lệ (IPv4 hoặc IPv6)",
  "validation.invalid.port": "Cổng phải nằm trong khoảng từ 1 đến 65535",
  "validation.required": "Trường này là bắt buộc",
  "common.accept": "Chấp nhận",
  "common.accessionNumber": "Mã mẫu (SID)",
  "common.action": "Thao tác",
  "common.actions": "Thao tác",
  "common.active": "Đang hoạt động",
  "common.addTests": "Thêm xét nghiệm",
  "common.aliquots": "phần chia",
  "common.all": "Tất cả",
  "common.allStatuses": "Mọi trạng thái",
  "common.analyzer": "Máy xét nghiệm",
  "common.analyzers": "Máy xét nghiệm",
  "common.auditTrail": "Nhật ký truy vết",
  "common.back": "Quay về",
  "common.boxId": "Mã hộp",
  "common.byUnit": "Theo đơn vị",
  "common.cancel": "Hủy",
  "common.category": "Phân loại",
  "common.clinical": "Lâm sàng",
  "common.code": "Mã",
  "common.collected": "Đã lấy",
  "common.collectionDate": "Ngày lấy mẫu",
  "common.complete": "Đủ kết quả",
  "common.completed": "Đã hoàn thành",
  "common.confirm": "Xác nhận",
  "common.correctiveActions": "Hành động khắc phục",
  "common.createAliquot": "Tạo phần chia",
  "common.critical": "Nguy kịch",
  "common.dashboard": "Bàn làm việc",
  "common.date": "Ngày",
  "common.dateRange": "Khoảng thời gian",
  "common.deactivate": "Ngừng dùng",
  "common.delete": "Xóa",
  "common.description": "Mô tả",
  "common.draft": "Bản nháp",
  "common.edit": "Sửa",
  "common.editOrder": "Sửa chỉ định",
  "common.email": "Email",
  "common.enterResults": "Nhập kết quả",
  "common.error": "Lỗi",
  "common.expired": "Hết hạn",
  "common.exportPdf": "Xuất PDF",
  "common.failed": "Thất bại",
  "common.filterByStatus": "Lọc theo trạng thái",
  "common.firstName": "Tên (đệm + tên)",
  "common.from": "Từ",
  "common.generateReport": "Tạo báo cáo",
  "common.home": "Bàn làm việc",
  "common.inProgress": "Đang làm",
  "common.inactive": "Không dùng",
  "common.labNumber": "Mã mẫu (SID)",
  "common.lastName": "Họ",
  "common.loading": "Đang tải...",
  "common.location": "Vị trí",
  "common.mean": "Trung bình",
  "common.name": "Tên",
  "common.nationalId": "Số CCCD",
  "common.new": "Mới",
  "common.none": "Không có",
  "common.normal": "Bình thường",
  "common.normalRange": "CSBT",
  "common.notCompleted": "Chưa hoàn thành",
  "common.notes": "Ghi chú",
  "common.order": "Chỉ định",
  "common.overdue": "Quá hạn",
  "common.panels": "Bộ xét nghiệm",
  "common.participants": "Người tham gia",
  "common.patient": "Bệnh nhân",
  "common.pending": "Chờ",
  "common.position": "Vị trí",
  "common.printLabel": "In nhãn",
  "common.priority": "Ưu tiên",
  "common.program": "Chương trình",
  "common.programName": "Tên chương trình",
  "common.provider": "Bác sĩ chỉ định",
  "common.quantity": "Số lượng",
  "common.reason": "Lý do",
  "common.received": "Đã nhận",
  "common.referenceLab": "Phòng xét nghiệm tham chiếu",
  "common.reject": "Từ chối",
  "common.remove": "Gỡ",
  "common.removeSelection": "Gỡ {name}",
  "common.reports": "Báo cáo",
  "common.requester": "Người chỉ định",
  "common.result": "Kết quả",
  "common.results": "Kết quả",
  "common.room": "Phòng",
  "common.routine": "Thường quy",
  "common.sample": "Mẫu",
  "common.sampleId": "Mã mẫu",
  "common.sampleManagement": "Quản lý mẫu",
  "common.sampleType": "Loại mẫu",
  "common.samples": "Mẫu",
  "common.samplingSite": "Điểm lấy mẫu",
  "common.save": "Lưu",
  "common.saveFailed": "Lưu thất bại",
  "common.saving": "Đang lưu...",
  "common.search": "Tìm",
  "common.select": "Chọn",
  "common.severity": "Mức độ nghiêm trọng",
  "common.siteName": "Tên điểm",
  "common.species": "Loài",
  "common.standard": "Tiêu chuẩn",
  "common.status": "Trạng thái",
  "common.storageLocation": "Vị trí lưu trữ",
  "common.study": "Nghiên cứu",
  "common.test": "Xét nghiệm",
  "common.testName": "Tên xét nghiệm",
  "common.tests": "Xét nghiệm",
  "common.type": "Loại",
  "common.unit": "Đơn vị",
  "common.user": "Người dùng",
  "common.value": "Giá trị",
  "common.view": "Xem",
  "common.warning": "Cảnh báo",
  "label.testCatalog.alerts.field.component": "Thành phần kết quả",
  "label.testCatalog.alerts.field.componentHelp": "Kết quả nào được cảnh báo này theo dõi. Để trống để theo dõi mọi thành phần của xét nghiệm này.",
  "label.testCatalog.alerts.field.sampleType": "Loại mẫu",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Loại bệnh phẩm nào được cảnh báo này theo dõi. Để trống để theo dõi mọi loại mẫu mà xét nghiệm này được chạy trên.",
  "label.testCatalog.alerts.scope.anyComponent": "Mọi thành phần",
  "label.testCatalog.alerts.scope.anySampleType": "Mọi loại mẫu",
  "label.testCatalog.alerts.col.scope": "Áp dụng cho",
  "label.testCatalog.alerts.scope.wholeTest": "Toàn bộ xét nghiệm",
  "microbiology.ast.breakpointStandard": "Tiêu chuẩn điểm cắt",
  "microbiology.ast.hint": "Ghi nhận số đọc MIC hoặc đường kính vòng ức chế, xem lại diễn giải và ghi chú ghi đè ngay tại chỗ.",
  "microbiology.ast.noOverride": "Không ghi đè",
  "microbiology.ast.reading": "Kết quả AST",
  "microbiology.case.isolates.hint": "Thêm và định danh các mọc có ý nghĩa lâm sàng trước khi làm AST.",
  "microbiology.isolate.contaminant": "Tạp nhiễm",
  "microbiology.isolate.edit": "Sửa chủng phân lập",
  "microbiology.isolate.identificationStatus": "Trạng thái định danh",
  "microbiology.isolate.normalFlora": "Hệ vi khuẩn thường trú",
  "microbiology.isolate.organism": "Vi sinh vật",
  "microbiology.isolate.organism.freeText": "Nhập vi sinh vật dạng tự do",
  "microbiology.isolate.significant": "Có ý nghĩa lâm sàng",
  "microbiology.isolate.unknown": "Chưa rõ",
  "microbiology.isolate.update": "Lưu định danh",
  "microbiology.enum.AST_REVIEW_REQUIRED": "Cần xem lại AST",
  "microbiology.enum.AWAITING_RESULTS": "Đang chờ kết quả",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "Cần ánh xạ kháng sinh",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "Cần hoàn tất ca",
  "microbiology.enum.AMENDED": "Đã hiệu chỉnh",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "Thao tác hiệu chỉnh thất bại",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "Đã đổi quy trình nuôi cấy",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "Đã mở hiệu chỉnh",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "Tải lịch sử hiệu chỉnh thất bại",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "Đang hiệu chỉnh",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "Cần chạy AST mới để hiệu chỉnh",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "Chưa mở hiệu chỉnh",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "Cần nhập lý do hiệu chỉnh",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "Hiệu chỉnh cần phát hành bản chính thức",
  "microbiology.enum.ACKNOWLEDGED": "Đã xác nhận",
  "microbiology.enum.AMENDMENT_CANCELLED": "Đã hủy hiệu chỉnh",
  "microbiology.enum.AMENDMENT_OPENED": "Đã mở hiệu chỉnh",
  "microbiology.enum.AMENDMENT_RELEASED": "Đã phát hành hiệu chỉnh",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "Nguồn AST hiệu chỉnh phải được phép báo cáo",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "Đã xác nhận cờ máy xét nghiệm",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "Máy xét nghiệm không đạt QC",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "Đã nhận kết quả máy xét nghiệm",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "Cần nhập lý do lần AST",
  "microbiology.enum.AST_ENTRY": "Nhập AST",
  "microbiology.enum.AST_IN_PROGRESS": "AST đang chạy",
  "microbiology.enum.AST_READY": "AST sẵn sàng",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "Cần làm lại hoặc kiểm tra lại",
  "microbiology.enum.AST_REVIEW": "Xem lại AST",
  "microbiology.enum.AST_REVIEWED": "Đã xem lại AST",
  "microbiology.enum.AST_READING_OVERRIDDEN": "Kết quả AST đã ghi đè",
  "microbiology.enum.AST_READING_RECORDED": "Đã ghi kết quả AST",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "Đã chọn AST được báo cáo",
  "microbiology.enum.AST_RUN_CREATED": "Đã tạo lần chạy AST",
  "microbiology.enum.AST_RUN_INVALIDATED": "Lần chạy AST đã bị vô hiệu",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "Phương pháp lần chạy AST không khớp",
  "microbiology.enum.AST_QC_OVERRIDDEN": "Đã ghi đè QC AST",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "Thiết lập AST không khả dụng",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "Lần chạy AST nguồn cần xem lại",
  "microbiology.enum.ANALYZER": "Máy xét nghiệm",
  "microbiology.enum.BROTH_MICRODILUTION": "Pha loãng vi lượng trong canh",
  "microbiology.enum.CASE": "Ca",
  "microbiology.enum.CASE_CREATED": "Đã tạo ca",
  "microbiology.enum.CASE_REVIEW": "Xem lại ca",
  "microbiology.enum.CANCELLED": "Đã hủy",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "Có ý nghĩa lâm sàng",
  "microbiology.enum.CLOSED": "Đã đóng",
  "microbiology.enum.CONFIRMED": "Đã xác nhận",
  "microbiology.enum.CONTAMINANT": "Tạp nhiễm",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "Đã xác nhận thông báo nguy kịch",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "Đã đóng thông báo nguy kịch",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "Đã ghi nhận thông báo nguy kịch",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "Cần theo dõi kết quả nguy kịch",
  "microbiology.enum.DISK_DIFFUSION": "Khuếch tán đĩa",
  "microbiology.enum.EMAIL": "Email",
  "microbiology.enum.EMERGENCY": "Cấp cứu",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "Thất bại",
  "microbiology.enum.FINAL": "Chính thức",
  "microbiology.enum.FINAL_REPORT_RELEASED": "Đã phát hành phiếu chính thức",
  "microbiology.enum.GROWTH_DETECTED": "Phát hiện mọc",
  "microbiology.enum.HIGH": "Cao",
  "microbiology.enum.IDENTIFICATION": "Định danh",
  "microbiology.enum.ICU": "ICU",
  "microbiology.enum.INCUBATING": "Đang ủ",
  "microbiology.enum.INPATIENT": "Nội trú",
  "microbiology.enum.IN_PROGRESS": "Đang làm",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "Trực tiếp",
  "microbiology.enum.INOCULATION_RECORDED": "Đã ghi nhận cấy",
  "microbiology.enum.ISOLATE": "Chủng phân lập",
  "microbiology.enum.ISOLATE_CREATED": "Đã tạo chủng phân lập",
  "microbiology.enum.ISOLATE_ID": "Mã chủng phân lập",
  "microbiology.enum.ISOLATE_REQUIRED": "Cần chủng phân lập",
  "microbiology.enum.ISOLATE_UPDATED": "Đã cập nhật chủng phân lập",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "Kỹ thuật MIC không xác định",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "Kỹ thuật vòng ức chế không xác định",
  "microbiology.enum.MANUAL_NOTE": "Ghi chú thủ công",
  "microbiology.enum.MANUAL_ENTRY": "Nhập thủ công",
  "microbiology.enum.MIC": "MIC",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "Không ghi được nhật ký cấy",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "Không ghi được nhật ký quy trình",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "Hãy chọn quy trình khác",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "Gán quy trình làm việc trước khi chọn giao thức",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "Nguồn cấy chuyển phải thuộc ca này",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "Không ghi được nhật ký quy trình làm việc",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "Xác nhận giữ lại công việc đang có",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "Cần phân loại quy trình làm việc",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "Phương pháp nuôi cấy không tương thích với quy trình",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "Quy trình không được hỗ trợ",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "Đã có ca cho quy trình này",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "Hãy chọn quy trình khác",
  "microbiology.enum.NO_GROWTH_READY": "Sẵn sàng báo không mọc",
  "microbiology.enum.NORMAL_FLORA": "Hệ vi khuẩn thường trú",
  "microbiology.enum.NEEDS_WORKFLOW": "Cần quy trình làm việc",
  "microbiology.enum.NOT_READY": "Chưa sẵn sàng",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "Đã báo cáo không phù hợp",
  "microbiology.enum.NONE": "Không có",
  "microbiology.enum.OPEN": "Đang mở",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "Cần ánh xạ vi sinh vật",
  "microbiology.enum.ORGANISM": "Vi sinh vật",
  "microbiology.enum.ORIGINAL": "Gốc",
  "microbiology.enum.OTHER": "Khác",
  "microbiology.enum.OUTPATIENT": "Ngoại trú",
  "microbiology.enum.PENDING": "Chờ",
  "microbiology.enum.PASSED": "Đạt",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "Điện thoại",
  "microbiology.enum.POSITIVE_SIGNAL": "Tín hiệu dương tính",
  "microbiology.enum.PRELIM_RELEASED": "Đã phát hành sơ bộ",
  "microbiology.enum.PRELIMINARY": "Sơ bộ",
  "microbiology.enum.PRELIMINARY_RELEASED": "Đã phát hành sơ bộ",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "Đã phát hành phiếu sơ bộ",
  "microbiology.enum.QC_FAILED": "QC không đạt",
  "microbiology.enum.RECEIVED": "Đã nhận",
  "microbiology.enum.RELEASED": "Đã phát hành",
  "microbiology.enum.REPEAT": "Làm lại",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "Cần lần chạy AST được báo cáo",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "Lần chạy AST được báo cáo phải được xem lại",
  "microbiology.enum.RESULT": "Kết quả",
  "microbiology.enum.RESULTS_IN": "Đã có kết quả",
  "microbiology.enum.RETEST": "Kiểm tra lại",
  "microbiology.enum.REVIEW_READY": "Sẵn sàng xem lại",
  "microbiology.enum.REVIEWED": "Đã xem lại",
  "microbiology.enum.INTERMEDIATE": "Trung gian",
  "microbiology.enum.LOST_SPECIMEN": "Mất bệnh phẩm",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "Mất bệnh phẩm - Cấy dương tính",
  "microbiology.enum.NO_BREAKPOINT": "Không có điểm cắt",
  "microbiology.enum.RESISTANT": "Kháng",
  "microbiology.enum.ROUTINE": "Thường quy",
  "microbiology.enum.SAMPLE_ITEM": "Mục mẫu",
  "microbiology.enum.SETUP": "Thiết lập",
  "microbiology.enum.SETUP_RECORDED": "Đã ghi nhận thiết lập",
  "microbiology.enum.SMS": "SMS",
  "microbiology.enum.SPECIMEN_LOST": "Mất bệnh phẩm",
  "microbiology.enum.STAGE_CHANGED": "Đã đổi giai đoạn",
  "microbiology.enum.SUBCULTURE_RECORDED": "Đã ghi nhận cấy chuyển",
  "microbiology.enum.UNASSIGNED": "Chưa gán",
  "microbiology.enum.UNKNOWN_ERROR": "Lỗi không xác định",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "Đã đổi quy trình làm việc",
  "microbiology.enum.ZONE": "Vòng ức chế",
  "microbiology.enum.FINAL_RELEASED": "Đã phát hành chính thức",
  "microbiology.enum.SUSCEPTIBLE": "Nhạy",
  "microbiology.enum.UNKNOWN": "Không rõ",
  "rulebuilder.label.selectComponent": "Chọn thành phần",
  "testcalculation.label.selectComponent": "Chọn thành phần",
  "testcalculation.label.finalComponent": "Thành phần kết quả",
  "qc.dashboard.tab.bench": "QC tại bàn",
  "qc.bench.source.all": "Mọi nguồn tại bàn",
  "qc.bench.source.manual": "Định lượng thủ công",
  "qc.bench.source.rdt": "Test nhanh (RDT)",
  "qc.bench.column.runs": "Số lần chạy mẫu chứng",
  "qc.bench.column.lastRun": "Lần chạy gần nhất",
  "qc.bench.empty": "Không ghi nhận mẫu chứng thủ công hoặc test nhanh nào trong giai đoạn này.",
  "microbiology.case.activityNote": "Ghi chú hoạt động",
  "microbiology.case.accessionNumber": "Mã mẫu (SID)",
  "microbiology.case.actionError": "Không thực hiện được thao tác nuôi cấy",
  "microbiology.case.action.markNoGrowth": "Đánh dấu sẵn sàng báo không mọc",
  "microbiology.case.action.recordGrowth": "Ghi nhận phát hiện mọc",
  "microbiology.case.action.rejectCase": "Từ chối ca",
  "microbiology.case.action.setIncubating": "Chuyển sang đang ủ",
  "microbiology.case.action.startInoculation": "Bắt đầu cấy",
  "microbiology.case.createIsolate": "Tạo chủng phân lập",
  "microbiology.case.cultureAction": "Thao tác nuôi cấy",
  "microbiology.case.atmosphere": "Khí quyển",
  "microbiology.case.eyebrow": "Bàn làm việc ca vi sinh",
  "microbiology.case.sectionExpanded": "Đã mở rộng {section}",
  "microbiology.case.sectionStatus": "Trạng thái mục",
  "microbiology.case.error": "Lỗi ca vi sinh",
  "microbiology.case.isolateLabel": "Nhãn chủng phân lập",
  "microbiology.case.isolates": "Chủng phân lập",
  "microbiology.case.isolates.empty": "Chưa ghi nhận chủng phân lập",
  "microbiology.case.loadError": "Không tải được ca vi sinh",
  "microbiology.case.lastActivityBy": "Hoạt động gần nhất bởi",
  "microbiology.case.incubation": "Ủ",
  "microbiology.case.media": "Môi trường hoặc chai",
  "microbiology.case.nextStage": "Giai đoạn tiếp theo",
  "microbiology.case.patient": "Bệnh nhân",
  "microbiology.case.nonconformanceCount": "{count, plural, other {# NCE}}",
  "microbiology.case.relatedWorkflows": "Quy trình bệnh phẩm liên quan",
  "microbiology.case.requestingLocation": "Nơi chỉ định",
  "microbiology.case.preliminaryOrganism": "Vi sinh vật sơ bộ",
  "microbiology.case.recordActivity": "Ghi nhận hoạt động",
  "microbiology.case.sampleItem": "Mục mẫu",
  "microbiology.case.setup": "Cấy",
  "microbiology.case.setup.hint": "Ghi nhận bước thiết lập ban đầu, môi trường hoặc ủ cho ca nuôi cấy này.",
  "microbiology.case.significance": "Ý nghĩa",
  "microbiology.case.specimenType": "Loại bệnh phẩm",
  "microbiology.case.timeline": "Diễn tiến ca",
  "microbiology.case.timeline.addNote": "Thêm ghi chú",
  "microbiology.case.timeline.auto": "Tự động",
  "microbiology.case.timeline.culturePurposeChange": "{from} thành {to}",
  "microbiology.case.timeline.culturePurposeChanged": "Đã đổi mục đích nuôi cấy",
  "microbiology.case.timeline.empty": "Chưa ghi nhận hoạt động của ca",
  "microbiology.case.timeline.hint": "Các hoạt động đã ghi nhận của ca được hiển thị theo thứ tự thời gian.",
  "microbiology.case.timeline.manual": "Thủ công",
  "microbiology.case.timeline.note": "Ghi chú hoặc quan sát",
  "microbiology.case.timeline.noteExpanded": "Đã mở biểu mẫu ghi chú",
  "microbiology.case.timeline.performedBy": "Thực hiện bởi {actor}",
  "microbiology.case.timeline.saveNote": "Lưu ghi chú",
  "microbiology.case.timeline.showAll": "Hiển thị tất cả {count} sự kiện",
  "microbiology.case.timeline.showRecent": "Hiển thị {count} sự kiện gần đây",
  "microbiology.case.events": "sự kiện",
  "microbiology.case.finalLocked.message": "Thay đổi chủng phân lập và AST bị khóa sau khi phát hành chính thức.",
  "microbiology.case.finalLocked.title": "Ca chính thức chỉ đọc",
  "microbiology.case.title": "Ca vi sinh",
  "microbiology.inoculation.addSubculture": "Thêm cấy chuyển",
  "microbiology.inoculation.empty": "Chưa ghi nhận môi trường nào. Bắt đầu cấy để tiếp tục.",
  "microbiology.inoculation.hint": "Ghi nhận từng chai hoặc đĩa và giữ dòng nuôi cấy của chúng.",
  "microbiology.inoculation.identifier": "Mã chai hoặc đĩa",
  "microbiology.inoculation.identifierHint": "Quét hoặc gõ mã.",
  "microbiology.inoculation.parent": "Môi trường gốc",
  "microbiology.inoculation.parentPlaceholder": "Chọn chai hoặc đĩa nguồn",
  "microbiology.inoculation.primaryExpanded": "Đã mở biểu mẫu cấy",
  "microbiology.inoculation.primary": "Cấy ban đầu",
  "microbiology.inoculation.recorded": "Môi trường đã ghi nhận",
  "microbiology.inoculation.save": "Lưu môi trường",
  "microbiology.inoculation.source": "Nguồn",
  "microbiology.inoculation.start": "Bắt đầu cấy",
  "microbiology.inoculation.subcultureExpanded": "Đã mở biểu mẫu cấy chuyển",
  "microbiology.inoculation.subculture": "Cấy chuyển",
  "microbiology.amendment.actionError": "Không thực hiện được thao tác hiệu chỉnh",
  "microbiology.amendment.cancel": "Hủy hiệu chỉnh",
  "microbiology.amendment.cancelReason": "Lý do hủy",
  "microbiology.amendment.cancelled": "Đã hủy hiệu chỉnh; ca chính thức được khóa lại",
  "microbiology.amendment.correctsVersion": "Sửa phiên bản {number}",
  "microbiology.amendment.hint": "Hiệu chỉnh phiếu chính thức mà không thay thế lịch sử đã phát hành.",
  "microbiology.amendment.history": "Lịch sử hiệu chỉnh",
  "microbiology.amendment.inProgress.message": "Ghi nhận phần sửa và phát hành hoặc hủy hiệu chỉnh này để khóa lại ca.",
  "microbiology.amendment.inProgress.title": "Đang hiệu chỉnh",
  "microbiology.amendment.noReportVersions": "Chưa ghi nhận phiên bản phiếu chính thức",
  "microbiology.amendment.none": "Chưa ghi nhận hiệu chỉnh",
  "microbiology.amendment.number": "Hiệu chỉnh",
  "microbiology.amendment.numberValue": "Hiệu chỉnh {number}",
  "microbiology.amendment.open": "Mở hiệu chỉnh",
  "microbiology.amendment.opened": "Đã mở hiệu chỉnh; có thể sửa thông tin lâm sàng",
  "microbiology.amendment.reason": "Lý do hiệu chỉnh",
  "microbiology.amendment.release": "Phát hành phiếu đã hiệu chỉnh",
  "microbiology.amendment.released": "Đã phát hành phiếu hiệu chỉnh; ca được khóa lại",
  "microbiology.amendment.reportVersions": "Các phiên bản phiếu đã phát hành",
  "microbiology.amendment.status": "Trạng thái",
  "microbiology.amendment.status.closed": "Không có hiệu chỉnh đang mở",
  "microbiology.amendment.status.open": "Đang mở hiệu chỉnh",
  "microbiology.amendment.title": "Hiệu chỉnh",
  "microbiology.amendment.version": "Phiên bản {number}",
  "microbiology.ast.antibiotic": "Kháng sinh",
  "microbiology.ast.acceptResults": "Chấp nhận kết quả",
  "microbiology.ast.acknowledgeFlags": "Xác nhận các cờ đã xem",
  "microbiology.ast.analyzer": "Máy xét nghiệm",
  "microbiology.ast.analyzerOrganism": "Vi sinh vật từ máy: {organism} ({confidence}%)",
  "microbiology.ast.analyzerProvenance": "Thẻ hoặc khay {card} · phần mềm {version}",
  "microbiology.ast.analyzerResolutionReason": "Lý do và hành động khắc phục",
  "microbiology.ast.actionError": "Không thực hiện được thao tác AST",
  "microbiology.ast.adjustPanel": "Điều chỉnh bộ kháng sinh",
  "microbiology.ast.orderedAntibiotics": "Kháng sinh cần làm",
  "microbiology.ast.actions": "Thao tác",
  "microbiology.ast.applyOverride": "Áp dụng ghi đè",
  "microbiology.ast.attempt": "Lần thực hiện",
  "microbiology.ast.attemptMethod": "Phương pháp lần thực hiện",
  "microbiology.ast.attemptNumber": "Lần {number}",
  "microbiology.ast.attemptReason": "Lý do",
  "microbiology.ast.attemptScope": "Phạm vi làm lại",
  "microbiology.ast.attempts": "Các lần AST",
  "microbiology.ast.attemptType": "Loại lần thực hiện",
  "microbiology.ast.awaitingAnalyzerResults": "Đang chờ kết quả máy xét nghiệm",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "Kết quả sẽ tự hiện khi máy đã kết nối gửi về. Sự kiện không khớp được giữ trong mục Lỗi nhập từ máy xét nghiệm.",
  "microbiology.ast.awaitingSetupCount": "{count} đang chờ thiết lập",
  "microbiology.ast.cardId": "Mã thẻ hoặc khay",
  "microbiology.ast.entryMode": "Cách nhập kết quả",
  "microbiology.ast.entryMode.analyzer": "Máy xét nghiệm đã kết nối",
  "microbiology.ast.entryMode.manual": "Nhập thủ công",
  "microbiology.ast.expertFlags": "Cờ chuyên gia của máy cần xem lại",
  "microbiology.ast.hideOriginal": "Ẩn lịch sử",
  "microbiology.ast.historyTo": "đến",
  "microbiology.ast.interpretation": "Diễn giải",
  "microbiology.ast.instrumentInterpretation": "Máy: {interpretation}",
  "microbiology.ast.invalidateAndRepeat": "Vô hiệu và bắt đầu lần chạy mới",
  "microbiology.ast.includedInReport": "Có trong phiếu",
  "microbiology.ast.initialAttemptReason": "Lần đầu",
  "microbiology.ast.isolate": "Chủng phân lập",
  "microbiology.ast.method": "Phương pháp",
  "microbiology.ast.matchedBy": "Điểm cắt khớp theo",
  "microbiology.ast.measurement.mic": "MIC (ug/mL)",
  "microbiology.ast.measurement.zone": "Đường kính vòng ức chế (mm)",
  "microbiology.ast.noBreakpointGuidance": "Không có điểm cắt chuẩn. Diễn giải kết quả này theo SOP tại chỗ.",
  "microbiology.ast.noBreakpointTitle": "Cần diễn giải tại chỗ",
  "microbiology.ast.noIsolate": "Tạo chủng phân lập trước khi ghi AST",
  "microbiology.ast.noSourceAttempt": "Lần gốc",
  "microbiology.ast.notIncludedInReport": "Không đưa vào phiếu",
  "microbiology.ast.newAttempt": "Làm lại hoặc kiểm tra lại mới",
  "microbiology.ast.noRunsYet": "Chưa có lần chạy",
  "microbiology.ast.antibioticToRepeat": "Kháng sinh cần làm lại",
  "microbiology.ast.override": "Ghi đè diễn giải",
  "microbiology.ast.overrideHistory": "Lịch sử ghi đè",
  "microbiology.ast.optionsExpanded": "Đã mở rộng tùy chọn {section}.",
  "microbiology.ast.overrideReason": "Lý do ghi đè",
  "microbiology.ast.orderedPanel": "Bộ AST đã chỉ định",
  "microbiology.ast.organismMismatch": "Vi sinh vật từ máy khác với chủng phân lập của ca",
  "microbiology.ast.organismMismatchDetail": "Nhận dạng từ máy chỉ mang tính tham khảo. Hãy xem xét sự khác biệt; chủng phân lập đã xác nhận của ca vẫn có giá trị quyết định.",
  "microbiology.ast.overrideQc": "Ghi đè cờ QC",
  "microbiology.ast.panel": "Bộ AST",
  "microbiology.ast.panelAdjustmentReason": "Lý do điều chỉnh bộ",
  "microbiology.ast.panelProvenance.organismDefault": "Chỉ định từ mặc định đã cấu hình của vi sinh vật đã định danh",
  "microbiology.ast.rawValue": "Giá trị kết quả",
  "microbiology.ast.qcFailed": "Máy xét nghiệm không đạt QC",
  "microbiology.ast.qcFailedDetail": "Tham chiếu QC {reference}. Chấp nhận kết quả bị chặn cho đến khi lần chạy này được vô hiệu hoặc người giám sát ghi nhận ghi đè.",
  "microbiology.ast.replacementCardId": "Mã thẻ hoặc khay mới",
  "microbiology.ast.resultsReady": "Kết quả máy sẵn sàng để xem lại",
  "microbiology.ast.resultsReadyDetail": "Xem lại sai lệch, điểm cắt còn thiếu và cờ chuyên gia trước khi chấp nhận các kết quả này.",
  "microbiology.ast.runsComplete": "{complete} / {total} lần chạy hoàn tất",
  "microbiology.ast.pendingIdentificationCount": "{count} đang chờ định danh",
  "microbiology.ast.reasonForAttempt": "Lý do làm lại hoặc kiểm tra lại",
  "microbiology.ast.recordReading": "Ghi kết quả AST",
  "microbiology.ast.reviewRun": "Xem lại lần chạy AST",
  "microbiology.ast.repeat": "Làm lại",
  "microbiology.ast.revertOverride": "Khôi phục về gốc",
  "microbiology.ast.revertReason": "Lý do hoàn tác ghi đè",
  "microbiology.ast.reporting": "Báo cáo",
  "microbiology.ast.retest": "Kiểm tra lại",
  "microbiology.ast.selectAntibiotic": "Chọn kháng sinh",
  "microbiology.ast.singleAntibiotic": "Một kháng sinh",
  "microbiology.ast.wholePanel": "Toàn bộ bộ",
  "microbiology.ast.runStatus": "Trạng thái lần chạy AST",
  "microbiology.ast.startRun": "Bắt đầu lần chạy AST",
  "microbiology.ast.startAttempt": "Bắt đầu lần {type}",
  "microbiology.ast.sourceAttempt": "Nguồn",
  "microbiology.ast.source": "Nguồn kết quả",
  "microbiology.ast.showOriginal": "Hiện bản gốc",
  "microbiology.ast.title": "AST thủ công",
  "microbiology.ast.useAttemptForReporting": "Dùng lần {number} để báo cáo",
  "microbiology.ast.useForReporting": "Dùng để báo cáo",
  "microbiology.ast.view": "Xem",
  "microbiology.ast.viewAttempt": "Xem lần {number}",
  "microbiology.ast.viewing": "Đang xem",
  "microbiology.ast.viewingAttempt": "Đang xem lần {number}",
  "microbiology.critical.acknowledge": "Xác nhận",
  "microbiology.critical.followUp": "Cần theo dõi",
  "microbiology.critical.hint": "Ghi nhận các cuộc gọi báo kết quả nguy kịch và xác nhận ngay tại chỗ.",
  "microbiology.critical.log": "Ghi nhận thông báo",
  "microbiology.critical.logForIsolate": "Ghi nhận thông báo nguy kịch cho {isolate}",
  "microbiology.critical.logNotification": "Ghi nhận thông báo nguy kịch",
  "microbiology.critical.method": "Phương thức thông báo",
  "microbiology.critical.message": "Nội dung",
  "microbiology.critical.messageRequired": "Cần nhập nội dung",
  "microbiology.critical.none": "Chưa ghi nhận thông báo nguy kịch",
  "microbiology.critical.recipient": "Người nhận",
  "microbiology.critical.recipientContact": "Liên hệ người nhận",
  "microbiology.critical.required": "Chọn đối tượng và nhập người nhận cùng nội dung.",
  "microbiology.critical.resolution": "Ghi chú xử lý",
  "microbiology.critical.resolutionRequired": "Cần ghi chú xử lý trước khi đóng thông báo.",
  "microbiology.critical.close": "Đóng thông báo",
  "microbiology.critical.target": "Đối tượng kết quả nguy kịch",
  "microbiology.critical.targetId": "Bản ghi đích",
  "microbiology.critical.title": "Thông báo nguy kịch",
  "microbiology.caseInfo.no": "Không",
  "microbiology.caseInfo.notProvided": "Chưa cung cấp",
  "microbiology.caseInfo.summary": "Tóm tắt thông tin ca",
  "microbiology.caseInfo.yes": "Có",
  "microbiology.currentStep.open": "Mở {step}",
  "microbiology.currentStep.title": "Bước hiện tại",
  "microbiology.cultureAction.error": "Không cập nhật được trạng thái nuôi cấy.",
  "microbiology.cultureAction.noGrowth.confirm": "Xác nhận không mọc",
  "microbiology.cultureAction.noGrowth.detail": "Xác nhận đã hết thời gian ủ bắt buộc và không phát hiện mọc.",
  "microbiology.cultureAction.noGrowth.title": "Đánh dấu nuôi cấy không mọc",
  "microbiology.cultureAction.positive.confirm": "Xác nhận tín hiệu dương tính",
  "microbiology.cultureAction.positive.detail": "Xác nhận tín hiệu dương tính. Bước tiếp theo là cấy chuyển và ghi nhuộm Gram.",
  "microbiology.cultureAction.positive.title": "Đánh dấu nuôi cấy dương tính",
  "microbiology.nce.category": "Nhóm",
  "microbiology.nce.configurationBlockerTitle": "Cần cấu hình",
  "microbiology.nce.configurationLoadError": "Không tải được nhóm NCE và đơn vị báo cáo.",
  "microbiology.nce.critical": "Nghiêm trọng",
  "microbiology.nce.description": "Mô tả",
  "microbiology.nce.disposition": "Xử lý",
  "microbiology.nce.errorTitle": "Không báo cáo được sự không phù hợp",
  "microbiology.nce.flagOnly": "Chỉ đánh dấu",
  "microbiology.nce.immediateAction": "Hành động ngay",
  "microbiology.nce.lostTypeMissing": "Cấu hình NCE đang dùng không có loại Mất bệnh phẩm.",
  "microbiology.nce.major": "Lớn",
  "microbiology.nce.markLost": "Đánh dấu mất",
  "microbiology.nce.markLostHint": "Ghi nhận bệnh phẩm vật lý là đã mất và từ chối các xét nghiệm đang mở bị ảnh hưởng.",
  "microbiology.nce.markLostTitle": "Đánh dấu mất bệnh phẩm",
  "microbiology.nce.minor": "Nhỏ",
  "microbiology.nce.rejectTests": "Từ chối các xét nghiệm bị ảnh hưởng",
  "microbiology.nce.retest": "Kiểm tra lại AST",
  "microbiology.nce.retestLoadError": "Không tải được các lần chạy AST đã xem lại. Thử lại trước khi chọn Kiểm tra lại AST.",
  "microbiology.nce.sourceAstRun": "Lần chạy AST cần kiểm tra lại",
  "microbiology.nce.report": "Báo cáo NCE",
  "microbiology.nce.reportHint": "Ghi nhận sự không phù hợp cho bệnh phẩm này và chọn cách xử lý.",
  "microbiology.nce.reportingUnit": "Đơn vị báo cáo",
  "microbiology.nce.reportTitle": "Báo cáo sự không phù hợp",
  "microbiology.nce.required": "Chọn nhóm, đơn vị báo cáo và mức độ, đồng thời nhập mô tả.",
  "microbiology.nce.sectionTitle": "Không phù hợp",
  "microbiology.nce.severity": "Mức độ",
  "microbiology.nce.submitError": "Không lưu được sự không phù hợp.",
  "microbiology.nce.title": "Tiêu đề",
  "microbiology.nce.type": "Loại",
  "microbiology.isolate.identify": "Định danh vi sinh vật",
  "microbiology.isolate.reidentify": "Định danh lại",
  "microbiology.isolate.identified": "Đã định danh",
  "microbiology.isolate.pending": "Chờ định danh",
  "microbiology.isolate.gramStain": "Nhuộm Gram",
  "microbiology.isolate.colonyMorphology": "Hình thái khuẩn lạc",
  "microbiology.isolate.identification": "Định danh",
  "microbiology.isolate.identificationMethod": "Phương pháp định danh",
  "microbiology.isolate.identificationConfidence": "Độ tin cậy định danh (%)",
  "microbiology.isolate.identificationChange": "{previous} thành {next}: {reason}",
  "microbiology.isolate.identificationHistory": "Lịch sử định danh",
  "microbiology.isolate.identificationReason": "Lý do định danh lại",
  "microbiology.isolate.organism.select": "Chọn vi sinh vật",
  "microbiology.isolate.unidentified": "Chưa định danh",
  "microbiology.ast.identificationRequired": "Định danh chủng phân lập trước khi thiết lập AST.",
  "microbiology.next.createIsolate": "Đã ghi nhận cấy. Thêm mọc có ý nghĩa hoặc đánh dấu ca sẵn sàng xử lý không mọc.",
  "microbiology.next.completeAmendment": "Đang mở hiệu chỉnh. Ghi nhận phần sửa, xem lại phiếu, rồi phát hành phiên bản đã hiệu chỉnh.",
  "microbiology.next.finalReleased": "Đã phát hành phiếu chính thức. Xem lại mức sẵn sàng giám sát trước khi xuất.",
  "microbiology.next.incubating": "Đang ủ. Đánh dấu ca dương tính khi có tín hiệu mọc, hoặc đánh dấu không mọc khi đã hết thời gian ủ bắt buộc.",
  "microbiology.next.subculturePositive": "Đã ghi nhận tín hiệu dương tính. Cấy chuyển chai và ghi nhuộm Gram.",
  "microbiology.next.recordSetup": "Đã nhận ca. Ghi nhận thiết lập ban đầu để bắt đầu ủ.",
  "microbiology.next.release": "Đã xem lại AST. Xác nhận sẵn sàng phiếu và phát hành phiếu chính thức.",
  "microbiology.next.noGrowthRelease": "Đã ghi nhận không mọc. Xem lại và phát hành phiếu âm tính chính thức.",
  "microbiology.next.reviewAst": "Đã ghi nhận chủng phân lập. Hoàn tất và xem lại AST trước khi phát hành.",
  "microbiology.next.title": "Bước tiếp theo",
  "microbiology.navigation.backToWorklist": "Quay về danh sách công việc vi sinh",
  "microbiology.navigation.menu": "Vi sinh",
  "microbiology.navigation.worklist": "Danh sách công việc vi sinh",
  "order.context.workflowProgress": "Tiến độ quy trình chỉ định",
  "microbiology.culturePurpose.clinical": "Chẩn đoán hoặc điều trị lâm sàng",
  "microbiology.culturePurpose.label": "Mục đích nuôi cấy",
  "microbiology.culturePurpose.screening": "Sàng lọc chủ động hoặc mang trùng",
  "microbiology.culturePurpose.unspecified": "Không xác định",
  "microbiology.orderDetail.antibioticExposure": "Bệnh nhân có phơi nhiễm kháng sinh gần đây (trong 2 tuần)",
  "microbiology.orderDetail.admissionDate": "Ngày nhập viện",
  "microbiology.orderDetail.admissionDateFuture": "Ngày nhập viện không thể ở tương lai.",
  "microbiology.orderDetail.admissionDateHelper": "Ngày nhập viện nội trú. Để trống nếu không biết.",
  "microbiology.orderDetail.admissionDateOutpatient": "Bệnh nhân ngoại trú không nhập viện - ghi nhận là nguồn cộng đồng.",
  "microbiology.orderDetail.collectionDateContext": "Ngày lấy mẫu: {date}",
  "microbiology.orderDetail.collectionTimingHospital": "Lấy mẫu sau nhập viện {days} ngày - nguồn bệnh viện để giám sát.",
  "microbiology.orderDetail.collectionTimingCommunity": "Lấy mẫu sau nhập viện {days} ngày - nguồn cộng đồng để giám sát.",
  "microbiology.orderDetail.clinicalHistory": "Tiền sử lâm sàng",
  "microbiology.orderDetail.cultureMethod": "Quy trình nuôi cấy",
  "microbiology.orderDetail.hint": "Ghi nhận bối cảnh chỉ định mà phòng xét nghiệm cần để thiết lập nuôi cấy và theo dõi kết quả nguy kịch.",
  "microbiology.orderDetail.numberOfSets": "Số bộ mẫu",
  "microbiology.orderDetail.numberOfSets.helper": "Nhóm lấy mẫu, ví dụ hai bộ cấy máu lấy từ các vị trí khác nhau. Không phải số lượng hay thể tích bệnh phẩm.",
  "microbiology.orderDetail.patientOrigin": "Nguồn bệnh nhân",
  "microbiology.orderDetail.protocolDerived": "Suy ra",
  "microbiology.orderDetail.protocolHelper": "Từ xét nghiệm đã chỉ định. Đổi tại bàn nếu quy trình xử lý khác.",
  "microbiology.orderDetail.protocolUnset": "Chưa đặt - bàn xét nghiệm sẽ chọn quy trình",
  "microbiology.orderDetail.protocolUnsetTitle": "Chưa đặt quy trình",
  "microbiology.orderDetail.save": "Lưu chi tiết chỉ định",
  "microbiology.orderDetail.title": "Chi tiết chỉ định",
  "microbiology.patientOrigin.emergency": "Khoa cấp cứu",
  "microbiology.patientOrigin.icu": "Hồi sức tích cực",
  "microbiology.patientOrigin.inpatient": "Khoa nội trú",
  "microbiology.patientOrigin.other": "Khác",
  "microbiology.patientOrigin.outpatient": "Phòng khám ngoại trú",
  "microbiology.progress.ast": "Kết quả AST",
  "microbiology.progress.caseInfo": "Thông tin ca",
  "microbiology.progress.inoculation": "Cấy",
  "microbiology.progress.isolates": "Chủng phân lập",
  "microbiology.progress.reports": "Phiếu kết quả",
  "microbiology.progress.review": "Xem lại chuyên gia",
  "microbiology.progress.timeline": "Diễn tiến",
  "microbiology.progress.title": "Tiến độ ca",
  "microbiology.protocol.noneTitle": "Chưa đặt quy trình",
  "microbiology.case.timeline.protocolChanged": "Đã đổi quy trình nuôi cấy từ {from} thành {to}: {reason}",
  "microbiology.readiness.blocked": "Phát hành chính thức bị chặn",
  "microbiology.readiness.ready": "Sẵn sàng phát hành chính thức",
  "microbiology.reagentLots.blocked": "Bị chặn: {reason}",
  "microbiology.reagentLots.context": "Bối cảnh tại bàn",
  "microbiology.reagentLots.context.AST_SETUP": "Thiết lập AST",
  "microbiology.reagentLots.context.CULTURE_SETUP": "Thiết lập nuôi cấy",
  "microbiology.reagentLots.empty": "Chưa có hóa chất nào được liên kết với xét nghiệm này.",
  "microbiology.reagentLots.fefo": "FEFO - dùng trước",
  "microbiology.reagentLots.fifo.tooltip": "Lô được sắp theo hạn dùng sớm nhất, sau đó theo ngày nhận khi không có hạn dùng.",
  "microbiology.reagentLots.hint": "Chọn đúng lô đã dùng cho từng hóa chất hoặc vật tư tiêu hao được liên kết.",
  "microbiology.reagentLots.history": "Lịch sử sử dụng lô đã ghi",
  "microbiology.reagentLots.legend": "Các lô sẵn có cho {reagent}",
  "microbiology.reagentLots.lot": "Lô",
  "microbiology.reagentLots.noExpiry": "Chưa ghi hạn dùng",
  "microbiology.reagentLots.noLots": "Không có lô tồn kho nào cho hóa chất này.",
  "microbiology.reagentLots.option": "{lot}, còn {quantity} {unit}, hết hạn {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "Số lượng mỗi xét nghiệm: {quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "{reagent} lô {lot} đã hết hạn; hãy chọn lô khác.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "{reagent} lô {lot} không còn đủ số lượng; hãy chọn lô khác.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "{reagent} lô {lot} không đạt QC; hãy chọn lô đã đạt QC.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "{reagent} lô {lot} chưa đạt QC; hãy chọn lô đã đạt QC.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "{reagent} lô {lot} không còn sẵn dùng; hãy làm mới và chọn lô khác.",
  "microbiology.reagentLots.qc.FAILED": "QC không đạt",
  "microbiology.reagentLots.qc.PASSED": "QC đạt",
  "microbiology.reagentLots.qc.PENDING": "Chờ QC",
  "microbiology.reagentLots.qc.QUARANTINED": "QC đang cách ly",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "Đã dùng hết",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "Hết hạn",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "Không dùng",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "Không đủ số lượng",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "QC không đạt",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "Chưa đạt QC",
  "microbiology.reagentLots.reagent": "Hóa chất hoặc vật tư tiêu hao",
  "microbiology.reagentLots.recorded": "Đã ghi nhận",
  "microbiology.reagentLots.role.PRIMARY": "Chính",
  "microbiology.reagentLots.role.SECONDARY": "Phụ",
  "microbiology.reagentLots.scan.ambiguous": "Số lô này khớp với nhiều hóa chất được liên kết. Hãy chọn lô trong danh sách hóa chất tương ứng.",
  "microbiology.reagentLots.scan.label": "Quét hoặc nhập số lô",
  "microbiology.reagentLots.scan.notFound": "Không có lô liên kết nào khớp với số lô này.",
  "microbiology.reagentLots.scan.placeholder": "Quét hoặc nhập đúng số lô",
  "microbiology.reagentLots.scan.selected": "Đã chọn lô {lot}.",
  "microbiology.reagentLots.status": "Trạng thái lô hiện tại",
  "microbiology.reagentLots.status.ACTIVE": "Đang dùng",
  "microbiology.reagentLots.status.CONSUMED": "Đã dùng hết",
  "microbiology.reagentLots.status.IN_USE": "Đang sử dụng",
  "microbiology.reagentLots.title": "Truy vết hóa chất và lô",
  "microbiology.reagentLots.used": "Số lượng đã dùng",
  "microbiology.release.failed": "Không phát hành được phiếu. Xem lại các yêu cầu và thử lại.",
  "microbiology.release.final": "Phát hành phiếu chính thức",
  "microbiology.release.finalReleased": "Đã phát hành phiếu chính thức",
  "microbiology.release.hint": "Chỉ phát hành phiếu khi các kiểm tra sẵn sàng đạt.",
  "microbiology.release.mappingConfigured": "Đã cấu hình ánh xạ phiếu bệnh nhân",
  "microbiology.release.mappingRequired": "Cần ánh xạ phiếu bệnh nhân để phát hành chính thức",
  "microbiology.release.noReportableContent": "Chưa có nội dung vi sinh được phép báo cáo sẵn sàng.",
  "microbiology.release.notEvaluated": "Chưa đánh giá mức sẵn sàng",
  "microbiology.release.patientReport": "Xem trước phiếu bệnh nhân",
  "microbiology.release.preliminary": "Phát hành phiếu sơ bộ",
  "microbiology.release.readinessChecks": "Mức sẵn sàng phát hành chính thức",
  "microbiology.release.title": "Mức sẵn sàng phiếu",
  "microbiology.release.viewPatientResults": "Xem kết quả bệnh nhân",
  "microbiology.release.useAmendment": "Phát hành bản đã sửa từ mục Hiệu chỉnh",
  "microbiology.release.whonetChecks": "Mức sẵn sàng WHONET",
  "microbiology.whonet.blocked": "Xuất WHONET bị chặn",
  "microbiology.whonet.ready": "Sẵn sàng xuất WHONET",
  "microbiology.worklist.clearFilters": "Xóa bộ lọc",
  "microbiology.worklist.column.action": "Thao tác",
  "microbiology.worklist.column.context": "Bối cảnh",
  "microbiology.worklist.column.due": "Thao tác cần làm",
  "microbiology.worklist.column.flags": "Cờ",
  "microbiology.worklist.column.isolate": "Chủng phân lập",
  "microbiology.worklist.column.labNumber": "Mã mẫu (SID)",
  "microbiology.worklist.column.lastActivity": "Hoạt động gần nhất bởi",
  "microbiology.worklist.column.organism": "Vi sinh vật",
  "microbiology.worklist.column.panel": "Bộ xét nghiệm",
  "microbiology.worklist.column.patient": "Bệnh nhân",
  "microbiology.worklist.column.priority": "Ưu tiên",
  "microbiology.worklist.column.sample": "Mục mẫu",
  "microbiology.worklist.column.specimen": "Bệnh phẩm",
  "microbiology.worklist.column.stage": "Giai đoạn",
  "microbiology.worklist.column.started": "Bắt đầu",
  "microbiology.worklist.column.status": "Trạng thái",
  "microbiology.worklist.column.urgency": "Mức khẩn",
  "microbiology.worklist.critical": "Thông báo nguy kịch",
  "microbiology.worklist.dueDetail.ast_entry": "Thiết lập AST cho chủng đã định danh.",
  "microbiology.worklist.dueDetail.ast_review": "Xem lại kết quả kháng sinh đã báo cáo.",
  "microbiology.worklist.dueDetail.case_review": "Xem lại mức sẵn sàng phiếu và phát hành.",
  "microbiology.worklist.dueDetail.isolate_id": "Ghi nhận mọc và định danh một chủng phân lập.",
  "microbiology.worklist.dueDetail.incubating": "Ngày {day} / {max}",
  "microbiology.worklist.dueDetail.setup": "Ghi nhận thiết lập nuôi cấy ban đầu.",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "Cấy chuyển và ghi nhuộm Gram.",
  "microbiology.worklist.empty.ast": "Không có lần AST nào khớp. Xóa tìm kiếm hoặc chọn trạng thái khác.",
  "microbiology.worklist.empty.cultures": "Không có mẫu nuôi cấy nào khớp. Xóa tìm kiếm hoặc chọn trạng thái khác.",
  "microbiology.worklist.expertRulesUnavailable": "Cờ quy tắc chuyên gia của OpenELIS có trong Giai đoạn 1B. Hiển thị cờ do máy báo cáo khi có.",
  "microbiology.worklist.filters": "Bộ lọc danh sách",
  "microbiology.worklist.filter.allActions": "Mọi thao tác",
  "microbiology.worklist.filter.allStages": "Mọi giai đoạn",
  "microbiology.worklist.filter.allUrgencies": "Mọi mức khẩn",
  "microbiology.worklist.filter.activeAst": "Công việc đang làm",
  "microbiology.worklist.filter.astStatus": "Trạng thái AST",
  "microbiology.worklist.filter.dueAction": "Thao tác cần làm",
  "microbiology.worklist.filter.reviewed": "Đã xem lại",
  "microbiology.worklist.filter.stage": "Giai đoạn",
  "microbiology.worklist.filter.urgency": "Mức khẩn",
  "microbiology.worklist.flagsUnavailable": "Quy tắc chuyên gia (Giai đoạn 1B)",
  "microbiology.worklist.loadError.subtitle": "Không tải được hàng đợi. Thử làm mới trang.",
  "microbiology.worklist.loadError.title": "Không tải được danh sách công việc vi sinh",
  "microbiology.worklist.editAst": "Sửa AST",
  "microbiology.worklist.grain.ast": "Lần chạy AST",
  "microbiology.worklist.grain.cultures": "Nuôi cấy",
  "microbiology.worklist.notSet": "Chưa đặt",
  "microbiology.worklist.notStarted": "Chưa bắt đầu",
  "microbiology.worklist.markLost": "Đánh dấu mất",
  "microbiology.worklist.markNoGrowth": "Đánh dấu không mọc",
  "microbiology.worklist.markPositive": "Đánh dấu dương tính",
  "microbiology.worklist.openCase": "Mở ca",
  "microbiology.worklist.newAstAttempt": "Thiết lập lần chạy AST mới",
  "microbiology.worklist.newPositive": "Dương tính mới",
  "microbiology.worklist.phase1b": "Có trong Giai đoạn 1B",
  "microbiology.worklist.print": "In danh sách",
  "microbiology.worklist.qcDashboard": "Bảng QC",
  "microbiology.worklist.queueStatus": "Hàng đợi dùng chung",
  "microbiology.worklist.refresh": "Làm mới ngay",
  "microbiology.worklist.rowActions": "Thao tác dòng",
  "microbiology.worklist.recentActivity.empty": "Chưa có hoạt động vi sinh gần đây.",
  "microbiology.worklist.recentActivity.title": "Hoạt động gần đây ({count})",
  "microbiology.worklist.resistance.hint": "Cờ do máy báo cáo đã hoàn tất hôm nay; phát hiện theo quy tắc chuyên gia của OpenELIS thuộc Giai đoạn 1B.",
  "microbiology.worklist.resistance.title": "Kết quả kháng thuốc hôm nay",
  "microbiology.worklist.search.ast": "Tìm mã mẫu (SID), bệnh nhân, chủng, vi sinh vật hoặc bộ xét nghiệm",
  "microbiology.worklist.search.cultures": "Tìm mã mẫu (SID), bệnh nhân hoặc bệnh phẩm",
  "microbiology.worklist.sharedQueue": "Hàng đợi xét nghiệm dùng chung",
  "microbiology.worklist.setupAst": "Thiết lập AST",
  "microbiology.worklist.sort": "Sắp xếp",
  "microbiology.worklist.sort.newest": "Hoạt động mới nhất",
  "microbiology.worklist.sort.priority": "Ưu tiên",
  "microbiology.worklist.sort.workflow": "Quy trình",
  "microbiology.worklist.subtitle": "Ưu tiên các ca nuôi cấy theo giai đoạn quy trình, mức khẩn và thao tác xét nghiệm cần làm.",
  "microbiology.worklist.summary.astReview": "Xem lại AST",
  "microbiology.worklist.summary.astInProgress": "Đang chạy",
  "microbiology.worklist.summary.astInQueue": "Trong hàng đợi",
  "microbiology.worklist.summary.astPendingSetup": "Chờ thiết lập",
  "microbiology.worklist.summary.astResultsIn": "Đã có kết quả - cần xem lại",
  "microbiology.worklist.summary.caseReview": "Sẵn sàng xem lại ca",
  "microbiology.worklist.summary.critical": "Theo dõi thông báo nguy kịch đang mở",
  "microbiology.worklist.summary.growthDetected": "Phát hiện mọc",
  "microbiology.worklist.summary.hint": "Chọn một hàng đợi để cập nhật danh sách ca.",
  "microbiology.worklist.summary.identification": "Đang định danh",
  "microbiology.worklist.summary.incubating": "Đang ủ",
  "microbiology.worklist.summary.positive": "Dương tính",
  "microbiology.worklist.summary.expertFlags": "Cờ chuyên gia (1B)",
  "microbiology.worklist.summary.title": "Công việc cần xử lý",
  "microbiology.worklist.summary.totalPending": "Tổng đang chờ",
  "microbiology.worklist.table.hint": "Các ca được sắp theo mức khẩn và thao tác cần làm tiếp theo.",
  "microbiology.worklist.table.astTitle": "Các lần AST",
  "microbiology.worklist.table.title": "Ca vi sinh đang mở",
  "microbiology.worklist.viewAudit": "Xem nhật ký",
  "microbiology.worklist.viewReviewedAst": "Xem AST đã xem lại",
  "microbiology.worklist.whonetExport": "Xuất sang WHONET",
  "microbiology.worklist.surveillance.title": "Phạm vi giám sát",
  "microbiology.worklist.surveillance.description": "Thu hẹp các dòng AST theo kỳ báo cáo và các trường giám sát có cấu trúc. Bộ lọc hàng đợi vận hành không làm thay đổi tập dữ liệu xuất.",
  "microbiology.worklist.ast.automaticResults": "Kết quả máy tự động về",
  "microbiology.worklist.ast.automaticResultsDetail": "Các máy đã kết nối gửi kết quả trực tiếp về ca. Sự kiện lỗi hoặc không khớp được giữ trong mục Lỗi nhập từ máy xét nghiệm.",
  "microbiology.worklist.ast.awaitingResults": "Đang chờ kết quả máy",
  "microbiology.worklist.ast.pendingIdentification": "Chờ định danh",
  "microbiology.worklist.ast.resultsInBadge": "Đã có kết quả",
  "microbiology.worklist.title": "Danh sách công việc vi sinh",
  "microbiology.worklist.updated": "Cập nhật {seconds} giây trước · tự làm mới mỗi 30 giây",
  "microbiology.admin.action.deactivate": "Ngừng dùng",
  "microbiology.admin.action.moveDown": "Chuyển xuống",
  "microbiology.admin.action.moveUp": "Chuyển lên",
  "microbiology.admin.action.reactivate": "Kích hoạt lại",
  "microbiology.admin.actions": "Thao tác dòng",
  "microbiology.admin.antibiotics.add": "Thêm kháng sinh",
  "microbiology.admin.antibiotics.description": "Danh mục kháng khuẩn dùng cho bộ AST và quy tắc điểm cắt.",
  "microbiology.admin.antibiotics.edit": "Kháng sinh",
  "microbiology.admin.antibiotics.title": "Kháng sinh",
  "microbiology.admin.astPanels.add": "Thêm bộ AST",
  "microbiology.admin.astPanels.antibiotic": "Kháng sinh",
  "microbiology.admin.astPanels.behavior.always": "Luôn luôn",
  "microbiology.admin.astPanels.behavior.cascade": "Theo tầng",
  "microbiology.admin.astPanels.behavior.resistant": "Chỉ khi kháng",
  "microbiology.admin.astPanels.current": "Hiện hành",
  "microbiology.admin.astPanels.confirmDeactivate": "Xuất bản phiên bản {version} thành không dùng được cho công việc mới? Các lần AST đang có sẽ giữ phiên bản bộ gốc.",
  "microbiology.admin.astPanels.confirmPublish": "Xuất bản phiên bản {version}? Các lần AST đang có sẽ giữ phiên bản bộ gốc.",
  "microbiology.admin.astPanels.confirmTitle": "Xác nhận xuất bản bộ",
  "microbiology.admin.astPanels.historical": "Lịch sử",
  "microbiology.admin.astPanels.loadingEditor": "Đang tải phần quản trị bộ AST.",
  "microbiology.admin.astPanels.publishVersion": "Xuất bản phiên bản mới",
  "microbiology.admin.astPanels.readOnly": "Phiên bản lịch sử này chỉ đọc. Mở phiên bản hiện hành để xuất bản thay đổi.",
  "microbiology.admin.astPanels.reportBehavior": "Cách báo cáo",
  "microbiology.admin.astPanels.tier": "Tầng",
  "microbiology.admin.astPanels.title": "Bộ AST",
  "microbiology.admin.astPanels.version": "Phiên bản",
  "microbiology.admin.astPanels.versionNotice": "Lưu sẽ tạo phiên bản bộ mới; các lần AST đang có giữ phiên bản gốc.",
  "microbiology.admin.astPanels.viewVersion": "Xem phiên bản",
  "microbiology.admin.breakpoints.activate": "Kích hoạt tiêu chuẩn",
  "microbiology.admin.breakpoints.applyValid": "Áp dụng các dòng hợp lệ",
  "microbiology.admin.breakpoints.archive": "Lưu trữ tiêu chuẩn",
  "microbiology.admin.breakpoints.archiveConfirm": "Tiêu chuẩn này vẫn có sẵn cho các lần AST lịch sử nhưng không thể chọn cho công việc mới.",
  "microbiology.admin.breakpoints.back": "Quay về danh sách tiêu chuẩn",
  "microbiology.admin.breakpoints.breakpointType": "Loại điểm cắt",
  "microbiology.admin.breakpoints.chooseFile": "Chọn tệp CSV",
  "microbiology.admin.breakpoints.correction.add": "Thêm hiệu chỉnh tại chỗ",
  "microbiology.admin.breakpoints.correction.edit": "Sửa hiệu chỉnh tại chỗ",
  "microbiology.admin.breakpoints.count.imported": "{count} đã nhập",
  "microbiology.admin.breakpoints.count.skipped": "{count} đã bỏ qua",
  "microbiology.admin.breakpoints.count.unchanged": "{count} không đổi",
  "microbiology.admin.breakpoints.count.valid": "{count} hợp lệ",
  "microbiology.admin.breakpoints.csv": "CSV điểm cắt",
  "microbiology.admin.breakpoints.description": "Các tiêu chuẩn điểm cắt đã nạp và phiên bản đang dùng cho lần AST mới.",
  "microbiology.admin.breakpoints.detail": "Quy tắc điểm cắt",
  "microbiology.admin.breakpoints.downloadRejected": "Tải các dòng bị từ chối",
  "microbiology.admin.breakpoints.effectiveDate": "Ngày có hiệu lực",
  "microbiology.admin.breakpoints.import": "Nhập CSV",
  "microbiology.admin.breakpoints.intermediate": "Trung gian",
  "microbiology.admin.breakpoints.intermediateLower": "Trung gian dưới",
  "microbiology.admin.breakpoints.intermediateUpper": "Trung gian trên",
  "microbiology.admin.breakpoints.groupOption": "Nhóm: {name}",
  "microbiology.admin.breakpoints.method.all": "Mọi phương pháp",
  "microbiology.admin.breakpoints.method.zone": "Vòng ức chế",
  "microbiology.admin.breakpoints.organism": "Vi sinh vật hoặc nhóm",
  "microbiology.admin.breakpoints.organismGroup": "Nhóm vi sinh vật",
  "microbiology.admin.breakpoints.publisher": "Đơn vị ban hành",
  "microbiology.admin.breakpoints.resistant": "Kháng",
  "microbiology.admin.breakpoints.rowError": "Dòng {row}",
  "microbiology.admin.breakpoints.rules": "Quy tắc",
  "microbiology.admin.breakpoints.source": "Nguồn",
  "microbiology.admin.breakpoints.source.imported": "Đã nhập",
  "microbiology.admin.breakpoints.source.local": "Hiệu chỉnh tại chỗ",
  "microbiology.admin.breakpoints.source.manual": "Thủ công",
  "microbiology.admin.breakpoints.specimen": "Bối cảnh bệnh phẩm",
  "microbiology.admin.breakpoints.specimen.any": "Mọi bệnh phẩm",
  "microbiology.admin.breakpoints.status.active": "Đang dùng",
  "microbiology.admin.breakpoints.status.archived": "Đã lưu trữ",
  "microbiology.admin.breakpoints.status.loaded": "Đã nạp",
  "microbiology.admin.breakpoints.susceptible": "Nhạy",
  "microbiology.admin.breakpoints.title": "Tiêu chuẩn điểm cắt",
  "microbiology.admin.breakpoints.units": "Đơn vị",
  "microbiology.admin.breakpoints.view": "Xem quy tắc",
  "microbiology.admin.filter.all": "Tất cả",
  "microbiology.admin.sort": "Sắp xếp",
  "microbiology.admin.sort.nameAsc": "Tên A-Z",
  "microbiology.admin.sort.nameDesc": "Tên Z-A",
  "microbiology.admin.deactivate.impact": "{name} đang được dùng bởi {count, plural, one {# bản ghi quy trình hiện có} other {# bản ghi quy trình hiện có}}. Ngừng dùng sẽ chặn chọn mới nhưng vẫn giữ các tham chiếu lịch sử đó.",
  "microbiology.admin.deactivate.title": "Xem lại tác động khi ngừng dùng",
  "microbiology.admin.deactivated": "Đã ngừng dùng mục tham chiếu",
  "microbiology.admin.empty": "Không có bản ghi tham chiếu khớp",
  "microbiology.admin.error.save": "Không lưu được bản ghi tham chiếu.",
  "microbiology.admin.error.title": "Không hoàn tất được yêu cầu",
  "microbiology.admin.field.active": "Sẵn sàng cho công việc mới",
  "microbiology.admin.field.atmosphere": "Mặc định khí quyển",
  "microbiology.admin.field.class": "Nhóm",
  "microbiology.admin.field.code": "Mã",
  "microbiology.admin.field.defaultPanel": "Bộ AST mặc định",
  "microbiology.admin.field.defaultPanelId": "Mã bộ AST mặc định",
  "microbiology.admin.field.gramStain": "Nhuộm Gram",
  "microbiology.admin.field.group": "Nhóm vi sinh vật",
  "microbiology.admin.field.incubation": "Mặc định ủ",
  "microbiology.admin.field.incubationHours": "Khoảng đọc thường quy (giờ)",
  "microbiology.admin.field.subcultureAtHours": "Cấy chuyển lúc (giờ)",
  "microbiology.admin.field.maxIncubationDays": "Thời gian ủ tối đa (ngày)",
  "microbiology.admin.field.media": "Mặc định môi trường",
  "microbiology.admin.field.method": "Phương pháp",
  "microbiology.admin.field.methodId": "Mã phương pháp",
  "microbiology.admin.field.name": "Tên",
  "microbiology.admin.field.notes": "Ghi chú",
  "microbiology.admin.field.oclCode": "Mã OCL",
  "microbiology.admin.field.reportableAnalyteId": "Mã chất phân tích được báo cáo",
  "microbiology.admin.field.route": "Đường dùng",
  "microbiology.admin.field.shortName": "Tên viết tắt",
  "microbiology.admin.field.significance": "Ý nghĩa ban đầu",
  "microbiology.admin.field.whonetCode": "Mã WHONET",
  "microbiology.admin.organisms.add": "Thêm vi sinh vật",
  "microbiology.admin.organisms.description": "Danh mục vi sinh vật dùng cho định danh nuôi cấy và AST.",
  "microbiology.admin.organisms.edit": "Vi sinh vật",
  "microbiology.admin.organisms.title": "Vi sinh vật",
  "microbiology.admin.patientOrigins.description": "Các lựa chọn nguồn bệnh nhân đã cấu hình, dùng khi nhập chỉ định vi sinh và khi xuất WHONET.",
  "microbiology.admin.patientOrigins.title": "Nguồn bệnh nhân",
  "microbiology.admin.reactivated": "Đã kích hoạt lại mục tham chiếu",
  "microbiology.admin.route.both": "Uống và truyền TM",
  "microbiology.admin.route.iv": "Truyền TM",
  "microbiology.admin.route.oral": "Uống",
  "microbiology.admin.route.topical": "Bôi ngoài da",
  "microbiology.admin.saved": "Đã lưu mục tham chiếu",
  "microbiology.admin.search": "Tìm dữ liệu tham chiếu",
  "microbiology.admin.sections": "Các mục dữ liệu tham chiếu vi sinh",
  "microbiology.admin.significance.possible": "Có thể gây bệnh",
  "microbiology.admin.significance.rare": "Hiếm gặp",
  "microbiology.admin.significance.usually": "Thường có ý nghĩa",
  "microbiology.admin.status": "Trạng thái",
  "microbiology.admin.status.active": "Đang dùng",
  "microbiology.admin.status.all": "Mọi trạng thái",
  "microbiology.admin.status.inactive": "Không dùng",
  "microbiology.admin.title": "Dữ liệu tham chiếu vi sinh",
  "button.add": "Thêm",
  "button.remove": "Gỡ",
  "sidenav.label.microbiology": "Vi sinh",
  "sidenav.label.microbiology.worklist": "Danh sách công việc vi sinh",
  "sidenav.label.microbiology.whonet": "Xuất WHONET",
  "microbiology.whonet.title": "Xuất WHONET",
  "microbiology.whonet.eyebrow": "Giám sát vi khuẩn học thường quy",
  "microbiology.whonet.subtitle": "Xem lại dữ liệu nuôi cấy và AST đã hoàn tất trước khi tạo CSV giám sát OpenELIS hiện tại để kiểm tra WHONET.",
  "microbiology.whonet.progress": "Tiến độ xuất WHONET",
  "microbiology.whonet.step.configure": "Cấu hình",
  "microbiology.whonet.step.preview": "Xem trước",
  "microbiology.whonet.step.generate": "Tạo",
  "microbiology.whonet.configure.title": "Cấu hình xuất",
  "microbiology.whonet.configure.description": "Chọn kỳ báo cáo và các chủng phân lập cần đưa vào.",
  "microbiology.whonet.from": "Từ",
  "microbiology.whonet.to": "Đến",
  "microbiology.whonet.date.placeholder": "yyyy-mm-dd",
  "microbiology.whonet.period.invalid": "Ngày kết thúc phải bằng hoặc sau ngày bắt đầu.",
  "microbiology.whonet.period.preset": "Kỳ báo cáo",
  "microbiology.whonet.period.thisMonth": "Tháng này",
  "microbiology.whonet.period.lastMonth": "Tháng trước",
  "microbiology.whonet.period.thisQuarter": "Quý này",
  "microbiology.whonet.period.custom": "Tùy chọn",
  "microbiology.whonet.source.worklist.title": "Phạm vi do danh sách AST cung cấp",
  "microbiology.whonet.source.worklist.description": "Kỳ báo cáo và bộ lọc giám sát có cấu trúc được lấy từ danh sách AST. Vẫn có thể sửa tại đây.",
  "microbiology.whonet.source.worklist.clear": "Xóa phạm vi danh sách",
  "microbiology.whonet.significance": "Phạm vi đưa vào",
  "microbiology.whonet.significance.clinical": "Chủng có ý nghĩa lâm sàng",
  "microbiology.whonet.significance.all": "Mọi chủng phân lập",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "Có ý nghĩa lâm sàng",
  "microbiology.whonet.significance.CONTAMINANT": "Tạp nhiễm",
  "microbiology.whonet.significance.NORMAL_FLORA": "Hệ vi khuẩn thường trú",
  "microbiology.whonet.significance.UNKNOWN": "Chưa phân loại",
  "microbiology.whonet.culturePurpose.description": "Mẫu nuôi cấy lâm sàng được đưa vào mặc định. Thêm các nhóm khác một cách rõ ràng khi câu hỏi giám sát yêu cầu.",
  "microbiology.whonet.culturePurpose.includeScreening": "Đưa vào mẫu sàng lọc chủ động hoặc mang trùng",
  "microbiology.whonet.culturePurpose.includeUnspecified": "Đưa vào mẫu lịch sử có mục đích không xác định",
  "microbiology.whonet.culturePurpose.title": "Mục đích nuôi cấy",
  "microbiology.whonet.filter.specimen": "Loại bệnh phẩm",
  "microbiology.whonet.filter.organism": "Vi sinh vật",
  "microbiology.whonet.filter.origin": "Nguồn bệnh nhân",
  "microbiology.whonet.filter.any": "Bất kỳ",
  "microbiology.whonet.filter.choose": "Chọn giá trị",
  "microbiology.whonet.dedup": "Loại trùng lặp",
  "microbiology.whonet.dedup.apply": "Áp dụng chọn chủng đầu tiên",
  "microbiology.whonet.dedup.apply.help": "Gộp các chủng lặp lại cùng bệnh nhân và cùng vi sinh vật trong cửa sổ đã chọn.",
  "microbiology.whonet.dedup.advanced": "Điều chỉnh chính sách chủng đầu tiên",
  "microbiology.whonet.dedup.window": "Độ dài cửa sổ",
  "microbiology.whonet.dedup.window.help": "Lần lặp đúng tại mốc số ngày đã chọn sẽ bắt đầu một cửa sổ mới.",
  "microbiology.whonet.dedup.sevenDay": "7 ngày",
  "microbiology.whonet.dedup.fourteenDay": "14 ngày",
  "microbiology.whonet.dedup.thirtyDay": "30 ngày",
  "microbiology.whonet.dedup.basis": "Ngày của cửa sổ",
  "microbiology.whonet.dedup.basis.collection": "Ngày lấy mẫu bệnh phẩm",
  "microbiology.whonet.dedup.basis.release": "Ngày phát hành kết quả chính thức",
  "microbiology.whonet.dedup.basis.help": "Chọn cửa sổ theo ngày lấy mẫu hoặc ngày phát hành kết quả chính thức. Kỳ báo cáo luôn theo ngày lấy mẫu.",
  "microbiology.whonet.dedup.scope": "Phạm vi nguồn bệnh phẩm",
  "microbiology.whonet.dedup.scope.any": "Mọi nguồn bệnh phẩm",
  "microbiology.whonet.dedup.scope.same": "Chỉ cùng nguồn bệnh phẩm",
  "microbiology.whonet.dedup.scope.help": "Chế độ mọi nguồn so sánh bệnh nhân và vi sinh vật giữa các loại bệnh phẩm; chế độ cùng nguồn so sánh trong từng loại bệnh phẩm.",
  "microbiology.whonet.dedup.contaminants": "Loại trừ tạp nhiễm có khả năng trước khi chọn",
  "microbiology.whonet.dedup.contaminants.help": "Loại bỏ tạp nhiễm có khả năng trước khi chọn chủng đại diện đầu tiên.",
  "microbiology.whonet.dedup.profile": "Hồ sơ nhạy cảm",
  "microbiology.whonet.dedup.profile.insensitive": "Bỏ qua thay đổi S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "Coi thay đổi S/I/R là chủng mới",
  "microbiology.whonet.dedup.profile.help": "Chọn theo hồ sơ sẽ tính một mẫu S/I/R kháng sinh đã xem lại khác là chủng mới trong cửa sổ.",
  "microbiology.whonet.dedup.none": "Không loại trùng lặp",
  "microbiology.whonet.preview.action": "Xem trước xuất",
  "microbiology.whonet.preview.title": "Xem trước",
  "microbiology.whonet.preview.description": "Các số đếm và dòng này sẽ được dùng khi tạo CSV.",
  "microbiology.whonet.generate.action": "Tạo CSV",
  "microbiology.whonet.count.cases": "Ca đã hoàn tất",
  "microbiology.whonet.count.clinicalPurpose": "Mẫu nuôi cấy lâm sàng",
  "microbiology.whonet.count.screeningPurpose": "Mẫu nuôi cấy sàng lọc",
  "microbiology.whonet.count.unspecifiedPurpose": "Mẫu nuôi cấy không xác định",
  "microbiology.whonet.count.purposeIncluded": "Sau khi chọn mục đích nuôi cấy",
  "microbiology.whonet.count.isolates": "Chủng phân lập tìm thấy",
  "microbiology.whonet.count.specimen": "Sau lọc bệnh phẩm",
  "microbiology.whonet.count.organism": "Sau lọc vi sinh vật",
  "microbiology.whonet.count.origin": "Sau lọc nguồn bệnh nhân",
  "microbiology.whonet.count.included": "Chủng phân lập được đưa vào",
  "microbiology.whonet.count.deduplicated": "Sau loại trùng lặp",
  "microbiology.whonet.count.mappable": "Chủng phân lập có thể ánh xạ",
  "microbiology.whonet.count.rows": "Dòng đủ điều kiện",
  "microbiology.whonet.count.excluded": "Dòng bị loại",
  "microbiology.whonet.mapping.title": "Mức sẵn sàng ánh xạ",
  "microbiology.whonet.mapping.excluded": "{count, plural, other {Đã loại # dòng}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "Sửa ánh xạ vi sinh vật",
  "microbiology.whonet.mapping.fixAntibiotic": "Sửa ánh xạ kháng sinh",
  "microbiology.whonet.mapping.fixSpecimen": "Sửa ánh xạ bệnh phẩm",
  "microbiology.whonet.table.title": "Các dòng AST đủ điều kiện",
  "microbiology.whonet.table.description": "Kết quả đọc AST đã xem lại và được phép báo cáo, kèm các ánh xạ cần thiết cho lần xuất này.",
  "microbiology.whonet.table.accession": "Mã mẫu (SID)",
  "microbiology.whonet.table.specimen": "Bệnh phẩm",
  "microbiology.whonet.table.organism": "Vi sinh vật",
  "microbiology.whonet.table.antibiotic": "Kháng sinh",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "Phương pháp",
  "microbiology.whonet.error.title": "Không hoàn tất được xuất WHONET",
  "microbiology.whonet.error.invalidRequest": "Xem lại kỳ báo cáo và tùy chọn xuất, rồi thử lại.",
  "microbiology.whonet.error.blocked": "Không còn dòng hợp lệ. Hãy xử lý các vấn đề sẵn sàng đã liệt kê trước khi tạo CSV.",
  "microbiology.whonet.error.network": "Không kết nối được dịch vụ xuất. Thử lại khi có kết nối.",
  "microbiology.whonet.error.generic": "Không hoàn tất được yêu cầu xuất.",
  "microbiology.whonet.preview.loading": "Đang chuẩn bị bản xem trước xuất.",
  "microbiology.whonet.preview.announced": "Bản xem trước đã sẵn sàng với {count, plural, one {# dòng đủ điều kiện} other {# dòng đủ điều kiện}}.",
  "microbiology.whonet.generated.title": "Đã tạo CSV",
  "microbiology.whonet.generated.subtitle": "Bản xuất đã kiểm tra được tải về và tóm tắt kiểm toán đã được ghi nhận.",
  "catalog.import.title": "Nhập danh mục (CSV)",
  "catalog.import.description": "Nạp tệp danh mục xét nghiệm mà không phải sửa từng xét nghiệm một. Xem trước kiểm tra từng tệp với danh mục hiện tại và không lưu gì, nên một dòng cần đơn vị, bệnh phẩm hoặc xét nghiệm mà tệp khác trong cùng đợt tải sẽ tạo ra sẽ được liệt kê là bỏ qua cho đến khi bạn áp dụng. Áp dụng nạp các tệp theo thứ tự và lưu cùng cấu hình, để lần khởi động lại sau nạp đúng những gì bạn đã áp dụng.",
  "catalog.import.dropzone": "Thêm tệp CSV",
  "catalog.import.preview": "Xem trước",
  "catalog.import.apply": "Áp dụng",
  "catalog.import.remove": "Gỡ",
  "catalog.import.plan.title": "Các tệp này sẽ làm gì",
  "catalog.import.result.title": "Đã nạp những gì",
  "catalog.import.column.file": "Tệp",
  "catalog.import.column.domain": "Khu vực danh mục",
  "catalog.import.column.created": "Đã tạo",
  "catalog.import.column.updated": "Đã cập nhật",
  "catalog.import.column.skipped": "Bỏ qua",
  "catalog.import.column.name": "Tên trong tệp",
  "catalog.import.column.where": "Xuất hiện ở đâu",
  "catalog.import.column.use": "Dùng bản ghi này",
  "catalog.import.file.error": "Không đọc được tệp này",
  "catalog.import.applied": "Các tệp danh mục đã được áp dụng.",
  "catalog.import.applied.partial": "Một số tệp danh mục chưa được nạp. Bảng cho biết tệp nào và vì sao.",
  "catalog.import.apply.failed": "Các tệp danh mục chưa được áp dụng.",
  "catalog.import.apply.hint": "Xem trước các tệp trước. Nút Áp dụng mở khi bản xem trước không còn lỗi tệp.",
  "catalog.import.failed": "Không gửi được các tệp danh mục.",
  "catalog.import.unresolved.title": "Cần bạn quyết định",
  "catalog.import.unresolved.description": "Các tên mà quá trình nhập không khớp được với bản ghi nào. Hãy trỏ từng tên tới bản ghi đúng hoặc bỏ qua. Ghi nhớ một tên sẽ tự giải quyết lần sau.",
  "catalog.import.unresolved.empty": "Không có mục nào đang chờ quyết định.",
  "catalog.import.remember": "Ghi nhớ tên này",
  "catalog.import.resolve": "Dùng",
  "catalog.import.skip": "Bỏ qua",
  "sidenav.label.admin.catalogImport": "Nhập danh mục (CSV)",
  "reporting.design.subtitle": "Tạo CSV cho một câu hỏi mới hoặc chạy lại một báo cáo quen thuộc cho kỳ mới.",
  "reporting.design.overview": "Tổng quan xuất dữ liệu",
  "reporting.design.newTitle": "Tạo bản xuất mới",
  "reporting.design.newHelp": "Chọn loại báo cáo, các trường cần thiết và kỳ báo cáo. Công việc của bạn vẫn còn nếu bạn rời hàng đợi hoặc quay lại sau.",
  "reporting.design.savedTitle": "Dùng báo cáo đã lưu",
  "reporting.design.savedHelp": "Dùng lại các trường và bộ lọc đã lưu, rồi chọn kỳ báo cáo mới.",
  "reporting.design.start": "Bắt đầu bản xuất mới",
  "reporting.design.continue": "Tiếp tục bản xuất hiện tại",
  "reporting.design.newExport": "Bản xuất mới",
  "reporting.design.useReport": "Dùng báo cáo",
  "reporting.design.savedFields": "{count} trường đã lưu · kỳ báo cáo không bao giờ được lưu",
  "reporting.design.steps": "Các bước xuất",
  "reporting.design.chooseColumns": "Chọn cột",
  "reporting.design.setFilters": "Đặt bộ lọc",
  "reporting.design.reviewSubmit": "Xem lại và gửi",
  "reporting.design.typeQuestion": "Bạn cần loại thông tin nào?",
  "reporting.design.typeHelp": "Chọn một loại báo cáo để mỗi dòng CSV có nghĩa rõ ràng. Bạn có thể đổi loại cho đến khi chọn trường.",
  "reporting.design.type.SAMPLE_TESTING": "Mẫu và xét nghiệm",
  "reporting.design.type.REFERRALS": "Gửi mẫu đi",
  "reporting.design.type.NON_CONFORMANCE": "Không phù hợp",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Chỉ định, kết quả, bệnh nhân và thời gian trả kết quả",
  "reporting.design.typeHelp.REFERRALS": "Xét nghiệm gửi sang phòng khác · giữ kết quả đã trả về và các mục gửi đang chờ",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Mẫu bị từ chối và sự kiện không phù hợp · giữ các bệnh phẩm liên quan và từng sự việc riêng",
  "reporting.design.pending": "Chưa kết nối",
  "reporting.design.building": "Bạn đang tạo báo cáo {type}.",
  "reporting.design.changeType": "Đổi loại và xóa các trường",
  "reporting.design.chooseType": "Chọn loại báo cáo để xem các trường của nó.",
  "reporting.design.configuredReports": "Báo cáo đã cấu hình",
  "reporting.design.chooseConfigured": "Chọn một báo cáo đã cấu hình",
  "reporting.design.available": "Trường có sẵn",
  "reporting.design.findField": "Tìm trường",
  "reporting.design.searchPlaceholder": "Tìm trong mọi trường và nhóm…",
  "reporting.design.clearSearch": "Xóa tìm kiếm",
  "reporting.design.fieldCount": "{count} trường trong {groups} nhóm",
  "reporting.design.matchCount": "{count} trường khớp trong {groups} nhóm",
  "reporting.design.expansion": "Mở rộng hoặc thu gọn nhóm trường",
  "reporting.design.expandAll": "Mở rộng tất cả",
  "reporting.design.collapseAll": "Thu gọn tất cả",
  "reporting.design.groupCount": "{added} / {total} đã thêm",
  "reporting.design.scrollCatalog": "Danh mục trường có thể cuộn",
  "reporting.design.addShown": "Thêm tất cả trường đang hiển thị",
  "reporting.design.removeShown": "Gỡ các trường đang hiển thị",
  "reporting.design.addShownGroup": "Thêm tất cả trường {group} đang hiển thị",
  "reporting.design.removeShownGroup": "Gỡ tất cả trường {group} đang hiển thị",
  "reporting.design.addField": "Thêm {field}",
  "reporting.design.addedField": "Đã thêm {field}",
  "reporting.design.add": "+ Thêm",
  "reporting.design.added": "Đã thêm",
  "reporting.design.noFields": "Không có trường nào khớp với tìm kiếm.",
  "reporting.design.selectedCount": "Các cột CSV của bạn ({count})",
  "reporting.design.orderHelp": "Kéo tay cầm để đổi thứ tự cột, hoặc dùng mũi tên. Phím mũi tên di chuyển tay cầm đang chọn; Home và End đưa về vị trí đầu hoặc cuối.",
  "reporting.design.columnOrder": "Các cột CSV theo thứ tự",
  "reporting.design.drag": "Kéo {field} để đổi thứ tự",
  "reporting.design.move": "Di chuyển {field}",
  "reporting.design.emptyColumns": "Thêm trường để tạo CSV.",
  "reporting.design.addedMessage": "Đã thêm {field}. {count} cột.",
  "reporting.design.removedMessage": "Đã gỡ {field}. {count} cột.",
  "reporting.design.columnViews": "Chế độ xem trình tạo cột",
  "reporting.design.yourColumns": "Các cột của bạn ({count})",
  "reporting.design.csvPreview": "Xem trước CSV",
  "reporting.design.previewHelp": "Bố cục cột theo đúng thứ tự sẽ xuất hiện trong CSV tải về.",
  "reporting.design.scrollPreview": "Xem trước CSV có thể cuộn",
  "reporting.design.nextFilters": "Tiếp: Đặt bộ lọc",
  "reporting.design.nextReview": "Tiếp: Xem lại và gửi",
  "reporting.design.scopeFilters": "Bộ lọc phạm vi (không bắt buộc)",
  "reporting.design.periodDays": "{count, plural, other {# ngày}}",
  "reporting.design.moreFilters": "Hiện thêm bộ lọc",
  "reporting.design.hideFilters": "Ẩn bớt bộ lọc",
  "reporting.design.sampleStatus": "Trạng thái mẫu",
  "reporting.design.referringSite": "Đơn vị gửi",
  "reporting.design.reviewConfiguration": "Xem lại cấu hình",
  "reporting.design.dateFilters": "Khoảng thời gian và bộ lọc",
  "reporting.design.testStatus": "Xét nghiệm và trạng thái",
  "reporting.design.change": "Đổi",
  "reporting.design.deliveryHelp": "CSV của bạn sẽ được tạo ở nền. Tải về tại đây khi xong, hoặc quay lại Hàng đợi báo cáo của tôi.",
  "reporting.design.fileName": "Tên tệp",
  "reporting.design.customFileName": "Tên tệp tùy chỉnh",
  "reporting.design.fileNamePending": "Tên tệp được tạo tự động. Tên tùy chỉnh chưa được kết nối.",
  "reporting.design.saveLater": "Lưu cấu hình báo cáo này để dùng sau",
  "reporting.design.saveSettings": "Lưu cấu hình báo cáo",
  "reporting.design.queueHelp": "Xem và tải về các bản xuất CSV đang xếp hàng của bạn.",
  "reporting.design.queue.jobName": "Tên công việc",
  "reporting.design.queue.report": "Báo cáo",
  "reporting.design.queue.size": "Số dòng / Dung lượng tệp",
  "reporting.design.queue.submitted": "Thời điểm gửi",
  "reporting.design.queuePending": "Các công việc đang chạy tự làm mới. Thử lại bản xuất lỗi, hủy công việc đang xếp hàng hoặc chạy lại báo cáo hết hạn với ngày mới. Chức năng xóa công việc chưa được kết nối.",
  "reporting.design.details": "Chi tiết",
  "reporting.design.expires": "Có thể tải đến {date}",
  "reporting.design.jobsShown": "Đang hiển thị {count} công việc",
  "reporting.design.jobAction.EXPIRED": "Chạy lại",
  "reporting.design.labScope": "Phạm vi phòng xét nghiệm",
  "reporting.design.reviewFields": "Các trường đã chọn ({count})",
  "reporting.recovery.cancelTitle": "Hủy bản xuất",
  "reporting.recovery.keepQueued": "Giữ trong hàng đợi",
  "reporting.recovery.cancelHelp": "Hủy bản xuất đang xếp hàng này? Nếu việc xử lý đã bắt đầu, nó sẽ tiếp tục chạy và bạn có thể quay lại xem kết quả.",
  "reporting.job.cannotCancel": "Bản xuất này đã bắt đầu hoặc đã xong nên không thể hủy.",
  "reporting.job.cannotRetry": "Chỉ bản xuất lỗi mới có thể thử lại. Dùng công việc hiện tại hoặc bắt đầu bản xuất mới.",
  "reporting.job.interrupted": "Quá trình xử lý bị gián đoạn. Thử lại bản xuất này để tạo tệp mới.",
  "reporting.job.claimLost": "Bản xuất này không còn được gán cho tiến trình hiện tại. Quay lại hàng đợi để xem trạng thái.",
  "sidenav.section.main": "Menu chính",
  "sidenav.section.patientOrders": "Bệnh nhân và chỉ định",
  "sidenav.section.administration": "Quản trị",
  "sidenav.workflow.orderTest": "Chỉ định xét nghiệm",
  "sidenav.workflow.resultsValidation": "Duyệt kết quả",
  "sidenav.workflow.patientManagement": "Quản lý bệnh nhân",
  "sidenav.moreTools": "Công cụ khác",
  "reporting.menu.otherReports": "Báo cáo khác",
  "reporting.menu.patientPrintQueue": "Hàng đợi in phiếu bệnh nhân",
  "common.icon": "Biểu tượng",
  "menu.presentation.style": "Hiển thị dưới dạng",
  "menu.presentation.item": "Mục menu",
  "menu.presentation.section": "Tiêu đề nhóm",
  "menu.configuration.description": "Cập nhật khả năng hiển thị menu, tiêu đề nhóm và biểu tượng. Các thiết lập do hệ thống này quản lý chỉ xem tại đây.",
  "menu.configuration.export": "Export menu file",
  "menu.configuration.loadError": "Không tải được thiết lập menu.",
  "menu.configuration.saved": "Đã lưu thiết lập menu.",
  "menu.presentation.sectionHint": "Tiêu đề nhóm gom các mục menu con của nó mà không có liên kết.",
  "menu.presentation.sectionIconHint": "Biểu tượng hiển thị trên các mục menu, không hiển thị trên tiêu đề nhóm.",
  "analyzer.action.copyMappings": "Sao chép ánh xạ",
  "analyzer.action.delete": "Xóa",
  "analyzer.action.edit": "Sửa",
  "analyzer.action.fieldMappings": "Ánh xạ trường",
  "analyzer.action.qcRules": "Quy tắc QC",
  "analyzer.action.testConnection": "Kiểm tra kết nối",
  "analyzer.copyMappings.confirmation.message": "Bạn có chắc muốn sao chép {count} ánh xạ? Các ánh xạ hiện có sẽ bị ghi đè.",
  "analyzer.copyMappings.confirmation.title": "Xác nhận sao chép ánh xạ",
  "analyzer.copyMappings.copy": "Sao chép ánh xạ",
  "analyzer.copyMappings.error": "Lỗi khi sao chép ánh xạ",
  "analyzer.copyMappings.error.noSourceMappings": "Máy nguồn không có ánh xạ đang dùng để sao chép",
  "analyzer.copyMappings.loading": "Đang sao chép ánh xạ...",
  "analyzer.copyMappings.source": "Máy nguồn",
  "analyzer.copyMappings.source.name": "Tên",
  "analyzer.copyMappings.source.type": "Loại",
  "analyzer.copyMappings.subtitle": "Sao chép ánh xạ trường từ {source} sang {target}",
  "analyzer.copyMappings.success": "Đã sao chép thành công {count} ánh xạ",
  "analyzer.copyMappings.success.viewTarget": "Xem máy đích",
  "analyzer.copyMappings.summary": "Tóm tắt ánh xạ",
  "analyzer.copyMappings.summary.breakdown": "Ánh xạ trường: {fieldCount}, Quy đổi đơn vị: {unitCount}, Ánh xạ định tính: {qualCount}",
  "analyzer.copyMappings.summary.count": "{count} ánh xạ sẽ được sao chép",
  "analyzer.copyMappings.target": "Máy đích",
  "analyzer.copyMappings.target.placeholder": "Chọn máy đích",
  "analyzer.copyMappings.target.required": "Máy đích *",
  "analyzer.copyMappings.title": "Sao chép ánh xạ trường",
  "analyzer.copyMappings.warning": "Thao tác này sẽ sao chép toàn bộ ánh xạ trường, bao gồm quy đổi đơn vị và ánh xạ giá trị định tính. Các ánh xạ hiện có sẽ bị ghi đè.",
  "analyzer.delete.cancel": "Hủy",
  "analyzer.delete.delete": "Xóa",
  "analyzer.delete.error": "Lỗi",
  "analyzer.delete.error.noId": "Cần mã máy xét nghiệm",
  "analyzer.delete.error.unknown": "Đã xảy ra lỗi không xác định khi xóa máy xét nghiệm",
  "analyzer.delete.message": "Bạn có chắc muốn xóa '{name}'? Thao tác này không thể hoàn tác và sẽ xóa toàn bộ ánh xạ trường liên quan.",
  "analyzer.delete.success": "Đã xóa máy xét nghiệm",
  "analyzer.delete.title": "Xóa máy xét nghiệm",
  "analyzer.delete.unknown": "Máy xét nghiệm không xác định",
  "analyzer.errorDashboard.acknowledgeAll": "Xác nhận tất cả",
  "analyzer.errorDashboard.action.acknowledge": "Xác nhận",
  "analyzer.errorDashboard.action.menu": "Thao tác lỗi",
  "analyzer.errorDashboard.action.viewDetails": "Xem chi tiết",
  "analyzer.errorDashboard.errorType.connection": "Kết nối",
  "analyzer.errorDashboard.errorType.mapping": "Ánh xạ",
  "analyzer.errorDashboard.errorType.protocol": "Giao thức",
  "analyzer.errorDashboard.errorType.timeout": "Quá thời gian",
  "analyzer.errorDashboard.errorType.validation": "Kiểm tra dữ liệu",
  "analyzer.errorDashboard.filter.analyzer": "Máy xét nghiệm",
  "analyzer.errorDashboard.filter.analyzer.all": "Tất cả",
  "analyzer.errorDashboard.filter.search": "Tìm lỗi...",
  "analyzer.errorDashboard.filter.severity": "Mức độ",
  "analyzer.errorDashboard.filter.severity.all": "Mọi mức độ",
  "analyzer.errorDashboard.filter.type": "Loại lỗi",
  "analyzer.errorDashboard.filter.type.all": "Mọi loại",
  "analyzer.errorDashboard.severity.critical": "Nghiêm trọng",
  "analyzer.errorDashboard.severity.error": "Lỗi",
  "analyzer.errorDashboard.severity.warning": "Cảnh báo",
  "analyzer.errorDashboard.stats.critical": "Nghiêm trọng",
  "analyzer.errorDashboard.stats.last24Hours": "24 giờ qua",
  "analyzer.errorDashboard.stats.total": "Tổng số lỗi",
  "analyzer.errorDashboard.stats.unacknowledged": "Chưa xác nhận",
  "analyzer.errorDashboard.status.acknowledged": "Đã xác nhận",
  "analyzer.errorDashboard.status.unacknowledged": "Chưa xác nhận",
  "analyzer.errorDashboard.subtitle": "Xem và quản lý lỗi và cảnh báo của máy xét nghiệm",
  "analyzer.errorDashboard.table.analyzer": "Máy xét nghiệm",
  "analyzer.errorDashboard.table.message": "Nội dung",
  "analyzer.errorDashboard.table.severity": "Mức độ",
  "analyzer.errorDashboard.table.status": "Trạng thái",
  "analyzer.errorDashboard.table.timestamp": "Thời điểm",
  "analyzer.errorDashboard.table.type": "Loại",
  "analyzer.errorDashboard.title": "Bảng lỗi",
  "analyzer.errorDetails.acknowledged": "Đã xác nhận",
  "analyzer.errorDetails.acknowledgedBy": "Bởi {user} lúc {date}",
  "analyzer.errorDetails.analyzer": "Máy xét nghiệm",
  "analyzer.errorDetails.analyzerId": "Mã máy xét nghiệm",
  "analyzer.errorDetails.close": "Đóng",
  "analyzer.errorDetails.copy": "Sao chép",
  "analyzer.errorDetails.createMapping": "Tạo ánh xạ",
  "analyzer.errorDetails.download": "Tải về",
  "analyzer.errorDetails.errorId": "Mã lỗi",
  "analyzer.errorDetails.errorMessage": "Nội dung lỗi",
  "analyzer.errorDetails.errorType": "Loại lỗi",
  "analyzer.errorDetails.logs": "Nhật ký máy xét nghiệm ({count} mục)",
  "analyzer.errorDetails.recommendedActions": "Hành động được đề xuất",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Kiểm tra cấu hình địa chỉ IP và cổng trong thiết lập máy xét nghiệm",
  "analyzer.errorDetails.recommendedActions.createMapping": "Tạo ánh xạ cho trường chưa được ánh xạ để xử lý lỗi này",
  "analyzer.errorDetails.recommendedActions.testConnection": "Kiểm tra kết nối bằng tính năng 'Kiểm tra kết nối'",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Xác nhận máy xét nghiệm đã bật và cáp mạng đã được cắm",
  "analyzer.errorDetails.severity": "Mức độ",
  "analyzer.errorDetails.subtitle": "Thông tin chi tiết và nhật ký máy xét nghiệm cho lỗi {id}",
  "analyzer.errorDetails.timestamp": "Thời điểm",
  "analyzer.errorDetails.title": "Chi tiết lỗi",
  "analyzer.fieldMapping.activationModal.activate": "Kích hoạt thay đổi",
  "analyzer.fieldMapping.activationModal.cancel": "Hủy",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "Tôi hiểu các thay đổi này chỉ áp dụng cho thông điệp mới",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Phát hiện thay đổi ánh xạ. Một người dùng khác đã sửa ánh xạ của máy xét nghiệm này. Vui lòng tải lại trang để xem thay đổi mới nhất.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Không thể kích hoạt: thiếu ánh xạ bắt buộc",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Thiếu các trường bắt buộc: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Tải lại trang",
  "analyzer.fieldMapping.activationModal.subtitle": "Xác nhận kích hoạt thay đổi ánh xạ cho máy xét nghiệm '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Kích hoạt thay đổi ánh xạ",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "Xem thông điệp đang chờ",
  "analyzer.fieldMapping.activationModal.warning": "Bạn sắp kích hoạt thay đổi ánh xạ cho máy xét nghiệm '{name}'. Các thay đổi này sẽ áp dụng cho mọi thông điệp mới nhận sau khi kích hoạt. Kết quả đã có sẽ không bị ảnh hưởng.",
  "analyzer.fieldMapping.activationModal.warningActive": "Máy xét nghiệm này đang hoạt động. Kích hoạt thay đổi có thể ảnh hưởng đến kết quả đang về.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "Máy xét nghiệm này có {count} thông điệp đang chờ trong hàng đợi lỗi. Kích hoạt thay đổi ánh xạ có thể ảnh hưởng đến cách xử lý lại các thông điệp này. Nên xử lý lỗi trước.",
  "analyzer.fieldMapping.back": "Quay về",
  "analyzer.fieldMapping.fieldType.controlTest": "Xét nghiệm mẫu chứng",
  "analyzer.fieldMapping.fieldType.custom": "Tùy chỉnh",
  "analyzer.fieldMapping.fieldType.dateTime": "Ngày/Giờ",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Điểm nóng chảy",
  "analyzer.fieldMapping.fieldType.numeric": "Số",
  "analyzer.fieldMapping.fieldType.qualitative": "Định tính",
  "analyzer.fieldMapping.fieldType.text": "Văn bản",
  "analyzer.fieldMapping.page.subtitle": "Cấu hình ánh xạ trường giữa máy xét nghiệm và OpenELIS",
  "analyzer.fieldMapping.page.title": "Ánh xạ trường",
  "analyzer.fieldMapping.panel.mapping.active": "Đang dùng",
  "analyzer.fieldMapping.panel.mapping.retired": "Đã gỡ bỏ",
  "analyzer.fieldMapping.panel.retire": "Gỡ bỏ ánh xạ",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Không thể gỡ bỏ: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} trường có sẵn",
  "analyzer.fieldMapping.panel.source.search": "Tìm trường...",
  "analyzer.fieldMapping.panel.source.title": "Trường máy xét nghiệm ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Đã ánh xạ",
  "analyzer.fieldMapping.panel.status.unmapped": "Chưa ánh xạ",
  "analyzer.fieldMapping.panel.statusFilter.active": "Chỉ đang dùng",
  "analyzer.fieldMapping.panel.statusFilter.all": "Mọi trường",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Chỉ bản nháp",
  "analyzer.fieldMapping.panel.statusFilter.label": "Lọc theo trạng thái",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Chỉ đã ánh xạ",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Chỉ chưa ánh xạ",
  "analyzer.fieldMapping.panel.target.cancel": "Hủy",
  "analyzer.fieldMapping.panel.target.edit": "Sửa",
  "analyzer.fieldMapping.panel.target.remove": "Gỡ",
  "analyzer.fieldMapping.panel.target.saveActivate": "Lưu và kích hoạt",
  "analyzer.fieldMapping.panel.target.saveDraft": "Lưu thành bản nháp",
  "analyzer.fieldMapping.panel.target.selectField": "Chọn một trường ở bảng bên trái để xem hoặc tạo ánh xạ.",
  "analyzer.fieldMapping.panel.target.summary": "Tóm tắt ánh xạ",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Trường chưa ánh xạ - trường này chưa có ánh xạ nào được cấu hình",
  "analyzer.fieldMapping.pendingCodes.actions": "Thao tác",
  "analyzer.fieldMapping.pendingCodes.code": "Mã máy xét nghiệm",
  "analyzer.fieldMapping.pendingCodes.empty": "Không có mã máy xét nghiệm chưa ánh xạ nào đang chờ.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Bỏ qua",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Đánh dấu đã ánh xạ",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Số lần gặp",
  "analyzer.fieldMapping.pendingCodes.status": "Trạng thái",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Xem và xử lý các mã xét nghiệm của máy chưa được ánh xạ.",
  "analyzer.fieldMapping.pendingCodes.title": "Mã chưa ánh xạ đang chờ",
  "analyzer.fieldMapping.pluginConfig.title": "Ảnh chụp cấu hình plugin",
  "analyzer.fieldMapping.queryAnalyzer": "Truy vấn máy xét nghiệm",
  "analyzer.fieldMapping.retirementModal.cancel": "Hủy",
  "analyzer.fieldMapping.retirementModal.confirmation": "Bạn có chắc muốn gỡ bỏ ánh xạ này? Các thông điệp lịch sử vẫn sẽ tham chiếu đến nó để phục vụ kiểm toán.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Không thể gỡ bỏ: {count} thông điệp đang chờ dùng ánh xạ này",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Lý do gỡ bỏ (không bắt buộc)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Không bắt buộc: lý do gỡ bỏ ánh xạ này",
  "analyzer.fieldMapping.retirementModal.retire": "Gỡ bỏ ánh xạ",
  "analyzer.fieldMapping.retirementModal.subtitle": "Xác nhận gỡ bỏ ánh xạ trường",
  "analyzer.fieldMapping.retirementModal.title": "Gỡ bỏ ánh xạ",
  "analyzer.fieldMapping.save": "Lưu ánh xạ",
  "analyzer.fieldMapping.stats.pendingCodes": "Mã đang chờ",
  "analyzer.fieldMapping.stats.required": "Ánh xạ bắt buộc",
  "analyzer.fieldMapping.stats.total": "Tổng số ánh xạ",
  "analyzer.fieldMapping.stats.unmapped": "Trường chưa ánh xạ",
  "analyzer.fieldMapping.status.active": "Đang dùng",
  "analyzer.fieldMapping.status.draft": "Bản nháp",
  "analyzer.fieldMapping.status.retired": "Đã gỡ bỏ",
  "analyzer.fieldMapping.status.unmapped": "Chưa ánh xạ",
  "analyzer.fieldMapping.testMapping": "Ánh xạ xét nghiệm",
  "analyzer.fieldMapping.warning.missingRequired": "Thiếu ánh xạ bắt buộc",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Một số trường bắt buộc chưa được ánh xạ. Hãy ánh xạ đầy đủ các trường bắt buộc trước khi kích hoạt.",
  "analyzer.navigation.errorDashboard": "Bảng lỗi",
  "analyzerType.column.name": "Tên",
  "analyzerType.column.description": "Mô tả",
  "analyzerType.column.pluginClass": "Lớp plugin",
  "analyzerType.column.genericPlugin": "Plugin chung",
  "analyzerType.column.identifierPattern": "Mẫu nhận dạng",
  "analyzerType.column.pluginLoaded": "Plugin đã nạp",
  "analyzerType.column.instances": "Số máy",
  "analyzerType.button.creating": "Đang tạo...",
  "analyzerType.modal.createTitle": "Tạo loại máy xét nghiệm mới",
  "analyzerType.field.name": "Tên",
  "analyzerType.field.description": "Mô tả",
  "analyzerType.field.selectProtocol": "Chọn giao thức",
  "analyzerType.field.pluginClassName": "Tên lớp plugin",
  "analyzerType.field.identifierPattern": "Mẫu nhận dạng",
  "analyzerType.field.identifierPatternHelper": "Biểu thức chính quy để khớp mã mẫu (vd ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Plugin chung",
  "analyzerType.field.isActive": "Đang dùng",
  "analyzerType.error.nameRequired": "Cần nhập tên",
  "analyzerType.notification.createSuccess": "Đã tạo loại máy xét nghiệm thành công",
  "analyzerType.notification.createError": "Tạo loại máy xét nghiệm thất bại",
  "analyzer.stat.pluginWarnings": "Cảnh báo plugin",
  "analyzer.status.pending_registration": "Chờ đăng ký",
  "analyzer.qcRules.modal.title": "Quy tắc nhận dạng mẫu QC — {analyzerName}",
  "analyzer.qcRules.breadcrumb": "Quy tắc nhận dạng mẫu QC",
  "analyzer.qcRules.orSemantics": "Các quy tắc dùng logic HOẶC: một mẫu được đánh dấu là QC nếu BẤT KỲ quy tắc đang dùng nào khớp.",
  "analyzer.qcRules.addRule": "Thêm quy tắc",
  "analyzer.qcRules.deleteRule": "Xóa quy tắc",
  "analyzer.qcRules.noRules": "Chưa cấu hình quy tắc QC nào. Hãy thêm ít nhất một quy tắc trước khi kích hoạt máy xét nghiệm này.",
  "analyzer.qcRules.ruleType": "Loại quy tắc",
  "analyzer.qcRules.targetField": "Tham chiếu trường",
  "analyzer.qcRules.targetField.placeholder": "vd: O.12, QC_TASK",
  "analyzer.qcRules.operand": "Giá trị khớp",
  "analyzer.qcRules.operand.placeholder": "vd: Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Không tải được quy tắc QC",
  "analyzer.qcRules.error.saveFailed": "Không lưu được quy tắc QC",
  "analyzer.qcRules.error.deleteFailed": "Không xóa được quy tắc QC",
  "analyzer.placement.instrumentSpecimen": "Máy đã gửi: {id}",
  "analyzer.placement.state.RESOLVED": "Đã khớp",
  "analyzer.placement.state.RETEST_CHOICE": "Đã có kết quả",
  "analyzer.placement.state.MULTI_TUBE": "Khớp nhiều mục",
  "analyzer.placement.state.UNORDERED_ONE_FITS": "Xét nghiệm chưa được chỉ định",
  "analyzer.placement.state.UNORDERED_MANY_FIT": "Xét nghiệm chưa được chỉ định",
  "analyzer.placement.state.UNORDERED_NONE_FIT": "Xét nghiệm chưa được chỉ định",
  "analyzer.placement.state.NEW_SAMPLE": "Mẫu mới",
  "analyzer.placement.reason.RESOLVED": "Một phân tích trên {tube} đang chờ kết quả này.",
  "analyzer.placement.reason.RETEST_CHOICE": "Phân tích trên {tube} đã có kết quả. Lưu sẽ thay thế và đánh dấu là đã sửa.",
  "analyzer.placement.reason.MULTI_TUBE": "Có nhiều hơn một phân tích khớp với mã này. Hãy chọn phân tích mà kết quả này thuộc về.",
  "analyzer.placement.reason.MULTI_TUBE_NO_ANALYSIS": "Có nhiều hơn một ống mang mã này. Hãy sửa nhãn ống bị trùng, rồi xem lại.",
  "analyzer.placement.reason.UNORDERED_ONE_FITS": "Xét nghiệm này chưa được chỉ định. Lưu sẽ thêm vào {tube}.",
  "analyzer.placement.reason.UNORDERED_MANY_FIT": "Xét nghiệm này chưa được chỉ định và có nhiều hơn một ống có thể chứa nó. Hãy chọn loại mẫu bên dưới.",
  "analyzer.placement.reason.UNORDERED_NONE_FIT": "Xét nghiệm này chưa được chỉ định và không ống nào trong chỉ định chứa được nó. Lưu sẽ thêm một ống mới cùng loại mẫu của xét nghiệm.",
  "analyzer.placement.reason.NEW_SAMPLE": "Không có chỉ định hay ống nào mang mã này. Lưu sẽ tạo mẫu mới cho mã này.",
  "analyzer.placement.chooseAnalysis": "Phân tích mà kết quả này thuộc về",
  "analyzer.placement.chooseAnalysis.none": "Chọn một phân tích",
  "analyzer.placement.option": "{tube}, {status}",
  "analyzer.placement.option.awaiting": "đang chờ kết quả",
  "analyzer.placement.option.hasResult": "đã có kết quả",
  "analyzer.placement.tubeUnlabelled": "ống {id}",
  "analyzer.placement.viewBundle": "Xem gói dữ liệu",
  "analyzer.placement.bundleTitle": "Gói dữ liệu gửi",
  "analyzer.placement.bundleLoading": "Đang tải gói dữ liệu gửi",
  "analyzer.placement.bundleFailed": "Không tải được gói dữ liệu gửi.",
  "analyzer.placement.redirect.open": "Đặt sang chỉ định khác",
  "analyzer.placement.redirect.accession": "Chỉ định (mã mẫu)",
  "analyzer.placement.redirect.reason": "Vì sao kết quả này thuộc về chỉ định đó",
  "analyzer.placement.redirect.help": "Dùng khi máy đọc sai mã bệnh phẩm. Lý do sẽ được lưu cùng kết quả.",
  "analyzer.placement.redirect.reasonRequired": "Nhập lý do trước khi lưu.",
  "analyzer.placement.patient.match": "Bệnh nhân trên máy {instrument} khớp với bệnh nhân của chỉ định.",
  "analyzer.placement.patient.mismatch.tag": "Bệnh nhân không khớp",
  "analyzer.placement.patient.mismatch": "Máy báo bệnh nhân {instrument}, nhưng bệnh nhân của chỉ định là {order}. Hãy thêm ghi chú nêu lý do trước khi lưu.",
  "analyzer.placement.patient.noOrderPatient": "Máy báo bệnh nhân {instrument}. Chỉ định không có mã bệnh nhân để đối chiếu.",
  "instructions.qc.fail.blocks.validation": "Khi bật, các kết quả thuộc phạm vi một lỗi QC đang mở không thể được chấp nhận ở bước Duyệt cho đến khi sự không phù hợp được đóng; vẫn có thể từ chối. Khi tắt, lỗi chỉ hiện trên dòng dưới dạng cảnh báo.",
  "coldStorage.bacnetUdpPort": "Cổng UDP BACnet",
  "coldStorage.config.saveSuccess": "Đã lưu cấu hình hệ thống thành công",
  "coldStorage.configMoved": "Cấu hình đã chuyển sang Bảng quản trị",
  "coldStorage.configMovedDesc": "Thiết lập toàn hệ thống nên được quản lý trong Giao diện quản trị, nơi tập trung mọi cấu hình chung. Trang này chỉ xem và sẽ bị gỡ trong bản phát hành sau.",
  "coldStorage.databaseVersion": "Phiên bản cơ sở dữ liệu",
  "coldStorage.error.loadConfig": "Không tải được cấu hình hệ thống: ",
  "coldStorage.error.saveConfig": "Không lưu được cấu hình hệ thống: ",
  "coldStorage.lastUpdate": "Cập nhật lần cuối",
  "coldStorage.loadingConfig": "Đang tải cấu hình hệ thống...",
  "coldStorage.modbusTcpPort": "Cổng Modbus TCP",
  "coldStorage.protocolConfiguration": "Cấu hình giao thức",
  "coldStorage.readOnlyMode": "Chế độ chỉ đọc",
  "coldStorage.readOnlyModeDesc": "Để sửa các thiết lập này, hãy vào Quản trị → Cấu hình hệ thống",
  "coldStorage.securitySettings": "Thiết lập bảo mật",
  "coldStorage.sessionTimeout": "Hết thời gian phiên",
  "coldStorage.systemConfiguration": "Cấu hình hệ thống",
  "coldStorage.systemInformation": "Thông tin hệ thống",
  "coldStorage.systemVersion": "Phiên bản hệ thống",
  "coldStorage.twoFactorAuth": "Xác thực hai yếu tố",
  "coldStorage.uptime": "Thời gian hoạt động",
  "customFieldType.page.hierarchy.management": "Loại trường tùy chỉnh",
  "customFieldType.page.hierarchy.root": "Quản trị hệ thống",
  "eqa.program.tests.helper": "Nhập kết quả cho chương trình này chỉ gồm đúng các xét nghiệm này, trên lưới kết quả và trong phần nhập CSV.",
  "eqa.program.tests.saveFailed": "Chương trình đã được lưu nhưng các xét nghiệm của nó thì chưa. Hãy mở lại và đặt lại.",
  "inventory.search.placeholder": "Tìm theo tên vật tư, số lô hoặc mã vạch",
  "label.results.control.capture.pass": "Đạt",
  "label.results.control.capture.fail": "Không đạt",
  "message.noPluginFound": "Không tìm thấy plugin nào",
  "nce.status.capa": "CAPA",
  "nce.status.completed": "Đã hoàn thành",
  "nce.capa.add": "Thêm",
  "plugin.files": "Tệp plugin",
  "plugin.name": "Tên plugin",
  "sidenav.label.admin.analyzerTest": "Tên xét nghiệm máy",
  "sidenav.label.admin.Listplugin": "Danh sách plugin",
  "sidenav.label.admin.pluginFile": "Tệp plugin",
  "label.testCatalog.accreditation.col.body": "Tổ chức công nhận",
  "label.testCatalog.accreditation.col.expires": "Hết hạn công nhận",
  "label.testCatalog.accreditation.col.status": "Trạng thái",
  "label.testCatalog.accreditation.col.actions": "Thao tác",
  "label.testCatalog.accreditation.remove.confirm": "Gỡ bỏ",
  "qa.qiConfig.title": "Cấu hình chỉ số chất lượng (QI)",
  "qa.qiConfig.error": "Không tải được cấu hình QI.",
  "qa.qiConfig.column.indicator": "Chỉ số",
  "qa.qiConfig.column.enabled": "Bật",
  "qa.qiConfig.column.target": "Mục tiêu",
  "qa.qiConfig.column.action": "Ngưỡng hành động",
  "qa.qiConfig.column.actions": "Thao tác",
  "qa.qms.capaRegister.title": "Sổ CAPA",
  "qa.qms.capaRegister.tile.open": "Đang mở",
  "qa.qms.capaRegister.tile.overdue": "Quá hạn",
  "qa.qms.capaRegister.filter.status": "Trạng thái",
  "qa.qms.capaRegister.filter.status.all": "Tất cả",
  "qa.qms.capaRegister.column.nceNumber": "Số NCE",
  "qa.qms.capaRegister.column.actionType": "Loại",
  "qa.qms.capaRegister.column.dueDate": "Hạn",
  "qa.qms.capaRegister.column.completed": "Hoàn thành",
  "qa.qms.capaRegister.column.status": "Trạng thái",
  "qa.qms.accreditation.tile.active": "Đang hiệu lực",
  "qa.qms.accreditation.tile.expiring": "Sắp hết hạn",
  "qa.qms.accreditation.tile.expired": "Đã hết hạn",
  "qa.qms.accreditation.body.column.code": "Mã",
  "qa.qms.accreditation.body.column.name": "Tên",
  "qa.qms.accreditation.body.column.enrolled": "Xét nghiệm đã đăng ký",
  "qa.qms.accreditation.body.column.status": "Trạng thái",
  "qa.qms.accreditation.body.column.actions": "Thao tác",
  "qa.qms.accreditation.body.field.code": "Mã",
  "qa.qms.accreditation.body.field.name": "Tên",
  "qa.qms.accreditation.body.field.displayOrder": "Thứ tự hiển thị",
  "qa.qms.accreditation.body.field.active": "Đang hiệu lực",
  "qa.qms.accreditation.body.delete.confirm": "Xóa",
  "qa.qms.accreditation.enrollment.column.test": "Xét nghiệm",
  "qa.qms.accreditation.enrollment.column.status": "Trạng thái",
  "qa.qms.accreditation.enrollment.column.actions": "Thao tác",
  "qa.qms.accreditation.eqa.column.body": "Tổ chức công nhận",
  "qa.qms.accreditation.filter.status": "Trạng thái",
  "qa.qms.accreditation.filter.all": "Tất cả",
  "qa.qms.accreditation.filter.search": "Tìm xét nghiệm",
  "qa.qms.accreditation.enroll.field.body": "Tổ chức công nhận",
  "qa.qms.accreditation.enroll.field.tests": "Xét nghiệm",
  "qa.qms.accreditation.enrollment.delete.confirm": "Gỡ bỏ",
  "qa.qms.esigLog.title": "Nhật ký chữ ký điện tử",
  "qa.qms.esigLog.column.signedAt": "Thời điểm ký",
  "qa.qms.esigLog.column.action": "Thao tác",
  "qa.qms.esigLog.column.reason": "Lý do",
  "qa.qms.esigLog.filter.from": "Khoảng ngày (từ)",
  "qa.qms.esigLog.filter.to": "Khoảng ngày (đến)",
  "qa.qms.esigLog.filter.action": "Thao tác",
  "qa.qms.esigLog.filter.user": "Người dùng",
  "qa.qms.esigLog.filter.all": "Tất cả",
  "qa.qms.esigLog.filter.clear": "Xóa bộ lọc",
  "qa.qms.esigLog.export.csv": "Xuất CSV",
  "qa.qms.esigLog.export.pdf": "Xuất PDF",
  "qa.qms.esigLog.export.confirm.confirm": "Xuất",
  "qa.qms.esigLog.export.confirm.cancel": "Hủy",
  "qa.qi.dashboard.title": "Bảng điều khiển QI",
  "qa.qi.dashboard.refresh": "Làm mới",
  "qa.qi.dashboard.comingSoon": "Sắp ra mắt — {ticket}",
  "qa.qi.amendment.filter.from": "Từ",
  "qa.qi.amendment.filter.to": "Đến",
  "qa.qi.amendment.column.labNumber": "Mã mẫu",
  "qa.qi.amendment.column.test": "Xét nghiệm",
  "qa.qi.amendment.empty": "Không có lần sửa kết quả nào trong khoảng thời gian này.",
  "qa.qi.amendment.error": "Không có dữ liệu sửa kết quả.",
  "qa.qi.amendment.trend.title": "Xu hướng",
  "qa.qi.amendment.trend.series": "Tỷ lệ sửa kết quả",
  "qa.qi.amendment.trend.interval": "Gộp theo",
  "qa.qi.amendment.threshold.target": "Mục tiêu",
  "qa.qi.amendment.threshold.action": "Hành động",
  "qa.qi.amendment.breakdown.column.test": "Xét nghiệm",
  "qa.qi.amendment.breakdown.column.amended": "Đã sửa",
  "qa.qi.amendment.breakdown.column.released": "Đã trả kết quả",
  "qa.qi.rejection.filter.from": "Từ",
  "qa.qi.rejection.filter.to": "Đến",
  "qa.qi.rejection.column.labNumber": "Mã mẫu",
  "qa.qi.rejection.column.test": "Xét nghiệm",
  "qa.qi.rejection.column.reason": "Lý do",
  "qa.qi.rejection.column.location": "Vị trí",
  "qa.qi.rejection.column.nce": "NCE",
  "qa.qi.rejection.error": "Không có dữ liệu từ chối mẫu.",
  "qa.qi.rejection.trend.title": "Xu hướng",
  "qa.qi.rejection.trend.series": "Tỷ lệ từ chối",
  "qa.qi.rejection.trend.interval": "Gộp theo",
  "qa.qi.rejection.trend.empty": "Không có dữ liệu xu hướng trong khoảng thời gian này.",
  "qa.qi.rejection.threshold.target": "Mục tiêu",
  "qa.qi.rejection.threshold.action": "Hành động",
  "qa.qi.rejection.reasons.column.reason": "Lý do",
  "qa.qi.rejection.reasons.column.count": "Số lượng",
  "qa.qi.rejection.breakdown.title": "Theo xét nghiệm",
  "qa.qi.rejection.breakdown.column.test": "Xét nghiệm",
  "qa.qi.rejection.breakdown.column.rejected": "Bị từ chối",
  "qa.qi.rejection.breakdown.column.total": "Đã bắt đầu",
  "qa.qi.rejection.breakdown.column.rate": "Tỷ lệ",
  "qa.qi.callback.failures.column.reason": "Lý do",
  "qa.qi.callback.failures.column.count": "Số lượng",
  "qa.qi.callback.error": "Không có dữ liệu thông báo lại kết quả.",
  "qa.qi.callback.column.releasedAt": "Trả lúc",
  "qa.qi.callback.column.labNumber": "Mã mẫu",
  "qa.qi.callback.column.test": "Xét nghiệm",
  "qa.qi.callback.column.resultValue": "Kết quả",
  "qa.qi.callback.column.criticalRange": "Khoảng nguy hiểm",
  "qa.qi.callback.column.recipient": "Người đã được thông báo",
  "qa.comingSoon.subtitle": "Trang này đã được lên kế hoạch nhưng chưa được xây dựng.",
  "qa.overview.section.today": "Hôm nay",
  "qa.overview.tile.tat": "TAT trung bình",
  "qa.overview.tile.rejectionRate": "Tỷ lệ từ chối",
  "qa.overview.tile.amendmentRate": "Tỷ lệ sửa kết quả",
  "qa.overview.tile.ncePulse": "Nhịp NCE",
  "qa.overview.ncePulse.criticalPending": "nguy hiểm đang chờ",
  "qa.overview.ncePulse.inCorrectiveAction": "{count} đang khắc phục",
  "qa.overview.activity.system": "Hệ thống",
  "storage.picker.backToSearch": "Quay lại tìm kiếm",
  "storage.picker.createNewLocation": "Tạo vị trí mới",
  "storage.picker.heading.moveSample": "Chuyển mẫu",
  "storage.picker.sample.accession": "Mã mẫu",
  "storage.picker.sample.heading": "Mẫu",
  "storage.picker.sample.status": "Trạng thái",
  "storage.picker.sample.type": "Loại",
  "storage.metrics.storage.locations": "Vị trí lưu trữ",
  "storage.tab.devices": "Thiết bị",
  "storage.tab.racks": "Giá",
  "storage.tab.rooms": "Phòng",
  "storage.tab.shelves": "Kệ",
  "validation.label.qcHold": "Kiểm soát chất lượng không đạt",
  "validation.qcHold.blocked": "Một số kết quả chưa được trả vì mẻ kiểm soát chất lượng bao phủ chúng bị lỗi. Đóng sự không phù hợp, hoặc từ chối các kết quả bị ảnh hưởng.",
  "validation.qcHold.withheld": "{count, plural, other {# kết quả chưa được phát hành ({accessions}). Lỗi QC liên quan vẫn đang mở. Hãy xem lại sự không phù hợp, hoặc từ chối kết quả.}}",
  "qc.dashboard.export.button": "Xuất",
  "qc.dashboard.export.instrument": "Máy xét nghiệm",
  "qc.dashboard.export.level": "Mức mẫu chứng",
  "qc.dashboard.export.startDate": "Ngày bắt đầu",
  "qc.dashboard.export.endDate": "Ngày kết thúc",
  "qc.dashboard.export.csv": "Xuất CSV",
  "qc.dashboard.export.pdf": "Xuất PDF",
  "qc.dashboard.export.cancel": "Hủy",
  "qc.instrument.tab.timeline": "Dòng thời gian hoạt động",
  "qc.instrument.tab.chart": "Biểu đồ kiểm soát",
  "qc.chart.stats.mean": "Trung bình",
  "qc.chart.stats.n": "N",
  "qc.chart.subtitle": "Biểu đồ kiểm soát Levey-Jennings",
  "qc.chart.filter.startDate": "Ngày bắt đầu",
  "qc.chart.filter.endDate": "Ngày kết thúc",
  "qc.chart.filter.controlLevel": "Mức mẫu chứng",
  "qc.chart.filter.selectLevel": "Chọn mức",
  "qc.chart.filter.levelLow": "Thấp",
  "qc.chart.filter.levelNormal": "Bình thường",
  "qc.chart.filter.levelHigh": "Cao",
  "qc.chart.filter.controlLot": "LOT mẫu chứng",
  "qc.chart.filter.allLots": "Tất cả LOT",
  "qc.chart.action.export": "Xuất",
  "qc.bench.source.label": "Nguồn",
  "qc.bench.column.labUnit": "Nhóm xét nghiệm",
  "qc.bench.column.test": "Xét nghiệm",
  "qc.bench.column.source": "Nguồn",
  "qc.bench.column.failed": "Không đạt",
  "eqa.distribution.updateSuccess": "Đã cập nhật phân phối bản nháp.",
  "banner.menu.eqa.myCycles": "Các đợt của tôi",
  "banner.menu.eqa.labPerformance": "Hiệu quả phòng XN",
  "banner.menu.eqa.followUpQueue": "Theo dõi của phòng XN này",
  "banner.menu.eqa.analystCompetency": "Năng lực kỹ thuật viên",
  "banner.menu.eqa.provider": "Đơn vị cung cấp EQA",
  "eqa.participant.myCycles.title": "Các đợt EQA của tôi",
  "eqa.participant.myCycles.subtitle": "Các đợt phòng XN đang tham gia. Nhập và duyệt kết quả thực hiện trong luồng kết quả OpenELIS chuẩn — trang này theo dõi tiến độ và dẫn bạn tới đó.",
  "eqa.participant.infoTitle": "Kết quả EQA đi qua luồng duyệt chuẩn.",
  "eqa.participant.infoBody": "Nhấp vào Mã mẫu để mở màn nhập kết quả chuẩn cho mẫu đó. Khi duyệt xong, đợt sẽ chuyển sang Đã gửi (hoặc Sẵn sàng gửi nếu chương trình yêu cầu xem xét ở cấp đợt).",
  "eqa.kpi.active": "Đợt đang chạy",
  "eqa.kpi.active.hint": "đang thực hiện",
  "eqa.kpi.readyToSubmit": "Sẵn sàng gửi",
  "eqa.kpi.readyToSubmit.hint": "đã bật bước xem xét",
  "eqa.kpi.awaiting": "Chờ điểm số",
  "eqa.kpi.awaiting.hint": "đã gửi cho đơn vị cung cấp",
  "eqa.kpi.openNce": "NCE liên quan EQA đang mở",
  "eqa.kpi.openNce.attention": "cần xử lý",
  "eqa.kpi.openNce.none": "không có mục mở",
  "eqa.bucket.label": "Trạng thái",
  "eqa.bucket.active": "Đang chạy",
  "eqa.bucket.awaiting": "Chờ điểm số",
  "eqa.bucket.completed": "Đã hoàn thành",
  "eqa.bucket.all": "Tất cả",
  "eqa.bucket.active.hint": "Đang thực hiện — sắp tới, đang xét nghiệm, hoặc sẵn sàng gửi",
  "eqa.bucket.awaiting.hint": "Đã gửi cho đơn vị cung cấp; đang chờ chấm điểm",
  "eqa.bucket.completed.hint": "Đã chấm điểm hoặc đã đóng",
  "eqa.bucket.all.hint": "Mọi đợt phòng XN này từng tham gia",
  "eqa.filter.schemeType": "Loại chương trình",
  "eqa.schemeType.all": "Tất cả loại",
  "eqa.schemeType.international_pt": "PT quốc tế",
  "eqa.schemeType.regional_pt": "PT khu vực",
  "eqa.schemeType.inter_lab_split": "Chia mẫu liên phòng",
  "eqa.schemeType.in_house": "Nội bộ",
  "eqa.filter.searchCycles": "Tìm chương trình, đơn vị cung cấp hoặc đợt",
  "eqa.filter.showing": "Hiển thị {shown} / {total} đợt",
  "eqa.filter.clear": "Xóa bộ lọc",
  "eqa.col.scheme": "Chương trình",
  "eqa.col.type": "Loại",
  "eqa.col.cycle": "Đợt",
  "eqa.col.status": "Trạng thái",
  "eqa.col.deadline": "Hạn chót",
  "eqa.col.progress": "Tiến độ",
  "eqa.cycle.status.planned": "Đã lên kế hoạch",
  "eqa.cycle.status.panel_received": "Đã nhận bộ mẫu",
  "eqa.cycle.status.testing": "Đang xét nghiệm",
  "eqa.cycle.status.ready_to_submit": "Sẵn sàng gửi",
  "eqa.cycle.status.submitted": "Đã gửi",
  "eqa.cycle.status.scored": "Đã chấm điểm",
  "eqa.cycle.status.closed": "Đã đóng",
  "eqa.cycle.toggleDetails": "Mở/đóng chi tiết đợt",
  "eqa.cycle.emptyFiltered": "Không có đợt nào khớp bộ lọc.",
  "eqa.cycle.nceBanner": "Điểm không chấp nhận được ở {scheme}. Theo dõi trong sổ NCE.",
  "eqa.cycle.perAnalyst.title": "Yêu cầu theo từng kỹ thuật viên",
  "eqa.cycle.perAnalyst.body": "Kỹ thuật viên được gán khi đăng ký chương trình. Cột theo kỹ thuật viên hiển thị ở trang nhập kết quả chuẩn.",
  "eqa.cycle.review.title": "Đã bật bước xem xét ở cấp đợt cho chương trình này.",
  "eqa.cycle.review.body": "Cả {total} chỉ tiêu đã được duyệt trong luồng chuẩn. Gửi chỉ cần một cú nhấp — duyệt là cổng chính thức, không xác thực lại.",
  "eqa.btn.reviewSubmit": "Xem xét & gửi",
  "eqa.cycle.submitted.success": "Đã gửi đợt cho đơn vị cung cấp — đang chờ điểm số.",
  "eqa.cycle.submitted.error": "Gửi thất bại — đợt chưa được chuyển trạng thái. Kiểm tra mọi kết quả đã được duyệt và thử lại.",
  "eqa.progress.title": "Tiến độ mẫu",
  "eqa.sample.labNo": "Mã mẫu",
  "eqa.sample.providerId": "Mã mẫu của đơn vị cung cấp",
  "eqa.sample.analytes": "Chỉ tiêu",
  "eqa.sample.analyst": "Kỹ thuật viên được gán",
  "eqa.sample.entryStatus": "Trạng thái nhập",
  "eqa.labNo.tooltip": "Mở nhập kết quả cho mã mẫu này",
  "eqa.entry.entered": "Đã nhập",
  "eqa.entry.in_progress": "Đang nhập",
  "eqa.entry.empty": "Chưa nhập",
  "eqa.cycle.scoredCopy": "Đã chấm điểm xong. Kết quả đã chấm nằm trong Hiệu quả phòng XN.",
  "eqa.cycle.submittedCopy": "Đã gửi cho đơn vị cung cấp — đang chờ điểm số.",
  "eqa.cycle.closedCopy": "Đợt đã đóng.",
  "eqa.cycle.panelReceivedCopy": "Đã nhận bộ mẫu. Tiếp tục nhập kết quả chuẩn để bắt đầu xét nghiệm.",
  "eqa.cycle.plannedCopy": "Phòng XN chưa nhận bộ mẫu. Mở Thêm chỉ định, đánh dấu ô EQA để ghi nhận việc nhận.",
  "eqa.btn.receivePanel": "Nhận bộ mẫu — mở Thêm chỉ định",
  "eqa.uncycled.title": "Chỉ định EQA chưa thuộc đợt",
  "eqa.uncycled.subtitle": "Các chỉ định EQA chưa gắn với đợt nào. Chúng vẫn hiển thị ở đây để không bị thất lạc.",
  "eqa.review.title": "Tóm tắt trước khi gửi",
  "eqa.review.subtitle": "Tóm tắt chỉ đọc của mọi kết quả đã duyệt, nhóm theo mẫu. Đây là nội dung sẽ gửi cho đơn vị cung cấp.",
  "eqa.review.auditFootnote": "Mọi giá trị trên đã được duyệt trong luồng chuẩn, và nhật ký kiểm toán đã ghi lại người duyệt. Gửi chỉ ghi nhận xác nhận — không có bước ký duyệt riêng.",
  "eqa.sample.analyte": "Chỉ tiêu",
  "eqa.sample.reportedValue": "Giá trị báo cáo",
  "eqa.sample.validatedAt": "Đã duyệt",
  "eqa.order.cycle": "Đợt EQA",
  "eqa.order.receipt.title": "Biên nhận bộ mẫu",
  "eqa.order.receipt.tempC": "Nhiệt độ khi đến (°C)",
  "eqa.order.receipt.integrityOk": "Bộ mẫu đến nguyên vẹn",
  "eqa.order.receipt.notes": "Ghi chú tình trạng",
  "eqa.order.receipt.recorded": "Đã ghi nhận biên nhận bộ mẫu vào {date}.",
  "eqa.cycle.status.prep_in_progress": "Đang chuẩn bị",
  "eqa.cycle.status.ready_to_ship": "Sẵn sàng gửi đi",
  "eqa.cycle.status.shipped": "Đã gửi đi",
  "eqa.cycle.status.delivered": "Đã giao",
  "eqa.cycle.status.submissions_open": "Đang mở nhận kết quả",
  "eqa.cycle.status.submissions_closed": "Đã đóng nhận kết quả",
  "eqa.cycle.status.scoring": "Đang chấm điểm",
  "eqa.provider.workbench.cycle": "Màn làm việc đợt",
  "eqa.provider.workbench.forCycle": "Chuẩn bị & vận chuyển — {name}",
  "eqa.provider.workbench.tabs": "Màn làm việc",
  "eqa.provider.workbench.stateHint": "Phải qua cổng kiểm kho và QC thì mới gửi được bộ mẫu.",
  "eqa.prep.tab": "Chuẩn bị",
  "eqa.prep.participants": "Phòng XN tham gia",
  "eqa.prep.panels": "Bộ mẫu",
  "eqa.prep.gate": "Cổng sẵn sàng gửi",
  "eqa.prep.gate.clear": "Đã đáp ứng mọi yêu cầu chuẩn bị",
  "eqa.prep.noPanel.title": "Chưa chuẩn bị bộ mẫu",
  "eqa.prep.noPanel.body": "Tạo bộ mẫu của đợt và các mẫu của bộ trước khi ghi tiến độ chuẩn bị.",
  "eqa.prep.needExplained": "Số phần chia cần: {samples, plural, one {# mẫu} other {# mẫu}} x {participants, plural, one {# phòng XN} other {# phòng XN}} + {reserved} giữ dự phòng = {needed, plural, one {# phần chia} other {# phần chia}}; đã gửi đi {shipped, plural, one {# phần chia} other {# phần chia}} cho đến nay.",
  "eqa.prep.produced": "Phần chia đã tạo",
  "eqa.prep.reserved": "Phần chia đã giữ dự phòng",
  "eqa.prep.shortfall": "thiếu {n}",
  "eqa.prep.homogeneity": "Đạt QC độ đồng nhất",
  "eqa.prep.homogeneityNotes": "Ghi chú QC",
  "eqa.prep.save": "Lưu bản ghi chuẩn bị",
  "eqa.prep.saved": "Đã cập nhật bản ghi chuẩn bị.",
  "eqa.prep.saveFailed": "Bản ghi chuẩn bị chưa được lưu.",
  "eqa.prep.readyToShip": "Đánh dấu đợt sẵn sàng gửi",
  "eqa.prep.readyToShip.success": "Đợt đã được phép gửi — ghi thông tin đơn vị vận chuyển ở tab Vận chuyển.",
  "eqa.prep.readyToShip.refused": "Đợt chưa được phép gửi. Xử lý các mục chuẩn bị còn tồn rồi thử lại.",
  "eqa.shipment.tab": "Vận chuyển",
  "eqa.shipment.participant": "Phòng XN tham gia",
  "eqa.shipment.box": "Thùng",
  "eqa.shipment.courier": "Đơn vị vận chuyển",
  "eqa.shipment.courierFor": "Đơn vị vận chuyển cho {name}",
  "eqa.shipment.tracking": "Mã vận đơn",
  "eqa.shipment.trackingFor": "Mã vận đơn cho {name}",
  "eqa.shipment.expected": "Dự kiến giao",
  "eqa.shipment.expectedFor": "Dự kiến giao cho {name}",
  "eqa.shipment.selectAll": "Chọn tất cả đang chờ",
  "eqa.shipment.selectRow": "Chọn {name} để gửi",
  "eqa.shipment.markShipped": "Đánh dấu đã gửi {n}",
  "eqa.shipment.firstShipHint": "Lần gửi đầu tiên sẽ chuyển đợt sang Đã gửi đi.",
  "eqa.shipment.saved": "Đã lưu thông tin vận chuyển.",
  "eqa.shipment.saveFailed": "Chưa lưu được thông tin vận chuyển.",
  "eqa.shipment.shipped": "Đã gửi {n} gói cho phòng XN tham gia.",
  "eqa.shipment.shipFailed": "Chưa gửi gói nào.",
  "eqa.shipment.shippedOn": "Đã gửi {date}",
  "eqa.shipment.packList": "Phiếu đóng gói",
  "eqa.shipment.packList.noPanel": "Đợt này chưa có bộ mẫu nên không có gì để đóng gói.",
  "eqa.shipment.packList.unavailable": "Không đọc được các mẫu của bộ, nên chưa lập được phiếu đóng gói. Tải lại và thử lại.",
  "eqa.shipment.packList.notes": "Vật liệu ngoại kiểm EQA — không mở trước thời gian xét nghiệm.",
  "eqa.shipment.label": "Nhãn",
  "eqa.shipment.noParticipants.title": "Chưa có phòng XN tham gia",
  "eqa.shipment.noParticipants.body": "Ghi danh các phòng XN tham gia vào đợt này trước khi gửi bộ mẫu.",
  "eqa.report.download": "Tải báo cáo hiệu quả",
  "banner.menu.eqa.inHouse": "Mù mẫu nội bộ",
  "eqa.inhouse.wizard.title": "Tạo bộ mẫu mù nội bộ",
  "eqa.inhouse.step1": "Chương trình & đợt",
  "eqa.inhouse.step2": "Mẫu & chuẩn bị",
  "eqa.inhouse.step3": "Kỹ thuật viên",
  "eqa.inhouse.step4": "Xác nhận & niêm phong",
  "eqa.inhouse.scheme": "Chương trình nội bộ",
  "eqa.inhouse.cycleName": "Tên đợt",
  "eqa.inhouse.plannedStart": "Ngày bắt đầu dự kiến",
  "eqa.inhouse.unblindDate": "Ngày mở mù (hạn nộp kết quả)",
  "eqa.inhouse.sample": "Mẫu",
  "eqa.inhouse.samples": "Mẫu",
  "eqa.inhouse.test": "Xét nghiệm",
  "eqa.inhouse.target": "Giá trị mục tiêu",
  "eqa.inhouse.unit": "Đơn vị",
  "eqa.inhouse.rangeLow": "Giới hạn dưới",
  "eqa.inhouse.rangeHigh": "Giới hạn trên",
  "eqa.inhouse.addSample": "Thêm mẫu",
  "eqa.inhouse.analyst": "Kỹ thuật viên",
  "eqa.inhouse.roster": "Danh sách kỹ thuật viên của chương trình",
  "eqa.inhouse.roster.pick": "Chọn kỹ thuật viên",
  "eqa.inhouse.roster.saveError": "Không lưu được danh sách kỹ thuật viên",
  "eqa.inhouse.assign.manual": "Gán kỹ thuật viên thủ công (nếu không sẽ luân phiên)",
  "eqa.inhouse.assign.mode": "Cách gán",
  "eqa.inhouse.assign.ROUND_ROBIN": "Luân phiên — mỗi mẫu một kỹ thuật viên, chia theo vòng",
  "eqa.inhouse.assign.IDENTICAL": "Bộ mẫu giống nhau — mọi kỹ thuật viên làm cùng các mẫu",
  "eqa.inhouse.assign.MANUAL": "Gán thủ công cho từng mẫu",
  "eqa.inhouse.assign.identicalNote": "Mỗi kỹ thuật viên làm mọi mẫu: {materials, plural, one {# mẫu} other {# mẫu}} × {analysts, plural, one {# kỹ thuật viên} other {# kỹ thuật viên}} = {aliquots, plural, one {# phần mù} other {# phần mù}}, mỗi phần có mã mù riêng.",
  "eqa.inhouse.assign.footnote": "Mỗi lần gán được ghi trên chỉ định mù mà nó tạo ra, và đi theo chỉ định đó qua nhập kết quả.",
  "eqa.inhouse.gate.identicalNeedsAnalysts": "Bộ mẫu giống nhau cần ít nhất một kỹ thuật viên trong danh sách chương trình",
  "eqa.inhouse.samplesLeadIn": "{count, plural, other {# mẫu}} defined. Target values are sealed when the wizard finishes; they are never stored in clear text.",
  "eqa.inhouse.confirm.aliquotRows": "Phần mù",
  "eqa.inhouse.confirm.sealWarning": "Niêm phong sẽ mã hóa giá trị mục tiêu",
  "eqa.inhouse.confirm.sealWarningBody": "Sau khi niêm phong, xem giá trị mục tiêu cần quyền mở mù và được ghi vào nhật ký kiểm toán. Sau đó không thể sửa bộ mẫu.",
  "eqa.inhouse.confirm.afterSeal": "Niêm phong tạo một chỉ định mù cho mỗi phần chia. Chúng hiển thị trong nhập kết quả và Phiếu công việc dưới mã mù, như mọi chỉ định khác.",
  "eqa.inhouse.prep.sourceType": "Nguồn",
  "eqa.inhouse.prep.lotNumber": "Số LOT",
  "eqa.inhouse.prep.aliquots": "Phần chia đã tạo",
  "eqa.inhouse.prep.storageTemp": "Nhiệt độ bảo quản",
  "eqa.inhouse.prep.expiration": "Ngày hết hạn",
  "eqa.inhouse.prep.homogeneity": "Đạt QC độ đồng nhất",
  "eqa.inhouse.prep.homogeneityNotes": "Ghi chú QC độ đồng nhất",
  "eqa.inhouse.gate.noSamples": "Thêm ít nhất một mẫu trước khi tiếp tục",
  "eqa.inhouse.gate.aliquots": "Số phần chia đã tạo phải đủ cho mọi mẫu mù",
  "eqa.inhouse.gate.homogeneity": "QC độ đồng nhất chưa đạt, nên phân phối cần có giải trình bằng văn bản",
  "eqa.inhouse.gate.targets": "Mỗi mẫu cần một xét nghiệm và một giá trị mục tiêu",
  "eqa.inhouse.confirm.samples": "Mẫu",
  "eqa.inhouse.confirm.labelNote": "Phiếu nhãn chỉ ghi mã mù, đợt và chỉ tiêu — không bao giờ ghi giá trị mục tiêu.",
  "eqa.inhouse.seal": "Niêm phong bộ mẫu & phân phối",
  "eqa.inhouse.seal.error": "Không niêm phong được bộ mẫu",
  "eqa.inhouse.seal.cycleError": "Không tạo được đợt",
  "eqa.inhouse.seal.panelError": "Không tạo được bộ mẫu",
  "eqa.inhouse.sealed.title": "Đã niêm phong và phân phối bộ mẫu",
  "eqa.inhouse.sealed.help": "Các chỉ định mù giờ mang các mã mù này làm mã mẫu, trong nhập kết quả và Phiếu công việc.",
  "eqa.inhouse.sealed.done": "Quay lại danh sách bộ mẫu nội bộ",
  "eqa.inhouse.panel": "Bộ vật liệu EQA",
  "eqa.inhouse.panel.defaultName": "Bộ mẫu nội bộ",
  "eqa.inhouse.cycle": "Đợt",
  "eqa.inhouse.status": "Trạng thái",
  "eqa.inhouse.actions": "Thao tác",
  "eqa.inhouse.launchWizard": "Mở trình hướng dẫn mù",
  "eqa.inhouse.noSchemes": "Chưa có chương trình nội bộ nào. Hãy tạo một chương trình trong quản lý chương trình EQA trước.",
  "eqa.inhouse.labels.print": "In phiếu nhãn",
  "eqa.inhouse.labels.error": "Không tạo được phiếu nhãn",
  "eqa.inhouse.unblind.now": "Mở mù ngay",
  "eqa.inhouse.unblind.done": "Đã mở mù và chấm điểm bộ mẫu",
  "eqa.inhouse.unblind.error": "Không mở mù được bộ mẫu này",
  "eqa.inhouse.targetValues": "Giá trị mục tiêu",
  "eqa.inhouse.seal.sealed": "Đã niêm phong",
  "eqa.inhouse.seal.unsealed": "Chưa niêm phong",
  "eqa.inhouse.kpi.awaitingDistribution": "Đã niêm phong, chờ phân phối",
  "eqa.inhouse.kpi.inTesting": "Đang xét nghiệm",
  "eqa.inhouse.kpi.unblindingSoon": "Mở mù trong 7 ngày",
  "eqa.inhouse.kpi.closed": "Đã chấm điểm hoặc đã đóng",
  "eqa.inhouse.prep.title": "Chi tiết chuẩn bị & chia phần",
  "eqa.inhouse.prep.subtitle": "Ghi cùng các chi tiết tồn bộ mẫu mà đơn vị cung cấp vẫn ghi.",
  "eqa.inhouse.prep.required": "Yêu cầu: {samples, plural, one {# mẫu} other {# mẫu}} = tối thiểu {samples, plural, one {# phần chia} other {# phần chia}}",
  "eqa.inhouse.back": "Quay lại",
  "eqa.inhouse.next": "Tiếp",
  "eqa.inhouse.cancel": "Hủy",
  "eqa.enrollment.testAnalytes": "Chỉ tiêu báo cáo cho mỗi xét nghiệm",
  "eqa.enrollment.testAnalytes.help": "Chọn chỉ tiêu mà mỗi xét nghiệm báo cáo trong chương trình này. Kết quả được gửi cho đơn vị cung cấp theo chỉ tiêu này; xét nghiệm để trống sẽ không tự động gửi.",
  "eqa.enrollment.selectAnalyte": "Chọn một chỉ tiêu",
  "eqa.provider.schemes.title": "Các chương trình EQA chúng tôi cung cấp",
  "eqa.provider.schemes.hint": "Mở rộng một chương trình để xem các đợt, hoặc bắt đầu đợt mới để định nghĩa bộ mẫu và phòng XN tham gia.",
  "eqa.provider.schemes.none.title": "Chưa có chương trình để cung cấp",
  "eqa.provider.schemes.none.body": "Chương trình xuất hiện ở đây khi có phòng XN khác đang ghi danh tích cực vào nó.",
  "eqa.provider.schemes.provider": "Đơn vị cung cấp",
  "eqa.provider.schemes.enrolled": "Phòng XN đã ghi danh",
  "eqa.provider.schemes.cycles": "Đợt",
  "eqa.provider.schemes.expand": "Xem các đợt",
  "eqa.provider.schemes.newCycle": "Đợt mới",
  "eqa.provider.schemes.noCycles": "Chưa có đợt nào. Bắt đầu một đợt để định nghĩa bộ mẫu và phòng XN tham gia.",
  "eqa.scheme.type.international_pt": "PT quốc tế",
  "eqa.scheme.type.regional_pt": "PT khu vực",
  "eqa.scheme.type.inter_lab_split": "Chia mẫu liên phòng",
  "eqa.scheme.type.in_house": "Nội bộ",
  "eqa.panel.source.in_house_aliquoted": "Gộp mẫu bệnh nhân, chia phần tại phòng XN",
  "eqa.panel.source.vendor_sourced": "Vật liệu do nhà cung cấp",
  "eqa.panel.source.mixed": "Nguồn hỗn hợp",
  "eqa.panel.storage.ambient": "Nhiệt độ phòng",
  "eqa.panel.storage.refrigerated_2_8c": "Bảo quản lạnh, 2–8°C",
  "eqa.panel.storage.frozen_minus_20c": "Đông lạnh, −20°C",
  "eqa.panel.storage.ultra_frozen_minus_80c": "Siêu lạnh, −80°C",
  "eqa.panel.storage.dry_ice": "Đá khô",
  "eqa.provider.wizard.title": "Đợt mới",
  "eqa.provider.wizard.forScheme": "Đợt mới — {name}",
  "eqa.provider.wizard.step.cycle": "Đợt",
  "eqa.provider.wizard.step.panel": "Bộ mẫu",
  "eqa.provider.wizard.step.distribution": "Phân phối",
  "eqa.provider.wizard.cycleName": "Tên đợt",
  "eqa.provider.wizard.cycleNumber": "Số đợt",
  "eqa.provider.wizard.cycleNumber.hint": "Để trống thì dùng số chưa dùng kế tiếp của chương trình này.",
  "eqa.provider.wizard.panelName": "Tên bộ mẫu",
  "eqa.provider.wizard.source": "Nguồn vật liệu",
  "eqa.provider.wizard.lot": "Số LOT",
  "eqa.provider.wizard.vendor": "Tên nhà cung cấp",
  "eqa.provider.wizard.vendorLot": "LOT nhà cung cấp",
  "eqa.provider.wizard.vendorCertificate": "Mã chứng nhận của nhà cung cấp",
  "eqa.provider.wizard.sampleCode": "Mã mẫu",
  "eqa.provider.wizard.target": "Giá trị mục tiêu",
  "eqa.provider.wizard.target.hint": "Giá trị mục tiêu được niêm phong và mã hóa khi lưu; để trống nếu mục tiêu chỉ biết lúc chấm điểm.",
  "eqa.provider.wizard.unit": "Đơn vị",
  "eqa.provider.wizard.rangeLow": "Giới hạn chấp nhận dưới",
  "eqa.provider.wizard.rangeHigh": "Giới hạn chấp nhận trên",
  "eqa.provider.wizard.addSample": "Thêm mẫu",
  "eqa.provider.wizard.removeSample": "Xóa",
  "eqa.provider.wizard.sampleCount": "Mẫu của bộ",
  "eqa.provider.wizard.test": "Xét nghiệm",
  "eqa.provider.wizard.test.select": "Chọn xét nghiệm",
  "eqa.provider.wizard.participants": "Phòng XN tham gia",
  "eqa.provider.wizard.participants.hint": "Chỉ phòng XN đang ghi danh tích cực vào chương trình này mới được tham gia, và chỉ những phòng chọn ở đây mới được cổng chuẩn bị tính.",
  "eqa.provider.wizard.storageTemp": "Nhiệt độ bảo quản",
  "eqa.provider.wizard.storageTemp.hint": "Trở thành yêu cầu nhiệt độ của mỗi thùng vận chuyển.",
  "eqa.provider.wizard.storageTemp.select": "Chọn nhiệt độ",
  "eqa.provider.wizard.expiration": "Hạn sử dụng vật liệu",
  "eqa.provider.wizard.reserve.hint": "Phần chia giữ lại để xét nghiệm lặp được ghi trên màn làm việc chuẩn bị, khi vật liệu đã có.",
  "eqa.provider.wizard.confirm.hint": "Tạo đợt sẽ chuyển ngay sang chuẩn bị, nơi ghi số phần chia và QC độ đồng nhất.",
  "eqa.provider.wizard.create": "Tạo đợt và bắt đầu chuẩn bị",
  "eqa.provider.wizard.failed": "Chưa tạo được đợt.",
  "eqa.cycle.distributionMethod": "Cách phân phối",
  "eqa.cycle.distributionMethod.fhir": "FHIR",
  "eqa.cycle.distributionMethod.csv": "Xuất file CSV",
  "eqa.cycle.distributionMethod.mixed": "Hỗn hợp",
  "eqa.cycle.distributionMethod.hint": "Nối FHIR, xuất file, hoặc cả hai nếu các phòng XN khác nhau. Chuỗi lạnh của bộ mẫu được ghi cùng nguồn ở bước 2.",
  "eqa.cycle.history": "Lịch sử đợt",
  "eqa.cycle.history.empty": "Chưa ghi nhận thay đổi trạng thái nào cho đợt này.",
  "eqa.cycle.history.when": "Thời điểm",
  "eqa.cycle.history.state": "Trạng thái",
  "eqa.cycle.history.trigger": "Tác nhân kích hoạt",
  "eqa.cycle.history.reason": "Lý do",
  "eqa.cycle.history.manual": "Thủ công",
  "eqa.report.comments.tab": "Nhận xét báo cáo",
  "eqa.report.comments.hint": "Chỉ in được nhận xét đã phê duyệt sẵn. Sửa nội dung trong Quản trị → Quản lý từ điển.",
  "eqa.report.comments.picker": "Nhận xét đã phê duyệt",
  "eqa.report.comments.pickerLabel": "Chọn nhận xét",
  "eqa.report.comments.add": "Thêm vào báo cáo",
  "eqa.report.comments.added": "Đã thêm {count} nhận xét vào báo cáo",
  "eqa.report.comments.comment": "Nhận xét",
  "eqa.report.comments.attribution": "Người thêm",
  "eqa.report.comments.none": "Báo cáo của đợt này chưa có nhận xét nào.",
  "eqa.report.comments.remove": "Xóa",
  "eqa.report.comments.emptyLibrary.title": "Chưa cấu hình nhận xét đã phê duyệt",
  "eqa.report.comments.emptyLibrary.body": "Thêm mục vào nhóm từ điển Nhận xét báo cáo EQA để có thể chọn ở đây.",
  "eqa.report.comments.addFailed": "Không thêm được nhận xét vào báo cáo.",
  "eqa.report.comments.removeFailed": "Không xóa được nhận xét khỏi báo cáo.",
  "eqa.performance.ACCEPTABLE": "Đạt",
  "eqa.performance.QUESTIONABLE": "Đáng ngờ",
  "eqa.performance.UNACCEPTABLE": "Không đạt",
  "eqa.oversight.followUpQueue": "Theo dõi của phòng XN này",
  "eqa.oversight.queueSubtitle": "Điểm EQA đáng ngờ của phòng XN này đang chờ rà soát khắc phục, từ đơn vị ngoài và từ các chương trình nội bộ của phòng XN này. Trao đổi với các phòng XN tham gia chương trình mà phòng XN này cung cấp là một sổ khác:",
  "eqa.queue.policyTitle": "Chính sách tự động mở NCE đang bật.",
  "eqa.queue.policyBody": "Điểm không đạt ở bất kỳ chương trình EQA bên ngoài nào mà phòng XN này tham gia sẽ tự động mở một NCE. Hàng đợi này giữ vùng đáng ngờ (2 < |Z| ≤ 3) và các lỗi nội bộ, cần người phân loại.",
  "eqa.queue.kpi.queued": "Mục đang chờ",
  "eqa.queue.kpi.questionable": "Đáng ngờ",
  "eqa.queue.kpi.questionable.hint": "2 < |Z| ≤ 3",
  "eqa.queue.kpi.inHouse": "Lỗi nội bộ",
  "eqa.queue.kpi.oldest": "Cũ nhất",
  "eqa.queue.kpi.days": "{days} ngày",
  "eqa.queue.count": "Hàng đợi · {count, plural, one {# mục} other {# mục}}",
  "eqa.queue.exportCsv": "Xuất CSV",
  "eqa.queue.empty": "Không có mục nào chờ phân loại. Điểm đáng ngờ và lỗi nội bộ sẽ vào đây khi các đợt được chấm điểm.",
  "eqa.queue.cycle": "Đợt",
  "eqa.queue.cycleNumber": "Đợt {number}",
  "eqa.queue.analyte": "Chỉ tiêu",
  "eqa.queue.analytePlus": "{first} +{more} nữa",
  "eqa.queue.zScore": "Z-score",
  "eqa.queue.reason": "Lý do",
  "eqa.queue.enqueued": "Vào hàng đợi",
  "eqa.queue.source": "Nguồn",
  "eqa.queue.source.external": "Đơn vị cung cấp bên ngoài",
  "eqa.queue.source.in_house": "Nội bộ",
  "eqa.queue.source.inter_lab_split": "Chia mẫu liên phòng",
  "eqa.queue.reason.questionable": "Đáng ngờ",
  "eqa.queue.reason.inHouseFailure": "Nội bộ không đạt",
  "eqa.queue.triage": "Phân loại",
  "eqa.queue.triageTitle": "Phân loại mục này",
  "eqa.queue.triageHelp": "Chuyển lên NCE nếu nghi có sự không phù hợp thật. Bác bỏ kèm lý do nếu đây là nhiễu — lỗi chép kết quả, hoặc sự cố thiết bị đã được ghi nhận. Các mục bị bác bỏ vẫn gắn với đợt để truy vết công nhận.",
  "eqa.queue.reported": "Báo cáo",
  "eqa.queue.target": "Mục tiêu",
  "eqa.queue.verdict": "Kết luận",
  "eqa.queue.escalate": "Chuyển lên NCE",
  "eqa.queue.dismiss": "Bác bỏ kèm lý do",
  "eqa.queue.viewCycle": "Xem đợt",
  "eqa.queue.escalated": "Đã chuyển lên — đã mở NCE {nce} cho đợt này.",
  "eqa.queue.escalateFailed": "Việc chuyển lên đã bị từ chối.",
  "eqa.queue.dismissed": "Đã bác bỏ. Sự kiện năng lực của danh mục này đã được ghi nhận.",
  "eqa.queue.dismissFailed": "Việc bác bỏ đã bị từ chối.",
  "eqa.queue.dismissHeading": "Bác bỏ kèm lý do",
  "eqa.queue.dismissConfirm": "Bác bỏ",
  "eqa.queue.dismissHelp": "Danh mục quyết định sự kiện năng lực nào được ghi cho mỗi kết quả mà mục này bao gồm, vì vậy hãy chọn danh mục mô tả đúng điều đã xảy ra.",
  "eqa.queue.cancel": "Hủy",
  "eqa.queue.category": "Danh mục",
  "eqa.queue.category.TRANSCRIPTION_ERROR": "Lỗi chép kết quả",
  "eqa.queue.category.KNOWN_EQUIPMENT_ISSUE": "Sự cố thiết bị đã biết",
  "eqa.queue.category.PENDING_RE_TEST": "Chờ xét nghiệm lại",
  "eqa.queue.category.ACCEPTABLE_ON_REVIEW": "Đạt khi xem xét lại",
  "eqa.queue.category.OTHER": "Khác",
  "eqa.queue.notes": "Ghi chú",
  "eqa.labperf.title": "Hiệu quả phòng XN",
  "eqa.labperf.coverage.title": "Hiệu quả ngoại kiểm EQA của phòng XN — Độ phủ",
  "eqa.labperf.coverage.subtitle": "Ảnh chụp công nhận: các KPI toàn phòng XN, rồi độ phủ EQA theo nhóm xét nghiệm qua bốn đợt gần nhất của mỗi chương trình. Nhóm không có PT đang hoạt động là ứng viên cho đánh giá thay thế theo ISO 15189 §7.7.2.",
  "eqa.labperf.recent.title": "Hiệu quả ngoại kiểm EQA của phòng XN — Các đợt gần đây",
  "eqa.labperf.recent.subtitle": "Các đợt phòng XN đã báo cáo trong 12 tháng qua, kèm trạng thái chấm điểm và kết luận.",
  "eqa.labperf.tab.coverage": "Độ phủ",
  "eqa.labperf.tab.recent": "Các đợt gần đây",
  "eqa.labperf.kpi.acceptance": "Tỷ lệ đạt (12 tháng)",
  "eqa.labperf.kpi.delta": "{delta} so với năm trước",
  "eqa.labperf.kpi.noPriorYear": "không có năm trước để so sánh",
  "eqa.labperf.kpi.onTime": "Tỷ lệ nộp đúng hạn",
  "eqa.labperf.kpi.late": "{late} trễ / {total}",
  "eqa.labperf.kpi.nce": "NCE phát sinh từ EQA (12 tháng)",
  "eqa.labperf.kpi.nceOpen": "{open} đang mở → sổ NCE",
  "eqa.labperf.kpi.uncovered": "Xét nghiệm được công nhận nhưng không có EQA",
  "eqa.labperf.kpi.uncovered.hint": "Ứng viên §7.7.2",
  "eqa.labperf.openNceRegister": "Mở sổ NCE đã lọc theo sự kiện phát sinh từ EQA",
  "eqa.labperf.legendIntro": "Bốn đợt gần nhất của mỗi chương trình, theo nhóm.",
  "eqa.labperf.legend.acceptable": "Đạt",
  "eqa.labperf.legend.questionable": "Đáng ngờ",
  "eqa.labperf.legend.unacceptable": "Không đạt",
  "eqa.labperf.legend.missing": "Chưa ghi danh / bỏ lỡ",
  "eqa.labperf.section": "Nhóm",
  "eqa.labperf.unassignedSection": "Nhóm chưa gán",
  "eqa.labperf.scheme": "Chương trình",
  "eqa.labperf.cycle": "Đợt",
  "eqa.labperf.cycleOffset": "Đợt −{n}",
  "eqa.labperf.mostRecent": "Gần nhất",
  "eqa.labperf.acceptanceRate": "Tỷ lệ đạt",
  "eqa.labperf.coverage.empty": "Chưa có kết quả EQA nào được chấm. Độ phủ xuất hiện khi một đợt mà phòng XN này tham gia được chấm điểm.",
  "eqa.labperf.gapTitle": "Được công nhận nhưng không có EQA bao phủ:",
  "eqa.labperf.gapBody": "{tests} — không có ghi danh EQA đang hoạt động, nên cần đánh giá thay thế theo ISO 15189 §7.7.2.",
  "eqa.labperf.filterScheme": "Lọc chương trình",
  "eqa.labperf.status": "Trạng thái",
  "eqa.labperf.score": "Điểm",
  "eqa.labperf.scoreOf": "{acceptable} / {scored} đạt",
  "eqa.labperf.performance": "Hiệu quả",
  "eqa.labperf.submitted": "Đã gửi",
  "eqa.labperf.pending": "chờ",
  "eqa.labperf.verdict.acceptable": "Đạt",
  "eqa.labperf.verdict.questionable": "Đáng ngờ",
  "eqa.labperf.verdict.unacceptable": "Không đạt",
  "eqa.labperf.recent.empty": "Không có đợt nào được báo cáo trong 12 tháng qua.",
  "nce.filter.source": "Nguồn",
  "nce.filter.source.all": "Mọi nguồn",
  "nce.filter.source.eqa": "Phát sinh từ EQA",
  "eqa.receipt.tab": "Biên nhận & chấm điểm",
  "eqa.receipt.hint": "Việc nhận kết quả tự mở khi mọi phòng XN tham gia đã có bộ mẫu. Quá hạn nghĩa là đã quá hai ngày làm việc so với ngày giao dự kiến.",
  "eqa.receipt.noParticipants.body": "Biên nhận sẽ hiện ở đây khi bộ mẫu đã được gửi tới các phòng XN tham gia đã ghi danh.",
  "eqa.receipt.condition": "Tình trạng",
  "eqa.receipt.damaged": "Hư hỏng: {notes}",
  "eqa.receipt.tempOnArrival": "{temp} °C",
  "eqa.receipt.isRepeat": "Lô gửi lặp",
  "eqa.receipt.markReceived": "Đánh dấu đã nhận",
  "eqa.receipt.delivered": "Đã ghi nhận giao hàng.",
  "eqa.receipt.deliveredFailed": "Không ghi nhận được việc giao hàng.",
  "eqa.receipt.sendRepeat": "Gửi lặp",
  "eqa.receipt.repeatHeading": "Gửi bộ mẫu lặp",
  "eqa.receipt.repeatHelp": "Bộ lặp lấy từ phần dự phòng của bộ mẫu. Nếu phần dự phòng không đủ, cần giải trình bằng văn bản trước khi dùng vật liệu không dự phòng.",
  "eqa.receipt.overrideNote": "Ghi chú ngoại lệ",
  "eqa.receipt.repeatSent": "Đã gửi bộ mẫu lặp.",
  "eqa.receipt.repeatFailed": "Yêu cầu gửi lặp đã bị từ chối.",
  "eqa.receipt.status.NOT_SHIPPED": "Chưa gửi",
  "eqa.receipt.status.IN_TRANSIT": "Đang vận chuyển",
  "eqa.receipt.status.EXCEPTION": "Đến nơi bị hư hỏng",
  "eqa.score.scoreCycle": "Chấm điểm đợt",
  "eqa.score.scored": "Đã chấm điểm đợt. Các phòng XN không đạt nằm trong sổ theo dõi.",
  "eqa.score.scoreFailed": "Không chấm được đợt.",
  "eqa.score.verdicts": "Điểm số",
  "eqa.score.counts": "{unacceptable} không đạt / {total}",
  "eqa.score.sendScores": "Gửi điểm số",
  "eqa.score.distributed": "Điểm số đã được đưa vào kho FHIR để phòng XN tham gia lấy về.",
  "eqa.score.distributeFailed": "Không trả được điểm số.",
  "eqa.score.downloadCsv": "Điểm số CSV",
  "eqa.provider.followups.title": "Theo dõi phòng XN tham gia",
  "eqa.provider.followups.subtitle": "Các phòng XN tham gia chương trình mà phòng XN này cung cấp và có kết quả không đạt. Theo dõi tại đây là trao đổi với phòng XN khác — không bao giờ mở một sự không phù hợp trong sổ của chính phòng XN này.",
  "eqa.provider.followups.open": "Sổ theo dõi",
  "eqa.provider.followups.empty": "Không có theo dõi phòng XN tham gia nào. Mục sẽ hiện ở đây khi các đợt của đơn vị cung cấp được chấm điểm.",
  "eqa.provider.followups.unknownOrg": "Phòng XN chưa rõ",
  "eqa.provider.followups.persistent": "Không đạt kéo dài",
  "eqa.provider.followups.response": "Phản hồi",
  "eqa.provider.followups.notify": "Thông báo phòng XN",
  "eqa.provider.followups.emailed": "Đã gửi email thông báo tới {to}.",
  "eqa.provider.followups.csvFallback": "Chưa có email liên hệ — thông báo đã tải về dạng CSV để gửi tay.",
  "eqa.provider.followups.flagRepeat": "Đánh dấu cho lần lặp",
  "eqa.provider.followups.repeatSent": "Đã gửi bộ mẫu lặp tới {name}.",
  "eqa.provider.followups.moved": "Đã chuyển theo dõi sang {status}.",
  "eqa.provider.followups.failed": "Thao tác đã bị từ chối.",
  "eqa.provider.followups.notesHelp": "Những gì đã thống nhất với phòng XN. Được ghi vào mục sổ để truy vết công nhận.",
  "eqa.provider.followups.status.NOTIFIED": "Đã thông báo",
  "eqa.provider.followups.status.RESPONSE_RECEIVED": "Đã nhận phản hồi",
  "eqa.provider.followups.status.UNDER_INVESTIGATION": "Đang điều tra",
  "eqa.provider.followups.status.ESCALATED": "Đã chuyển lên",
  "eqa.provider.followups.status.REMOVED_FROM_PROGRAM": "Đã gỡ khỏi chương trình",
  "eqa.provider.followups.action.RESPONSE_RECEIVED": "Ghi nhận phản hồi",
  "eqa.provider.followups.action.UNDER_INVESTIGATION": "Điều tra",
  "eqa.provider.followups.action.RESOLVED": "Giải quyết",
  "eqa.provider.followups.action.REMOVED_FROM_PROGRAM": "Gỡ khỏi chương trình",
  "eqa.competency.subtitle": "Mọi kỹ thuật viên được phân công làm thử nghiệm thành thạo trong 12 tháng qua, xếp loại theo từng chỉ tiêu. Kỹ thuật viên chỉ được coi là đủ năng lực khi bằng chứng cho thấy vậy — dưới bốn mẫu đánh giá được thì xếp là đang xem xét, không phải đạt.",
  "eqa.competency.band.competent": "Đủ năng lực",
  "eqa.competency.band.underReview": "Đang xem xét",
  "eqa.competency.band.notCompetent": "Không đủ năng lực",
  "eqa.competency.outcome.acceptable": "Đạt",
  "eqa.competency.outcome.questionable": "Đáng ngờ",
  "eqa.competency.outcome.unacceptable": "Không đạt",
  "eqa.competency.outcome.missed": "Trễ hạn",
  "eqa.competency.outcome.dismissed": "Bác bỏ khi phân loại",
  "eqa.competency.event.scored": "Kết quả đã chấm",
  "eqa.competency.event.UNACCEPTABLE_SCORE": "Điểm không đạt",
  "eqa.competency.event.QUESTIONABLE_SCORE": "Điểm đáng ngờ",
  "eqa.competency.event.EXTERNAL_MISSED_DEADLINE": "Trễ hạn của đơn vị cung cấp",
  "eqa.competency.event.IN_HOUSE_MISSED_DEADLINE": "Trễ hạn nội bộ",
  "eqa.competency.event.ESCALATED_TO_NCE": "Đã chuyển lên sự không phù hợp",
  "eqa.competency.event.DISMISSED_EQUIPMENT": "Bác bỏ — thiết bị",
  "eqa.competency.event.DISMISSED_TRANSCRIPTION": "Bác bỏ — chép kết quả",
  "eqa.competency.event.DISMISSED_ACCEPTABLE_ON_REVIEW": "Bác bỏ — đạt khi xem xét",
  "eqa.competency.event.DISMISSED_OTHER": "Bác bỏ — khác",
  "eqa.competency.kpi.analysts": "Kỹ thuật viên được đánh giá",
  "eqa.competency.kpi.samples": "{count} mẫu PT",
  "eqa.competency.kpi.notCompetent.hint": "NCE đang mở đã chuyển",
  "eqa.competency.search": "Lọc kỹ thuật viên",
  "eqa.competency.export": "Xuất CSV",
  "eqa.competency.analyst": "Kỹ thuật viên",
  "eqa.competency.samples": "Mẫu PT (12 tháng)",
  "eqa.competency.recent": "Hiệu quả gần nhất",
  "eqa.competency.status": "Năng lực",
  "eqa.competency.history": "Lịch sử",
  "eqa.competency.viewHistory": "Xem lịch sử",
  "eqa.competency.empty": "Chưa ghi nhận kỹ thuật viên nào trên kết quả EQA trong 12 tháng qua. Kỹ thuật viên sẽ hiện ở đây khi kết quả có gán kỹ thuật viên.",
  "eqa.competency.analyteCount": "{count} chỉ tiêu được đánh giá",
  "eqa.competency.thisYear": "{count} trong năm nay · {failures} không đạt",
  "eqa.competency.byAnalyte": "Năng lực theo chỉ tiêu",
  "eqa.competency.analyte": "Chỉ tiêu",
  "eqa.competency.evaluable": "Đánh giá được",
  "eqa.competency.failures": "Không đạt",
  "eqa.competency.latest": "Gần nhất",
  "eqa.competency.unnamedAnalyte": "Chỉ tiêu chưa đặt tên",
  "eqa.competency.evidence": "Bằng chứng · mọi sự kiện trong khoảng thời gian",
  "eqa.competency.date": "Ngày",
  "eqa.competency.scheme": "Chương trình",
  "eqa.competency.event": "Sự kiện",
  "eqa.competency.outcome": "Kết quả",
  "eqa.competency.counted": "Tính vào",
  "eqa.competency.countsFail": "Không đạt",
  "eqa.competency.countsPass": "Được đánh giá",
  "eqa.competency.countsExcused": "Miễn tính",
  "eqa.result.analyst": "Kỹ thuật viên (EQA)",
  "eqa.result.analystChoose": "Chọn kỹ thuật viên",
  "eqa.result.analystRequired": "Chương trình EQA này ghi ai đã chạy từng mẫu. Hãy chọn kỹ thuật viên trước khi lưu.",
  "eqa.program.perAnalyst": "Ghi kỹ thuật viên cho mọi kết quả",
  "eqa.program.perAnalyst.on": "Đã ghi kỹ thuật viên",
  "eqa.program.perAnalyst.off": "Không ghi",
  "eqa.result.analyst.tooltip": "Hiển thị vì lần chạy này có mẫu EQA thuộc chương trình ghi ai đã chạy từng mẫu. Chọn người dùng OpenELIS đã chạy mẫu, từ danh sách kỹ thuật viên của chương trình — đây là bản ghi tách biệt với người nhập và người duyệt kết quả này. Các dòng không thuộc EQA không cần nhập.",
  "shipment.settings.siteOrgUnsetTitle": "Chưa đặt tổ chức của phòng XN",
  "shipment.settings.siteOrgUnsetSubtitle": "Lô hàng đến không được lọc theo phòng XN này và thùng gửi đi không ghi người gửi. Hãy chọn tổ chức đại diện cho phòng XN này.",
  "shipment.settings.siteOrgUnmatchedTitle": "Đang đặt thành một tổ chức mà instance này không có",
  "shipment.settings.siteOrgUnmatchedSubtitle": "UUID bên dưới là mã mà đối tác dùng để gọi phòng XN này, và nó không khớp với tổ chức nào ở đây. Lọc vẫn hoạt động; hãy giữ nguyên trừ khi đối tác đổi mã.",
  "eqa.receipt.openSubmissions": "Mở nhận kết quả",
  "eqa.receipt.openSubmissionsHeading": "Mở nhận kết quả khi còn bộ mẫu chưa giao",
  "eqa.receipt.openSubmissionsHelp": "Các phòng XN tham gia chưa nhận được bộ mẫu sẽ vẫn nằm trong danh sách và được tính là trễ. Đây là thao tác ghi đè thủ công có ghi nhận — hãy nêu lý do.",
  "eqa.receipt.openSubmissionsReason": "Lý do",
  "eqa.receipt.submissionsOpened": "Đã mở nhận kết quả.",
  "eqa.receipt.submissionsOpenFailed": "Không mở được nhận kết quả.",
  "eqa.provider.schemes.lastDistribution": "Lần phân phối gần nhất",
  "eqa.provider.wizard.distributionDate": "Ngày phân phối",
  "eqa.provider.wizard.submissionDeadline": "Hạn nộp kết quả",
  "eqa.provider.kpi.activeSchemes": "Chương trình đang hoạt động",
  "eqa.provider.kpi.openCycles": "Đợt đang mở",
  "eqa.provider.kpi.enrolled": "Phòng XN đã ghi danh",
  "eqa.provider.kpi.followupsOpen": "Theo dõi đang mở",
  "eqa.provider.schemes.discipline": "Lĩnh vực",
  "eqa.cycle.history.actor": "Người thực hiện",
  "eqa.cycle.history.systemActor": "Hệ thống",
  "eqa.prep.reserved.recommend": "Khuyến nghị {n}: max(10% phòng XN, 5)",
  "eqa.provider.schemes.participantOnly.title": "Chỉ xem với tư cách phòng XN tham gia",
  "eqa.provider.schemes.participantOnly.body": "Quản trị chương trình cung cấp cần quyền của đơn vị cung cấp. Việc tham gia của phòng XN bạn nằm ở các trang dưới đây.",
  "eqa.provider.schemes.link.myPrograms": "Ghi danh của tôi — các chương trình phòng XN này tham gia",
  "eqa.provider.schemes.link.myCycles": "Các đợt của tôi — bộ mẫu, kết quả và hạn chót",
  "eqa.btn.newCycle": "Đợt mới",
  "eqa.cycle.new.heading": "Đợt EQA mới",
  "eqa.cycle.new.help": "Với đơn vị cung cấp không gửi lô hàng tới OpenELIS này: ghi đợt mà bộ mẫu thuộc về để nó hiện ở đây với \"Nhận bộ mẫu\". Lô hàng từ một đơn vị cung cấp dùng OpenELIS sẽ tự mở đợt khi nhập.",
  "eqa.cycle.new.scheme": "Chương trình (từ Chương trình EQA của tôi)",
  "eqa.cycle.new.name": "Tên đợt",
  "eqa.cycle.new.distributionDate": "Ngày phân phối",
  "eqa.cycle.new.deadline": "Hạn nộp kết quả",
  "eqa.cycle.new.create": "Tạo đợt",
  "eqa.cycle.new.created": "Đã tạo đợt. Đợt được liệt kê là Đã lên kế hoạch; dùng \"Nhận bộ mẫu\" khi bộ mẫu đến.",
  "eqa.cycle.new.error": "Không tạo được đợt",
  "eqa.cycle.new.noPrograms": "Hãy ghi danh vào một chương trình trong Chương trình EQA của tôi trước.",
  "eqa.order.receipt.consignment": "Lô hàng đến",
  "eqa.order.receipt.consignment.none": "Không có — nhận ngoài module vận chuyển",
  "eqa.order.receipt.consignment.thisCycle": "đợt này",
  "eqa.order.receipt.consignment.help": "Chọn lô hàng là nhận giao lô hàng đó và thông báo cho đơn vị cung cấp rằng bộ mẫu đã đến.",
  "eqa.order.receipt.reference": "Mã vận chuyển",
  "eqa.order.receipt.referenceRecorded": "Đã nhận lô hàng {code}.",
  "eqa.intake.enterResults": "Nhập kết quả",
  "eqa.intake.heading": "Kết quả từ {lab}",
  "eqa.intake.help": "Nhập các giá trị đúng như phòng XN báo cáo — số, hoặc chữ như Reactive. Lưu sẽ ghi đè những gì đang có cho xét nghiệm đó.",
  "eqa.intake.test": "Xét nghiệm",
  "eqa.intake.value": "Giá trị báo cáo",
  "eqa.intake.save": "Lưu kết quả",
  "eqa.intake.saved": "Đã ghi nhận kết quả cho {lab}.",
  "eqa.intake.failed": "Không ghi nhận được kết quả",
  "eqa.intake.csv": "Hoặc dán gói xuất CSV của phòng XN tham gia",
  "eqa.intake.import": "Nhập CSV",
  "eqa.intake.imported": "{count, plural, other {Đã nhập # giá trị.}}",
  "eqa.intake.noTests": "Chương trình này chưa gán xét nghiệm nào.",
  "eqa.cycle.importScores": "Nhập điểm số (CSV)",
  "eqa.cycle.importScores.heading": "Nhập điểm số của đơn vị cung cấp",
  "eqa.cycle.importScores.help": "Dán file CSV điểm số đơn vị cung cấp đã gửi (các cột analyte_name và performance_status). Điểm số từ đơn vị cung cấp dùng OpenELIS sẽ tự về qua kho FHIR.",
  "eqa.cycle.importScores.csv": "CSV điểm số",
  "eqa.cycle.importScores.import": "Nhập điểm số",
  "eqa.cycle.importScores.imported": "Đã ghi nhận {count} điểm số.",
  "eqa.cycle.importScores.unmapped": "Không nhận diện được ở đây: {names}",
  "eqa.cycle.importScores.failed": "Không nhập được điểm số",
  "eqa.program.schemeType": "Loại chương trình",
  "eqa.program.schemeType.helper": "Chương trình nội bộ do phòng XN này tự chạy và không cần đơn vị cung cấp; mọi loại khác thì cần.",
  "eqa.order.receipt.notes.required": "Ghi rõ vật liệu có vấn đề gì. Biên nhận đánh dấu không nguyên vẹn cần ghi chú giải thích.",
  "eqa.provider.wizard.cycleName.required": "Đợt cần có tên.",
  "eqa.provider.wizard.dates.required": "Đợt cần cả ngày phân phối và hạn nộp kết quả; hạn nộp là mốc để gửi các nhắc nhở.",
  "eqa.enrollment.scheme": "Chương trình",
  "eqa.enrollment.scheme.helper": "Chọn một chương trình instance này có, hoặc chọn Không có trong danh sách và gõ tên.",
  "eqa.enrollment.scheme.frozen": "Ghi danh này đã có đợt, nên không thể đổi chương trình và đơn vị cung cấp.",
  "eqa.enrollment.scheme.other": "Không có trong danh sách - gõ tên",
  "eqa.action.forbidden": "Thao tác này cần quyền {grant}, mà tài khoản của bạn không có. Hãy yêu cầu quản trị viên cấp quyền.",
  "eqa.receipt.readOnly.title": "Chỉ xem biên nhận và điểm số",
  "eqa.receipt.readOnly.body": "Ghi nhận giao hàng, gửi lặp, nhập kết quả và trả điểm số đều cần quyền đơn vị cung cấp; chấm điểm đợt cần quyền quản lý. Bảng dưới đây là toàn bộ đợt trong cả hai trường hợp.",
  "eqa.inhouse.readOnly.title": "Chỉ xem bộ mẫu nội bộ",
  "eqa.inhouse.readOnly.body": "Thiết kế và niêm phong bộ mẫu mù cần quyền quản lý. Các bộ mẫu bên dưới là toàn bộ bức tranh trong cả hai trường hợp.",
  "eqa.score.downloadReport": "Báo cáo PDF",
  "eqa.labperf.exportCsv": "Xuất CSV",
  "eqa.labperf.kpi.submitted": "Các đợt đã gửi",
  "eqa.labperf.acceptableOf": "Đạt trên tổng đã chấm",
  "eqa.labperf.kpi.lateCount": "Các lần gửi trễ",
  "eqa.labperf.kpi.nceOpenCount": "Trong số đó, còn mở",
  "eqa.queue.source.all": "Mọi nguồn",
  "eqa.queue.countFiltered": "Hàng đợi · {count} / {total, plural, one {# mục} other {# mục}}",
  "eqa.queue.emptyForSource": "Không có mục nào từ nguồn này đang chờ phân loại. Hàng đợi có {total, plural, one {# mục} other {# mục}} từ các nguồn khác.",
  "eqa.program.requiresCycleReview": "Giữ mỗi đợt để xem xét trước khi gửi",
  "eqa.program.requiresCycleReview.off": "Tự động gửi",
  "eqa.program.requiresCycleReview.on": "Giữ để xem xét",
  "eqa.cycle.submitManual": "Gửi thủ công",
  "eqa.cycle.submitManual.heading": "Ghi nhận bản gửi làm bằng tay",
  "eqa.cycle.submitManual.help": "Dùng khi kết quả đã đến đơn vị cung cấp bằng cách khác. Mã tham chiếu họ đưa cho bạn là thứ biến việc này thành bản ghi chứ không phải lời khai, nên bắt buộc có.",
  "eqa.cycle.submitManual.reference": "Mã tham chiếu của đơn vị cung cấp",
  "eqa.cycle.submitManual.success": "Đã ghi nhận là đã gửi thủ công, kèm mã tham chiếu của đơn vị cung cấp.",
  "eqa.cycle.retriesSpent.title": "Tự động gửi đã dừng cho đợt này.",
  "eqa.cycle.retriesSpent.body": "Đã thất bại {attempts} lần và sẽ không thử lại. Hãy tự gửi kết quả cho đơn vị cung cấp — gói xuất nằm ở trang của chương trình — và ghi mã tham chiếu của họ tại đây.",
  "eqa.provider.wizard.sampleCode.duplicate": "Mỗi mã mẫu trong một bộ mẫu phải khác nhau.",
  "eqa.provider.wizard.rangeHigh.backwards": "Giới hạn trên của khoảng chấp nhận không thể thấp hơn giới hạn dưới.",
  "eqa.shipment.packList.panelColumn": "Bộ mẫu",
  "eqa.provider.schemes.performance": "Hiệu quả",
  "eqa.performance.title": "Hiệu quả phòng XN tham gia",
  "eqa.performance.subtitle": "Tỷ lệ đạt của mỗi phòng XN qua bốn đợt đã chấm gần nhất trong chương trình này. Mở rộng một dòng để xem các đợt tạo nên tỷ lệ.",
  "eqa.performance.laboratory": "Phòng XN",
  "eqa.performance.region": "Khu vực",
  "eqa.performance.enrollment": "Ghi danh",
  "eqa.performance.passRate": "Tỷ lệ đạt (4 đợt gần nhất)",
  "eqa.performance.mostRecent": "Gần nhất",
  "eqa.performance.openFollowups": "Theo dõi đang mở",
  "eqa.performance.expand": "Lịch sử đợt",
  "eqa.performance.ofJudged": "{accepted} / {judged}",
  "eqa.performance.noRate": "Chưa có đợt nào được chấm",
  "eqa.performance.noCycles": "Phòng XN này chưa báo cáo vào đợt nào đã chấm.",
  "eqa.performance.empty": "Chưa có phòng XN nào ghi danh vào chương trình này.",
  "eqa.performance.loadFailed": "Không tải được hiệu quả phòng XN tham gia",
  "eqa.myPrograms.group.active": "Ghi danh đang hoạt động ({count})",
  "eqa.order.coverage.title": "Ngoài phạm vi ghi danh của phòng XN này",
  "eqa.order.coverage.subtitle": "Ghi danh cho chương trình này không bao gồm: {tests}. Bạn vẫn có thể lưu chỉ định.",
  "eqa.myPrograms.group.suspended": "Ghi danh đã tạm ngưng ({count})",
  "eqa.myPrograms.group.withdrawn": "Ghi danh đã rút ({count})",
  "eqa.enrollment.resume": "Tiếp tục",
  "eqa.enrollment.statusReason": "Lý do",
  "eqa.enrollment.statusReasonPlaceholder": "Vì sao ghi danh này đổi trạng thái?",
  "eqa.enrollment.statusEffectiveDate": "Có hiệu lực từ",
  "eqa.enrollment.withdrawIsFinal": "Rút ghi danh là vĩnh viễn. Để tham gia lại, phòng XN này phải ghi danh lại chương trình từ đầu.",
  "eqa.enrollment.statusChanged": "Ghi danh này hiện là {status}",
  "eqa.enrollment.statusChangeFailed": "Không đổi được trạng thái ghi danh này",
  "eqa.enrollment.panels.help": "Các bộ xét nghiệm chuẩn từ danh mục. Đây là thứ phòng XN báo cáo, không phải vật liệu EQA đơn vị cung cấp gửi cho bạn.",
  "eqa.myPrograms.panels.help": "Các bộ xét nghiệm trong danh mục mà ghi danh này bao gồm.",
  "eqa.score.scoredWithUnjudged": "Đợt đã chấm, nhưng {count} kết quả không có kết luận, ở {tests}. Các chỉ tiêu đó không có mục tiêu niêm phong và đợt có quá ít đồng nghiệp để đặt chúng vào.",
  "eqa.cycle.close": "Đóng đợt",
  "eqa.cycle.closeHeading": "Đóng đợt này",
  "eqa.cycle.closeHelp": "Đợt đã đóng là kết thúc: người tham gia thấy đợt đã đóng và không ghi thêm kết luận nào. Không thể đóng khi còn theo dõi đang mở hoặc kết quả trễ hạn còn chờ phản hồi.",
  "eqa.cycle.closeFailed": "Không đóng được đợt này",
  "eqa.prep.ofTotal": "{n} / {total}",
  "eqa.prep.tile.participants": "Phòng XN đã ghi danh được chọn cho đợt này",
  "eqa.prep.tile.panels": "Bộ mẫu đã chuẩn bị",
  "eqa.prep.dispatched": "Gói hàng đã gửi tới phòng XN tham gia",
  "eqa.prep.readyToShip.blockedByGate": "Chuẩn bị chưa hoàn tất. Cổng sẵn sàng gửi ở trên liệt kê những mục còn thiếu.",
  "eqa.prep.readyToShip.notInPrep": "Trạng thái đợt: {status}. Chỉ cho phép xác nhận sẵn sàng gửi khi đợt đang chuẩn bị.",
  "eqa.prep.goToShipments": "Mở tab Vận chuyển",
  "eqa.competency.rule.meetsEvidence": "Đủ bằng chứng",
  "eqa.competency.rule.repeatedFailure": "Không đạt lặp lại",
  "eqa.competency.rule.insufficientEvidence": "Thiếu bằng chứng",
  "eqa.competency.rule.openEscalation": "Sự không phù hợp đang mở",
  "eqa.competency.reason.meetsEvidence": "{evaluable} mẫu đánh giá được với {failures} lần không đạt từ {from} đến {to}, đạt hoặc vượt ngưỡng bằng chứng tối thiểu {floor}. Không cần xử lý.",
  "eqa.competency.reason.repeatedFailure": "{failures} lần không đạt trong {evaluable} mẫu đánh giá được từ {from} đến {to}. Đây là vấn đề về năng lực: rà soát các kết quả không đạt rồi mở sự không phù hợp, hoặc bác bỏ khi phân loại.",
  "eqa.competency.reason.insufficientEvidence": "{evaluable} mẫu đánh giá được từ {from} đến {to}, chưa đạt ngưỡng bằng chứng tối thiểu {floor}. Đây không phải vấn đề về năng lực: hãy phân thêm mẫu thử thành thạo cho kỹ thuật viên này.",
  "eqa.competency.reason.openEscalation": "Một sự không phù hợp đã chuyển lên, mở từ {from} đến {to}, vẫn đang mở, trên {evaluable} mẫu đánh giá được với {failures} lần không đạt. Đóng sự không phù hợp để gỡ mức xếp loại.",
  "eqa.competency.whatIsAnAnalyst": "Kỹ thuật viên là tài khoản người dùng OpenELIS trong danh sách kỹ thuật viên của chương trình, được ghi trên mẫu mà người đó đã chạy. Đây là bản ghi tách biệt với người nhập và người duyệt kết quả.",
  "eqa.inhouse.roster.help": "Kỹ thuật viên là tài khoản người dùng OpenELIS. Mọi người được chọn ở đây sẽ vào danh sách kỹ thuật viên của chương trình này và có thể được gán mẫu để chạy; danh sách này tách biệt với người nhập và người duyệt kết quả.",
  "banner.menu.eqa.providerFollowups": "Theo dõi phòng XN tham gia",
  "eqa.oversight.queueSubtitle.link": "Theo dõi phòng XN tham gia",
  "eqa.inhouse.sealed.deadline": "Ngày mở mù và hạn để kỹ thuật viên nộp kết quả: {date}",
  "eqa.inhouse.sealed.analysts": "Kỹ thuật viên được gán: {names}",
  "eqa.inhouse.sealed.noAnalysts": "Chưa gán kỹ thuật viên cho mẫu nào trong bộ này.",
  "eqa.inhouse.sealed.toMyCycles": "Mở Các đợt của tôi",
  "eqa.inhouse.sealed.toWorkplan": "Mở Phiếu công việc",
  "analyzerType.editor.heading": "Cài đặt hồ sơ",
  "analyzerType.editor.choose": "Chọn…",
  "analyzerType.editor.version": "Phiên bản hồ sơ",
  "analyzerType.editor.confidence": "Độ tin cậy bằng chứng",
  "analyzerType.editor.category": "Lĩnh vực xét nghiệm",
  "analyzerType.editor.inboundResults": "Nhận kết quả từ máy",
  "analyzerType.editor.outboundOrders": "Gửi chỉ định tới máy",
  "analyzerType.editor.connectionTest": "Hỗ trợ kiểm tra kết nối",
  "analyzerType.editor.fileHeading": "Phân tích tệp",
  "analyzerType.editor.fileFormat": "Định dạng tệp của hồ sơ",
  "analyzerType.editor.defaultFileFormat": "Định dạng tệp mặc định",
  "analyzerType.editor.filePattern": "Mẫu tên tệp",
  "analyzerType.editor.hasHeader": "Dòng đầu chứa tên cột",
  "analyzerType.editor.delimiter": "Ký tự phân cách cột",
  "analyzerType.editor.encoding": "Mã hóa ký tự",
  "analyzerType.editor.sheetIndex": "Số thứ tự sheet (bắt đầu từ 0)",
  "analyzerType.editor.skipRows": "Số dòng bỏ qua",
  "analyzerType.editor.extensions": "Phần mở rộng tệp được hỗ trợ",
  "analyzerType.editor.columns": "Cột của tệp",
  "analyzerType.editor.columnsHelp": "Khớp tên cột trong tệp xuất với các trường kết quả bên dưới. Giữ nguyên chính tả và dấu câu.",
  "analyzerType.editor.columnNumber": "Cột tệp {number}",
  "analyzerType.editor.columnName": "Tên cột trong tệp",
  "analyzerType.editor.columnField": "Ý nghĩa của cột",
  "analyzerType.editor.removeColumn": "Xóa cột",
  "analyzerType.editor.columnsInvalid": "Mỗi cột cần một tên duy nhất và một ý nghĩa đã chọn.",
  "analyzerType.editor.addColumn": "Thêm cột",
  "analyzerType.editor.resultOrder": "Ưu tiên giá trị kết quả (giá trị có sẵn đầu tiên được chọn)",
  "analyzerType.editor.communicationHeading": "Mặc định giao tiếp",
  "analyzerType.editor.analyzerName": "Tên máy trong thông điệp",
  "analyzerType.editor.identifierPattern": "Mẫu định danh máy",
  "analyzerType.editor.protocolVersion": "Phiên bản giao thức",
  "analyzerType.editor.lowerLayerVersion": "Phiên bản khung ASTM",
  "analyzerType.editor.msh3Pattern": "Mẫu ứng dụng gửi (MSH-3)",
  "analyzerType.editor.communicationMode": "Bên khởi tạo giao tiếp",
  "analyzerType.editor.lisInitiated": "Cho phép hệ thống phòng XN khởi tạo giao tiếp",
  "analyzerType.editor.connectionRole": "Vai trò kết nối mặc định",
  "analyzerType.editor.transport": "Phương thức truyền mặc định",
  "analyzerType.editor.port": "Cổng gửi đi mặc định (không bắt buộc)",
  "analyzerType.editor.aggregationMode": "Gom nhóm kết quả",
  "analyzerType.editor.aggregationWindowSeconds": "Khoảng thời gian gom nhóm kết quả (giây)",
  "analyzerType.editor.connectionFields": "Trường hiển thị khi thiết lập kết nối",
  "analyzerType.editor.connectionFieldsHelp": "Các trường này mô tả cài đặt mà phòng XN cung cấp cho mỗi kết nối. Kết nối kiểu FILE cần một trường thư mục cho thư mục được theo dõi trên Bridge. Nhãn dùng khóa dịch của ứng dụng. Lựa chọn giữ nguyên kiểu giá trị; điều kiện hiển thị tham chiếu tới một cài đặt khác.",
  "analyzerType.editor.connectionFieldNumber": "Trường kết nối {number}",
  "analyzerType.editor.fieldKey": "Tên cài đặt",
  "analyzerType.editor.fieldLabel": "Khóa dịch nhãn",
  "analyzerType.editor.inputKind": "Kiểu nhập",
  "analyzerType.editor.required": "Bắt buộc khi thiết lập kết nối",
  "analyzerType.editor.addField": "Thêm trường kết nối",
  "analyzerType.editor.removeField": "Xóa trường kết nối",
  "analyzerType.editor.save": "Lưu và kiểm tra cài đặt hồ sơ",
  "analyzerType.editor.saved": "Đã lưu cài đặt hồ sơ",
  "analyzerType.editor.saveBeforeRecognition": "Lưu cài đặt hồ sơ trước khi sửa nhận diện mẫu kiểm soát hoặc xuất bản.",
  "analyzerType.editor.loadError": "Không tải lại được bản nháp. Các chỉnh sửa chưa lưu của bạn vẫn còn đây.",
  "analyzerType.editor.saveError": "Không lưu được bản nháp. Chỉnh sửa của bạn vẫn còn đây; hãy thử lưu lại.",
  "analyzerType.editor.conflict": "Bản nháp đã thay đổi kể từ khi bạn mở. Chỉnh sửa của bạn chưa được gửi đi. Hãy tải lại bản nháp đã lưu trước khi thay đổi thêm.",
  "analyzerType.editor.error": "Không lưu được hồ sơ",
  "analyzerType.editor.reload": "Tải lại bản nháp đã lưu và bỏ chỉnh sửa tại chỗ",
  "analyzerType.editor.validation": "Hồ sơ cần xem lại",
  "analyzerType.editor.add": "Thêm giá trị",
  "analyzerType.editor.remove": "Xóa giá trị",
  "analyzerType.editor.semantic.sampleId": "Định danh mẫu",
  "analyzerType.editor.semantic.testCode": "Mã xét nghiệm của máy",
  "analyzerType.editor.semantic.qcTask": "Tác vụ mẫu kiểm soát",
  "analyzerType.editor.semantic.ctValue": "Ngưỡng chu kỳ (Ct)",
  "analyzerType.editor.inputKind.TEXT": "Văn bản",
  "analyzerType.editor.inputKind.NUMBER": "Số",
  "analyzerType.editor.inputKind.SELECT": "Danh sách chọn",
  "analyzerType.editor.inputKind.BOOLEAN": "Có hoặc không",
  "analyzerType.editor.inputKind.SECRET": "Bí mật",
  "analyzerType.editor.inputKind.FILE_PATH": "Đường dẫn thư mục hoặc tệp",
  "analyzerType.editor.testDefinitions": "Định nghĩa xét nghiệm của máy",
  "analyzerType.editor.testDefinitionsHelp": "Liệt kê mã xét nghiệm và giá trị kết quả mà máy báo cáo. Các định nghĩa này chỉ cung cấp gợi ý để khớp với danh mục xét nghiệm của phòng XN; chúng không tạo mới hay thay đổi xét nghiệm của phòng XN.",
  "analyzerType.editor.testNumber": "Xét nghiệm máy {number}",
  "analyzerType.editor.testCode": "Mã xét nghiệm của máy",
  "analyzerType.editor.testName": "Tên xét nghiệm gợi ý",
  "analyzerType.editor.loinc": "Mã LOINC",
  "analyzerType.editor.testUnit": "Đơn vị báo cáo",
  "analyzerType.editor.resultType": "Kiểu giá trị báo cáo",
  "analyzerType.editor.resultType.quantitative": "Đo lường bằng số",
  "analyzerType.editor.resultType.qualitative": "Kết quả dạng tên",
  "analyzerType.editor.resultType.text": "Kết quả văn bản tự do",
  "analyzerType.editor.testAliases": "Mã khác cho cùng xét nghiệm này",
  "analyzerType.editor.testValues": "Giá trị kết quả máy báo cáo cho xét nghiệm này",
  "analyzerType.editor.removeTest": "Xóa xét nghiệm của máy",
  "analyzerType.editor.addTest": "Thêm xét nghiệm của máy",
  "analyzerType.editor.choices": "Lựa chọn kết nối",
  "analyzerType.editor.choiceNumber": "Lựa chọn {number}",
  "analyzerType.editor.choiceValue": "Giá trị lựa chọn",
  "analyzerType.editor.addChoice": "Thêm lựa chọn",
  "analyzerType.editor.removeChoice": "Xóa lựa chọn",
  "analyzerType.editor.visibility": "Hiển thị trường kết nối này khi",
  "analyzerType.editor.controllingField": "Cài đặt điều khiển",
  "analyzerType.editor.comparison": "So sánh",
  "analyzerType.editor.comparisonValue": "Giá trị so sánh",
  "analyzerType.editor.comparison.EQUALS": "Bằng",
  "analyzerType.editor.comparison.NOT_EQUALS": "Không bằng",
  "analyzerType.editor.comparison.IN": "Thuộc một trong các giá trị",
  "analyzerType.editor.comparison.NOT_IN": "Không thuộc các giá trị",
  "analyzerType.editor.addCondition": "Thêm điều kiện hiển thị",
  "analyzerType.editor.removeCondition": "Xóa điều kiện hiển thị",
  "analyzerType.editor.valueType": "Kiểu giá trị",
  "analyzerType.editor.valueType.string": "Giá trị văn bản",
  "analyzerType.editor.valueType.boolean": "Giá trị đúng/sai",
  "analyzerType.editor.valueType.array": "Giá trị danh sách",
  "analyzerType.editor.valueType.object": "Giá trị đối tượng",
  "analyzerType.editor.valueType.null": "Giá trị null",
  "analyzerType.editor.nullValue": "Lựa chọn này có giá trị null.",
  "analyzerType.editor.invalidTypedValue": "Nhập giá trị hợp lệ theo kiểu đã chọn.",
  "analyzerType.editor.structuredValueHelp": "Nhập danh sách hoặc đối tượng JSON đúng với kiểu đã chọn. Dùng danh sách cho phép so sánh “thuộc một trong các giá trị”.",
  "analyzerType.editor.newProtocolHelp": "Chọn FILE, ASTM hoặc HL7 và nhập các cài đặt máy hỗ trợ. Giao thức được cố định sau lần lưu đầu tiên.",
  "analyzerType.editor.switchProtocol": "Đổi giao thức và xóa cài đặt của nó",
  "analyzerType.editor.switchProtocolHelp": "Chuyển sang {protocol}? Thao tác này xóa các cài đặt giao tiếp, phân tích, trường kết nối và nhận diện mẫu kiểm soát chưa lưu. Định danh hồ sơ, định nghĩa xét nghiệm và thông tin mô tả được giữ lại.",
  "analyzerType.editor.keepProtocol": "Giữ giao thức hiện tại",
  "analyzerType.editor.supportedTransports": "Phương thức truyền được hỗ trợ",
  "analyzerType.editor.supportTransport": "Hỗ trợ {transport}",
  "analyzerType.editor.transportSettings": "Cài đặt {transport}",
  "analyzerType.editor.transportPortHelp": "Cổng đích gửi đi không bắt buộc cho phương thức truyền này. Bỏ trống để dùng cổng dự phòng của Bridge; thông điệp đến dùng bộ lắng nghe chung.",
  "analyzerType.editor.serialSettings": "Cài đặt giao tiếp nối tiếp (serial)",
  "analyzerType.editor.readTimeout": "Thời gian chờ đọc serial (mili giây)",
  "analyzerType.editor.messageTimeout": "Thời gian chờ thông điệp serial (mili giây)",
  "analyzerType.editor.reconnectInterval": "Khoảng thời gian kết nối lại serial (mili giây)",
  "analyzerType.editor.maxReconnectAttempts": "Số lần kết nối lại serial tối đa",
  "analyzerType.editor.rtsEnabled": "Bật RTS",
  "analyzerType.editor.dtrEnabled": "Bật DTR",
  "analyzerType.editor.resultRecords": "Bản ghi kết quả cần phân tích",
  "analyzerType.editor.resultRecords.ALL": "Tất cả bản ghi kết quả",
  "analyzerType.editor.resultRecords.FIELD_NON_BLANK": "Bản ghi có trường đã điền",
  "analyzerType.editor.resultRecordField": "Trường ASTM bắt buộc (record.field.component)",
  "analyzerType.editor.specimenPosition": "Vị trí mẫu HL7 so với kết quả",
  "analyzerType.editor.dataFlow": "Chiều truyền dữ liệu mặc định",
  "analyzerType.editor.outboundPortMode": "Cách chọn cổng gửi đi mặc định",
  "analyzerType.editor.clientProfilePort": "Cổng kết nối phía client lưu trong hồ sơ này (không bắt buộc)",
  "eqa.intake.sample": "Mẫu {code}",
  "eqa.competency.countsFoldedTriage": "Quyết định khi phân loại",
  "eqa.competency.countsFoldedScore": "Tính cùng điểm số",
  "eqa.provider.followups.responseText": "Phòng XN đã nói gì",
  "eqa.provider.followups.responseHelp": "Nguyên nhân gốc phòng XN tìm ra và hành động khắc phục đã thực hiện. Được lưu cùng mục theo dõi.",
  "eqa.provider.followups.responseShown": "Phản hồi của phòng XN: {text}",
  "notification.organization.post.error": "Chưa lưu được tổ chức. Kiểm tra các trường và thử lại.",
  "organization.email": "Email liên hệ",
  "eqa.provider.followups.sendFailed": "Không gửi được email tới {to}. Thông báo đã tải về dạng CSV để gửi tay.",
  "label.validation.review.error.qcHold": "Không thể trả kết quả: một mẫu kiểm soát QC không đạt đang giữ kết quả này cho tới khi sự không phù hợp được đóng.",
  "sidenav.label.admin.locations": "Địa điểm & Tổ chức",
  "sidenav.label.admin.locations.organizations": "Tổ chức",
  "sidenav.label.admin.locations.sites": "Điểm lấy mẫu",
  "sidenav.label.admin.locations.areas": "Khu vực địa lý",
  "sidenav.label.admin.locations.import": "Nhập / Xuất",
  "help.locations.page.organizations": "Tổ chức là các cơ sở y tế và phòng xét nghiệm mà phòng XN của bạn làm việc cùng: bệnh viện, phòng khám và trạm y tế gửi mẫu bệnh nhân cho bạn, cùng các phòng xét nghiệm bạn chuyển mẫu tới. Khoa và phòng bên trong một tổ chức được liệt kê dưới tổ chức đó. Tổ chức xuất hiện khi nhập chỉ định như nơi yêu cầu và trong chuyển mẫu như phòng xét nghiệm đích.",
  "help.locations.page.sites": "Điểm lấy mẫu là các vị trí cố định trong môi trường nơi thu mẫu không đến từ bệnh nhân: một nguồn nước, một bẫy muỗi, một máy đo không khí, một ô đất. Điểm lấy mẫu không chỉ định xét nghiệm. Nó ghi nơi mẫu được lấy, để có thể so sánh kết quả theo thời gian tại cùng một chỗ. Mỗi điểm nằm trong một khu vực địa lý và có thể có tọa độ GPS và người liên hệ riêng.",
  "help.locations.page.areas": "Khu vực địa lý là các đơn vị hành chính của quốc gia, ví dụ Vùng, Tỉnh, Huyện và LLG. Chúng dùng cho địa chỉ bệnh nhân và để xác định vị trí của từng tổ chức và điểm lấy mẫu. Đa số hệ thống nạp chúng một lần từ danh sách quốc gia, rồi thêm hoặc sửa tại đây. Để thêm khu vực bên trong một khu vực khác, dùng nút + ở dòng cha: \"+ Huyện\" trên Tỉnh Morobe sẽ thêm một huyện trong Tỉnh Morobe. Dùng \"+ Thêm Vùng\" ở đầu trang để tạo khu vực cấp cao nhất mới.",
  "help.locations.page.import": "Tải hoặc cập nhật tổ chức, khoa/phòng, điểm lấy mẫu và khu vực địa lý từ các tệp CSV, theo cùng định dạng hệ thống dùng khi cài đặt. Chưa có gì được lưu cho đến khi bạn xem trước và áp dụng.",
  "label.locations.page.compare": "Tổ chức hay điểm lấy mẫu: bạn cần cái nào?",
  "label.locations.page.compare.orgTitle": "Thêm tổ chức khi...",
  "label.locations.page.compare.siteTitle": "Thêm điểm lấy mẫu khi...",
  "label.locations.page.compare.orgExamples": "Ví dụ: Port Moresby General Hospital, 9 Mile Urban Clinic, Central Public Health Laboratory",
  "label.locations.page.compare.siteExamples": "Ví dụ: Bẫy đèn Bumbu Settlement, Trạm lấy nước sông Laloki, Máy đo không khí Waigani",
  "help.locations.page.compare.org": "Thêm tổ chức khi mẫu đến từ người được khám tại đó, khi nơi đó chỉ định xét nghiệm hoặc nhận kết quả hay mẫu chuyển, hoặc khi có khoa hay phòng yêu cầu xét nghiệm.",
  "help.locations.page.compare.site": "Thêm điểm lấy mẫu khi mẫu lấy từ môi trường (nước, đất, không khí hoặc côn trùng), khi bạn lấy mẫu nhiều lần tại cùng một vị trí cố định, hoặc khi muốn xem kết quả của vị trí đó theo thời gian, trên bản đồ.",
  "help.locations.page.compare.tip": "Bể nước tại một bệnh viện vẫn là điểm lấy mẫu: bệnh viện là tổ chức, còn bể nước là điểm lấy mẫu đặt trong cùng khu vực.",
  "label.locations.kind.facility": "Cơ sở y tế",
  "label.locations.kind.ward": "Khoa / Phòng",
  "label.locations.kind.wards": "khoa / phòng",
  "label.locations.kind.site": "Điểm lấy mẫu",
  "label.locations.kind.area": "Khu vực địa lý",
  "label.locations.kind.records": "bản ghi",
  "label.locations.column.name": "Tên",
  "label.locations.column.code": "Mã",
  "label.locations.column.type": "Loại",
  "label.locations.column.wards": "Khoa / Phòng",
  "label.locations.column.location": "Vị trí",
  "label.locations.column.inUse": "Đang sử dụng",
  "label.locations.column.level": "Cấp",
  "label.locations.column.children": "Khu vực con",
  "label.locations.column.siteType": "Loại điểm",
  "label.locations.column.active": "Hoạt động",
  "label.locations.column.actions": "Thao tác",
  "label.locations.column.serviceType": "Loại dịch vụ",
  "label.locations.column.contact": "Người liên hệ",
  "label.locations.column.phone": "Điện thoại",
  "label.locations.column.email": "Email",
  "label.locations.column.gps": "GPS",
  "label.locations.open": "đang mở",
  "label.locations.openOrders": "chỉ định đang mở",
  "label.locations.none": "không có",
  "label.locations.empty": "(trống)",
  "label.locations.location.notSet": "chưa đặt",
  "label.locations.status.active": "Đang hoạt động",
  "label.locations.status.inactive": "Ngừng hoạt động",
  "label.locations.status.all": "Tất cả",
  "label.locations.source.registry": "Danh bạ cơ sở",
  "help.locations.registry": "Lấy từ danh bạ cơ sở y tế. Danh bạ là nguồn chuẩn cho bản ghi này.",
  "label.locations.filter.type": "Loại",
  "label.locations.filter.type.all": "Tất cả loại",
  "label.locations.filter.location": "Vị trí (bao gồm các khu vực bên dưới)",
  "label.locations.filter.location.any": "Mọi khu vực",
  "label.locations.filter.status": "Trạng thái",
  "label.locations.filter.clear": "Xóa bộ lọc",
  "label.locations.filter.reviewOverdue": "Chỉ phòng XN chuyển mẫu quá hạn rà soát hoặc đã hết hạn công nhận",
  "label.locations.filter.category.all": "Tất cả nhóm",
  "label.locations.filter.ownership.all": "Mọi hình thức sở hữu",
  "label.locations.toolbar": "Bộ lọc",
  "placeholder.locations.search": "Tìm theo tên, mã hoặc bất kỳ định danh nào",
  "placeholder.locations.area.search": "Tìm khu vực theo tên hoặc mã",
  "help.locations.status.inactive": "Bản ghi ngừng hoạt động bị ẩn khỏi nhập chỉ định và các ô chọn khác. Chúng vẫn hiện trên chỉ định và báo cáo đã có.",
  "help.locations.field.location": "Chọn khu vực cụ thể nhất bạn biết. Nếu không biết LLG thì chọn huyện cũng được.",
  "help.locations.field.gps": "Độ thập phân, WGS84",
  "help.locations.field.siteDescription": "Ghi chỉ đường để người khác tìm đúng vị trí",
  "help.locations.identifiers": "Nhập nhãn bất kỳ, hoặc chọn nhãn đã dùng. Mã báo cáo hiện là Mã trong danh sách, xuất file và báo cáo. Mọi định danh đều tìm được và dùng để khớp dòng nhập.",
  "help.locations.ward": "Khoa, phòng hoặc phòng khám bên trong tổ chức này",
  "help.locations.ward.gps": "Để trống GPS để dùng vị trí của {parent}. Địa chỉ luôn là của {parent}.",
  "label.locations.ward.inheritedGps": "{lat}, {lng} kế thừa từ {parent}",
  "label.locations.inherited": "kế thừa",
  "label.locations.inherits": "kế thừa",
  "label.locations.draft": "Bản nháp",
  "label.locations.ward.namePlaceholder": "Tên khoa / phòng",
  "label.locations.optional": "Không bắt buộc",
  "warning.locations.registry.edit": "Bản ghi này lấy từ danh bạ cơ sở y tế. Thay đổi các trường do danh bạ cung cấp sẽ bị ghi đè ở lần đồng bộ tới. Để sửa vĩnh viễn, hãy cập nhật danh bạ. Khoa/phòng và các chi tiết nội bộ khác bạn thêm ở đây vẫn được giữ.",
  "warning.locations.registry.deactivate": "Bản ghi này lấy từ danh bạ cơ sở y tế. Lần đồng bộ tới có thể kích hoạt lại; để ngừng vĩnh viễn, hãy cập nhật danh bạ.",
  "label.locations.registry.field": "Từ danh bạ",
  "button.locations.add": "Thêm",
  "button.locations.import": "Nhập",
  "button.locations.export": "Xuất",
  "button.locations.deactivate": "Ngừng dùng",
  "button.locations.reactivate": "Kích hoạt lại",
  "button.locations.exportSelected": "Xuất mục đã chọn",
  "button.locations.addWard": "Thêm khoa / phòng",
  "button.locations.saveWards": "Lưu {count} khoa / phòng mới",
  "button.locations.moveWard": "Chuyển",
  "button.locations.history": "Lịch sử",
  "button.locations.history.hide": "Ẩn lịch sử",
  "button.locations.identifier.add": "Thêm định danh",
  "button.locations.area.addChildLevel": "+ {level}",
  "button.locations.area.addTop": "Thêm {level}",
  "button.locations.area.expandAll": "Mở tất cả",
  "button.locations.area.collapseAll": "Thu gọn tất cả",
  "button.locations.undo": "Hoàn tác",
  "button.locations.template": "Tải mẫu",
  "button.locations.import.preview": "Xem trước",
  "button.locations.import.apply": "Áp dụng",
  "button.locations.import.report": "Tải báo cáo kết quả",
  "label.locations.selectAll": "Chọn tất cả dòng",
  "label.locations.select": "Chọn",
  "label.locations.section.identity": "Thông tin nhận dạng",
  "label.locations.section.identifiers": "Định danh",
  "label.locations.section.location": "Vị trí",
  "label.locations.section.contact": "Liên hệ",
  "label.locations.section.referral": "Phòng XN chuyển mẫu",
  "label.locations.section.site": "Chi tiết điểm lấy mẫu",
  "label.locations.section.wards": "Khoa / Phòng",
  "label.locations.form.jump": "Chuyển tới",
  "label.locations.field.types": "Loại tổ chức",
  "label.locations.field.shortName": "Tên viết tắt",
  "label.locations.field.category": "Nhóm",
  "label.locations.field.ownership": "Hình thức sở hữu",
  "label.locations.field.description": "Mô tả",
  "label.locations.field.location": "Vị trí",
  "label.locations.field.parentArea": "Khu vực cha",
  "label.locations.field.streetAddress": "Địa chỉ đường",
  "label.locations.field.city": "Thành phố",
  "label.locations.field.state": "Tỉnh / Bang",
  "label.locations.field.zipCode": "Mã bưu điện",
  "label.locations.field.gpsLatitude": "Vĩ độ GPS",
  "label.locations.field.gpsLongitude": "Kinh độ GPS",
  "label.locations.field.contactName": "Người liên hệ",
  "label.locations.field.phone": "Điện thoại",
  "label.locations.field.email": "Email",
  "label.locations.field.website": "Website",
  "label.locations.field.serviceType": "Loại dịch vụ",
  "label.locations.field.siteType": "Loại điểm",
  "label.locations.field.subtype": "Phân loại con",
  "label.locations.field.zone": "Vùng môi trường",
  "label.locations.identifier.label": "Nhãn",
  "label.locations.identifier.value": "Giá trị",
  "label.locations.identifier.reporting": "Mã báo cáo",
  "label.locations.identifier.labelPlaceholder": "ví dụ: mã DHIS2",
  "label.locations.referral.approval": "Trạng thái phê duyệt",
  "label.locations.referral.approved": "Đã phê duyệt",
  "label.locations.referral.evaluation": "Đang đánh giá",
  "label.locations.referral.suspended": "Tạm ngưng",
  "label.locations.referral.notApproved": "Chưa phê duyệt",
  "label.locations.referral.accreditationBody": "Tổ chức công nhận",
  "label.locations.referral.accreditationNumber": "Số công nhận",
  "label.locations.referral.accreditationExpiry": "Hạn công nhận",
  "label.locations.referral.lastReview": "Ngày rà soát gần nhất",
  "label.locations.referral.nextReview": "Hạn rà soát tiếp theo",
  "label.locations.referral.notes": "Ghi chú rà soát",
  "label.locations.referral.overdue": "Quá hạn rà soát",
  "label.locations.referral.expired": "Đã hết hạn công nhận",
  "message.locations.referral.overdueSince": "Quá hạn rà soát từ {date}. Ghi nhận rà soát bên dưới, hoặc đổi trạng thái phê duyệt.",
  "label.locations.history.title": "Lịch sử của {name}",
  "label.locations.history.filter": "Lọc theo thao tác",
  "label.locations.history.allChanges": "Mọi thay đổi",
  "help.locations.history.readOnly": "Chỉ đọc. Được giữ chừng nào bản ghi còn tồn tại.",
  "label.locations.history.formerly": "Trước đây là {name}",
  "label.locations.history.action.created": "Đã tạo",
  "label.locations.history.action.edited": "Đã sửa",
  "label.locations.history.action.deactivated": "Đã ngừng dùng",
  "label.locations.history.action.reactivated": "Đã kích hoạt lại",
  "label.locations.history.action.moved": "Đã chuyển",
  "label.locations.history.action.identifiers": "Đã đổi định danh",
  "label.locations.history.action.referralReview": "Rà soát phòng XN chuyển mẫu",
  "label.locations.history.action.imported": "Đã nhập",
  "label.locations.history.action.registrySync": "Cập nhật từ danh bạ",
  "label.locations.search.ward": "Khoa / phòng: {name}",
  "error.locations.name.required": "Bắt buộc nhập tên",
  "error.locations.types.required": "Chọn ít nhất một loại tổ chức",
  "error.locations.gps.range": "Nhập độ thập phân: vĩ độ từ -90 đến 90, kinh độ từ -180 đến 180",
  "error.locations.parent.kind": "Khoa/phòng phải thuộc một cơ sở y tế",
  "error.locations.parent.required": "Chọn khu vực cha",
  "error.locations.referral.status": "Chọn trạng thái phê duyệt",
  "error.locations.identifier.duplicate": "{label} {value} đã được dùng bởi {name}",
  "error.locations.reactivate.parentInactive": "Hãy kích hoạt lại {parent} trước.",
  "error.locations.save.conflict": "Một quản trị viên khác đã lưu bản ghi này trước. Giá trị của họ hiển thị bên dưới; hãy áp lại thay đổi và lưu lần nữa.",
  "error.locations.save.failed": "Chưa lưu được bản ghi.",
  "error.locations.request.failed": "Không hoàn tất được yêu cầu, nên chưa lưu gì. Thử lại; nếu vẫn lỗi, hãy báo quản trị viên.",
  "error.locations.save.check": "Chưa lưu. Kiểm tra: {fields}.",
  "error.locations.save.failedBecause": "Chưa lưu được bản ghi: {reason}",
  "error.locations.save.conflictKept": "Một quản trị viên khác đã lưu bản ghi này trước. Thay đổi của bạn được giữ lại, và thay đổi của họ được điền vào những chỗ bạn chưa nhập ({fields}). Kiểm tra biểu mẫu và lưu lại.",
  "warning.locations.wards.unsaved": "{count, plural, other {# khoa / phòng}} typed but not saved yet. Save them with Save wards, or remove them, then save the record.",
  "error.locations.ward.notSaved": "Chưa lưu được {name}: {reason}",
  "message.locations.wards.saved": "{count, plural, other {Đã lưu # khoa / phòng.}}",
  "warning.locations.import.ignoredColumns": "Các cột sau không được nhập và đã bị bỏ qua: {columns}",
  "label.locations.import.run.applied": "Đã áp dụng",
  "label.locations.import.run.preview": "Xem trước",
  "warning.locations.identifiers.shared": "Một số định danh đang được dùng bởi nhiều bản ghi. Hãy đặt giá trị riêng cho từng bản ghi.",
  "error.locations.load.failed": "Không tải được danh sách. Thử lại.",
  "warning.locations.name.duplicate": "Đã tồn tại {kind} đang hoạt động khác tên \"{name}\"",
  "message.locations.empty.none": "Chưa có bản ghi nào. Thêm một bản ghi, hoặc nhập tệp.",
  "message.locations.empty.filtered": "Không có bản ghi nào khớp bộ lọc.",
  "message.locations.search.elsewhere": "Trong {view}: {count, plural, one {# kết quả} other {# kết quả}}",
  "message.locations.saved": "Đã lưu {name}.",
  "message.locations.added": "Đã thêm {name}.",
  "message.locations.deactivated": "Đã ngừng dùng {name}.",
  "message.locations.reactivated": "Đã kích hoạt lại {name}.",
  "message.locations.undo.deactivated": "Đã ngừng dùng {name}.",
  "message.locations.deactivate.inUse": "{name} có {open} chỉ định đang mở và {children} {childKind} đang hoạt động.",
  "message.locations.deactivate.confirm": "Ngừng dùng {name}?",
  "button.locations.deactivate.record": "Ngừng dùng {name}",
  "button.locations.deactivate.only": "Chỉ ngừng dùng {name}",
  "button.locations.deactivate.withChildren": "Ngừng dùng {name} và {count} {childKind} của nó",
  "message.locations.area.inUse": "{name} vẫn còn khu vực, tổ chức hoặc điểm lấy mẫu đang hoạt động bên trong. Hãy ngừng dùng hoặc chuyển chúng trước.",
  "message.locations.area.searchContext": "{count, plural, other {# kết quả khớp}}, shown with the areas they sit in",
  "message.locations.area.loadOnExpand": "Các mục con được tải khi mở một dòng.",
  "label.locations.area.new": "Mới",
  "label.locations.area.topLevel": "cấp cao nhất",
  "message.locations.unsaved": "Bạn có thay đổi chưa lưu. Rời đi mà không lưu?",
  "label.locations.import.mode": "Chế độ nhập",
  "label.locations.import.mode.merge": "Thêm & cập nhật",
  "help.locations.import.mode.merge": "Thêm bản ghi mới và cập nhật bản ghi khớp. Không thay đổi gì khác.",
  "label.locations.import.mode.replace": "Thay thế",
  "help.locations.import.mode.replace": "Đồng thời ngừng dùng các bản ghi thuộc loại có trong tệp này mà tệp không bao gồm. Không xóa gì cả.",
  "label.locations.import.files": "Tệp",
  "label.locations.import.drop": "Kéo tệp CSV vào đây hoặc nhấp để chọn (organizations-*.csv, *-levels.csv, *-values.csv)",
  "label.locations.import.area": "Phạm vi",
  "label.locations.import.area.organizations": "Cơ sở, khoa & điểm lấy mẫu",
  "label.locations.import.area.levels": "Cấp địa lý",
  "label.locations.import.area.values": "Khu vực địa lý",
  "label.locations.import.forThisFile": "Với tệp này:",
  "label.locations.import.replaceScope": "Tệp này có các dòng {types}. {untouched} sẽ không thay đổi. Khoa / phòng chỉ được thay thế tại {parents}. Bản ghi từ danh bạ không bao giờ bị ngừng dùng.",
  "label.locations.import.rename.title": "Có thể đổi tên",
  "label.locations.import.rename.same": "Cùng một nơi, đổi tên",
  "label.locations.import.rename.different": "Khác nơi",
  "warning.locations.import.registryOverwrite": "Sẽ bị ghi đè ở lần đồng bộ danh bạ tới",
  "warning.locations.import.wardAddressIgnored": "Dòng {line}: địa chỉ bị bỏ qua với khoa / phòng, vì dùng địa chỉ của tổ chức",
  "label.locations.import.outcome.new": "Mới",
  "label.locations.import.outcome.updated": "Đã cập nhật",
  "label.locations.import.outcome.unchanged": "Không đổi",
  "label.locations.import.outcome.reactivated": "Đã kích hoạt lại",
  "label.locations.import.outcome.deactivated": "Đã ngừng dùng",
  "label.locations.import.outcome.decision": "Cần quyết định",
  "label.locations.import.outcome.rename": "Có thể đổi tên",
  "label.locations.import.outcome.rejected": "Bị từ chối",
  "label.locations.import.decision.use": "Dùng bản ghi này",
  "label.locations.import.decision.new": "Tạo mới",
  "label.locations.import.decision.skip": "Bỏ qua dòng",
  "label.locations.import.decision.remember": "Ghi nhớ tên này",
  "label.locations.import.willDeactivate": "Sẽ bị ngừng dùng",
  "label.locations.import.rows": "Dòng",
  "label.locations.import.column.line": "Dòng",
  "label.locations.import.column.outcome": "Kết quả",
  "label.locations.import.column.type": "Loại",
  "label.locations.import.column.code": "Mã",
  "label.locations.import.column.name": "Tên",
  "label.locations.import.column.detail": "Chi tiết",
  "message.locations.import.nothingSaved": "Chưa lưu gì cả.",
  "label.locations.import.confirm.title": "Áp dụng lần nhập này?",
  "label.locations.import.confirm.replace": "Tôi hiểu {count} bản ghi sẽ bị ngừng dùng",
  "label.locations.import.complete": "Nhập xong",
  "label.locations.import.recent": "Lần nhập gần đây",
  "message.locations.export.done": "Đã xuất {count} bản ghi theo định dạng nhập.",
  "label.locations.import.working": "Đang đọc tệp và khớp từng dòng. Tệp lớn cần chút thời gian.",
  "message.locations.import.failed": "Không đọc được tệp nhập: {reason}",
  "eqa.wizard.noSchemeTests": "Chương trình này không có xét nghiệm nào mà bộ mẫu có thể dùng.",
  "eqa.performance.titleForScheme": "Hiệu quả phòng XN tham gia: {scheme}",
  "eqa.cycle.trigger.first_shipment_sent": "Đã gửi lô hàng đầu tiên",
  "eqa.cycle.trigger.all_shipments_delivered": "Đã giao mọi lô hàng",
  "eqa.cycle.trigger.score_intake": "Đã ghi nhận điểm số",
  "eqa.cycle.trigger.panel_receipt": "Đã nhận bộ mẫu",
  "eqa.cycle.trigger.last_validated_result": "Đã duyệt kết quả cuối",
  "eqa.cycle.trigger.fhir_submit_success": "Đã gửi kết quả cho đơn vị cung cấp",
  "eqa.cycle.trigger.panel_unblind": "Đã mở mù bộ mẫu",
  "eqa.cycle.trigger.v1_backfill": "Chuyển từ đợt phân phối trước",
  "sampleAcceptance.banner.resampledFrom.accession": "Đây là mẫu thay thế được tạo khi lấy lại mẫu {accession}.",
  "label.results.sampleStatus.markUsedUpConfirm.title": "Đánh dấu mẫu này đã dùng hết?",
  "label.results.sampleStatus.markUsedUpConfirm.body": "Thể tích còn lại được đặt về 0. Mẫu vẫn nằm trong kho cho tới khi được tiêu hủy.",
  "alerts.acknowledge.note": "Nhận xét xác nhận",
  "alerts.acknowledge.note.required": "Cần nhận xét để xác nhận cảnh báo nguy hiểm",
  "alerts.resolve.button": "Xử lý xong",
  "alerts.resolve.title": "Xử lý cảnh báo",
  "alerts.resolve.comment.required": "Cần nhận xét xử lý",
  "alerts.resolve.error": "Không xử lý được cảnh báo",
  "configuration.panel.manage": "Quản lý bộ mẫu",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Xem danh mục xét nghiệm",
  "compliance.parameterGroup.deleted": "Đã xóa nhóm thông số.",
  "compliance.parameterGroup.updated": "Đã cập nhật nhóm thông số.",
  "compliance.parameterGroup.deleteError": "Không xóa được nhóm thông số.",
  "compliance.validation.fillRequired": "Vui lòng điền đủ các trường bắt buộc.",
  "compliance.parameterGroup.moveError": "Không sắp xếp lại được nhóm thông số.",
  "compliance.parameterGroup.moved": "Đã sắp xếp lại nhóm thông số.",
  "compliance.parameterGroup.created": "Đã thêm nhóm thông số.",
  "compliance.testEditor.thresholdsDone": "Đã cập nhật ngưỡng tuân thủ cho xét nghiệm này.",
  "compliance.testEditor.meta.loinc": "LOINC:",
  "compliance.testEditor.meta.resultType.select": "Danh sách chọn",
  "compliance.testEditor.meta.resultType": "Kiểu kết quả:",
  "compliance.testEditor.editHeader": "Sửa xét nghiệm:",
  "compliance.testEditor.meta.sampleType": "Loại mẫu:",
  "compliance.testThresholds.comboboxPlaceholder": "Tìm theo tên, mã hoặc LOINC…",
  "label.button.done": "Xong",
  "compliance.testEditor.meta.resultType.numeric": "Số",
  "compliance.multiLimit.advisoryNote.placeholder": "ví dụ: Cần lấy mẫu lại trong 24 giờ",
  "compliance.multiLimit.advisoryNote": "Ghi chú khuyến cáo",
  "compliance.inlineEdit.editingMapping": "đang sửa ánh xạ tuân thủ",
  "label.loading.message": "Đang tải…",
  "compliance.linkedTest.unlinked": "Đã gỡ xét nghiệm khỏi nhóm thông số.",
  "compliance.linkedTest.unlinkError": "Không gỡ được xét nghiệm này khỏi nhóm.",
  "compliance.threshold.testLinked": "Đã liên kết xét nghiệm với nhóm thông số.",
  "compliance.inlineEdit.editingLimits": "đang sửa mọi giới hạn",
  "search.possibleMatches.title": "Có thể trùng",
  "search.possibleMatches.intro": "Các bản ghi này giống với bản bạn đang tạo. Dùng một trong số đó, hoặc tạo bản ghi mới.",
  "search.possibleMatches.use": "Dùng bản này",
  "search.possibleMatches.createAnyway": "Vẫn tạo mới",
  "search.possibleMatches.confirm": "Tạo bản ghi mới dù đã có {count} bản ghi tương tự?",
  "search.possibleMatches.confirm.button": "Tạo bản ghi mới",
  "search.possibleMatches.back": "Quay lại",
  "search.possibleMatches.matched": "Trùng theo: {fields}",
  "search.possibleMatches.field.name": "tên",
  "search.possibleMatches.field.dateOfBirth": "ngày sinh",
  "search.possibleMatches.field.identifier": "định danh",
  "search.possibleMatches.field.code": "mã",
  "search.possibleMatches.inactive": "Ngừng hoạt động",
  "search.possibleMatches.failed": "Không kiểm tra được bản ghi tương tự. Bạn vẫn có thể tạo bản ghi mới.",
  "search.possibleMatches.recordFailed": "Không ghi nhận được lựa chọn của bạn, nên chưa tạo gì. Thử lại.",
  "order.entry.patient.create": "Tạo bệnh nhân",
  "order.entry.patient.willBeCreated": "Bệnh nhân mới sẽ được tạo khi lưu chỉ định.",
  "provider.title.none": "Không có chức danh",
  "order.billing.reference": "Mã tham chiếu thanh toán",
  "sample.handling.title": "Xử lý mẫu",
  "sample.handling.noRequirement": "Không yêu cầu",
  "sample.handling.processWithin": "xử lý trong {time}",
  "sample.handling.holding.minutes": "{minutes} phút",
  "sample.handling.holding.hours": "{hours} giờ",
  "sample.handling.holding.hoursMinutes": "{hours} giờ {minutes} phút",
  "sample.handling.requiredLabel": "Yêu cầu:",
  "sample.handling.storedAtLabel": "Bảo quản tại:",
  "sample.handling.arrivedAs": "Đến ở trạng thái",
  "sample.handling.measuredTemp": "Nhiệt độ đo được (°C)",
  "sample.handling.measuredTemp.invalid": "Nhập nhiệt độ từ -100 đến 60 °C.",
  "sample.handling.sameForAll": "Giống nhau cho mọi mẫu",
  "sample.handling.notStored": "Chưa bảo quản",
  "sample.handling.storedAt.temperature": "{location} ({degrees} °C)",
  "sample.handling.mismatch": "Không khớp yêu cầu xử lý",
  "sample.handling.mismatch.detail": "Cần {required}; {actual}",
  "sample.handling.actual.arrived": "đến ở trạng thái {condition}",
  "sample.handling.actual.measured": "đo được {degrees} °C khi đến",
  "sample.handling.actual.stored": "bảo quản ở {degrees} °C",
  "sample.handling.reportNonConformity": "Báo cáo sự không phù hợp",
  "sample.condition.roomTemp": "Nhiệt độ phòng",
  "sample.condition.refrigerated": "Lạnh 2 đến 8 °C",
  "sample.condition.frozen": "Đông lạnh",
  "sample.condition.onIce": "Trên đá lạnh",
  "sample.condition.dryIce": "Đá khô",
  "common.notRecorded": "Chưa ghi nhận",
  "sample.legacy.recordedBefore": "Ghi nhận trước phiên bản này",
  "order.continue.item.arrivalTemperature": "Nhiệt độ đo của {sample} nằm ngoài khoảng -100 đến 60 °C",
  "order.entry.receivedBy.you": "Nhận bởi {name} (bạn)",
  "order.entry.receivedBy.other": "Nhận bởi {name}",
  "order.entry.receivedBy.search": "Nhận bởi",
  "common.change": "Đổi",
  "common.moreActions": "Thao tác khác",
  "order.tests.action.markTestedElsewhere": "Đánh dấu đã xét nghiệm ở nơi khác",
  "order.tests.action.unmarkTestedElsewhere": "Bỏ đánh dấu xét nghiệm ở nơi khác",
  "order.tests.tag.testedElsewhere": "Xét nghiệm ở nơi khác",
  "order.tests.testedElsewhere.help": "Kết quả do phòng XN khác báo cáo",
  "order.tests.testedElsewhereAt": "Xét nghiệm ở nơi khác: {lab}",
  "order.tests.testedElsewhere.value": "Giá trị báo cáo",
  "order.tests.testedElsewhere.lab": "Phòng XN thực hiện",
  "order.tests.testedElsewhere.saveFailed": "Chưa lưu được thông tin xét nghiệm ở nơi khác: {reason}",
  "inventory.board.title": "Vật tư",
  "inventory.board.purpose": "Vật tư hiện có và cần đặt bổ sung. Mở một dòng để xem các LOT và vị trí của chúng.",
  "inventory.board.column.item": "Vật tư",
  "inventory.board.column.onHand": "Tồn kho",
  "inventory.board.column.runsOut": "Dự kiến hết",
  "inventory.board.byLocation": "Theo vị trí:",
  "inventory.board.empty": "Chưa có vật tư nào. Thêm vật tư để bắt đầu theo dõi, rồi nhập kho.",
  "inventory.board.noMatches": "Không có vật tư nào khớp tìm kiếm và bộ lọc. Xóa bộ lọc để xem toàn bộ danh mục.",
  "inventory.board.error": "Không tải được bảng vật tư.",
  "inventory.filter.location": "Lọc theo vị trí",
  "inventory.projection.window": "{early} – {late}",
  "inventory.projection.windowOpen": "{early} trở đi",
  "inventory.projection.basis": "dựa trên mức dùng đến {date}",
  "inventory.projection.stale": "Theo dõi — dữ liệu sử dụng có thể đã cũ",
  "inventory.projection.insufficient": "Chưa đủ số ngày sử dụng để dự báo ngày hết",
  "inventory.projection.outOfStock": "Hết hàng",
  "inventory.projection.trend": "Xu hướng sử dụng",
  "inventory.projection.trend.steady": "ổn định",
  "inventory.projection.trend.change": "{percent}% / {days} ngày",
  "inventory.projection.medianDailyUse": "Mức dùng trung vị mỗi ngày: {rate} {units}/ngày (trong {days} ngày gần nhất — trung vị làm phẳng các đột biến nhất thời)",
  "inventory.orderBy.label": "Sắp xếp theo",
  "inventory.orderBy.pastDue": "quá hạn",
  "inventory.orderBy.leadSet": "{days} ngày (đã đặt)",
  "inventory.orderBy.leadObserved": "~{days} ngày (thực tế)",
  "inventory.orderBy.leadDefault": "{days} ngày (mặc định — hãy đặt để chính xác hơn)",
  "inventory.reorderStatus.now": "Đặt ngay",
  "inventory.reorderStatus.soon": "Sắp cần đặt",
  "inventory.reorderStatus.adequate": "Đủ dùng",
  "inventory.reorderStatus.buildingData": "Đang thu thập dữ liệu",
  "inventory.lots.useFirst": "Dùng trước",
  "inventory.lots.disposeFailedQc": "Không đạt QC: tiêu hủy",
  "inventory.lots.flag": "Đánh dấu",
  "inventory.lots.none": "Chưa có LOT nào cho vật tư này. Nhập kho để bắt đầu theo dõi.",
  "inventory.actions.forItem": "Thao tác cho {item}",
  "inventory.actions.forLot": "Thao tác cho LOT {lot}",
  "inventory.actions.editItem": "Sửa thông tin vật tư",
  "inventory.actions.editLot": "Sửa LOT và vị trí",
  "inventory.lots.expiringInDays": "Hết hạn sau {days} ngày",
  "inventory.logUsage.button": "Ghi nhận sử dụng",
  "inventory.logUsage.title": "Ghi nhận sử dụng",
  "inventory.logUsage.help": "Ghi nhận vật tư đã dùng tại bàn làm việc. Số liệu này dùng cho dự báo hết hàng; để sửa số đếm, hãy dùng Điều chỉnh tồn kho.",
  "inventory.logUsage.quantityWithUnits": "Số lượng đã dùng ({units})",
  "inventory.logUsage.onHand": "{quantity} {units} tồn kho. Xuất LOT theo thứ tự hạn sớm nhất trước.",
  "inventory.logUsage.error.noItem": "Chọn vật tư để ghi nhận sử dụng.",
  "inventory.logUsage.error.wholeUnits": "Nhập số nguyên đơn vị, tối thiểu 1.",
  "inventory.receiveStock.button": "Nhập kho",
  "label.testCatalog.basicInfo.opensMicrobiologyCase": "Mở hồ sơ Vi sinh",
  "label.testCatalog.basicInfo.microbiologyCaseRole": "Vai trò hồ sơ",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CULTURE": "Cấy",
  "label.testCatalog.basicInfo.microbiologyCaseRole.DIRECT": "Trực tiếp",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CASE": "Hồ sơ",
  "label.testCatalog.basicInfo.collectedInSets": "Lấy theo bộ",
  "microbiology.sets.warning.SINGLE_BOTTLE": "Chỉ có một chai trong bộ này",
  "microbiology.sets.warning.REPEATED_CONTAINER": "Trùng loại dụng cụ trong bộ này",
  "microbiology.sets.warning.DIFFERENT_SITES": "Các vị trí lấy mẫu khác nhau trong bộ này",
  "microbiology.sets.warning.COLLECTION_INTERVAL": "Thời điểm lấy mẫu cách nhau hơn {minutes} phút",
  "microbiology.sets.title": "Bộ cấy",
  "microbiology.sets.count.sets": "{sets, plural, other {# bộ}}",
  "microbiology.sets.count.bottles": "{bottles, plural, other {# chai}}",
  "microbiology.sets.count.summary": "{sets}, {bottles}",
  "microbiology.sets.number": "Bộ {number}",
  "microbiology.sets.unassigned": "Chưa ghi nhận bộ",
  "order.microPreview.title": "Chỉ định này sẽ mở gì",
  "order.microPreview.loading": "Đang cập nhật xem trước chỉ định…",
  "order.microPreview.failed": "Không có xem trước chỉ định",
  "order.microPreview.failedDetail": "Không cập nhật được xem trước. Kiểm tra kết nối và thử lại.",
  "order.microPreview.opens": "Mở hồ sơ",
  "order.microPreview.ordinary": "Ở lại mục Kết quả",
  "order.microPreview.case": "{tests} hồ sơ tại {unit}: {samples}",
  "order.microPreview.sample": "Mẫu {type} số {number}",
  "order.microPreview.stays": "{test} ở lại mục Kết quả",
  "order.microPreview.splitTag": "Hồ sơ tách riêng",
  "order.microPreview.split": "Mẫu {number} mở {count} hồ sơ: {units}.",
  "order.microPreview.reflex": "{name}: nếu {conditions}, có thể thêm {tests}.",
  "order.microPreview.component": "{test} — {component}",
  "order.microPreview.specimen": "{test} ({type})",
  "order.microPreview.and": " và ",
  "order.microPreview.or": " hoặc ",
  "order.microPreview.condition.EQUALS": "Kết quả {subject} bằng {value}",
  "order.microPreview.condition.NOT_EQUALS": "Kết quả {subject} khác {value}",
  "order.microPreview.condition.LESS_THAN": "Kết quả {subject} nhỏ hơn {value}",
  "order.microPreview.condition.LESS_THAN_OR_EQUAL": "Kết quả {subject} tối đa là {value}",
  "order.microPreview.condition.GREATER_THAN": "Kết quả {subject} lớn hơn {value}",
  "order.microPreview.condition.GREATER_THAN_OR_EQUAL": "Kết quả {subject} tối thiểu là {value}",
  "order.microPreview.condition.BETWEEN": "Kết quả {subject} nằm giữa {value} và {value2}",
  "order.microPreview.condition.INSIDE_NORMAL_RANGE": "Kết quả {subject} nằm trong khoảng bình thường",
  "order.microPreview.condition.OUTSIDE_NORMAL_RANGE": "Kết quả {subject} nằm ngoài khoảng bình thường",
  "order.microPreview.newUnitTag": "Nhóm xét nghiệm mới",
  "order.microPreview.newUnit": "{test} mở một hồ sơ tại {unit}; chỉ định này không có xét nghiệm nào khác tại nhóm đó.",
  "dictionary.containerPopulation": "Đối tượng của chai cấy (dụng cụ mẫu)",
  "dictionary.containerPopulation.unspecified": "Chưa xác định",
  "dictionary.containerPopulation.ADULT": "Người lớn",
  "dictionary.containerPopulation.PAEDIATRIC": "Trẻ em",
  "dictionary.aedesAegyptiPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAegyptiPathogens.dengue": "Dengue",
  "dictionary.aedesAegyptiPathogens.yellowFever": "Yellow Fever",
  "dictionary.aedesAegyptiPathogens.zika": "Zika",
  "dictionary.aedesAlbopictusPathogens.chikungunya": "Chikungunya",
  "dictionary.aedesAlbopictusPathogens.dengue": "Dengue",
  "dictionary.aedesAlbopictusPathogens.zika": "Zika",
  "dictionary.afbSkinResults.1Plus": "1+",
  "dictionary.afbSkinResults.2Plus": "2+",
  "dictionary.afbSkinResults.3Plus": "3+",
  "dictionary.afbSkinResults.4Plus": "4+",
  "dictionary.afbSkinResults.5Plus": "5+",
  "dictionary.afbSkinResults.6Plus": "6+",
  "dictionary.afbSkinResults.negative": "Negative",
  "dictionary.afbSputumResults.1Plus": "1+",
  "dictionary.afbSputumResults.2Plus": "2+",
  "dictionary.afbSputumResults.3Plus": "3+",
  "dictionary.afbSputumResults.negative": "Negative",
  "dictionary.afbSputumResults.scanty": "Scanty",
  "dictionary.analyzerGeneXpertResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertResults.error": "ERROR",
  "dictionary.analyzerGeneXpertResults.high": "HIGH",
  "dictionary.analyzerGeneXpertResults.indeterminate": "INDETERMINATE",
  "dictionary.analyzerGeneXpertResults.low": "LOW",
  "dictionary.analyzerGeneXpertResults.medium": "MEDIUM",
  "dictionary.analyzerGeneXpertResults.mtbDetected": "MTB DETECTED",
  "dictionary.analyzerGeneXpertResults.noResult": "NO RESULT",
  "dictionary.analyzerGeneXpertResults.notDetected": "NOT DETECTED",
  "dictionary.analyzerGeneXpertResults.veryLow": "VERY LOW",
  "dictionary.analyzerGeneXpertRifResults.detected": "DETECTED",
  "dictionary.analyzerGeneXpertRifResults.indeterminate": "Không xác định",
  "dictionary.analyzerGeneXpertRifResults.notDetected": "NOT DETECTED",
  "dictionary.anophelesPathogens.malaria": "Sốt rét",
  "dictionary.biolineHivResults.hiv1And2Positive": "HIV 1 and 2 Positive",
  "dictionary.biolineHivResults.hiv1Positive": "HIV 1 Positive",
  "dictionary.biolineHivResults.hiv2Positive": "HIV 2 Positive",
  "dictionary.biolineHivResults.indeterminate": "Không xác định",
  "dictionary.biolineHivResults.negative": "Negative",
  "dictionary.candidaKohResults.hypa": "Hyphae",
  "dictionary.candidaKohResults.spora": "Spores",
  "dictionary.candidaKohResults.yeastCell": "Yeast cell",
  "dictionary.clinicalCollectionMethod.arterialPuncture": "Arterial Puncture",
  "dictionary.clinicalCollectionMethod.aspirate": "Aspirate",
  "dictionary.clinicalCollectionMethod.biopsy": "Biopsy",
  "dictionary.clinicalCollectionMethod.capillaryFingerPrick": "Capillary / Finger Prick",
  "dictionary.clinicalCollectionMethod.catheter": "Catheter",
  "dictionary.clinicalCollectionMethod.heelPrick": "Heel Prick",
  "dictionary.clinicalCollectionMethod.lumbarPuncture": "Lumbar Puncture",
  "dictionary.clinicalCollectionMethod.midstreamCleanCatch": "Midstream Clean Catch",
  "dictionary.clinicalCollectionMethod.other": "Khác",
  "dictionary.clinicalCollectionMethod.sputumExpectoration": "Sputum Expectoration",
  "dictionary.clinicalCollectionMethod.swab": "Swab",
  "dictionary.clinicalCollectionMethod.venipuncture": "Venipuncture",
  "dictionary.confirmatoryResults.indeterminate": "Không xác định",
  "dictionary.confirmatoryResults.invalid": "Không hợp lệ",
  "dictionary.confirmatoryResults.negative": "Negative",
  "dictionary.confirmatoryResults.positive": "Dương tính",
  "dictionary.culexPathogens.westNileVirus": "West Nile Virus",
  "dictionary.detectionResults.terdeteksi": "Detected",
  "dictionary.detectionResults.tidakMeyakinkan": "Inconclusive",
  "dictionary.detectionResults.tidakTerdeteksi": "Not Detected",
  "dictionary.envCollectionMethod.composite24H": "Composite 24h",
  "dictionary.envCollectionMethod.composite8H": "Composite 8h",
  "dictionary.envCollectionMethod.depthIntegrated": "Depth Integrated",
  "dictionary.envCollectionMethod.grabSample": "Grab Sample",
  "dictionary.envCollectionMethod.other": "Khác",
  "dictionary.envCollectionMethod.passiveSampler": "Passive Sampler",
  "dictionary.envCollectionMethod.surfaceGrab": "Surface Grab",
  "dictionary.envWeather.clearSunny": "Clear / Sunny",
  "dictionary.envWeather.drizzle": "Drizzle",
  "dictionary.envWeather.foggy": "Foggy",
  "dictionary.envWeather.heavyRain": "Heavy Rain",
  "dictionary.envWeather.lightRain": "Light Rain",
  "dictionary.envWeather.other": "Khác",
  "dictionary.envWeather.overcast": "Overcast",
  "dictionary.envWeather.partlyCloudy": "Partly Cloudy",
  "dictionary.envWeather.windy": "Windy",
  "dictionary.environmentalZone.agricultural": "Agricultural",
  "dictionary.environmentalZone.industrial": "Industrial",
  "dictionary.environmentalZone.periUrban": "Peri-Urban",
  "dictionary.environmentalZone.protectedArea": "Protected Area",
  "dictionary.environmentalZone.rural": "Rural",
  "dictionary.environmentalZone.urban": "Urban",
  "dictionary.fleaFullCycle.adult": "Người lớn",
  "dictionary.fleaFullCycle.egg": "Egg",
  "dictionary.fleaFullCycle.larva": "Larva",
  "dictionary.fleaFullCycle.pupa": "Pupa",
  "dictionary.flyStages.adult": "Người lớn",
  "dictionary.flyStages.larva": "Larva",
  "dictionary.flyStages.pupa": "Pupa",
  "dictionary.genieHivResults.hiv1": "HIV 1",
  "dictionary.genieHivResults.hiv2": "HIV 2",
  "dictionary.genieHivResults.hivDual": "HIV Dual",
  "dictionary.genieHivResults.indeterminate": "Không xác định",
  "dictionary.genieHivResults.invalid": "Không hợp lệ",
  "dictionary.genieHivResults.negative": "Negative",
  "dictionary.gramStainGenitalResults.gramDiplococcusFound": "Gram(-) diplococcus found",
  "dictionary.gramStainGenitalResults.gramDiplococcusNotFound": "Gram(-) diplococcus not found",
  "dictionary.hBsAgResults.negative": "Negative",
  "dictionary.hBsAgResults.positive": "Dương tính",
  "dictionary.hivRapidResults.indeterminate": "Không xác định",
  "dictionary.hivRapidResults.negative": "Negative",
  "dictionary.hivRapidResults.positive": "Dương tính",
  "dictionary.malariaResults.mixedInfection": "Mixed infection",
  "dictionary.malariaResults.noParasitesSeen": "No parasites seen",
  "dictionary.malariaResults.plasmodiumFalciparum": "Plasmodium falciparum",
  "dictionary.malariaResults.plasmodiumMalariae": "Plasmodium malariae",
  "dictionary.malariaResults.plasmodiumOvale": "Plasmodium ovale",
  "dictionary.malariaResults.plasmodiumVivax": "Plasmodium vivax",
  "dictionary.mosquitoFullCycle.adult": "Người lớn",
  "dictionary.mosquitoFullCycle.egg": "Egg",
  "dictionary.mosquitoFullCycle.larva": "Larva",
  "dictionary.mosquitoFullCycle.pupa": "Pupa",
  "dictionary.muscaPathogens.typhus": "Typhus",
  "dictionary.p24AgResults.hiv1": "HIV 1",
  "dictionary.p24AgResults.indeterminate": "Không xác định",
  "dictionary.p24AgResults.negative": "Negative",
  "dictionary.phlebotomusPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.positifNegatif.negatif": "Negative",
  "dictionary.positifNegatif.positif": "Dương tính",
  "dictionary.pregnancyTestResults.negative": "Negative",
  "dictionary.pregnancyTestResults.positive": "Dương tính",
  "dictionary.proteinuriaResults.negative": "Negative",
  "dictionary.proteinuriaResults.positivePlus": "Positive +",
  "dictionary.proteinuriaResults.positivePlusPlus": "Positive ++",
  "dictionary.proteinuriaResults.positivePlusPlusPlus": "Positive +++",
  "dictionary.qaChecklistItem.labelsVerified": "Labels have been printed and applied",
  "dictionary.qaChecklistItem.patientInfoVerified": "Patient information is correct",
  "dictionary.qaChecklistItem.samplesVerified": "Sample types and tests are correct",
  "dictionary.qaChecklistItem.storageVerified": "Storage locations have been assigned",
  "dictionary.rattusPathogens.plague": "Plague",
  "dictionary.rattusPathogens.typhus": "Typhus",
  "dictionary.rodentStages.adult": "Người lớn",
  "dictionary.sampleAcceptanceItem.coldChain": "Cold chain maintained",
  "dictionary.sampleAcceptanceItem.containerIntact": "Container intact / undamaged",
  "dictionary.sampleAcceptanceItem.labelLegible": "Label legible and matches request",
  "dictionary.sampleAcceptanceItem.paperwork": "Required paperwork present and complete",
  "dictionary.sampleAcceptanceItem.transit": "Acceptable transit time / condition",
  "dictionary.sampleAcceptanceItem.volumeAdequate": "Sample volume adequate",
  "dictionary.sampleContainer.1LHdpeBottle": "1L HDPE bottle",
  "dictionary.sampleContainer.250MLGlassBottle": "250mL glass bottle",
  "dictionary.sampleContainer.500MLGlassBottle": "500mL glass bottle",
  "dictionary.sampleContainer.compositeJerryCan5L": "Composite jerry can 5L",
  "dictionary.sampleContainer.filterMembrane": "Filter membrane",
  "dictionary.sampleContainer.other": "Khác",
  "dictionary.sampleContainer.sterileBag": "Sterile bag",
  "dictionary.sampleType.hPlasma": "Plasma",
  "dictionary.sampleType.hSaliva": "Saliva",
  "dictionary.sampleType.hSerum": "Serum",
  "dictionary.sampleType.hTissue": "Tissue",
  "dictionary.sampleType.hUrine": "Urine",
  "dictionary.sampleType.hWholeBlood": "Whole Blood",
  "dictionary.samplingSiteType.airMonitoringStation": "Air Monitoring Station",
  "dictionary.samplingSiteType.distributionPoint": "Distribution Point",
  "dictionary.samplingSiteType.foodFacility": "Food Facility",
  "dictionary.samplingSiteType.monitoringStation": "Monitoring Station",
  "dictionary.samplingSiteType.other": "Khác",
  "dictionary.samplingSiteType.soilSamplingSite": "Soil Sampling Site",
  "dictionary.samplingSiteType.treatmentPlant": "Treatment Plant",
  "dictionary.samplingSiteType.waterSource": "Water Source",
  "dictionary.specimenOrigin.communityField": "Community / Field",
  "dictionary.specimenOrigin.emergencyDepartment": "Emergency Department",
  "dictionary.specimenOrigin.inpatientWard": "Inpatient Ward",
  "dictionary.specimenOrigin.intensiveCare": "Intensive Care",
  "dictionary.specimenOrigin.operatingTheatre": "Operating Theatre",
  "dictionary.specimenOrigin.outpatientClinic": "Outpatient Clinic",
  "dictionary.specimenOrigin.referredFromExternalFacility": "Referred from External Facility",
  "dictionary.susceptibilityResults.intermediate": "Trung gian",
  "dictionary.susceptibilityResults.resistan": "Kháng",
  "dictionary.susceptibilityResults.sensitif": "Sensitive",
  "dictionary.testResults.detected": "Detected",
  "dictionary.testResults.inconclusive": "Inconclusive",
  "dictionary.testResults.indeterminate": "Không xác định",
  "dictionary.testResults.negative": "Negative",
  "dictionary.testResults.nonReactive": "Non-Reactive",
  "dictionary.testResults.notDetected": "Not Detected",
  "dictionary.testResults.positive": "Dương tính",
  "dictionary.testResults.reactive": "Reactive",
  "dictionary.titerResults.1To10": "1:10",
  "dictionary.titerResults.1To160": "1:160",
  "dictionary.titerResults.1To20": "1:20",
  "dictionary.titerResults.1To320": "1:320",
  "dictionary.titerResults.1To40": "1:40",
  "dictionary.titerResults.1To640": "1:640",
  "dictionary.titerResults.1To80": "1:80",
  "dictionary.trichomonasResults.trichomonasNegative": "Trichomonas negative",
  "dictionary.trichomonasResults.trichomonasPositive": "Trichomonas positive",
  "dictionary.urinalysisResults.clear": "Xóa",
  "dictionary.urinalysisResults.cloudy": "Cloudy",
  "dictionary.urinalysisResults.slightlyCloudy": "Slightly Cloudy",
  "dictionary.urinalysisResults.turbid": "Turbid",
  "dictionary.urineColor.amber": "Amber",
  "dictionary.urineColor.brown": "Brown",
  "dictionary.urineColor.darkYellow": "Dark Yellow",
  "dictionary.urineColor.red": "Red",
  "dictionary.urineColor.yellow": "Yellow",
  "dictionary.vecBloodmealHostSpecies.avianProxyToChicken": "Avian (proxy: chicken)",
  "dictionary.vecBloodmealHostSpecies.cattleBosTaurus": "Cattle (Bos taurus)",
  "dictionary.vecBloodmealHostSpecies.dogCanisFamiliaris": "Dog (Canis familiaris)",
  "dictionary.vecBloodmealHostSpecies.goatCapraHircus": "Goat (Capra hircus)",
  "dictionary.vecBloodmealHostSpecies.humanHomoSapiens": "Human (Homo sapiens)",
  "dictionary.vecBloodmealHostSpecies.mixedHostBloodmeal": "Mixed-host bloodmeal",
  "dictionary.vecBloodmealHostSpecies.noHostDetected": "No host detected",
  "dictionary.vecBloodmealHostSpecies.pigSusScrofa": "Pig (Sus scrofa)",
  "dictionary.vecCollectionTimeOfDay.dawn": "Rạng sáng",
  "dictionary.vecCollectionTimeOfDay.daylight": "Daylight",
  "dictionary.vecCollectionTimeOfDay.dusk": "Chạng vạng",
  "dictionary.vecCollectionTimeOfDay.night": "Ban đêm",
  "dictionary.vecCollectionTimeOfDay.unknown": "Chưa rõ",
  "dictionary.vecInsecticideResistanceGenotype.heterozygote": "Heterozygote",
  "dictionary.vecInsecticideResistanceGenotype.indeterminate": "Không xác định",
  "dictionary.vecInsecticideResistanceGenotype.resistantHomozygote": "Resistant homozygote",
  "dictionary.vecInsecticideResistanceGenotype.susceptibleHomozygote": "Susceptible homozygote",
  "dictionary.vecLifecycleStages.adult": "Người lớn",
  "dictionary.vecLifecycleStages.egg": "Egg",
  "dictionary.vecLifecycleStages.larva": "Larva",
  "dictionary.vecLifecycleStages.nymph": "Nymph",
  "dictionary.vecLifecycleStages.pupa": "Pupa",
  "dictionary.vecPathogenResult.equivocalIndeterminate": "Equivocal / Indeterminate",
  "dictionary.vecPathogenResult.invalid": "Không hợp lệ",
  "dictionary.vecPathogenResult.negative": "Negative",
  "dictionary.vecPathogenResult.positive": "Dương tính",
  "dictionary.vecPathogens.chikungunya": "Chikungunya",
  "dictionary.vecPathogens.dengue": "Dengue",
  "dictionary.vecPathogens.malaria": "Sốt rét",
  "dictionary.vecPathogens.plague": "Plague",
  "dictionary.vecPathogens.riftValleyFever": "Rift Valley Fever",
  "dictionary.vecPathogens.typhus": "Typhus",
  "dictionary.vecPathogens.westNileVirus": "West Nile Virus",
  "dictionary.vecPathogens.yellowFever": "Yellow Fever",
  "dictionary.vecPathogens.zika": "Zika",
  "dictionary.vecPhysiologicalState.bloodFed": "Đã hút máu",
  "dictionary.vecPhysiologicalState.gravid": "Mang trứng",
  "dictionary.vecPhysiologicalState.halfGravid": "Mang trứng một phần",
  "dictionary.vecPhysiologicalState.unfed": "Chưa hút máu",
  "dictionary.vecPhysiologicalState.unknownNotAssessed": "Không rõ / chưa đánh giá",
  "dictionary.vecPlasmodiumDrugResistanceVariant.76T": "76T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a437G": "A437G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a581G": "A581G",
  "dictionary.vecPlasmodiumDrugResistanceVariant.a613S": "A613S",
  "dictionary.vecPlasmodiumDrugResistanceVariant.c580Y": "C580Y",
  "dictionary.vecPlasmodiumDrugResistanceVariant.d1246": "D1246",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i164L": "I164L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.i543T": "I543T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k540E": "K540E",
  "dictionary.vecPlasmodiumDrugResistanceVariant.k76WildType": "K76 (wild type)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n1042": "N1042",
  "dictionary.vecPlasmodiumDrugResistanceVariant.n51I": "N51I",
  "dictionary.vecPlasmodiumDrugResistanceVariant.otherVariantSequenceCaptured": "Other variant (sequence captured)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.p553L": "P553L",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r539T": "R539T",
  "dictionary.vecPlasmodiumDrugResistanceVariant.r59": "R59",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s1034": "S1034",
  "dictionary.vecPlasmodiumDrugResistanceVariant.s108": "S108",
  "dictionary.vecPlasmodiumDrugResistanceVariant.wildTypePfkelch13": "Wild type (pfkelch13)",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y184": "Y184",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y493H": "Y493H",
  "dictionary.vecPlasmodiumDrugResistanceVariant.y86": "Y86",
  "dictionary.vecPlasmodiumSpecies.indeterminate": "Không xác định",
  "dictionary.vecPlasmodiumSpecies.mixedInfection": "Mixed infection",
  "dictionary.vecPlasmodiumSpecies.pFalciparum": "P. falciparum",
  "dictionary.vecPlasmodiumSpecies.pKnowlesi": "P. knowlesi",
  "dictionary.vecPlasmodiumSpecies.pMalariae": "P. malariae",
  "dictionary.vecPlasmodiumSpecies.pOvale": "P. ovale",
  "dictionary.vecPlasmodiumSpecies.pVivax": "P. vivax",
  "dictionary.vecRestingContext.indoorEndophilic": "Trong nhà (ưa trong nhà)",
  "dictionary.vecRestingContext.outdoorExophilic": "Ngoài trời (ưa ngoài nhà)",
  "dictionary.vecRestingContext.unknown": "Chưa rõ",
  "dictionary.vecTrapType.aspirator": "Aspirator",
  "dictionary.vecTrapType.bgSentinelTrap": "BG-Sentinel trap",
  "dictionary.vecTrapType.cdcLightTrap": "CDC light trap",
  "dictionary.vecTrapType.gravidTrap": "Gravid trap",
  "dictionary.vecTrapType.humanLandingCollection": "Human-landing collection",
  "dictionary.vecTrapType.otherSpecifyInNotes": "Other (specify in notes)",
  "dictionary.vecTrapType.ovitrap": "Ovitrap",
  "dictionary.vecTrapType.sweepNet": "Sweep net",
  "dictionary.vecVirusIsolationResult.inconclusive": "Inconclusive",
  "dictionary.vecVirusIsolationResult.isolated": "Isolated",
  "dictionary.vecVirusIsolationResult.notIsolated": "Not isolated",
  "dictionary.vecWhoInsecticideSusceptibilityClass.possiblyResistant": "Possibly resistant",
  "dictionary.vecWhoInsecticideSusceptibilityClass.resistant": "Kháng",
  "dictionary.vecWhoInsecticideSusceptibilityClass.susceptible": "Nhạy",
  "dictionary.waterClarity.agakKeruh": "Slightly Turbid",
  "dictionary.waterClarity.jernih": "Xóa",
  "dictionary.waterClarity.keruh": "Turbid",
  "dictionary.waterColor.biru": "Blue",
  "dictionary.waterColor.cokelat": "Brown",
  "dictionary.waterColor.hijau": "Green",
  "dictionary.waterColor.hitam": "Black",
  "dictionary.waterColor.kuning": "Yellow",
  "dictionary.waterColor.merah": "Red",
  "dictionary.waterColor.putih": "White",
  "dictionary.waterColor.tidakBerwarna": "Colorless",
  "dictionary.xenopsyllaPathogens.plague": "Plague",
  "dictionary.xenopsyllaPathogens.typhus": "Typhus",
  "microbiology.sets.warning.MIXED_POPULATIONS": "Bộ này có cả chai trẻ em và người lớn.",
  "order.cultureSetNumber": "Số bộ",
  "order.cultureSetNumber.required": "Nhập số bộ nguyên dương.",
  "order.cultureBottle.duplicate": "Trùng chai",
  "microbiology.sets.container": "Loại dụng cụ",
  "microbiology.sets.bodySite": "Vị trí lấy mẫu",
  "inventory.reorder.suggestions": "Gợi ý đặt hàng bổ sung",
  "inventory.reorder.help": "Vật tư ở hoặc dưới ngưỡng, hoặc dự báo sẽ chạm ngưỡng trước khi đơn hàng mới kịp về. Đánh dấu đã đặt chỉ ghi nhận rằng đơn đã được đặt — không tự đặt hàng.",
  "inventory.reorder.none": "Hiện không có vật tư nào cần đặt.",
  "inventory.reorder.markOrdered": "Đánh dấu đã đặt",
  "inventory.reorder.onOrder": "Đang đặt",
  "inventory.reorder.note": "Ghi chú",
  "inventory.reorder.note.placeholder": "Số phiếu yêu cầu hoặc số PO",
  "inventory.reorder.expectedDate": "Ngày dự kiến",
  "inventory.reorder.marked": "{count, plural, other {# vật tư}} marked as ordered.",
  "inventory.reorder.reviewAndOrder": "Xem lại và đánh dấu đã đặt",
  "inventory.reorder.clearOrdered": "Thực ra chưa đặt",
  "inventory.reorder.cleared": "{count, plural, other {# vật tư}} no longer marked as ordered.",
  "inventory.board.andMore": "và {count} nữa",
  "inventory.item.leadTime": "Thời gian giao hàng (ngày)",
  "inventory.item.leadTime.help": "Vật tư mất bao lâu để về sau khi đặt. Để trống để hệ thống tự học từ các lần giao hàng của bạn.",
  "inventory.item.leadTime.observedSuggest": "Các lần giao hàng gần đây của bạn mất khoảng {days} ngày.",
  "inventory.item.leadTime.useObserved": "Dùng giá trị này",
  "inventory.item.tags": "Thẻ",
  "inventory.item.tags.help": "Cách vật tư này được nhóm, lọc và báo cáo. Một vật tư có thể có nhiều thẻ.",
  "inventory.item.tags.add": "Gõ để tìm hoặc thêm thẻ",
  "inventory.item.tags.remove": "Xóa thẻ {tag}",
  "inventory.item.autoConsume.help": "Không có cài đặt tự động trừ. Liên kết vật tư với một xét nghiệm trong Danh mục xét nghiệm cho phép bàn làm việc ghi nhận việc sử dụng khi nhập kết quả xét nghiệm đó.",
  "inventory.search.placeholder.board": "Tìm theo tên, mã, thẻ hoặc số LOT của vật tư",
  "inventory.filter.tags": "Lọc theo thẻ",
  "inventory.filter.tags.clear": "Xóa thẻ",
  "inventory.tags.manage": "Quản lý thẻ",
  "inventory.tags.help": "Dọn dẹp các thẻ. Ngừng dùng một thẻ sẽ không còn gợi ý hay hiện làm bộ lọc. Vật tư đang gắn thẻ đó vẫn giữ nguyên.",
  "inventory.tags.tag": "Thẻ",
  "inventory.tags.usage": "Vật tư",
  "inventory.tags.status": "Trạng thái",
  "inventory.tags.active": "Đang dùng",
  "inventory.tags.deactivated": "Đã ngừng dùng",
  "inventory.tags.deactivate": "Ngừng dùng",
  "inventory.tags.reactivate": "Kích hoạt lại",
  "inventory.tags.showDeactivated": "Hiện mục đã ngừng dùng",
  "inventory.tags.new": "Thẻ mới",
  "inventory.tags.add": "Thêm thẻ",
  "inventory.tags.none": "Chưa có thẻ nào. Thêm thẻ tại đây, hoặc gắn thẻ trực tiếp cho vật tư.",
  "inventory.tags.error.blank": "Thẻ cần có tên.",
  "inventory.item.new": "Vật tư mới",
  "inventory.item.created": "Đã định nghĩa vật tư. Nhập kho cho vật tư này để bắt đầu theo dõi số lượng.",
  "inventory.item.showDeactivated": "Hiện mục đã ngừng dùng",
  "inventory.item.deactivated": "Đã ngừng dùng",
  "inventory.item.deactivate": "Ngừng dùng vật tư",
  "inventory.item.reactivate": "Kích hoạt lại vật tư",
  "inventory.item.reactivated": "{item} đã hoạt động trở lại.",
  "inventory.item.deactivated.success": "Đã ngừng dùng {item}. Bật Hiện mục đã ngừng dùng để tìm lại.",
  "inventory.item.deactivate.confirm.title": "Ngừng dùng vật tư này?",
  "inventory.item.deactivate.confirm": "Ngừng dùng {item}?",
  "inventory.item.deactivate.implication.hidden": "Vật tư rời khỏi bảng và không còn được đề xuất khi nhập kho hoặc ghi nhận sử dụng.",
  "inventory.item.deactivate.implication.stock": "LOT và lịch sử được giữ lại, và số tồn còn lại không bị xóa sổ.",
  "inventory.item.deactivate.implication.reversible": "Bạn có thể kích hoạt lại bất cứ lúc nào từ mục Hiện mục đã ngừng dùng.",
  "catalog.item.catalogNumber": "Mã danh mục",
  "catalog.item.expirationAlertDays": "Cảnh báo trước hạn sử dụng bằng số ngày này",
  "catalog.item.trackLots": "Theo dõi LOT và hạn sử dụng",
  "catalog.item.trackLots.help": "Bật cho vật tư nhập theo lô có hạn sử dụng. Tắt cho vật tư tiêu hao được đếm như một khối chung.",
  "catalog.item.form.help": "Mục này định nghĩa một loại vật tư. Để thêm số lượng cho loại đã có, dùng Nhập kho.",
  "inventory.item.form.title.add": "Vật tư mới",
  "inventory.item.form.title.edit": "Sửa vật tư",
  "inventory.count.enter": "Chế độ kiểm đếm",
  "inventory.count.leave": "Thoát chế độ kiểm đếm",
  "inventory.count.confirm": "Xác nhận kiểm đếm",
  "inventory.count.expected": "trên {expected} {units}",
  "inventory.count.matches": "Khớp",
  "inventory.count.perLot": "Đếm từng LOT bên dưới (dự kiến {expected} {units} ở đây)",
  "inventory.count.nothingHere": "Không có gì để đếm ở đây",
  "inventory.count.countOf": "Số lượng đã đếm của {item}",
  "inventory.count.tally": "{counted, plural, =0 {Chưa đếm LOT nào} one {# LOT đã đếm} other {# LOT đã đếm}}",
  "inventory.count.scoped": "Đang kiểm đếm {location}. Chỉ hiển thị tồn kho tại vị trí này, và chỉ những gì bạn nhập mới được ghi nhận.",
  "inventory.count.unscoped": "Đang kiểm đếm toàn bộ. Lọc theo vị trí để đếm từng kệ một. Chỉ những gì bạn nhập mới được ghi nhận.",
  "inventory.count.done": "Đã ghi nhận kiểm đếm: {adjusted, plural, =0 {không điều chỉnh} one {# điều chỉnh} other {# điều chỉnh}}, {confirmed, plural, =0 {chưa xác nhận LOT nào} one {# LOT đã xác nhận} other {# LOT đã xác nhận}}.",
  "inventory.count.lastCounted": "Đã đếm {date}",
  "inventory.count.neverCounted": "Chưa từng đếm",
  "inventory.count.column": "Lần đếm gần nhất",
  "inventory.delivery.purpose": "Lập phiếu nhập hàng. Quét thùng, nhập số lượng nhận được, bấm thêm, rồi quét thùng tiếp theo. Chưa có gì được lưu cho tới khi bạn xác nhận cả phiếu.",
  "inventory.delivery.scan": "Quét thùng hàng",
  "inventory.delivery.scan.help": "Nhãn GS1 sẽ tự điền sản phẩm, số lô và hạn dùng. Thông tin nào nhãn không có thì nhập tay bên dưới.",
  "inventory.delivery.scan.unread": "Không nhận ra mã này. Hãy nhập dòng này bằng tay.",
  "inventory.delivery.partialScan": "Quét được một phần",
  "inventory.delivery.add": "Thêm vào phiếu nhập",
  "inventory.delivery.remove": "Gỡ",
  "inventory.delivery.confirm": "Nhập kho {count, plural, one {# dòng} other {# dòng}}",
  "inventory.delivery.discard": "Bỏ phiếu nhập",
  "inventory.delivery.received": "{count, plural, other {# dòng}} received.",
  "inventory.delivery.expired": "Lô này đã quá hạn dùng",
  "inventory.delivery.expired.help": "Bạn vẫn nhập được. Hàng hạn dùng ngắn vẫn là một lần nhập bình thường, bảng vật tư sẽ đánh dấu cho bạn.",
  "catalog.item.upc": "Mã vạch sản phẩm (UPC hoặc GTIN)",
  "catalog.item.upc.help": "Mã vạch của nhà sản xuất cho sản phẩm này. Mỗi hộp đều có cùng mã, nên quét mã cho biết vật tư là gì, chứ không cho biết lô nào vừa về.",
  "inventory.receive.title": "Nhập kho",
  "inventory.receive.submit": "Nhập",
  "inventory.receive.success": "Đã nhận {quantity} {units}. Đã tính vào tồn kho, và có thể dùng khi đạt QC.",
  "inventory.receive.help": "Thêm số lượng cho vật tư đã có. Để định nghĩa vật tư mới, dùng Vật tư mới.",
  "inventory.receive.scan": "Quét mã vạch sản phẩm",
  "inventory.receive.scan.help": "Quét hoặc nhập UPC để chọn vật tư mà không cần tìm kiếm.",
  "inventory.receive.scan.unknown": "Không có vật tư nào mang mã vạch này",
  "inventory.receive.quantityWithUnits": "Số lượng nhận ({units})",
  "inventory.receive.lotNumber.help": "Để trống thì hệ thống tự tạo từ mã vật tư và ngày hôm nay.",
  "inventory.receive.location.optional": "Chưa gán. Có thể đặt ngay bây giờ hoặc gán sau trên LOT.",
  "inventory.receive.error.noItem": "Chọn vật tư được nhập.",
  "inventory.receive.error.quantity": "Nhập số lượng đã nhận.",
  "inventory.receive.error.locationAfterReceive": "Đã nhận vật tư, nhưng không gán được vị trí lưu trữ: {reason}",
  "reports.type.received": "Nhận lúc",
  "reports.type.received.description": "Những gì đã nhận trong kỳ, theo vật tư và lô.",
  "reports.type.consumed": "Đã tiêu hao",
  "reports.type.consumed.description": "Những gì đã dùng trong kỳ, cộng theo vật tư.",
  "reports.type.stockOnHand": "Tồn kho hiện có",
  "reports.type.stockOnHand.description": "Những gì đang có trong kho, theo từng lô, kèm hạn dùng.",
  "reports.type.expiring": "Sắp hết hạn",
  "reports.type.expiring.description": "Các lô có hạn dùng nằm trong khoảng thời gian bạn chọn.",
  "reports.asOfDate": "Tính đến ngày",
  "reports.asOfDate.help": "Để trống để xem tồn kho hiện tại.",
  "reports.expiringFrom": "Hết hạn từ",
  "reports.expiringTo": "Hết hạn đến",
  "reports.tags": "Thẻ",
  "reports.tags.help": "Chỉ báo cáo các vật tư có ít nhất một trong các thẻ này.",
  "reports.tags.placeholder": "Thẻ bất kỳ",
  "reports.run": "Chạy báo cáo",
  "reports.running": "Đang chạy...",
  "reports.empty": "Không có dữ liệu khớp các bộ lọc này.",
  "reports.empty.stockOnHandAsOf": "Không có lần nhập xuất kho nào được ghi nhận vào hoặc trước ngày này, nên không tính lại được tồn kho lúc đó. Điều này không có nghĩa là lúc đó kho trống.",
  "reports.asOfDate.basis": "Tính lại từ các lần nhập xuất kho đã ghi nhận tới ngày này, không phải từ kiểm kê thực tế.",
  "order.continue.item.eqaScheme": "Chọn chương trình EQA",
  "order.eqa.cycle": "Đợt",
  "order.eqa.cycle.none": "Không có đợt",
  "order.eqa.cycleNotInScheme": "Đợt đã chọn không phải đợt đang mở của chương trình EQA này.",
  "order.eqa.newCycle": "Đợt mới",
  "order.eqa.noCycle.warning": "Mẫu này chưa gắn với đợt nào nên sẽ không được nộp hay chấm điểm từ OpenELIS.",
  "order.eqa.noEnrollments.link": "Đăng ký trong Chương trình EQA của tôi",
  "order.eqa.noEnrollments.title": "Phòng xét nghiệm này chưa đăng ký chương trình EQA nào đang hoạt động.",
  "order.eqa.providerSampleId.codes": "Mã mẫu trong bộ mẫu của đợt này: {codes}",
  "order.eqa.providerSampleId.noMatch": "Mã này không khớp mã mẫu nào trong bộ mẫu của đợt ({codes}).",
  "order.eqa.scheme": "Chương trình EQA",
  "order.eqa.scheme.choose": "Chọn chương trình",
  "order.eqa.schemeRequired": "Chọn chương trình EQA của mẫu này.",
  "order.eqa.schemeUnknown": "Chương trình EQA đã chọn không nằm trong các chương trình phòng xét nghiệm này đang đăng ký.",
  "order.save.requirement.eqaScheme": "chương trình EQA",
  "save.order.success.labNumber": "Đã lưu chỉ định {labNumber}.",
  "qc.status.error.required": "Chọn trạng thái QC.",
  "qc.status.error.notesRequired": "Ghi rõ lý do QC không đạt.",
  "disposal.error.reasonRequired": "Chọn lý do tiêu hủy.",
  "common.error.notesRequiredForOther": "Thêm ghi chú giải thích lý do bạn chọn.",
  "adjustment.error.negativeQuantity": "Số lượng không được âm.",
  "adjustment.error.reasonRequired": "Chọn lý do điều chỉnh.",
  "lot.error.numberRequired": "Cần nhập số lô.",
  "lot.error.locationRequired": "Chọn vị trí lưu trữ.",
  "lot.status.select": "Chọn trạng thái lô",
  "catalog.item.error.nameRequired": "Cần nhập tên vật tư.",
  "sidenav.label.inventory.items": "Vật tư",
  "sidenav.label.inventory.items.tooltip": "Hàng đang có và hàng cần đặt thêm",
  "sidenav.label.inventory.receive": "Nhập",
  "sidenav.label.inventory.receive.tooltip": "Lập phiếu nhập, quét hoặc gõ từng dòng",
  "sidenav.label.inventory.reports": "Báo cáo",
  "sidenav.label.inventory.reports.tooltip": "Đã nhận, đã dùng, tồn kho hiện có và sắp hết hạn",
  "inventory.import.button": "Nhập vật tư từ tệp",
  "inventory.import.title": "Nhập vật tư từ tệp",
  "inventory.import.help": "Khai báo nhiều vật tư cùng lúc từ tệp CSV. Phần xem trước cho biết tệp sẽ làm gì và không lưu gì cả; chỉ khi bấm Áp dụng mới ghi dữ liệu. Nhập lại tệp đã sửa sẽ cập nhật đúng các vật tư cũ chứ không thêm mới lần nữa.",
  "inventory.import.template": "Tải tệp mẫu",
  "inventory.import.dropzone": "Thêm tệp CSV",
  "inventory.import.preview": "Xem trước",
  "inventory.import.apply": "Áp dụng",
  "inventory.import.plan.title": "Tệp này sẽ làm gì",
  "inventory.import.result.title": "Đã nhập những gì",
  "inventory.import.column.line": "Dòng",
  "inventory.import.column.outcome": "Kết cục",
  "inventory.import.column.reason": "Lý do",
  "inventory.import.outcome.create": "Mới",
  "inventory.import.outcome.update": "Đã cập nhật",
  "inventory.import.outcome.unchanged": "Không đổi",
  "inventory.import.outcome.skip": "Bỏ qua",
  "inventory.import.count.created": "{count} mới",
  "inventory.import.count.updated": "Đã cập nhật {count}",
  "inventory.import.count.unchanged": "{count} không đổi",
  "inventory.import.count.skipped": "{count} đã bỏ qua",
  "inventory.import.error.rowsTitle": "Một số dòng không dùng được",
  "inventory.import.error.rowsMessage": "Các dòng liệt kê bên dưới sẽ bị bỏ qua. Bấm Áp dụng sẽ lưu phần còn lại; sửa các dòng đó rồi thêm lại tệp để đưa chúng vào.",
  "inventory.import.error.unreadable": "Không đọc được tệp này.",
  "inventory.import.error.failed": "Không nhập được tệp.",
  "inventory.import.nothingToDo": "Tệp này không thay đổi gì",
  "inventory.import.nothingToDo.help": "Mọi vật tư trong tệp đều đã khớp với dữ liệu đang lưu.",
  "sidenav.label.reports.printQueue": "Hàng đợi in phiếu kết quả",
  "reportQueue.title": "Hàng đợi in phiếu kết quả",
  "reportQueue.subtitle": "In, in lại và phát hành lại phiếu kết quả đã phát hành",
  "reportQueue.guidance.lead": "Phiếu xuất hiện ở đây khi kết quả đầu tiên được phát hành.",
  "reportQueue.guidance.body": "Phiếu đã in sẽ quay lại đây khi có thêm kết quả được phát hành hoặc một kết quả đã in bị thay đổi.",
  "reportQueue.legend.partial": "Còn kết quả chưa được phát hành",
  "reportQueue.legend.final": "Mọi kết quả đã được phát hành",
  "reportQueue.legend.amended": "Một kết quả đã in bị thay đổi, hoặc phiếu được phát hành lại kèm hiệu chỉnh",
  "reportQueue.legend.unprinted": "Nội dung hiện tại chưa được in",
  "reportQueue.legend.printed": "Bản in gần nhất khớp với nội dung đã phát hành",
  "reportQueue.tile.toPrint": "Cần in",
  "reportQueue.tile.amendedToPrint": "Đã hiệu chỉnh, cần in",
  "reportQueue.type.patient": "Phiếu kết quả",
  "reportQueue.state.partial": "Chưa đủ {released}/{total}",
  "reportQueue.state.partialName": "Chưa đủ",
  "reportQueue.state.final": "Chính thức",
  "reportQueue.state.amended": "Đã hiệu chỉnh",
  "reportQueue.state.amendedPartial": "Đã hiệu chỉnh {released}/{total}",
  "reportQueue.printStatus.unprinted": "Chưa in",
  "reportQueue.printStatus.printed": "Đã in",
  "reportQueue.col.type": "Loại",
  "reportQueue.col.labNoName": "Mã mẫu / Họ tên",
  "reportQueue.col.subject": "Tiêu đề",
  "reportQueue.col.details": "Chi tiết",
  "reportQueue.col.released": "Phát hành / Gửi",
  "reportQueue.col.state": "Trạng thái",
  "reportQueue.col.printStatus": "Trạng thái in",
  "reportQueue.col.version": "Phiên bản",
  "reportQueue.version.none": "Chưa in",
  "reportQueue.version.value": "v{n}",
  "reportQueue.action.print": "In",
  "reportQueue.print.disabled.nothingReleased": "Chỉ định này chưa có kết quả nào được phát hành",
  "reportQueue.print.success": "{count, plural, other {# phiếu}} ready",
  "reportQueue.print.failed": "Không chuẩn bị được {count, plural, one {# phiếu} other {# phiếu}}: {labNumbers}",
  "reportQueue.print.reprinted": "Đã in lại phiên bản {n} của {labNumber}",
  "reportQueue.print.issued": "Đã in phiên bản {n} của {labNumber}",
  "reportQueue.print.popupBlocked": "Trình duyệt đã chặn cửa sổ phiếu của {labNumber}",
  "reportQueue.print.open": "Mở phiếu",
  "reportQueue.filter.labNo.placeholder": "Quét hoặc nhập mã mẫu",
  "reportQueue.filter.labNo.helper": "Quét mã vạch là lọc ngay",
  "reportQueue.filter.labNo.range": "Khoảng",
  "reportQueue.filter.labNo.to": "Đến mã mẫu",
  "reportQueue.filter.labNo.rangeReversed": "The To lab number is before the From lab number",
  "reportQueue.filter.patient": "Tìm theo bệnh nhân",
  "reportQueue.filter.state": "Trạng thái",
  "reportQueue.filter.printStatus": "Trạng thái in",
  "reportQueue.filter.window": "Khoảng thời gian",
  "reportQueue.filter.window.24h": "24 giờ qua",
  "reportQueue.filter.window.7d": "7 ngày qua",
  "reportQueue.filter.window.30d": "30 ngày qua",
  "reportQueue.filter.window.all": "Mọi lúc",
  "reportQueue.filter.window.custom": "Tự chọn khoảng",
  "reportQueue.filter.window.to": "Đến",
  "reportQueue.filter.window.helper": "Áp dụng cho phiếu đã in; phiếu chưa in luôn hiện",
  "reportQueue.filter.facility": "Cơ sở",
  "reportQueue.filter.ward": "Khoa / Phòng / Đơn vị",
  "reportQueue.filter.ward.disabled": "Chọn cơ sở trước",
  "reportQueue.filter.typeahead.helper": "Gõ từ 2 ký tự trở lên để tìm",
  "reportQueue.filter.clear": "Xóa bộ lọc",
  "reportQueue.search.active.labNo": "Mã mẫu: {labNo}",
  "reportQueue.search.active.labRange": "Mã mẫu: {from} đến {to}",
  "reportQueue.search.active.patient": "Bệnh nhân: {name}",
  "reportQueue.search.clear": "Xóa tìm kiếm",
  "reportQueue.search.disabledHelper": "Các bộ lọc khác tạm tắt khi bạn tra một chỉ định cụ thể",
  "reportQueue.empty": "Không có gì cần in. Mọi phiếu đã phát hành trong mục này đều đã in.",
  "reportQueue.error.load": "Không tải được hàng đợi.",
  "reportQueue.detail.tests": "Xét nghiệm",
  "reportQueue.detail.order": "Chỉ định",
  "reportQueue.detail.validatedBy": "Người duyệt",
  "reportQueue.detail.col.test": "Xét nghiệm",
  "reportQueue.detail.col.result": "Kết quả",
  "reportQueue.detail.col.flag": "Đánh dấu",
  "reportQueue.detail.col.released": "Trả lúc",
  "reportQueue.detail.awaitingValidation": "Chờ duyệt",
  "reportQueue.detail.inProgress": "Đang xử lý",
  "reportQueue.history.title": "Lịch sử phiên bản",
  "reportQueue.history.issued": "Đã phát hành",
  "reportQueue.history.by": "Bởi",
  "reportQueue.history.change": "Thay đổi",
  "reportQueue.history.firstIssue": "Lần phát hành đầu",
  "reportQueue.history.completeness": "Mức đầy đủ",
  "reportQueue.history.fingerprint": "Mã nhận dạng (fingerprint)",
  "reportQueue.history.openPdf": "Mở PDF",
  "reportQueue.history.reprinted": "In lại {date} bởi {user}",
  "reportQueue.history.notArchived": "Chưa lưu trữ (phát hành trước {date})",
  "reportQueue.history.archiveFailed": "Lưu trữ thất bại",
  "reportQueue.history.none": "Chưa in lần nào",
  "reportQueue.awaitingValidation": "Correction awaiting validation",
  "sidenav.label.reports.sentMessages": "Thông báo đã gửi",
  "sidenav.label.admin.notifications": "Thông báo",
  "sidenav.label.admin.notifications.channels": "Kênh",
  "sidenav.label.admin.notifications.templates": "Mẫu nội dung",
  "sidenav.label.admin.notifications.delivery": "Cài đặt gửi kết quả",
  "sidenav.label.admin.notifications.triggers": "Điều kiện",
  "delivery.sent.title": "Thông báo đã gửi",
  "delivery.sent.subtitle": "Mọi tin phòng xét nghiệm đã gửi hoặc đã thử gửi: phiếu kết quả, cảnh báo, báo đã có kết quả, thông báo tự động và tin gửi thử kênh",
  "delivery.sent.empty": "Không có tin nào được gửi trong khoảng thời gian này.",
  "delivery.sent.loadError": "Không tải được danh sách tin",
  "delivery.sent.resend": "Gửi lại",
  "delivery.sent.resend.done": "Đã đưa tin vào hàng đợi gửi lại.",
  "delivery.sent.resend.failed": "Không đưa được tin vào hàng đợi gửi lại.",
  "delivery.sent.sentBy.auto": "Tự động",
  "delivery.sent.col.time": "Giờ",
  "delivery.sent.col.product": "Loại tin",
  "delivery.sent.col.labNo": "Mã mẫu",
  "delivery.sent.col.recipient": "Người nhận",
  "delivery.sent.col.channel": "Kênh",
  "delivery.sent.col.status": "Trạng thái",
  "delivery.sent.col.attempts": "Số lần thử",
  "delivery.sent.col.sentBy": "Người gửi",
  "delivery.sent.filter.product": "Loại tin",
  "delivery.sent.filter.status": "Trạng thái",
  "delivery.sent.filter.channel": "Kênh",
  "delivery.sent.filter.to": "Đến",
  "delivery.sent.filter.recipient": "Người nhận",
  "delivery.sent.filter.all": "Tất cả",
  "delivery.sent.detail.subject": "Tiêu đề",
  "delivery.sent.detail.message": "Nội dung",
  "delivery.sent.detail.attempts": "Số lần thử",
  "delivery.sent.detail.noAttempts": "Chưa thử lần nào",
  "delivery.sent.detail.nextAttempt": "Thử lại lúc {time}",
  "delivery.sent.detail.rule": "Quy tắc",
  "delivery.sent.detail.report": "Phiếu kết quả phiên bản {n}, {format}",
  "delivery.sent.detail.openOrder": "Mở chỉ định",
  "delivery.sent.detail.openQueue": "Mở trong Hàng đợi in phiếu kết quả",
  "delivery.sent.detail.loadError": "Không tải được tin này",
  "delivery.status.queued": "Đang chờ",
  "delivery.status.sent": "Đã gửi",
  "delivery.status.failed": "Lỗi",
  "delivery.status.skipped": "Bỏ qua",
  "delivery.product.report": "Báo cáo",
  "delivery.product.alert": "Cảnh báo",
  "delivery.product.notice": "Báo đã có kết quả",
  "delivery.product.trigger": "Thông báo tự động",
  "delivery.product.test": "Xét nghiệm",
  "delivery.format.protected": "Phiếu đầy đủ, có mật khẩu",
  "delivery.format.masked": "Bản rút gọn, che thông tin",
  "delivery.channel.email": "Email",
  "delivery.channel.sms": "SMS",
  "delivery.channel.whatsapp": "WhatsApp",
  "delivery.channel.title": "Kênh",
  "delivery.channel.subtitle": "Email, SMS và WhatsApp được thiết lập một lần ở đây và dùng cho mọi tin phòng xét nghiệm gửi đi",
  "delivery.channel.status.ready": "Sẵn sàng",
  "delivery.channel.status.notSetUp": "Chưa thiết lập",
  "delivery.channel.status.failing": "Đang lỗi",
  "delivery.channel.lastSuccess": "Lần gửi thành công gần nhất",
  "delivery.channel.never": "Chưa bao giờ",
  "delivery.channel.lastError": "Lỗi gần nhất",
  "delivery.channel.active": "Đang dùng",
  "delivery.channel.host": "Máy chủ SMTP",
  "delivery.channel.port": "Cổng",
  "delivery.channel.security": "Bảo mật",
  "delivery.channel.security.starttls": "STARTTLS",
  "delivery.channel.security.ssl": "SSL/TLS",
  "delivery.channel.security.none": "Không",
  "delivery.channel.username": "Tên đăng nhập",
  "delivery.channel.password": "Mật khẩu",
  "delivery.channel.secretSet": "Đã đặt",
  "delivery.channel.secretHelper": "Đã lưu khóa bí mật. Để trống ô này nếu muốn giữ nguyên.",
  "delivery.channel.replace": "Thay thế",
  "delivery.channel.senderAddress": "Địa chỉ người gửi",
  "delivery.channel.senderName": "Tên người gửi",
  "delivery.channel.replyTo": "Địa chỉ nhận trả lời (Reply-to)",
  "delivery.channel.whatsapp.accountSid": "Account SID",
  "delivery.channel.whatsapp.token": "Token xác thực",
  "delivery.channel.whatsapp.from": "Số gửi đi",
  "delivery.channel.whatsapp.address": "Địa chỉ API (tùy chọn)",
  "delivery.channel.countryCode": "Mã quốc gia mặc định",
  "delivery.channel.gateway": "Cổng dịch vụ (gateway)",
  "delivery.channel.sms.note": "Cổng SMS (BMP hoặc SMPP) tạm thời vẫn cấu hình trong thuộc tính máy chủ cho tới khi có bản cập nhật riêng; dòng này chỉ cho biết cổng có đang bật hay không.",
  "delivery.channel.save": "Lưu",
  "delivery.channel.saved": "Đã lưu kênh.",
  "delivery.channel.saveFailed": "Không lưu được kênh: kiểm tra {field}.",
  "delivery.channel.sendTest": "Gửi thử",
  "delivery.channel.test.title": "Gửi tin thử",
  "delivery.channel.test.address": "Địa chỉ",
  "delivery.channel.test.send": "Gửi",
  "delivery.channel.test.sent": "Đã gửi tin thử.",
  "delivery.channel.test.failed": "Chưa gửi được tin thử.",
  "delivery.settings.title": "Cài đặt gửi kết quả",
  "delivery.settings.subtitle": "Quy định chung toàn phòng xét nghiệm về cách gửi phiếu kết quả, cảnh báo và thông báo",
  "delivery.settings.retryDelays": "Thử lại sau (phút, theo thứ tự)",
  "delivery.settings.retryDelays.helper": "Ví dụ 1,5,15: lần gửi lỗi được thử lại sau 1, 5 và 15 phút, rồi đánh dấu Lỗi",
  "delivery.settings.defaultFormat": "Định dạng cho người nhận chưa có mật khẩu",
  "delivery.settings.hold": "Chờ trước khi gửi phiên bản mới (phút)",
  "delivery.settings.partials": "Tự động gửi phiếu chưa đủ kết quả",
  "delivery.settings.contact": "Dòng thông tin liên hệ của phòng xét nghiệm",
  "delivery.settings.contact.helper": "Điện thoại, email và giờ làm việc, in y như trên thông báo",
  "delivery.settings.location": "Nơi gửi phiếu kết quả",
  "delivery.settings.location.local": "Phòng xét nghiệm này",
  "delivery.settings.location.central": "Dịch vụ gửi tập trung",
  "delivery.settings.centralAddress": "Địa chỉ dịch vụ gửi tập trung",
  "delivery.settings.centralConfirm": "Phiếu kết quả, cảnh báo và thông báo cho bệnh nhân của phòng xét nghiệm này sẽ do dịch vụ tập trung tại {address} gửi. Phòng xét nghiệm này sẽ ngừng tự gửi.",
  "delivery.settings.links": "Liên kết bảo mật",
  "delivery.settings.linkDays": "Thời hạn liên kết (ngày)",
  "delivery.settings.countryCode": "Mã quốc gia mặc định",
  "delivery.settings.save": "Lưu",
  "delivery.settings.saved": "Đã lưu cài đặt.",
  "delivery.settings.invalid": "Không lưu được cài đặt: kiểm tra {field}.",
  "externalconnections.password.set": "Đã lưu mật khẩu. Để trống ô này nếu muốn giữ nguyên.",
  "notificationtrigger.referralrejected.name": "Kết quả mẫu gửi đi bị từ chối",
  "notificationtrigger.referralrejected.description": "Gửi khi kết quả do phòng xét nghiệm tham chiếu trả về bị từ chối và cần lấy lại mẫu.",
  "notificationtrigger.templates.referralrejected.description": "Gửi tới bác sĩ chỉ định hoặc người gửi mẫu khi kết quả mẫu gửi đi trả về bị từ chối.",
  "notificationtrigger.referralnudge.name": "Nhắc mẫu gửi đi",
  "notificationtrigger.referralnudge.description": "Gửi tới người liên hệ của phòng xét nghiệm tham chiếu khi mẫu gửi đi đã quá hạn và có yêu cầu nhắc.",
  "notificationtrigger.templates.referralnudge.description": "Gửi tới người liên hệ chuỗi bảo quản (CoC) ở phòng xét nghiệm tham chiếu khi đang chờ kết quả.",
  "notificationtrigger.sampleresampled.name": "Lấy lại mẫu",
  "notificationtrigger.sampleresampled.description": "Gửi khi một chỉ định được đánh dấu cần lấy lại mẫu và chỉ định thay thế đã được tạo.",
  "notificationtrigger.templates.sampleresampled.description": "Gửi tới bác sĩ chỉ định hoặc người gửi mẫu khi cần lấy lại mẫu.",
  "notificationtrigger.testresult.name": "Đã có kết quả cho bệnh nhân",
  "notificationtrigger.testresult.description": "Gửi tới bệnh nhân hoặc bác sĩ khi một xét nghiệm đã cấu hình trong Thông báo xét nghiệm có kết quả được phát hành.",
  "notificationtrigger.templates.testresult.description": "Gửi tới bệnh nhân hoặc bác sĩ khi kết quả của một xét nghiệm đã cấu hình được phát hành. Tin không bao giờ ghi tên bệnh nhân."
}
